"use strict";
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































const { useState, useEffect, useRef, useCallback } = React

// <busca-core> — cópia da regra de busca-core.js (servidor): sem acento, maiúscula, plural nem ordem das palavras;
// as regras estão explicadas lá. test/busca-core.test.js roda os mesmos casos aqui e lá.
const BUSCA_ACENTOS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g')   // acentos que o NFD separa
const semAcento = s => String(s ?? '').normalize('NFD').replace(BUSCA_ACENTOS, '').toLowerCase()
const BUSCA_LIGACAO = new Set(['de', 'da', 'do', 'das', 'dos', 'e', 'em', 'no', 'na', 'nos', 'nas', 'para', 'pra', 'p/'])
const BUSCA_SINONIMOS = { com: ['c/'], 'c/': ['com'], sem: ['s/'], 's/': ['sem'] }
// Formas aceitas de uma palavra: [forma, modo] — 'sub' em qualquer ponto, 'ini' no começo de uma palavra, 'pal' palavra
// inteira. acento = a pessoa digitou com acento; digitando = é a última palavra e ainda não veio espaço depois.
function formasBusca(w, { acento = false, digitando = false } = {}) {
  if (BUSCA_SINONIMOS[w]) return [w, ...BUSCA_SINONIMOS[w]].map(f => [f, digitando ? 'ini' : 'pal'])
  if (w.length <= 2) return [[w, acento ? 'pal' : 'ini']]
  const f = [[w, 'sub']]
  if (w.length < 4) return f
  const add = s => { if (s.length >= 3) f.push([s, s.length === 3 ? 'pal' : 'ini']) }
  if (/[oa]es$/.test(w)) add(w.slice(0, -3) + 'ao')
  if (/ais$/.test(w)) add(w.slice(0, -3) + 'al')
  if (/eis$/.test(w)) add(w.slice(0, -3) + 'el')
  if (/ns$/.test(w)) add(w.slice(0, -2) + 'm')
  if (/[rzl]es$/.test(w)) add(w.slice(0, -2))
  if (/s$/.test(w)) add(w.slice(0, -1))
  return f
}
// Palavras da busca, cada uma com as formas aceitas (lista de [forma, modo]).
function termosBusca(q) {
  const bruto = String(q ?? '').toLowerCase()
  const palavras = bruto.split(/\s+/).filter(Boolean)
  const digitando = !/\s$/.test(bruto)
  let ts = palavras.map((p, i) => ({ w: semAcento(p), acento: semAcento(p) !== p, ultima: i === palavras.length - 1 }))
  const uteis = ts.filter(t => !BUSCA_LIGACAO.has(t.w) || (digitando && t.ultima))
  if (uteis.length) ts = uteis
  return ts.map(t => formasBusca(t.w, { acento: t.acento, digitando: digitando && t.ultima }))
}
const BUSCA_RE = new Map()
function reBusca(f, modo) {
  const k = modo + ' ' + f
  let r = BUSCA_RE.get(k)
  if (!r) {
    if (BUSCA_RE.size > 500) BUSCA_RE.clear()
    r = new RegExp('(?:^|[^a-z0-9])' + f.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&') + (modo === 'pal' ? '(?![a-z0-9])' : ''))
    BUSCA_RE.set(k, r)
  }
  return r
}
// Todas as palavras aparecem no texto (já normalizado por semAcento)?
const casaTermos = (termos, txt) => termos.every(fs => fs.some(([f, modo]) => modo === 'sub' ? txt.includes(f) : reBusca(f, modo).test(txt)))
// casaBusca('modulo tomada', item.nome, item.codigo): busca vazia casa com tudo.
function casaBusca(q, ...campos) {
  const termos = termosBusca(q)
  return !termos.length || casaTermos(termos, semAcento(campos.filter(v => v != null).join(' ')))
}
// </busca-core>

const token = { value: localStorage.getItem('cf_token') }

// Modo apresentação (tour do CEO): quando ativo, o app está personificando um perfil em
// SOMENTE LEITURA. O servidor já barra escritas, mas bloqueamos aqui também para dar
// feedback imediato e evitar qualquer chamada de mutação durante a demonstração.
const tourMode = { active: false, onBlock: null }

// Sessão de login (ver SESSÃO DE LOGIN no server.js): termina com 1 h sem interação. O servidor só conta como uso a
// requisição feita logo depois de um toque/clique/tecla — as automáticas (badge a cada 30 s, recargas) vão com
// X-Cautelix-Auto e não seguram aberta uma tela esquecida. Mexendo sem salvar nada (formulário longo), um aviso
// leve a cada 5 min mantém a sessão. aoEncerrar: o App volta ao login com o motivo.
const sessaoTela = { ultima: Date.now(), avisado: Date.now(), aoEncerrar: null }
;['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(ev => window.addEventListener(ev, () => {
  const agora = Date.now()
  sessaoTela.ultima = agora
  if (token.value && !tourMode.active && agora - sessaoTela.avisado > 5 * 60 * 1000) {
    sessaoTela.avisado = agora
    fetch('/api/auth/ativo', { method: 'POST', headers: { Authorization: `Bearer ${token.value}` } }).catch(() => {})
  }
}, { capture: true, passive: true }))

async function api(method, path, body) {
  if (tourMode.active && method !== 'GET') {
    if (tourMode.onBlock) tourMode.onBlock()
    throw new Error('Ação desabilitada no modo apresentação (somente leitura).')
  }
  const auto = Date.now() - sessaoTela.ultima > 60 * 1000
  if (!auto) sessaoTela.avisado = Date.now()
  const res = await fetch('/api' + path, {
    method,
    headers: { 'Content-Type': 'application/json', ...(token.value ? { Authorization: `Bearer ${token.value}` } : {}), ...(auto ? { 'X-Cautelix-Auto': '1' } : {}) },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    const e = new Error(data.error || `Erro ${res.status}`); e.data = data; e.status = res.status
    // 401 da SESSÃO (o servidor marca `sessao`): volta ao login. Outro 401 (senha errada numa confirmação) não.
    if (res.status === 401 && data.sessao && token.value && !tourMode.active && sessaoTela.aoEncerrar) sessaoTela.aoEncerrar(e.message)
    throw e
  }
  return data
}
const GET = p => api('GET', p)
const POST = (p, b) => api('POST', p, b)
// Download autenticado (CSV/XML): a rota exige o Bearer, então não dá para usar <a href> direto.
async function baixarArquivo(path, nome) {
  const res = await fetch('/api' + path, { headers: token.value ? { Authorization: `Bearer ${token.value}` } : {} })
  if (!res.ok) { const d = await res.json().catch(() => ({})); throw new Error(d.error || `Erro ${res.status}`) }
  const url = URL.createObjectURL(await res.blob())
  const el = document.createElement('a'); el.href = url; el.download = nome; el.click(); URL.revokeObjectURL(url)
}
// Troca de perfil no tour: precisa usar o token do apresentador (master/diretor), não o
// token-tour vigente (que é somente-leitura), então faz um fetch cru fora do guard.
async function postTour(role, masterToken) {
  const res = await fetch('/api/auth/tour', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${masterToken}` },
    body: JSON.stringify({ role })
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || `Erro ${res.status}`)
  return data
}
const PUT = (p, b) => api('PUT', p, b)
const DEL = p => api('DELETE', p)

// Nome (e logo opcional) da empresa buscados uma vez do backend (evita texto fixo em termos/avisos legais)
// nome = nome de exibição curto (UI: login, sidebar) | razaoSocial = nome legal completo (declarações formais)
const empresaInfo = { nome: 'sua empresa', razaoSocial: 'sua empresa', logoUrl: null }

function fmt(d) {
  if (!d) return '—'
  // Aceita ISO ("…T…") e o formato local do banco ("AAAA-MM-DD HH:MM:SS") — sem isso a hora
  // vazava para o dia ("28 13:00:00/09/2026").
  const [y,m,dd] = String(d).split(/[T ]/)[0].split('-')
  return `${dd}/${m}/${y}`
}
function fmtDT(d) {
  if (!d) return '—'
  return d.replace('T', ' ').slice(0, 16)
}
function today() { return new Date().toISOString().slice(0, 10) }
function fmtBRL(v) {
  if (!v) return 'R$ 0,00'
  return 'R$ ' + Number(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
// Moeda compacta para leitura de relance no painel (ex.: "R$ 148,3 mil").
function fmtBRLc(v) {
  v = Number(v) || 0
  if (v >= 1000) return 'R$ ' + (v / 1000).toFixed(1).replace('.', ',') + ' mil'
  return 'R$ ' + v.toFixed(0)
}
// Moeda em reais inteiros (ex.: "R$ 11.924") — número de card de resumo, lido de relance.
function fmtBRLi(v) {
  if (v == null || v === '') return '—'
  return 'R$ ' + Math.round(Number(v) || 0).toLocaleString('pt-BR')
}
// Valor em R$ de card de resumo. Sem centavos: não mudam a leitura de relance e tomam um quarto da largura
// do card — com eles o número precisava encolher (ou vazava). O valor exato fica no "passar o mouse" e nas tabelas.
function ValorCard({ v, className }) {
  return <div className={'stat-value money' + (className ? ' ' + className : '')} title={v == null || v === '' ? undefined : fmtBRL(v)}>{fmtBRLi(v)}</div>
}
// Iniciais para avatar (1ª e última palavra do nome).
function iniciais(nome) {
  const p = String(nome||'').trim().split(/\s+/).filter(Boolean)
  if (!p.length) return '?'
  return (p[0][0] + (p.length>1 ? p[p.length-1][0] : '')).toUpperCase()
}

const STATUS_LABEL = {
  solicitada: 'Solicitada', separando: 'Separando', pronta: 'Pronto p/ retirada',
  retirada: 'Retirada', cancelada: 'Cancelada', estornada: 'Estornada',
  aguardando_retirada: 'Aguard. retirada', ativa: 'Ativa', devolvida: 'Devolvida',
  aguardando_tomador: 'Aguard. confirmação', aguardando_lider: 'Aguard. líder',
  ativo: 'Ativo', devolvido: 'Devolvido', recusado: 'Recusado'
}
// Tag de status de solicitação/cautela. Bolsa a caminho com o apontador ganha a tag própria — no banco
// segue 'pronta' / 'aguardando_retirada' até o responsável assinar o recebimento na obra.
function TagStatus({ status, porte }) {
  if (porte) return <span className="badge badge-com_portador" title={`Com ${porte.portador_nome} desde ${tlHora(porte.desde)}`}>Com o apontador</span>
  return <span className={`badge badge-${status}`}>{STATUS_LABEL[status] || status}</span>
}
const ROLE_LABEL = { almoxarifado: 'Almoxarifado', lider: 'Líder', operario: 'Operário', administracao: 'Administração', compras: 'Compras', diretor: 'Diretor de Operações', gerente: 'Gerente de Contrato', engenheiro: 'Engenheiro', logistica: 'Logística', almoxarife2: 'Almoxarife 2', motorista: 'Ajudante de motorista', condutor: 'Motorista', apontador: 'Apontador', ceo: 'CEO', auxiliar: 'Auxiliar Técnica' }
// Auxiliar Técnica = mesmas permissões do Diretor de Operações. Como o servidor já remapeia
// auxiliar→diretor em auth(), o cliente faz o mesmo para toda a UI condicional, guardando o papel
// real em `roleReal` só para o rótulo. Um ponto só evita espalhar 'auxiliar' por dezenas de checagens.
function normUser(u) {
  if (!u) return u
  // Auxiliar Técnica = Diretor (permissões). CEO = Master somente-leitura (vê tudo, sem editar):
  // espelha o Master no cliente (role almoxarifado + is_master) e o bloqueio de escrita é ativado
  // por efeito no App (tourMode). O papel real fica em roleReal só para o rótulo.
  if (u.role === 'auxiliar') return { ...u, role: 'diretor', roleReal: 'auxiliar' }
  // Motorista ('condutor') = mesmas permissões do Ajudante de motorista ('motorista'), como no servidor.
  if (u.role === 'condutor') return { ...u, role: 'motorista', roleReal: 'condutor', is_master: !!u.is_master }
  if (u.role === 'ceo') return { ...u, role: 'almoxarifado', roleReal: 'ceo', is_master: true, ceo: true }
  // Perfil administrativo (is_admin): braço direito do Master. Espelha o Master na UI
  // (role almoxarifado + is_master → vê tudo), mas marca admin=true, o que ESCONDE as
  // ações destrutivas (excluir/cancelar/estornar/zerar/reset). O papel real fica em
  // roleReal só para o rótulo. O servidor aplica a mesma regra (auth/naoCancelador).
  if (u.is_admin) return { ...u, role: 'almoxarifado', roleReal: (u.roleReal || u.role), is_master: true, admin: true }
  // Líder com a tag "atua como engenheiro": a UI inteira de engenheiro (o servidor faz o mesmo em auth()).
  if (u.role === 'lider' && u.atua_engenheiro) return { ...u, role: 'engenheiro', roleReal: 'lider', is_master: !!u.is_master, liderEngenheiro: true }
  // Booleano: o banco devolve 0/1 e `{user.is_master && …}` imprimia um "0" solto na tela.
  return { ...u, is_master: !!u.is_master }
}
const roleLabelDe = u => (u && u.liderEngenheiro) ? 'Líder · Engenheiro'
  : (u && u.role === 'almoxarife2' && u.base_nome) ? `Almoxarife 2 · ${u.base_nome}`
  : ROLE_LABEL[(u && (u.roleReal || u.role))] || (u && u.role) || ''
// Categorias oficiais do material — base da separação por categoria e da cotação.
const REC_CATEGORIAS = ['Alvenaria e Estrutura', 'Hidráulica', 'Elétrica', 'Cobertura',
  'Tintas e Acessórios', 'Pisos e Revestimentos', 'Acabamento e Decoração', 'Ferramentas e Ferragens',
  'Limpeza e Diversos']
// Perfis com acesso ao módulo Uniformes/EPI (mesmo conjunto do backend UNIF_RETIRADA). O Almoxarife 2 entra
// só com a Retirada (e os alertas de desgaste) dos funcionários da base dele — ver UniformesPage.
const PERFIS_UNIFORME = ['almoxarifado', 'administracao', 'compras', 'almoxarife2']
// Ícone de cada perfil no seletor do Modo apresentação (tour do CEO).
const TOUR_ICON = { diretor: 'dashboard', auxiliar: 'clipboard', gerente: 'clipboard', engenheiro: 'building', lider: 'users', operario: 'worker', almoxarifado: 'package', almoxarife2: 'package', compras: 'exchange', administracao: 'clipboard', logistica: 'exchange', motorista: 'exchange', condutor: 'exchange', apontador: 'clipboard', ceo: 'eye' }

// ── Módulos comercializáveis (scaffold de venda por pacote) ──
// 'cautela' é base (sempre ativo). Cada aba/indicador declara de qual módulo depende;
// se o cliente não contratou o módulo, a aba some e o painel se remonta — sem quebrar.
// O backend manda os módulos ativos em user.modulos; ausência = tudo ligado (legado).
const MODULO_DA_ABA = { obras: 'obras', 'kanban-obras': 'obras', equipe: 'equipe', 'equipe-auditoria': 'equipe', emprestimos: 'emprestimos', uniformes: 'uniformes', rec: 'rec', estoque: 'rec', 'servicos-extras': 'equipe', 'minhas-atividades': 'manutencao' }
const temModulo = (user, m) => { if (!m || m === 'cautela') return true; const mods = user && user.modulos; return !mods || mods.includes(m) }
const abaAtiva = (user, id) => temModulo(user, MODULO_DA_ABA[id])

// ── Helpers de estoque por tamanho (uniformes) ──
const SEM_TAM_UI = '—'
const gradeDe = it => (it && it.tamanhos || '').split(',').map(s => s.trim()).filter(Boolean)
// Capacetes: a COR do capacete identifica a função de quem o usa (padrão de segurança de obra).
// Quando a grade de um item é composta só por essas cores, o eixo de variação vira "Cor", não "Tamanho".
const CORES_CAPACETE = {
  'Branco': 'Engenheiro', 'Amarelo': 'Visita', 'Azul': 'Pedreiro', 'Preto': 'Operador de máquina',
  'Vermelho': 'Carpinteiro / Bombeiro', 'Laranja': 'Eletricista', 'Verde': 'Servente',
}
const ehGradeDeCor = it => { const g = gradeDe(it); return g.length > 0 && g.every(t => CORES_CAPACETE[t]) }
// Rótulo do eixo de variação do item: "Cor" para capacete, "Tamanho" para o resto.
const eixoVar = it => ehGradeDeCor(it) ? 'Cor' : 'Tamanho'
// Linhas iniciais do mapeamento de uma NF-e: item sugerido pelo nome; linha de EPI sem item no
// catálogo já vem como "cadastrar item novo" (nome e tamanho lidos da nota); a que já entrou fica fora.
const uniLinhasIniciais = parsed => parsed.itens.map(l => {
  const sug = parsed.catalogo.find(c => c.id === l.item_id_sugerido)
  const item_id = l.ja_entrou ? '' : sug ? sug.id : (l.epi ? 'novo' : '')
  return { ...l, item_id, tamanho: item_id === 'novo' ? (l.tamanho_desc || '') : uniTamSug(l.descricao, sug) }
})
// Tamanho/cor sugerido pela descrição da NF-e ("MACACÃO BRIM TAM G", "BOTINA Nº 42", "CAPACETE BRANCO").
// Só com prefixo explícito (tam/tamanho/nº) — um "P" solto pode ser "p/" — ou cor inteira de capacete.
function uniTamSug(descricao, item) {
  const grade = gradeDe(item)
  if (!grade.length) return ''
  const d = ' ' + String(descricao || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase() + ' '
  const esc = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const hit = grade.find(t => new RegExp(`[^A-Z](TAM(ANHO)?\\.?|N[O°º]?\\.?)\\s*:?\\s*${esc(t)}(?![A-Z0-9])`).test(d)
    || (ehGradeDeCor(item) && new RegExp(`[^A-Z]${esc(t)}(?![A-Z])`).test(d)))
  return hit || ''
}
// Rótulo de um valor da grade: cor + função ("Branco (Engenheiro)") quando for capacete; senão o próprio valor.
const rotuloVar = (it, t) => (t && ehGradeDeCor(it) && CORES_CAPACETE[t]) ? `${t} (${CORES_CAPACETE[t]})` : t
// Lista de tamanhos para exibir/selecionar: a grade, ou [SEM_TAM_UI] para item de tamanho único.
const tamsDe = it => { const g = gradeDe(it); return g.length ? g : [SEM_TAM_UI] }
// Disponível de um tamanho (usa o detalhamento que o backend já calculou).
const dispDeTam = (it, tam) => {
  const arr = (it && it.estoque_por_tamanho) || []
  const linha = arr.find(l => l.tamanho === (tam || SEM_TAM_UI))
  return linha ? linha.disponivel : 0
}
// min_por_tamanho vem do backend como string JSON; converte para objeto de trabalho.
const parseMinTam = v => { if (!v) return {}; if (typeof v === 'object') return v; try { return JSON.parse(v) || {} } catch { return {} } }
// Chip visual de "tamanho: disponível" (vermelho quando zerado ou abaixo do mínimo).
function TamChip({ tamanho, disponivel, baixo }) {
  const low = disponivel <= 0 || baixo
  return <span style={{ fontSize: '.68rem', padding: '1px 7px', borderRadius: 10, border: '1px solid', borderColor: low ? 'var(--danger)' : 'var(--border)', color: low ? 'var(--danger)' : 'var(--text-secondary)', background: low ? 'rgba(122,46,46,.06)' : 'var(--bg)', whiteSpace: 'nowrap' }}>{tamanho === SEM_TAM_UI ? 'único' : tamanho}: <strong>{disponivel}</strong></span>
}

// ─── SIGNATURE PAD ────────────────────────────────────────────────────────────
function SignaturePad({ label, onConfirm, onCancel }) {
  const ref = useRef(null)
  const drawing = useRef(false)
  const [hasSig, setHasSig] = useState(false)
  const [semAssinatura, setSemAssinatura] = useState(false)
  // Escala a posição do ponteiro pela razão entre a resolução interna do canvas e o tamanho
  // renderizado em CSS — sem isso, num celular onde o canvas é exibido menor que 480px (ver
  // regra .sig-canvas com max-width:100%), o traço desalinha do dedo/caneta.
  const getPos = e => {
    const r = ref.current.getBoundingClientRect()
    const s = e.touches ? e.touches[0] : e
    const scaleX = ref.current.width / r.width
    const scaleY = ref.current.height / r.height
    return [(s.clientX - r.left) * scaleX, (s.clientY - r.top) * scaleY]
  }
  const start = e => { e.preventDefault(); drawing.current = true; const [x,y] = getPos(e); const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(x,y) }
  const move = e => { if (!drawing.current) return; e.preventDefault(); const [x,y] = getPos(e); const ctx = ref.current.getContext('2d'); ctx.lineWidth=2.5; ctx.strokeStyle='#1A2535'; ctx.lineCap='round'; ctx.lineJoin='round'; ctx.lineTo(x,y); ctx.stroke(); setHasSig(true); setSemAssinatura(false) }
  const stop = () => { drawing.current = false }
  const clear = () => { ref.current.getContext('2d').clearRect(0,0,ref.current.width,ref.current.height); setHasSig(false) }
  const confirm = () => { if (!hasSig) { setSemAssinatura(true); return }; onConfirm(ref.current.toDataURL()) }
  return (
    <div>
      <div className="sig-wrap" style={semAssinatura ? {borderColor:'var(--danger)'} : null}>
        <p style={{display:'flex',alignItems:'center',gap:6}}><Icon name="signature" size={15}/> {label || 'Assine no campo abaixo'}</p>
        <canvas ref={ref} width={480} height={160} className="sig-canvas"
          onMouseDown={start} onMouseMove={move} onMouseUp={stop} onMouseLeave={stop}
          onTouchStart={start} onTouchMove={move} onTouchEnd={stop} />
        <div className="sig-actions"><button className="btn btn-ghost btn-sm" onClick={clear}><Icon name="trash" size={14}/> Limpar</button></div>
        {semAssinatura && <p style={{color:'var(--danger)',fontSize:'.8rem',marginTop:8,display:'flex',alignItems:'center',justifyContent:'center',gap:6}}><Icon name="alertTriangle" size={14}/> Assine antes de confirmar.</p>}
      </div>
      <div className="modal-footer" style={{padding:'16px 0 0',border:'none'}}>
        {onCancel && <button className="btn btn-ghost" onClick={onCancel}>Cancelar</button>}
        <button className="btn btn-primary" onClick={confirm} disabled={!hasSig}><Icon name="check" size={14}/> Confirmar assinatura</button>
      </div>
    </div>
  )
}

// Assinatura de custódia (retirada/recebimento de remessa): termo genérico na hora de assinar,
// foto opcional (quem assina e/ou os itens) e consentimento de uso de imagem (LGPD) — o consentimento
// só é exigido se uma foto for anexada. Entrega ao chamador a assinatura + a foto (data-URL ou null).
function AssinaturaCustodia({ label, tipo, acaoTexto, onConfirm, onCancel }) {
  const [foto, setFoto] = useState(null)
  const [consent, setConsent] = useState(false)
  const [erroConsent, setErroConsent] = useState(false)
  const capturar = file => { if (!file) return; const r = new FileReader(); r.onload = () => setFoto(r.result); r.readAsDataURL(file) }
  const confirmar = sig => {
    if (foto && !consent) { setErroConsent(true); return }
    onConfirm(sig, foto || null)
  }
  const ret = tipo === 'retirada'
  const acao = acaoTexto || (ret ? 'a retirada da custódia dos materiais desta remessa para transporte' : 'o recebimento dos materiais desta remessa na obra')
  const box = { background:'var(--rec-amber-soft, #fff8ee)', border:'1px solid var(--border,#e5e7eb)', borderRadius:8, padding:'12px 14px', fontSize:'.82rem', color:'var(--text-secondary,#374151)', lineHeight:1.5, marginBottom:12 }
  return (
    <div>
      <div style={box}>
        <div style={{fontWeight:700, color:'var(--ink,#111)', marginBottom:6}}>Termo de {ret ? 'Retirada' : 'Recebimento'} de Custódia</div>
        <p style={{margin:'0 0 8px'}}>Declaro, para os devidos fins, realizar {acao}, conferindo os itens e as condições registrados. Estou ciente de que esta assinatura eletrônica, feita com minhas credenciais, tem <strong>validade jurídica plena</strong> nos termos da Lei nº 14.063/2020 e da MP nº 2.200-2/2001, e é de minha exclusiva responsabilidade.</p>
        <p style={{margin:0}}>Caso eu registre foto neste ato, <strong>autorizo</strong> a captura e o uso da imagem (minha e/ou dos materiais) <strong>exclusivamente</strong> para comprovação da cadeia de custódia deste material, nos termos da Lei nº 13.709/2018 (LGPD). A imagem fica associada a este registro e não é usada para qualquer outra finalidade.</p>
      </div>
      <div style={{marginBottom:12}}>
        <div style={{fontSize:'.78rem', color:'var(--text-secondary,#6b7280)', marginBottom:6}}>Foto (opcional) — registrar quem assina e/ou os itens</div>
        {foto ? (
          <div style={{display:'inline-block', position:'relative'}}>
            <img src={foto} alt="registro" style={{maxHeight:120, borderRadius:8, border:'1px solid var(--border,#e5e7eb)', display:'block'}} />
            <button onClick={() => { setFoto(null); setConsent(false); setErroConsent(false) }} title="Remover foto"
              style={{position:'absolute', top:-8, right:-8, width:22, height:22, borderRadius:'50%', border:'none', background:'var(--fill-danger)', color:'#fff', cursor:'pointer', fontSize:13, lineHeight:'22px', padding:0}}>×</button>
          </div>
        ) : (
          <label className="btn btn-ghost btn-sm" style={{display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer'}}>
            📷 Tirar / anexar foto
            <input type="file" accept="image/*" capture="environment" style={{display:'none'}}
              onChange={e => { capturar(e.target.files && e.target.files[0]); e.target.value = '' }} />
          </label>
        )}
      </div>
      {foto && (
        <label style={{display:'flex', gap:8, alignItems:'flex-start', fontSize:'.82rem', color:'var(--text-secondary,#374151)', marginBottom:erroConsent?4:12, cursor:'pointer'}}>
          <input type="checkbox" checked={consent} style={{marginTop:3}} onChange={e => { setConsent(e.target.checked); if (e.target.checked) setErroConsent(false) }} />
          <span>Autorizo o uso desta imagem para o registro da cadeia de custódia, nos termos da LGPD (Lei nº 13.709/2018).</span>
        </label>
      )}
      {erroConsent && <p style={{color:'var(--danger,#b91c1c)', fontSize:'.8rem', margin:'0 0 12px', display:'flex', alignItems:'center', gap:6}}><Icon name="alertTriangle" size={14}/> Marque o consentimento de uso de imagem para anexar a foto (ou remova a foto para assinar sem ela).</p>}
      <SignaturePad label={label} onConfirm={confirmar} onCancel={onCancel} />
    </div>
  )
}

// Assinatura DUPLA de custódia no aparelho do Ajudante: o ator (logado) assina e a contraparte assina
// no mesmo aparelho — com reautenticação OPCIONAL por e-mail/senha (amarra a identidade) ou apenas o
// nome digitado. Foto opcional + consentimento de uso de imagem (LGPD, exigido só se houver foto).
// tipo 'retirada' → contraparte = quem entrega (almoxarifado); 'entrega' → contraparte = quem recebe.
function AssinaturaDupla({ tipo, atorNome, onConfirm, onCancel }) {
  const ret = tipo === 'retirada'
  const [assAtor, setAssAtor] = useState(null)
  const [assContra, setAssContra] = useState(null)
  const [reEmail, setReEmail] = useState('')
  const [reSenha, setReSenha] = useState('')
  const [contraNome, setContraNome] = useState('')
  const [foto, setFoto] = useState(null)
  const [consent, setConsent] = useState(false)
  const [erro, setErro] = useState('')
  const capturar = file => { if (!file) return; const r = new FileReader(); r.onload = () => setFoto(r.result); r.readAsDataURL(file) }
  const contraLabel = ret ? 'quem entrega (Almoxarifado)' : 'quem recebe na obra'
  const acao = ret ? 'a retirada da custódia dos materiais desta remessa para transporte' : 'a entrega dos materiais desta remessa na obra'
  const box = { background:'var(--rec-amber-soft, #fff8ee)', border:'1px solid var(--border,#e5e7eb)', borderRadius:8, padding:'12px 14px', fontSize:'.82rem', color:'var(--text-secondary,#374151)', lineHeight:1.5, marginBottom:12 }
  const sub = { fontSize:'.8rem', fontWeight:700, color:'var(--ink,#111)', margin:'14px 0 6px' }
  // Estilo dos campos da contraparte. Precisa ser local: o `inp` do RecPage não existe aqui, e a
  // referência solta derrubava a tela inteira ao abrir "Retirar (assinar)"/"Entregar (assinar)".
  const inp = { padding:'8px 10px', border:'1px solid var(--border,#d1d5db)', borderRadius:8, background:'var(--card,#fff)', color:'var(--ink,#111)', fontSize:'.9rem', minWidth:0 }
  const thumb = (img, onRefazer) => (
    <div style={{display:'flex', alignItems:'center', gap:10}}>
      <img src={img} alt="assinatura" style={{height:48, border:'1px solid var(--border,#e5e7eb)', borderRadius:6, background:'#fff'}} />
      <span style={{color:'var(--rec-green,#15803d)', fontSize:'.82rem'}}>✓ assinado</span>
      <button className="btn btn-ghost btn-sm" onClick={onRefazer}>Refazer</button>
    </div>
  )
  const confirmar = () => {
    if (!assAtor) return setErro('Falta a sua assinatura.')
    if (!assContra) return setErro('Falta a assinatura de ' + contraLabel + '.')
    if (!reEmail.trim() && !contraNome.trim()) return setErro('Identifique ' + contraLabel + ': e-mail (reautenticação) ou nome.')
    if (foto && !consent) return setErro('Marque o consentimento de uso de imagem para anexar a foto.')
    setErro('')
    onConfirm({
      ator: assAtor, contra: assContra,
      reauth: (reEmail.trim() && reSenha.trim()) ? { email: reEmail.trim(), senha: reSenha } : null,
      contraNome: contraNome.trim() || null,
      foto: foto || null,
    })
  }
  return (
    <div>
      <div style={box}>
        <div style={{fontWeight:700, color:'var(--ink,#111)', marginBottom:6}}>Termo de {ret ? 'Retirada' : 'Entrega'} de Custódia</div>
        <p style={{margin:'0 0 8px'}}>Declaramos, para os devidos fins, realizar {acao}, conferindo os itens e as condições registrados. As assinaturas eletrônicas abaixo têm <strong>validade jurídica plena</strong> nos termos da Lei nº 14.063/2020 e da MP nº 2.200-2/2001, e são de responsabilidade de cada signatário.</p>
        <p style={{margin:0}}>Havendo foto neste ato, os signatários <strong>autorizam</strong> a captura e o uso da imagem <strong>exclusivamente</strong> para comprovação da cadeia de custódia, nos termos da Lei nº 13.709/2018 (LGPD).</p>
      </div>

      <div style={sub}>1 · Sua assinatura — {atorNome}</div>
      {assAtor ? thumb(assAtor, () => setAssAtor(null)) : <SignaturePad label={`Assinatura de ${atorNome}`} onConfirm={setAssAtor} />}

      <div style={sub}>2 · Assinatura de {contraLabel}</div>
      <div style={{fontSize:'.76rem', color:'var(--text-secondary,#6b7280)', marginBottom:6}}>Reautenticação opcional — se {ret ? 'o almoxarife' : 'quem recebe'} tiver login, informe e-mail/senha para amarrar a identidade. Senão, digite o nome.</div>
      <div style={{display:'flex', gap:8, flexWrap:'wrap', marginBottom:8}}>
        <input style={{...inp, flex:'1 1 160px'}} type="email" placeholder="e-mail (opcional)" value={reEmail} onChange={e=>setReEmail(e.target.value)} autoComplete="off" />
        <input style={{...inp, flex:'1 1 120px'}} type="password" placeholder="senha (opcional)" value={reSenha} onChange={e=>setReSenha(e.target.value)} autoComplete="off" />
        <input style={{...inp, flex:'1 1 160px'}} placeholder="ou nome de quem assina" value={contraNome} onChange={e=>setContraNome(e.target.value)} />
      </div>
      {assContra ? thumb(assContra, () => setAssContra(null)) : <SignaturePad label={`Assinatura de ${contraLabel}`} onConfirm={setAssContra} />}

      <div style={{...sub, marginBottom:6}}>Foto (opcional) — registrar quem assina e/ou os itens</div>
      {foto ? (
        <div style={{display:'inline-block', position:'relative'}}>
          <img src={foto} alt="registro" style={{maxHeight:120, borderRadius:8, border:'1px solid var(--border,#e5e7eb)', display:'block'}} />
          <button onClick={() => { setFoto(null); setConsent(false) }} title="Remover foto"
            style={{position:'absolute', top:-8, right:-8, width:22, height:22, borderRadius:'50%', border:'none', background:'var(--fill-danger)', color:'#fff', cursor:'pointer', fontSize:13, lineHeight:'22px', padding:0}}>×</button>
        </div>
      ) : (
        <label className="btn btn-ghost btn-sm" style={{display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer'}}>
          📷 Tirar / anexar foto
          <input type="file" accept="image/*" capture="environment" style={{display:'none'}}
            onChange={e => { capturar(e.target.files && e.target.files[0]); e.target.value = '' }} />
        </label>
      )}
      {foto && (
        <label style={{display:'flex', gap:8, alignItems:'flex-start', fontSize:'.82rem', color:'var(--text-secondary,#374151)', margin:'10px 0 0', cursor:'pointer'}}>
          <input type="checkbox" checked={consent} style={{marginTop:3}} onChange={e => setConsent(e.target.checked)} />
          <span>Autorizo o uso desta imagem para o registro da cadeia de custódia, nos termos da LGPD (Lei nº 13.709/2018).</span>
        </label>
      )}

      {erro && <p style={{color:'var(--danger,#b91c1c)', fontSize:'.8rem', margin:'12px 0 0', display:'flex', alignItems:'center', gap:6}}><Icon name="alertTriangle" size={14}/> {erro}</p>}
      <div className="modal-footer" style={{padding:'16px 0 0', border:'none'}}>
        {onCancel && <button className="btn btn-ghost" onClick={onCancel}>Cancelar</button>}
        <button className="btn btn-primary" onClick={confirmar} disabled={!assAtor || !assContra}><Icon name="check" size={14}/> Confirmar {ret ? 'retirada' : 'entrega'}</button>
      </div>
    </div>
  )
}

// Retirada de remessa DIRETA no balcão do fornecedor (compra levada direto à unidade). O balconista não tem conta
// no app, então a prova da retirada é: a conferência item a item, o NOME de quem entregou e a FOTO do material
// (obrigatórios, com o consentimento LGPD), mais a assinatura do motorista. A assinatura do balconista vale se ele
// aceitar assinar (opcional). Item não conferido exige a divergência por escrito (falta, avaria, troca).
function AssinaturaFornecedor({ fornecedor, itens, atorNome, onConfirm, onCancel }) {
  const lista = itens || []
  const [ok, setOk] = useState(() => lista.map(() => false))
  const [contraNome, setContraNome] = useState('')
  const [foto, setFoto] = useState(null)
  const [consent, setConsent] = useState(false)
  const [assAtor, setAssAtor] = useState(null)
  const [assBalcao, setAssBalcao] = useState(null)
  const [balcao, setBalcao] = useState(false)       // abriu o quadro da assinatura do balconista
  const [diverg, setDiverg] = useState('')
  const [erro, setErro] = useState('')
  const capturar = file => { if (!file) return; const r = new FileReader(); r.onload = () => setFoto(r.result); r.readAsDataURL(file) }
  const conferidos = ok.filter(Boolean).length
  const tudoOk = conferidos === lista.length
  const forn = fornecedor || 'o fornecedor'
  const box = { background:'var(--rec-amber-soft, #fff8ee)', border:'1px solid var(--border,#e5e7eb)', borderRadius:8, padding:'12px 14px', fontSize:'.82rem', color:'var(--text-secondary,#374151)', lineHeight:1.5, marginBottom:12 }
  const sub = { fontSize:'.8rem', fontWeight:700, color:'var(--ink,#111)', margin:'14px 0 6px' }
  const inp = { padding:'8px 10px', border:'1px solid var(--border,#d1d5db)', borderRadius:8, background:'var(--card,#fff)', color:'var(--ink,#111)', fontSize:'.9rem', minWidth:0, width:'100%', boxSizing:'border-box' }
  const thumb = (img, onRefazer) => (
    <div style={{display:'flex', alignItems:'center', gap:10}}>
      <img src={img} alt="assinatura" style={{height:48, border:'1px solid var(--border,#e5e7eb)', borderRadius:6, background:'#fff'}} />
      <span style={{color:'var(--rec-green,#15803d)', fontSize:'.82rem'}}>✓ assinado</span>
      <button className="btn btn-ghost btn-sm" onClick={onRefazer}>Refazer</button>
    </div>
  )
  const confirmar = () => {
    if (!tudoOk && diverg.trim().length < 3) return setErro('Item não conferido: descreva a divergência (o que faltou, veio avariado ou trocado).')
    if (!contraNome.trim()) return setErro('Informe o nome de quem entregou o material no balcão.')
    if (!foto) return setErro('Tire a foto do material retirado: é a prova da retirada no fornecedor.')
    if (!consent) return setErro('Marque o consentimento de uso de imagem (LGPD) para registrar a foto.')
    if (!assAtor) return setErro('Falta a sua assinatura.')
    setErro('')
    onConfirm({ ator: assAtor, contra: assBalcao || null, contraNome: contraNome.trim(), foto, divergencia: diverg.trim() || null })
  }
  return (
    <div>
      <div style={box}>
        <div style={{fontWeight:700, color:'var(--ink,#111)', marginBottom:6}}>Termo de Retirada no Fornecedor</div>
        <p style={{margin:'0 0 8px'}}>Declaro retirar em <strong>{forn}</strong> os materiais desta remessa, conferidos item a item, e assumir a custódia deles até a entrega na unidade. Esta assinatura eletrônica tem <strong>validade jurídica plena</strong> nos termos da Lei nº 14.063/2020 e da MP nº 2.200-2/2001.</p>
        <p style={{margin:0}}>A foto do material é <strong>obrigatória</strong> e, com o consentimento abaixo, é usada <strong>exclusivamente</strong> para comprovar a cadeia de custódia, nos termos da Lei nº 13.709/2018 (LGPD).</p>
      </div>

      <div style={sub}>1 · Conferência <span style={{fontWeight:400, color:'var(--rec-sub,#6b7280)'}}>— {conferidos}/{lista.length} conferido(s)</span></div>
      <div style={{display:'grid', gap:6}}>
        {lista.map((it, i) => (
          <label key={it.id || i} style={{display:'flex', gap:10, alignItems:'center', padding:'8px 10px', borderRadius:8, cursor:'pointer', fontSize:'.86rem', color:'var(--ink,#111)',
            background: ok[i] ? 'var(--rec-green-soft, rgba(46,125,107,.10))' : 'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)'}}>
            <input type="checkbox" checked={ok[i]} onChange={e => setOk(o => o.map((v, j) => j === i ? e.target.checked : v))} style={{width:18, height:18, flex:'none'}} />
            <span><strong>{Number(it.qtd)}{it.unidade ? ` ${it.unidade}` : ''}</strong> · {it.catalogo_nome || it.descricao || 'item'}</span>
          </label>
        ))}
      </div>
      {!tudoOk && <textarea style={{...inp, minHeight:52, marginTop:8}} placeholder="Divergência: o que faltou, veio avariado ou trocado…" value={diverg} onChange={e=>setDiverg(e.target.value)} />}

      <div style={sub}>2 · Quem entregou no balcão *</div>
      <input style={inp} placeholder={`Nome do funcionário de ${forn}`} value={contraNome} onChange={e=>setContraNome(e.target.value)} maxLength={120} autoComplete="off" />

      <div style={sub}>3 · Foto do material *</div>
      {foto ? (
        <div style={{display:'inline-block', position:'relative'}}>
          <img src={foto} alt="material retirado" style={{maxHeight:140, borderRadius:8, border:'1px solid var(--border,#e5e7eb)', display:'block'}} />
          <button onClick={() => { setFoto(null); setConsent(false) }} title="Remover foto"
            style={{position:'absolute', top:-8, right:-8, width:22, height:22, borderRadius:'50%', border:'none', background:'var(--fill-danger)', color:'#fff', cursor:'pointer', fontSize:13, lineHeight:'22px', padding:0}}>×</button>
        </div>
      ) : (
        <label className="btn btn-outline" style={{display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer'}}>
          📷 Tirar foto do material
          <input type="file" accept="image/*" capture="environment" style={{display:'none'}}
            onChange={e => { capturar(e.target.files && e.target.files[0]); e.target.value = '' }} />
        </label>
      )}
      <label style={{display:'flex', gap:8, alignItems:'flex-start', fontSize:'.82rem', color:'var(--text-secondary,#374151)', margin:'10px 0 0', cursor:'pointer'}}>
        <input type="checkbox" checked={consent} style={{marginTop:3}} onChange={e => setConsent(e.target.checked)} />
        <span>Autorizo o uso desta imagem para o registro da cadeia de custódia, nos termos da LGPD (Lei nº 13.709/2018).</span>
      </label>

      <div style={sub}>4 · Sua assinatura — {atorNome} *</div>
      {assAtor ? thumb(assAtor, () => setAssAtor(null)) : <SignaturePad label={`Assinatura de ${atorNome}`} onConfirm={setAssAtor} />}

      <div style={sub}>5 · Assinatura de quem entregou <span style={{fontWeight:400, color:'var(--rec-sub,#6b7280)'}}>(opcional)</span></div>
      {assBalcao ? thumb(assBalcao, () => setAssBalcao(null))
        : balcao ? <SignaturePad label={`Assinatura de ${contraNome.trim() || 'quem entregou'}`} onConfirm={setAssBalcao} onCancel={() => setBalcao(false)} />
        : <button className="btn btn-ghost btn-sm" onClick={() => setBalcao(true)}>O balconista aceita assinar</button>}

      {erro && <p style={{color:'var(--danger,#b91c1c)', fontSize:'.8rem', margin:'12px 0 0', display:'flex', alignItems:'center', gap:6}}><Icon name="alertTriangle" size={14}/> {erro}</p>}
      <div className="modal-footer" style={{padding:'16px 0 0', border:'none'}}>
        {onCancel && <button className="btn btn-ghost" onClick={onCancel}>Cancelar</button>}
        <button className="btn btn-primary" onClick={confirmar}><Icon name="check" size={14}/> Confirmar retirada</button>
      </div>
    </div>
  )
}

// ─── TOAST ────────────────────────────────────────────────────────────────────
function Toast({ toasts }) {
  return <div className="toast-container">{toasts.map(t=>(
    <div key={t.id} className={`toast ${t.type}`}>
      <span><Icon name={t.type==='success'?'checkCircle':t.type==='error'?'x':'alertTriangle'} size={16}/></span><span>{t.msg}</span>
    </div>
  ))}</div>
}

// ─── ITEMS EDITOR ─────────────────────────────────────────────────────────────
// ct (opcional, useContratosCadastro): com 2+ contratos cada ferramenta leva a etiqueta do contrato dela.
function ItemsEditor({ ferramentas, value, onChange, ct }) {
  const [fId, setFId] = useState('')
  const [qty, setQty] = useState(1)
  const [aviso, setAviso] = useState('')
  // Disponível = o que o backend calculou (total − reservado/em campo). Fallback ao total se o campo não veio.
  const dispDe = f => (f && f.quantidade_disponivel != null ? f.quantidade_disponivel : (f ? (f.quantidade_total || 0) : 0))
  const selecionada = ferramentas.find(f => f.id == fId)
  const dispSel = dispDe(selecionada)
  const add = () => {
    setAviso('')
    if (!fId) return
    const f = ferramentas.find(f => f.id == fId)
    if (!f || value.find(i => i.ferramenta_id == fId)) return
    const disp = dispDe(f)
    if (disp <= 0) { setAviso(`"${f.nome}" está sem disponibilidade no estoque.`); return }
    const q = Math.min(Math.max(1, qty), disp)
    onChange([...value, { ferramenta_id: parseInt(fId), quantidade: q, ferramenta_nome: f.nome, valor_unitario: f.valor_unitario || 0 }])
    setFId(''); setQty(1)
  }
  const remove = id => onChange(value.filter(i => i.ferramenta_id !== id))
  const updateQty = (id, q) => {
    const f = ferramentas.find(f => f.id === id)
    const max = f ? dispDe(f) : Infinity
    const v = Math.min(Math.max(1, parseInt(q) || 1), max || 1)
    onChange(value.map(i => i.ferramenta_id === id ? {...i, quantidade: v} : i))
  }
  const available = ferramentas.filter(f => !value.find(i => i.ferramenta_id === f.id))
  const total = value.reduce((s,i) => s + (i.valor_unitario||0)*(i.quantidade||1), 0)
  return (
    <div>
      <div className="ie-add">
        <select value={fId} onChange={e=>{setFId(e.target.value); setAviso(''); const f=ferramentas.find(x=>x.id==e.target.value); if(f) setQty(Math.min(qty, Math.max(1, dispDe(f))))}}>
          <option value="">Selecione uma ferramenta...</option>
          {available.map(f=>{const d=dispDe(f); return <option key={f.id} value={f.id} disabled={d<=0}>{f.nome}{f.codigo?` (${f.codigo})`:''} — {d>0?`${d} disp.`:'sem estoque'}{f.valor_unitario?` · ${fmtBRL(f.valor_unitario)}`:''}{ct && ct.multi?` · ${ct.nome(ct.de(f))}`:''}</option>})}
        </select>
        <input type="number" min="1" max={dispSel||1} value={qty} onChange={e=>setQty(parseInt(e.target.value)||1)} inputMode="numeric" aria-label="Quantidade" disabled={!fId || dispSel<=0} />
        <button className="btn btn-accent btn-sm" type="button" onClick={add} disabled={!fId || dispSel<=0}><Icon name="plus" size={14}/> Add</button>
      </div>
      {aviso && <div className="alert alert-warning" style={{display:'flex',alignItems:'center',gap:8,marginBottom:8,padding:'8px 12px'}}><Icon name="alertTriangle" size={15}/> {aviso}</div>}
      {value.length > 0 && (
        <div className="items-list">
          {value.map(i => {
            const f = ferramentas.find(x=>x.id===i.ferramenta_id); const d = f ? dispDe(f) : null
            return (
            <div key={i.ferramenta_id} className="item-row">
              <span style={{fontSize:'.88rem'}}>{i.ferramenta_nome}{d!=null && <span className="text-muted" style={{fontSize:'.72rem'}}> · {d} disp.</span>}{ct && f && <ContratoTag ct={ct} id={ct.de(f)}/>}</span>
              <input type="number" min="1" max={d!=null?Math.max(1,d):undefined} value={i.quantidade} onChange={e=>updateQty(i.ferramenta_id,e.target.value)} style={{padding:'4px 8px',fontSize:'.85rem'}} />
              <span style={{fontSize:'.82rem',color:'var(--success)',fontWeight:600}}>{fmtBRL((i.valor_unitario||0)*(i.quantidade||1))}</span>
              <button className="btn btn-danger btn-sm" type="button" onClick={()=>remove(i.ferramenta_id)} style={{display:'inline-flex',alignItems:'center'}}><Icon name="x" size={14}/></button>
            </div>
          )})}
          {total > 0 && <div style={{padding:'8px 12px',background:'rgba(46,125,107,.08)',display:'flex',justifyContent:'flex-end',gap:8,fontWeight:700}}>
            <span className="text-muted">Total estimado:</span>
            <span style={{color:'var(--success)'}}>{fmtBRL(total)}</span>
          </div>}
        </div>
      )}
      {!value.length && <p className="text-muted" style={{marginTop:4}}>Nenhum item adicionado.</p>}
    </div>
  )
}

// ─── PRIMEIRO ACESSO ──────────────────────────────────────────────────────────
function PrimeiroAcessoPage({ user, onConcluido }) {
  const [senha, setSenha] = useState('')
  const [confirma, setConfirma] = useState('')
  const [aceite, setAceite] = useState(false)
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)
  const [mostraSenha, setMostraSenha] = useState(false)
  const [mostraConfirma, setMostraConfirma] = useState(false)

  const submit = async e => {
    e.preventDefault(); setErr('')
    if (senha.length < 6) return setErr('A senha deve ter pelo menos 6 caracteres.')
    if (senha !== confirma) return setErr('As senhas não coincidem.')
    if (!aceite) return setErr('Você deve ler e aceitar o Termo de Responsabilidade.')
    setLoading(true)
    try {
      const data = await POST('/auth/trocar-senha', { nova_senha: senha, aceite_termos: true })
      token.value = data.token; localStorage.setItem('cf_token', data.token)
      onConcluido(data.user)
    } catch(e) { setErr(e.message) }
    setLoading(false)
  }

  return (
    <div style={{minHeight:'100dvh',background:'var(--bg)',display:'flex',alignItems:'center',justifyContent:'center',padding:'max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left))'}}>
      <div style={{background:'var(--card)',borderRadius:12,boxShadow:'0 4px 24px rgba(0,0,0,.12)',maxWidth:600,width:'100%',overflow:'hidden'}}>
        <div style={{background:'var(--fill-navy)',padding:'20px 24px',color:'#fff'}}>
          <div style={{fontWeight:700,fontSize:'1.1rem',display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={18}/> Bem-vindo(a), {user.nome}</div>
          <div style={{fontSize:'.88rem',opacity:.9,marginTop:4}}>Este é seu primeiro acesso. Crie uma senha pessoal para continuar.</div>
        </div>
        <div style={{padding:24}}>
          <div style={{border:'1px solid var(--border)',borderRadius:8,maxHeight:320,overflowY:'auto',padding:'16px 20px',background:'var(--surface-alt)',fontSize:'.82rem',lineHeight:1.7,marginBottom:20}}>
            <div style={{fontWeight:700,fontSize:'.95rem',textAlign:'center',marginBottom:12}}>TERMO DE RESPONSABILIDADE E CONFIDENCIALIDADE DE SENHA</div>
            <p>Ao criar sua senha pessoal de acesso ao Sistema de Cautela de Ferramentas da <strong>{empresaInfo.razaoSocial}</strong>, você declara que leu, compreendeu e concorda com as seguintes condições:</p>
            <p><strong>1. Senha pessoal e intransferível</strong><br/>Sua senha de acesso é pessoal, secreta e intransferível. É estritamente proibido compartilhá-la com qualquer pessoa, incluindo colegas, líderes ou qualquer outro funcionário da empresa.</p>
            <p><strong>2. Responsabilidade exclusiva pelas ações</strong><br/>Todas as ações realizadas no sistema com suas credenciais — incluindo solicitações de ferramentas, assinaturas eletrônicas de termos e confirmações de recebimento — são de sua <em>exclusiva responsabilidade</em> e possuem plena validade jurídica, nos termos da Lei nº 14.063/2020.</p>
            <p><strong>3. Guarda e sigilo obrigatórios</strong><br/>Você se compromete a manter o sigilo absoluto de sua senha, não a anotando em locais acessíveis a terceiros e não a transmitindo por nenhum meio (oral, escrito ou digital).</p>
            <p><strong>4. Comunicação de comprometimento</strong><br/>Em caso de suspeita de acesso indevido ou comprometimento de suas credenciais, você deve comunicar imediatamente ao almoxarifado para que o acesso seja suspenso e uma nova senha seja criada.</p>
            <p><strong>5. Proibição de uso por terceiros</strong><br/>É vedado permitir que terceiros utilizem o sistema em seu nome, mesmo que temporariamente. O uso indevido poderá resultar em medidas disciplinares, incluindo rescisão contratual.</p>
            <p><strong>6. Validade das assinaturas eletrônicas</strong><br/>As assinaturas realizadas com suas credenciais têm validade jurídica plena. Ao assinar qualquer termo no sistema, você confirma ter lido o documento e concorda integralmente com seu conteúdo.</p>
            <p><strong>7. Isenção de responsabilidade da empresa</strong><br/>A {empresaInfo.razaoSocial} não se responsabiliza por prejuízos decorrentes do compartilhamento voluntário ou da guarda inadequada de senha pelo usuário.</p>
            <p style={{marginTop:12,fontStyle:'italic'}}>Ao criar sua senha e clicar em <strong>"Confirmar e Acessar"</strong>, você afirma ter lido integralmente este termo e que a senha criada é exclusivamente do seu conhecimento.</p>
          </div>
          <form onSubmit={submit}>
            <div style={{display:'flex',flexDirection:'column',gap:12,marginBottom:12}}>
              <div className="form-group">
                <label>Nova senha <span style={{color:'red'}}>*</span></label>
                <div style={{position:'relative'}}>
                  <input type={mostraSenha?'text':'password'} value={senha} onChange={e=>setSenha(e.target.value)} placeholder="Mínimo 6 caracteres" autoComplete="new-password" style={{paddingRight:40}} />
                  <button type="button" onClick={()=>setMostraSenha(v=>!v)} style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--text-secondary)',padding:0,display:'inline-flex',alignItems:'center'}}>
                    <Icon name={mostraSenha ? 'eyeOff' : 'eye'} size={17}/>
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label>Confirmar nova senha <span style={{color:'red'}}>*</span></label>
                <div style={{position:'relative'}}>
                  <input type={mostraConfirma?'text':'password'} value={confirma} onChange={e=>setConfirma(e.target.value)} placeholder="Repita a senha" autoComplete="new-password" style={{paddingRight:40}} />
                  <button type="button" onClick={()=>setMostraConfirma(v=>!v)} style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--text-secondary)',padding:0,display:'inline-flex',alignItems:'center'}}>
                    <Icon name={mostraConfirma ? 'eyeOff' : 'eye'} size={17}/>
                  </button>
                </div>
              </div>
            </div>
            <label style={{display:'flex',alignItems:'flex-start',gap:10,cursor:'pointer',marginBottom:12,fontSize:'.88rem'}}>
              <input type="checkbox" checked={aceite} onChange={e=>setAceite(e.target.checked)} style={{marginTop:3,flexShrink:0,width:'auto'}} />
              <span>Li e aceito o <strong>Termo de Responsabilidade e Confidencialidade de Senha</strong>. Estou ciente de que minha senha é pessoal e intransferível.</span>
            </label>
            {err && <div className="alert alert-error" style={{marginBottom:12}}>{err}</div>}
            <button className="btn btn-primary" type="submit" disabled={loading} style={{width:'100%',padding:'12px'}}>
              {loading ? 'Aguarde...' : <span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="check" size={15}/> Confirmar e Acessar</span>}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

// ─── LOGIN ────────────────────────────────────────────────────────────────────
function LoginPage({ onLogin, aviso }) {
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [mostraSenha, setMostraSenha] = useState(false)
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)
  const submit = async e => {
    e.preventDefault(); setErr(''); setLoading(true)
    try {
      const data = await POST('/auth/login', { email, senha })
      token.value = data.token; localStorage.setItem('cf_token', data.token); onLogin(data.user)
    } catch(e) { setErr(e.message) }
    setLoading(false)
  }
  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          {empresaInfo.logoUrl
            ? <img src={empresaInfo.logoUrl} alt={empresaInfo.nome} style={{maxWidth:160,maxHeight:70,marginBottom:8}} />
            : <div className="brand-mark" aria-hidden="true">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2.5l7.5 2.8v5.4c0 4.2-3 7.4-7.5 8.4-4.5-1-7.5-4.2-7.5-8.4V5.3L12 2.5z"/>
                  <path d="M14.4 8.6a2.2 2.2 0 00-2.8 2.8l-2.7 2.7 1.3 1.3 2.7-2.7a2.2 2.2 0 002.8-2.8l-1.4 1.4-1.3-1.3 1.4-1.4z" fill="#fff" stroke="none"/>
                </svg>
              </div>}
          <h1 style={{fontWeight:800,letterSpacing:'.01em'}}>Cautelix</h1>
          <p style={{marginTop:4,fontSize:'.8rem',color:'var(--silver)'}}>{empresaInfo.nome} — Controle de Ferramentas</p>
        </div>
        {err && <div className="alert alert-error" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {err}</div>}
        {!err && aviso && <div className="alert alert-info" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={15}/> {aviso}</div>}
        <form onSubmit={submit}>
          <div className="form-group" style={{marginBottom:14}}>
            <label>Email</label>
            <input type="email" name="email" autoComplete="username" value={email} onChange={e=>setEmail(e.target.value)} placeholder="seu@email.com" required />
          </div>
          <div className="form-group" style={{marginBottom:20}}>
            <label>Senha</label>
            <div style={{position:'relative'}}>
              <input type={mostraSenha?'text':'password'} name="password" autoComplete="current-password" value={senha} onChange={e=>setSenha(e.target.value)} placeholder="••••••••" required style={{paddingRight:40}} />
              <button type="button" onClick={()=>setMostraSenha(v=>!v)} style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--text-secondary)',padding:0,display:'inline-flex',alignItems:'center'}}>
                <Icon name={mostraSenha ? 'eyeOff' : 'eye'} size={17}/>
              </button>
            </div>
          </div>
          <button className="btn btn-primary" style={{width:'100%',justifyContent:'center',padding:'12px'}} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
        <p style={{textAlign:'center',marginTop:24,fontSize:'.72rem',color:'var(--silver)'}}>
          Desenvolvido por <strong style={{color:'var(--text-secondary)'}}>MindMax Tecnologia</strong>
        </p>
      </div>
    </div>
  )
}

// Card de engenheiro no ranking do Diretor. Métricas alinhadas numa coluna à direita
// (leitura de relance) e drill-in ao clicar: abre quais obras e quais colaboradores.
// ir(page, id, filtro) → função de navegação ou null (papel sem a aba); irTransf = destino das
// transferências pendentes (caixa de tarefas do Gerente / Auditoria do Diretor).
function EngRankCard({ l, maxLider, ir, irTransf }) {
  const [open, setOpen] = useState(false)
  const obrasL  = l.obras_lista || []
  const colabsL = l.colaboradores_lista || []
  const pct = Math.min(100, Math.round((l.valor || 0) / maxLider * 100))
  const go = (...a) => ir ? ir(...a) : null
  // Cautelas em posse da equipe dele (mesma base do "valor sob gestão").
  const irEquipe = colabsL.length && l.cautelas ? go('cautelas', null, { status: 'ativa', colaboradores: colabsL.map(c => c.id), rotulo: `Cautelas da equipe de ${l.nome}` }) : null
  return (
    <div className={`erk ${open ? 'open' : ''}`}>
      <button className="erk-hd" onClick={() => setOpen(o => !o)} aria-expanded={open}>
        <div className="erk-id">
          <div className="erk-av">{iniciais(l.nome)}</div>
          <div>
            <div className="erk-n">{l.nome}</div>
            <div className="erk-sub">{l.obras} obra{l.obras === 1 ? '' : 's'} · {l.colaboradores} colaborador{l.colaboradores === 1 ? '' : 'es'}</div>
          </div>
        </div>
        <span className="erk-chev"><Icon name="chevronRight" size={18} /></span>
      </button>

      <div className="erk-metrics">
        <div className="erk-m"><span className="erk-l">Colaboradores</span><span className="erk-v">{l.colaboradores}</span></div>
        <div className="erk-m lk-row" {...linkProps(irEquipe)}><span className="erk-l">Cautelas ativas</span><span className="erk-v">{l.cautelas}</span></div>
        <div className="erk-m erk-val lk-row" {...linkProps(irEquipe)}><span className="erk-l">Valor sob gestão</span><span className="erk-v strong">{fmtBRLc(l.valor || 0)}</span></div>
        <div className="erk-bar"><i style={{ width: pct + '%' }} /></div>
        {l.transf_pend > 0 && <div className="erk-m warn lk-row" {...linkProps(irTransf)}><span className="erk-l">Transferências pendentes</span><span className="erk-v">{l.transf_pend}</span></div>}
        {l.sol_paradas > 0 && <div className="erk-m warn lk-row" {...linkProps(go('solicitacoes', null, { lider: l.id, ativas: true, criadaMaisDe: 3, rotulo: `Solicitações paradas +3 dias · ${l.nome}` }))}><span className="erk-l">Solicitações paradas +3d</span><span className="erk-v">{l.sol_paradas}</span></div>}
      </div>

      {open && (
        <div className="erk-det">
          <div className="erk-dsec">
            <div className="erk-dh">Obras <span>{obrasL.length}</span></div>
            {obrasL.length ? (
              <ul className="erk-list">
                {obrasL.map((o, i) => (
                  <li key={i} className="lk-row" {...linkProps(o.id ? go('obras', o.id) : null)}><span className="erk-li-n">{o.codigo ? o.codigo + ' · ' : ''}{o.nome}</span><span className="erk-li-v">{o.colaboradores} colab.</span></li>
                ))}
              </ul>
            ) : <div className="erk-empty">Nenhuma obra atribuída.</div>}
          </div>
          <div className="erk-dsec">
            <div className="erk-dh">Colaboradores <span>{colabsL.length}</span></div>
            {colabsL.length ? (
              <ul className="erk-list">
                {colabsL.map(c => (
                  <li key={c.id} className="lk-row" {...linkProps(c.cautelas
                    ? go('cautelas', null, { status: 'ativa', colaborador: c.id, rotulo: `Cautelas com ${c.nome}` })
                    : go('usuarios', c.id))}>
                    <span className="erk-li-n">{c.nome}<em>{c.cargo || 'Sem função'}{c.obra ? ' · ' + c.obra : ''}</em></span>
                    <span className="erk-li-v">{c.cautelas ? c.cautelas + ' cautela' + (c.cautelas === 1 ? '' : 's') : '—'}</span>
                  </li>
                ))}
              </ul>
            ) : <div className="erk-empty">Nenhum colaborador na equipe.</div>}
          </div>
        </div>
      )}
    </div>
  )
}

// Caixa "Tarefas em aberto" do Gerente de Contrato. Lista eventos que pedem ciência
// (transferências pendentes, solicitações paradas). "Ciente" é registro de supervisão —
// não trava a operação. Pendentes de ciência aparecem primeiro; reconhecidas caem abaixo.
// ir(page, id) abre a solicitação parada (transferência não tem tela para o Gerente: segue só ciência).
function GerenteTarefas({ tarefas: inicial, addToast, ir }) {
  const [tarefas, setTarefas] = useState(inicial || [])
  // O dashboard busca /api/dashboard de forma assíncrona: no 1º render `inicial` chega
  // undefined (stats={}) e só depois vem preenchido. Sem este sync, o useState mantém o
  // valor inicial ([]) para sempre e a caixa fica vazia mesmo com tarefas no payload.
  useEffect(() => { setTarefas(inicial || []) }, [inicial])
  const [busy, setBusy] = useState(null)
  const darCiente = async t => {
    const key = t.tipo + t.ref_id
    setBusy(key)
    try {
      const r = await POST('/gerente/tarefas/ciente', { tipo: t.tipo, ref_id: t.ref_id })
      setTarefas(r.tarefas || [])
      addToast && addToast('Ciência registrada.', 'success')
    } catch { addToast && addToast('Não foi possível registrar a ciência.', 'error') }
    setBusy(null)
  }
  const pend = tarefas.filter(t => !t.ciente).length
  return (
    <div className="dc-card dc-span12" id="gerente-tarefas" style={{ scrollMarginTop: 16 }}>
      <span className="dc-mtag">Supervisão</span>
      <h4>Tarefas em aberto {pend > 0 && <span className="gt-count">{pend}</span>}</h4>
      <p className="gt-hint">Eventos que pedem sua ciência. Registrar não altera a operação — é só supervisão.</p>
      {tarefas.length === 0 ? (
        <div className="gt-empty"><Icon name="checkCircle" size={17} /> Nada pendente agora.</div>
      ) : (
        <ul className="gt-list">
          {tarefas.map(t => {
            const key = t.tipo + t.ref_id
            return (
              <li key={key} className={`gt-item ${t.ciente ? 'done' : ''}`}>
                <span className={`gt-ic ${t.tipo}`}><Icon name={t.tipo === 'transferencia' ? 'handshake' : 'download'} size={16} /></span>
                <div className="gt-body lk-row" {...linkProps(t.tipo === 'solicitacao' && ir ? ir('solicitacoes', t.ref_id) : null)}>
                  <div className="gt-t">{t.titulo}</div>
                  <div className="gt-d">há {t.dias}d · {t.detalhe}</div>
                  {t.estado && <div className={`gt-state ${t.tipo === 'transferencia' && /Aceita/.test(t.estado) ? 'aceita' : ''}`}>{t.estado}</div>}
                  {t.ciente && <div className="gt-ack"><Icon name="check" size={12} /> Ciente — {t.ciente_por}</div>}
                </div>
                {t.ciente
                  ? <span className="gt-badge">Ciente</span>
                  : <button className="btn btn-sm btn-primary gt-btn" disabled={busy === key} onClick={() => darCiente(t)}>{busy === key ? '…' : 'Ciente'}</button>}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

// ─── DASHBOARD ────────────────────────────────────────────────────────────────
// ─── INBOX DE PENDÊNCIAS ───────────────────────────────────────────────────────
// Consolida os badges que hoje ficam espalhados pela sidebar (solicitações, empréstimos,
// transferências, uniformes) numa fila única "precisa de você" — padrão Activity/Unreads
// do Slack, ancorado no núcleo do produto: responsabilização e rastreabilidade.
// Deriva do MESMO objeto `notif` já carregado no App (GET /notificacoes, poll de 30s) —
// zero endpoint novo. Cada linha é acionável e leva direto para a fila correta.
//
// sev: 'urgent' (vermelho/notif) · 'action' (cobre/accent) · 'info' (prata, só visibilidade).
// O total no topo e o badge da sidebar contam SÓ os acionáveis (urgent+action) — o que de
// fato depende da pessoa; os 'info' entram no grupo "Acompanhando", sem inflar o número.
function pendenciasDefs(notif, user) {
  const n = notif || {}, r = user.role, out = []
  const add = (qtd, o) => { if (qtd > 0) out.push({ ...o, n: qtd }) }
  if (r === 'almoxarifado') {
    add(n.solicitacoes_novas,   { sev: 'action', icon: 'clipboard', label: 'Solicitações novas',            desc: 'aguardando separação no almoxarifado', page: 'solicitacoes', cta: 'Separar' })
    add(n.solicitacoes_prontas, { sev: 'info',   icon: 'package',   label: 'Prontas para retirada',         desc: 'separadas — o líder vai buscar',       page: 'solicitacoes', cta: 'Ver' })
    add(n.cautelas_aguardando,  { sev: 'info',   icon: 'package',   label: 'Cautelas aguardando retirada',  desc: 'colaborador precisa buscar',           page: 'cautelas',     cta: 'Ver' })
    add(n.portes_em_transito,   { sev: 'info',   icon: 'truck',     label: 'Bolsas com o apontador',        desc: 'a caminho do operário — falta o recebimento assinado', page: 'solicitacoes', cta: 'Ver' })
    add(n.estoque_pedidos_abertos, { sev: 'action', icon: 'send',   label: 'Pedidos de reposição das bases', desc: 'uma base pediu material à Sede',     page: 'estoque', target: 'pedidos', cta: 'Enviar' })
  }
  if (r === 'almoxarife2') {
    add(n.estoque_pedidos_a_receber, { sev: 'action', icon: 'signature', label: 'Material a caminho da sua base', desc: 'confira e assine a chegada', page: 'estoque', target: 'pedidos', cta: 'Confirmar' })
    add(n.estoque_pedidos_abertos, { sev: 'info',   icon: 'send',      label: 'Pedidos à Sede aguardando',     desc: 'a Sede ainda não respondeu',           page: 'estoque', target: 'pedidos', cta: 'Ver' })
  }
  if (r === 'lider' || r === 'engenheiro') {
    add(n.transferencias_recebidas,     { sev: 'urgent', icon: 'handshake', label: 'Transferências para aceitar', desc: 'colaborador aguardando o seu aceite', page: 'equipe',       cta: 'Aceitar' })
    add(n.emprestimos_aguardando_aval,  { sev: 'action', icon: 'exchange',  label: 'Empréstimos para avaliar',    desc: 'aguardando a sua aprovação',          page: 'emprestimos',  cta: 'Avaliar' })
    add(n.solicitacoes_prontas,         { sev: 'action', icon: 'package',   label: 'Solicitações prontas',        desc: 'separadas — retire no almoxarifado',  page: 'solicitacoes', cta: 'Retirar' })
    add(n.cautelas_aguardando_retirada, { sev: 'info',   icon: 'package',   label: 'Cautelas aguardando retirada', desc: 'sua equipe precisa buscar',          page: 'cautelas',     cta: 'Ver' })
  }
  if (r === 'apontador') {
    add(n.portes_em_maos, { sev: 'action', icon: 'truck',    label: 'Bolsas com você para entregar',   desc: 'o operário assina o recebimento no seu aparelho', page: 'entregas-bolsas', cta: 'Entregar' })
    add(n.portes_buscar,  { sev: 'action', icon: 'backpack', label: 'Bolsas prontas para você buscar', desc: 'passe no almoxarifado e assine a saída',          page: 'entregas-bolsas', cta: 'Ver' })
  }
  if (r === 'operario' || r === 'lider' || r === 'engenheiro')
    add(n.portes_a_caminho, { sev: 'info', icon: 'truck', label: 'Sua bolsa está a caminho', desc: 'na entrega, o apontador pede seu CPF e sua assinatura', page: 'cautelas', cta: 'Ver' })
  if (r === 'operario') {
    add(n.emprestimos_aguardando_confirmacao, { sev: 'action', icon: 'exchange', label: 'Empréstimos para confirmar', desc: 'confirme o recebimento da ferramenta', page: 'emprestimos', cta: 'Confirmar' })
  }
  if (PERFIS_UNIFORME.includes(r)) {
    add(n.uniforme_estoque_minimo, { sev: 'action', icon: 'shirt',         label: 'Itens no estoque mínimo',        desc: 'uniforme/EPI para repor',        page: 'uniformes', target: 'alertas', cta: 'Repor' })
    add(n.uniforme_desgaste,       { sev: 'action', icon: 'alertTriangle', label: 'Uniformes com desgaste vencendo', desc: 'troca próxima do prazo',        page: 'uniformes', target: 'alertas', cta: 'Ver' })
    add(n.uniforme_epi_notas,      { sev: 'action', icon: 'inbox',         label: 'Notas com EPI para dar entrada', desc: 'EPI/uniforme separado das notas de compra', page: 'uniformes', target: 'entradas', cta: 'Dar entrada' })
  }
  // REC: o servidor só manda as chaves que valem para o papel (as mesmas do badge da aba REC).
  add(n.rec_solicitacoes_abertas, { sev: 'action', icon: 'clipboard', label: 'Pedidos de material (REC)',         desc: 'analisar, reservar ou separar a remessa', page: 'rec', target: 'solicitacoes', cta: 'Atender' })
  add(n.rec_remessas_separar,     { sev: 'action', icon: 'package',   label: 'Remessas do seu depósito para separar', desc: 'separe e marque como pronta',             page: 'rec', target: 'remessas',     cta: 'Separar' })
  add(n.rec_remessas_transporte,  { sev: 'action', icon: 'send',      label: 'Remessas para levar',               desc: 'retirar no depósito ou entregar na obra', page: 'rec', target: 'remessas',     cta: 'Ver' })
  add(n.rec_remessas_receber,     { sev: 'action', icon: 'signature', label: 'Material chegando à obra',          desc: 'confira e assine o recebimento',          page: 'rec', target: 'remessas',     cta: 'Receber' })
  add(n.rec_compras_abertas,      { sev: 'action', icon: 'fileText',  label: 'Requerimentos de compra em aberto', desc: 'cotar, comprar e dar entrada no estoque', page: 'rec', target: 'compras',      cta: 'Abrir' })
  add(n.rec_retiradas_minhas,     { sev: 'action', icon: 'package',   label: 'Retiradas de material comprado',    desc: 'Compras designou você para buscar',       page: 'rec', target: 'retiradas',    cta: 'Retirar' })
  add(n.rec_aprovacoes_prazo,     { sev: 'action', icon: 'clock',     label: 'Pedidos fora do prazo para aprovar', desc: 'só chegam ao almoxarifado depois do seu OK', page: 'rec', target: 'solicitacoes', cta: 'Decidir' })
  add(n.rec_recusadas,            { sev: 'action', icon: 'undo',      label: 'Pedidos de material recusados',     desc: 'reenvie com nova data ou desista',         page: 'rec', target: 'solicitacoes', cta: 'Ver' })
  add(n.rec_devolvidas_obra,      { sev: 'action', icon: 'undo',      label: 'Pedidos devolvidos: é obra',        desc: 'refaça como Obra (sai da Sede) ou desista', page: 'rec', target: 'solicitacoes', cta: 'Ver' })
  add(n.rec_ciencias_prazo,       { sev: 'info',   icon: 'alertTriangle', label: 'Emergências para dar ciência',  desc: 'seguiram direto, fora do prazo',           page: 'rec', target: 'solicitacoes', cta: 'Ver' })
  add(n.rec_fora_prazo_sem_data,  { sev: 'info',   icon: 'clock',     label: 'Fora do prazo sem data prometida',  desc: 'diga a quem pediu quando consegue entregar', page: 'rec', target: 'solicitacoes', cta: 'Ver' })
  add(n.rec_devolucoes_base,      { sev: 'info',   icon: 'undo',      label: 'Itens que a base devolveu à Sede',  desc: 'o Almoxarife 2 não conseguiu enviar — separe aqui', page: 'rec', target: 'solicitacoes', cta: 'Ver' })
  // Diário de obra (RDO): o servidor só manda as chaves de quem tem o papel e o contrato com o módulo.
  // "Fechar" vale para os dois modos (assinar é fechar com a assinatura desenhada).
  add(n.rdo_sem_lancar, { sev: 'urgent', icon: 'clock',         label: 'RDO de ontem em aberto',       desc: 'o prazo para fechar termina no próximo dia útil às 23:59',   page: 'rdo', cta: 'Lançar' })
  add(n.rdo_assinar,    { sev: 'action', icon: 'signature',     label: 'RDOs para você fechar',        desc: 'rascunhos em que você é o responsável',                       page: 'rdo', cta: 'Abrir' })
  add(n.rdo_atrasados,  { sev: 'urgent', icon: 'alertTriangle', label: 'RDOs em atraso',               desc: 'dias úteis com o prazo vencido — o gestor lança, com motivo', page: 'rdo', cta: 'Ver' })
  return out
}
const PEND_RANK = { urgent: 0, action: 1, info: 2 }
// Total acionável — usado no topo do inbox E no badge da sidebar (fonte única).
function totalPendencias(notif, user) {
  return pendenciasDefs(notif, user).filter(d => d.sev !== 'info').reduce((s, d) => s + d.n, 0)
}

function PendRow({ d, navigate }) {
  return (
    <button className={`pend-row sev-${d.sev}`} onClick={() => navigate(d.page, d.target)}>
      <span className="pend-ic"><Icon name={d.icon} size={18} /></span>
      <span className="pend-n">{d.n}</span>
      <span className="pend-txt"><span className="pend-l">{d.label}</span><span className="pend-d">{d.desc}</span></span>
      <span className="pend-cta">{d.cta} <Icon name="chevronRight" size={15} /></span>
    </button>
  )
}

function PendenciasPage({ user, navigate, notif }) {
  const ordered = [...pendenciasDefs(notif, user)].sort((a, b) => PEND_RANK[a.sev] - PEND_RANK[b.sev] || b.n - a.n)
  const acionaveis = ordered.filter(d => d.sev !== 'info')
  const acompanhando = ordered.filter(d => d.sev === 'info')
  const totalAcao = acionaveis.reduce((s, d) => s + d.n, 0)
  return (
    <div>
      <div className="pend-head">
        <div>
          <h1 className="pend-title"><Icon name="inbox" size={22} /> Pendências</h1>
          <p className="pend-sub">{totalAcao > 0
            ? `${totalAcao} ${totalAcao === 1 ? 'item precisa' : 'itens precisam'} da sua ação`
            : 'Tudo em dia — nada precisa de você agora.'}</p>
        </div>
        {totalAcao > 0 && <span className="pend-total">{totalAcao}</span>}
      </div>

      {ordered.length === 0 && (
        <div className="pend-empty">
          <div className="pend-empty-ic"><Icon name="checkCircle" size={44} /></div>
          <p><b>Nada pendente agora.</b></p>
          <p className="muted">Quando algo precisar de você, aparece aqui primeiro.</p>
        </div>
      )}

      {acionaveis.length > 0 && (
        <div className="pend-group">
          <div className="pend-group-hd"><Icon name="alertTriangle" size={13} /> Precisa de você</div>
          {acionaveis.map((d, i) => <PendRow key={i} d={d} navigate={navigate} />)}
        </div>
      )}

      {acompanhando.length > 0 && (
        <div className="pend-group">
          <div className="pend-group-hd"><Icon name="eye" size={13} /> Acompanhando</div>
          {acompanhando.map((d, i) => <PendRow key={i} d={d} navigate={navigate} />)}
        </div>
      )}
    </div>
  )
}

// ─── PAINEL DO MOTORISTA / AJUDANTE ────────────────────────────────────────────
// A rota do dia: as Pendências do transporte SÃO o painel (o menu deles fica só com Painel e REC).
// Mesmas listas da aba REC (GET /rec/remessas e /rec/retiradas), então o número bate com o badge.
// Ordem = responsabilidade: primeiro o que JÁ está sob a custódia dele (levar à obra), depois o que
// buscar no depósito e no fornecedor. "Assinar" abre o REC direto na assinatura daquela remessa.
// Remessa direta (compra levada do fornecedor à unidade) não sai de depósito: a origem é o fornecedor.
const motDep = r => r.direta ? (r.fornecedor || 'Fornecedor') : r.deposito_tipo === 'sede' ? 'Sede' : (r.deposito_nome || 'Depósito')
const motMapa = q => 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(q)
const motHora = s => { const t = String(s || ''); return t.length >= 16 ? t.slice(8, 10) + '/' + t.slice(5, 7) + ' ' + t.slice(11, 16) : '' }
const motPrazoRem = r => r.data_prometida || r.necessario_em || null
const motOrdem = (a, b) => String(a || '9999').localeCompare(String(b || '9999'))
function motPrazo(d) {
  if (!d) return null
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0)
  const x = new Date(String(d).slice(0, 10) + 'T00:00:00')
  if (isNaN(x)) return null
  const dias = Math.round((x - hoje) / 86400000)
  if (dias < 0) return { tom: 'perigo', label: `Atrasado ${-dias} dia${-dias > 1 ? 's' : ''}` }
  if (dias === 0) return { tom: 'alerta', label: 'Para hoje' }
  if (dias === 1) return { tom: 'aco', label: 'Para amanhã' }
  return { tom: 'neutro', label: 'Até ' + String(d).slice(8, 10) + '/' + String(d).slice(5, 7) }
}
function MotPrazoTag({ d }) {
  const p = motPrazo(d)
  return p ? <span className={`rtag tg-${p.tom}`}><Icon name="clock" size={11}/> {p.label}</span> : null
}
function MotItens({ itens }) {
  const l = (itens || []).map(it => `${Number(it.qtd)}${it.unidade ? ' ' + it.unidade : ''} ${it.catalogo_nome || it.descricao || 'item'}`)
  if (!l.length) return null
  return <div className="mot-itens">{l.slice(0, 3).join(' · ')}{l.length > 3 && <span className="mais"> · +{l.length - 3} {l.length - 3 === 1 ? 'item' : 'itens'}</span>}</div>
}
// As obras do Zoneamento foram semeadas com a REGIÃO no endereço ("Zona 01 — Região Norte, Niterói/RJ"),
// que o mapa não acha. Sem rua cadastrada, a busca vai pelo nome da unidade + cidade (policlínica, UBS,
// hospital: o Google Maps encontra pelo nome).
const motSoRegiao = e => /^\s*zona\s*\d/i.test(String(e || ''))
function motMapaObra(r) {
  const e = r.obra_endereco
  if (e && !motSoRegiao(e)) return { q: e, rua: true }
  if (!r.obra_nome) return e ? { q: e, rua: false } : null
  const cidade = e ? e.split(',').slice(1).join(',').trim() : ''
  return { q: r.obra_nome + (cidade ? ', ' + cidade : ''), rua: false }
}
function MotDestino({ r, alvo }) {
  const m = motMapaObra(r)
  return (
    <div className={`mot-pt${alvo ? ' alvo' : ''}`}><span className="mot-dot"/>
      <div className="mot-pt-tx">
        <div className="mot-pt-l">Entregar em</div>
        <div className="mot-pt-v">{r.obra_nome || 'Obra não informada'}</div>
        {m && <div className="mot-pt-s">{r.obra_endereco ? r.obra_endereco + ' · ' : 'Endereço não cadastrado na obra · '}<a className="mot-lk" href={motMapa(m.q)} target="_blank" rel="noopener noreferrer">{m.rua ? 'Abrir no mapa ↗' : 'Buscar no mapa ↗'}</a></div>}
      </div>
    </div>
  )
}
function MotContato({ r }) {
  if (!r.solicitante_nome) return null
  const tel = String(r.solicitante_telefone || '').replace(/\D/g, '')
  return (
    <div className="mot-meta">
      <span><Icon name="users" size={13}/> Pediu: {r.solicitante_nome}</span>
      {tel && <a className="mot-lk" href={'tel:' + tel}><Icon name="phone" size={13}/> Ligar</a>}
    </div>
  )
}

function PainelMotorista({ user, navigate, addToast, notif }) {
  const [rems, setRems] = useState(null)        // null = carregando
  const [rets, setRets] = useState([])
  const [st, setSt] = useState({})
  const [busy, setBusy] = useState(null)
  const [confirma, setConfirma] = useState(null) // retirada de compra esperando o 2º toque
  const carregar = async () => {
    const [a, b, c] = await Promise.all([GET('/rec/remessas').catch(() => []), GET('/rec/retiradas').catch(() => []), GET('/dashboard').catch(() => ({}))])
    setRems(a || []); setRets(b || []); setSt(c || {})
  }
  // Recarrega quando o poll de 30s do App muda os números (remessa designada, retirada encaminhada…).
  const n = notif || {}
  useEffect(() => { carregar() }, [n.rec_remessas_transporte, n.rec_retiradas_minhas])
  useEffect(() => { if (!confirma) return; const t = setTimeout(() => setConfirma(null), 5000); return () => clearTimeout(t) }, [confirma])

  const lista = rems || []
  const obra = lista.filter(r => r.status === 'em_transporte').sort((a, b) => motOrdem(motPrazoRem(a), motPrazoRem(b)))
  const aRetirar = lista.filter(r => r.status === 'pronta' || r.status === 'a_caminho')
    .sort((a, b) => (b.status === 'a_caminho') - (a.status === 'a_caminho') || motOrdem(motPrazoRem(a), motPrazoRem(b)))
  const dep = aRetirar.filter(r => !r.direta)
  // Compra que vai direto do fornecedor para a unidade: remessa (assina no fornecedor e na unidade), na seção do fornecedor.
  const fornRem = aRetirar.filter(r => r.direta)
  const forn = [...rets].sort((a, b) => (b.prioridade === 'urgente') - (a.prioridade === 'urgente') || motOrdem(a.prazo, b.prazo))
  // Qualquer outra pendência do papel (hoje não há) continua aparecendo aqui — o painel é o inbox dele.
  const outras = pendenciasDefs(notif, user).filter(d => !(d.page === 'rec' && (d.target === 'remessas' || d.target === 'retiradas')))
  const total = obra.length + dep.length + fornRem.length + forn.length
  const hist = st.transporte_historico || []
  const feitas7 = (st.entregues_7d || 0) + (st.retiradas_compra_7d || 0)

  const assinar = r => navigate('rec', 'remessas', { remessa: r.id, assinar: true })
  const aCaminho = async r => {
    setBusy('ac' + r.id)
    try { await POST('/rec/remessas/' + r.id + '/a-caminho'); addToast(`Avisado: você está a caminho ${r.direta ? 'do fornecedor' : 'do depósito'}.`, 'success'); await carregar() }
    catch (e) { addToast(e.message, 'error') }
    setBusy(null)
  }
  const confirmarCompra = async rc => {
    if (confirma !== rc.id) { setConfirma(rc.id); return }
    setConfirma(null); setBusy('rc' + rc.id)
    try { const r = await POST('/rec/retiradas/' + rc.id + '/confirmar', {}); addToast(`Retirada ${rc.numero} confirmada.` + (r && r.remessa ? ` Seguiu na remessa ${r.remessa.numero}.` : ''), 'success'); await carregar() }
    catch (e) { addToast(e.message, 'error') }
    setBusy(null)
  }
  const ir = id => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }) }

  const h = new Date().getHours()
  const ola = h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite'
  const hoje = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: '2-digit' })
  const kpis = [
    ['k-obra', obra.length, 'Levar à obra', 'mot-obra'],
    ['k-dep', dep.length, 'Buscar no depósito', 'mot-dep'],
    ['k-forn', fornRem.length + forn.length, 'Buscar no fornecedor', 'mot-forn'],
    ['k-ok', feitas7, 'Concluídas · 7 dias', 'mot-hist'],
  ]
  const secHd = (icon, titulo, qtd, sub) => (
    <div className="mot-sec-hd"><Icon name={icon} size={14}/> {titulo} <span className="k">{qtd}</span>{sub && <span className="s">— {sub}</span>}</div>
  )
  return (
    <div>
      <div className="topbar"><h2>Painel do {user.roleReal === 'condutor' ? 'Motorista' : 'Ajudante'}</h2></div>
      <p className="mot-ola">{ola}, <b>{String(user.nome || '').split(' ')[0]}</b> · {hoje} — {rems === null ? 'carregando sua rota…'
        : total ? `${total} ${total === 1 ? 'tarefa' : 'tarefas'} na sua rota.` : 'nada esperando por você agora.'}</p>
      {rems !== null && <>
        <div className="mot-kpis">
          {kpis.map(([c, q, l, alvo]) => (
            <button key={c} type="button" className={`mot-kpi ${c}${q ? ' on' : ''}`} {...(q ? { 'data-go': '', onClick: () => ir(alvo) } : { tabIndex: -1 })}>
              <span className="k-n">{q}</span><span className="k-l">{l}</span>
            </button>
          ))}
        </div>

        {outras.length > 0 && (
          <section className="mot-sec">
            <div className="mot-sec-hd"><Icon name="inbox" size={14}/> Outras pendências</div>
            {outras.map((d, i) => <PendRow key={i} d={d} navigate={navigate} />)}
          </section>
        )}

        {total === 0 && (
          <div className="mot-livre">
            <div className="ic"><Icon name="checkCircle" size={40}/></div>
            <b>Rota livre</b>
            <p style={{margin:'6px 0 0', fontSize:'.85rem'}}>Quando o almoxarifado ou Compras designar algo para você buscar ou levar, aparece aqui.</p>
          </div>
        )}

        {obra.length > 0 && (
          <section className="mot-sec" id="mot-obra">
            {secHd('truck', 'Levar à obra', obra.length, 'material sob a sua custódia')}
            {obra.map(r => {
              const ret = (r.eventos || []).filter(e => e.tipo === 'retirada').pop()
              return (
                <div key={r.id} className="mot-card st-obra">
                  <div className="mot-top"><span className="mot-num">{r.numero}</span><RecStatus s={r.status}/><MotPrazoTag d={motPrazoRem(r)}/></div>
                  <div className="mot-rota">
                    <div className="mot-pt feito"><span className="mot-dot"/><div className="mot-pt-tx"><div className="mot-pt-l">Retirado em</div><div className="mot-pt-v">{motDep(r)}</div></div></div>
                    <MotDestino r={r} alvo />
                  </div>
                  <MotItens itens={r.itens}/>
                  <MotContato r={r}/>
                  {ret && <div className="mot-custodia"><Icon name="signature" size={14}/><span>Sob a sua custódia desde {motHora(ret.criado_em)}</span><code>#{String(ret.hash_evento || '').slice(0, 8)}</code></div>}
                  <div className="mot-acoes">
                    <button className="btn btn-accent" onClick={() => assinar(r)}><Icon name="signature" size={15}/> Entregar e assinar</button>
                  </div>
                </div>
              )
            })}
          </section>
        )}

        {dep.length > 0 && (
          <section className="mot-sec" id="mot-dep">
            {secHd('package', 'Buscar no depósito', dep.length, 'remessas separadas para a obra')}
            {dep.map(r => (
              <div key={r.id} className="mot-card st-dep">
                <div className="mot-top">
                  <span className="mot-num">{r.numero}</span><RecStatus s={r.status}/><MotPrazoTag d={motPrazoRem(r)}/>
                  {!r.motorista_id && <span className="rtag tg-neutro">Sem motorista definido</span>}
                </div>
                <div className="mot-rota">
                  <div className="mot-pt alvo"><span className="mot-dot"/><div className="mot-pt-tx">
                    <div className="mot-pt-l">Retirar em</div><div className="mot-pt-v">{motDep(r)}</div>
                    <div className="mot-pt-s">{r.status === 'a_caminho' ? 'Você avisou que está a caminho' : 'Separado e pronto para retirada'}</div>
                  </div></div>
                  <MotDestino r={r} />
                </div>
                <MotItens itens={r.itens}/>
                <MotContato r={r}/>
                <div className="mot-acoes">
                  {r.status === 'pronta' && <button className="btn btn-outline" disabled={busy === 'ac' + r.id} onClick={() => aCaminho(r)}><Icon name="truck" size={15}/> Estou a caminho</button>}
                  <button className="btn btn-accent" onClick={() => assinar(r)}><Icon name="signature" size={15}/> Retirar e assinar</button>
                </div>
              </div>
            ))}
          </section>
        )}

        {(fornRem.length + forn.length) > 0 && (
          <section className="mot-sec" id="mot-forn">
            {secHd('mapPin', 'Buscar no fornecedor', fornRem.length + forn.length, 'material comprado')}
            {fornRem.map(r => {
              const onde = r.fornecedor_endereco || r.fornecedor
              const tel = String(r.fornecedor_contato || '').replace(/\D/g, '')
              return (
                <div key={'r' + r.id} className="mot-card st-forn">
                  <div className="mot-top">
                    <span className="mot-num">{r.numero}</span><span className="rtag tg-cobre">Direto p/ a unidade</span><MotPrazoTag d={motPrazoRem(r)}/>
                  </div>
                  <div className="mot-rota">
                    <div className="mot-pt alvo"><span className="mot-dot"/><div className="mot-pt-tx">
                      <div className="mot-pt-l">Buscar em</div><div className="mot-pt-v">{r.fornecedor || 'Fornecedor não informado'}</div>
                      <div className="mot-pt-s">{r.fornecedor_endereco ? r.fornecedor_endereco + ' · ' : ''}{onde
                        ? <a className="mot-lk" href={motMapa(onde)} target="_blank" rel="noopener noreferrer">{r.fornecedor_endereco ? 'Abrir no mapa ↗' : 'Buscar no mapa ↗'}</a>
                        : 'confirme com Compras onde buscar'}{r.status === 'a_caminho' ? ' · você avisou que está a caminho' : ''}</div>
                    </div></div>
                    <MotDestino r={r} />
                  </div>
                  <MotItens itens={r.itens}/>
                  {(r.fornecedor_contato || r.fornecedor_obs) && (
                    <div className="mot-meta">
                      {r.fornecedor_contato && (tel.length >= 8 ? <a className="mot-lk" href={'tel:' + tel}><Icon name="phone" size={13}/> {r.fornecedor_contato}</a> : <span><Icon name="phone" size={13}/> {r.fornecedor_contato}</span>)}
                      {r.fornecedor_obs && <span><Icon name="fileText" size={13}/> {r.fornecedor_obs}</span>}
                    </div>
                  )}
                  <MotContato r={r}/>
                  <div className="mot-acoes">
                    {r.status === 'pronta' && <button className="btn btn-outline" disabled={busy === 'ac' + r.id} onClick={() => aCaminho(r)}><Icon name="truck" size={15}/> Estou a caminho</button>}
                    <button className="btn btn-accent" onClick={() => assinar(r)}><Icon name="signature" size={15}/> Retirar e assinar</button>
                  </div>
                </div>
              )
            })}
            {forn.map(rc => {
              const onde = rc.retirada_endereco || rc.fornecedor
              const tel = String(rc.retirada_contato || '').replace(/\D/g, '')
              const pedir = confirma === rc.id
              return (
                <div key={rc.id} className="mot-card st-forn">
                  <div className="mot-top"><span className="mot-num">{rc.numero}</span>{rc.prioridade === 'urgente' && <RecUrgente sm/>}<MotPrazoTag d={rc.prazo}/></div>
                  <div className="mot-itens" style={{fontWeight:600}}>{Number(rc.qtd)}{rc.unidade ? ` ${rc.unidade}` : ''} · {rc.descricao || '(item)'}</div>
                  <div className="mot-rota">
                    <div className="mot-pt alvo"><span className="mot-dot"/><div className="mot-pt-tx">
                      <div className="mot-pt-l">Buscar em</div><div className="mot-pt-v">{rc.fornecedor || 'Fornecedor não informado'}</div>
                      <div className="mot-pt-s">{rc.retirada_endereco ? rc.retirada_endereco + ' · ' : ''}{onde
                        ? <a className="mot-lk" href={motMapa(onde)} target="_blank" rel="noopener noreferrer">{rc.retirada_endereco ? 'Abrir no mapa ↗' : 'Buscar no mapa ↗'}</a>
                        : 'confirme com Compras onde buscar'}</div>
                    </div></div>
                    <div className="mot-pt"><span className="mot-dot"/><div className="mot-pt-tx">
                      <div className="mot-pt-l">Material para</div><div className="mot-pt-v">{rc.obra_nome || (rc.destino_nome ? `Depósito ${rc.destino_nome}` : 'Estoque (reposição)')}</div>
                    </div></div>
                  </div>
                  {(rc.retirada_contato || rc.retirada_obs) && (
                    <div className="mot-meta">
                      {rc.retirada_contato && (tel ? <a className="mot-lk" href={'tel:' + tel}><Icon name="phone" size={13}/> {rc.retirada_contato}</a> : <span><Icon name="phone" size={13}/> {rc.retirada_contato}</span>)}
                      {rc.retirada_obs && <span><Icon name="fileText" size={13}/> {rc.retirada_obs}</span>}
                    </div>
                  )}
                  <div className="mot-acoes">
                    <button className={`btn btn-primary${pedir ? ' confirma' : ''}`} disabled={busy === 'rc' + rc.id} onClick={() => confirmarCompra(rc)}>
                      <Icon name="check" size={15}/> {pedir ? 'Toque de novo para confirmar' : 'Já retirei — confirmar'}
                    </button>
                  </div>
                </div>
              )
            })}
          </section>
        )}

        {hist.length > 0 && (
          <section className="mot-sec" id="mot-hist">
            <div className="mot-sec-hd"><Icon name="history" size={14}/> Concluídas recentemente</div>
            <div className="mot-hist">
              {hist.map((x, i) => (
                <div key={i} className="mot-hrow">
                  <span className="mot-hic"><Icon name="checkCircle" size={15}/></span>
                  <div className="mot-htx">
                    <b>{x.numero}</b> {x.tipo === 'entrega' ? 'entregue na obra' : 'retirada no fornecedor'}
                    <div className="d">{x.tipo === 'entrega' ? (x.destino || 'obra') : [x.descricao, x.destino].filter(Boolean).join(' · ')}{x.condicao === 'divergencia' ? ' · com divergência registrada' : ''}</div>
                  </div>
                  <span className="mot-hq">{motHora(x.em)}{x.hash && <><br/><code>#{x.hash.slice(0, 8)}</code></>}</span>
                </div>
              ))}
            </div>
          </section>
        )}
      </>}
    </div>
  )
}

// ─── PAINEL DO ALMOXARIFE 2 (depósito de base: Niterói, Costellation…) ─────────
// Antes ele caía no painel do Operário ("Valor sob minha responsabilidade", empréstimos) — nada disso é dele:
// o Almoxarife 2 não tem cautela nem vê R$. O painel é a BASE dele, nas duas abas que ele tem (REC e Estoque):
// primeiro o que espera por ele (motorista chegando, remessa a separar, material da Sede a assinar), depois por
// onde anda cada remessa da base, a saúde do estoque (abaixo do mínimo e o que já foi pedido), o que ele
// acompanha e o último movimento. Mesmas rotas das abas — o servidor já recorta a base e corta os R$ —, então
// os números batem com o menu e com as Pendências.
const A2_MAX = 4   // cards por grupo na fila; o resto abre na aba
// "há 5 h", "há 3 dias" — leitura de relance (o detalhe com minutos fica nas abas).
function a2Ha(s) {
  if (!s) return null
  const min = Math.max(0, Math.round(diasDesde(s) * 1440))
  if (min < 60) return min <= 1 ? 'agora' : `há ${min} min`
  if (min < 1440) return `há ${Math.floor(min / 60)} h`
  const d = Math.floor(min / 1440)
  return `há ${d} ${d === 1 ? 'dia' : 'dias'}`
}
function A2Linha({ icon, tom, titulo, sub, quando, onClick }) {
  return (
    <button type="button" className="a2-row" onClick={onClick}>
      <span className={`a2-row-ic ${tom || ''}`}><Icon name={icon} size={15}/></span>
      <span className="a2-row-tx"><b>{titulo}</b>{sub && <span className="d">{sub}</span>}</span>
      {quando && <span className="a2-row-q">{quando}</span>}
      <Icon name="chevronRight" size={15}/>
    </button>
  )
}

function PainelAlmox2({ user, navigate, notif }) {
  const [rems, setRems] = useState(null)        // null = carregando
  const [resumo, setResumo] = useState(null)
  const [repo, setRepo] = useState(null)
  const [peds, setPeds] = useState([])
  const [movs, setMovs] = useState([])
  const [compras, setCompras] = useState([])
  const opera = !user.ceo && !user.tour         // apresentação/CEO: só leitura (os atalhos que gravam somem)
  const baseCompra = !!user.base_nome && !!user.base_compra
  const base = user.base_nome || 'sua base'
  const carregar = async () => {
    const [a, b, c, d, e, f] = await Promise.all([
      GET('/rec/remessas').catch(() => []), GET('/estoque/resumo').catch(() => null), GET('/estoque/reposicao').catch(() => null),
      GET('/estoque/pedidos').catch(() => []), GET('/estoque/movimentos?limit=6').catch(() => []),
      baseCompra ? GET('/estoque/compras').catch(() => []) : Promise.resolve([])])
    setRems(a || []); setResumo(b); setRepo(c); setPeds(d || []); setMovs(e || []); setCompras(f || [])
  }
  // Recarrega quando o poll de 30s do App muda os números (remessa nova, envio da Sede, pedido respondido).
  // A 1ª leitura das notificações (vazio → números) não recarrega: o painel acabou de buscar tudo.
  const n = notif || {}
  const chave = [n.rec_remessas_separar, n.estoque_pedidos_a_receber, n.estoque_pedidos_abertos].join('|')
  const chaveAnt = useRef(null)
  useEffect(() => {
    const ant = chaveAnt.current; chaveAnt.current = chave
    if (user.base_nome && (ant === null || (ant !== '||' && ant !== chave))) carregar()
  }, [chave])

  const h = new Date().getHours()
  const ola = h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite'
  const hoje = new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: '2-digit' })
  const topo = (
    <div className="topbar"><h2>Painel — {roleLabelDe(user)}</h2>
      {user.base_nome && opera && <div className="topbar-actions">
        {baseCompra && <button className="btn btn-outline btn-sm" onClick={() => navigate('estoque', 'compras', { novaCompra: true })}><Icon name="cart" size={14}/> Solicitar compra</button>}
        <button className="btn btn-accent btn-sm" onClick={() => navigate('estoque', 'pedidos')}><Icon name="send" size={14}/> Pedir à Sede</button>
      </div>}
    </div>
  )
  // Conta sem base: nada a mostrar (o servidor devolve tudo vazio) — diz o que fazer em vez de zeros.
  if (!user.base_nome) return (
    <div className="a2-wrap">{topo}
      <div className="mot-livre">
        <div className="ic" style={{ color: 'var(--warning)' }}><Icon name="alertTriangle" size={40}/></div>
        <b>Sua conta ainda não está ligada a um depósito de base</b>
        <p style={{ margin: '6px 0 0', fontSize: '.85rem' }}>Peça ao administrador para escolher o contrato da sua conta (a base vem do contrato, na tela Contratos).</p>
      </div>
    </div>
  )

  // ── REC: remessas da base ──
  const lista = (rems || []).filter(r => r.status !== 'cancelada')
  const porPrazo = (a, b) => motOrdem(motPrazoRem(a), motPrazoRem(b))
  const separar = lista.filter(r => r.status === 'separando').sort(porPrazo)
  const prontas = lista.filter(r => r.status === 'pronta').sort(porPrazo)
  const vindo = lista.filter(r => r.status === 'a_caminho').sort(porPrazo)        // motorista avisou que está vindo
  const transporte = lista.filter(r => r.status === 'em_transporte')
  const entregue7 = r => r.status === 'entregue' && (r.eventos || []).some(e => e.tipo === 'entrega' && diasDesde(e.criado_em) < 7)
  const entregues7 = lista.filter(entregue7)
  // ── Estoque: pedidos à Sede, reposição, compras ──
  const chegadas = peds.filter(p => p.status === 'em_transito')
  const aguardSede = peds.filter(p => p.status === 'aberto')
  const dep = resumo && resumo.depositos && resumo.depositos[0]
  const faltaPedir = it => estQtdPos(it.linhas.reduce((a, l) => a + l.falta, 0) - (it.pedido_sede || 0) - (it.a_caminho || 0))
  const linhaBase = it => it.linhas[0] || { saldo: 0, minimo: 0, falta: 0 }
  const abaixo = ((repo && repo.itens) || []).slice().sort((a, b) => {
    const la = linhaBase(a), lb = linhaBase(b)
    return (la.saldo > 0) - (lb.saldo > 0) || (la.saldo / (la.minimo || 1)) - (lb.saldo / (lb.minimo || 1)) || a.nome.localeCompare(b.nome)
  })
  const aPedir = abaixo.filter(it => faltaPedir(it) > 0)
  // A retirada que Compras designou a ELE já está em "Precisa de você" (rec_retiradas_minhas): não repete aqui.
  const comprasAbertas = compras.filter(c => ['recebida', 'em_cotacao', 'comprada', 'em_transito', 'aguardando_retirada'].includes(c.status)
    && !(c.status === 'aguardando_retirada' && c.retirada_responsavel_id === user.id))
  // Qualquer outra pendência do papel (ex.: retirada de material comprado designada a ele) segue aparecendo aqui.
  const outras = pendenciasDefs(notif, user).filter(d => d.sev !== 'info' && !(d.page === 'rec' && d.target === 'remessas') && !(d.page === 'estoque' && d.target === 'pedidos'))
  // Mesma conta do badge de Pendências (separar + chegada a assinar + outras). O motorista vindo buscar é um
  // aviso (ele assina a saída quando o motorista chegar), não entra no número.
  const tarefas = separar.length + chegadas.length + outras.reduce((a, d) => a + d.n, 0)

  const abrirRem = r => navigate('rec', 'remessas', { remessa: r.id })
  const irRem = (st, rotulo) => navigate('rec', 'remessas', { rem: st, rotulo })
  const assinarChegada = pd => navigate('estoque', 'pedidos', { chegada: pd.id })
  const pedirFalta = () => navigate('estoque', 'pedidos', { prefill: aPedir.map(it => ({ catalogo_id: it.id, qtd: faltaPedir(it) })) })
  const rolar = id => { const el = document.getElementById(id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }) }
  const secHd = (icon, titulo, qtd, sub) => (
    <div className="mot-sec-hd"><Icon name={icon} size={14}/> {titulo}{qtd != null && <span className="k">{qtd}</span>}{sub && <span className="s">— {sub}</span>}</div>
  )
  const kpis = [
    ['k-dep', separar.length, 'Remessas a separar', 'a2-agora'],
    ['k-obra', chegadas.length, 'Chegadas p/ assinar', 'a2-agora'],
    ['k-alerta', abaixo.length, 'Itens abaixo do mínimo', 'a2-estoque'],
    ['k-ok', entregues7.length, 'Entregues na obra · 7 dias', 'a2-remessas'],
  ]
  const trilho = [
    { cls: 'p-sep', st: ['separando'], n: separar.length, l: 'Em separação', s: 'com você', rot: 'Remessas em separação' },
    { cls: 'p-pronta', st: ['pronta'], n: prontas.length, l: 'Prontas', s: 'esperando o motorista', rot: 'Remessas prontas aguardando o motorista' },
    { cls: 'p-vindo', st: ['a_caminho'], n: vindo.length, l: 'Motorista vindo', s: 'você assina a saída', rot: 'Remessas com o motorista a caminho' },
    { cls: 'p-transp', st: ['em_transporte'], n: transporte.length, l: 'Em transporte', s: 'a caminho da obra', rot: 'Remessas em transporte para a obra' },
    { cls: 'p-ok', st: ['entregue'], n: entregues7.length, l: 'Entregues', s: 'últimos 7 dias', rot: 'Remessas entregues' },
  ]
  const itensRem = r => <MotItens itens={r.itens}/>
  const paraObra = r => (
    <div className="mot-meta">
      <span><Icon name="mapPin" size={13}/> Para: <b style={{ color: 'var(--ink)' }}>{r.obra_nome || 'obra não informada'}</b></span>
      {r.solicitante_nome && <span><Icon name="users" size={13}/> Pediu: {r.solicitante_nome}</span>}
    </div>
  )

  return (
    <div className="a2-wrap">
      {topo}
      <p className="mot-ola">{ola}, <b>{String(user.nome || '').split(' ')[0]}</b> · {hoje} — {rems === null ? 'carregando sua base…'
        : tarefas ? `${tarefas} ${tarefas === 1 ? 'tarefa esperando' : 'tarefas esperando'} por você no depósito ${base}.` : `depósito ${base} em dia, nada esperando por você.`}</p>
      {rems !== null && <>
        <div className="mot-kpis">
          {kpis.map(([c, q, l, alvo]) => (
            <button key={c} type="button" className={`mot-kpi ${c}${q ? ' on' : ''}`} onClick={() => rolar(alvo)} data-go="">
              <span className="k-n">{q}</span><span className="k-l">{l}</span>
            </button>
          ))}
        </div>

        {resumo && !resumo.iniciado && <div className="alert alert-warning" style={{ marginBottom: 20 }}>Estoque ainda não iniciado: os saldos são os do cadastro até o administrador fazer a carga inicial.</div>}

        {/* Motorista a caminho do depósito: aviso no topo — a saída é assinada no aparelho dele, com você presente. */}
        {vindo.map(r => (
          <button key={r.id} type="button" className="a2-vindo" onClick={() => abrirRem(r)}>
            <span className="ic"><Icon name="truck" size={18}/></span>
            <span className="tx"><b>{r.motorista_nome || 'O motorista'} está vindo buscar a {r.numero}</b>
              <span className="d">Para {r.obra_nome || 'a obra'} · deixe o material conferido: você assina a saída no aparelho dele.</span></span>
            <span className="cta">Ver remessa <Icon name="chevronRight" size={15}/></span>
          </button>
        ))}

        {/* ── Precisa de você ── */}
        <section className="mot-sec" id="a2-agora">
          {secHd('inbox', 'Precisa de você', tarefas || null)}
          {tarefas === 0 && (
            <div className="mot-livre" style={{ marginBottom: 0 }}>
              <div className="ic"><Icon name="checkCircle" size={36}/></div>
              <b>Base em dia</b>
              <p style={{ margin: '6px 0 0', fontSize: '.85rem' }}>Quando o almoxarifado mandar uma remessa para separar ou a Sede enviar material, aparece aqui.</p>
            </div>
          )}
          {outras.map((d, i) => <PendRow key={'o' + i} d={d} navigate={navigate} />)}

          {separar.slice(0, A2_MAX).map(r => (
            <div key={r.id} className="mot-card st-dep a2-card">
              <div className="mot-top"><span className="mot-num">{r.numero}</span><RecStatus s={r.status}/><MotPrazoTag d={motPrazoRem(r)}/>
                <span className="mot-quando">chegou {a2Ha(r.criado_em)}</span></div>
              {paraObra(r)}
              {itensRem(r)}
              <div className="mot-acoes"><button className="btn btn-accent" onClick={() => abrirRem(r)}><Icon name="package" size={15}/> {opera ? 'Separar e escolher o motorista' : 'Ver remessa'}</button></div>
            </div>
          ))}
          {separar.length > A2_MAX && <button className="a2-mais" onClick={() => irRem(['separando'], 'Remessas em separação')}>Ver as {separar.length} remessas em separação <Icon name="chevronRight" size={14}/></button>}

          {chegadas.slice(0, A2_MAX).map(pd => {
            const its = pd.itens.filter(i => i.qtd_enviada > 0).map(i => `${estNum(i.qtd_enviada)}${i.unidade ? ' ' + i.unidade : ''} ${i.nome}`)
            return (
              <div key={pd.id} className="mot-card st-obra a2-card">
                <div className="mot-top"><span className="mot-num">{pd.numero}</span><span className="rtag dot tg-aco">{pd.origem === 'nota' ? 'Da nota fiscal' : pd.origem === 'compra' ? 'Compra sem nota' : `Em trânsito de ${pd.de_nome || 'Sede'}`}</span>
                  {pd.urgente ? <span className="rtag tg-urgente">Urgente</span> : null}
                  {pd.enviado_a_menos && <span className="rtag tg-alerta">Sede enviou menos que o pedido</span>}
                  <span className="mot-quando">{pd.origem === 'nota' ? 'lançada' : pd.origem === 'compra' ? 'comprada' : `saiu de ${pd.de_nome || 'Sede'}`} {a2Ha(pd.respondido_em)}</span></div>
                <div className="a2-aviso aco"><Icon name="signature" size={15}/><span>{pd.origem === 'compra'
                  ? `Quando o fornecedor entregar, confira, anexe o comprovante (foto ou PDF) e assine: entra no saldo de ${pd.para_nome || base} e a compra fecha.`
                  : `Quando chegar, confira e assine: só entra no saldo de ${pd.para_nome || base} o que você assinar.`}</span></div>
                {its.length > 0 && <div className="mot-itens">{its.slice(0, 3).join(' · ')}{its.length > 3 && <span className="mais"> · +{its.length - 3} {its.length - 3 === 1 ? 'item' : 'itens'}</span>}</div>}
                <div className="mot-meta"><span><Icon name="users" size={13}/> {pd.origem === 'nota' ? `${estPedDeQuem(pd)} · lançada por ${pd.respondido_nome || 'Sede'}`
                  : pd.origem === 'compra' ? `${estPedDeQuem(pd)} · Compras: ${pd.respondido_nome || '—'}` : `Enviado por ${pd.respondido_nome || 'Sede'}`}</span></div>
                <div className="mot-acoes"><button className="btn btn-primary" onClick={() => assinarChegada(pd)}><Icon name="signature" size={15}/> {opera ? 'Conferir e assinar a chegada' : 'Ver pedido'}</button></div>
              </div>
            )
          })}
          {chegadas.length > A2_MAX && <button className="a2-mais" onClick={() => navigate('estoque', 'pedidos')}>Ver as {chegadas.length} chegadas <Icon name="chevronRight" size={14}/></button>}
        </section>

        {/* ── Remessas da base: por onde anda cada uma ── */}
        <section className="mot-sec" id="a2-remessas">
          {secHd('truck', `Remessas saindo de ${base}`, null, 'toque numa etapa para ver as remessas')}
          <div className="a2-trilho">
            {trilho.map(s => (
              <button key={s.cls} type="button" className={`a2-passo ${s.cls}${s.n ? ' on' : ''}`} onClick={() => irRem(s.st, s.rot)}>
                <span className="p-dot"/>
                <span className="p-n">{s.n}</span>
                <span className="p-tx"><span className="p-l">{s.l}</span><span className="p-s">{s.s}</span></span>
              </button>
            ))}
          </div>
        </section>

        <div className="a2-cols">
          {/* ── Estoque da base ── */}
          <section className="mot-sec" id="a2-estoque">
            {secHd('layers', `Estoque · ${base}`)}
            <div className="a2-box">
              <div className="a2-resumo">
                <button type="button" onClick={() => navigate('estoque', 'saldo')}><b>{dep ? dep.itens || 0 : '—'}</b><span>itens com saldo</span></button>
                <button type="button" onClick={() => navigate('estoque', 'saldo')}><b>{dep ? dep.categorias || 0 : '—'}</b><span>categorias</span></button>
                <button type="button" className={abaixo.length ? 'alerta' : 'ok'} onClick={() => navigate('estoque', 'reposicao')}><b>{abaixo.length}</b><span>abaixo do mínimo</span></button>
              </div>
              {abaixo.length === 0
                ? <div className="a2-tudo-ok"><Icon name="checkCircle" size={16}/> Nenhum item abaixo do mínimo na base.</div>
                : <div className="a2-min">
                    <div className="a2-min-hd"><span>Abaixo do mínimo</span><span>saldo / mínimo</span></div>
                    {abaixo.slice(0, 5).map(it => {
                      const l = linhaBase(it), fp = faltaPedir(it)
                      const pct = Math.max(0, Math.min(100, (l.saldo / (l.minimo || 1)) * 100))
                      const ja = estQtdPos((it.pedido_sede || 0) + (it.a_caminho || 0))
                      return (
                        <button type="button" key={it.id} className="a2-min-row" onClick={() => navigate('estoque', 'reposicao')}>
                          <span className="nm">{it.nome}<span className="d">{[it.categoria, fp > 0 ? `falta pedir ${estNum(fp)}${it.unidade ? ' ' + it.unidade : ''}` : null].filter(Boolean).join(' · ')}</span></span>
                          <span className="bar"><i className={l.saldo <= 0 ? 'zero' : ''} style={{ width: pct + '%' }}/></span>
                          <span className="q"><b>{estNum(l.saldo)}</b> / {estNum(l.minimo)} <span className="un">{it.unidade || ''}</span></span>
                          <span className="tg">{l.saldo <= 0 ? <span className="rtag tg-perigo">Zerado</span>
                            : fp > 0 ? <span className="rtag tg-alerta">Pedir</span>
                            : <span className="rtag tg-aco" title={[it.pedido_sede ? `pedido à Sede: ${estNum(it.pedido_sede)}` : '', it.a_caminho ? `compra a caminho: ${estNum(it.a_caminho)}` : ''].filter(Boolean).join(' · ')}>Já pedido</span>}
                            {l.saldo <= 0 && ja > 0 && <span className="rtag tg-aco">Já pedido</span>}</span>
                        </button>
                      )
                    })}
                    {abaixo.length > 5 && <div className="a2-min-mais">+ {abaixo.length - 5} {abaixo.length - 5 === 1 ? 'item' : 'itens'} na aba Abaixo do mínimo</div>}
                  </div>}
              <div className="a2-acoes">
                {opera && resumo && resumo.iniciado && aPedir.length > 0 && <button className="btn btn-accent btn-sm" onClick={pedirFalta}><Icon name="send" size={14}/> Pedir à Sede o que falta ({aPedir.length})</button>}
                <button className="btn btn-outline btn-sm" onClick={() => navigate('estoque', 'reposicao')}>Ver abaixo do mínimo</button>
                <button className="btn btn-ghost btn-sm" onClick={() => navigate('estoque', 'saldo')}><Icon name="search" size={13}/> Consultar saldo</button>
              </div>
            </div>
          </section>

          <div>
            {/* ── Acompanhando: o que está na mão de outra pessoa ── */}
            <section className="mot-sec">
              {secHd('eye', 'Acompanhando', null, 'na mão de outra pessoa')}
              <div className="a2-lista">
                {prontas.map(r => <A2Linha key={'p' + r.id} icon="package" tom="aco" onClick={() => abrirRem(r)}
                  titulo={`${r.numero} pronta — esperando ${r.motorista_nome || 'o motorista'}`} sub={r.obra_nome ? `para ${r.obra_nome}` : null}/>)}
                {aguardSede.map(pd => <A2Linha key={'s' + pd.id} icon="send" tom="alerta" onClick={() => navigate('estoque', 'pedidos')}
                  titulo={`${pd.numero} — aguardando a Sede`} sub={`${pd.itens.length} ${pd.itens.length === 1 ? 'item' : 'itens'}${pd.urgente ? ' · urgente' : ''}`} quando={a2Ha(pd.criado_em)}/>)}
                {comprasAbertas.map(c => <A2Linha key={'c' + c.id} icon="cart" tom="cobre" onClick={() => navigate('estoque', 'compras')}
                  titulo={`${c.numero} — ${REC_STATUS_LABEL[c.status] || c.status}`} sub={`${estNum(c.qtd)}${c.unidade ? ' ' + c.unidade : ''} ${c.descricao || ''}`} quando={a2Ha(c.criado_em)}/>)}
                {!prontas.length && !aguardSede.length && !comprasAbertas.length && <div className="a2-vazio">Nada parado com outra pessoa.</div>}
              </div>
            </section>

            {/* ── Últimas movimentações da base ── */}
            <section className="mot-sec">
              {secHd('history', 'Últimas movimentações')}
              <div className="a2-lista">
                {movs.map(m => (
                  <div key={m.id} className="a2-mov">
                    <span className={`a2-mov-q ${m.quantidade < 0 ? 'sai' : 'entra'}`}>{m.quantidade > 0 ? '+' : ''}{estNum(m.quantidade)}<span className="un">{m.unidade || ''}</span></span>
                    <span className="a2-row-tx"><b>{m.item_nome}</b><span className="d">{[EST_TIPO[m.tipo] || m.tipo, m.obs, m.usuario_nome].filter(Boolean).join(' · ')}</span></span>
                    <span className="a2-row-q">{motHora(m.criado_em)}</span>
                  </div>
                ))}
                {!movs.length && <div className="a2-vazio">Nenhuma movimentação ainda.</div>}
                <button type="button" className="a2-mais dentro" onClick={() => navigate('estoque', 'movimentos')}>Ver todas as movimentações <Icon name="chevronRight" size={14}/></button>
              </div>
            </section>
          </div>
        </div>
      </>}
    </div>
  )
}

// ─── Painel de Compras: a central do setor ─────────────────────────────────────
// Compras é UM setor para todos os contratos. O painel é a mesa de trabalho dele: os indicadores (de todos os
// contratos ou do contrato em foco), o quadro por contrato — em aberto, atrasadas, valor parado e o comprado
// no mês (o custo que cada contrato gerou) — e, embaixo, a própria esteira (cotar, comprar, encaminhar a
// retirada, dar entrada), sem precisar ir ao REC. Os cards filtram a esteira aqui mesmo e rolam até ela.
// Com um contrato só, nada de contrato aparece: o painel fica como sempre foi.
function PainelCompras({ user, stats, navigate, addToast, L }) {
  const temRec = temModulo(user, 'rec')
  const [lista, setLista] = useState(null)          // requerimentos de compra (todos os contratos)
  const [contratos, setContratos] = useState([])    // todos os contratos (o quadro mostra também quem não pediu nada)
  const [ct, setCt] = useState('')                  // contrato em foco ('' = todos)
  const [filtroEst, setFiltroEst] = useState(null)  // card → filtro da esteira logo abaixo
  const estRef = useRef(null)
  const recarregar = () => GET('/rec/compras').then(setLista).catch(e => { addToast && addToast(e.message, 'error'); setLista(l => l || []) })
  useEffect(() => { if (temRec) { recarregar(); GET('/rec/compras/contratos').then(setContratos).catch(() => {}) } }, [])
  const irEsteira = compraStatus => {
    setFiltroEst({ compraStatus })
    setTimeout(() => { if (estRef.current) estRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' }) }, 40)
  }
  const C = (compraStatus, cta) => linkProps(() => irEsteira(compraStatus), cta)

  const todas = lista || []
  // Contratos conhecidos: os cadastrados + os que aparecem na fila (se a lista de contratos não vier).
  const ctMap = new Map()
  for (const c of contratos) ctMap.set(c.id, { id: c.id, nome: c.nome, cor: corContrato(c, c.idx || 0), idx: c.idx || 0, ativo: c.ativo })
  for (const c of rcContratos(todas)) if (!ctMap.has(c.id)) ctMap.set(c.id, { ...c, ativo: 1 })
  const cts = [...ctMap.values()].filter(c => c.ativo || todas.some(rc => rc.contrato_id === c.id)).sort((a, b) => a.idx - b.idx)
  const multi = cts.length > 1
  const ctFoco = ct ? cts.find(c => String(c.id) === ct) : null
  const doCt = ct ? todas.filter(rc => String(rc.contrato_id) === ct) : todas

  const d = new Date(), mes = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')
  const valorDe = rc => (rc.valor_unit != null ? Number(rc.valor_unit) * Number(rc.qtd || 0) : 0)
  const kind = rc => { const pi = recPrazoInfo(rc.prazo, rc.status); return pi ? pi.kind : null }
  const COMPRADA = ['comprada', 'aguardando_retirada', 'em_transito', 'em_estoque', 'a_caminho_unidade', 'entregue_unidade']
  const resumo = rows => {
    const abertas = rows.filter(rcAberta)
    const doMes = rows.filter(rc => COMPRADA.includes(rc.status) && String(rc.comprado_em || '').slice(0, 7) === mes)
    return {
      abertas: abertas.length,
      cotar: rows.filter(rc => rc.status === 'recebida').length,
      atrasadas: abertas.filter(rc => kind(rc) === 'atrasado').length,
      hoje: abertas.filter(rc => kind(rc) === 'hoje').length,
      urgentes: abertas.filter(rc => rc.prioridade === 'urgente').length,
      valorAberto: abertas.reduce((t, rc) => t + valorDe(rc), 0),
      valorAtraso: abertas.filter(rc => kind(rc) === 'atrasado').reduce((t, rc) => t + valorDe(rc), 0),
      semCusto: abertas.filter(rc => rc.valor_unit == null).length,
      compradoMes: doMes.reduce((t, rc) => t + valorDe(rc), 0),
      compradoMesN: doMes.length,
    }
  }
  const r = resumo(doCt)
  const cnt = st => doCt.filter(rc => rc.status === st).length
  const andamento = cnt('comprada') + cnt('aguardando_retirada') + cnt('em_transito') + cnt('a_caminho_unidade')
  const porCt = multi ? cts.map(c => ({ c, ...resumo(todas.filter(rc => rc.contrato_id === c.id)) })) : []
  const total = multi ? resumo(todas) : null
  const mesNome = d.toLocaleDateString('pt-BR', { month: 'long' })
  const chip = ativo => ({ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '7px 13px', borderRadius: 999, cursor: 'pointer', fontSize: '.8rem', fontWeight: 600, fontFamily: 'inherit',
    background: ativo ? 'var(--rec-navy)' : 'var(--card,#fff)', color: ativo ? 'var(--rec-on-accent)' : 'var(--ink,#111)', border: `1px solid ${ativo ? 'var(--rec-navy)' : 'var(--border,#e5e7eb)'}` })

  return (
    <div>
      <div className="topbar"><h2>Painel Geral — Compras</h2></div>
      {temRec && lista && <>
        {multi && (
          <div style={{ marginBottom: 14 }}>
            <p style={{ margin: '-6px 0 10px', fontSize: '.86rem', color: 'var(--text-secondary)' }}>Um setor de Compras para os {cts.length} contratos: os pedidos de todos chegam aqui, cada um com o contrato de origem.</p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }} role="group" aria-label="Contrato em foco">
              <button type="button" style={chip(!ct)} onClick={() => setCt('')}>Todos os contratos <span style={{ opacity: .75 }}>{total.abertas}</span></button>
              {porCt.map(({ c, abertas, atrasadas }) => (
                <button type="button" key={c.id} style={chip(ct === String(c.id))} onClick={() => setCt(ct === String(c.id) ? '' : String(c.id))}>
                  <span style={{ width: 9, height: 9, borderRadius: 2, background: c.cor, flex: 'none' }} />{c.nome}
                  <span style={{ opacity: .75 }}>{abertas}</span>
                  {atrasadas > 0 && <span style={{ fontSize: '.66rem', fontWeight: 800, padding: '1px 7px', borderRadius: 999, color: ct === String(c.id) ? 'var(--rec-on-accent)' : 'var(--rec-urg-fg)', background: ct === String(c.id) ? 'rgba(255,255,255,.18)' : 'var(--rec-urg-bg)' }}>{atrasadas} atrasada{atrasadas > 1 ? 's' : ''}</span>}
                </button>
              ))}
            </div>
          </div>
        )}
        <div className="stat-section">
          <div className="stat-section-title"><span className="st-ic"><Icon name="exchange" size={14}/></span>REC — Compras de material{ctFoco ? ` · ${ctFoco.nome}` : ''}</div>
          <div className="rec-kpi" {...C('_abertas')} style={{background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderLeft:'4px solid var(--accent,#A07C4E)', borderRadius:12, padding:'14px 34px 14px 16px', marginBottom:12, display:'flex', alignItems:'center', justifyContent:'space-between', gap:16, flexWrap:'wrap'}}>
            <div>
              <div style={{fontSize:'.78rem', color:'var(--text-secondary,#6b7280)'}}>Valor total em compras <span style={{opacity:.7}}>(em aberto)</span></div>
              <div style={{fontSize:'1.7rem', fontWeight:800, color:'var(--accent,#A07C4E)', lineHeight:1.1, marginTop:2}}>{fmtBRL(r.valorAberto)}</div>
            </div>
            <div style={{display:'flex', gap:20, flexWrap:'wrap'}}>
              <div><div style={{fontSize:'1.05rem', fontWeight:800}}>{r.abertas}</div><div style={{fontSize:'.72rem', color:'var(--text-secondary,#6b7280)'}}>requerimentos</div></div>
              <div><div style={{fontSize:'1.05rem', fontWeight:800, color: r.valorAtraso>0?'var(--danger,#b91c1c)':'inherit'}}>{fmtBRL(r.valorAtraso)}</div><div style={{fontSize:'.72rem', color:'var(--text-secondary,#6b7280)'}}>em atraso</div></div>
              <div><div style={{fontSize:'1.05rem', fontWeight:800}}>{fmtBRL(r.compradoMes)}</div><div style={{fontSize:'.72rem', color:'var(--text-secondary,#6b7280)'}}>comprado em {mesNome}</div></div>
              {r.semCusto>0 && <div><div style={{fontSize:'1.05rem', fontWeight:800, color:'var(--text-secondary,#6b7280)'}}>{r.semCusto}</div><div style={{fontSize:'.72rem', color:'var(--text-secondary,#6b7280)'}}>sem custo</div></div>}
            </div>
          </div>
          <div className="stats-grid">
            <div className={`stat-card ${r.cotar>0?'blue':''}`} {...C('recebida', true)}><div className="stat-label">A cotar</div><div className="stat-value">{r.cotar}</div><div style={{fontSize:'.72rem',color:'var(--primary-accent)',marginTop:2,fontWeight:600}}>Cotar →</div></div>
            <div className="stat-card" {...C('em_cotacao')}><div className="stat-label">Em cotação</div><div className="stat-value">{cnt('em_cotacao')}</div></div>
            <div className="stat-card" {...C('_andamento')}><div className="stat-label">Em andamento</div><div className="stat-value">{andamento}</div><div style={{fontSize:'.72rem',color:'var(--text-secondary)',marginTop:2}}>comprado / retirada</div></div>
            <div className={`stat-card ${r.atrasadas>0?'red':''}`} {...C('_atrasadas')}><div className="stat-label">Atrasadas</div><div className="stat-value">{r.atrasadas}</div></div>
            <div className="stat-card" {...C('_hoje')}><div className="stat-label">Vencem hoje</div><div className="stat-value">{r.hoje}</div></div>
          </div>
          {(r.atrasadas>0 || r.hoje>0 || r.urgentes>0) && (
            <div className="pending-banner">
              <span className="msg" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={15}/> {r.atrasadas} atrasada(s) · {r.hoje} vence(m) hoje · {r.urgentes} urgente(s) em aberto</span>
              <button className="btn btn-accent btn-sm" onClick={()=>irEsteira('_abertas')}>Ver na fila ↓</button>
            </div>
          )}
        </div>
        {multi && (
          <div className="stat-section">
            <div className="stat-section-title"><span className="st-ic"><Icon name="layers" size={14}/></span>Por contrato</div>
            <div className="card"><div className="table-wrap"><table className="cards-mobile">
              <thead><tr><th>Contrato</th><th style={{textAlign:'right'}}>Em aberto</th><th style={{textAlign:'right'}}>A cotar</th><th style={{textAlign:'right'}}>Atrasadas</th><th style={{textAlign:'right'}}>Valor em aberto</th><th style={{textAlign:'right'}}>Comprado em {mesNome}</th></tr></thead>
              <tbody>
                {porCt.map(({ c, ...x }) => {
                  const foco = ct === String(c.id)
                  return (
                    <tr key={c.id} {...linkProps(() => setCt(foco ? '' : String(c.id)))} style={{cursor:'pointer', ...(foco ? {background:'var(--rec-navy-soft)'} : {})}} title={foco ? 'Voltar para todos os contratos' : 'Ver só este contrato'}>
                      <td data-label="Contrato"><span style={{display:'inline-flex', alignItems:'center', gap:9, fontWeight:700}}><span style={{width:11, height:11, borderRadius:3, background:c.cor, flex:'none'}}/>{c.nome}</span></td>
                      <td data-label="Em aberto" style={{textAlign:'right', fontWeight:700}}>{x.abertas}</td>
                      <td data-label="A cotar" style={{textAlign:'right'}}>{x.cotar}</td>
                      <td data-label="Atrasadas" style={{textAlign:'right', color: x.atrasadas ? 'var(--danger)' : 'inherit', fontWeight: x.atrasadas ? 700 : 400}}>{x.atrasadas}</td>
                      <td data-label="Valor em aberto" style={{textAlign:'right'}}>{fmtBRL(x.valorAberto)}</td>
                      <td data-label={`Comprado em ${mesNome}`} style={{textAlign:'right'}}>{fmtBRL(x.compradoMes)}{x.compradoMesN ? <span style={{color:'var(--text-secondary)', fontSize:'.74rem'}}> · {x.compradoMesN} item(ns)</span> : null}</td>
                    </tr>
                  )
                })}
                <tr style={{fontWeight:800, borderTop:'2px solid var(--border)'}}>
                  <td data-label="Contrato">Total</td>
                  <td data-label="Em aberto" style={{textAlign:'right'}}>{total.abertas}</td>
                  <td data-label="A cotar" style={{textAlign:'right'}}>{total.cotar}</td>
                  <td data-label="Atrasadas" style={{textAlign:'right'}}>{total.atrasadas}</td>
                  <td data-label="Valor em aberto" style={{textAlign:'right'}}>{fmtBRL(total.valorAberto)}</td>
                  <td data-label={`Comprado em ${mesNome}`} style={{textAlign:'right'}}>{fmtBRL(total.compradoMes)}</td>
                </tr>
              </tbody>
            </table></div></div>
          </div>
        )}
      </>}
      <div className="stat-section">
        <div className="stat-section-title"><span className="st-ic"><Icon name="shirt" size={14}/></span>Uniformes / EPI — Estoque</div>
        <div className="stats-grid">
          <div className="stat-card blue" {...L('uniformes', 'estoque')}><div className="stat-label">Itens no catálogo</div><div className="stat-value">{stats.uniforme_total_itens||0}</div></div>
          <div className="stat-card red" {...L('uniformes', 'alertas')}><div className="stat-label">Abaixo do mínimo</div><div className="stat-value">{stats.uniforme_abaixo_minimo||0}</div></div>
          <div className="stat-card" {...L('uniformes', 'retirada')}><div className="stat-label">Colaboradores</div><div className="stat-value">{stats.uniforme_colaboradores||0}</div></div>
        </div>
      </div>
      <div className="stat-section">
        <div className="stat-section-title"><span className="st-ic"><Icon name="alertTriangle" size={14}/></span>Alertas &amp; movimento</div>
        <div className="stats-grid">
          <div className="stat-card" {...L('uniformes', 'alertas')}><div className="stat-label">Desgaste vencendo (30d)</div><div className="stat-value">{stats.uniforme_desgaste_30d||0}</div></div>
          <div className="stat-card green" {...L('uniformes', 'retirada')}><div className="stat-label">Entregas no mês</div><div className="stat-value">{stats.uniforme_entregas_mes||0}</div></div>
        </div>
      </div>
      {((stats.uniforme_abaixo_minimo||0) > 0 || (stats.uniforme_desgaste_30d||0) > 0) && (
        <div className="pending-banner">
          <span className="msg" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={15}/> {stats.uniforme_abaixo_minimo||0} item(ns) no mínimo · {stats.uniforme_desgaste_30d||0} com desgaste vencendo</span>
          <button className="btn btn-accent btn-sm" onClick={()=>navigate('uniformes', 'alertas')}>Ver alertas →</button>
        </div>
      )}
      <div className="card"><div className="card-body" style={{textAlign:'center',padding:24}}>
        <button className="btn btn-primary" onClick={()=>navigate('uniformes')}><Icon name="shirt" size={15}/> Ir para Uniformes / EPI</button>
      </div></div>
      {temRec && lista && (
        <div className="stat-section" ref={estRef} style={{scrollMarginTop:12}}>
          <div className="stat-section-title"><span className="st-ic"><Icon name="clipboard" size={14}/></span>Fila de compras{ctFoco ? ` · ${ctFoco.nome}` : ''} — cotar, comprar e encaminhar daqui mesmo</div>
          <ComprasEsteira user={user} addToast={addToast} lista={lista} recarregar={recarregar} filtro={filtroEst}
            contrato={ct} onContrato={setCt} inicioStatus="_abertas" />
        </div>
      )}
    </div>
  )
}

function Dashboard({ user, navigate, addToast }) {
  const [stats, setStats] = useState({})
  const [recPainel, setRecPainel] = useState(null)
  // Master: Visão por contrato embutida em Ferramentas & Cautelas (null = carregando) + contrato aberto.
  const [visaoContratos, setVisaoContratos] = useState(null)
  const [contratoSel, setContratoSel] = useState(null)
  useEffect(() => { GET('/dashboard').then(setStats).catch(() => {}) }, [])
  useEffect(() => {
    // Almoxarifado: o bloco REC do Painel Geral é o mesmo painel da aba REC (mesma fonte).
    if (user.role === 'almoxarifado' && temModulo(user, 'rec'))
      GET('/rec/painel').then(setRecPainel).catch(() => setRecPainel(false))
  }, [])
  // Card do painel → assunto em si. Só vira link se a aba de destino está no menu de quem clica
  // (papel sem a aba = card só de leitura). `filtro.rotulo` aparece na faixa "Mostrando" do destino.
  const ir = (page, id = null, filtro = null) => podeAbrir(user, page) ? () => navigate(page, id, filtro) : null
  const L = (page, id, filtro, cta) => linkProps(ir(page, id, filtro), cta)
  const ATIVAS = { status: 'ativa', rotulo: 'Cautelas ativas (ferramenta em campo)' }

  // Gerente multicontrato (ex.: Cesar · Costellation): o painel dele é a VISÃO CONSOLIDADA
  // + por contrato dos contratos a que está vinculado — nunca o cockpit global (que somaria
  // contratos que ele não pode ver, inclusive o principal). Tudo montado por PainelContratos.
  if (user.multi_contrato) return (
    <div>
      <div className="topbar"><h2>Painel — {roleLabelDe(user)}</h2></div>
      <PainelContratos user={user} navigate={navigate} />
      {user.rdo_ativo ? <div style={{ marginTop: 16 }}><RdoPainelResumo navigate={navigate} /></div> : null}
    </div>
  )

  // Administração e Compras: a central do setor de Compras (todos os contratos) + Uniformes/EPI.
  if (user.role === 'administracao' || user.role === 'compras') return (
    <PainelCompras user={user} stats={stats} navigate={navigate} addToast={addToast} L={L} />
  )

  // Diretor de Operações / Gerente de Contrato: cockpit de decisão (gestão à vista das equipes).
  // Cada bloco só é renderizado se o módulo de que depende estiver contratado (temModulo).
  if (user.role === 'diretor' || user.role === 'gerente') {
    const has = m => temModulo(user, m)
    const porObra = stats.por_obra || []
    const maxObra = Math.max(1, ...porObra.map(o => o.valor || 0))
    const lideres = stats.ranking_lideres || []
    const maxLider = Math.max(1, ...lideres.map(l => l.valor || 0))
    const aging = stats.aging || []
    const agTotal = Math.max(1, aging.reduce((t, a) => t + (a.valor || 0), 0))
    const agCor = ['#C9A227', 'var(--accent)', 'var(--danger)']
    const funil = stats.funil || {}
    const maxFunil = Math.max(1, funil.solicitada || 0, funil.separando || 0, funil.pronta || 0, funil.retiradas_7d || 0)
    // Destinos reaproveitados pelo Radar, ranking e cards abaixo.
    const SEM_ENG = { semLider: true, rotulo: 'Obras ativas sem engenheiro' }
    // Transferências: o Gerente tem a caixa "Tarefas em aberto" logo abaixo (rola até ela); o
    // Diretor abre a Auditoria filtrada em transferências.
    const irTransf = user.role === 'gerente'
      ? () => { const el = document.getElementById('gerente-tarefas'); if (el) el.scrollIntoView({ block: 'start' }) }
      : ir('diretor-auditoria', null, { tipo: 'transferencia', rotulo: 'Transferências de colaborador' })
    // Radar — só o que exige ação hoje (cada alerta some com seu módulo).
    const alertas = []
    if (has('obras') && (stats.obras_sem_lider || 0) > 0) alertas.push({ sev: 'crit', ic: 'alertTriangle', n: stats.obras_sem_lider, t: <>obras <b>sem engenheiro</b> responsável</>, go: ir('obras', null, SEM_ENG) })
    if ((stats.aging_valor_60 || 0) > 0) alertas.push({ sev: 'crit', ic: 'history', n: fmtBRLc(stats.aging_valor_60), t: <>em ferramenta há <b>+60 dias</b> em campo</>, go: ir('cautelas', null, { status: 'ativa', dias: [60, null], rotulo: 'Cautelas em campo há +60 dias' }) })
    if (has('equipe') && (stats.transf_pendentes_48h || 0) > 0) alertas.push({ sev: 'warn', ic: 'handshake', n: stats.transf_pendentes_48h, t: <><b>transferências</b> pendentes de aceite +48h</>, go: irTransf })
    if ((stats.prontas_paradas_3d || 0) > 0) alertas.push({ sev: 'warn', ic: 'download', n: stats.prontas_paradas_3d, t: <>solicitações <b>prontas</b> sem retirada +3 dias</>, go: ir('solicitacoes', null, { status: 'pronta', criadaMaisDe: 3, rotulo: 'Prontas sem retirada há +3 dias' }) })
    // EPI: Diretor/Gerente não têm a aba Uniformes — o alerta fica só informativo para eles.
    if (has('uniformes') && (stats.epi_abaixo_minimo || 0) > 0) alertas.push({ sev: 'info', ic: 'shirt', n: stats.epi_abaixo_minimo, t: <>itens de <b>EPI</b> abaixo do estoque mínimo</>, go: ir('uniformes', 'alertas') })
    const AG_FAIXAS = [[15, 30], [30, 60], [60, null]]   // mesma ordem de stats.aging
    // Pessoas: Diretor abre Usuários; o Gerente (sem essa aba) cai no Kanban de Obras.
    const irPessoas = f => ir('usuarios', null, { role: 'operario', ativos: true, ...f }) || ir('kanban-obras')
    const pctPill = d => d >= 60 ? <span className="dc-pill crit">crítico</span> : (d >= 30 ? <span className="dc-pill warn">atenção</span> : null)
    const flag = (v, bad) => <span className={`dc-flag ${v === 0 ? 'ok' : (v >= bad ? 'bad' : 'mid')}`}>{v}</span>

    return (
    <div>
      <div className="topbar"><h2>Painel — {roleLabelDe(user)}</h2></div>

      {user.role === 'diretor' && <PainelContratos user={user} navigate={navigate} selExt={contratoSel} onSel={setContratoSel} onVisivel={setVisaoContratos} />}

      {/* Drill-in num contrato (como no Painel do Master): o cockpit abaixo é do GRUPO (radar, exposição,
          obras de todos os contratos) e, colado no bloco do contrato, se lia como se fosse dele. Some até
          voltar a "Todos os contratos". */}
      {!(contratoSel && visaoContratos) && <>
      {/* Radar */}
      <div className="dc-sec">
        <div className="dc-head"><span className="k">Radar</span><h3>Precisa da sua ação hoje</h3></div>
        {alertas.length ? (
          <div className="dc-alerts">
            {alertas.map((a, i) => (
              <button key={i} className={`dc-alert ${a.sev} ${a.go ? 'go' : ''}`} onClick={a.go || undefined}>
                <span className="ic"><Icon name={a.ic} size={16}/></span>
                <span><span className="n">{a.n}</span><span className="tt">{a.t}</span></span>
              </button>
            ))}
          </div>
        ) : (
          <div className="dc-calm"><Icon name="check" size={16}/> Tudo em dia — nenhum alerta operacional aberto.</div>
        )}
      </div>

      {user.rdo_ativo ? <RdoPainelResumo navigate={navigate} /> : null}

      {/* Tarefas em aberto / ciência — só o Gerente de Contrato */}
      {user.role === 'gerente' && (
        <div className="dc-sec">
          <div className="dc-grid">
            <GerenteTarefas tarefas={stats.gerente_tarefas} addToast={addToast} ir={ir} />
          </div>
        </div>
      )}

      {/* Prioridade 1 — Exposição financeira */}
      <div className="dc-sec">
        <div className="dc-head"><span className="k">Prioridade 1</span><h3>Exposição financeira</h3></div>
        <div className="dc-cols">
          <div className="dc-col">
            <div className="dc-card dc-hero" {...L('cautelas', null, ATIVAS)}>
              <span className="dc-mtag">Cautela</span>
              <h4>Valor total em campo</h4>
              <div className="big">{fmtBRLc(stats.valor_em_campo || 0)}</div>
              <div className="line">{stats.cautelas_ativas || 0} cautelas ativas · {stats.colaboradores_em_campo || 0} colaboradores em campo</div>
              <div className="split">
                <div><div className="v">{fmtBRLc(stats.valor_medio_colaborador || 0)}</div><div className="l">média / colaborador</div></div>
                {has('obras') && <div><div className="v">{fmtBRLc(stats.valor_medio_obra || 0)}</div><div className="l">média / obra</div></div>}
              </div>
            </div>

            <div className="dc-card">
              <span className="dc-mtag">Cautela</span>
              <h4>Ferramenta parada em campo</h4>
              <p className="dc-cap">Quanto mais tempo fora, maior o risco de perda</p>
              <div className="dc-ag">
                {aging.map((a, i) => <span key={i} style={{width:Math.round((a.valor || 0) / agTotal * 100) + '%', background:agCor[i]}}/>)}
              </div>
              {aging.map((a, i) => (
                <div className="dc-agr lk-row" key={i} {...L('cautelas', null, { status: 'ativa', dias: AG_FAIXAS[i], rotulo: `Em campo há ${a.faixa}` })}>
                  <span className="sw" style={{background:agCor[i]}}/><span className="rl">{a.faixa}</span>
                  <span className="rn">{a.cautelas} cautela(s)</span><span className="rv">{fmtBRLc(a.valor || 0)}</span>
                </div>
              ))}
              {podeAbrir(user, 'cautelas') && <div className="lk-hint">Toque numa faixa para ver as cautelas.</div>}
            </div>
          </div>

          <div className="dc-col">
            {has('obras') && porObra.length > 0 && (
              <div className="dc-card dc-fill">
                <span className="dc-mtag">Obras</span>
                <h4>Valor em campo por obra</h4>
                <p className="dc-cap">Top {porObra.length} · concentração do risco financeiro{podeAbrir(user, 'cautelas') ? ' · toque numa obra para ver as cautelas' : ''}</p>
                <div className="dc-bars">
                  {porObra.map(o => (
                    <div className="dc-bar lk-row" key={o.obra_id ?? 'volantes'} {...L('cautelas', null, { status: 'ativa', obra: o.obra_id ?? null, rotulo: `Em campo · ${o.obra_nome}` })}>
                      <div className="t"><span className="nm">{o.obra_nome}</span><span className="vl">{fmtBRLc(o.valor || 0)}</span></div>
                      <div className="tk"><div className={`fl ${o.obra_id == null ? 'vol' : ''}`} style={{width:Math.round((o.valor || 0) / maxObra * 100) + '%'}}/></div>
                      <div className="mt">{o.eng_nome || 'Sem engenheiro'} · {o.colaboradores || 0} colab.</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {(stats.riscos_individuais || []).length > 0 && (
              <div className="dc-card">
                <span className="dc-mtag">Cautela</span>
                <h4>Maiores riscos individuais</h4>
                <p className="dc-cap">Colaboradores com ferramenta há mais tempo sem devolução{podeAbrir(user, 'cautelas') ? ' · toque para abrir a cautela' : ''}</p>
                <table className="dc-risk" style={{marginTop:10}}><tbody>
                  {stats.riscos_individuais.map((r, i) => (
                    <tr key={i} {...L('cautelas', r.cautela_id || null, r.cautela_id ? null : ATIVAS)}>
                      <td><span className="cn">{r.colaborador}</span><br/><span className="co">{r.obra_nome || 'Sem obra'}{r.eng_nome ? ' · ' + r.eng_nome : ''}</span></td>
                      <td className="dd" style={{color:r.dias >= 60 ? 'var(--danger)' : 'var(--accent-dark)'}}>{r.dias} dias {pctPill(r.dias)}</td>
                      <td className="vv">{fmtBRL(r.valor || 0)}</td>
                    </tr>
                  ))}
                </tbody></table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Prioridade 2 — Desempenho dos líderes/engenheiros */}
      {has('equipe') && lideres.length > 0 && (
        <div className="dc-sec">
          <div className="dc-head"><span className="k">Prioridade 2</span><h3>Desempenho dos líderes &amp; engenheiros</h3></div>
          <div className="dc-grid">
            <div className="dc-card dc-span12">
              <span className="dc-mtag">Equipe</span>
              <h4>Ranking por engenheiro responsável</h4>
              <p className="erk-hint">Toque num engenheiro para ver as obras e os colaboradores.</p>
              <div className="erk-wrap">
                {lideres.map(l => <EngRankCard key={l.id} l={l} maxLider={maxLider} ir={ir} irTransf={irTransf} />)}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Contexto — cobertura, fluxo, pessoas */}
      <div className="dc-sec">
        <div className="dc-head"><span className="k">Contexto</span><h3>Cobertura, fluxo e pessoas</h3></div>
        <div className="dc-grid dc-trio">
          {has('obras') && (
            <div className="dc-card">
              <span className="dc-mtag">Obras</span>
              <h4>Cobertura das obras</h4>
              <div style={{marginTop:6}}>
                <div className="dc-cov lk-row" {...L('obras', null, { ativas: true, rotulo: 'Obras ativas' })}><span className="cv">{stats.obras_ativas || 0}</span><span className="cl">obras ativas no contrato</span></div>
                <div className="dc-cov lk-row" {...L('obras', null, { comLider: true, rotulo: 'Obras com engenheiro responsável' })}><span className="cv good">{stats.obras_com_lider || 0}</span><span className="cl">com engenheiro responsável</span></div>
                <div className="dc-cov lk-row" {...L('obras', null, SEM_ENG)}><span className="cv bad">{stats.obras_sem_lider || 0}</span><span className="cl">sem engenheiro — atribuir</span></div>
                <div className="dc-cov"><span className="cv">{stats.obras_sem_movimento || 0}</span><span className="cl">sem ferramenta em campo hoje</span></div>
              </div>
              {(stats.obras_sem_lider || 0) > 0 && ir('obras') && <button className="btn btn-accent btn-sm" style={{marginTop:12,width:'100%'}} onClick={ir('obras', null, SEM_ENG)}>Atribuir engenheiros →</button>}
            </div>
          )}

          <div className="dc-card">
            <span className="dc-mtag">Cautela</span>
            <h4>Funil de solicitações</h4>
            <div style={{marginTop:10}}>
              {[['Solicitada', funil.solicitada, 'var(--primary-accent)', ir('solicitacoes', null, { status: 'solicitada', rotulo: 'Solicitações novas' })],
                ['Em separação', funil.separando, 'var(--primary-accent)', ir('solicitacoes', null, { status: 'separando', rotulo: 'Solicitações em separação' })],
                ['Pronta p/ retirada', funil.pronta, 'var(--primary-accent)', ir('solicitacoes', null, { status: 'pronta', rotulo: 'Solicitações prontas p/ retirada' })],
                ['Retiradas (7 dias)', funil.retiradas_7d, 'var(--success)', ir('cautelas', null, { retiradaDias: 7, rotulo: 'Retiradas nos últimos 7 dias' })]].map(([l, v, c, go], i) => (
                <div className="dc-fr lk-row" key={i} {...linkProps(go)}>
                  <div className="ft"><span className="fl">{l}</span><span className="fv">{v || 0}</span></div>
                  <div className="tk"><i style={{width:Math.round((v || 0) / maxFunil * 100) + '%', background:c}}/></div>
                </div>
              ))}
            </div>
          </div>

          {has('equipe') && (
            <div className="dc-card">
              <span className="dc-mtag">Equipe</span>
              <h4>Pessoas &amp; alocação</h4>
              <div className="dc-people-total lk-row" {...linkProps(irPessoas({ rotulo: 'Colaboradores ativos' }))}>
                <span className="dpt-n">{stats.colaboradores_ativos || 0}</span>
                <span className="dpt-l">colaboradores ativos no total</span>
              </div>
              <div style={{marginTop:6}}>
                <div className="dc-pr lk-row" {...linkProps(irPessoas({ semObra: true, rotulo: 'Volantes (sem obra)' }))}><span className="pl">Volantes (sem obra)</span><span className="pv vol">{stats.volantes || 0}</span></div>
                {(stats.por_funcao || []).map((f, i) => (
                  <div className="dc-pr lk-row" key={i} {...linkProps(irPessoas({ cargo: f.funcao, rotulo: `Colaboradores · ${f.funcao}` }))}><span className="pl">{f.funcao}</span><span className="pv">{f.n}</span></div>
                ))}
                {has('emprestimos') && <div className="dc-pr lk-row" {...L('emprestimos', null, { status: 'ativo', rotulo: 'Empréstimos ativos' })}><span className="pl">Empréstimos ativos entre equipes</span><span className="pv">{stats.emprestimos_ativos || 0}</span></div>}
              </div>
            </div>
          )}
        </div>
      </div>
      </>}
    </div>
    )
  }

  // Painel Geral do almoxarifado — um bloco por MÓDULO, cada um com título próprio. Só números +
  // atalho para a aba correspondente (listas item a item ficam nas abas, não no painel).
  if (user.role === 'almoxarifado') {
    const modHd = (icon, titulo, sub, acao) => (
      <div className="painel-mod">
        <span className="pm-ic"><Icon name={icon} size={16}/></span>
        <div className="pm-tx"><h3>{titulo}</h3>{sub && <span className="pm-sub">{sub}</span>}</div>
        {acao}
      </div>
    )
    const uniMin = stats.uniforme_abaixo_minimo || 0, uniDesg = stats.uniforme_desgaste_30d || 0
    // Drill-in num contrato: os módulos de baixo (REC, Uniformes/EPI) seguem com os números do grupo — o
    // subtítulo diz isso, para não serem lidos como do contrato aberto lá em cima.
    const doGrupo = sub => contratoSel && visaoContratos ? <><b>Todos os contratos</b> · {sub}</> : sub
    return (
    <div>
      <div className="topbar"><h2>Painel Geral</h2>{user.is_master && <a href="/api/admin/backup" className="btn btn-ghost btn-sm" style={{fontSize:'.8rem',display:'inline-flex',alignItems:'center',gap:6}}><Icon name="download" size={14}/> Baixar backup</a>}</div>
      {modHd('wrench', 'Ferramentas & Cautelas', 'patrimônio, estoque e solicitações de ferramentas')}
      {/* Com 2+ contratos, a Visão por contrato É o bloco de patrimônio do módulo: o consolidado dela
          substitui o hero abaixo, e o drill-in num contrato traz o próprio Estoque/Panorama/Fila. */}
      {user.is_master && <PainelContratos user={user} navigate={navigate} selExt={contratoSel} onSel={setContratoSel} onVisivel={setVisaoContratos} />}
      {user.is_master && visaoContratos === false && (() => {
        const totalCampo = stats.valor_em_campo || 0
        const obras = (stats.por_obra || []).filter(o => (o.valor_em_campo || 0) > 0).sort((a, b) => (b.valor_em_campo || 0) - (a.valor_em_campo || 0))
        const palette = ['#C39A64', '#4A90A4', '#8A9BB0', '#2E3F55']
        const segs = obras.slice(0, 4).map((o, i) => ({ nome: o.obra_nome, val: o.valor_em_campo || 0, cor: palette[i] }))
        const outras = obras.slice(4).reduce((s, o) => s + (o.valor_em_campo || 0), 0)
        if (outras > 0) segs.push({ nome: 'Outras obras', val: outras, cor: '#566475' })
        const kBRL = v => v >= 1000 ? 'R$ ' + (v / 1000).toFixed(1).replace('.', ',') + ' mil' : fmtBRL(v)
        return (
          <div className="stat-section">
            <div className="stat-section-title"><span className="st-ic"><Icon name="signature" size={14}/></span>Responsabilidade &amp; valores</div>
            <div className="fin-hero" style={{marginBottom:16}} {...L('cautelas', null, ATIVAS)}>
              <span className="fh-chip">tempo real</span>
              <div className="fh-label"><Icon name="shield" size={14}/> Patrimônio sob responsabilidade · em campo</div>
              <div className="fh-value"><span className="cur">R$</span>{fmtBRL(totalCampo).replace('R$ ', '')}</div>
              <div className="fh-sub">{stats.cautelas_ativas || 0} cautela(s) ativa(s){segs.length ? ` em ${obras.length} obra(s)` : ''}</div>
              {totalCampo > 0 && segs.length > 0 && (<>
                <div className="fh-bar">{segs.map((s, i) => <span key={i} style={{ width: (s.val / totalCampo * 100) + '%', background: s.cor }}></span>)}</div>
                <div className="fh-legend">{segs.map((s, i) => <span className="lg" key={i}><i style={{ background: s.cor }}></i>{s.nome} <b>{kBRL(s.val)}</b></span>)}</div>
              </>)}
            </div>
          </div>
        )
      })()}
      {/* Drill-in num contrato: o PainelContratos já mostra Estoque/Panorama/Fila daquele contrato. */}
      {!(contratoSel && visaoContratos) && <>
      <div className="stat-section">
        <div className="stat-section-title"><span className="st-ic"><Icon name="package" size={14}/></span>Estoque</div>
        <div className="stats-grid">
          <div className="stat-card blue" {...L('ferramentas')}><div className="stat-label">Ferramentas</div><div className="stat-value">{stats.total_ferramentas||0}</div><div style={{fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}>{stats.total_unidades||0} unidades</div></div>
          <div className="stat-card" {...L('ferramentas', null, { patrimonio: true, rotulo: 'Ferramentas com código de patrimônio' })}><div className="stat-label">Com código de patrimônio</div><div className="stat-value">{stats.total_patrimonio||0}</div><div style={{fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}>ferramentas rastreadas por patrimônio</div></div>
          {user.is_master && <div className="stat-card green" {...L('ferramentas')}><div className="stat-label">Valor total cadastrado</div><ValorCard v={stats.valor_total_estoque || 0} /></div>}
        </div>
      </div>
      <div className="stat-section">
        <div className="stat-section-title"><span className="st-ic"><Icon name="exchange" size={14}/></span>Panorama operacional</div>
        <div className="stats-grid">
          <div className="stat-card blue" {...L('cautelas', null, ATIVAS)}><div className="stat-label">Ferramentas em campo</div><div className="stat-value">{stats.unidades_em_campo||0}</div><div style={{fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}>{stats.cautelas_ativas||0} cautela(s) ativa(s)</div></div>
          <div className="stat-card" {...L('cautelas', null, { status: 'aguardando_retirada', rotulo: 'Cautelas aguardando retirada' })}><div className="stat-label">Aguardando retirada</div><div className="stat-value">{stats.cautelas_aguardando||0}</div><div style={{fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}>separadas p/ o colaborador buscar</div></div>
          <div className={`stat-card ${(stats.cautelas_atencao_15d||0) > 0 ? 'red' : ''}`} {...L('cautelas', null, { status: 'ativa', dias: [15, null], rotulo: 'Em campo há +15 dias — cobrar devolução' })}><div className="stat-label">Em campo há +15 dias</div><div className="stat-value">{stats.cautelas_atencao_15d||0}</div><div style={{fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}>atenção — cobrar devolução</div></div>
          <div className="stat-card green" {...L('cautelas', null, { movHoje: true, rotulo: 'Saídas e devoluções de hoje' })}><div className="stat-label">Movimento hoje</div><div className="stat-value">{stats.retiradas_hoje||0} <span style={{fontSize:'.9rem',fontWeight:600,color:'var(--text-secondary)'}}>saídas</span></div><div style={{fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}>{stats.devolucoes_hoje||0} devolução(ões) hoje</div></div>
        </div>
      </div>
      <div className="stat-section">
        <div className="stat-section-title"><span className="st-ic"><Icon name="clipboard" size={14}/></span>Fila de solicitações</div>
        <div className="stats-grid">
          <div className="stat-card" {...L('solicitacoes', null, { status: 'solicitada', rotulo: 'Solicitações novas' }, true)}><div className="stat-label">Solicitações novas</div><div className="stat-value">{stats.sol_solicitadas||0}</div><div style={{fontSize:'.72rem',color:'var(--primary-accent)',marginTop:2,fontWeight:600}}>Ver fila →</div></div>
          <div className="stat-card" {...L('solicitacoes', null, { status: 'separando', rotulo: 'Solicitações em separação' })}><div className="stat-label">Separando</div><div className="stat-value">{stats.sol_separando||0}</div></div>
          <div className="stat-card" {...L('solicitacoes', null, { status: 'pronta', rotulo: 'Solicitações prontas p/ retirada' })}><div className="stat-label">Prontas p/ retirada</div><div className="stat-value">{stats.sol_prontas||0}</div></div>
        </div>
      </div>
      </>}
      {temModulo(user, 'rec') && recPainel !== false && <>
        {modHd('clipboard', 'REC · Custódia de materiais', doGrupo('solicitações, remessas e compras de material'),
          <button className="btn btn-outline btn-sm pm-go" onClick={()=>navigate('rec')}>Abrir REC →</button>)}
        <RecPainelIndicadores painel={recPainel} veEmCompras={['diretor', 'gerente'].includes(user.role) || !!user.is_master}
          irAba={podeAbrir(user, 'rec') ? (t, f) => navigate('rec', t, f) : null}
          irEstoque={ir('estoque', 'saldo')} />
      </>}

      {user.rdo_ativo ? <RdoPainelResumo navigate={navigate} /> : null}

      {temModulo(user, 'uniformes') && <>
        {modHd('shirt', 'Uniformes / EPI', doGrupo('reposição de estoque e troca por desgaste'))}
        <div className="stats-grid">
          <div className={`stat-card ${uniMin > 0 ? 'red' : 'green'}`} {...L('uniformes', 'alertas', null, true)} title="Ver os itens em Uniformes / EPI › Alertas"><div className="stat-label">Estoque no mínimo</div><div className="stat-value">{uniMin}</div><div style={{fontSize:'.72rem',color:'var(--primary-accent)',marginTop:2,fontWeight:600}}>Ver itens →</div></div>
          <div className={`stat-card ${uniDesg > 0 ? 'red' : 'green'}`} {...L('uniformes', 'alertas', null, true)} title="Ver os colaboradores em Uniformes / EPI › Alertas"><div className="stat-label">Desgaste vencendo (≤ 30 dias)</div><div className="stat-value">{uniDesg}</div><div style={{fontSize:'.72rem',color:'var(--primary-accent)',marginTop:2,fontWeight:600}}>Ver colaboradores →</div></div>
        </div>
      </>}
    </div>
    )
  }

  // Painel do Engenheiro — foco em INDICADORES de Obras + Equipe.
  // Cards: Minhas obras · Colaboradores · Cautelas ativas (em posse da equipe) · Valor em campo ·
  // Aguard. meu aval. (Os cards de equipe espelham a aba Minha equipe; os de Obras, a aba Obras.)
  if (user.role === 'engenheiro') return (
    <div>
      <div className="topbar">
        <h2>Painel do Engenheiro</h2>
      </div>
      {(stats.sol_prontas > 0 || stats.emp_aguardando_aval > 0) && (
        <div className="pending-banner">
          <div>
            <div className="msg" style={{display:'flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={15}/> Itens requerem sua atenção</div>
            <div style={{fontSize:'.85rem',marginTop:4,color:'var(--tag-alerta-fg)'}}>
              {stats.sol_prontas > 0 && <span>{stats.sol_prontas} solicitação(ões) pronta(s) para retirada &nbsp;</span>}
              {stats.emp_aguardando_aval > 0 && <span>{stats.emp_aguardando_aval} empréstimo(s) aguardando seu aval</span>}
            </div>
          </div>
          <div className="gap-8">
            {stats.sol_prontas > 0 && <button className="btn btn-accent btn-sm" onClick={()=>navigate('solicitacoes')}>Retirar →</button>}
            {stats.emp_aguardando_aval > 0 && <button className="btn btn-primary btn-sm" onClick={()=>navigate('emprestimos')}>Aval →</button>}
          </div>
        </div>
      )}
      <div className="stat-section">
        <div className="section-title" style={{display:'flex',alignItems:'center',gap:8,margin:'0 0 12px',fontWeight:600,color:'var(--text-secondary)'}}><Icon name="building" size={16}/> Minhas obras e equipe</div>
        <div className="stats-grid">
          <div className="stat-card blue" {...L('obras')}><div className="stat-label">Minhas obras</div><div className="stat-value">{stats.minhas_obras||0}</div></div>
          <div className="stat-card" {...L('equipe')}><div className="stat-label">Colaboradores</div><div className="stat-value">{stats.equipe_colaboradores||0}</div></div>
          {/* Posse da EQUIPE (não as cautelas em que ele assina como responsável) — filtra pelos membros. */}
          {(() => { const eq = stats.equipe_cautelas ? L('cautelas', null, { status: 'ativa', colaboradores: stats.equipe_ids || [], rotulo: 'Cautelas em posse da minha equipe' }) : {}
            return <>
              <div className="stat-card green" {...eq}><div className="stat-label">Cautelas ativas</div><div className="stat-value">{stats.equipe_cautelas||0}</div></div>
              <div className="stat-card" {...eq}><div className="stat-label">Valor em campo</div><ValorCard v={stats.equipe_valor||0} /></div>
            </> })()}
          <div className="stat-card" {...L('emprestimos', null, { status: 'aguardando_lider', rotulo: 'Empréstimos aguardando meu aval' })}><div className="stat-label">Aguard. meu aval (emprést.)</div><div className="stat-value">{stats.emp_aguardando_aval||0}</div></div>
        </div>
      </div>
      <div className="card">
        <div className="card-header"><span className="card-title">Minhas solicitações</span><button className="btn btn-outline btn-sm" onClick={()=>navigate('solicitacoes')}>Ver todas</button></div>
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Número</th><th>Data</th><th>Status</th></tr></thead>
          <tbody>
            {(stats.minhas_solicitacoes||[]).map(s=>(
              <tr key={s.id} {...L('solicitacoes', s.id)}>
                <td className="fw-bold" data-label="Número">{s.numero}</td>
                <td data-label="Data">{fmt(s.criado_em)}</td>
                <td data-label="Status"><span className={`badge badge-${s.status}`}>{STATUS_LABEL[s.status]}</span></td>
              </tr>
            ))}
            {!(stats.minhas_solicitacoes||[]).length && <tr><td colSpan="3" className="text-muted" style={{textAlign:'center',padding:20}}>Nenhuma solicitação ainda.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  )

  if (user.role === 'lider') return (
    <div>
      <div className="topbar">
        <h2>Painel do Líder</h2>
      </div>
      {(stats.sol_prontas > 0 || stats.emp_aguardando_aval > 0) && (
        <div className="pending-banner">
          <div>
            <div className="msg" style={{display:'flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={15}/> Itens requerem sua atenção</div>
            <div style={{fontSize:'.85rem',marginTop:4,color:'var(--tag-alerta-fg)'}}>
              {stats.sol_prontas > 0 && <span>{stats.sol_prontas} solicitação(ões) pronta(s) para retirada &nbsp;</span>}
              {stats.emp_aguardando_aval > 0 && <span>{stats.emp_aguardando_aval} empréstimo(s) aguardando seu aval</span>}
            </div>
          </div>
          <div className="gap-8">
            {stats.sol_prontas > 0 && <button className="btn btn-accent btn-sm" onClick={()=>navigate('solicitacoes')}>Retirar →</button>}
            {stats.emp_aguardando_aval > 0 && <button className="btn btn-primary btn-sm" onClick={()=>navigate('emprestimos')}>Aval →</button>}
          </div>
        </div>
      )}
      <div className="stats-grid">
        <div className="stat-card" {...L('solicitacoes', null, { ativas: true, rotulo: 'Solicitações em andamento' })}><div className="stat-label">Minhas solicitações ativas</div><div className="stat-value">{stats.minhas_sol_ativas||0}</div></div>
        <div className="stat-card green" {...L('cautelas', null, ATIVAS)}><div className="stat-label">Cautelas ativas</div><div className="stat-value">{stats.cautelas_ativas||0}</div></div>
        <div className="stat-card" {...L('cautelas', null, ATIVAS)}><div className="stat-label">Em campo — minha equipe</div><ValorCard v={stats.valor_responsabilidade||0} /></div>
        <div className="stat-card" {...L('cautelas', null, { status: 'ativa', comEntrega: true, rotulo: 'Cautelas com ferramenta entregue a colaboradores' })}><div className="stat-label">Em posse dos colaboradores</div><ValorCard v={stats.valor_entregue_equipe||0} /></div>
        <div className="stat-card" {...L('emprestimos', null, { status: 'aguardando_lider', rotulo: 'Empréstimos aguardando meu aval' })}><div className="stat-label">Aguard. meu aval (emprést.)</div><div className="stat-value">{stats.emp_aguardando_aval||0}</div></div>
      </div>
      <div className="card">
        <div className="card-header"><span className="card-title">Minhas solicitações</span><button className="btn btn-outline btn-sm" onClick={()=>navigate('solicitacoes')}>Ver todas</button></div>
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Número</th><th>Data</th><th>Status</th></tr></thead>
          <tbody>
            {(stats.minhas_solicitacoes||[]).map(s=>(
              <tr key={s.id} {...L('solicitacoes', s.id)}>
                <td className="fw-bold" data-label="Número">{s.numero}</td>
                <td data-label="Data">{fmt(s.criado_em)}</td>
                <td data-label="Status"><span className={`badge badge-${s.status}`}>{STATUS_LABEL[s.status]}</span></td>
              </tr>
            ))}
            {!(stats.minhas_solicitacoes||[]).length && <tr><td colSpan="3" className="text-muted" style={{textAlign:'center',padding:20}}>Nenhuma solicitação ainda.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  )

  // Operário
  // Apontador: o painel é a guarda das bolsas que ele leva ao operário — quanto está com ele e o que buscar.
  if (user.role === 'apontador') return (
    <div>
      <div className="topbar"><h2>Meu Painel</h2></div>
      {stats.portes_em_maos > 0 && (
        <div className="pending-banner">
          <span className="msg" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="truck" size={15}/> Você está com {stats.portes_em_maos} bolsa(s) para entregar</span>
          <button className="btn btn-accent btn-sm" onClick={()=>navigate('entregas-bolsas')}>Entregar →</button>
        </div>
      )}
      {stats.portes_buscar > 0 && (
        <div className="pending-banner">
          <span className="msg" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="backpack" size={15}/> {stats.portes_buscar} bolsa(s) pronta(s) no almoxarifado para você levar</span>
          <button className="btn btn-outline btn-sm" onClick={()=>navigate('entregas-bolsas')}>Ver →</button>
        </div>
      )}
      <div className="stats-grid">
        <div className="stat-card red" {...L('entregas-bolsas')}><div className="stat-label">Valor sob sua guarda</div><ValorCard v={stats.portes_valor_em_maos||0} /><div style={{fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}>bolsas retiradas e ainda não entregues</div></div>
        <div className="stat-card" {...L('entregas-bolsas')}><div className="stat-label">Bolsas com você</div><div className="stat-value">{stats.portes_em_maos||0}</div></div>
        <div className="stat-card" {...L('entregas-bolsas')}><div className="stat-label">Prontas para buscar</div><div className="stat-value">{stats.portes_buscar||0}</div></div>
        <div className="stat-card" {...L('entregas-bolsas')}><div className="stat-label">Entregues (7 dias)</div><div className="stat-value">{stats.portes_entregues_7d||0}</div></div>
      </div>
    </div>
  )

  return (
    <div>
      <div className="topbar"><h2>Meu Painel</h2></div>
      {(stats.portes_a_caminho||[]).map(p => (
        <div key={p.cautela_id} className="pending-banner">
          <span className="msg" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="truck" size={15}/> Sua bolsa ({p.numero}) está a caminho com o apontador {p.portador_nome}. Na entrega, ele pede seu CPF e sua assinatura.</span>
          <button className="btn btn-outline btn-sm" onClick={()=>navigate('cautelas', p.cautela_id)}>Ver →</button>
        </div>
      ))}
      {stats.emp_aguardando_confirmacao > 0 && (
        <div className="pending-banner">
          <span className="msg" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="signature" size={15}/> Você tem {stats.emp_aguardando_confirmacao} empréstimo(s) aguardando sua confirmação</span>
          <button className="btn btn-accent btn-sm" onClick={()=>navigate('emprestimos')}>Confirmar →</button>
        </div>
      )}
      <div className="stats-grid">
        <div className="stat-card red" {...L('cautelas')}><div className="stat-label">Valor sob minha responsabilidade</div><ValorCard v={stats.valor_responsabilidade||0} /></div>
        <div className="stat-card" {...L('emprestimos', null, { status: 'ativo', rotulo: 'Empréstimos ativos' })}><div className="stat-label">Empréstimos ativos</div><div className="stat-value">{stats.emp_ativos||0}</div></div>
        <div className="stat-card" {...L('emprestimos', null, { status: 'aguardando_tomador', rotulo: 'Empréstimos aguardando minha confirmação' })}><div className="stat-label">Aguard. minha confirmação</div><div className="stat-value">{stats.emp_aguardando_confirmacao||0}</div></div>
      </div>
      {(stats.minhas_entregas||[]).length > 0 && (
        <div className="card">
          <div className="card-header"><span className="card-title" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="checkCircle" size={15}/> Ferramentas sob minha guarda</span></div>
          <div className="card-body">
            {stats.minhas_entregas.map(e=>(
              <div key={(e.direta ? 'd' : 'e') + e.id} className="lk-row" {...L('cautelas', e.cautela_id || null)} style={{padding:'8px 0',borderBottom:'1px solid var(--border)'}}>
                <strong>{e.cautela_numero}</strong>
                <span className="text-muted" style={{marginLeft:8}}>{e.direta ? 'Retirada direta' : `Líder: ${e.lider_nome}`}</span>
                <span className="text-muted" style={{marginLeft:8}}>Desde: {fmt(e.data_entrega)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

// ─── SOLICITAÇÕES (fila almoxarife + acompanhamento líder) ────────────────────
function SolicitacoesPage({ user, navigate, addToast, openTarget, clearOpenTarget }) {
  const [lista, setLista] = useState([])
  const [detalhe, setDetalhe] = useState(null)
  const [filtro, setFiltro] = useState(() => filtroDoAlvo(openTarget, 'solicitacoes'))  // card do painel
  // Diretor/Gerente (e o gerente multicontrato): só consulta — sem nova solicitação nem cancelar.
  const consulta = user.role === 'diretor' || user.role === 'gerente' || !!user.multi_contrato
  const [retiradaModal, setRetiradaModal] = useState(null) // cautela para retirada
  const [authEmail, setAuthEmail] = useState('')
  const [authSenha, setAuthSenha] = useState('')
  const [authStep, setAuthStep] = useState('form') // form | termo | sign
  const [authUser, setAuthUser] = useState(null)
  const [authErr, setAuthErr] = useState('')
  const [termoHTML, setTermoHTML] = useState('')
  // --- Editar itens (separando) ---
  const [editItensModal, setEditItensModal] = useState(null)
  const [editItens, setEditItens] = useState([])
  const [editItensErr, setEditItensErr] = useState('')
  const [editItensLoading, setEditItensLoading] = useState(false)
  const [editSelFerr, setEditSelFerr] = useState('')
  const [editSelQtd, setEditSelQtd] = useState(1)
  const [editItensRemovidos, setEditItensRemovidos] = useState([])
  // --- Solicitar por Operário ---
  const [porOpModal, setPorOpModal] = useState(false)
  const [porOpStep, setPorOpStep] = useState('form') // form | sign
  const [porOpOperario, setPorOpOperario] = useState('')
  const [porOpTipo, setPorOpTipo] = useState('bolsa') // bolsa | itens
  const [porOpBolsaId, setPorOpBolsaId] = useState('')
  const [porOpItens, setPorOpItens] = useState([])
  const [porOpObs, setPorOpObs] = useState('')
  const [porOpErr, setPorOpErr] = useState('')
  const [porOpLoading, setPorOpLoading] = useState(false)
  const [porOpAuthEmail, setPorOpAuthEmail] = useState('')
  const [porOpAuthSenha, setPorOpAuthSenha] = useState('')
  const [porOpAuthErr, setPorOpAuthErr] = useState('')
  const [porOpSelFerr, setPorOpSelFerr] = useState('')
  const [porOpSelQtd, setPorOpSelQtd] = useState(1)
  const [operarios, setOperarios] = useState([])
  const [bolsasLista, setBolsasLista] = useState([])
  const [ferramentasLista, setFerramentasLista] = useState([])
  // A Sede atende todos os contratos: com 2+, cada pedido leva a etiqueta do contrato de quem pede, e o acervo
  // oferecido é sempre o do contrato DELE (o operário escolhido, ou o dono da solicitação na edição da lista).
  const ct = useContratosCadastro(user)
  const tagSol = s => <ContratoTag ct={ct} id={ct.de({ contrato_id: s.lider_contrato_id })}/>
  const doAcervo = (fid, cid) => { if (!ct.multi) return true; const f = ferramentasLista.find(x => x.id == fid); return !!f && ct.de(f) === cid }
  // --- Estorno de retirada (correção de lançamento errado) ---
  const [estornoAlvo, setEstornoAlvo] = useState(null)
  const [estornoExcluir, setEstornoExcluir] = useState(false)
  const [estornoMotivo, setEstornoMotivo] = useState('')
  const [estornoLoading, setEstornoLoading] = useState(false)
  // --- Bolsa levada pelo apontador (operário que não consegue vir ao almoxarifado) ---
  const [apontadores, setApontadores] = useState([])
  const [porOpModo, setPorOpModo] = useState('presente') // presente | apontador
  const [porOpPortador, setPorOpPortador] = useState('')
  const [porteModal, setPorteModal] = useState(null)     // saída no balcão: { step, portadorId, sel, email, senha, err }
  const [retornoModal, setRetornoModal] = useState(null) // voltou sem entrega: { sol, step, email, senha, motivo, detalhe, err }
  // Apontadores de 2+ contratos: cada opção leva o nome do contrato (o apontador leva para qualquer um).
  const apMultiCt = new Set(apontadores.map(a => a.contrato_id).filter(Boolean)).size > 1
  const opcaoApontador = a => <option key={a.id} value={a.id}>{a.nome}{a.cargo ? ` — ${a.cargo}` : ''}{apMultiCt && a.contrato_nome ? ` · ${a.contrato_nome}` : ''}</option>

  const load = () => GET('/solicitacoes').then(setLista).catch(() => {})
  // Deep-link do painel: abre a solicitação pedida assim que a lista chega e consome o alvo.
  useEffect(() => {
    if (!openTarget || openTarget.page !== 'solicitacoes') return
    if (!openTarget.id) { clearOpenTarget && clearOpenTarget(); return }
    const s = lista.find(x => x.id === openTarget.id)
    if (s) { setDetalhe(s); clearOpenTarget && clearOpenTarget() }
  }, [openTarget, lista])
  useEffect(() => {
    load()
    if (user.role === 'almoxarifado') {
      GET('/usuarios').then(us => setOperarios(us.filter(u => u.role === 'operario' && u.ativo))).catch(() => {})
      // Apontador leva para todos os contratos: a lista vem inteira, não só os do contrato desta conta.
      GET('/portes/apontadores').then(setApontadores).catch(() => {})
      GET('/bolsas').then(setBolsasLista).catch(() => {})
      GET('/ferramentas').then(setFerramentasLista).catch(() => {})
    }
  }, [])

  const abrirEditItens = (s) => {
    setEditItensModal(s)
    setEditItens(s.itens.map(i => ({ ...i })))
    setEditItensRemovidos([])
    setEditItensErr(''); setEditSelFerr(''); setEditSelQtd(1)
  }
  // Na edição da lista, só o acervo do contrato de quem pediu (antes vinha só o do contrato da Sede).
  const acervoEdit = editItensModal ? ferramentasLista.filter(f => doAcervo(f.id, ct.de({ contrato_id: editItensModal.lider_contrato_id }))) : []

  const addItemToEdit = () => {
    if (!editSelFerr) return
    const f = ferramentasLista.find(f => f.id == editSelFerr)
    if (!f) return
    const existe = editItens.find(i => i.ferramenta_id == editSelFerr)
    if (existe) {
      setEditItens(editItens.map(i => i.ferramenta_id == editSelFerr ? {...i, quantidade: i.quantidade + editSelQtd} : i))
    } else {
      setEditItens([...editItens, { ferramenta_id: f.id, ferramenta_nome: f.nome, quantidade: editSelQtd }])
    }
    setEditSelFerr(''); setEditSelQtd(1)
  }

  const removeItemEdit = (ferramenta_id) => {
    const nova = editItens.filter(i => i.ferramenta_id !== ferramenta_id)
    if (!nova.length) { setEditItensErr('A lista não pode ficar vazia'); return }
    const removido = editItens.find(i => i.ferramenta_id === ferramenta_id)
    setEditItensRemovidos(prev => [...prev, removido])
    setEditItensErr(''); setEditItens(nova)
  }

  const restaurarItemEdit = (ferramenta_id) => {
    const item = editItensRemovidos.find(i => i.ferramenta_id === ferramenta_id)
    if (!item) return
    setEditItens(prev => [...prev, item])
    setEditItensRemovidos(prev => prev.filter(i => i.ferramenta_id !== ferramenta_id))
  }

  const alterarQtdEdit = (ferramenta_id, qtd) => {
    const q = Math.max(1, parseInt(qtd) || 1)
    setEditItens(editItens.map(i => i.ferramenta_id === ferramenta_id ? {...i, quantidade: q} : i))
  }

  const salvarEditItens = async () => {
    if (!editItens.length) { setEditItensErr('A lista não pode ficar vazia'); return }
    setEditItensLoading(true); setEditItensErr('')
    try {
      await PUT(`/solicitacoes/${editItensModal.id}/itens`, {
        itens: editItens.map(i => ({ ferramenta_id: i.ferramenta_id, quantidade: i.quantidade }))
      })
      addToast('Lista atualizada!', 'success')
      setEditItensModal(null); load()
    } catch(e) { setEditItensErr(e.message) }
    finally { setEditItensLoading(false) }
  }

  const abrirPorOpModal = () => {
    setPorOpModal(true); setPorOpStep('form'); setPorOpOperario(''); setPorOpTipo('bolsa')
    setPorOpBolsaId(''); setPorOpItens([]); setPorOpObs(''); setPorOpErr('')
    setPorOpSelFerr(''); setPorOpSelQtd(1)
    setPorOpAuthEmail(''); setPorOpAuthSenha(''); setPorOpAuthErr('')
    setPorOpModo('presente'); setPorOpPortador('')
  }

  // Disponível de uma ferramenta (do estoque já calculado pelo backend)
  const dispPorOp = fid => { const f = ferramentasLista.find(x => x.id == fid); return f ? (f.quantidade_disponivel != null ? f.quantidade_disponivel : (f.quantidade_total || 0)) : 0 }
  // Código de patrimônio da ferramenta — exibido na solicitação para conferência física do item retirado
  const codigoPorOp = fid => { const f = ferramentasLista.find(x => x.id == fid); return f && f.codigo ? f.codigo : '' }
  // Ao escolher a bolsa, expande os itens dela para uma lista editável (permite remover o que falta)
  const selecionarBolsaPorOp = id => {
    setPorOpBolsaId(id); setPorOpErr('')
    const b = bolsasLista.find(x => x.id == id)
    setPorOpItens(b && b.itens ? b.itens.map(i => ({ ferramenta_id: i.ferramenta_id, quantidade: i.quantidade, nome: i.ferramenta_nome })) : [])
  }
  const removerIndisponiveisPorOp = () => { setPorOpItens(porOpItens.filter(it => it.quantidade <= dispPorOp(it.ferramenta_id))); setPorOpErr('') }
  const setQtdPorOp = (idx, q) => setPorOpItens(porOpItens.map((it, j) => j === idx ? { ...it, quantidade: Math.max(1, Math.min(parseInt(q) || 1, dispPorOp(it.ferramenta_id) || 1)) } : it))
  const itensSemEstoquePorOp = () => porOpItens.filter(it => it.quantidade > dispPorOp(it.ferramenta_id))
  // Contrato do operário escolhido: itens e kits oferecidos são só do acervo dele (com 2+ contratos, antes de
  // escolher o operário não há acervo a oferecer). Trocar para um operário de outro contrato tira o que não serve.
  const ctDoOp = oid => { const o = operarios.find(x => x.id == oid); return o ? ct.de(o) : null }
  const ctPorOp = ctDoOp(porOpOperario)
  const acervoPorOp = ct.multi && !ctPorOp ? [] : ferramentasLista.filter(f => doAcervo(f.id, ctPorOp))
  const bolsasPorOp = ct.multi && !ctPorOp ? [] : bolsasLista.filter(b => (b.itens || []).every(i => doAcervo(i.ferramenta_id, ctPorOp)))
  const escolherOperarioPorOp = oid => {
    setPorOpOperario(oid); setPorOpErr('')
    const cid = ctDoOp(oid)
    // Ferramenta escolhida e ainda sem "Add": fora do acervo do novo operário, sai junto (o seletor já não a mostra).
    if (porOpSelFerr && !doAcervo(porOpSelFerr, cid)) { setPorOpSelFerr(''); setPorOpSelQtd(1) }
    const fora = cid ? porOpItens.filter(it => !doAcervo(it.ferramenta_id, cid)) : []
    if (!fora.length) return
    const nomeOp = operarios.find(x => x.id == oid).nome
    if (porOpTipo === 'bolsa' && porOpBolsaId) {
      const b = bolsasLista.find(x => x.id == porOpBolsaId)
      setPorOpBolsaId(''); setPorOpItens([])
      setPorOpErr(`A bolsa ${b ? b.nome : ''} tem ferramenta de outro contrato. ${nomeOp} pede do acervo de ${ct.nome(cid)}: escolha um kit de lá.`)
    } else {
      setPorOpItens(porOpItens.filter(it => doAcervo(it.ferramenta_id, cid)))
      setPorOpErr(`Saiu da lista (é de outro contrato): ${fora.map(it => it.nome).join(', ')}. ${nomeOp} pede do acervo de ${ct.nome(cid)}.`)
    }
  }

  const addItemPorOp = () => {
    if (!porOpSelFerr) return
    if (!doAcervo(porOpSelFerr, ctPorOp)) { setPorOpSelFerr(''); return }   // só do acervo do operário
    const f = ferramentasLista.find(f => f.id == porOpSelFerr)
    if (!f) return
    const disp = dispPorOp(f.id)
    if (disp <= 0) { setPorOpErr(`"${f.nome}" está sem disponibilidade no estoque.`); return }
    const existe = porOpItens.find(i => i.ferramenta_id == porOpSelFerr)
    if (existe) {
      setPorOpItens(porOpItens.map(i => i.ferramenta_id == porOpSelFerr ? {...i, quantidade: Math.min(i.quantidade + porOpSelQtd, disp)} : i))
    } else {
      setPorOpItens([...porOpItens, { ferramenta_id: f.id, quantidade: Math.min(porOpSelQtd, disp), nome: f.nome }])
    }
    setPorOpSelFerr(''); setPorOpSelQtd(1); setPorOpErr('')
  }

  const avancarParaAssinatura = () => {
    if (!porOpOperario) { setPorOpErr('Selecione o operário.'); return }
    if (porOpModo === 'apontador' && !porOpPortador) { setPorOpErr('Escolha o apontador que vai levar a bolsa.'); return }
    if (porOpTipo === 'bolsa' && !porOpBolsaId) { setPorOpErr('Selecione uma bolsa.'); return }
    if (!porOpItens.length) { setPorOpErr(porOpTipo === 'bolsa' ? 'A bolsa ficou sem itens. Escolha outra ou adicione itens.' : 'Adicione ao menos um item.'); return }
    if (itensSemEstoquePorOp().length) { setPorOpErr('Há itens sem estoque suficiente (marcados em vermelho). Remova-os ou reduza a quantidade para prosseguir.'); return }
    setPorOpErr('')
    if (porOpModo === 'apontador') criarParaApontador()
    else setPorOpStep('sign')
  }

  // Operário ausente: o pedido nasce sem o login dele, já com o apontador que vai levar. O operário
  // assina o recebimento na obra, no aparelho do apontador — é ali que ele assume a responsabilidade.
  const criarParaApontador = async () => {
    setPorOpLoading(true)
    try {
      await POST('/solicitacoes/por-operario', {
        operario_id: parseInt(porOpOperario),
        bolsa_id: porOpTipo === 'bolsa' ? parseInt(porOpBolsaId) : null,
        itens: porOpItens,
        obs: porOpObs,
        portador_id: parseInt(porOpPortador)
      })
      const ap = apontadores.find(a => a.id == porOpPortador)
      addToast(`Solicitação criada. Quando ficar pronta, ${ap ? ap.nome : 'o apontador'} retira aqui e leva ao operário.`, 'success')
      setPorOpModal(false); load()
    } catch(e) { setPorOpErr(e.message) }
    finally { setPorOpLoading(false) }
  }

  const confirmarPorOperario = async () => {
    setPorOpAuthErr('')
    if (!porOpAuthEmail || !porOpAuthSenha) { setPorOpAuthErr('Preencha email e senha'); return }
    setPorOpLoading(true)
    try {
      await POST('/solicitacoes/por-operario', {
        operario_id: parseInt(porOpOperario),
        // bolsa_id fica só como referência de origem; os itens de fato são os editados (já sem o que faltava)
        bolsa_id: porOpTipo === 'bolsa' ? parseInt(porOpBolsaId) : null,
        itens: porOpItens,
        obs: porOpObs,
        email_operario: porOpAuthEmail,
        senha_operario: porOpAuthSenha
      })
      addToast('Solicitação criada com autenticação do operário!', 'success')
      setPorOpModal(false); load()
    } catch(e) { setPorOpAuthErr(e.message) }
    finally { setPorOpLoading(false) }
  }

  const avancar = async (id, acao) => {
    try {
      await POST(`/solicitacoes/${id}/${acao}`, {})
      addToast('Status atualizado!', 'success'); load()
    } catch(e) { addToast(e.message, 'error') }
  }

  const cancelar = async (s) => {
    if (user.admin) { addToast('Seu perfil administrativo não pode cancelar.', 'error'); return }
    // Já separada: a cautela gerada (aguardando retirada) cai junto e os itens voltam ao disponível.
    if (!confirm(s.status === 'pronta'
      ? `Cancelar ${s.numero}? Já está separada: a cautela vinculada também é cancelada e os itens voltam ao estoque disponível.`
      : `Cancelar ${s.numero}?`)) return
    try { await POST(`/solicitacoes/${s.id}/cancelar`, {}); addToast(`${s.numero} cancelada.`, 'success'); setDetalhe(null); load() }
    catch(e) { addToast(e.message, 'error') }
  }

  const abrirEstorno = (s) => { if (user.admin) { addToast('Seu perfil administrativo não pode estornar.', 'error'); return } setEstornoAlvo(s); setEstornoExcluir(false); setEstornoMotivo('') }
  const confirmarEstorno = async () => {
    if (!estornoAlvo) return
    setEstornoLoading(true)
    try {
      const r = await POST(`/solicitacoes/${estornoAlvo.id}/estornar`, { excluir: estornoExcluir, motivo: estornoMotivo })
      addToast(r.excluir ? 'Retirada excluída — estoque devolvido.' : 'Retirada estornada — estoque devolvido.', 'success')
      setEstornoAlvo(null); load()
    } catch(e) { addToast(e.message, 'error') }
    finally { setEstornoLoading(false) }
  }

  const iniciarRetirada = async (sol) => {
    // Busca a cautela associada à solicitação
    try {
      const cautelas = await GET('/cautelas')
      const c = cautelas.find(c => c.solicitacao_id == sol.id && c.status === 'aguardando_retirada')
      if (!c) { addToast('Cautela não encontrada ou já retirada.', 'error'); return }
      setRetiradaModal({ cautela: c, sol })
      setAuthEmail(''); setAuthSenha(''); setAuthStep('form'); setAuthUser(null); setAuthErr('')
    } catch(e) { addToast(e.message, 'error') }
  }

  const validarLider = async () => {
    setAuthErr('')
    const isDireto = retiradaModal.cautela.cautela_tipo === 'direto'
    const roleEsperado = isDireto ? 'operario' : 'lider'
    try {
      const u = await POST('/auth/validar', { email: authEmail, senha: authSenha, role_esperado: roleEsperado })
      if (u.id !== retiradaModal.cautela.lider_id) {
        setAuthErr(`Este login não corresponde ao ${isDireto ? 'operário' : 'líder'} desta solicitação.`)
        return
      }
      setAuthUser(u)
      // Carrega o Termo antes da assinatura: ciência direta ou comodato
      try {
        const tipoTermo = retiradaModal.cautela.cautela_tipo === 'direto' ? 'ciencia_direta' : 'comodato'
        const t = await GET(`/cautelas/${retiradaModal.cautela.id}/termo/${tipoTermo}`)
        setTermoHTML(t.html || '')
      } catch(e) { setTermoHTML('') }
      setAuthStep('termo')
    } catch(e) { setAuthErr(e.message) }
  }

  const confirmarRetirada = async (sig) => {
    try {
      await POST(`/cautelas/${retiradaModal.cautela.id}/retirar`, { email: authEmail, senha: authSenha, assinatura: sig })
      addToast('Retirada registrada! Cautela ativa.', 'success')
      setRetiradaModal(null); load()
    } catch(e) { addToast(e.message, 'error') }
  }

  // ── Saída pelo apontador: escolhe quem leva e as bolsas prontas; ele autentica e assina uma vez ──
  const porteSet = patch => setPorteModal(m => m && ({ ...m, ...patch }))
  const designadasA = pid => prontasBalcao.filter(x => x.cautela_id && pid && String(x.portador_id) === String(pid)).map(x => x.cautela_id)
  const abrirPorte = s => {
    const pid = s.portador_id ? String(s.portador_id) : ''
    setPorteModal({ step: 'form', portadorId: pid, sel: [...new Set([s.cautela_id, ...designadasA(pid)].filter(Boolean))], email: '', senha: '', err: '' })
  }
  // Trocar o apontador marca também as bolsas já designadas a ele (as marcadas continuam).
  const trocarPortador = pid => porteSet({ portadorId: pid, sel: [...new Set([...porteModal.sel, ...designadasA(pid)])], err: '' })
  const marcarBolsa = cid => porteSet({ sel: porteModal.sel.includes(cid) ? porteModal.sel.filter(x => x !== cid) : [...porteModal.sel, cid] })
  const porteAvancar = () => {
    if (!porteModal.portadorId) { porteSet({ err: 'Escolha o apontador que vai levar.' }); return }
    if (!porteModal.sel.length) { porteSet({ err: 'Marque ao menos uma bolsa.' }); return }
    porteSet({ step: 'auth', err: '' })
  }
  const porteValidar = async () => {
    porteSet({ err: '' })
    try {
      const u = await POST('/auth/validar', { email: porteModal.email, senha: porteModal.senha, role_esperado: 'apontador' })
      if (String(u.id) !== String(porteModal.portadorId)) { porteSet({ err: 'Este login não é o do apontador escolhido.' }); return }
      porteSet({ step: 'termo' })
    } catch(e) { porteSet({ err: e.message }) }
  }
  const porteConfirmar = async sig => {
    try {
      const r = await POST('/portes/saida', { cautela_ids: porteModal.sel, portador_id: parseInt(porteModal.portadorId), email: porteModal.email, senha: porteModal.senha, assinatura: sig })
      addToast(`${r.cautelas.length} bolsa(s) com ${r.apontador}. O operário assina o recebimento no aparelho dele, na obra.`, 'success')
      setPorteModal(null); load()
    } catch(e) { porteSet({ err: e.message, step: 'termo' }) }
  }

  // ── Voltou sem entrega: o apontador devolve no balcão, com login, motivo e assinatura ──
  const MOTIVOS_RETORNO = ['Operário não estava na obra', 'Operário não conseguiu entrar no sistema', 'Obra ou destino errado', 'Outro motivo']
  const retSet = patch => setRetornoModal(m => m && ({ ...m, ...patch }))
  const abrirRetorno = s => setRetornoModal({ sol: s, step: 'form', email: '', senha: '', motivo: MOTIVOS_RETORNO[0], detalhe: '', err: '' })
  const retornoValidar = async () => {
    if (retornoModal.motivo === 'Outro motivo' && !retornoModal.detalhe.trim()) { retSet({ err: 'Descreva o motivo.' }); return }
    retSet({ err: '' })
    try {
      const u = await POST('/auth/validar', { email: retornoModal.email, senha: retornoModal.senha, role_esperado: 'apontador' })
      if (u.id !== retornoModal.sol.porte.portador_id) { retSet({ err: `Quem devolve é ${retornoModal.sol.porte.portador_nome}, que levou a bolsa.` }); return }
      retSet({ step: 'sign' })
    } catch(e) { retSet({ err: e.message }) }
  }
  const retornoConfirmar = async sig => {
    const m = retornoModal
    try {
      await POST(`/portes/${m.sol.cautela_id}/retorno`, { email: m.email, senha: m.senha, assinatura: sig, motivo: [m.motivo, m.detalhe.trim()].filter(Boolean).join(' — ') })
      addToast('Bolsa de volta ao almoxarifado — está de novo em "Pronto p/ retirada".', 'success')
      setRetornoModal(null); load()
    } catch(e) { retSet({ err: e.message, step: 'form' }) }
  }
  const verTermoPorte = async cautelaId => {
    try {
      const { html } = await GET(`/cautelas/${cautelaId}/termo/porte`)
      const w = window.open('', '_blank', 'width=900,height=700,scrollbars=yes')
      w.document.write(html); w.document.close()
    } catch(e) { addToast(e.message, 'error') }
  }

  // Divide por status para almoxarife (kanban). Vindo de um card do painel, só o filtrado.
  const visiveis     = lista.filter(s => solNoFiltro(s, filtro))
  const solicitadas  = visiveis.filter(s => s.status === 'solicitada')
  const separando    = visiveis.filter(s => s.status === 'separando')
  const prontas      = visiveis.filter(s => s.status === 'pronta')
  const prontasBalcao = prontas.filter(s => !s.porte)   // esperando quem retira no balcão
  // Apontador designado para levar (pedido do operário que não consegue vir).
  const chipLeva = s => s.portador_nome ? <div style={{display:'flex',alignItems:'center',gap:5,fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}><Icon name="truck" size={13}/> Leva: <strong style={{color:'var(--text)'}}>{s.portador_nome}</strong></div> : null
  const comApontador  = prontas.filter(s => s.porte)    // saiu com o apontador, falta o recebimento assinado
  const historico    = visiveis.filter(s => SOL_ENCERRADAS.includes(s.status))
  const [historicoTela, fimHistorico] = useAosPoucos(historico)
  const [visiveisTela, fimVisiveis] = useAosPoucos(visiveis)
  const faixaFiltro  = <FiltroPainel filtro={filtro} n={visiveis.length} onLimpar={()=>setFiltro(null)} />

  if (user.role === 'almoxarifado') return (
    <div>
      <div className="topbar">
        <h2>Fila de Solicitações</h2>
        <button className="btn btn-accent" onClick={abrirPorOpModal}><Icon name="clipboard" size={16}/> Solicitar por Operário</button>
      </div>
      {faixaFiltro}
      <div className={`kanban${comApontador.length ? ' kanban-4' : ''}`}>
        {/* Coluna: Solicitadas */}
        <div className="kanban-col">
          <h4><span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="inbox" size={16}/> Novas</span> <span className="kanban-count">{solicitadas.length}</span></h4>
          {solicitadas.map(s=>(
            <div key={s.id} className="kanban-card">
              <div className="kc-numero">{s.numero} {(s.assinatura_solicitante || s.portador_id) && <span style={{fontSize:'.65rem',background:'var(--fill-steel)',color:'#fff',borderRadius:4,padding:'1px 5px',marginLeft:4}}>Direto</span>}</div>
              <div className="kc-lider" style={{display:'flex',alignItems:'center',gap:5}}><Icon name="worker" size={13}/> {s.lider_nome}{(s.assinatura_solicitante || s.portador_id) && <span style={{fontSize:'.7rem',color:'var(--text-secondary)',marginLeft:4}}>(operário)</span>}{tagSol(s)}</div>
              <div className="kc-valor">{fmtBRL(s.valor_total)} · {s.itens.length} item(ns)</div>
              {chipLeva(s)}
              <div className="kc-actions">
                <button className="btn btn-primary btn-sm" onClick={()=>avancar(s.id,'separando')}>Iniciar separação</button>
                <button className="btn btn-ghost btn-sm" onClick={()=>setDetalhe(s)}><Icon name="eye" size={14}/> Ver</button>
              </div>
            </div>
          ))}
          {!solicitadas.length && <p className="text-muted" style={{fontSize:'.82rem',textAlign:'center',padding:12}}>Nenhuma</p>}
        </div>
        {/* Coluna: Separando */}
        <div className="kanban-col">
          <h4><span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="package" size={16}/> Separando</span> <span className="kanban-count">{separando.length}</span></h4>
          {separando.map(s=>(
            <div key={s.id} className="kanban-card">
              <div className="kc-numero">{s.numero} {(s.assinatura_solicitante || s.portador_id) && <span style={{fontSize:'.65rem',background:'var(--fill-steel)',color:'#fff',borderRadius:4,padding:'1px 5px',marginLeft:4}}>Direto</span>}</div>
              <div className="kc-lider" style={{display:'flex',alignItems:'center',gap:5}}><Icon name="worker" size={13}/> {s.lider_nome}{(s.assinatura_solicitante || s.portador_id) && <span style={{fontSize:'.7rem',color:'var(--text-secondary)',marginLeft:4}}>(operário)</span>}{tagSol(s)}</div>
              <div className="kc-valor">{fmtBRL(s.valor_total)}</div>
              {chipLeva(s)}
              <div className="kc-actions">
                <button className="btn btn-success btn-sm" onClick={()=>avancar(s.id,'pronta')}><Icon name="checkCircle" size={14}/> Pronto</button>
                <button className="btn btn-ghost btn-sm" onClick={()=>abrirEditItens(s)}><Icon name="edit" size={14}/> Editar lista</button>
                <button className="btn btn-ghost btn-sm" onClick={()=>setDetalhe(s)}><Icon name="eye" size={14}/> Ver</button>
              </div>
            </div>
          ))}
          {!separando.length && <p className="text-muted" style={{fontSize:'.82rem',textAlign:'center',padding:12}}>Nenhuma</p>}
        </div>
        {/* Coluna: Prontas */}
        <div className="kanban-col">
          <h4><span style={{display:'inline-flex',alignItems:'center',gap:6}}><span style={{width:8,height:8,borderRadius:'50%',background:'var(--success)',display:'inline-block'}}/> Pronto p/ retirada</span> <span className="kanban-count">{prontasBalcao.length}</span></h4>
          {prontasBalcao.map(s=>(
            <div key={s.id} className="kanban-card">
              <div className="kc-numero">{s.numero} {(s.assinatura_solicitante || s.portador_id) && <span style={{fontSize:'.65rem',background:'var(--fill-steel)',color:'#fff',borderRadius:4,padding:'1px 5px',marginLeft:4}}>Direto</span>}</div>
              <div className="kc-lider" style={{display:'flex',alignItems:'center',gap:5}}><Icon name="worker" size={13}/> {s.lider_nome}{(s.assinatura_solicitante || s.portador_id) && <span style={{fontSize:'.7rem',color:'var(--text-secondary)',marginLeft:4}}>(operário)</span>}{tagSol(s)}</div>
              <div className="kc-valor">{fmtBRL(s.valor_total)}</div>
              {chipLeva(s)}
              <div className="kc-actions">
                {s.portador_id && s.cautela_id
                  ? <button className="btn btn-accent btn-sm" onClick={()=>abrirPorte(s)}><Icon name="truck" size={14}/> Entregar ao apontador</button>
                  : <button className="btn btn-accent btn-sm" onClick={()=>iniciarRetirada(s)}><Icon name="signature" size={14}/> Registrar retirada</button>}
                {s.portador_id
                  ? <button className="btn btn-ghost btn-sm" onClick={()=>iniciarRetirada(s)} title="O operário veio buscar pessoalmente"><Icon name="signature" size={14}/> No balcão</button>
                  : (apontadores.length > 0 && s.cautela_id && <button className="btn btn-ghost btn-sm" onClick={()=>abrirPorte(s)} title="O operário não pode vir: o apontador leva"><Icon name="truck" size={14}/> Pelo apontador</button>)}
                <button className="btn btn-ghost btn-sm" onClick={()=>setDetalhe(s)}><Icon name="eye" size={14}/> Ver</button>
              </div>
            </div>
          ))}
          {!prontasBalcao.length && <p className="text-muted" style={{fontSize:'.82rem',textAlign:'center',padding:12}}>Nenhuma</p>}
        </div>
        {/* Coluna: com o apontador — saiu assinada, falta o operário assinar o recebimento na obra */}
        {comApontador.length > 0 && (
          <div className="kanban-col">
            <h4><span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="truck" size={16}/> Com o apontador</span> <span className="kanban-count">{comApontador.length}</span></h4>
            {comApontador.map(s=>(
              <div key={s.id} className="kanban-card">
                <div className="kc-numero">{s.numero} {(s.assinatura_solicitante || s.portador_id) && <span style={{fontSize:'.65rem',background:'var(--fill-steel)',color:'#fff',borderRadius:4,padding:'1px 5px',marginLeft:4}}>Direto</span>}</div>
                <div className="kc-lider" style={{display:'flex',alignItems:'center',gap:5}}><Icon name="worker" size={13}/> {s.lider_nome}<span style={{fontSize:'.7rem',color:'var(--text-secondary)',marginLeft:4}}>(destino)</span>{tagSol(s)}</div>
                <div className="kc-valor">{fmtBRL(s.valor_total)}</div>
                <div style={{display:'flex',alignItems:'center',gap:5,fontSize:'.75rem',color:'var(--text-secondary)',marginTop:2}}><Icon name="truck" size={13}/> <strong style={{color:'var(--text)'}}>{s.porte.portador_nome}</strong> · saiu {tlHora(s.porte.desde)}</div>
                <div className="kc-actions">
                  <button className="btn btn-ghost btn-sm" onClick={()=>abrirRetorno(s)} title="O apontador trouxe a bolsa de volta sem entregar"><Icon name="undo" size={14}/> Voltou sem entregar</button>
                  <button className="btn btn-ghost btn-sm" onClick={()=>verTermoPorte(s.cautela_id)}><Icon name="fileText" size={14}/> Termo</button>
                  <button className="btn btn-ghost btn-sm" onClick={()=>setDetalhe(s)}><Icon name="eye" size={14}/> Ver</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Histórico */}
      {historico.length > 0 && (
        <div className="card">
          <div className="card-header"><span className="card-title">Histórico</span></div>
          <div className="table-wrap"><table className="cards-mobile">
            <thead><tr><th>Número</th><th>Líder</th><th>Data</th><th>Status</th><th>Ações</th></tr></thead>
            <tbody>{historicoTela.map(s=>(
              <tr key={s.id}>
                <td className="fw-bold" data-label="Número">{s.numero}</td>
                <td data-label="Líder">{s.lider_nome}{tagSol(s)}</td>
                <td data-label="Data">{fmt(s.criado_em)}</td>
                <td data-label="Status"><span className={`badge badge-${s.status}`}>{STATUS_LABEL[s.status]}</span></td>
                <td data-label="Ações">
                  {s.status === 'retirada' && !user.admin
                    ? <button className="btn btn-ghost btn-sm" title="Desfazer esta retirada (lançamento errado)" onClick={()=>abrirEstorno(s)} style={{display:'inline-flex',alignItems:'center',gap:5,color:'var(--danger)'}}><Icon name="undo" size={14}/> Estornar</button>
                    : <span className="text-muted" style={{fontSize:'.78rem'}}>—</span>}
                </td>
              </tr>
            ))}</tbody>
          </table></div>{fimHistorico}
        </div>
      )}

      {/* Modal estorno de retirada */}
      {estornoAlvo && (
        <div className="modal-overlay open">
          <div className="modal modal-sm">
            <div className="modal-header">
              <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="undo" size={17}/> Estornar retirada {estornoAlvo.numero}</h3>
              <button className="modal-close" onClick={()=>setEstornoAlvo(null)}>×</button>
            </div>
            <div className="modal-body">
              <div className="alert alert-warning" style={{marginBottom:12}}>
                Isto <strong>desfaz</strong> a retirada de <strong>{estornoAlvo.lider_nome}</strong> ({fmtBRL(estornoAlvo.valor_total)} · {estornoAlvo.itens.length} item(ns)). As ferramentas voltam ao estoque disponível.
              </div>
              <div className="form-group">
                <label>Motivo (opcional)</label>
                <input type="text" value={estornoMotivo} onChange={e=>setEstornoMotivo(e.target.value)} placeholder="Ex.: lançamento em duplicidade" />
              </div>
              {user.is_master && (
                <label style={{display:'flex',alignItems:'flex-start',gap:8,marginTop:8,cursor:'pointer',fontSize:'.86rem'}}>
                  <input type="checkbox" checked={estornoExcluir} onChange={e=>setEstornoExcluir(e.target.checked)} style={{marginTop:3}} />
                  <span>Excluir o registro por completo (não deixa histórico). Sem marcar, a solicitação fica registrada como <strong>Estornada</strong> para auditoria.</span>
                </label>
              )}
              <div style={{marginTop:16,display:'flex',gap:8,justifyContent:'flex-end'}}>
                <button className="btn btn-ghost" onClick={()=>setEstornoAlvo(null)} disabled={estornoLoading}>Cancelar</button>
                <button className={`btn ${estornoExcluir ? 'btn-danger' : 'btn-primary'}`} onClick={confirmarEstorno} disabled={estornoLoading}>
                  {estornoLoading ? 'Processando...' : (estornoExcluir ? 'Excluir definitivamente' : 'Confirmar estorno')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal detalhe */}
      {detalhe && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header"><h3>Solicitação {detalhe.numero}</h3><button className="modal-close" onClick={()=>setDetalhe(null)}>×</button></div>
            <div className="modal-body">
              <p><strong>{(detalhe.assinatura_solicitante || detalhe.portador_id) ? 'Operário' : 'Líder'}:</strong> {detalhe.lider_nome} ({detalhe.lider_email})</p>
              {ct.multi && <p style={{marginTop:8}}><strong>Contrato:</strong> {ct.nome(ct.de({ contrato_id: detalhe.lider_contrato_id }))}</p>}
              {detalhe.portador_nome && <p style={{marginTop:8,display:'flex',alignItems:'center',gap:6}}><Icon name="truck" size={14}/> <span><strong>Leva:</strong> apontador {detalhe.portador_nome}{detalhe.porte ? ` — com ele desde ${tlHora(detalhe.porte.desde)}` : ''}</span></p>}
              {!detalhe.portador_nome && detalhe.porte && <p style={{marginTop:8,display:'flex',alignItems:'center',gap:6}}><Icon name="truck" size={14}/> <span>Com o apontador {detalhe.porte.portador_nome} desde {tlHora(detalhe.porte.desde)}</span></p>}
              {detalhe.bolsa_nome && <p style={{marginTop:8}}><strong>Bolsa:</strong> {detalhe.bolsa_nome}</p>}
              {detalhe.obs && <p style={{marginTop:8}} className="text-muted">Obs: {detalhe.obs}</p>}
              <hr className="divider" />
              <p className="fw-bold" style={{marginBottom:8}}>Itens solicitados</p>
              <div className="items-list">
                {detalhe.itens.map(i=>(
                  <div key={i.id} className="item-row">
                    <span>{i.ferramenta_nome}</span>
                    <span><strong>{i.quantidade}x</strong></span>
                    <span style={{color:'var(--success)',fontSize:'.82rem'}}>{fmtBRL(i.valor_unitario||0)}</span>
                    <span style={{fontWeight:600}}>{fmtBRL(i.valor_item||0)}</span>
                  </div>
                ))}
                <div style={{padding:'8px 12px',background:'rgba(46,125,107,.08)',fontWeight:700,display:'flex',justifyContent:'flex-end',gap:8}}>
                  <span className="text-muted">Total:</span><span style={{color:'var(--success)'}}>{fmtBRL(detalhe.valor_total)}</span>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {!user.admin && ['solicitada','separando','pronta'].includes(detalhe.status) && !detalhe.porte &&
                <button className="btn btn-ghost" style={{color:'var(--danger)',marginRight:'auto'}} onClick={()=>cancelar(detalhe)}><Icon name="x" size={14}/> Cancelar solicitação</button>}
              <button className="btn btn-ghost" onClick={()=>setDetalhe(null)}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar Itens (separando) */}
      {editItensModal && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header">
              <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="edit" size={17}/> Editar itens — {editItensModal.numero}</h3>
              <button className="modal-close" onClick={()=>setEditItensModal(null)}>×</button>
            </div>
            <div className="modal-body">
              {editItensErr && <div className="alert alert-error" style={{marginBottom:12}}>{editItensErr}</div>}

              {/* Lista atual */}
              <p className="fw-bold" style={{marginBottom:8,fontSize:'.85rem'}}>Itens do pedido</p>
              <div style={{display:'flex',flexDirection:'column',gap:6,marginBottom:16}}>
                {editItens.map(i => (
                  <div key={i.ferramenta_id} style={{display:'flex',alignItems:'center',gap:10,background:'var(--bg)',borderRadius:6,padding:'8px 12px'}}>
                    <span style={{flex:1,fontSize:'.88rem'}}>{i.ferramenta_nome}</span>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <label style={{fontSize:'.75rem',color:'var(--text-secondary)'}}>Qtd:</label>
                      <input type="number" min="1" value={i.quantidade}
                        onChange={e=>alterarQtdEdit(i.ferramenta_id, e.target.value)}
                        style={{width:60,padding:'3px 6px',fontSize:'.85rem'}} />
                    </div>
                    <button onClick={()=>removeItemEdit(i.ferramenta_id)}
                      style={{background:'none',border:'none',cursor:'pointer',color:'var(--danger)',padding:'0 4px',display:'inline-flex',alignItems:'center'}}
                      title="Remover item"><Icon name="x" size={15}/></button>
                  </div>
                ))}
                {editItens.length === 0 && <p className="text-muted" style={{textAlign:'center',padding:8}}>Nenhum item.</p>}
              </div>

              {/* Itens removidos */}
              {editItensRemovidos.length > 0 && (<>
                <hr className="divider" />
                <p className="fw-bold" style={{marginBottom:8,fontSize:'.85rem',color:'var(--danger)',display:'flex',alignItems:'center',gap:6}}><Icon name="trash" size={14}/> Itens removidos</p>
                <div style={{display:'flex',flexDirection:'column',gap:6,marginBottom:16}}>
                  {editItensRemovidos.map(i => (
                    <div key={i.ferramenta_id} style={{display:'flex',alignItems:'center',gap:10,background:'var(--tag-perigo-bg)',borderRadius:6,padding:'8px 12px',border:'1px solid var(--tag-perigo-bd)'}}>
                      <span style={{flex:1,fontSize:'.88rem',color:'var(--danger)',textDecoration:'line-through'}}>{i.ferramenta_nome}</span>
                      <span style={{fontSize:'.8rem',color:'var(--text-secondary)'}}>{i.quantidade}x</span>
                      <button onClick={()=>restaurarItemEdit(i.ferramenta_id)}
                        style={{background:'none',border:'1px solid var(--success)',borderRadius:4,cursor:'pointer',color:'var(--success)',fontSize:'.75rem',padding:'2px 8px',display:'inline-flex',alignItems:'center',gap:4}}>
                        <Icon name="undo" size={12}/> Restaurar
                      </button>
                    </div>
                  ))}
                </div>
              </>)}

              {/* Adicionar item */}
              <hr className="divider" />
              <p className="fw-bold" style={{marginBottom:8,fontSize:'.85rem'}}>Adicionar item{ct.multi && <span className="text-muted" style={{fontWeight:400}}> · acervo de {ct.nome(ct.de({ contrato_id: editItensModal.lider_contrato_id }))}</span>}</p>
              <div style={{display:'flex',gap:8,alignItems:'flex-end'}}>
                <div className="form-group" style={{flex:1,marginBottom:0}}>
                  <select value={editSelFerr} onChange={e=>setEditSelFerr(e.target.value)}>
                    <option value="">Selecione a ferramenta...</option>
                    {acervoEdit.map(f=><option key={f.id} value={f.id}>{f.nome}</option>)}
                  </select>
                </div>
                <div style={{width:70}}>
                  <input type="number" min="1" value={editSelQtd}
                    onChange={e=>setEditSelQtd(Math.max(1,parseInt(e.target.value)||1))}
                    style={{padding:'6px 8px',fontSize:'.85rem',width:'100%'}} />
                </div>
                <button className="btn btn-primary btn-sm" onClick={addItemToEdit} disabled={!editSelFerr}><Icon name="plus" size={14}/> Add</button>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setEditItensModal(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvarEditItens} disabled={editItensLoading || !editItens.length}>
                {editItensLoading ? 'Salvando...' : <span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="save" size={14}/> Salvar lista</span>}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Solicitar por Operário */}
      {porOpModal && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header">
              <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="clipboard" size={17}/> Solicitar por Operário</h3>
              <button className="modal-close" onClick={()=>setPorOpModal(false)}>×</button>
            </div>
            <div className="modal-body">
              {porOpStep === 'form' && (
                <>
                  {apontadores.length > 0 && (
                    <div className="form-group" style={{marginBottom:12}}>
                      <label>Quem retira a bolsa?</label>
                      <div style={{display:'flex',gap:8,marginTop:6,flexWrap:'wrap'}}>
                        <button className={`btn btn-sm ${porOpModo==='presente' ? 'btn-primary' : 'btn-ghost'}`} onClick={()=>{setPorOpModo('presente'); setPorOpErr('')}} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="worker" size={14}/> O operário, aqui no balcão</button>
                        <button className={`btn btn-sm ${porOpModo==='apontador' ? 'btn-primary' : 'btn-ghost'}`} onClick={()=>{setPorOpModo('apontador'); setPorOpErr('')}} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="truck" size={14}/> O apontador leva até a obra</button>
                      </div>
                    </div>
                  )}
                  <div className="alert alert-info" style={{marginBottom:16}}>
                    {porOpModo === 'apontador'
                      ? 'O operário não consegue vir. Quando a bolsa ficar pronta, o apontador assina a saída aqui e leva; na obra, o operário confirma o CPF do cadastro (não precisa de login) e assina o recebimento no aparelho do apontador.'
                      : 'O operário está presente no almoxarifado. Selecione-o, escolha a bolsa ou itens, e na próxima etapa ele assina neste dispositivo.'}
                  </div>
                  {porOpErr && <div className="alert alert-error" style={{marginBottom:12}}>{porOpErr}</div>}
                  <div className="form-group">
                    <label>Operário *</label>
                    <select value={porOpOperario} onChange={e=>escolherOperarioPorOp(e.target.value)}>
                      <option value="">Selecione o operário...</option>
                      {ct.multi
                        ? ct.contratos.filter(c => operarios.some(o => ct.de(o) === c.id)).map(c => (
                            <optgroup key={c.id} label={c.nome}>
                              {operarios.filter(o => ct.de(o) === c.id).map(o=><option key={o.id} value={o.id}>{o.nome} {o.cargo ? `— ${o.cargo}` : ''}</option>)}
                            </optgroup>))
                        : operarios.map(o=><option key={o.id} value={o.id}>{o.nome} {o.cargo ? `— ${o.cargo}` : ''}</option>)}
                    </select>
                    {ct.multi && ctPorOp && <p className="text-muted" style={{fontSize:'.75rem',marginTop:4}}><span style={{display:'inline-block',width:8,height:8,borderRadius:2,background:ct.cor(ctPorOp),marginRight:6}}/>Contrato <strong>{ct.nome(ctPorOp)}</strong> — bolsas e itens abaixo são do acervo dele.</p>}
                  </div>
                  {porOpModo === 'apontador' && (
                    <div className="form-group" style={{marginTop:12}}>
                      <label>Apontador que vai levar *</label>
                      <select value={porOpPortador} onChange={e=>setPorOpPortador(e.target.value)}>
                        <option value="">Selecione o apontador...</option>
                        {apontadores.map(opcaoApontador)}
                      </select>
                    </div>
                  )}
                  <div className="form-group" style={{marginTop:12}}>
                    <label>Tipo de solicitação</label>
                    <div style={{display:'flex',gap:8,marginTop:6}}>
                      <button className={`btn btn-sm ${porOpTipo==='bolsa' ? 'btn-primary' : 'btn-ghost'}`} onClick={()=>setPorOpTipo('bolsa')} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="backpack" size={14}/> Por Bolsa</button>
                      <button className={`btn btn-sm ${porOpTipo==='itens' ? 'btn-primary' : 'btn-ghost'}`} onClick={()=>setPorOpTipo('itens')} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="wrench" size={14}/> Itens avulsos</button>
                    </div>
                  </div>
                  {porOpTipo === 'bolsa' && (
                    <div className="form-group" style={{marginTop:12}}>
                      <label>Bolsa *</label>
                      <select value={porOpBolsaId} onChange={e=>selecionarBolsaPorOp(e.target.value)} disabled={ct.multi && !ctPorOp}>
                        <option value="">{ct.multi && !ctPorOp ? 'Escolha o operário primeiro...' : 'Selecione a bolsa...'}</option>
                        {bolsasPorOp.map(b=><option key={b.id} value={b.id}>{b.nome}</option>)}
                      </select>
                      {ct.multi && ctPorOp && !bolsasPorOp.length && <p className="text-muted" style={{fontSize:'.75rem',marginTop:4}}>{acervoPorOp.length
                        ? <>Nenhum kit montado com o acervo de <strong>{ct.nome(ctPorOp)}</strong>: use <b>Itens avulsos</b> ou monte o kit em Bolsas / Kits.</>
                        : <>O acervo de <strong>{ct.nome(ctPorOp)}</strong> ainda não tem ferramentas: cadastre-as em Ferramentas, nesse contrato.</>}</p>}
                      {porOpBolsaId && <p className="text-muted" style={{fontSize:'.75rem',marginTop:4}}>Itens da bolsa abaixo — remova o que estiver sem estoque para prosseguir.</p>}
                    </div>
                  )}
                  {porOpTipo === 'itens' && (
                    <div style={{marginTop:12,display:'flex',gap:8,alignItems:'flex-end'}}>
                      <div className="form-group" style={{flex:1,marginBottom:0}}>
                        <label>Ferramenta</label>
                        <select value={porOpSelFerr} onChange={e=>setPorOpSelFerr(e.target.value)} disabled={ct.multi && !ctPorOp}>
                          <option value="">{ct.multi && !ctPorOp ? 'Escolha o operário primeiro...' : 'Selecione...'}</option>
                          {acervoPorOp.map(f=>{const d=dispPorOp(f.id); return <option key={f.id} value={f.id} disabled={d<=0}>{f.nome}{f.codigo?` (${f.codigo})`:''} — {d>0?`${d} disp.`:'sem estoque'}</option>})}
                        </select>
                      </div>
                      <div className="form-group" style={{width:72,marginBottom:0}}>
                        <label>Qtd</label>
                        <input type="number" min="1" value={porOpSelQtd} onChange={e=>setPorOpSelQtd(parseInt(e.target.value)||1)} />
                      </div>
                      <button className="btn btn-primary btn-sm" style={{marginBottom:0,height:38}} onClick={addItemPorOp}><Icon name="plus" size={14}/> Add</button>
                    </div>
                  )}
                  {porOpTipo === 'itens' && ct.multi && ctPorOp && !acervoPorOp.length && <p className="text-muted" style={{fontSize:'.75rem',marginTop:4}}>O acervo de <strong>{ct.nome(ctPorOp)}</strong> ainda não tem ferramentas: cadastre-as em Ferramentas, nesse contrato.</p>}
                  {porOpItens.length > 0 && (
                    <div style={{marginTop:12}}>
                      {itensSemEstoquePorOp().length > 0 && (
                        <div className="alert alert-warning" style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,flexWrap:'wrap',margin:'0 0 8px',padding:'8px 12px'}}>
                          <span style={{display:'inline-flex',alignItems:'center',gap:8,fontSize:'.85rem'}}><Icon name="alertTriangle" size={15}/> Itens em vermelho estão sem estoque suficiente.</span>
                          <button className="btn btn-danger btn-sm" type="button" onClick={removerIndisponiveisPorOp}><Icon name="trash" size={13}/> Remover indisponíveis</button>
                        </div>
                      )}
                      <div style={{background:'var(--bg)',borderRadius:8,padding:'2px 12px'}}>
                        {porOpItens.map((it,i)=>{ const d=Math.max(0,dispPorOp(it.ferramenta_id)); const falta=it.quantidade>dispPorOp(it.ferramenta_id); return (
                          <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,fontSize:'.85rem',padding:'8px 0',borderBottom:i===porOpItens.length-1?'none':'1px solid var(--border)'}}>
                            <span style={{minWidth:0}}>{it.nome}{codigoPorOp(it.ferramenta_id) && <span title="Código de patrimônio — confira no item físico" style={{fontSize:'.68rem',fontWeight:700,color:'var(--primary-accent)',border:'1px solid var(--border)',background:'var(--surface)',borderRadius:6,padding:'1px 6px',marginLeft:6,whiteSpace:'nowrap'}}>{codigoPorOp(it.ferramenta_id)}</span>}<span className="text-muted" style={{fontSize:'.72rem'}}> · {d} disp.</span>{falta && <span style={{color:'var(--danger)',fontSize:'.72rem',fontWeight:700}}> — sem estoque</span>}</span>
                            <span style={{display:'flex',gap:8,alignItems:'center',flexShrink:0}}>
                              <input type="number" min="1" value={it.quantidade} onChange={e=>setQtdPorOp(i,e.target.value)} style={{width:56,padding:'4px 6px',fontSize:'.82rem',borderColor:falta?'var(--danger)':undefined}} />
                              <button title="Remover item" style={{background:'none',border:'none',cursor:'pointer',color:'var(--danger)',padding:0,display:'inline-flex',alignItems:'center'}} onClick={()=>setPorOpItens(porOpItens.filter((_,j)=>j!==i))}><Icon name="trash" size={14}/></button>
                            </span>
                          </div>
                        )})}
                      </div>
                    </div>
                  )}
                  <div className="form-group" style={{marginTop:12}}>
                    <label>Observação</label>
                    <input type="text" value={porOpObs} onChange={e=>setPorOpObs(e.target.value)} placeholder="Opcional..." />
                  </div>
                  <div style={{marginTop:16,textAlign:'right'}}>
                    {porOpModo === 'apontador'
                      ? <button className="btn btn-primary" onClick={avancarParaAssinatura} disabled={porOpLoading}>{porOpLoading ? 'Criando...' : 'Criar solicitação →'}</button>
                      : <button className="btn btn-primary" onClick={avancarParaAssinatura}>Próximo: Assinatura do Operário →</button>}
                  </div>
                </>
              )}
              {porOpStep === 'sign' && (
                <>
                  <div className="auth-device-box">
                    <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={16}/> {operarios.find(o=>o.id==porOpOperario)?.nome || 'Operário'} — confirme seu acesso</h4>
                    <p style={{fontSize:'.82rem',color:'var(--text-secondary)',marginBottom:12}}>
                      {porOpTipo==='bolsa'
                        ? `Bolsa ${bolsasLista.find(b=>b.id==porOpBolsaId)?.nome || '—'} · ${porOpItens.length} item(ns)`
                        : `${porOpItens.length} item(ns) avulso(s)`}
                      {porOpObs && ` · Obs: ${porOpObs}`}
                    </p>
                    {porOpItens.length > 0 && (
                      <div style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:8,padding:'6px 12px',marginBottom:12}}>
                        <div style={{fontSize:'.72rem',fontWeight:700,color:'var(--text-secondary)',textTransform:'uppercase',letterSpacing:'.04em',padding:'2px 0 6px'}}>Confira os itens que está retirando</div>
                        {porOpItens.map((it,i)=>(
                          <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,fontSize:'.85rem',padding:'6px 0',borderTop:'1px solid var(--border)'}}>
                            <span style={{minWidth:0}}>{it.nome}{codigoPorOp(it.ferramenta_id) && <span title="Código de patrimônio — confira no item físico" style={{fontSize:'.68rem',fontWeight:700,color:'var(--primary-accent)',border:'1px solid var(--border)',background:'var(--bg)',borderRadius:6,padding:'1px 6px',marginLeft:6,whiteSpace:'nowrap'}}>{codigoPorOp(it.ferramenta_id)}</span>}</span>
                            <span style={{flexShrink:0,fontWeight:700}}>{it.quantidade}×</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {porOpAuthErr && <div className="alert alert-error" style={{marginBottom:10}}>{porOpAuthErr}</div>}
                    <div className="form-grid">
                      <div className="form-group">
                        <label>Email</label>
                        <input type="email" value={porOpAuthEmail} onChange={e=>setPorOpAuthEmail(e.target.value)}
                          placeholder={operarios.find(o=>o.id==porOpOperario)?.email || 'seu@email.com'} />
                      </div>
                      <div className="form-group">
                        <label>Senha</label>
                        <input type="password" value={porOpAuthSenha} onChange={e=>setPorOpAuthSenha(e.target.value)}
                          placeholder="••••••••" onKeyDown={e=>e.key==='Enter'&&confirmarPorOperario()} />
                      </div>
                    </div>
                    <div style={{marginTop:12,display:'flex',gap:8,justifyContent:'flex-end'}}>
                      <button className="btn btn-ghost" onClick={()=>setPorOpStep('form')}>← Voltar</button>
                      <button className="btn btn-primary" onClick={confirmarPorOperario} disabled={porOpLoading}>
                        {porOpLoading ? 'Autenticando...' : 'Confirmar →'}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal saída pelo apontador — ele autentica e assina neste dispositivo, uma vez para todas as bolsas */}
      {porteModal && (() => {
        const ap = apontadores.find(a => String(a.id) === String(porteModal.portadorId))
        const sel = prontasBalcao.filter(x => porteModal.sel.includes(x.cautela_id))
        const total = sel.reduce((t, x) => t + (x.valor_total || 0), 0)
        return (
          <div className="modal-overlay open">
            <div className="modal modal-md">
              <div className="modal-header">
                <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="truck" size={17}/> Retirada pelo apontador</h3>
                <button className="modal-close" onClick={()=>setPorteModal(null)}>×</button>
              </div>
              <div className="modal-body">
                {porteModal.err && <div className="alert alert-error" style={{marginBottom:12,display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {porteModal.err}</div>}
                {porteModal.step === 'form' && (<>
                  <div className="alert alert-info" style={{marginBottom:14}}>Para o operário que não consegue vir ao almoxarifado. O apontador assina a saída aqui e responde pela bolsa até o operário assinar o recebimento no aparelho dele, na obra.</div>
                  <div className="form-group">
                    <label>Apontador que vai levar *</label>
                    <select value={porteModal.portadorId} onChange={e=>trocarPortador(e.target.value)}>
                      <option value="">Selecione o apontador...</option>
                      {apontadores.map(opcaoApontador)}
                    </select>
                    {!apontadores.length && <p className="text-muted" style={{fontSize:'.75rem',marginTop:4}}>Nenhum apontador ativo. Cadastre em Usuários com o perfil Apontador.</p>}
                  </div>
                  <p className="fw-bold" style={{margin:'14px 0 8px',fontSize:'.85rem'}}>Bolsas que ele leva agora</p>
                  <div style={{display:'flex',flexDirection:'column',gap:6}}>
                    {prontasBalcao.filter(x => x.cautela_id).map(x => { const on = porteModal.sel.includes(x.cautela_id); return (
                      <label key={x.id} className={`porte-op${on ? ' on' : ''}`}>
                        <input type="checkbox" checked={on} onChange={()=>marcarBolsa(x.cautela_id)} />
                        <span style={{flex:1,minWidth:0}}>
                          <strong>{x.lider_nome}</strong> <span className="text-muted">· {x.numero}</span>
                          <span style={{display:'block',fontSize:'.76rem',color:'var(--text-secondary)'}}>{x.bolsa_nome ? `Bolsa ${x.bolsa_nome} · ` : ''}{x.itens.length} item(ns){x.obra_nome ? ` · ${x.obra_nome}` : ''}{x.portador_nome ? ` · designada a ${x.portador_nome}` : ''}</span>
                        </span>
                        <span style={{fontWeight:600,fontSize:'.82rem',whiteSpace:'nowrap'}}>{fmtBRL(x.valor_total)}</span>
                      </label>
                    )})}
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:10,marginTop:14,flexWrap:'wrap'}}>
                    <span className="text-muted" style={{fontSize:'.82rem'}}>{sel.length} bolsa(s) · {fmtBRL(total)} sob a guarda do apontador</span>
                    <button className="btn btn-primary" onClick={porteAvancar}>Próximo: login do apontador →</button>
                  </div>
                </>)}
                {porteModal.step === 'auth' && (
                  <div className="auth-device-box">
                    <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={16}/> {ap ? ap.nome : 'Apontador'} — confirme seu acesso</h4>
                    <p style={{fontSize:'.82rem',color:'var(--text-secondary)',marginBottom:12}}>{sel.length} bolsa(s) · {fmtBRL(total)}</p>
                    <div className="form-grid">
                      <div className="form-group"><label>Email</label><input type="email" value={porteModal.email} onChange={e=>porteSet({ email: e.target.value })} placeholder={ap ? ap.email : 'seu@email.com'} /></div>
                      <div className="form-group"><label>Senha</label><input type="password" value={porteModal.senha} onChange={e=>porteSet({ senha: e.target.value })} placeholder="••••••••" onKeyDown={e=>e.key==='Enter'&&porteValidar()} /></div>
                    </div>
                    <div style={{marginTop:12,display:'flex',gap:8,justifyContent:'flex-end'}}>
                      <button className="btn btn-ghost" onClick={()=>porteSet({ step: 'form', err: '' })}>← Voltar</button>
                      <button className="btn btn-primary" onClick={porteValidar}>Autenticar →</button>
                    </div>
                  </div>
                )}
                {porteModal.step === 'termo' && (<>
                  <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="checkCircle" size={16}/> Autenticado como {ap ? ap.nome : 'apontador'}. Leia antes de assinar.</div>
                  <div style={{border:'2px solid var(--primary-text)',borderRadius:8,maxHeight:380,overflowY:'auto',padding:16,background:'var(--surface-alt)',marginBottom:16,fontSize:'.84rem',lineHeight:1.6}}>
                    <p style={{fontWeight:700,marginBottom:6}}>Termo de transporte e guarda</p>
                    <p>Eu, <strong>{ap ? ap.nome : 'apontador'}</strong>, recebo do almoxarifado da {empresaInfo.razaoSocial} as bolsas abaixo para entregar aos destinatários. Respondo pela guarda e integridade dos itens até que cada destinatário confirme quem é e assine o recebimento no meu aparelho, ou até devolvê-los ao almoxarifado com a minha assinatura. Comunico imediatamente qualquer extravio, dano ou impossibilidade de entrega.</p>
                    {sel.map(x => (
                      <div key={x.id} style={{marginTop:10,paddingTop:8,borderTop:'1px solid var(--border)'}}>
                        <div style={{display:'flex',justifyContent:'space-between',gap:8}}><strong>{x.numero} → {x.lider_nome}</strong><span style={{whiteSpace:'nowrap'}}>{fmtBRL(x.valor_total)}</span></div>
                        <div style={{fontSize:'.78rem',color:'var(--text-secondary)'}}>{x.itens.map(i => `${i.ferramenta_nome}${i.codigo ? ` (${i.codigo})` : ''} × ${i.quantidade}`).join(' · ')}</div>
                      </div>
                    ))}
                    <div style={{marginTop:10,paddingTop:8,borderTop:'2px solid var(--border)',display:'flex',justifyContent:'space-between',fontWeight:700}}><span>TOTAL SOB MINHA GUARDA</span><span>{fmtBRL(total)}</span></div>
                  </div>
                  <div style={{textAlign:'right'}}>
                    <button className="btn btn-primary" onClick={()=>porteSet({ step: 'sign', err: '' })} style={{display:'inline-flex',alignItems:'center',gap:6}}>Li e concordo → Assinar <Icon name="signature" size={14}/></button>
                  </div>
                </>)}
                {porteModal.step === 'sign' && (
                  <SignaturePad label={`Assinatura de ${ap ? ap.nome : 'apontador'} (saída do almoxarifado)`} onConfirm={porteConfirmar} onCancel={()=>porteSet({ step: 'termo' })} />
                )}
              </div>
            </div>
          </div>
        )
      })()}

      {/* Modal voltou sem entrega — o apontador devolve a bolsa com login, motivo e assinatura */}
      {retornoModal && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header">
              <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="undo" size={17}/> Voltou sem entrega — {retornoModal.sol.numero}</h3>
              <button className="modal-close" onClick={()=>setRetornoModal(null)}>×</button>
            </div>
            <div className="modal-body">
              {retornoModal.err && <div className="alert alert-error" style={{marginBottom:12,display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {retornoModal.err}</div>}
              {retornoModal.step === 'form' && (<>
                <div className="alert alert-warning" style={{marginBottom:14}}>A bolsa de <strong>{retornoModal.sol.lider_nome}</strong> volta ao almoxarifado e fica de novo pronta para retirada. Confira os itens e peça a <strong>{retornoModal.sol.porte.portador_nome}</strong> o login e a assinatura.</div>
                <div className="form-group">
                  <label>Por que não foi entregue?</label>
                  <select value={retornoModal.motivo} onChange={e=>retSet({ motivo: e.target.value })}>
                    {MOTIVOS_RETORNO.map(m => <option key={m} value={m}>{m}</option>)}
                  </select>
                </div>
                <div className="form-group" style={{marginTop:10}}>
                  <label>Detalhe {retornoModal.motivo === 'Outro motivo' ? '*' : '(opcional)'}</label>
                  <input type="text" maxLength={200} value={retornoModal.detalhe} onChange={e=>retSet({ detalhe: e.target.value })} placeholder="Ex.: estava de atestado" />
                </div>
                <div className="auth-device-box" style={{marginTop:12}}>
                  <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={16}/> {retornoModal.sol.porte.portador_nome} — confirme seu acesso</h4>
                  <div className="form-grid">
                    <div className="form-group"><label>Email</label><input type="email" value={retornoModal.email} onChange={e=>retSet({ email: e.target.value })} placeholder={(apontadores.find(a => a.id === retornoModal.sol.porte.portador_id) || {}).email || 'seu@email.com'} /></div>
                    <div className="form-group"><label>Senha</label><input type="password" value={retornoModal.senha} onChange={e=>retSet({ senha: e.target.value })} placeholder="••••••••" onKeyDown={e=>e.key==='Enter'&&retornoValidar()} /></div>
                  </div>
                  <div style={{marginTop:12,textAlign:'right'}}>
                    <button className="btn btn-primary" onClick={retornoValidar}>Autenticar →</button>
                  </div>
                </div>
              </>)}
              {retornoModal.step === 'sign' && (
                <SignaturePad label={`Assinatura de ${retornoModal.sol.porte.portador_nome} (devolução ao almoxarifado)`} onConfirm={retornoConfirmar} onCancel={()=>retSet({ step: 'form' })} />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal retirada (auth líder no dispositivo do almoxarife) */}
      {retiradaModal && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header">
              <h3>Retirada — {retiradaModal.sol.numero}</h3>
              <button className="modal-close" onClick={()=>setRetiradaModal(null)}>×</button>
            </div>
            <div className="modal-body">
              {authStep === 'form' && (
                <>
                  <div className="alert alert-info">{retiradaModal.cautela.cautela_tipo==='direto' ? 'O operário deve autenticar neste dispositivo para confirmar a retirada.' : 'O líder deve autenticar neste dispositivo para confirmar a retirada.'}</div>
                  <div className="auth-device-box">
                    <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={16}/> Autenticação {retiradaModal.cautela.cautela_tipo==='direto' ? 'do Operário' : 'do Líder'}: {retiradaModal.sol.lider_nome}</h4>
                    {authErr && <div className="alert alert-error" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {authErr}</div>}
                    <div className="form-grid">
                      <div className="form-group"><label>Email</label><input type="email" value={authEmail} onChange={e=>setAuthEmail(e.target.value)} placeholder={retiradaModal.sol.lider_email} /></div>
                      <div className="form-group"><label>Senha</label><input type="password" value={authSenha} onChange={e=>setAuthSenha(e.target.value)} placeholder="••••••••" /></div>
                    </div>
                    <div style={{marginTop:12,textAlign:'right'}}>
                      <button className="btn btn-primary" onClick={validarLider}>Autenticar →</button>
                    </div>
                  </div>
                </>
              )}
              {authStep === 'termo' && authUser && (
                <>
                  <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="checkCircle" size={16}/> Autenticado como {authUser.nome}. Leia o Termo de {retiradaModal.cautela.cautela_tipo==='direto' ? 'Ciência' : 'Comodato'} antes de assinar.</div>
                  <div style={{border:'2px solid var(--primary-text)',borderRadius:8,maxHeight:380,overflowY:'auto',padding:16,background:'var(--surface-alt)',marginBottom:16,fontSize:'.82rem',lineHeight:1.6}}>
                    {termoHTML
                      ? <div dangerouslySetInnerHTML={{__html: termoHTML}} />
                      : <p style={{color:'var(--text-secondary)'}}>Carregando termo...</p>}
                  </div>
                  <div style={{textAlign:'right'}}>
                    <button className="btn btn-primary" onClick={()=>setAuthStep('sign')} style={{display:'inline-flex',alignItems:'center',gap:6}}>Li e concordo → Assinar <Icon name="signature" size={14}/></button>
                  </div>
                </>
              )}
              {authStep === 'sign' && authUser && (
                <>
                  <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="checkCircle" size={16}/> Autenticado como {authUser.nome}. Confira os itens e assine abaixo.</div>
                  <div style={{background:'rgba(46,125,107,.08)',border:'1px solid rgba(46,125,107,.35)',borderRadius:8,padding:12,marginBottom:16}}>
                    {retiradaModal.sol.itens.map(i=>(
                      <div key={i.id} style={{display:'flex',justifyContent:'space-between',fontSize:'.85rem',marginBottom:4}}>
                        <span>{i.ferramenta_nome} × {i.quantidade}</span>
                        <span style={{color:'var(--success)',fontWeight:600}}>{fmtBRL(i.valor_item||0)}</span>
                      </div>
                    ))}
                    <div style={{borderTop:'1px solid rgba(46,125,107,.35)',marginTop:8,paddingTop:8,display:'flex',justifyContent:'space-between',fontWeight:700}}>
                      <span>TOTAL SOB RESPONSABILIDADE:</span>
                      <span style={{color:'var(--success)'}}>{fmtBRL(retiradaModal.sol.valor_total)}</span>
                    </div>
                  </div>
                  <div className="alert alert-warning" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={16}/> Ao assinar, você confirma o recebimento das ferramentas e assume a responsabilidade perante a {empresaInfo.razaoSocial}.</div>
                  <SignaturePad label={`Assinatura de ${authUser.nome}`} onConfirm={confirmarRetirada} onCancel={()=>setAuthStep('termo')} />
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )

  // Modal de detalhe (somente leitura) — líder e consulta do Diretor/Gerente.
  const modalDetalhe = detalhe && (
    <div className="modal-overlay open">
      <div className="modal modal-md">
        <div className="modal-header"><h3>Solicitação {detalhe.numero}</h3><button className="modal-close" onClick={()=>setDetalhe(null)}>×</button></div>
        <div className="modal-body">
          <p><TagStatus status={detalhe.status} porte={detalhe.porte} />{detalhe.porte && <span className="text-muted" style={{marginLeft:8,fontSize:'.82rem'}}>com {detalhe.porte.portador_nome} desde {tlHora(detalhe.porte.desde)}</span>}</p>
          {consulta && <p style={{marginTop:8}}><strong>Líder:</strong> {detalhe.lider_nome}{detalhe.obra_nome ? ` · ${detalhe.obra_nome}` : ''}</p>}
          {detalhe.obs && <p style={{marginTop:8}} className="text-muted">Obs: {detalhe.obs}</p>}
          <hr className="divider" />
          <div className="items-list">
            {detalhe.itens.map(i=>(
              <div key={i.id} className="item-row">
                <span>{i.ferramenta_nome}</span>
                <span><strong>{i.quantidade}x</strong></span>
                <span style={{color:'var(--success)',fontSize:'.82rem'}}>{fmtBRL(i.valor_unitario||0)}</span>
                <span style={{fontWeight:600}}>{fmtBRL(i.valor_item||0)}</span>
              </div>
            ))}
            <div style={{padding:'8px 12px',background:'rgba(46,125,107,.08)',fontWeight:700,display:'flex',justifyContent:'flex-end',gap:8}}>
              <span className="text-muted">Total:</span><span style={{color:'var(--success)'}}>{fmtBRL(detalhe.valor_total)}</span>
            </div>
          </div>
        </div>
        <div className="modal-footer"><button className="btn btn-ghost" onClick={()=>setDetalhe(null)}>Fechar</button></div>
      </div>
    </div>
  )

  // Diretor / Gerente — consulta de todas as solicitações (o backend já escopa por contrato).
  if (consulta) return (
    <div>
      <div className="topbar"><h2>Solicitações</h2></div>
      {faixaFiltro}
      <div className="card">
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Número</th><th>Líder</th><th>Obra</th><th>Valor</th><th>Data</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {visiveisTela.map(s=>(
              <tr key={s.id}>
                <td className="fw-bold" data-label="Número">{s.numero}</td>
                <td data-label="Líder">{s.lider_nome}{tagSol(s)}</td>
                <td data-label="Obra">{s.obra_nome || '—'}</td>
                <td data-label="Valor" style={{color:'var(--success)',fontWeight:600}}>{fmtBRL(s.valor_total)}</td>
                <td data-label="Data">{fmt(s.criado_em)}</td>
                <td data-label="Status"><TagStatus status={s.status} porte={s.porte} /></td>
                <td className="cell-actions"><div className="actions">
                  <button className="btn btn-ghost btn-sm" onClick={()=>setDetalhe(s)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="eye" size={14}/> Ver</button>
                </div></td>
              </tr>
            ))}
            {!visiveis.length && <tr><td colSpan="7" className="text-muted" style={{textAlign:'center',padding:20}}>{filtro ? 'Nenhuma solicitação neste filtro agora.' : 'Nenhuma solicitação registrada.'}</td></tr>}
          </tbody>
        </table></div>{fimVisiveis}
      </div>
      {modalDetalhe}
    </div>
  )

  // Líder — acompanhar próprias solicitações
  return (
    <div>
      <div className="topbar">
        <h2>Minhas Solicitações</h2>
        <button className="btn btn-accent" onClick={()=>navigate('nova-solicitacao')}><Icon name="plus" size={14}/> Nova Solicitação</button>
      </div>
      {faixaFiltro}
      <div className="card">
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Número</th><th>Itens</th><th>Valor</th><th>Data</th><th>Status</th><th>Ações</th></tr></thead>
          <tbody>
            {visiveisTela.map(s=>(
              <tr key={s.id}>
                <td className="fw-bold" data-label="Número">{s.numero}</td>
                <td data-label="Itens">{s.itens.length} tipo(s)</td>
                <td data-label="Valor" style={{color:'var(--success)',fontWeight:600}}>{fmtBRL(s.valor_total)}</td>
                <td data-label="Data">{fmt(s.criado_em)}</td>
                <td data-label="Status"><TagStatus status={s.status} porte={s.porte} /></td>
                <td className="cell-actions"><div className="actions">
                  <button className="btn btn-ghost btn-sm" onClick={()=>setDetalhe(s)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="eye" size={14}/> Ver</button>
                  {['solicitada','separando'].includes(s.status) && !user.admin && (
                    <button className="btn btn-danger btn-sm" onClick={()=>cancelar(s)}>Cancelar</button>
                  )}
                </div></td>
              </tr>
            ))}
            {!visiveis.length && filtro && lista.length > 0 && <tr><td colSpan="6" className="text-muted" style={{textAlign:'center',padding:20}}>Nenhuma solicitação neste filtro agora.</td></tr>}
            {!lista.length && <tr><td colSpan="6"><div className="empty"><div className="empty-icon"><Icon name="clipboard" size={32}/></div><p>Você ainda não fez nenhuma solicitação.</p><button className="btn btn-accent empty-cta" onClick={()=>navigate('nova-solicitacao')}><Icon name="plus" size={14}/> Nova solicitação</button></div></td></tr>}
          </tbody>
        </table></div>{fimVisiveis}
      </div>
      {modalDetalhe}
    </div>
  )
}

// ─── NOVA SOLICITAÇÃO (líder) ─────────────────────────────────────────────────
function NovaSolicitacaoPage({ user, navigate, addToast, openTarget, clearOpenTarget }) {
  // Pedido vindo do Cronograma de manutenção: chega com kit, unidade e observação preenchidos. É o
  // mesmo fluxo de sempre (o almoxarifado aprova); só o vínculo com a atividade é gravado a mais.
  const [origem] = useState(() => openTarget && openTarget.page === 'nova-solicitacao' && openTarget.id && typeof openTarget.id === 'object' ? openTarget.id : null)
  const aplicouOrigem = useRef(false)
  useEffect(() => { if (origem && clearOpenTarget) clearOpenTarget() }, [])
  const [bolsas, setBolsas] = useState([])
  // Kits já chegaram? (O servidor só manda os do acervo do contrato — pode vir vazio e o pedido do Cronograma
  // ainda precisa preencher obra e observação.)
  const [bolsasOk, setBolsasOk] = useState(false)
  const [ferramentas, setFerramentas] = useState([])
  const [obras, setObras] = useState([])
  const [form, setForm] = useState({ tipo: 'bolsa' })
  const [itens, setItens] = useState([])
  const [loading, setLoading] = useState(false)
  // Obra padrão do cadastro (null = não tem): sem ela, "Minha obra padrão" mandaria o pedido sem obra.
  // undefined = ainda não sabemos → não bloqueia.
  const [obraPadrao, setObraPadrao] = useState(undefined)
  const exigeObra = obras.length > 0 && obraPadrao === null
  // Acervo já carregado: só então "vazio" quer dizer acervo vazio (antes, o aviso piscaria para todos).
  const [ferrCarregadas, setFerrCarregadas] = useState(false)

  useEffect(() => { GET('/bolsas').then(b => { setBolsas(b); setBolsasOk(true) }); GET('/ferramentas').then(f => { setFerramentas(f); setFerrCarregadas(true) }); GET('/obras?escolha=1').then(setObras).catch(()=>{}); GET('/auth/me').then(u => setObraPadrao(u && u.obra_id ? u.obra_id : null)).catch(()=>{}) }, [])
  // Sem obra padrão mas responsável por UMA obra ativa (o engenheiro do FMS): ela já vem escolhida — com
  // várias, ele escolhe. O /obras?escolha=1 do engenheiro/líder traz as dele (volante: as do contrato).
  useEffect(() => {
    if (obraPadrao !== null) return
    const minhas = obras.filter(o => o.lider_id === user.id)
    if (minhas.length === 1) setForm(f => f.obra_id ? f : { ...f, obra_id: minhas[0].id })
  }, [obras, obraPadrao])
  useEffect(() => {
    if (!origem || aplicouOrigem.current || !bolsasOk) return
    aplicouOrigem.current = true
    const b = origem.bolsa_id && bolsas.find(x => x.id == origem.bolsa_id)
    setForm(f => ({ ...f, tipo: b ? 'bolsa' : 'avulso', bolsa_id: b ? b.id : undefined, obra_id: origem.obra_id || f.obra_id, obs: origem.obs || f.obs }))
    if (b) setItens(b.itens.map(i => ({ ferramenta_id: i.ferramenta_id, quantidade: i.quantidade, ferramenta_nome: i.ferramenta_nome, valor_unitario: i.valor_unitario || 0 })))
  }, [bolsas, bolsasOk])

  // Acervo por contrato: só os kits cujas ferramentas são TODAS do acervo da pessoa (o /ferramentas já vem
  // filtrado pelo contrato dela). Kit da Sede não aparece para o engenheiro da Costellation — o servidor recusaria.
  const acervo = React.useMemo(() => new Set(ferramentas.map(f => f.id)), [ferramentas])
  const bolsasDoAcervo = React.useMemo(() => bolsas.filter(b => b.itens.length && b.itens.every(i => acervo.has(i.ferramenta_id))), [bolsas, acervo])

  const selecionarBolsa = id => {
    setForm({...form, bolsa_id: id})
    const b = bolsas.find(b => b.id == id)
    if (b) setItens(b.itens.map(i => ({ ferramenta_id: i.ferramenta_id, quantidade: i.quantidade, ferramenta_nome: i.ferramenta_nome, valor_unitario: i.valor_unitario || 0 })))
    else setItens([])
  }

  const enviar = async () => {
    if (!itens.length) { addToast('Adicione ao menos um item.', 'error'); return }
    if (exigeObra && !form.obra_id) { addToast('Escolha a obra de destino: seu cadastro não tem obra padrão.', 'error'); return }
    setLoading(true)
    try {
      const r = await POST('/solicitacoes', { bolsa_id: form.bolsa_id || null, itens, obs: form.obs || '', obra_id: form.obra_id || null })
      addToast('Solicitação enviada ao almoxarifado!', 'success')
      if (origem && origem.ref) {
        await POST('/manutencao/atividades/vincular_solicitacao', { ref: origem.ref, solicitacao_id: r.id }).catch(() => {})
        navigate('cronograma')
      } else navigate('solicitacoes')
    } catch(e) { addToast(e.message, 'error') }
    setLoading(false)
  }

  return (
    <div>
      <div className="topbar">
        <h2>Nova Solicitação</h2>
        <button className="btn btn-ghost" onClick={()=>navigate(origem ? 'cronograma' : 'solicitacoes')}>← Voltar</button>
      </div>
      {origem && (
        <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="clipboard" size={16}/>
          <span>Pedido feito pelo <b>Cronograma de manutenção</b>: kit, obra e observação já vieram da atividade. Confira os itens antes de enviar.</span></div>
      )}
      <div className="card">
        <div className="card-header"><span className="card-title">Solicitar ferramentas ao almoxarifado</span></div>
        <div className="card-body">
          <div className="alert alert-warning" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={16}/> Você é responsável pelos itens solicitados. Solicite somente o que sua equipe realmente precisará.</div>
          {/* Acervo por contrato: contrato sem ferramenta cadastrada (ex.: Galpão Costellation) não tem kit nem
              avulso a oferecer — diz o porquê e a quem pedir, em vez de dois seletores vazios e o botão travado. */}
          {ferrCarregadas && !ferramentas.length && (
            <div className="alert alert-info" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="package" size={16}/> <span>O acervo do seu contrato ainda não tem ferramentas cadastradas, então não há kit nem item para pedir. Peça ao almoxarifado para cadastrar as ferramentas no seu contrato.</span></div>
          )}
          <div style={{marginBottom:12}}>
            <label>Tipo de solicitação</label>
            <div className="gap-8" style={{marginTop:8}}>
              <button className={`btn ${form.tipo==='bolsa'?'btn-primary':'btn-ghost'}`} onClick={()=>setForm({...form,tipo:'bolsa',bolsa_id:undefined})} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="backpack" size={14}/> Bolsa padrão</button>
              <button className={`btn ${form.tipo==='avulso'?'btn-primary':'btn-ghost'}`} onClick={()=>{setForm({...form,tipo:'avulso',bolsa_id:undefined});setItens([])}} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="wrench" size={14}/> Avulso</button>
            </div>
          </div>
          {form.tipo === 'bolsa' && (
            <div className="form-group" style={{marginBottom:16}}>
              <label>Bolsa</label>
              <select value={form.bolsa_id||''} onChange={e=>selecionarBolsa(e.target.value)}>
                <option value="">Selecione uma bolsa...</option>
                {bolsasDoAcervo.map(b=><option key={b.id} value={b.id}>{b.nome} — {fmtBRL(b.valor_total)}</option>)}
              </select>
              {ferramentas.length > 0 && !bolsasDoAcervo.length && <p className="text-muted" style={{fontSize:'.8rem',margin:'6px 0 0'}}>Nenhum kit montado com o acervo do seu contrato. Peça as ferramentas pelo <b>Avulso</b>.</p>}
            </div>
          )}
          {obras.length > 0 && (
            <div className="form-group" style={{marginBottom:16}}>
              <label>Obra {obras.length ? '' : '(opcional)'}</label>
              <select value={form.obra_id||''} onChange={e=>setForm({...form,obra_id:e.target.value})}>
                <option value="">{exigeObra ? 'Selecione a obra...' : 'Minha obra padrão'}</option>
                {obras.map(o=><option key={o.id} value={o.id}>{o.nome}{o.codigo?` (${o.codigo})`:''}</option>)}
              </select>
              {exigeObra && !form.obra_id && <div className="text-muted" style={{fontSize:'.78rem',marginTop:4}}>Seu cadastro não tem obra padrão: escolha a obra para onde vão as ferramentas.</div>}
            </div>
          )}
          <label style={{display:'block',marginBottom:6}}>Itens {form.tipo==='bolsa'?'(editáveis)':''}</label>
          <ItemsEditor ferramentas={ferramentas} value={itens} onChange={setItens} />
          <hr className="divider" />
          <div className="form-group">
            <label>Observações</label>
            <textarea value={form.obs||''} onChange={e=>setForm({...form,obs:e.target.value})} placeholder="Obra, necessidade, prazo urgente..." />
          </div>
          <div style={{marginTop:16,textAlign:'right'}}>
            <button className="btn btn-accent" onClick={enviar} disabled={loading || !itens.length}>
              {loading ? 'Enviando...' : <span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="send" size={14}/> Enviar solicitação</span>}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

// ─── CAUTELAS (líder: entregas ao operário) ───────────────────────────────────
// ─── RASTREIO DA CAUTELA ────────────────────────────────────────────────────────
// Linha do tempo única: eventos do sistema (imutáveis — criação, retirada assinada,
// entregas, devoluções) + observações humanas do canal 'cautela:<id>'. Reaproveita a
// mesma infra do RecChat (WebSocket + POST /chat + histórico), mas renderiza como trilha
// auditável presa ao objeto — não como bate-papo. Nada é editável ou apagável.
// Comprime a imagem no cliente (canvas → JPEG) antes de subir — evita inchar o banco com
// data-URIs de câmera de celular (que passam de 3–5 MB). Reduz para no máx. maxDim px no maior lado.
function comprimirImagem(file, maxDim = 1280, quality = 0.7) {
  return new Promise((resolve, reject) => {
    if (!file || !/^image\//.test(file.type)) return reject(new Error('Arquivo não é uma imagem.'))
    const reader = new FileReader()
    reader.onerror = () => reject(new Error('Falha ao ler a imagem.'))
    reader.onload = () => {
      const img = new Image()
      img.onerror = () => reject(new Error('Imagem inválida.'))
      img.onload = () => {
        let { width, height } = img
        if (width > maxDim || height > maxDim) {
          const r = Math.min(maxDim / width, maxDim / height)
          width = Math.round(width * r); height = Math.round(height * r)
        }
        const canvas = document.createElement('canvas')
        canvas.width = width; canvas.height = height
        canvas.getContext('2d').drawImage(img, 0, 0, width, height)
        resolve(canvas.toDataURL('image/jpeg', quality))
      }
      img.src = reader.result
    }
    reader.readAsDataURL(file)
  })
}
// Comprovante de compra sem nota (foto ou PDF): foto passa pela compressão (texto legível em 1600 px); PDF vai como
// está, até 5 MB. Devolve { dataUrl, nome }.
const COMPROVANTE_MAX_PDF = 5 * 1024 * 1024
function lerComprovante(file) {
  if (!file) return Promise.reject(new Error('Escolha o arquivo.'))
  if (/^image\//.test(file.type)) return comprimirImagem(file, 1600, 0.75).then(dataUrl => ({ dataUrl, nome: file.name }))
  if (file.type !== 'application/pdf') return Promise.reject(new Error('Use uma foto ou um PDF.'))
  if (file.size > COMPROVANTE_MAX_PDF) return Promise.reject(new Error('PDF muito grande (máx. 5 MB).'))
  return new Promise((resolve, reject) => {
    const r = new FileReader()
    r.onerror = () => reject(new Error('Falha ao ler o PDF.'))
    r.onload = () => resolve({ dataUrl: r.result, nome: file.name })
    r.readAsDataURL(file)
  })
}
// Baixa o comprovante que o servidor guarda como data-URL — mesmo caminho do baixarArquivo (link com download), que
// funciona no celular; aba nova (pop-up) o app instalado e o navegador embutido bloqueiam. `buscar` devolve
// { comprovante, comprovante_nome }. A foto foi comprimida para JPEG: a extensão sai do tipo, não do nome original.
async function baixarComprovante(buscar) {
  const r = await buscar()
  if (!r || !r.comprovante) throw new Error('Comprovante não encontrado.')
  const [cab, b64] = String(r.comprovante).split(',')
  const tipo = (cab.match(/^data:([^;]+)/) || [])[1] || 'application/octet-stream'
  const bin = atob(b64), bytes = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i)
  const ext = tipo === 'application/pdf' ? '.pdf' : tipo === 'image/png' ? '.png' : tipo === 'image/webp' ? '.webp' : '.jpg'
  const url = URL.createObjectURL(new Blob([bytes], { type: tipo }))
  const el = document.createElement('a'); el.href = url
  el.download = String(r.comprovante_nome || 'comprovante').replace(/\.[a-z0-9]{2,5}$/i, '') + ext
  el.click(); setTimeout(() => URL.revokeObjectURL(url), 60000)
}
// Após um deep-link abrir um painel de edição (ferramenta/obra/pessoa), traz o painel
// para o centro da tela — em listas longas ele abriria fora da vista.
function scrollPainelParaFoco() {
  setTimeout(() => { const el = document.querySelector('.tool-edit-panel'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }) }, 80)
}
const RASTREIO_ICON = { criada: 'package', retirada: 'signature', entrega: 'handshake', entrega_devolvida: 'undo', devolucao: 'download', porte_saida: 'truck', porte_entrega: 'handshake', porte_retorno: 'undo' }
const tlHora = d => { const s = String(d || ''); return s.length >= 16 ? `${s.slice(8, 10)}/${s.slice(5, 7)} ${s.slice(11, 16)}` : s }
const tlIniciais = n => (n || '—').trim().split(/\s+/).filter(Boolean).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?'

function CautelaRastreio({ cautelaId, user, addToast }) {
  const [eventos, setEventos] = useState(null)
  const [semAcesso, setSemAcesso] = useState('')  // 403: quem abre o detalhe pela equipe/contrato mas não participa da trilha
  const [texto, setTexto] = useState('')
  const [foto, setFoto] = useState(null)          // data-URI comprimida, anexo pendente
  const [preparandoFoto, setPreparandoFoto] = useState(false)
  const [lightbox, setLightbox] = useState(null)  // foto ampliada
  const [online, setOnline] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const wsRef = useRef(null)
  const fileRef = useRef(null)
  const fimRef = useRef(null)
  const canal = 'cautela:' + cautelaId
  // Dedup por (tipo+id) — a nota chega tanto na resposta do POST quanto pelo WS.
  const addNota = m => setEventos(prev => {
    const nova = { tipo: 'note', id: m.id, de_id: m.de_id, de_nome: m.de_nome, de_role: m.de_role, texto: m.texto, foto: m.foto || null, data: m.criado_em }
    if ((prev || []).some(x => x.tipo === 'note' && x.id === m.id)) return prev
    return [...(prev || []), nova]
  })
  useEffect(() => {
    let vivo = true, retry = null
    setSemAcesso('')
    GET('/cautelas/' + cautelaId + '/rastreio').then(r => { if (vivo) setEventos(r.eventos || []) })
      .catch(e => { if (!vivo) return; setEventos([]); if (e.status === 403) { setSemAcesso(e.message || 'Sem acesso ao rastreio desta cautela.'); vivo = false; try { wsRef.current && wsRef.current.close() } catch {} } })
    const conectar = () => {
      if (!vivo) return
      const proto = location.protocol === 'https:' ? 'wss' : 'ws'
      const tk = token.value || ''
      let ws
      try { ws = new WebSocket(`${proto}://${location.host}/ws/chat`, tk ? ['cautelix', tk] : undefined) }
      catch { retry = setTimeout(conectar, 3000); return }
      wsRef.current = ws
      ws.onopen = () => { setOnline(true); try { ws.send(JSON.stringify({ type: 'sub', canal })) } catch {} }
      ws.onmessage = ev => { let m; try { m = JSON.parse(ev.data) } catch { return } if (m.type === 'msg' && m.canal === canal) addNota(m.msg) }
      ws.onclose = () => { setOnline(false); if (vivo) retry = setTimeout(conectar, 3000) }
      ws.onerror = () => { try { ws.close() } catch {} }
    }
    conectar()
    return () => { vivo = false; if (retry) clearTimeout(retry); try { wsRef.current && wsRef.current.close() } catch {} }
  }, [cautelaId])
  useEffect(() => { if (fimRef.current) fimRef.current.scrollIntoView({ block: 'nearest' }) }, [eventos])
  const anexarFoto = async file => {
    if (!file) return
    setPreparandoFoto(true)
    try { setFoto(await comprimirImagem(file)) }
    catch (e) { addToast(e.message || 'Não foi possível anexar a foto.', 'error') }
    finally { setPreparandoFoto(false) }
  }
  const registrar = async () => {
    const t = texto.trim(); if ((!t && !foto) || enviando) return
    const fotoEnvio = foto
    setEnviando(true); setTexto(''); setFoto(null)
    try { addNota(await POST('/chat/' + encodeURIComponent(canal), { texto: t, foto: fotoEnvio })) }
    catch (e) { setTexto(t); setFoto(fotoEnvio); addToast(e.message || 'Falha ao registrar observação.', 'error') }
    finally { setEnviando(false) }
  }
  if (eventos === null) return <div className="tl-empty">Carregando rastreio…</div>
  if (semAcesso) return <div className="tl-empty"><Icon name="lock" size={13} /> {semAcesso} O rastreio fica com a gestão, o responsável e quem recebeu peça desta cautela.</div>
  return (
    <div>
      <div className="tl">
        {eventos.length === 0 && <div className="tl-empty">Sem eventos ainda.</div>}
        {eventos.map((e, i) => e.tipo === 'evt' ? (
          <div className="tl-row" key={'e' + i}>
            <span className={`tl-dot ${e.sign ? 'sign' : 'evt'}`}><Icon name={RASTREIO_ICON[e.kind] || 'history'} size={11} /></span>
            <div className="evt-l">{e.titulo}</div>
            <div className="evt-sub">
              {e.who_nome && <span className="evt-who">{e.who_nome}{e.who_role ? ` · ${ROLE_LABEL[e.who_role] || e.who_role}` : ''}</span>}
              {e.sign && <span className="evt-lock"><Icon name="lock" size={11} /> assinatura{e.ip ? ' + IP' : ''}</span>}
              {e.ident && <span className="evt-lock">{e.ident}</span>}
              {e.foto && <span className="evt-lock"><Icon name="camera" size={11} /> foto</span>}
              {e.local && <span className="evt-lock"><Icon name="mapPin" size={11} /> local</span>}
              {e.hash && <span className="evt-lock" title="Elo da cadeia de custódia — encadeado ao anterior por hash">elo {e.hash}</span>}
            </div>
            {e.obs && <div className="note-tx" style={{fontSize:'.78rem',color:'var(--text-secondary)',marginTop:3}}>“{e.obs}”</div>}
            <div className="tl-time">{tlHora(e.data)}</div>
          </div>
        ) : (
          <div className="tl-row" key={'n' + e.id}>
            <span className="tl-dot note"><Icon name="send" size={11} /></span>
            <div className="note-b">
              <div className="note-hd">
                <span className="note-av">{tlIniciais(e.de_nome)}</span>
                <span className="note-nm">{e.de_nome || '—'}</span>
                <span className="note-role">· {ROLE_LABEL[e.de_role] || e.de_role || ''}</span>
              </div>
              {e.texto && <div className="note-tx">{e.texto}</div>}
              {e.foto && <img src={e.foto} className="note-foto" alt="anexo" onClick={() => setLightbox(e.foto)} />}
            </div>
            <div className="tl-time">{tlHora(e.data)}</div>
          </div>
        ))}
        <div ref={fimRef} />
      </div>
      <div className="ct-comp">
        <div className="ct-comp-cap"><Icon name="lock" size={11} /> Observação registrada no rastreio — atribuída a você, sem edição/exclusão {online ? '' : '· reconectando…'}</div>
        {foto && (
          <div className="ct-foto-prev">
            <img src={foto} alt="prévia do anexo" onClick={() => setLightbox(foto)} />
            <button className="ct-foto-rm" onClick={() => setFoto(null)} title="Remover foto"><Icon name="x" size={13} /></button>
          </div>
        )}
        <div className="ct-comp-row">
          <input type="file" accept="image/*" capture="environment" ref={fileRef} style={{ display: 'none' }}
            onChange={e => { anexarFoto(e.target.files[0]); e.target.value = '' }} />
          <button className="ct-anexo" onClick={() => fileRef.current && fileRef.current.click()} disabled={preparandoFoto} title="Anexar foto">
            <Icon name={preparandoFoto ? 'clock' : 'camera'} size={16} />
          </button>
          <input placeholder="Adicionar observação a esta cautela…" value={texto} onChange={e => setTexto(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); registrar() } }} />
          <button onClick={registrar} disabled={enviando || (!texto.trim() && !foto)}><Icon name="send" size={14} /> Registrar</button>
        </div>
      </div>
      {lightbox && (
        <div className="foto-lightbox" onClick={() => setLightbox(null)}>
          <img src={lightbox} alt="anexo ampliado" onClick={e => e.stopPropagation()} />
          <button className="foto-lightbox-x" onClick={() => setLightbox(null)}><Icon name="x" size={20} /></button>
        </div>
      )}
    </div>
  )
}

function CautelasPage({ user, navigate, addToast, openTarget, clearOpenTarget }) {
  const [lista, setLista] = useState([])
  const [detalhe, setDetalhe] = useState(null)
  const [abaDet, setAbaDet] = useState('detalhes')  // detalhes | rastreio
  const [entregaModal, setEntregaModal] = useState(null)
  const [devModal, setDevModal] = useState(null)
  // Auth operário no dispositivo do líder
  const [authEmail, setAuthEmail] = useState('')
  const [authSenha, setAuthSenha] = useState('')
  const [authStep, setAuthStep] = useState('form') // form | termo | sign
  const [authUser, setAuthUser] = useState(null)
  const [authErr, setAuthErr] = useState('')
  const [entregaItens, setEntregaItens] = useState([])
  const [termoHTML, setTermoHTML] = useState('')
  // Devolução com auth do responsável
  const [devEmail, setDevEmail] = useState('')
  const [devSenha, setDevSenha] = useState('')
  const [devStep, setDevStep] = useState('form') // form | sign
  const [devErr, setDevErr] = useState('')
  const [selFerr, setSelFerr] = useState(''); const [selQtd, setSelQtd] = useState(1)
  const [filtro, setFiltro] = useState(() => filtroDoAlvo(openTarget, 'cautelas'))  // card do painel
  const ct = useContratosCadastro(user)   // com 2+ contratos o cartão leva a etiqueta do contrato do responsável
  const visiveis = lista.filter(c => cautelaNoFiltro(c, filtro))
  const [cartoes, fimCartoes] = useAosPoucos(visiveis)
  // Vindo do card "equipe" (filtro por colaboradores), o líder/engenheiro precisa ver também as
  // cautelas de outros responsáveis que estão com a equipe dele (?equipe=1). Sem o filtro, só as dele.
  const daEquipe = !!(filtro && filtro.colaboradores) && (user.role === 'lider' || user.role === 'engenheiro')

  const load = () => GET('/cautelas' + (daEquipe ? '?equipe=1' : '')).then(setLista).catch(()=>{})
  useEffect(() => { load() }, [daEquipe])

  const verDetalhe = async c => {
    try {
      const full = await GET(`/cautelas/${c.id}`)
      setAbaDet('detalhes')
      setDetalhe(full)
    } catch (e) { addToast(e.message || 'Não foi possível abrir a cautela.', 'error') }
  }

  // Deep-link da busca/painel: abre direto o modal da cautela pedida e consome o alvo.
  useEffect(() => {
    if (openTarget && openTarget.page === 'cautelas') {
      if (openTarget.id) verDetalhe({ id: openTarget.id })
      clearOpenTarget && clearOpenTarget()
    }
  }, [openTarget])

  const verTermo = async (id, tipo) => {
    try {
      const { html } = await GET(`/cautelas/${id}/termo/${tipo}`)
      const w = window.open('', '_blank', 'width=900,height=700,scrollbars=yes')
      w.document.write(html); w.document.close()
    } catch(e) { addToast(e.message, 'error') }
  }

  // Só o que ainda está com o responsável (a_entregar = item da cautela − entregas ativas, vem do servidor):
  // o que já foi entregue a um operário não volta à lista, e o editor não oferece o acervo inteiro.
  const entregaveis = c => {
    const m = new Map()
    for (const i of (c && c.itens) || []) if (i.a_entregar > 0) {
      const x = m.get(i.ferramenta_id)
      if (x) x.quantidade_disponivel += i.a_entregar
      else m.set(i.ferramenta_id, { id: i.ferramenta_id, nome: i.ferramenta_nome, codigo: i.codigo, valor_unitario: i.valor_unitario || 0, quantidade_disponivel: i.a_entregar })
    }
    return [...m.values()]
  }
  const abrirEntrega = c => {
    setEntregaModal(c)
    setAuthEmail(''); setAuthSenha(''); setAuthStep('form'); setAuthUser(null); setAuthErr('')
    setEntregaItens(entregaveis(c).map(f=>({ferramenta_id:f.id,quantidade:f.quantidade_disponivel,ferramenta_nome:f.nome,valor_unitario:f.valor_unitario})))
  }

  const validarOperario = async () => {
    setAuthErr('')
    try {
      const u = await POST('/auth/validar', { email: authEmail, senha: authSenha, role_esperado: 'operario' })
      // Termo de Ciência DESTA entrega (o operário autenticado e os itens escolhidos), antes da assinatura dele.
      // O servidor já confere os itens: erro aqui volta ao formulário, antes de assinar.
      const t = await POST(`/cautelas/${entregaModal.id}/entregas/termo-previa`, { email: authEmail, senha: authSenha, itens: entregaItens })
      setTermoHTML(t.html || ''); setAuthUser(u)
      setAuthStep('termo')
    } catch(e) { setAuthErr(e.message) }
  }

  const confirmarEntrega = async sig => {
    try {
      const r = await POST(`/cautelas/${entregaModal.id}/entregas`, { email: authEmail, senha: authSenha, assinatura: sig, itens: entregaItens })
      addToast(`Entrega registrada para ${r.operario_nome}!`, 'success')
      setEntregaModal(null); load()
    } catch(e) { addToast(e.message, 'error') }
  }

  const devolverEntrega = async (cautelaId, entregaId) => {
    if (!confirm('Confirmar devolução desta entrega?')) return
    try {
      await POST(`/cautelas/${cautelaId}/entregas/${entregaId}/devolver`, {})
      addToast('Devolução registrada!', 'success')
      const full = await GET(`/cautelas/${cautelaId}`)
      setDetalhe(full); load()
    } catch(e) { addToast(e.message, 'error') }
  }

  const abrirDevolver = c => {
    setDevModal({...c, obs:''})
    setDevEmail(''); setDevSenha(''); setDevStep('form'); setDevErr('')
  }

  const validarLiderDev = async () => {
    setDevErr('')
    try {
      const roleEsperado = devModal.cautela_tipo === 'direto' ? 'operario' : 'lider'
      const u = await POST('/auth/validar', { email: devEmail, senha: devSenha, role_esperado: roleEsperado })
      if (u.id !== devModal.lider_id) { setDevErr(`Este login não corresponde ao responsável desta cautela.`); return }
      setDevStep('sign')
    } catch(e) { setDevErr(e.message) }
  }

  const devolver = async (sig) => {
    try {
      await POST(`/cautelas/${devModal.id}/devolver`, { email: devEmail, senha: devSenha, assinatura: sig, obs_devolucao: devModal.obs || '' })
      addToast('Cautela devolvida com assinatura!', 'success')
      setDevModal(null); setDetalhe(null); load()
    } catch(e) { addToast(e.message, 'error') }
  }

  const verTermoDevolucao = async (id) => {
    try {
      const { html } = await GET(`/cautelas/${id}/termo/devolucao`)
      const w = window.open('', '_blank', 'width=900,height=700,scrollbars=yes')
      w.document.write(html); w.document.close()
    } catch(e) { addToast('Recibo indisponível (cautela ainda não devolvida ou sem assinatura).', 'warning') }
  }

  const isLider = user.role === 'lider' || user.role === 'engenheiro'
  const isAlm   = user.role === 'almoxarifado'

  return (
    <div>
      <div className="topbar">
        <h2>Cautelas</h2>
      </div>
      <FiltroPainel filtro={filtro} n={visiveis.length} onLimpar={()=>setFiltro(null)} />
      {visiveis.length ? (
        <><div className="cbgrid">
          {cartoes.map(c=>{
            const nome = (c.lider_nome||'—').trim()
            const ini = nome.split(/\s+/).filter(Boolean).map(w=>w[0]).slice(0,2).join('').toUpperCase() || '?'
            const direto = c.cautela_tipo === 'direto'
            return (
              <div className="cbcard" key={c.id}>
                <div className="head">
                  <span className="cbav">{ini}</span>
                  <div className="who">
                    <span className="nm">{nome}</span>
                    <span className="num">{c.numero} · {direto ? 'Operário (direta)' : 'Via líder'}{c.porte ? ` · com ${c.porte.portador_nome}` : ''}<ContratoTag ct={ct} id={ct.de({ contrato_id: c.lider_contrato_id })}/></span>
                  </div>
                  <TagStatus status={c.status} porte={c.porte} />
                </div>
                <div className="grid">
                  <div className="cell"><div className="k">Retirada</div><div className="v" style={{fontSize:'.9rem'}}>{fmt(c.data_retirada)}</div></div>
                  <div className="cell"><div className="k">Sob responsab.</div><div className="v resp">{['cancelada','estornada'].includes(c.status) ? '—' : fmtBRL(c.valor_total)}</div></div>
                </div>
                <div className="acts">
                  <button className="btn btn-outline btn-sm" onClick={()=>verDetalhe(c)}><Icon name="eye" size={14}/> Ver</button>
                  {isLider && !direto && c.status === 'ativa' && c.lider_id === user.id && c.a_entregar > 0 && (
                    <button className="btn btn-accent btn-sm" onClick={()=>abrirEntrega(c)}><Icon name="send" size={14}/> Entregar</button>
                  )}
                  {isAlm && c.status === 'ativa' && (
                    <button className="btn btn-success btn-sm" onClick={()=>abrirDevolver(c)}><Icon name="download" size={14}/> Devolução</button>
                  )}
                </div>
              </div>
            )
          })}
        </div>{fimCartoes}</>
      ) : (
        <div className="card"><div className="empty"><div className="empty-icon"><Icon name="clipboard" size={32}/></div><p>{filtro && lista.length ? 'Nenhuma cautela neste filtro agora.' : 'Nenhuma cautela.'}</p></div></div>
      )}

      {/* Detalhe */}
      {detalhe && (
        <div className="modal-overlay open">
          <div className="modal modal-lg">
            <div className="modal-header">
              <h3>Cautela {detalhe.numero}</h3>
              <button className="modal-close" onClick={()=>setDetalhe(null)}>×</button>
            </div>
            <div className="modal-body">
              <div className="dt-tabs">
                <button className={`dt-tab ${abaDet==='detalhes'?'on':''}`} onClick={()=>setAbaDet('detalhes')}><Icon name="fileText" size={14}/> Detalhes</button>
                <button className={`dt-tab ${abaDet==='rastreio'?'on':''}`} onClick={()=>setAbaDet('rastreio')}><Icon name="history" size={14}/> Rastreio</button>
              </div>
              {abaDet==='rastreio' && <CautelaRastreio cautelaId={detalhe.id} user={user} addToast={addToast} />}
              {abaDet==='detalhes' && (<>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
                <div><span className="text-muted">{detalhe.cautela_tipo==='direto'?'Operário (responsável)':'Líder'}</span><br/><strong>{detalhe.lider_nome}</strong></div>
                <div><span className="text-muted">Status</span><br/><TagStatus status={detalhe.status} porte={detalhe.porte} /></div>
                <div><span className="text-muted">Retirada</span><br/><strong>{fmtDT(detalhe.data_retirada)}</strong></div>
                <div><span className="text-muted">Valor total</span><br/><strong style={{color:'var(--success)'}}>{fmtBRL(detalhe.valor_total)}</strong></div>
              </div>
              {detalhe.ip_lider && <p className="text-muted" style={{fontSize:'.75rem',marginBottom:8}}>IP retirada: {detalhe.ip_lider}</p>}
              <div style={{display:'flex',gap:8,marginBottom:12,flexWrap:'wrap'}}>
                {/* Cautela direta: o operário assinou o Termo de Ciência e Responsabilidade na retirada — é ele que se reimprime (comodato e ciência por operário são da via líder). */}
                {detalhe.cautela_tipo==='direto'
                  ? <button className="btn btn-outline btn-sm" onClick={()=>verTermo(detalhe.id,'ciencia_direta')} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="fileText" size={14}/> Termo de Ciência</button>
                  : <>
                <button className="btn btn-outline btn-sm" onClick={()=>verTermo(detalhe.id,'comodato')} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="fileText" size={14}/> Termo de Comodato</button>
                <button className="btn btn-outline btn-sm" onClick={()=>verTermo(detalhe.id,'ciencia')} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="fileText" size={14}/> Termos de Ciência</button>
                  </>}
                {(detalhe.custodia||[]).length > 0 && <button className="btn btn-outline btn-sm" onClick={()=>verTermo(detalhe.id,'porte')} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="truck" size={14}/> Termo de Transporte</button>}
              </div>
              {(detalhe.custodia||[]).length > 0 && (
                <div style={{border:'1px solid var(--border)',borderRadius:8,padding:'10px 12px',marginBottom:12,background:'var(--surface-alt)'}}>
                  <p className="fw-bold" style={{marginBottom:6,display:'flex',alignItems:'center',gap:6,fontSize:'.88rem'}}><Icon name="truck" size={15}/> Cadeia de custódia — levada pelo apontador</p>
                  {detalhe.custodia.map(e => (
                    <div key={e.id} style={{display:'flex',alignItems:'center',gap:10,padding:'7px 0',borderTop:'1px solid var(--border)',flexWrap:'wrap'}}>
                      <span style={{flex:'1 1 220px',minWidth:0,fontSize:'.84rem'}}>
                        <strong>{{ saida: 'Saída do almoxarifado', entrega: 'Entrega na obra', retorno: 'Voltou ao almoxarifado' }[e.tipo] || e.tipo}</strong>
                        <span className="text-muted"> · {e.de_nome || '—'} → {e.para_nome || '—'}</span>
                        <span style={{display:'block',fontSize:'.74rem',color:'var(--text-secondary)'}}>{tlHora(e.criado_em)}{e.ip ? ` · IP ${e.ip}` : ''} · elo {String(e.hash_evento || '').slice(0, 12)}{e.obs ? ` · ${e.obs}` : ''}</span>
                        {e.identificacao && <span style={{display:'block',fontSize:'.74rem',color:'var(--text-secondary)'}}>Identificação: {{ login: 'login e senha', cpf: 'CPF conferido com o cadastro', foto: 'assinatura com foto (cadastro sem CPF)' }[e.identificacao]}{e.geo_lat != null && <> · <a href={`https://www.google.com/maps/search/?api=1&query=${e.geo_lat},${e.geo_lng}`} target="_blank" rel="noopener noreferrer" style={{color:'var(--primary-accent)'}}>local no mapa</a></>}</span>}
                      </span>
                      {e.foto && <img src={e.foto} height={38} title="Foto do recebimento" style={{border:'1px solid var(--border)',borderRadius:4,objectFit:'cover',maxWidth:60}} alt="foto do recebimento" />}
                      {e.assinatura && <img src={e.assinatura} height={38} style={{border:'1px solid var(--border)',borderRadius:4,background:'#fff'}} alt={`assinatura — ${e.tipo}`} />}
                    </div>
                  ))}
                  {detalhe.porte && <p style={{fontSize:'.78rem',color:'var(--text-secondary)',marginTop:6}}>A bolsa está com {detalhe.porte.portador_nome}. A cautela fica ativa quando {detalhe.lider_nome} assinar o recebimento no aparelho dele.</p>}
                </div>
              )}
              <hr className="divider" />
              <p className="fw-bold" style={{marginBottom:8}}>Itens da cautela</p>
              <div className="items-list">
                {detalhe.itens.map(i=>(
                  <div key={i.id} className="item-row">
                    <span>{i.ferramenta_nome}{i.codigo && <span className="text-muted"> ({i.codigo})</span>}</span>
                    <span><strong>{i.quantidade}x</strong></span>
                    <span style={{color:'var(--success)',fontSize:'.82rem'}}>{fmtBRL(i.valor_unitario||0)}</span>
                    <span style={{fontWeight:600}}>{fmtBRL(i.valor_item||0)}</span>
                  </div>
                ))}
              </div>
              {(detalhe.entregas||[]).length > 0 && (
                <>
                  <hr className="divider" />
                  <p className="fw-bold" style={{marginBottom:8}}>Entregas a operários</p>
                  {detalhe.entregas.map(e=>(
                    <div key={e.id} style={{border:'1px solid var(--border)',borderRadius:8,padding:12,marginBottom:8}}>
                      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8}}>
                        <div>
                          <strong>{e.operario_nome}</strong>
                          <span className="text-muted" style={{marginLeft:8}}>{e.operario_cargo}</span>
                          <span className={`badge badge-${e.status}`} style={{marginLeft:8}}>{STATUS_LABEL[e.status]||e.status}</span>
                        </div>
                        <div className="gap-8">
                          {e.ip_operario && <span className="text-muted" style={{fontSize:'.75rem'}}>IP: {e.ip_operario}</span>}
                          {/* O operário devolveu ao responsável: a peça volta a poder ser entregue a outro (a entrega só sai do que está com ele). */}
                          {isLider && detalhe.status === 'ativa' && detalhe.lider_id === user.id && e.status === 'ativa' && (
                            <button className="btn btn-outline btn-sm" onClick={()=>devolverEntrega(detalhe.id, e.id)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="download" size={13}/> Recebi de volta</button>
                          )}
                        </div>
                      </div>
                      {e.itens && e.itens.length > 0 && (
                        <div style={{marginTop:8,fontSize:'.82rem',color:'var(--text-secondary)'}}>
                          {e.itens.map(i=>`${i.ferramenta_nome}${i.codigo?` (${i.codigo})`:''} × ${i.quantidade}`).join(' · ')}
                        </div>
                      )}
                      {e.assinatura_operario && <img src={e.assinatura_operario} height={50} style={{marginTop:6,border:'1px solid var(--border)',borderRadius:4}} alt="assinatura" />}
                    </div>
                  ))}
                </>
              )}
              {detalhe.assinatura_lider && (
                <>
                  <hr className="divider" />
                  <p className="text-muted" style={{marginBottom:6}}>{detalhe.cautela_tipo==='direto' ? 'Assinatura do operário (retirada)' : 'Assinatura do Líder (retirada)'}{(detalhe.custodia||[]).some(e => e.tipo === 'entrega') ? ' — recebida na obra, pelo apontador' : ''}</p>
                  <img src={detalhe.assinatura_lider} className="sig-preview" height={70} alt="assinatura líder" />
                </>
              )}
              </>)}
            </div>
            <div className="modal-footer">
              {isLider && detalhe.cautela_tipo !== 'direto' && detalhe.status === 'ativa' && detalhe.lider_id === user.id && detalhe.a_entregar > 0 && (
                <button className="btn btn-accent" onClick={()=>{setDetalhe(null);abrirEntrega(detalhe)}} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="send" size={14}/> Entregar a operário</button>
              )}
              {isAlm && detalhe.status === 'ativa' && (
                <button className="btn btn-success" onClick={()=>{setDetalhe(null);abrirDevolver(detalhe)}} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="download" size={14}/> Registrar devolução</button>
              )}
              {detalhe.status === 'devolvida' && detalhe.assinatura_devolucao && (
                <button className="btn btn-outline btn-sm" onClick={()=>verTermoDevolucao(detalhe.id)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="fileText" size={14}/> Recibo Devolução</button>
              )}
              <button className="btn btn-ghost" onClick={()=>setDetalhe(null)}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal entregar ao operário */}
      {entregaModal && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header">
              <h3>Entregar ao Operário — {entregaModal.numero}</h3>
              <button className="modal-close" onClick={()=>setEntregaModal(null)}>×</button>
            </div>
            <div className="modal-body">
              {authStep === 'form' && (
                <>
                  <div className="alert alert-info">O operário deve autenticar neste dispositivo para confirmar o recebimento.</div>
                  <div className="auth-device-box">
                    <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={16}/> Autenticação do Operário</h4>
                    {authErr && <div className="alert alert-error" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {authErr}</div>}
                    <div className="form-grid">
                      <div className="form-group"><label>Email do operário</label><input type="email" value={authEmail} onChange={e=>setAuthEmail(e.target.value)} placeholder="operario@email.com" /></div>
                      <div className="form-group"><label>Senha</label><input type="password" value={authSenha} onChange={e=>setAuthSenha(e.target.value)} placeholder="••••••••" /></div>
                    </div>
                    <div style={{marginTop:12,textAlign:'right'}}>
                      <button className="btn btn-primary" onClick={validarOperario}>Autenticar →</button>
                    </div>
                  </div>
                  <hr className="divider" />
                  <label style={{display:'block',marginBottom:6}}>Itens a entregar</label>
                  <p className="text-muted" style={{fontSize:'.78rem',margin:'0 0 6px'}}>Só o que desta cautela ainda está com você ("disp." = o que falta entregar).</p>
                  <ItemsEditor ferramentas={entregaveis(entregaModal)} value={entregaItens} onChange={setEntregaItens} />
                </>
              )}
              {authStep === 'termo' && authUser && (
                <>
                  <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="checkCircle" size={16}/> Autenticado como {authUser.nome}. Leia o Termo de Ciência e tome ciência das responsabilidades antes de assinar.</div>
                  <div style={{border:'2px solid var(--primary-text)',borderRadius:8,maxHeight:380,overflowY:'auto',padding:16,background:'var(--surface-alt)',marginBottom:16,fontSize:'.82rem',lineHeight:1.6}}>
                    {termoHTML
                      ? <div dangerouslySetInnerHTML={{__html: termoHTML}} />
                      : <p style={{color:'var(--text-secondary)'}}>Carregando termo...</p>}
                  </div>
                  <div style={{textAlign:'right'}}>
                    <button className="btn btn-primary" onClick={()=>setAuthStep('sign')} style={{display:'inline-flex',alignItems:'center',gap:6}}>Li e concordo → Assinar <Icon name="signature" size={14}/></button>
                  </div>
                </>
              )}
              {authStep === 'sign' && authUser && (
                <>
                  <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="checkCircle" size={16}/> Autenticado como {authUser.nome}. Confira os itens e assine o Termo de Ciência.</div>
                  <div style={{background:'rgba(46,125,107,.08)',border:'1px solid rgba(46,125,107,.35)',borderRadius:8,padding:12,marginBottom:16}}>
                    {entregaItens.map(i=>(
                      <div key={i.ferramenta_id} style={{display:'flex',justifyContent:'space-between',fontSize:'.85rem',marginBottom:4}}>
                        <span>{i.ferramenta_nome} × {i.quantidade}</span>
                        <span style={{color:'var(--success)',fontWeight:600}}>{fmtBRL((i.valor_unitario||0)*i.quantidade)}</span>
                      </div>
                    ))}
                  </div>
                  <div className="alert alert-warning" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={16}/> Ao assinar, {authUser.nome} confirma o recebimento e assume responsabilidade por estes itens.</div>
                  <SignaturePad label={`Assinatura de ${authUser.nome} (Operário)`} onConfirm={confirmarEntrega} onCancel={()=>setAuthStep('termo')} />
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal devolver cautela — exige auth + assinatura do líder */}
      {devModal && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header">
              <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="download" size={17}/> Registrar devolução — Cautela {devModal.numero}</h3>
              <button className="modal-close" onClick={()=>setDevModal(null)}>×</button>
            </div>
            <div className="modal-body">
              {devStep === 'form' && (
                <>
                  <div className="alert alert-warning" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={16}/> A devolução requer autenticação e assinatura do líder responsável para garantir o registro formal da entrega.</div>
                  <div className="form-group" style={{marginBottom:12}}>
                    <label>Observações (condição das ferramentas)</label>
                    <textarea value={devModal.obs||''} onChange={e=>setDevModal({...devModal,obs:e.target.value})} placeholder="Sem avarias, desgaste normal..." />
                  </div>
                  <div className="auth-device-box">
                    <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={16}/> Autenticação do {devModal.cautela_tipo==='direto'?'Operário':'Líder'}: {devModal.lider_nome}</h4>
                    {devErr && <div className="alert alert-error" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {devErr}</div>}
                    <div className="form-grid">
                      <div className="form-group"><label>Email</label><input type="email" value={devEmail} onChange={e=>setDevEmail(e.target.value)} placeholder={devModal.lider_email} /></div>
                      <div className="form-group"><label>Senha</label><input type="password" value={devSenha} onChange={e=>setDevSenha(e.target.value)} placeholder="••••••••" /></div>
                    </div>
                    <div style={{marginTop:12,textAlign:'right'}}>
                      <button className="btn btn-primary" onClick={validarLiderDev}>Autenticar →</button>
                    </div>
                  </div>
                </>
              )}
              {devStep === 'sign' && (
                <>
                  <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="checkCircle" size={16}/> Autenticado. Ao assinar, {devModal.cautela_tipo==='direto'?'o operário confirma':'o líder confirma'} a devolução de todos os itens ao almoxarifado.</div>
                  {devModal.obs && <p className="text-muted" style={{marginBottom:8}}>Obs: {devModal.obs}</p>}
                  <SignaturePad label={`Assinatura de ${devModal.lider_nome} — Confirmo a devolução`} onConfirm={devolver} onCancel={()=>setDevStep('form')} />
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// ─── EMPRÉSTIMOS ──────────────────────────────────────────────────────────────
function EmprestimosPage({ user, addToast, openTarget }) {
  const [lista, setLista] = useState([])
  const [lideres, setLideres] = useState([])
  const [ferramentas, setFerramentas] = useState([])
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState({})
  const [itens, setItens] = useState([])
  const [buscaEmail, setBuscaEmail] = useState('')
  const [tomadorEncontrado, setTomadorEncontrado] = useState(null)
  const [buscando, setBuscando] = useState(false)
  const [sigModal, setSigModal] = useState(null)
  const [filtro, setFiltro] = useState(() => (filtroDoAlvo(openTarget, 'emprestimos') || {}).status || '')  // card do painel

  const load = () => GET('/emprestimos').then(setLista).catch(()=>{})
  useEffect(() => {
    load()
    GET('/ferramentas').then(setFerramentas)
    if (user.role === 'operario') GET('/usuarios/lideres').then(setLideres)
  }, [])

  const buscarTomador = async () => {
    if (!buscaEmail) return
    setBuscando(true); setTomadorEncontrado(null)
    try {
      const u = await GET(`/usuarios/buscar?email=${encodeURIComponent(buscaEmail)}`)
      if (!u) addToast('Nenhum operário encontrado com este email.', 'warning')
      setTomadorEncontrado(u)
    } catch(e) { addToast(e.message, 'error') }
    setBuscando(false)
  }

  const solicitar = async () => {
    if (!tomadorEncontrado) { addToast('Busque e confirme o tomador.', 'error'); return }
    if (!form.lider_id) { addToast('Selecione o líder responsável.', 'error'); return }
    if (!itens.length) { addToast('Adicione ao menos um item.', 'error'); return }
    try {
      const r = await POST('/emprestimos', { tomador_email: buscaEmail, lider_id: form.lider_id, itens, obs: form.obs || '' })
      addToast(`Solicitação enviada. ${r.tomador_nome} receberá notificação.`, 'success')
      setModal(null); setBuscaEmail(''); setTomadorEncontrado(null); setItens([]); setForm({}); load()
    } catch(e) { addToast(e.message, 'error') }
  }

  const confirmar = async id => {
    try { await POST(`/emprestimos/${id}/confirmar`, {}); addToast('Confirmado!', 'success'); load() }
    catch(e) { addToast(e.message, 'error') }
  }
  const recusar = async id => {
    if (!confirm('Recusar este empréstimo?')) return
    try { await POST(`/emprestimos/${id}/recusar`, {}); addToast('Recusado.', 'success'); load() }
    catch(e) { addToast(e.message, 'error') }
  }
  const devolver = async id => {
    if (!confirm('Confirmar devolução?')) return
    try { await POST(`/emprestimos/${id}/devolver`, {}); addToast('Devolução registrada!', 'success'); load() }
    catch(e) { addToast(e.message, 'error') }
  }

  const avalLider = async sig => {
    try {
      await POST(`/emprestimos/${sigModal.id}/aval-lider`, { assinatura: sig })
      addToast('Empréstimo aprovado e ativo!', 'success')
      setSigModal(null); load()
    } catch(e) { addToast(e.message, 'error') }
  }

  const filtrados = lista.filter(e => !filtro || e.status === filtro)
  const [filtradosTela, fimFiltrados] = useAosPoucos(filtrados)

  return (
    <div>
      <div className="topbar">
        <h2>Empréstimos entre Operários</h2>
        {user.role === 'operario' && <button className="btn btn-accent" onClick={()=>setModal('novo')}><Icon name="plus" size={14}/> Solicitar Empréstimo</button>}
      </div>

      <div className="card">
        <div className="card-body" style={{paddingBottom:0}}>
          <select value={filtro} onChange={e=>setFiltro(e.target.value)} style={{width:'auto',marginBottom:16}}>
            <option value="">Todos</option>
            <option value="aguardando_tomador">Aguard. confirmação</option>
            <option value="aguardando_lider">Aguard. aval líder</option>
            <option value="ativo">Ativos</option>
            <option value="devolvido">Devolvidos</option>
            <option value="recusado">Recusados</option>
          </select>
        </div>
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Solicitante</th><th>Tomador</th><th>Líder</th><th>Itens</th><th>Status</th><th>Ações</th></tr></thead>
          <tbody>
            {filtradosTela.map(e=>(
              <tr key={e.id}>
                <td data-label="Solicitante">{e.solicitante_nome}</td>
                <td data-label="Tomador">{e.tomador_nome}</td>
                <td data-label="Líder">{e.lider_nome||'—'}</td>
                <td data-label="Itens" style={{fontSize:'.82rem'}}>{e.itens.map(i=>`${i.ferramenta_nome} (${i.quantidade}x)`).join(', ')}</td>
                <td data-label="Status"><span className={`badge badge-${e.status}`}>{STATUS_LABEL[e.status]}</span></td>
                <td className="cell-actions"><div className="actions">
                  {e.status === 'aguardando_tomador' && user.id === e.tomador_id && <>
                    <button className="btn btn-success btn-sm" onClick={()=>confirmar(e.id)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="check" size={14}/> Confirmar</button>
                    <button className="btn btn-danger btn-sm" onClick={()=>recusar(e.id)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="x" size={14}/> Recusar</button>
                  </>}
                  {e.status === 'aguardando_lider' && user.id === e.lider_id && (
                    <button className="btn btn-accent btn-sm" onClick={()=>setSigModal(e)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="signature" size={14}/> Assinar aval</button>
                  )}
                  {e.status === 'ativo' && (user.id === e.solicitante_id || user.id === e.tomador_id) && (
                    <button className="btn btn-success btn-sm" onClick={()=>devolver(e.id)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="download" size={14}/> Devolver</button>
                  )}
                </div></td>
              </tr>
            ))}
            {!filtrados.length && <tr><td colSpan="6"><div className="empty"><div className="empty-icon"><Icon name="handshake" size={32}/></div><p>{filtro ? 'Nenhum empréstimo com esse status.' : 'Nenhum empréstimo registrado.'}</p>{!filtro && user.role==='operario' && <button className="btn btn-accent empty-cta" onClick={()=>setModal('novo')}><Icon name="plus" size={14}/> Solicitar empréstimo</button>}</div></td></tr>}
          </tbody>
        </table></div>{fimFiltrados}
      </div>

      {/* Modal novo empréstimo */}
      {modal === 'novo' && (
        <div className="modal-overlay open">
          <div className="modal modal-lg">
            <div className="modal-header"><h3>Solicitar Empréstimo</h3><button className="modal-close" onClick={()=>setModal(null)}>×</button></div>
            <div className="modal-body">
              <div className="alert alert-info">O colega precisará confirmar no próprio login, e o líder selecionado assinará o aval.</div>
              <div className="auth-device-box">
                <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="search" size={16}/> Buscar Operário pelo Email</h4>
                <div style={{display:'flex',gap:8,marginBottom:8}}>
                  <input type="email" value={buscaEmail} onChange={e=>{setBuscaEmail(e.target.value);setTomadorEncontrado(null)}} placeholder="email.exato@do.colega.com" style={{flex:1}} />
                  <button className="btn btn-primary" onClick={buscarTomador} disabled={buscando}>{buscando?'...':'Buscar'}</button>
                </div>
                {tomadorEncontrado && (
                  <div style={{background:'var(--tag-ok-bg)',color:'var(--tag-ok-fg)',padding:10,borderRadius:8,fontSize:'.88rem',display:'flex',alignItems:'center',gap:8}}>
                    <Icon name="checkCircle" size={15}/> Encontrado: <strong>{tomadorEncontrado.nome}</strong> — {tomadorEncontrado.cargo||ROLE_LABEL[tomadorEncontrado.role]}
                  </div>
                )}
                {buscaEmail && !tomadorEncontrado && !buscando && (
                  <div style={{background:'var(--tag-perigo-bg)',color:'var(--tag-perigo-fg)',padding:10,borderRadius:8,fontSize:'.88rem'}}>Nenhum operário encontrado com este email.</div>
                )}
              </div>
              <div className="form-group" style={{marginBottom:16}}>
                <label>Líder responsável *</label>
                <select value={form.lider_id||''} onChange={e=>setForm({...form,lider_id:e.target.value})}>
                  <option value="">Selecione o líder...</option>
                  {lideres.map(l=><option key={l.id} value={l.id}>{l.nome} — {l.cargo}</option>)}
                </select>
              </div>
              <label style={{display:'block',marginBottom:6}}>Ferramentas a emprestar *</label>
              <ItemsEditor ferramentas={ferramentas} value={itens} onChange={setItens} />
              <div className="form-group" style={{marginTop:12}}>
                <label>Observação</label>
                <textarea value={form.obs||''} onChange={e=>setForm({...form,obs:e.target.value})} placeholder="Motivo do empréstimo..." />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setModal(null)}>Cancelar</button>
              <button className="btn btn-accent" onClick={solicitar} disabled={!tomadorEncontrado||!itens.length} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="send" size={14}/> Enviar solicitação</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal aval líder */}
      {sigModal && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header"><h3>Aval do Líder</h3><button className="modal-close" onClick={()=>setSigModal(null)}>×</button></div>
            <div className="modal-body">
              <p style={{marginBottom:8}}><strong>De:</strong> {sigModal.solicitante_nome} → <strong>Para:</strong> {sigModal.tomador_nome}</p>
              <p style={{marginBottom:12}}>Itens: {sigModal.itens.map(i=>`${i.ferramenta_nome} (${i.quantidade}x)`).join(', ')}</p>
              <div className="alert alert-warning" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={16}/> Ambos os operários confirmaram. Ao assinar, você aprova este empréstimo.</div>
              <SignaturePad label={`Aval de ${user.nome}`} onConfirm={avalLider} onCancel={()=>setSigModal(null)} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// ─── LISTA EM ACORDEÃO (padrão reutilizável) ──────────────────────────────────
// Lista compacta: cada item mostra um resumo (título + info à direita). Tocar num
// item expande o painel de edição logo abaixo dele (entre os itens); tocar de novo
// fecha. Usado em Ferramentas, Usuários, etc. — o visual da lista/painel vive só
// aqui, então mudanças de design são feitas uma vez e valem para todas as telas.
function ListaAcordeao({ itens, keyOf, resumo, painel, novoAberto, painelNovo, abertoId, onToggle, vazio }) {
  // O item aberto fica sempre desenhado (a tela rola até o painel dele).
  const [itensTela, fimLista] = useAosPoucos(itens, 60, abertoId != null ? (it => keyOf(it) === abertoId) : null)
  if (!itens.length && !novoAberto) return vazio || null
  return (
    <div className="tool-list">
      {novoAberto && painelNovo}
      {itensTela.map(it => {
        const k = keyOf(it)
        const isOpen = abertoId === k
        const r = resumo(it)
        return (
          <div className="tool-row-wrap" key={k}>
            <button className={`tool-item ${isOpen?'open':''} ${r.sub&&!isOpen?'with-sub':''}`} onClick={()=>onToggle(it)}>
              <span className="ti-nome">{r.titulo}</span>
              <span className="ti-right">{r.direita}<span className="ti-chevron"><Icon name="chevronRight" size={18}/></span></span>
            </button>
            {r.sub && !isOpen && <div className="ti-sub">{r.sub}</div>}
            {isOpen && painel(it)}
          </div>
        )
      })}
      {fimLista}
    </div>
  )
}

// Casca padrão do painel de edição do acordeão (cabeçalho + fechar + rodapé).
// A página passa os campos (children) e os botões do rodapé (footer).
function PainelEdicao({ titulo, onFechar, children, footer }) {
  return (
    <div className="tool-edit-panel">
      <div className="tep-head">
        <span className="tep-title">{titulo}</span>
        <button className="tep-close" onClick={onFechar} aria-label="Fechar"><Icon name="x" size={16}/></button>
      </div>
      {children}
      <div className="tep-footer">{footer}</div>
    </div>
  )
}

// ─── FERRAMENTAS ──────────────────────────────────────────────────────────────
function FerramentasPage({ user, addToast, openTarget, clearOpenTarget }) {
  const [lista, setLista] = useState([])
  const [openId, setOpenId] = useState(null)   // id da ferramenta aberta, 'new', ou null
  const [form, setForm] = useState({})
  const [busca, setBusca] = useState('')
  const [confirmDel, setConfirmDel] = useState(false)
  const [mostrarFantasmas, setMostrarFantasmas] = useState(false)
  const [filtroP, setFiltroP] = useState(() => filtroDoAlvo(openTarget, 'ferramentas'))  // card do painel
  const isMaster = !!(user && user.is_master)
  const ct = useContratosCadastro(user)   // com 2+ contratos: o acervo novo escolhe o contrato (o de cada um é separado)
  const [filtroCt, setFiltroCt] = useState('')   // filtro da lista por contrato (só com 2+ contratos)
  const load = () => GET('/ferramentas').then(setLista)
  useEffect(() => { load() }, [])
  // Deep-link da busca: abre direto o painel da ferramenta pedida.
  useEffect(() => {
    if (!openTarget || openTarget.page !== 'ferramentas') return
    if (!openTarget.id) { clearOpenTarget && clearOpenTarget(); return }
    const f = lista.find(x => x.id === openTarget.id)
    if (f) { setForm({ ...f }); setConfirmDel(false); setOpenId(f.id); setBusca(''); clearOpenTarget && clearOpenTarget(); scrollPainelParaFoco() }
  }, [openTarget, lista])
  const abrirNovo = () => {
    const cid = Number(filtroCt) || (filtroP && filtroP.contrato) || ct.principal
    setForm({quantidade_total:1, ...(ct.multi && cid ? { contrato_id: cid } : {})}); setConfirmDel(false); setOpenId('new')
  }
  const toggle = f => {
    if (openId === f.id) { fechar(); return }
    setForm({...f}); setConfirmDel(false); setOpenId(f.id)
  }
  const fechar = () => { setOpenId(null); setConfirmDel(false) }
  const save = async () => {
    if (!form.nome) { addToast('Informe o nome.','error'); return }
    try {
      if (form.id) await PUT(`/ferramentas/${form.id}`, form)
      else await POST('/ferramentas', form)
      addToast(form.id ? 'Atualizada!' : 'Cadastrada!', 'success')
      fechar(); load()
    } catch(e) { addToast(e.message,'error') }
  }
  const del = async () => {
    try { await DEL(`/ferramentas/${form.id}`); addToast('Excluída!','success'); fechar(); load() }
    catch(e) { addToast(e.message,'error') }
  }
  const filtradas = lista.filter(f => casaBusca(busca, f.nome, f.codigo)
    && (!filtroCt || ct.de(f) === Number(filtroCt)))
  // Painel de edição/cadastro (usa a casca padrão PainelEdicao)
  const painel = () => {
    const temCodigo = !!(form.codigo && form.codigo.trim())
    const codigoLocked = !!(form.id && form.codigo && form.codigo.trim())
    const titulo = form.id ? (form.codigo ? `Patrimônio ${form.codigo}` : 'Editar ferramenta') : 'Nova ferramenta'
    const footer = confirmDel ? (
      <div style={{display:'flex',alignItems:'center',gap:10,width:'100%',justifyContent:'space-between',flexWrap:'wrap'}}>
        <span style={{fontSize:'.85rem',color:'var(--danger)',fontWeight:600,display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={15}/> Excluir esta ferramenta?</span>
        <div className="gap-8"><button className="btn btn-ghost btn-sm" onClick={()=>setConfirmDel(false)}>Não</button><button className="btn btn-danger btn-sm" onClick={del}>Sim, excluir</button></div>
      </div>
    ) : (<>
      <div>{isMaster && !user.admin && form.id && !temCodigo && <button className="btn btn-danger btn-sm" onClick={()=>setConfirmDel(true)}><Icon name="trash" size={14}/> Excluir</button>}</div>
      <div className="gap-8">
        <button className="btn btn-ghost btn-sm" onClick={fechar}>Cancelar</button>
        <button className="btn btn-primary btn-sm" onClick={save}><Icon name="check" size={14}/> Salvar</button>
      </div>
    </>)
    return (
      <PainelEdicao titulo={titulo} onFechar={fechar} footer={footer}>
        <div className="form-grid">
          <div className="form-group full"><label>Nome *</label><input value={form.nome||''} onChange={e=>setForm({...form,nome:e.target.value})} /></div>
          {ct.multi && (form.id
            ? <div className="form-group full"><label>Contrato</label><div style={{fontSize:'.88rem',fontWeight:600,padding:'4px 0'}}>{ct.nome(ct.de(form))}</div></div>
            : <div className="form-group full"><label>Contrato</label>
                <select value={form.contrato_id || ct.principal || ''} onChange={e=>setForm({...form,contrato_id:Number(e.target.value)})}>
                  {ct.contratos.filter(c=>c.ativo).map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
                </select>
                <span className="text-muted" style={{fontSize:'.72rem',marginTop:4,display:'block'}}>Cada contrato tem o próprio acervo: a equipe só pede ferramenta do acervo do contrato dela.</span>
              </div>)}
          <div className="form-group">
            <label>Código / Patrimônio</label>
            <input value={form.codigo||''} onChange={e=>!codigoLocked&&setForm({...form,codigo:e.target.value})} placeholder="FUR-001" disabled={codigoLocked} style={codigoLocked?{background:'var(--surface-alt)',cursor:'not-allowed'}:{}} />
            {codigoLocked && <span style={{fontSize:'.72rem',color:'var(--text-secondary)',marginTop:2,display:'inline-flex',alignItems:'center',gap:4}}><Icon name="lock" size={11}/> Código de patrimônio não pode ser alterado</span>}
          </div>
          <div className="form-group"><label>Categoria</label><input value={form.categoria||''} onChange={e=>setForm({...form,categoria:e.target.value})} /></div>
          <div className="form-group">
            <label>Quantidade total {temCodigo && <span style={{color:'var(--text-secondary)',fontWeight:400,fontSize:'.75rem'}}>(item único — fixo em 1)</span>}</label>
            <input type="number" min="0" value={temCodigo ? 1 : (form.quantidade_total??0)} onChange={e=>!temCodigo&&setForm({...form,quantidade_total:Math.max(0,parseInt(e.target.value)||0)})} disabled={temCodigo} style={temCodigo?{background:'var(--surface-alt)',cursor:'not-allowed'}:{}} />
            {form.id && form.quantidade_disponivel != null && <span style={{fontSize:'.72rem',marginTop:3,color:form.quantidade_disponivel<=0?'var(--danger)':'var(--text-secondary)',display:'inline-flex',alignItems:'center',gap:4}}><Icon name="package" size={11}/> {Math.max(0,form.quantidade_disponivel)} disponível agora · {form.quantidade_total-Math.max(0,form.quantidade_disponivel)} em uso</span>}
          </div>
          <div className="form-group full"><label>Valor unitário (R$)</label><input type="number" min="0" step="0.01" value={form.valor_unitario||''} onChange={e=>setForm({...form,valor_unitario:parseFloat(e.target.value)||0})} placeholder="0,00" /></div>
          <div className="form-group full"><label>Descrição</label><textarea value={form.descricao||''} onChange={e=>setForm({...form,descricao:e.target.value})} /></div>
        </div>
      </PainelEdicao>
    )
  }
  const vazio = <div className="empty"><div className="empty-icon"><Icon name="wrench" size={32}/></div><p>{busca ? 'Nenhuma ferramenta encontrada para essa busca.' : 'Nenhuma ferramenta cadastrada ainda.'}</p>{!busca && <button className="btn btn-accent empty-cta" onClick={abrirNovo}><Icon name="plus" size={14}/> Cadastrar ferramenta</button>}</div>
  // Resumo do item na lista (badge de quantidade + barra de disponibilidade).
  const resumo = f => {
    const total = f.quantidade_total || 0
    const disp = Math.max(0, f.quantidade_disponivel != null ? f.quantidade_disponivel : total)
    const emCampo = Math.max(0, total - disp)
    const esgotado = disp <= 0
    const val = f.valor_unitario || 0
    return {
      titulo: <><span className="nm">{f.nome}</span>{f.codigo && <span title="Item patrimonial único" style={{color:'var(--text-secondary)',display:'inline-flex',flexShrink:0}}><Icon name="lock" size={12}/></span>}<ContratoTag ct={ct} id={ct.de(f)} compacta/></>,
      direita: <span className="qtd-badge" title={`${disp} disponível de ${total} no total`} style={esgotado?{color:'var(--danger)',borderColor:'var(--danger)'}:(disp!==total?{color:'var(--warning)',borderColor:'var(--warning)'}:null)}>{disp}{disp!==total && <span style={{color:'var(--text-secondary)',fontWeight:500}}> / {total}</span>}</span>,
      sub: total > 0 ? (
        <div className="tavail">
          <div className="tavail-row"><span>Disponibilidade</span><span><b>{emCampo}</b> em campo · <b>{disp}</b> {disp===1?'livre':'livres'}</span></div>
          <div className="tavail-track">
            {emCampo>0 && <span className="field" style={{width:(emCampo/total*100)+'%'}}></span>}
            {disp>0 && <span className="free" style={{width:(disp/total*100)+'%'}}></span>}
          </div>
          {val>0 && <div className="tavail-row"><span>Valor unitário</span><span className="val">{fmtBRL(val)}</span></div>}
        </div>
      ) : null
    }
  }
  // Divide o catálogo em três lugares: "Patrimônio" (itens únicos com código —
  // ativo de maior valor, foco de rastreabilidade), e o consumível/genérico
  // separado por DISPONIBILIDADE: "com ferramentas" (há unidade livre para
  // retirar) e "zeradas" (0 livres — seja por estoque zero ou tudo em campo).
  // Assim a ferramenta que "zerou" (esgotou o disponível) sai da coluna de
  // estoque e vai para as zeradas, alinhado ao badge vermelho de esgotado.
  const temPatr = f => !!(f.codigo && f.codigo.trim())
  const dispDe = f => Math.max(0, f.quantidade_disponivel != null ? f.quantidade_disponivel : (f.quantidade_total || 0))
  // "Fantasma": consumível/genérico que nunca teve estoque real (total 0) — cadastro
  // vazio/duplicado. Some da lista por padrão para não poluir; reaparece ao buscar
  // pelo nome ou ativando o toggle. NÃO é o mesmo que "tudo em campo" (total>0,
  // disponível 0), que continua visível na coluna Zeradas por ser estoque legítimo.
  const ehFantasma = f => !temPatr(f) && (f.quantidade_total || 0) <= 0
  const fantasmas = filtradas.filter(ehFantasma)
  const ocultarFantasmas = !busca && !mostrarFantasmas
  // Card do painel: só patrimônio e/ou só o acervo de um contrato.
  const noFiltroP = f => !filtroP || ((filtroP.contrato == null || f.contrato_id === filtroP.contrato) && (!filtroP.patrimonio || temPatr(f)))
  const visiveis = (ocultarFantasmas ? filtradas.filter(f => !ehFantasma(f)) : filtradas).filter(noFiltroP)
  const patrimonio = visiveis.filter(temPatr)
  const comFerr = visiveis.filter(f => !temPatr(f) && dispDe(f) > 0)
  const zeradas = visiveis.filter(f => !temPatr(f) && dispDe(f) <= 0)
  const vazioCol = txt => <div className="ferr-empty"><span className="fe-ic"><Icon name="wrench" size={22}/></span>{txt}</div>
  return (
    <div className="ferr-page">
      <div className="topbar"><h2>Ferramentas</h2><button className="btn btn-accent" onClick={abrirNovo}><Icon name="plus" size={14}/> Cadastrar</button></div>
      <FiltroPainel filtro={filtroP} n={visiveis.length} onLimpar={()=>setFiltroP(null)} />
      <div className="card">
        <div className="card-body" style={{paddingBottom:20}}>
          <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
            <input placeholder="Buscar por nome ou código..." value={busca} onChange={e=>setBusca(e.target.value)} style={{flex:'1 1 220px',minWidth:0}} />
            {ct.multi && (
              <select value={filtroCt} onChange={e=>setFiltroCt(e.target.value)} style={{width:'auto',maxWidth:'100%'}} aria-label="Filtrar por contrato">
                <option value="">Todos os contratos</option>
                {ct.contratos.map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            )}
          </div>
          {!busca && fantasmas.length > 0 && (
            <label style={{display:'inline-flex',alignItems:'center',gap:7,marginTop:10,fontSize:'.82rem',color:'var(--text-secondary)',cursor:'pointer'}}>
              <input type="checkbox" checked={mostrarFantasmas} onChange={e=>setMostrarFantasmas(e.target.checked)} />
              Mostrar {fantasmas.length} ferramenta(s) sem estoque cadastrado (0/0)
            </label>
          )}
        </div>
      </div>
      {/* Acervo vazio (contrato novo, deploy novo): o "Cadastrar" abre o formulário — antes o vazio o escondia. */}
      {lista.length === 0 && !busca && openId !== 'new' ? (
        <div className="card">{vazio}</div>
      ) : (
        <>
        <div className="card ferr-col ferr-patr">
          <div className="ferr-col-head patr">
            <span className="fch-title"><Icon name="lock" size={16}/> Patrimônio</span>
            <span className="fch-count">{patrimonio.length}</span>
          </div>
          <div className="ferr-patr-note">Itens únicos rastreados por código de patrimônio — controle individual de responsabilidade.</div>
          <ListaAcordeao
            itens={patrimonio} keyOf={f=>f.id} abertoId={openId} onToggle={toggle}
            novoAberto={false} painel={()=>painel()}
            vazio={vazioCol(busca ? 'Nenhum item de patrimônio para essa busca.' : 'Nenhuma ferramenta com código de patrimônio ainda.')}
            resumo={resumo}
          />
        </div>
        <div className="ferr-cols">
          <div className="card ferr-col">
            <div className="ferr-col-head ok">
              <span className="fch-title"><Icon name="checkCircle" size={16}/> Com ferramentas</span>
              <span className="fch-count">{comFerr.length}</span>
            </div>
            <ListaAcordeao
              itens={comFerr} keyOf={f=>f.id} abertoId={openId} onToggle={toggle}
              novoAberto={openId==='new'} painelNovo={painel()} painel={()=>painel()}
              vazio={vazioCol(busca ? 'Nenhuma ferramenta com estoque para essa busca.' : 'Nenhuma ferramenta com estoque.')}
              resumo={resumo}
            />
          </div>
          <div className="card ferr-col">
            <div className="ferr-col-head zero">
              <span className="fch-title"><Icon name="alertTriangle" size={16}/> Zeradas</span>
              <span className="fch-count">{zeradas.length}</span>
            </div>
            <ListaAcordeao
              itens={zeradas} keyOf={f=>f.id} abertoId={openId} onToggle={toggle}
              novoAberto={false} painel={()=>painel()}
              vazio={vazioCol(busca ? 'Nenhuma ferramenta zerada para essa busca.' : 'Nenhuma ferramenta zerada.')}
              resumo={resumo}
            />
          </div>
        </div>
        </>
      )}
    </div>
  )
}

// ─── ESTOQUE (Sede + Niterói · livro-razão) ────────────────────────────────────
// O Cautelix é o dono do saldo; as NF-e chegam pelo Qive ou por XML. Entrada por nota (de-para memorizado
// por fornecedor, conversão de unidade, parcial), saída automática na retirada da remessa do REC,
// entrada manual (material sem nota), transferência entre depósitos e ajuste de inventário.
// Diretor/gerente só visualizam.
const EST_TIPO = { saldo_inicial: 'Saldo inicial', entrada_nfe: 'Entrada NF-e', entrada_manual: 'Entrada manual', saida_remessa: 'Saída (remessa)',
  transf_saida: 'Transf. saída', transf_entrada: 'Transf. entrada', ajuste: 'Ajuste', ajuste_custo: 'Correção de custo' }
const estBRL = v => v == null ? '—' : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
const estNum = v => v == null ? '—' : Number(v).toLocaleString('pt-BR', { maximumFractionDigits: 3 })
// Coluna Qtd do kardex. A correção de custo (Master/Admin) não mexe na quantidade: "—", não um "0" verde.
const estQtdMov = (m, un) => m.tipo === 'ajuste_custo' ? <span className="est-sub">—</span>
  : <span style={{ color: m.quantidade < 0 ? 'var(--danger)' : 'var(--success)', fontWeight: 700 }}>{m.quantidade > 0 ? '+' : ''}{estNum(m.quantidade)}{un ? <> <span className="est-sub">{un}</span></> : null}</span>
const estQtdPos = v => Math.max(0, Math.round(Number(v) * 10000) / 10000)   // evita 0.30000000004 e negativo
const estData = d => d ? d.slice(0, 10).split('-').reverse().join('/') : '—'
const estRotItem = c => c.codigo ? `${c.nome} · ${c.codigo}` : c.nome

// Campo de texto com sugestões logo abaixo — substitui o <datalist> do navegador, que só achava o texto literal (com
// acento). A busca é a dos filtros (termosBusca/casaTermos). A lista fica no fluxo da página (não flutua): dentro de modal
// não some atrás de nada, e ao abrir rola para ficar à vista (no iPhone o teclado cobre a metade de baixo). Quem usa guarda
// o texto (valor/aoMudar(texto, opcao)); escolher uma sugestão põe o `rotulo` dela no campo.
// opcoes: [{ chave, rotulo, titulo, sub, busca (já em semAcento) }]. livre = texto livre (fornecedor novo, por exemplo):
// nada vem destacado, e o Enter só escolhe a sugestão que a pessoa marcou com as setas — senão envia o formulário.
const SUG_MAX = 40
function CampoSugestoes({ valor, aoMudar, opcoes, vazio, livre = false, onFocus, onBlur, ...props }) {
  const [aberto, setAberto] = useState(false)
  const [foco, setFoco] = useState(livre ? -1 : 0)
  const listRef = useRef(null)
  const id = React.useId()
  const termos = termosBusca(valor)
  const achados = aberto && termos.length ? opcoes.filter(o => casaTermos(termos, o.busca)) : []
  const vis = achados.slice(0, SUG_MAX)
  const mostra = aberto && termos.length > 0 && (vis.length > 0 || !!vazio)
  useEffect(() => { const el = listRef.current && listRef.current.querySelector('.cmd-item.on'); if (el) el.scrollIntoView({ block: 'nearest' }) }, [foco])
  useEffect(() => { if (mostra && listRef.current) listRef.current.scrollIntoView({ block: 'nearest' }) }, [mostra])
  const escolher = o => { setAberto(false); aoMudar(o.rotulo, o) }
  const onKey = e => {
    if (!mostra || !vis.length) return
    if (e.key === 'ArrowDown') { e.preventDefault(); setFoco(i => Math.min(i + 1, vis.length - 1)) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setFoco(i => Math.max(i - 1, 0)) }
    else if (e.key === 'Enter' && (!livre || foco >= 0)) { e.preventDefault(); escolher(vis[foco] || vis[0]) }
    else if (e.key === 'Tab' && !livre && vis.length === 1) escolher(vis[0])   // uma sugestão só: Tab aceita e segue
    else if (e.key === 'Escape') { e.preventDefault(); setAberto(false) }
  }
  return (
    <div style={{ minWidth: 0 }}>
      <input {...props} value={valor} autoComplete="off" role="combobox" aria-autocomplete="list" aria-expanded={mostra} aria-controls={id}
        aria-activedescendant={mostra && vis[foco] ? `${id}-${foco}` : undefined} onKeyDown={onKey}
        onChange={e => { setAberto(true); setFoco(livre ? -1 : 0); aoMudar(e.target.value, null) }}
        onFocus={e => { if (termos.length && !opcoes.some(o => o.rotulo === valor)) setAberto(true); onFocus && onFocus(e) }}
        onBlur={e => { setAberto(false); onBlur && onBlur(e) }} />
      {mostra && (
        <div className="est-pick-list" ref={listRef} role="listbox" id={id}>
          {vis.length ? vis.map((o, i) => (
            <button key={o.chave} id={`${id}-${i}`} type="button" tabIndex={-1} role="option" aria-selected={i === foco}
              className={`cmd-item ${i === foco ? 'on' : ''}`} onMouseEnter={() => setFoco(i)} onMouseDown={e => e.preventDefault()} onClick={() => escolher(o)}>
              <span className="cmd-tt">{o.titulo}{o.sub ? <span className="rib-sub">{o.sub}</span> : null}</span>
            </button>
          )) : <div className="est-pick-vazio">{vazio}</div>}
          {achados.length > vis.length && <div className="est-pick-vazio">+ {achados.length - vis.length} — digite mais para refinar</div>}
        </div>
      )}
    </div>
  )
}

// Campo de item do catálogo do Estoque (Entrada, Transferir, Ajustar, Solicitar compra, Pedido à Sede, Notas a lançar):
// procura pelo nome e pelo código, como o datalist que substituiu (a categoria não entra — "tinta" traria a categoria
// Tintas inteira). value/onChange = id do item ('' enquanto o texto não é um item).
function EstItemPicker({ catalogo, value, onChange, placeholder }) {
  const sel = catalogo.find(c => String(c.id) === String(value))
  const [txt, setTxt] = useState(sel ? estRotItem(sel) : '')
  // O formulário pode trocar ou limpar o item por fora (Notas a lançar recarregadas, sugestão aceita): o texto acompanha.
  useEffect(() => {
    if (sel) { if (estRotItem(sel) !== txt) setTxt(estRotItem(sel)) }
    else if (!value && catalogo.some(c => estRotItem(c) === txt)) setTxt('')
  }, [value, catalogo])
  const opcoes = React.useMemo(() => catalogo.map(c => ({ chave: c.id, rotulo: estRotItem(c), busca: semAcento(estRotItem(c)), id: c.id,
    titulo: <>{c.nome}{c.unidade ? <span className="cmd-sub"> ({c.unidade})</span> : null}</>, sub: [c.codigo, c.categoria].filter(Boolean).join(' · ') })), [catalogo])
  return <CampoSugestoes valor={txt} opcoes={opcoes} placeholder={placeholder || 'Buscar item do catálogo…'} vazio={`Nenhum item do catálogo com “${txt.trim()}”.`}
    aoMudar={(v, o) => { setTxt(v); const c = o || opcoes.find(x => x.rotulo === v); onChange(c ? c.id : '') }} />
}

// Almoxarife 2 só vê e só movimenta a base dele (Niterói, Costellation…) — o backend nem manda os números da Sede;
// aqui os seletores já oferecem só o que ele pode usar. A base DELE (user.base_id), não toda base: a lista de
// depósitos (/rec/depositos) traz as outras bases também, e o filtro de Movimentações oferecia "Niterói" ao
// Almoxarife 2 da Costellation — escolhendo, a lista voltava vazia (o servidor só manda a base dele).
const estDepsMov = (user, deps) => user.role === 'almoxarife2' ? deps.filter(d => d.id === user.base_id) : deps
// Resposta do /estoque/transferir: para uma base vira remessa em trânsito (entra lá na assinatura da chegada).
const estMsgTransf = r => r && r.em_transito ? `${r.numero} a caminho de ${r.para}: entra no saldo de lá quando o almoxarife 2 conferir e assinar a chegada.` : 'Transferência registrada.'
// Valor em R$ é da Sede: o almoxarife 2 vê quantidade, categoria e mínimo (o backend nem manda o custo).
const estVeValor = user => user.role !== 'almoxarife2'

function EstoquePage({ user, addToast, openTarget, clearOpenTarget }) {
  // Atalho das Pendências abre direto numa sub-aba (navigate('estoque', 'pedidos')).
  const [aba, setAba] = useState(openTarget && openTarget.page === 'estoque' && openTarget.id ? openTarget.id : 'saldo')
  // Atalhos do Painel do Almoxarife 2: { prefill } monta o pedido à Sede com o que falta, { chegada } abre a
  // conferência daquele envio e { novaCompra } abre o "Solicitar compra". Lidos uma vez, na montagem.
  const [alvo] = useState(() => (openTarget && openTarget.page === 'estoque' && openTarget.filtro) || {})
  const [resumo, setResumo] = useState(null)
  const [prefill, setPrefill] = useState(alvo.prefill || null)   // itens que a Reposição (ou o Painel) manda para um pedido novo à Sede
  const escrita = ['almoxarifado', 'almoxarife2', 'compras', 'administracao'].includes(user.role) && !user.ceo && !user.tour
  const veNotas = user.role !== 'almoxarife2'   // notas fiscais são da Sede/compras, não do almoxarife 2
  const carregarResumo = () => GET('/estoque/resumo').then(setResumo).catch(e => addToast(e.message, 'error'))
  useEffect(() => { if (openTarget && clearOpenTarget) clearOpenTarget(); carregarResumo() }, [])
  const podeInventario = escrita && user.role === 'almoxarifado'
  const almox2 = user.role === 'almoxarife2'
  const pedirASede = itens => { setPrefill(itens); setAba('pedidos') }
  // Pedem compra o almoxarifado da Sede e o Almoxarife 2 de base com a compra ligada (Costellation…; Niterói
  // não — só pede à Sede). `compra` = formulário aberto ({ inicial } vindo da Reposição ou vazio pelo topo);
  // `versaoCompras` recarrega Reposição e Compras pedidas.
  const baseCompra = almox2 && !!user.base_nome && !!user.base_compra
  const podeComprar = escrita && (user.role === 'almoxarifado' || baseCompra)
  const [compra, setCompra] = useState(alvo.novaCompra && podeComprar ? {} : null)
  const [versaoCompras, setVersaoCompras] = useState(0)
  const abas = [
    { id: 'saldo', label: 'Saldo', icon: 'layers' },
    { id: 'reposicao', label: 'Abaixo do mínimo', icon: 'alertTriangle', badge: resumo && resumo.abaixo_minimo },   // id antigo: deep-links do Painel
    ...(!almox2 || baseCompra ? [{ id: 'compras', label: 'Compras pedidas', icon: 'cart' }] : []),
    // O badge é de quem tem que agir: a Sede envia o que está aberto; a base assina a chegada do que está em trânsito.
    { id: 'pedidos', label: almox2 ? 'Pedidos à Sede' : 'Pedidos das bases', icon: 'send', badge: resumo && (almox2 ? resumo.pedidos_em_transito : resumo.pedidos_abertos) },
    ...(veNotas ? [{ id: 'notas', label: 'Notas a lançar', icon: 'fileText', badge: resumo && resumo.notas_pendentes }] : []),
    { id: 'movimentos', label: 'Movimentações', icon: 'history' },
    ...(podeInventario ? [{ id: 'inventario', label: 'Inventário', icon: 'clipboard' }] : []),
    ...(escrita ? [{ id: 'operacoes', label: 'Entrada / Transferir / Ajustar', icon: 'exchange' }] : []),
  ]
  // Área reservada ao Master (o backend só manda direto_obra para ele).
  if (resumo && resumo.direto_obra) abas.push({ id: 'direto', label: 'Direto p/ obra', icon: 'lock', badge: resumo.direto_obra.pendentes })
  if (resumo && resumo.pj_bloqueados != null) abas.push({ id: 'pj', label: 'PJs bloqueados', icon: 'eyeOff' })
  const iniciado = resumo && resumo.iniciado
  const veValor = estVeValor(user)
  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <div className="topbar"><h2>Estoque</h2>
        <div className="topbar-actions">
          {!escrita && <span className="badge" style={{ background: 'var(--bg)', color: 'var(--text-secondary)', border: '1px solid var(--border)' }}>Somente visualização</span>}
          {user.role === 'almoxarife2' && <span className="badge" style={{ background: 'var(--bg)', color: 'var(--text-secondary)', border: '1px solid var(--border)' }}>Depósito {user.base_nome || 'de base'}</span>}
          {podeComprar && <button className="btn btn-accent btn-sm" onClick={() => setCompra({})}><Icon name="cart" size={14} /> Solicitar compra</button>}
        </div>
      </div>
      {resumo && !iniciado && <EstCargaInicial resumo={resumo} addToast={addToast} onFeito={() => { carregarResumo(); setAba('saldo') }} />}
      {resumo && (
        <div className="stats-grid">
          {resumo.depositos.map(d => (
            veValor ? <div key={d.id} className="stat-card blue"><div className="stat-label">{d.nome}</div>
              <ValorCard v={d.valor} />
              <div className="est-sub">{d.itens || 0} itens com saldo</div></div>
            : <div key={d.id} className="stat-card blue"><div className="stat-label">{d.nome} — itens com saldo</div>
              <div className="stat-value">{d.itens || 0}</div>
              <div className="est-sub">em {d.categorias || 0} categoria{d.categorias === 1 ? '' : 's'}</div></div>
          ))}
          {veValor && resumo.depositos.length > 1 && <div className="stat-card"><div className="stat-label">Total em estoque</div><ValorCard v={resumo.valor_total} /><div className="est-sub">custo médio × saldo</div></div>}
          <div className={`stat-card ${resumo.abaixo_minimo ? 'red' : 'green'}`} style={{ cursor: 'pointer' }} onClick={() => setAba('reposicao')}><div className="stat-label">Abaixo do mínimo</div><div className="stat-value">{resumo.abaixo_minimo}</div><div className="est-sub">itens a repor</div></div>
          {veNotas && <div className={`stat-card ${resumo.notas_pendentes ? '' : 'green'}`} style={{ cursor: 'pointer' }} onClick={() => setAba('notas')}><div className="stat-label">Notas aguardando entrada</div><div className="stat-value">{resumo.notas_pendentes}</div><div className="est-sub">{resumo.notas_aguardando ? `+ ${resumo.notas_aguardando} aguardando material` : 'Qive · XML'}</div></div>}
        </div>
      )}
      <div className="uni-tabs">
        {abas.map(a => (
          <button key={a.id} className={`uni-tab ${aba === a.id ? 'active' : ''}`} onClick={() => setAba(a.id)}>
            <Icon name={a.icon} size={15} /> {a.label}{a.badge > 0 && <span className="est-tab-badge">{a.badge}</span>}
          </button>
        ))}
      </div>
      {aba === 'saldo' && <EstSaldo user={user} escrita={escrita} iniciado={iniciado} addToast={addToast} onVerAbaixo={() => setAba('reposicao')} onMudou={carregarResumo} />}
      {aba === 'reposicao' && <EstReposicao user={user} escrita={escrita} iniciado={iniciado} addToast={addToast} onMudou={carregarResumo} onPedirASede={pedirASede}
        versao={versaoCompras} onPedirCompra={podeComprar ? inicial => setCompra({ inicial }) : null} />}
      {aba === 'compras' && (!almox2 || baseCompra) && <EstComprasPedidas user={user} podePedir={podeComprar} versao={versaoCompras} onSolicitar={() => setCompra({})} addToast={addToast} />}
      {aba === 'pedidos' && <EstPedidos user={user} iniciado={iniciado} prefill={prefill} onPrefillUsado={() => setPrefill(null)} abrirChegadaId={alvo.chegada} addToast={addToast} onMudou={carregarResumo} />}
      {aba === 'notas' && veNotas && <EstNotas escrita={escrita} iniciado={iniciado} addToast={addToast} onMudou={carregarResumo} />}
      {aba === 'movimentos' && <EstMovimentos user={user} addToast={addToast} />}
      {aba === 'inventario' && podeInventario && <EstInventario iniciado={iniciado} addToast={addToast} onMudou={carregarResumo} />}
      {aba === 'operacoes' && escrita && <EstOperacoes user={user} iniciado={iniciado} addToast={addToast} onMudou={carregarResumo} />}
      {aba === 'direto' && resumo && resumo.direto_obra && <EstDiretoObra addToast={addToast} onMudou={carregarResumo} />}
      {aba === 'pj' && resumo && resumo.pj_bloqueados != null && <EstPjBloqueados addToast={addToast} onMudou={carregarResumo} />}
      {compra && <EstSolicitarCompra user={user} inicial={compra.inicial} addToast={addToast} onFechar={() => setCompra(null)} onFeito={() => { setCompra(null); setVersaoCompras(v => v + 1) }} />}
    </div>
  )
}

// Estoque ainda não iniciado: só o Master de verdade faz a carga inicial (digitando INICIAR).
function EstCargaInicial({ resumo, addToast, onFeito }) {
  const [conf, setConf] = useState('')
  const [busy, setBusy] = useState(false)
  const iniciar = async () => {
    setBusy(true)
    try {
      const r = await POST('/estoque/carga-inicial', { confirmacao: conf })
      addToast(`Estoque iniciado: ${r.itens} saldo(s) importado(s)${r.negativos ? ` · ${r.negativos} negativo(s) zerado(s)` : ''}.`, 'success'); onFeito()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  return (
    <div className="alert alert-warning">
      <strong>Estoque ainda não iniciado.</strong> Até a carga inicial, os saldos exibidos são os gravados no cadastro e nenhum lançamento é aceito.
      {resumo.pode_iniciar ? (
        <div style={{ marginTop: 10, display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ fontWeight: 400 }}>A carga transforma esses saldos (Sede e bases) no saldo inicial e passa a controlar o estoque aqui. É feita <strong>uma única vez</strong>. Digite <strong>INICIAR</strong>:</span>
          <input value={conf} onChange={e => setConf(e.target.value)} style={{ maxWidth: 140 }} placeholder="INICIAR" />
          <button className="btn btn-primary btn-sm" disabled={busy || conf.trim().toUpperCase() !== 'INICIAR'} onClick={iniciar}>{busy ? 'Iniciando…' : 'Fazer carga inicial'}</button>
        </div>
      ) : <div style={{ marginTop: 6, fontWeight: 400 }}>Peça ao administrador master para fazer a carga inicial.</div>}
    </div>
  )
}

function EstSaldo({ user, escrita, iniciado, addToast, onVerAbaixo, onMudou }) {
  const [dados, setDados] = useState(null)
  const [data, setData] = useState('')   // '' = posição atual; AAAA-MM-DD = recalculada do histórico
  const [q, setQ] = useState('')
  const [catF, setCatF] = useState('')
  const [depF, setDepF] = useState('')
  const [soAbaixo, setSoAbaixo] = useState(false)
  const [verForaDe, setVerForaDe] = useState(null)   // a busca em que se clicou "mostrar" (busca nova = esconde de novo)
  const [kardex, setKardex] = useState(null)
  // Vem o catálogo inteiro (todos=1): quem decide o que aparece é o filtro abaixo — a busca precisa achar o item sem saldo.
  const carregar = () => GET('/estoque/saldos?todos=1' + (data ? '&data=' + data : '')).then(setDados).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [data])
  const hoje = new Date().toISOString().slice(0, 10)
  if (!dados) return <div className="card"><div className="card-body text-muted">Carregando…</div></div>
  const deps = depF ? dados.depositos.filter(d => String(d.id) === depF) : dados.depositos
  const varios = dados.depositos.length > 1   // almoxarife 2 só recebe a base dele: sem filtro nem coluna Total
  const cats = [...new Set(dados.itens.map(i => i.categoria).filter(Boolean))].sort()
  const t = q.trim().toLowerCase()
  const baixo = (i, d) => { const s = i.saldos[d.id]; return s && s.minimo > 0 && (s.qtd || 0) < s.minimo }
  // Saldo = o que está EM DIA (tem saldo e não está abaixo do mínimo); o que precisa repor — zerado ou com saldo abaixo do
  // mínimo — mora na aba "Abaixo do mínimo" (pedido do Maxwel, 30/10/2026: cada item numa aba só). Com depósito filtrado,
  // vale o depósito; em "Todos os depósitos" o item fica se estiver em dia em algum depósito (e o mínimo geral, se houver,
  // não estiver estourado) — os outros depósitos da linha podem aparecer em vermelho. O filtro "Abaixo do mínimo" mostra
  // os de repor (com e sem saldo). Numa busca, o "mostrar" do rodapé traz o que ficou de fora (é por ali que se acha um
  // item sem saldo nem mínimo para abrir o histórico e definir o mínimo). "Posição em" (data passada) é a posição de
  // fechamento: tudo o que tinha saldo, sem separar pelo mínimo (que é o de hoje).
  const temSaldo = i => depF ? !!(i.saldos[depF] && i.saldos[depF].qtd) : i.total > 0
  const abaixoEm = i => depF ? baixo(i, { id: Number(depF) }) : i.abaixo_minimo
  const emDiaEm = (i, id) => { const s = i.saldos[id]; return !!(s && s.qtd > 0 && !(s.minimo > 0 && s.qtd < s.minimo)) }
  const emDia = i => depF ? emDiaEm(i, depF) : !(i.estoque_minimo > 0 && i.total < i.estoque_minimo) && dados.depositos.some(d => emDiaEm(i, d.id))
  const noSaldo = i => data ? temSaldo(i) : emDia(i)
  const casa = i => casaBusca(t, i.nome, i.codigo) && (!catF || i.categoria === catF)
  const verFora = !!t && verForaDe === t
  const lista = dados.itens.filter(i => casa(i) && (soAbaixo ? abaixoEm(i) : noSaldo(i) || verFora))
  const foraBusca = t && !soAbaixo && !verFora ? dados.itens.filter(i => casa(i) && !noSaldo(i)).length : 0
  const abaixoFora = t || soAbaixo || data ? [] : dados.itens.filter(i => casa(i) && !noSaldo(i) && abaixoEm(i))
  const abaixoComSaldo = abaixoFora.filter(temSaldo).length, abaixoZerados = abaixoFora.length - abaixoComSaldo
  const veValor = estVeValor(user)
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title">Saldo por depósito <span className="text-muted" style={{ fontWeight: 400, fontSize: '.8rem' }}>· {lista.length} itens{!soAbaixo && !data && !verFora ? ' em dia' : ''}</span></span>
        <div className="est-filtros">
          <CampoBusca placeholder="Buscar item ou código…" valor={q} aoMudar={setQ} />
          <select value={catF} onChange={e => setCatF(e.target.value)}><option value="">Todas as categorias</option>{cats.map(c => <option key={c}>{c}</option>)}</select>
          {varios && <select value={depF} onChange={e => setDepF(e.target.value)}><option value="">Todos os depósitos</option>{dados.depositos.map(d => <option key={d.id} value={d.id}>{d.nome}</option>)}</select>}
          <label className="est-chk"><input type="checkbox" checked={soAbaixo} onChange={e => setSoAbaixo(e.target.checked)} /> Abaixo do mínimo</label>
          <label className="est-chk" title="Deixe vazio para a posição atual">Posição em <input type="date" value={data} max={hoje} onChange={e => setData(e.target.value)} style={{ minWidth: 0 }} /></label>
          <button className="btn btn-ghost btn-sm" onClick={() => baixarArquivo('/estoque/saldos.csv' + (data ? '?data=' + data : ''), `posicao-estoque-${data || hoje}.csv`).catch(e => addToast(e.message, 'error'))}><Icon name="download" size={13} /> Excel (CSV)</button>
        </div>
      </div>
      {data && <div className="alert alert-info" style={{ margin: '0 16px 12px' }}>Posição de <strong>{estData(data)}</strong> (fim do dia), recalculada pelo histórico de movimentações.{!iniciado && ' O histórico só começa na carga inicial — antes dela a posição fica vazia.'} Os mínimos mostrados são os atuais. <button className="est-link" onClick={() => setData('')}>voltar à posição atual</button></div>}
      {lista.length === 0 ? <div className="empty">{foraBusca ? 'Nenhum item em dia nessa busca.' : 'Nenhum item encontrado.'}</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Item</th>{deps.map(d => <th key={d.id} style={{ textAlign: 'right' }}>{d.nome}</th>)}{varios && <th style={{ textAlign: 'right' }}>Total</th>}{veValor && <><th style={{ textAlign: 'right' }}>Custo médio</th><th style={{ textAlign: 'right' }}>Valor</th></>}</tr></thead>
          <tbody>{lista.slice(0, 400).map(i => (
            <tr key={i.id} style={{ cursor: 'pointer' }} onClick={() => setKardex(i.id)}>
              <td data-label="Item"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{i.nome}{abaixoEm(i) && <span className="badge est-bad" style={{ marginLeft: 6 }}>abaixo do mínimo</span>}</div>
                <div className="est-sub">{[i.codigo, i.unidade, i.categoria].filter(Boolean).join(' · ')}</div></td>
              {deps.map(d => <td key={d.id} data-label={d.nome} className="est-num" style={baixo(i, d) ? { color: 'var(--danger)', fontWeight: 700 } : null}>
                {estNum(i.saldos[d.id] ? i.saldos[d.id].qtd : 0)}{i.saldos[d.id] && i.saldos[d.id].minimo > 0 && <span className="est-sub"> / mín {estNum(i.saldos[d.id].minimo)}</span>}</td>)}
              {varios && <td data-label="Total" className="est-num" style={{ fontWeight: 700 }}>{estNum(i.total)} <span className="est-sub">{i.unidade || ''}</span></td>}
              {veValor && <><td data-label="Custo médio" className="est-num">{estBRL(i.custo_medio)}</td>
              <td data-label="Valor" className="est-num">{estBRL(i.valor)}</td></>}
            </tr>))}</tbody>
        </table></div>
      )}
      {lista.length > 400 && <div className="card-body text-muted" style={{ fontSize: '.8rem' }}>Mostrando 400 de {lista.length}. Refine a busca.</div>}
      {abaixoFora.length > 0 && <div className="card-body est-sub" style={{ fontSize: '.85rem' }}>
        + {abaixoFora.length} {abaixoFora.length === 1 ? 'item abaixo do mínimo' : 'itens abaixo do mínimo'} ({[abaixoComSaldo && `${abaixoComSaldo} com saldo`,
          abaixoZerados && `${abaixoZerados} ${abaixoZerados === 1 ? 'zerado' : 'zerados'}`].filter(Boolean).join(', ')}) ·{' '}
        <button className="est-link" onClick={() => onVerAbaixo ? onVerAbaixo() : setSoAbaixo(true)}>ver em Abaixo do mínimo</button></div>}
      {foraBusca > 0 && <div className="card-body est-sub" style={{ fontSize: '.85rem' }}>
        + {foraBusca} {foraBusca === 1 ? 'item' : 'itens'} com “{q.trim()}” abaixo do mínimo ou sem saldo ·{' '}
        <button className="est-link" onClick={() => setVerForaDe(t)}>mostrar</button></div>}
      {kardex && <EstKardex id={kardex} user={user} depositos={dados.depositos} escrita={escrita} addToast={addToast} onClose={() => setKardex(null)}
        onMudou={() => { carregar(); onMudou && onMudou() }} />}
    </div>
  )
}

// Histórico (kardex) do item + mínimos por depósito.
function EstKardex({ id, user, depositos, escrita, addToast, onClose, onMudou }) {
  const editaveis = new Set(estDepsMov(user, depositos).map(d => d.id))
  const [it, setIt] = useState(null)
  const [mins, setMins] = useState({})
  const carregar = () => GET('/estoque/kardex/' + id).then(r => {
    setIt(r); const m = { geral: r.estoque_minimo ?? '' }
    for (const s of r.saldos) m[s.deposito_id] = s.minimo ?? ''
    setMins(m)
  }).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [id])
  const salvarMin = async depId => {
    try { await PUT('/estoque/minimo', { catalogo_id: id, deposito_id: depId === 'geral' ? null : depId, minimo: mins[depId] }); addToast('Mínimo salvo.', 'success'); onMudou() }
    catch (e) { addToast(e.message, 'error') }
  }
  const saldoDe = d => { const s = it && it.saldos.find(x => x.deposito_id === d.id); return s ? s.quantidade : 0 }
  const veValor = estVeValor(user)
  return (
    <div className="modal-overlay open" onClick={onClose}>
      <div className="modal modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header"><h3>{it ? it.nome : 'Carregando…'}</h3><button className="modal-close" onClick={onClose}>×</button></div>
        <div className="modal-body">
          {it && <>
            <div className="est-sub" style={{ marginBottom: 12 }}>{[it.codigo, it.unidade, it.categoria, it.ncm && 'NCM ' + it.ncm].filter(Boolean).join(' · ')}</div>
            <div className="est-mins">
              {depositos.map(d => (
                <div key={d.id} className="est-min-box"><div className="stat-label">{d.nome}</div>
                  <div style={{ fontSize: '1.3rem', fontWeight: 800, color: 'var(--ink)' }}>{estNum(saldoDe(d))} <span className="est-sub">{it.unidade || ''}</span></div>
                  {escrita && editaveis.has(d.id) ? <div className="est-min-edit"><span className="est-sub">mín.</span><input type="number" min="0" value={mins[d.id] ?? ''} onChange={e => setMins({ ...mins, [d.id]: e.target.value })} /><button className="btn btn-ghost btn-sm" onClick={() => salvarMin(d.id)}>Salvar</button></div>
                    : <div className="est-sub">mín. {mins[d.id] === '' || mins[d.id] == null ? '—' : estNum(mins[d.id])}</div>}
                </div>
              ))}
            </div>
            <div className="table-wrap" style={{ marginTop: 14 }}><table className="cards-mobile">
              <thead><tr><th>Data</th><th>Tipo</th><th>Depósito</th><th style={{ textAlign: 'right' }}>Qtd</th><th style={{ textAlign: 'right' }}>Saldo após</th>{veValor && <th style={{ textAlign: 'right' }}>Custo médio</th>}<th>Referência</th></tr></thead>
              <tbody>{it.movimentos.length === 0 ? <tr><td colSpan={veValor ? 7 : 6} className="text-muted">Sem movimentações.</td></tr> : it.movimentos.map(m => (
                <tr key={m.id}>
                  <td data-label="Data">{(m.criado_em || '').slice(0, 16).replace('T', ' ')}</td>
                  <td data-label="Tipo">{EST_TIPO[m.tipo] || m.tipo}</td>
                  <td data-label="Depósito">{m.deposito_nome}</td>
                  <td data-label="Qtd" className="est-num">{estQtdMov(m)}</td>
                  <td data-label="Saldo após" className="est-num">{estNum(m.saldo_apos)}</td>
                  {veValor && <td data-label="Custo médio" className="est-num">{estBRL(m.custo_medio_apos)}</td>}
                  <td data-label="Referência"><span className="est-sub">{m.obs || ''}{m.usuario_nome ? ` · ${m.usuario_nome}` : ''}</span></td>
                </tr>))}</tbody>
            </table></div>
          </>}
        </div>
      </div>
    </div>
  )
}

const EST_ORIGEM = { vobi: 'Vobi', qive: 'Qive', xml: 'XML' }
const estCnpj = c => { const d = String(c || '').replace(/\D/g, ''); return d.length === 14 ? d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : (c || '') }
const estLerTexto = f => new Promise((ok, falha) => { const r = new FileReader(); r.onload = () => ok(r.result); r.onerror = () => falha(new Error('Não consegui ler ' + f.name)); r.readAsText(f) })
const estQuando = iso => { if (!iso) return 'nunca'; try { return new Date(iso.includes('T') ? iso : iso.replace(' ', 'T')).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) } catch { return iso } }

// Notas de entrada de TODAS as fontes: Qive (todos os CNPJs do grupo) e XML enviado à mão (qualquer
// CNPJ). As que vieram do Vobi (desligado em 28/09/2026) continuam na lista. Nunca entra duas vezes.
function EstNotas({ escrita, iniciado, addToast, onMudou }) {
  const [notas, setNotas] = useState(null)
  const [todas, setTodas] = useState(false)
  const [aberta, setAberta] = useState(null)
  const [busy, setBusy] = useState(false)
  const [fontes, setFontes] = useState(null)
  const [empresa, setEmpresa] = useState('')
  const [q, setQ] = useState('')
  const [envio, setEnvio] = useState(null)
  const fileRef = useRef(null)
  const carregar = () => GET('/estoque/notas' + (todas ? '?todas=1' : '')).then(setNotas).catch(e => addToast(e.message, 'error'))
  const carregarFontes = () => GET('/estoque/fontes').then(setFontes).catch(() => {})
  useEffect(() => { carregar() }, [todas])
  useEffect(() => { carregarFontes() }, [])
  const atualizarTudo = () => { carregar(); carregarFontes(); onMudou() }
  const buscar = async () => {
    setBusy(true)
    try {
      const r = await POST('/estoque/notas/buscar')
      const partes = Object.entries(r.fontes).map(([k, v]) => v.erro ? `${EST_ORIGEM[k]}: falhou (${v.erro})` : v.ocupado ? `${EST_ORIGEM[k]}: já sincronizando` : `${EST_ORIGEM[k]}: ${v.novas || 0} nova(s)`)
      addToast(partes.join(' · '), Object.values(r.fontes).some(v => v.erro) ? 'warning' : 'success'); atualizarTudo()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const enviarXml = async files => {
    const lista = [...(files || [])].slice(0, 50)
    if (!lista.length) return
    setBusy(true)
    try {
      const arquivos = await Promise.all(lista.map(async f => ({ nome: f.name, xml: await estLerTexto(f) })))
      const r = await POST('/estoque/notas/xml', { arquivos })
      setEnvio(r.resultado)
      addToast(`${r.novas} nota(s) nova(s) em ${lista.length} arquivo(s).`, r.novas ? 'success' : 'warning'); atualizarTudo()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false); if (fileRef.current) fileRef.current.value = '' }
  }
  if (aberta) return <EstLancarNota id={aberta} escrita={escrita && iniciado} addToast={addToast} onVoltar={() => { setAberta(null); atualizarTudo() }} />
  const ST = { a_lancar: ['A lançar', 'est-st-pend'], parcial: ['Parcial', 'est-st-parc'], lancada: ['Lançada', 'est-st-ok'],
    aguardando: ['Aguardando material', 'tg-alerta'], so_epi: ['Só EPI → Uniformes', 'tg-cobre'] }
  const automatica = fontes && fontes.qive.configurado
  const t = q.trim().toLowerCase()
  // O que dá para lançar agora vem primeiro; as que esperam o material chegar, logo depois.
  const ordem = s => s === 'a_lancar' || s === 'parcial' ? 0 : s === 'aguardando' ? 1 : 2
  const lista = (notas || []).filter(n => (!empresa || n.destinatario_cnpj === empresa)
    && casaBusca(t, n.numero, n.emitente, n.chave, n.destinatario))
    .sort((a, b) => ordem(a.status) - ordem(b.status))
  const ENV = { nova: ['nova', 'est-st-ok'], ja_existia: ['já estava', 'est-st-parc'], invalida: ['recusado', 'est-bad'] }
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title">Notas fiscais de entrada <span className="text-muted" style={{ fontWeight: 400, fontSize: '.8rem' }}>· {lista.length}</span></span>
        <div className="est-filtros">
          <input placeholder="NF, fornecedor ou chave…" value={q} onChange={e => setQ(e.target.value)} />
          {fontes && fontes.empresas.length > 1 && <select value={empresa} onChange={e => setEmpresa(e.target.value)}><option value="">Todas as empresas</option>{fontes.empresas.map(e => <option key={e.cnpj} value={e.cnpj}>{e.nome || estCnpj(e.cnpj)}</option>)}</select>}
          <label className="est-chk"><input type="checkbox" checked={todas} onChange={e => setTodas(e.target.checked)} /> Mostrar já lançadas</label>
          {escrita && automatica && <button className="btn btn-ghost btn-sm" disabled={busy} onClick={buscar}>{busy ? 'Buscando…' : 'Buscar notas novas'}</button>}
          {escrita && <>
            <input ref={fileRef} type="file" accept=".xml,text/xml,application/xml" multiple style={{ display: 'none' }} onChange={e => enviarXml(e.target.files)} />
            <button className="btn btn-outline btn-sm" disabled={busy} onClick={() => fileRef.current && fileRef.current.click()}><Icon name="inbox" size={13} /> Enviar XML</button>
          </>}
        </div>
      </div>
      {fontes && (
        <div className="est-fontes">
          <span className={`est-fonte ${fontes.qive.configurado ? 'on' : 'wait'}`} title={fontes.qive.configurado ? `Última consulta: ${estQuando(fontes.qive.ultimo_sync)}` : 'Assim que as chaves de API do Qive forem cadastradas no servidor, as notas de todos os CNPJs passam a chegar sozinhas a cada 30 min.'}><b>Qive</b> {fontes.qive.configurado ? `ativo · ${fontes.qive.notas} nota(s) · ${fontes.qive.filtra_cnpjs ? `${fontes.qive.filtra_cnpjs} CNPJ(s) do grupo` : 'todos os CNPJs'}` : 'pronto — aguardando contratação da API'}</span>
          <span className="est-fonte on"><b>XML manual</b> {fontes.xml.notas} nota(s) · qualquer CNPJ</span>
          {fontes.vobi.notas > 0 && <span className="est-fonte" title="Integração desligada em 28/09/2026. As notas que vieram antes continuam aqui."><b>Vobi</b> desligado · {fontes.vobi.notas} nota(s) antigas</span>}
        </div>
      )}
      {envio && (
        <div className="est-envio">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}><strong>Resultado do envio</strong><button className="est-link" onClick={() => setEnvio(null)}>fechar</button></div>
          {envio.map((r, k) => (
            <div key={k} className="est-envio-linha">
              <span className={`badge ${ENV[r.status][1]}`}>{ENV[r.status][0]}</span>
              <span style={{ fontWeight: 600 }}>{r.nome}</span>
              <span className="est-sub">{r.status === 'invalida' ? r.motivo : `NF ${r.numero || '—'} · ${r.emitente || ''}${r.destinatario ? ` → ${r.destinatario}` : ''} · ${r.itens} linha(s)`}</span>
            </div>
          ))}
        </div>
      )}
      {!notas ? <div className="card-body text-muted">Carregando…</div> : lista.length === 0 ? <div className="empty">{notas.length ? 'Nenhuma nota no filtro.' : `Nenhuma nota aguardando entrada.${automatica ? ' As fontes automáticas são consultadas a cada 30 min.' : ''}${escrita ? ' Para outro CNPJ, use "Enviar XML".' : ''}`}</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Emissão</th><th>NF</th><th>Fornecedor</th><th>Comprador</th><th>Linhas</th><th style={{ textAlign: 'right' }}>Valor</th><th>Situação</th><th></th></tr></thead>
          <tbody>{lista.map(n => (
            <tr key={n.id}>
              <td data-label="Emissão">{estData(n.data_emissao)}</td>
              <td data-label="NF">{n.numero || '—'} <span className="badge est-origem" title={`Veio por: ${EST_ORIGEM[n.origem] || n.origem}`}>{EST_ORIGEM[n.origem] || n.origem}</span></td>
              <td data-label="Fornecedor"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{n.emitente || '—'}</div>{n.usada_uniformes ? <span className="est-sub">usada em Uniformes/EPI</span> : null}</td>
              <td data-label="Comprador"><div>{n.destinatario || '—'}</div>{n.destinatario_cnpj && <span className="est-sub">{estCnpj(n.destinatario_cnpj)}</span>}</td>
              <td data-label="Linhas">{n.tratadas - (n.epi || 0)}/{n.qtd_itens - (n.epi || 0)}{n.epi > 0 && <div className="est-sub" title="Linhas de EPI/uniforme: vão para Uniformes/EPI, não para este estoque">+ {n.epi} de EPI</div>}</td>
              <td data-label="Valor" className="est-num">{estBRL(n.valor_total)}</td>
              <td data-label="Situação"><span className={`badge ${ST[n.status][1]}`}>{ST[n.status][0]}</span>
                {n.status === 'aguardando' && <div className="est-sub">desde {estData(n.aguardando_em)}{n.aguardando_nome ? ` · ${n.aguardando_nome.split(' ')[0]}` : ''}</div>}</td>
              <td data-label="">{(() => {
                const ver = ['lancada', 'so_epi'].includes(n.status) || !escrita || !iniciado
                return <button className={`btn btn-sm ${ver ? 'btn-ghost' : n.status === 'aguardando' ? 'btn-outline' : 'btn-primary'}`} onClick={() => setAberta(n.id)}>{ver ? 'Ver' : n.status === 'aguardando' ? 'Chegou? Dar entrada' : 'Dar entrada'}</button>
              })()}</td>
            </tr>))}</tbody>
        </table></div>
      )}
    </div>
  )
}

// PJs bloqueados (só o Master): PJs parceiros cuja nota é o pagamento da pessoa. As notas desses CNPJs
// ficam ocultas de todas as telas (Estoque e Uniformes/EPI) — quem lança nota não vê quanto cada um
// recebe. Nada é apagado: tirar da lista faz as notas voltarem. Aqui não aparece valor de nota.
function EstPjBloqueados({ addToast, onMudou }) {
  const [lista, setLista] = useState(null)
  const [q, setQ] = useState('')
  const [novo, setNovo] = useState({ cnpj: '', nome: '', obs: '' })
  const [busy, setBusy] = useState(false)
  const carregar = () => GET('/estoque/pj-bloqueados').then(setLista).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [])
  const bloquear = async () => {
    setBusy(true)
    try {
      const r = await POST('/estoque/pj-bloqueados', novo)
      addToast(`CNPJ bloqueado${r.notas ? ` — ${r.notas} nota(s) que já estavam no Cautelix ficaram ocultas` : ''}.`, 'success')
      setNovo({ cnpj: '', nome: '', obs: '' }); carregar(); onMudou()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const desbloquear = async b => {
    if (!confirm(`Desbloquear ${b.nome || b.obs || estCnpj(b.cnpj)}?\n\nAs notas deste CNPJ voltam a aparecer para Compras e Almoxarifado (com os valores).`)) return
    try { await DEL('/estoque/pj-bloqueados/' + b.id); addToast('CNPJ desbloqueado.', 'success'); carregar(); onMudou() } catch (e) { addToast(e.message, 'error') }
  }
  if (!lista) return <div className="card"><div className="card-body text-muted">Carregando…</div></div>
  const t = q.trim().toLowerCase(), td = t.replace(/\D/g, '')
  const filtrada = lista.filter(b => casaBusca(t, b.nome, b.obs) || (td && b.cnpj.includes(td)))
  const ocultas = lista.reduce((a, b) => a + b.notas, 0)
  const lancadas = lista.filter(b => b.lancadas > 0)
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title"><Icon name="eyeOff" size={15} /> PJs bloqueados <span className="text-muted" style={{ fontWeight: 400, fontSize: '.8rem' }}>· {lista.length} CNPJ(s) · só você vê</span></span>
        <div className="est-filtros"><input placeholder="Nome, função ou CNPJ…" value={q} onChange={e => setQ(e.target.value)} /></div>
      </div>
      <div className="card-body" style={{ paddingTop: 0 }}>
        <div className="est-sub" style={{ fontSize: '.84rem', marginBottom: 12 }}>A nota de um PJ parceiro é o pagamento da pessoa. As notas destes CNPJs <strong>não aparecem para ninguém</strong> — nem em Notas a lançar, nem em Uniformes/EPI, nem em contagens ou planilhas. Chegam pelo Qive e ficam guardadas, ocultas; tirar um CNPJ da lista faz as notas dele voltarem.{ocultas ? ` Hoje há ${ocultas} nota(s) oculta(s).` : ''}</div>
        {lancadas.length > 0 && <div className="alert alert-warning">{lancadas.map(b => `${b.nome || b.obs}: ${b.lancadas}`).join(' · ')} — nota(s) lançada(s) no estoque antes do bloqueio. A nota sumiu das filas, mas a entrada continua nas Movimentações.</div>}
        <div className="est-dob-forn est-dob-add" style={{ flexDirection: 'row', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 12 }}>
          <div style={{ flex: '1 1 170px' }}><div className="stat-label">CNPJ</div><input inputMode="numeric" value={novo.cnpj} placeholder="00.000.000/0000-00" onChange={e => setNovo({ ...novo, cnpj: e.target.value })} style={{ width: '100%' }} /></div>
          <div style={{ flex: '2 1 200px' }}><div className="stat-label">Nome</div><input value={novo.nome} placeholder="Nome do PJ" onChange={e => setNovo({ ...novo, nome: e.target.value })} style={{ width: '100%' }} /></div>
          <div style={{ flex: '1 1 140px' }}><div className="stat-label">Função</div><input value={novo.obs} placeholder="Ex.: Eletricista" onChange={e => setNovo({ ...novo, obs: e.target.value })} style={{ width: '100%' }} /></div>
          <button className="btn btn-primary btn-sm" disabled={busy || novo.cnpj.replace(/\D/g, '').length !== 14} onClick={bloquear}><Icon name="lock" size={13} /> Bloquear</button>
        </div>
      </div>
      {filtrada.length === 0 ? <div className="empty">{lista.length ? 'Nenhum CNPJ no filtro.' : 'Nenhum CNPJ bloqueado.'}</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>PJ</th><th>CNPJ</th><th style={{ textAlign: 'right' }}>Notas ocultas</th><th>Bloqueado em</th><th></th></tr></thead>
          <tbody>{filtrada.map(b => (
            <tr key={b.id}>
              <td data-label="PJ"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{b.nome || <span className="text-muted">sem nome na lista</span>}</div>{b.obs && <div className="est-sub">{b.obs}</div>}</td>
              <td data-label="CNPJ" style={{ whiteSpace: 'nowrap' }}>{estCnpj(b.cnpj)}</td>
              <td data-label="Notas ocultas" className="est-num">{b.notas}</td>
              <td data-label="Bloqueado em">{estData(b.criado_em)}<div className="est-sub">{b.usuario_nome || 'lista inicial'}</div></td>
              <td data-label=""><button className="est-link" onClick={() => desbloquear(b)}>desbloquear</button></td>
            </tr>))}</tbody>
        </table></div>
      )}
    </div>
  )
}

// Direto p/ obra (só o Master): fornecedores cujo material vai do fornecedor direto para a obra. As
// notas deles saem da fila de todos e não viram saldo; ficam aqui para consultar preço. Marcar um
// fornecedor mostra antes o que sai do estoque (prévia do servidor) e só grava na confirmação.
function EstDiretoObra({ addToast, onMudou }) {
  const [d, setD] = useState(null)
  const [vista, setVista] = useState('precos')
  const [q, setQ] = useState('')
  const [novo, setNovo] = useState('')
  const [previa, setPrevia] = useState(null)   // { forn:{cnpj,nome}, plano, jaMarcado }
  const [busy, setBusy] = useState(false)
  const [aberta, setAberta] = useState(null)
  const carregar = () => GET('/estoque/direto-obra').then(setD).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [])
  const rotCand = c => `${c.nome} · ${c.cnpj ? estCnpj(c.cnpj) : 'sem CNPJ'} · ${c.notas} nota(s)`
  const abrirPrevia = async (forn, jaMarcado) => {
    setBusy(true)
    try { setPrevia({ forn, jaMarcado, plano: await POST('/estoque/direto-obra/previa', forn) }) }
    catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const confirmar = async () => {
    setBusy(true)
    try {
      const r = await POST('/estoque/direto-obra', previa.forn)
      addToast(r.movimentos ? `${previa.forn.nome}: ${r.movimentos} entrada(s) tiradas do estoque (${estBRL(r.valor)})${r.itens_excluidos ? ` · ${r.itens_excluidos} item(ns) apagados do catálogo` : ''}.` : `${previa.forn.nome} marcado — as notas saíram da fila.`, 'success')
      setPrevia(null); setNovo(''); carregar(); onMudou()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const desmarcar = async f => {
    if (!confirm(`Tirar "${f.nome}" da lista?\n\nAs notas dele voltam para a fila "Notas a lançar" de Compras/Almoxarifado. O que já foi tirado do estoque não volta sozinho.`)) return
    try { await DEL('/estoque/direto-obra/' + f.id); addToast('Fornecedor tirado da lista.', 'success'); carregar(); onMudou() } catch (e) { addToast(e.message, 'error') }
  }
  if (!d) return <div className="card"><div className="card-body text-muted">Carregando…</div></div>
  const cand = d.candidatos.find(c => rotCand(c) === novo)
  // Tabela de preços: um registro por item do fornecedor (código dele, ou descrição) + unidade.
  const precos = (() => {
    const m = new Map()
    for (const n of d.notas) for (const i of n.itens) {
      const k = [n.emitente_cnpj || n.emitente, i.codigo || i.descricao, i.unidade].join('|').toLowerCase()
      const p = m.get(k) || { descricao: i.descricao, codigo: i.codigo, ncm: i.ncm, unidade: i.unidade, fornecedor: n.emitente, compras: 0, qtd: 0, total: 0, menor: null, maior: null, ultimo: null }
      const vu = Number(i.valor_unit) || (i.quantidade ? Number(i.valor_total) / Number(i.quantidade) : 0)
      p.compras++; p.qtd += Number(i.quantidade) || 0; p.total += Number(i.valor_total) || vu * (Number(i.quantidade) || 0)
      if (vu > 0) { p.menor = p.menor == null ? vu : Math.min(p.menor, vu); p.maior = p.maior == null ? vu : Math.max(p.maior, vu) }
      if (!p.ultimo || (n.data_emissao || '') > (p.ultimo.data || '')) p.ultimo = { preco: vu, data: n.data_emissao, nf: n.numero }
      m.set(k, p)
    }
    return [...m.values()].map(p => ({ ...p, medio: p.qtd ? p.total / p.qtd : null })).sort((a, b) => a.descricao.localeCompare(b.descricao))
  })()
  const t = q.trim().toLowerCase()
  const precosF = precos.filter(p => casaBusca(t, p.descricao, p.codigo, p.ncm, p.fornecedor))
  const notasF = d.notas.filter(n => casaBusca(t, n.numero, n.emitente, n.chave, ...n.itens.map(i => i.descricao)))
  const baixarPrecos = () => {
    const cel = v => { const x = v == null ? '' : typeof v === 'number' ? String(Math.round(v * 10000) / 10000).replace('.', ',') : String(v); return /[;"\n]/.test(x) ? `"${x.replace(/"/g, '""')}"` : x }
    const linhas = [['Fornecedor', 'Código', 'Descrição', 'NCM', 'Unidade', 'Último preço', 'Data', 'NF', 'Menor', 'Maior', 'Médio', 'Qtd comprada', 'Compras'].join(';')]
    for (const p of precosF) linhas.push([cel(p.fornecedor), cel(p.codigo), cel(p.descricao), cel(p.ncm), cel(p.unidade), cel(p.ultimo && p.ultimo.preco), cel(estData(p.ultimo && p.ultimo.data)), cel(p.ultimo && p.ultimo.nf),
      cel(p.menor), cel(p.maior), cel(p.medio), cel(p.qtd), cel(p.compras)].join(';'))
    const url = URL.createObjectURL(new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8' }))
    const a = document.createElement('a'); a.href = url; a.download = `precos-direto-obra-${new Date().toISOString().slice(0, 10)}.csv`; a.click(); URL.revokeObjectURL(url)
  }
  const pl = previa && previa.plano
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title"><Icon name="lock" size={15} /> Direto p/ obra <span className="text-muted" style={{ fontWeight: 400, fontSize: '.8rem' }}>· só você vê</span></span>
      </div>
      <div className="card-body" style={{ paddingTop: 0 }}>
        <div className="est-sub" style={{ fontSize: '.84rem', marginBottom: 12 }}>Fornecedores que entregam direto na obra. As notas deles <strong>não entram no estoque</strong> e não aparecem para Compras nem Almoxarifado — ficam aqui para consulta e precificação.</div>
        {d.fornecedores.filter(f => f.pendente.movimentos > 0).map(f => (
          <div key={'p' + f.id} className="alert alert-warning" style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ flex: 1, minWidth: 220 }}><strong>{f.nome}</strong>: {f.pendente.movimentos} linha(s) de {f.pendente.notas} nota(s) ainda estão no estoque ({estBRL(f.pendente.valor)}).</span>
            <button className="btn btn-danger btn-sm" disabled={busy} onClick={() => abrirPrevia({ cnpj: f.cnpj, nome: f.nome }, true)}><Icon name="trash" size={13} /> Ver e tirar do estoque</button>
          </div>
        ))}
        <div className="est-dob-forns">
          {d.fornecedores.map(f => (
            <div key={f.id} className="est-dob-forn">
              <div style={{ fontWeight: 700, color: 'var(--ink)' }}>{f.nome}</div>
              <div className="est-sub">{f.cnpj ? estCnpj(f.cnpj) : 'sem CNPJ'} · {f.notas} nota(s) · {estBRL(f.valor_total)}{f.ultima ? ` · última ${estData(f.ultima)}` : ''}</div>
              <div className="est-sub">Marcado em {estData(f.criado_em)}{f.usuario_nome ? ` por ${f.usuario_nome}` : ''}</div>
              <button className="est-link" style={{ marginTop: 4 }} onClick={() => desmarcar(f)}>tirar da lista</button>
            </div>
          ))}
          <div className="est-dob-forn est-dob-add">
            <div className="stat-label">Adicionar fornecedor</div>
            <CampoSugestoes valor={novo} aoMudar={v => setNovo(v)} placeholder="Buscar fornecedor (nome ou CNPJ)…" vazio="Nenhum fornecedor das notas com esse nome."
              opcoes={d.candidatos.map(c => ({ chave: (c.cnpj || '') + c.nome, rotulo: rotCand(c), titulo: c.nome, sub: rotCand(c).slice(c.nome.length + 3),
                busca: semAcento(`${c.nome} ${c.cnpj || ''} ${c.cnpj ? estCnpj(c.cnpj) : ''}`) }))} />
            <button className="btn btn-outline btn-sm" disabled={!cand || busy} onClick={() => abrirPrevia({ cnpj: cand.cnpj || null, nome: cand.nome }, false)}>Ver o que acontece</button>
          </div>
        </div>
      </div>
      <div className="uni-tabs" style={{ padding: '0 16px' }}>
        <button className={`uni-tab ${vista === 'precos' ? 'active' : ''}`} onClick={() => setVista('precos')}><Icon name="search" size={15} /> Preços</button>
        <button className={`uni-tab ${vista === 'notas' ? 'active' : ''}`} onClick={() => setVista('notas')}><Icon name="fileText" size={15} /> Notas <span className="est-sub">({d.notas.length})</span></button>
        <div className="est-filtros" style={{ marginLeft: 'auto' }}>
          <input placeholder={vista === 'precos' ? 'Item, código ou NCM…' : 'NF, fornecedor ou item…'} value={q} onChange={e => setQ(e.target.value)} />
          {vista === 'precos' && precosF.length > 0 && <button className="btn btn-ghost btn-sm" onClick={baixarPrecos}><Icon name="download" size={13} /> Excel (CSV)</button>}
        </div>
      </div>
      {vista === 'precos' && (precosF.length === 0 ? <div className="empty">{d.notas.length ? 'Nenhum item no filtro.' : 'Nenhuma nota destes fornecedores ainda.'}</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Item</th><th style={{ textAlign: 'right' }}>Último preço</th><th style={{ textAlign: 'right' }}>Menor</th><th style={{ textAlign: 'right' }}>Maior</th><th style={{ textAlign: 'right' }}>Médio</th><th style={{ textAlign: 'right' }}>Comprado</th></tr></thead>
          <tbody>{precosF.map((p, k) => (
            <tr key={k}>
              <td data-label="Item"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{p.descricao}</div>
                <div className="est-sub">{[p.codigo && 'cód. ' + p.codigo, p.unidade, p.ncm && 'NCM ' + p.ncm, d.fornecedores.length > 1 && p.fornecedor].filter(Boolean).join(' · ')}</div></td>
              <td data-label="Último preço" className="est-num"><div style={{ fontWeight: 700, color: 'var(--ink)' }}>{estBRL(p.ultimo && p.ultimo.preco)}</div><div className="est-sub">{estData(p.ultimo && p.ultimo.data)}{p.ultimo && p.ultimo.nf ? ` · NF ${p.ultimo.nf}` : ''}</div></td>
              <td data-label="Menor" className="est-num">{estBRL(p.menor)}</td>
              <td data-label="Maior" className="est-num">{estBRL(p.maior)}</td>
              <td data-label="Médio" className="est-num">{estBRL(p.medio)}</td>
              <td data-label="Comprado" className="est-num">{estNum(p.qtd)} <span className="est-sub">{p.unidade || ''} · {p.compras}×</span></td>
            </tr>))}</tbody>
        </table></div>
      ))}
      {vista === 'notas' && (notasF.length === 0 ? <div className="empty">Nenhuma nota{t ? ' no filtro' : ''}.</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Emissão</th><th>NF</th><th>Fornecedor</th><th>Comprador</th><th>Itens</th><th style={{ textAlign: 'right' }}>Valor</th><th></th></tr></thead>
          <tbody>{notasF.map(n => (
            <React.Fragment key={n.id}>
              <tr style={{ cursor: 'pointer' }} onClick={() => setAberta(aberta === n.id ? null : n.id)}>
                <td data-label="Emissão">{estData(n.data_emissao)}</td>
                <td data-label="NF">{n.numero || '—'} <span className="badge est-origem">{EST_ORIGEM[n.origem] || n.origem}</span></td>
                <td data-label="Fornecedor"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{n.emitente || '—'}</div></td>
                <td data-label="Comprador">{n.destinatario || '—'}</td>
                <td data-label="Itens">{n.itens.length}</td>
                <td data-label="Valor" className="est-num">{estBRL(n.valor_total)}</td>
                <td data-label="" onClick={e => e.stopPropagation()}>{n.tem_xml ? <button className="btn btn-ghost btn-sm" onClick={() => baixarArquivo(`/nfe/vobi/${n.id}/xml`, `${n.chave || 'NFe-' + (n.numero || n.id)}.xml`).catch(e => addToast(e.message, 'error'))}><Icon name="download" size={13} /> XML</button> : null}</td>
              </tr>
              {aberta === n.id && <tr><td colSpan="7" style={{ background: 'var(--bg)' }}>
                {n.itens.map(i => (
                  <div key={i.id} className="est-dob-item">
                    <span style={{ flex: 1, minWidth: 180 }}>{i.descricao}<span className="est-sub">{i.codigo ? ` · cód. ${i.codigo}` : ''}</span></span>
                    <span className="est-num">{estNum(i.quantidade)} {i.unidade || ''}</span>
                    <span className="est-num">{estBRL(i.valor_unit)}</span>
                    <span className="est-num" style={{ fontWeight: 700 }}>{estBRL(i.valor_total)}</span>
                  </div>))}
              </td></tr>}
            </React.Fragment>))}</tbody>
        </table></div>
      ))}
      {previa && (
        <div className="modal-overlay open" onClick={() => !busy && setPrevia(null)}>
          <div className="modal modal-lg" onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>{previa.jaMarcado ? 'Tirar do estoque' : 'Marcar como direto p/ obra'} — {previa.forn.nome}</h3><button className="modal-close" onClick={() => !busy && setPrevia(null)}>×</button></div>
            <div className="modal-body">
              <div className="est-repo-resumo" style={{ padding: 0, marginBottom: 12 }}>
                <div><span className="stat-label">Notas</span><strong>{pl.notas}</strong><span className="est-sub">saem da fila de todos</span></div>
                <div><span className="stat-label">Entradas no estoque</span><strong>{pl.movimentos.length}</strong><span className="est-sub">de {pl.notas_com_entrada} nota(s) já lançada(s)</span></div>
                <div><span className="stat-label">Valor que sai</span><strong>{estBRL(pl.valor)}</strong><span className="est-sub">custo de entrada</span></div>
                <div><span className="stat-label">Itens apagados</span><strong>{pl.itens_excluir.length}</strong><span className="est-sub">só existiam por essas notas</span></div>
              </div>
              {pl.conflitos.length > 0 && <div className="alert alert-error"><strong>Não dá para aplicar ainda.</strong> Parte do material já saiu do estoque depois da entrada: {pl.conflitos.map(c => `${c.item} em ${c.deposito} (${c.tipo}, ${estData(c.data)})`).join('; ')}. Desfaça essa saída ou ajuste o inventário antes.</div>}
              {pl.movimentos.length > 0 ? <>
                <div className="stat-label" style={{ marginBottom: 6 }}>Sai do estoque</div>
                <div className="table-wrap"><table className="cards-mobile">
                  <thead><tr><th>Item</th><th>Depósito</th><th style={{ textAlign: 'right' }}>Qtd</th><th style={{ textAlign: 'right' }}>Valor</th><th>Lançado</th></tr></thead>
                  <tbody>{pl.movimentos.map(m => (
                    <tr key={m.id}>
                      <td data-label="Item"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{m.item}</div>{pl.itens_excluir.some(i => i.nome === m.item) && <span className="badge est-bad">apagado do catálogo</span>}</td>
                      <td data-label="Depósito">{m.deposito}</td>
                      <td data-label="Qtd" className="est-num" style={{ color: 'var(--danger)', fontWeight: 700 }}>−{estNum(m.quantidade)} <span className="est-sub">{m.unidade || ''}</span></td>
                      <td data-label="Valor" className="est-num">{estBRL(Number(m.quantidade) * (Number(m.custo_unit) || 0))}</td>
                      <td data-label="Lançado"><span className="est-sub">{m.nf}{m.usuario ? ` · ${m.usuario}` : ''} · {estData(m.data)}</span></td>
                    </tr>))}</tbody>
                </table></div>
              </> : <div className="alert alert-info">Nada destas notas entrou no estoque — só vão sair da fila.</div>}
              <div className="est-sub" style={{ marginTop: 12, fontSize: '.82rem' }}>As notas continuam guardadas aqui, só para você. O saldo e o custo médio dos itens são recalculados sem essas entradas. Não dá para desfazer — fica registrado na auditoria.</div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" disabled={busy} onClick={() => setPrevia(null)}>Cancelar</button>
              <button className={`btn ${pl.movimentos.length ? 'btn-danger' : 'btn-primary'}`} disabled={busy || pl.conflitos.length > 0} onClick={confirmar}>
                {busy ? 'Aplicando…' : pl.movimentos.length ? (previa.jaMarcado ? 'Tirar do estoque' : 'Marcar e tirar do estoque') : 'Marcar fornecedor'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// Reposição: o que está abaixo do mínimo e O QUE FAZER — transferir do outro depósito (quando ele
// tem sobra acima do próprio mínimo) ou pedir compra do que faltar, descontando o que já foi pedido.
// "Pedir compra" abre o formulário "Solicitar compra" do Estoque já preenchido (onPedirCompra); `versao`
// muda quando uma compra é enviada, para o "Já pedido" recarregar.
function EstReposicao({ user, escrita, iniciado, addToast, onMudou, onPedirASede, onPedirCompra, versao }) {
  const [d, setD] = useState(null)
  const [busy, setBusy] = useState(null)
  const [kardex, setKardex] = useState(null)
  const [catF, setCatF] = useState('')
  const carregar = () => GET('/estoque/reposicao').then(setD).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [versao])
  const podeComprar = escrita && !!onPedirCompra
  // Almoxarife 2 não vê a Sede: o que falta na base dele ele PEDE à Sede (aba Pedidos) ou pede COMPRA
  // direto para a base (o a_caminho dele = só as compras que vão para a base).
  const almox2 = user.role === 'almoxarife2'
  const podePedirSede = almox2 && escrita && iniciado && !!onPedirASede
  const faltaPedir = it => estQtdPos(it.linhas.reduce((a, l) => a + l.falta, 0) - (it.pedido_sede || 0) - (it.a_caminho || 0))
  const veValor = estVeValor(user)
  const acao = async (chave, fn, ok) => {
    setBusy(chave)
    try { const r = await fn(); addToast(typeof ok === 'function' ? ok(r) : ok, 'success'); carregar(); onMudou() } catch (e) { addToast(e.message, 'error') } finally { setBusy(null) }
  }
  const transferir = (it, l) => {
    if (!confirm(`Transferir ${estNum(l.transferir)} ${it.unidade || ''} de "${it.nome}"\n${l.transferir_de_nome} → ${l.deposito_nome}?`)) return
    acao(`t${it.id}:${l.deposito_id}`, () => POST('/estoque/transferir', { catalogo_id: it.id, de_deposito_id: l.transferir_de_id, para_deposito_id: l.deposito_id, quantidade: l.transferir, obs: 'reposição de mínimo' }), estMsgTransf)
  }
  // Falta na Sede que a transferência de uma base cobriria: muitas vezes comprar sai melhor que trazer da
  // base, então o "Pedir compra" fica disponível também aí. Falta numa base coberta pela sobra da Sede não
  // entra (a compra chegaria na Sede, que já tem sobra — o caminho é transferir).
  const linhasSede = it => it.linhas.filter(l => l.deposito_id && (d.depositos.find(x => x.id === l.deposito_id) || {}).tipo !== 'centro')
  const semCompra = it => estQtdPos(linhasSede(it).reduce((a, l) => a + l.falta, 0) - (it.a_caminho || 0))
  const soTransferencia = it => !almox2 && !(it.comprar_liquido > 0) && semCompra(it) > 0
  // Sugestão: o que falta comprar (na base: o que falta pedir; coberto por transferência: tudo o que falta);
  // urgente quando algum depósito zerou (o motivo já vai escrito).
  const pedir = it => {
    const trf = soTransferencia(it)
    const onde = (trf ? linhasSede(it) : it.linhas).filter(l => almox2 || trf ? l.falta > 0 : l.comprar > 0).map(l => `${l.deposito_nome}: saldo ${estNum(l.saldo)} / mín ${estNum(l.minimo)}`).join('; ')
    const de = trf ? [...new Set(linhasSede(it).map(l => l.transferir_de_nome).filter(Boolean))].join(', ') : ''
    onPedirCompra({ catalogo_id: it.id, qtd: String(almox2 ? faltaPedir(it) : trf ? semCompra(it) : it.comprar_liquido), prioridade: it.linhas.some(l => l.saldo <= 0) ? 'urgente' : 'normal',
      justificativa: trf ? `Comprar em vez de transferir de ${de || 'outro depósito'} — ${onde}` : `Reposição de estoque mínimo — ${onde}` })
  }
  const baixarLista = () => {
    const cel = v => { const x = v == null ? '' : typeof v === 'number' ? String(Math.round(v * 1000) / 1000).replace('.', ',') : String(v); return /[;"\n]/.test(x) ? `"${x.replace(/"/g, '""')}"` : x }
    const linhas = [['Código', 'Item', 'Categoria', 'Unidade', 'Onde falta', 'Já pedido', 'Comprar', ...(veValor ? ['Custo médio', 'Valor estimado'] : [])].join(';')]
    for (const it of lista.filter(i => i.comprar_liquido > 0))
      linhas.push([cel(it.codigo), cel(it.nome), cel(it.categoria), cel(it.unidade), cel(it.linhas.map(l => `${l.deposito_nome} ${estNum(l.saldo)}/${estNum(l.minimo)}`).join(' | ')),
        cel(it.a_caminho), cel(it.comprar_liquido), ...(veValor ? [cel(it.custo_medio), cel(it.custo_medio ? it.custo_medio * it.comprar_liquido : null)] : [])].join(';'))
    const url = URL.createObjectURL(new Blob(['﻿' + linhas.join('\r\n')], { type: 'text/csv;charset=utf-8' }))
    const a = document.createElement('a'); a.href = url; a.download = `lista-de-compra-${new Date().toISOString().slice(0, 10)}.csv`; a.click(); URL.revokeObjectURL(url)
  }
  if (!d) return <div className="card"><div className="card-body text-muted">Carregando…</div></div>
  const cats = [...new Set(d.itens.map(i => i.categoria).filter(Boolean))].sort()
  const lista = d.itens.filter(i => !catF || i.categoria === catF)
  const aTransferir = lista.filter(i => i.linhas.some(l => l.transferir > 0)).length
  const aComprar = lista.filter(i => i.comprar_liquido > 0)
  const aPedir = lista.filter(i => faltaPedir(i) > 0)
  const valorCompra = aComprar.reduce((a, i) => a + (i.custo_medio || 0) * i.comprar_liquido, 0)
  const podeTirarDe = new Set(estDepsMov(user, d.depositos).map(x => x.id))   // transferência é de quem entrega
  const varios = d.depositos.length > 1   // almoxarife 2 só enxerga a base dele: não há de onde sugerir transferência
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title">Abaixo do mínimo <span className="text-muted" style={{ fontWeight: 400, fontSize: '.8rem' }}>· {lista.length} {lista.length === 1 ? 'item' : 'itens'} a repor</span></span>
        <div className="est-filtros">
          {cats.length > 1 && <select value={catF} onChange={e => setCatF(e.target.value)}><option value="">Todas as categorias</option>{cats.map(c => <option key={c}>{c}</option>)}</select>}
          {!almox2 && aComprar.length > 0 && <button className="btn btn-ghost btn-sm" onClick={baixarLista}><Icon name="download" size={13} /> Lista de compra (CSV)</button>}
          {podePedirSede && aPedir.length > 0 && <button className="btn btn-accent btn-sm" onClick={() => onPedirASede(aPedir.map(i => ({ catalogo_id: i.id, qtd: faltaPedir(i) })))}><Icon name="send" size={13} /> Pedir tudo à Sede ({aPedir.length})</button>}
        </div>
      </div>
      {lista.length === 0 ? <div className="empty">Nada abaixo do mínimo. {d.itens.length === 0 && 'Defina mínimos clicando no item na aba Saldo.'}</div> : <>
        <div className="est-repo-resumo">
          {varios && <div><span className="stat-label">Resolver transferindo</span><strong>{aTransferir}</strong><span className="est-sub">sem gastar — há sobra no outro depósito</span></div>}
          {almox2 ? <div><span className="stat-label">Falta pedir</span><strong>{aPedir.length}</strong><span className="est-sub">{podeComprar ? 'à Sede ou em compra — já descontado o que foi pedido' : 'à Sede — já descontado o que foi pedido'}</span></div>
            : <div><span className="stat-label">Precisa comprar</span><strong>{aComprar.length}</strong><span className="est-sub">já descontado o que está pedido</span></div>}
          {veValor && <div><span className="stat-label">Compra estimada</span><strong>{estBRL(valorCompra)}</strong><span className="est-sub">pelo custo médio atual</span></div>}
        </div>
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Item</th><th>Onde falta</th>{varios && <th>Transferir</th>}<th style={{ textAlign: 'right' }}>Já pedido</th><th style={{ textAlign: 'right' }}>{almox2 ? 'Falta pedir' : 'Comprar'}</th><th></th></tr></thead>
          <tbody>{lista.map(it => (
            <tr key={it.id}>
              <td data-label="Item"><button className="est-link" style={{ fontSize: '.9rem', color: 'var(--ink)', textAlign: 'left', whiteSpace: 'normal' }} onClick={() => setKardex(it.id)}>{it.nome}</button>
                <div className="est-sub">{[it.codigo, it.unidade, it.categoria].filter(Boolean).join(' · ')}</div></td>
              <td data-label="Onde falta">{it.linhas.map(l => (
                <div key={l.deposito_id || 'g'} style={{ whiteSpace: 'nowrap' }}>{l.deposito_nome}: <strong style={{ color: l.saldo <= 0 ? 'var(--danger)' : 'var(--warning)' }}>{estNum(l.saldo)}</strong><span className="est-sub"> / mín {estNum(l.minimo)}</span></div>))}
                {!almox2 && it.pedido_sede > 0 && <div className="est-sub">base(s) já pediram {estNum(it.pedido_sede)} à Sede</div>}</td>
              {varios && <td data-label="Transferir">{it.linhas.filter(l => l.transferir > 0).map(l => (
                <div key={l.deposito_id} style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                  <span>{estNum(l.transferir)} <span className="est-sub">{l.transferir_de_nome} → {l.deposito_nome}</span></span>
                  {escrita && iniciado && podeTirarDe.has(l.transferir_de_id) && <button className="btn btn-outline btn-sm" disabled={!!busy} onClick={() => transferir(it, l)}>{busy === `t${it.id}:${l.deposito_id}` ? '…' : 'Transferir'}</button>}
                </div>))}{!it.linhas.some(l => l.transferir > 0) && <span className="est-sub">—</span>}</td>}
              {almox2 ? <>
                <td data-label="Já pedido" className="est-num">{it.pedido_sede || it.a_caminho ? <>
                  {it.pedido_sede > 0 && <div>{estNum(it.pedido_sede)} <span className="est-sub">à Sede</span></div>}
                  {it.a_caminho > 0 && <div>{estNum(it.a_caminho)} <span className="est-sub">em compra</span></div>}</> : <span className="est-sub">—</span>}</td>
                <td data-label="Falta pedir" className="est-num" style={{ fontWeight: 700, color: faltaPedir(it) > 0 ? 'var(--ink)' : 'var(--success)' }}>{faltaPedir(it) > 0 ? <>{estNum(faltaPedir(it))} <span className="est-sub">{it.unidade || ''}</span></> : 'pedido'}</td>
                <td data-label="">{faltaPedir(it) > 0 && (podePedirSede || podeComprar) && <div className="est-repo-acoes">
                  {podePedirSede && <button className="btn btn-accent btn-sm" onClick={() => onPedirASede([{ catalogo_id: it.id, qtd: faltaPedir(it) }])}>Pedir à Sede</button>}
                  {podeComprar && <button className="btn btn-outline btn-sm" onClick={() => pedir(it)}><Icon name="cart" size={13} /> Pedir compra</button>}
                </div>}</td>
              </> : <>
                <td data-label="Já pedido" className="est-num">{it.a_caminho ? estNum(it.a_caminho) : <span className="est-sub">—</span>}</td>
                <td data-label="Comprar" className="est-num" style={{ fontWeight: 700, color: it.comprar_liquido > 0 ? 'var(--ink)' : 'var(--success)' }}>{it.comprar_liquido > 0 ? <>{estNum(it.comprar_liquido)} <span className="est-sub">{it.unidade || ''}</span></>
                  : soTransferencia(it) ? <span className="est-sub">0 — dá para transferir</span> : 'coberto'}</td>
                <td data-label="">{podeComprar && (it.comprar_liquido > 0
                  ? <button className="btn btn-accent btn-sm" disabled={!!busy} onClick={() => pedir(it)}>Pedir compra</button>
                  : soTransferencia(it) && <button className="btn btn-outline btn-sm" disabled={!!busy} onClick={() => pedir(it)} title="Há sobra em outro depósito, mas você pode comprar em vez de transferir"><Icon name="cart" size={13} /> Comprar em vez de transferir</button>)}</td>
              </>}
            </tr>))}</tbody>
        </table></div>
      </>}
      {kardex && <EstKardex id={kardex} user={user} depositos={d.depositos} escrita={escrita} addToast={addToast} onClose={() => setKardex(null)} onMudou={() => { carregar(); onMudou() }} />}
    </div>
  )
}

// "Solicitar compra" do estoque (almoxarifado da Sede — o único canal do estoque para Compras): item do
// catálogo ou digitado, quantidade, para quando (vira o prazo em Compras), prioridade e para que é. Urgente
// passa na frente na fila de Compras, então pede o motivo por extenso (o servidor confere as mesmas regras).
// Mostra o saldo e as compras já em aberto do item, para não pedir duas vezes. Abre vazio pelo topo do
// Estoque ou já preenchido pelo "Pedir compra" da Reposição (`inicial`).
const EST_COMPRA_JUST_MIN = 5, EST_COMPRA_URG_MIN = 20
const estHojeISO = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 10) }
const estMaisDias = n => { const d = new Date(); d.setDate(d.getDate() + n); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 10) }
function EstSolicitarCompra({ user, inicial, addToast, onFechar, onFeito }) {
  const base = user.role === 'almoxarife2' ? user.base_nome || 'sua base' : null   // pedido do Almoxarife 2 vai para a base dele
  const [cat, setCat] = useState(null)
  const [deps, setDeps] = useState([])
  const [f, setF] = useState(() => ({ novo: false, catalogo_id: '', nome: '', unidade: '', qtd: '', prazo: '', prioridade: 'normal', justificativa: '', ...(inicial || {}) }))
  const [abertas, setAbertas] = useState([])
  const [busy, setBusy] = useState(false)
  useEffect(() => { GET('/estoque/saldos?todos=1').then(r => { setCat(r.itens); setDeps(r.depositos) }).catch(e => addToast(e.message, 'error')) }, [])
  useEffect(() => {
    setAbertas([])
    if (f.novo || !f.catalogo_id) return
    let vivo = true
    GET('/estoque/compras/abertas?catalogo_id=' + f.catalogo_id).then(r => { if (vivo) setAbertas(r) }).catch(() => {})
    return () => { vivo = false }
  }, [f.catalogo_id, f.novo])
  const sel = !f.novo && f.catalogo_id && cat ? cat.find(c => String(c.id) === String(f.catalogo_id)) : null
  const un = f.novo ? f.unidade : sel ? sel.unidade || '' : ''
  const urgente = f.prioridade === 'urgente'
  const justMin = urgente ? EST_COMPRA_URG_MIN : EST_COMPRA_JUST_MIN
  const justLen = f.justificativa.trim().length
  const jaPedido = abertas.reduce((a, x) => a + (x.qtd || 0), 0)
  const enviar = async () => {
    if (f.novo ? !f.nome.trim() : !f.catalogo_id) { addToast(f.novo ? 'Informe o nome do item novo.' : 'Escolha o item (ou digite um item novo).', 'error'); return }
    if (!(estNumTxt(f.qtd) > 0)) { addToast('Informe a quantidade.', 'error'); return }
    if (!f.prazo) { addToast('Informe para quando o estoque precisa do material.', 'error'); return }
    if (f.prazo < estHojeISO()) { addToast('A data não pode estar no passado.', 'error'); return }
    if (justLen < justMin) { addToast(urgente ? `Urgente: explique o motivo (mínimo ${EST_COMPRA_URG_MIN} caracteres).` : 'Informe para que é a compra.', 'error'); return }
    setBusy(true)
    try {
      const r = await POST('/rec/compras/solicitar', { ...(f.novo ? { descricao: f.nome.trim(), unidade: f.unidade.trim() } : { catalogo_id: f.catalogo_id }),
        qtd: estNumTxt(f.qtd), prazo: f.prazo, prioridade: f.prioridade, justificativa: f.justificativa.trim() })
      addToast(`${r.numero} enviado a Compras — entrou na fila "A cotar".`, 'success')
      onFeito(r)
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  return (
    <div className="modal-overlay open">
      <div className="modal modal-md">
        <div className="modal-header">
          <h3 style={{ display: 'flex', alignItems: 'center', gap: 8 }}><Icon name="cart" size={17} /> Solicitar compra</h3>
          <button className="modal-close" onClick={onFechar} aria-label="Fechar">×</button>
        </div>
        <div className="modal-body">
          {!cat ? <div className="text-muted">Carregando…</div> : <div className="form-grid">
            {base && <div className="form-group full"><div className="est-compra-destino"><Icon name="mapPin" size={15} /><span>Compra para o depósito <strong>{base}</strong> — Compras vê o destino e a entrega vai para a sua base.</span></div></div>}
            <div className="form-group full">
              <label style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>{f.novo ? 'Item novo *' : 'Item *'}
                <button type="button" className="est-link" onClick={() => setF({ ...f, novo: !f.novo, catalogo_id: '' })}>{f.novo ? '← buscar no catálogo' : '+ item novo (fora do catálogo)'}</button></label>
              {f.novo
                ? <input value={f.nome} onChange={e => setF({ ...f, nome: e.target.value })} placeholder="nome do material, ex.: Disjuntor DIN 32A curva C" />
                : <EstItemPicker catalogo={cat} value={f.catalogo_id} onChange={v => setF({ ...f, catalogo_id: v })} />}
            </div>
            {sel && <div className="form-group full"><div className="est-compra-info">
              <span>Saldo hoje: {deps.map(d => { const s = sel.saldos[d.id]; return <span key={d.id}>{d.nome} <strong>{estNum(s ? s.qtd : 0)}</strong>{s && s.minimo > 0 ? <span className="est-sub"> / mín {estNum(s.minimo)}</span> : null}</span> }).reduce((a, x, i) => i ? [...a, ' · ', x] : [x], [])} <span className="est-sub">{un}</span></span>
            </div></div>}
            {abertas.length > 0 && <div className="form-group full"><div className="alert alert-warning" style={{ margin: 0 }}>
              <strong>Já em compra: {estNum(jaPedido)} {un}</strong> — confira antes de pedir de novo.
              {abertas.map(a => <div key={a.numero} className="est-sub" style={{ color: 'inherit' }}>{a.numero} · {estNum(a.qtd)} {a.unidade || ''} · {RC_STAT_LABEL[a.status] || a.status} · {a.origem === 'almoxarifado' ? `pedido do estoque${a.destino_nome ? ` (${a.destino_nome})` : ' (Sede)'}` : a.obra_nome ? `obra ${a.obra_nome}` : 'pedido de obra'}{a.prazo ? ` · para ${estData(a.prazo)}` : ''}</div>)}
            </div></div>}
            {f.novo && <div className="form-group"><label>Unidade</label><input value={f.unidade} onChange={e => setF({ ...f, unidade: e.target.value })} placeholder="UN, SC, M, KG…" /></div>}
            <div className="form-group"><label>Quantidade * {un && <span className="est-sub">({un})</span>}</label>
              <input type="number" min="0" step="any" inputMode="decimal" value={f.qtd} onChange={e => setF({ ...f, qtd: e.target.value })} /></div>
            <div className="form-group"><label>Preciso no estoque até *</label>
              <input type="date" min={estHojeISO()} value={f.prazo} onChange={e => setF({ ...f, prazo: e.target.value })} />
              <span className="est-compra-atalhos">em {[7, 15, 30].map(n => <button key={n} type="button" className="est-link" onClick={() => setF({ ...f, prazo: estMaisDias(n) })}>{n} dias</button>)}</span></div>
            <div className="form-group full"><label>Prioridade</label>
              <div className="uni-switch" style={{ alignSelf: 'flex-start' }}>
                <button type="button" className={!urgente ? 'active' : ''} onClick={() => setF({ ...f, prioridade: 'normal' })}>Normal</button>
                <button type="button" className={urgente ? 'active' : ''} onClick={() => setF({ ...f, prioridade: 'urgente' })}>Urgente</button>
              </div>
              {urgente && <div className="est-sub" style={{ marginTop: 6 }}>Urgente passa na frente na fila de Compras — explique abaixo por que não pode esperar.</div>}
            </div>
            <div className="form-group full"><label style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>{urgente ? 'Por que é urgente? *' : 'Para que é? *'}
              {justLen < justMin && <span className="est-sub">{urgente ? `mín. ${EST_COMPRA_URG_MIN} caracteres (${justLen}/${EST_COMPRA_URG_MIN})` : ''}</span>}</label>
              <textarea rows={2} value={f.justificativa} onChange={e => setF({ ...f, justificativa: e.target.value })}
                placeholder={urgente ? 'ex.: saldo zerado e a obra Ed. Atlântico precisa na segunda' : base ? 'ex.: comprar perto da base sai mais rápido que pedir à Sede' : 'ex.: repor o mínimo da Sede; consumo alto este mês'} /></div>
          </div>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onFechar} disabled={busy}>Cancelar</button>
          <button className="btn btn-accent" onClick={enviar} disabled={busy || !cat}><Icon name="send" size={14} /> {busy ? 'Enviando…' : 'Enviar para Compras'}</button>
        </div>
      </div>
    </div>
  )
}

// Compras pedidas pelo estoque: o que o almoxarifado mandou a Compras e em que pé está — a esteira é de
// Compras; aqui é só acompanhamento. Em aberto primeiro; concluídas e canceladas dos últimos 90 dias.
const estCompraTom = st => st === 'em_estoque' || st === 'entregue_unidade' ? 'tg-ok' : st === 'cancelada' ? 'tg-neutro' : 'tg-cobre'
function EstComprasPedidas({ user, podePedir, versao, onSolicitar, addToast }) {
  const almox2 = user.role === 'almoxarife2'
  const [lista, setLista] = useState(null)
  const [verTodas, setVerTodas] = useState(false)
  useEffect(() => { GET('/estoque/compras').then(setLista).catch(e => addToast(e.message, 'error')) }, [versao])
  if (!lista) return <div className="card"><div className="card-body text-muted">Carregando…</div></div>
  const abertas = lista.filter(rcAberta)
  const vis = verTodas ? lista : abertas
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title">{almox2 ? `Compras pedidas para ${user.base_nome || 'a base'}` : 'Compras pedidas pelo estoque'} <span className="text-muted" style={{ fontWeight: 400, fontSize: '.8rem' }}>· {abertas.length} em aberto</span></span>
        <div className="est-filtros">
          <label className="est-chk"><input type="checkbox" checked={verTodas} onChange={e => setVerTodas(e.target.checked)} /> Mostrar concluídas (90 dias)</label>
          {podePedir && <button className="btn btn-accent btn-sm" onClick={onSolicitar}><Icon name="cart" size={13} /> Solicitar compra</button>}
        </div>
      </div>
      {vis.length === 0 ? <div className="empty">{lista.length ? 'Nenhuma compra do estoque em aberto.' : podePedir ? 'O estoque ainda não pediu compras. Use "Solicitar compra" (ou "Pedir compra" na aba Abaixo do mínimo).' : 'O estoque ainda não pediu compras.'}</div> : (
        <div className="est-ped-lista">{vis.map(rc => {
          const aberta = rcAberta(rc)
          const pi = recPrazoInfo(rc.prazo, rc.status)
          return (
            <div key={rc.id} className={`est-ped ${aberta ? (rc.prioridade === 'urgente' ? 'urgente' : 'aberto') : ''}`}>
              <div className="est-ped-head">
                <strong>{rc.numero}</strong>
                <span className={`badge ${estCompraTom(rc.status)}`}>{RC_STAT_LABEL[rc.status] || rc.status}</span>
                {rc.prioridade === 'urgente' && <span className="badge tg-urgente">Urgente</span>}
                {pi && <span className={`badge ${pi.kind === 'atrasado' ? 'tg-perigo' : 'tg-alerta'}`}>{pi.label}</span>}
                {!almox2 && rc.destino_nome && <span className="badge tg-aco">para {rc.destino_nome}</span>}
                <span className="est-sub" style={{ marginLeft: 'auto' }}>{aberta ? `pedido há ${estDuracao(rc.criado_em)}` : `${rc.status === 'cancelada' ? 'cancelada' : 'chegou'} em ${estData(rc.atualizado_em)}`}</span>
              </div>
              <div className="est-ped-item" style={{ padding: 0 }}>
                <span className="nome">{rc.descricao}{!rc.catalogo_id && <span className="badge est-origem">fora do catálogo</span>}</span>
                <span><strong>{estNum(rc.qtd)}</strong> <span className="est-sub">{rc.unidade || ''}</span></span>
                {rc.prazo && <span className="est-sub">para {estData(rc.prazo)}</span>}
              </div>
              <div className="est-sub">pedido por {rc.origem_nome || '—'} em {estQuando(rc.criado_em)}{rc.fornecedor ? ` · fornecedor: ${rc.fornecedor}` : ''}{rc.valor_unit ? ` · estimado ${estBRL(rc.valor_unit * rc.qtd)}` : ''}</div>
              {rc.justificativa && <div className="est-ped-resp" style={{ borderLeftColor: 'var(--silver)' }}>{rc.justificativa}</div>}
              {/* Compra sem nota entregue na base: a chegada é assinada na aba Pedidos (quem fecha a compra é a base). */}
              {rc.base_rp_status === 'em_transito' && <div className="est-ped-resp" style={{ borderLeftColor: 'var(--warning)' }}>
                <strong>Sem nota fiscal · {almox2 ? 'quando chegar, confira, anexe o comprovante e assine' : `aguardando ${rc.base_rp_para || 'a base'} conferir e assinar`}</strong> · remessa {rc.base_rp_numero} na aba Pedidos</div>}
              {rc.base_rp_status === 'recebido' && <div className="est-ped-resp" style={{ borderLeftColor: 'var(--success)' }}>
                <strong>Chegada assinada em {rc.base_rp_para || 'base'} por {rc.base_rp_recebido_nome || '—'}</strong> · {estQuando(rc.base_rp_recebido_em)} · chegou {estNum(rc.base_rp_qtd_recebida || 0)} {rc.unidade || ''}{rc.base_rp_obs ? `\n${rc.base_rp_obs}` : ''}
                {rc.base_rp_comprovante ? <div style={{ marginTop: 4 }}><button className="est-link" onClick={() => baixarComprovante(() => GET(`/estoque/pedidos/${rc.base_rp_id}/recebimento`)).catch(e => addToast(e.message, 'error'))}>baixar comprovante</button></div> : null}</div>}
              {rc.status === 'cancelada' && rc.cancelada_motivo && <div className="est-ped-resp" style={{ borderLeftColor: 'var(--danger)' }}>
                <strong>Cancelada por {rc.cancelada_por_nome || 'Compras'}</strong>{rc.cancelada_em ? ` · ${estQuando(rc.cancelada_em)}` : ''}{`\n${rc.cancelada_motivo}`}</div>}
            </div>
          )
        })}</div>
      )}
    </div>
  )
}

// Pedido de reposição base (Niterói, Costellation…) → Sede. O almoxarife 2 pede (ele não enxerga a Sede) e só puxa do estoque
// da Sede — compra não sai daqui (Compras recebe só pelo almoxarifado da Sede, aba Reposição). A Sede
// envia (sai do saldo dela) ou recusa com motivo; o material fica em trânsito até o almoxarife 2 conferir
// e ASSINAR a chegada — só então entra no saldo da base. Os demais perfis do Estoque acompanham.
const EST_PED_ST = { aberto: ['Aguardando a Sede', 'tg-alerta'], em_transito: ['Em trânsito', 'tg-aco'], recebido: ['Recebido', 'tg-ok'],
  recusado: ['Recusado', 'tg-perigo'], cancelado: ['Cancelado', 'tg-neutro'] }
const EST_PED_ATIVO = ['aberto', 'em_transito']
// Remessa que não nasceu de pedido da base: linhas de nota fiscal ('nota'), transferência direta ('envio') ou compra
// sem nota entregue pelo fornecedor na base ('compra' — a chegada pede o comprovante e fecha a compra).
// A chegada é a mesma: o almoxarife 2 confere e assina. De onde vem, para mostrar na lista e no painel:
const estPedDeQuem = pd => pd.origem === 'nota' ? `NF ${pd.nf_numero || '—'}${pd.nf_emitente ? ' · ' + pd.nf_emitente : ''}`
  : pd.origem === 'compra' ? `Compra ${pd.compra_numero || '—'}${pd.compra_fornecedor ? ' · ' + pd.compra_fornecedor : ''}` : (pd.de_nome || 'Sede')
const EST_ORIGEM_ROTULO = { nota: 'Nota fiscal', envio: 'Envio direto', compra: 'Compra sem nota' }
// Como a quantidade de origem aparece: "na nota 12", "comprado 5", "enviado 3".
const estPedVeio = pd => pd.origem === 'nota' ? 'na nota' : pd.origem === 'compra' ? 'comprado' : 'enviado'
// Tempo entre dois momentos (ou até agora): "40 min", "2h 10min", "3 dias 4h".
const estDuracao = (de, ate) => {
  const t = s => new Date(String(s).replace(' ', 'T')).getTime()
  const min = Math.max(0, Math.round(((ate ? t(ate) : Date.now()) - t(de)) / 60000))
  if (isNaN(min)) return ''
  if (min < 60) return `${min} min`
  const h = Math.floor(min / 60)
  if (h < 24) return `${h}h${min % 60 ? ` ${min % 60}min` : ''}`
  const d = Math.floor(h / 24)
  return `${d} dia${d > 1 ? 's' : ''}${h % 24 ? ` ${h % 24}h` : ''}`
}
const estNumTxt = v => Number(String(v == null ? '' : v).replace(',', '.')) || 0

function EstPedidos({ user, iniciado, prefill, onPrefillUsado, abrirChegadaId, addToast, onMudou }) {
  const pede = user.role === 'almoxarife2' && !user.ceo && !user.tour
  const atende = user.role === 'almoxarifado' && !user.ceo && !user.tour
  const [peds, setPeds] = useState(null)
  const [verTodos, setVerTodos] = useState(user.role === 'almoxarife2')   // quem pede quer ver as respostas; a Sede, a fila
  const [envio, setEnvio] = useState(null)       // Sede enviando: { id, qtd: { itemId: valor }, resposta }
  const [chegada, setChegada] = useState(null)   // base recebendo: { id, qtd: { itemId: valor }, obs, assinar }
  const [assinaturas, setAssinaturas] = useState({})   // id → { assinatura, foto } (carregadas sob demanda)
  const [busy, setBusy] = useState(false)
  const carregar = () => GET('/estoque/pedidos').then(setPeds).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [])
  const run = async (fn, ok) => {
    setBusy(true)
    try { await fn(); addToast(ok, 'success'); carregar(); onMudou(); return true } catch (e) { addToast(e.message, 'error'); return false } finally { setBusy(false) }
  }
  // Sugestão de envio = o pedido, limitado ao que a Sede tem.
  const abrirEnvio = pd => { setChegada(null); setEnvio({ id: pd.id, resposta: '',
    qtd: Object.fromEntries(pd.itens.map(i => { const s = i.saldos ? i.saldos[pd.de_deposito_id] : null; return [i.id, String(estQtdPos(s == null ? i.qtd : Math.min(i.qtd, s)))] })) }) }
  const confirmarEnvio = pd => {
    const itens = pd.itens.map(i => ({ id: i.id, qtd_enviada: estNumTxt(envio.qtd[i.id]) }))
    run(() => POST(`/estoque/pedidos/${pd.id}/atender`, { itens, resposta: envio.resposta }), `${pd.numero}: saiu da Sede — em trânsito até ${pd.para_nome || 'a base'} assinar a chegada.`)
      .then(ok => ok && setEnvio(null))
  }
  // Sugestão de chegada = o que a Sede enviou; o almoxarife 2 corrige o que veio diferente.
  const abrirChegada = pd => { setEnvio(null); setChegada({ id: pd.id, obs: '', assinar: false, qtd: Object.fromEntries(pd.itens.map(i => [i.id, String(i.qtd_enviada)])) }) }
  const chegouMenos = pd => chegada && pd.itens.some(i => estNumTxt(chegada.qtd[i.id]) < i.qtd_enviada)
  const irParaAssinatura = pd => {
    const veio = pd.origem === 'nota' ? 'veio na nota' : pd.origem === 'compra' ? 'foi comprado' : 'foi enviado'
    if (pd.itens.some(i => estNumTxt(chegada.qtd[i.id]) > i.qtd_enviada)) { addToast(`A quantidade que chegou não pode ser maior do que ${veio}.`, 'error'); return }
    if (chegouMenos(pd) && chegada.obs.trim().length < 5) { addToast(`Chegou menos do que ${veio}: descreva o que aconteceu.`, 'error'); return }
    if (pd.origem === 'compra') {
      if (!pd.itens.some(i => estNumTxt(chegada.qtd[i.id]) > 0)) { addToast('Nada chegou? Então não assine: a compra segue aberta e Compras cobra o fornecedor.', 'error'); return }
      if (!chegada.comprovante) { addToast('Anexe o comprovante da compra (foto ou PDF) antes de assinar.', 'error'); return }
    }
    setChegada({ ...chegada, assinar: true })
  }
  // Compra sem nota: o comprovante (foto do recibo/pedido ou PDF) é o documento da entrada.
  const anexarComprovante = file => {
    if (!file) return
    setChegada(c => c && { ...c, lendo: true })
    lerComprovante(file).then(({ dataUrl, nome }) => setChegada(c => c && { ...c, comprovante: dataUrl, comprovante_nome: nome, lendo: false }))
      .catch(e => { addToast(e.message, 'error'); setChegada(c => c && { ...c, lendo: false }) })
  }
  const confirmarChegada = (pd, assinatura, foto) => {
    const itens = pd.itens.map(i => ({ id: i.id, qtd_recebida: estNumTxt(chegada.qtd[i.id]) }))
    const compra = pd.origem === 'compra' ? { comprovante: chegada.comprovante, comprovante_nome: chegada.comprovante_nome } : {}
    run(() => POST(`/estoque/pedidos/${pd.id}/receber`, { itens, obs: chegada.obs, assinatura, foto, ...compra }),
      `${pd.numero}: chegada assinada — entrou no saldo de ${pd.para_nome || 'sua base'}${pd.origem === 'compra' ? ` e a compra ${pd.compra_numero || ''} foi fechada` : ''}.`)
      .then(ok => ok && setChegada(null))
  }
  const recusar = pd => {
    const m = prompt(`Recusar o pedido ${pd.numero}.\nMotivo (${pd.para_nome || 'a base'} vai ver):`)
    if (m == null) return
    run(() => POST(`/estoque/pedidos/${pd.id}/recusar`, { motivo: m }), `${pd.numero} recusado.`)
  }
  // Remessa de nota/envio direto ainda em trânsito (base errada, lançou por engano).
  const desfazer = pd => {
    const volta = pd.origem === 'nota' ? 'As linhas voltam a ficar pendentes na nota — depois é só lançar de novo no destino certo.'
      : pd.origem === 'compra' ? `A compra ${pd.compra_numero || ''} volta para "Comprado" em Compras.` : `O material volta para o saldo de ${pd.de_nome}.`
    const m = prompt(`Desfazer a remessa ${pd.numero} para ${pd.para_nome}?\n${volta}\nMotivo (obrigatório):`, '')
    if (m == null) return
    run(() => POST(`/estoque/pedidos/${pd.id}/desfazer`, { motivo: m }), pd.origem === 'nota' ? `${pd.numero} desfeita — as linhas voltaram para a nota.`
      : pd.origem === 'compra' ? `${pd.numero} desfeita — a compra voltou para Comprado.` : `${pd.numero} desfeita — o material voltou para ${pd.de_nome}.`)
  }
  const cancelar = pd => {
    const m = prompt(`Cancelar o pedido ${pd.numero}?\nMotivo (opcional):`, '')
    if (m == null) return
    run(() => POST(`/estoque/pedidos/${pd.id}/cancelar`, { motivo: m }), `${pd.numero} cancelado.`)
  }
  const verAssinatura = pd => GET(`/estoque/pedidos/${pd.id}/recebimento`).then(r => setAssinaturas(a => ({ ...a, [pd.id]: r }))).catch(e => addToast(e.message, 'error'))
  // Vindo do Painel ("Conferir e assinar a chegada"): abre a conferência daquele envio e rola até ele, uma vez.
  const chegadaFeita = useRef(false)
  useEffect(() => {
    if (!peds || !abrirChegadaId || chegadaFeita.current) return
    chegadaFeita.current = true
    const pd = peds.find(p => p.id === abrirChegadaId)
    if (!pd) return
    if (pede && pd.status === 'em_transito') abrirChegada(pd)
    setTimeout(() => { const el = document.getElementById('est-ped-' + pd.id); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }) }, 60)
  }, [peds])
  if (!peds) return <div className="card"><div className="card-body text-muted">Carregando…</div></div>
  const abertos = peds.filter(p => p.status === 'aberto').length
  const transito = peds.filter(p => p.status === 'em_transito').length
  const lista = verTodos ? peds : peds.filter(p => EST_PED_ATIVO.includes(p.status))
  return (
    <>
      {pede && <EstNovoPedido iniciado={iniciado} prefill={prefill} onPrefillUsado={onPrefillUsado} addToast={addToast} onCriado={() => { carregar(); onMudou() }} />}
      <div className="card">
        <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
          <span className="card-title">{pede ? 'Pedidos à Sede e chegadas' : 'Pedidos e remessas para as bases'} <span className="text-muted" style={{ fontWeight: 400, fontSize: '.8rem' }}>· {abertos} aguardando a Sede · {transito} em trânsito</span></span>
          <div className="est-filtros"><label className="est-chk"><input type="checkbox" checked={verTodos} onChange={e => setVerTodos(e.target.checked)} /> Mostrar concluídos</label></div>
        </div>
        {atende && abertos > 0 && <div className="est-sub" style={{ padding: '0 16px 10px' }}>Ao enviar, o material sai do saldo da Sede em seu nome e só entra na base (Niterói, Costellation…) quando o almoxarife 2 de lá assinar a chegada.</div>}
        {lista.length === 0 ? <div className="empty">{peds.length ? 'Nenhum pedido em andamento.' : pede ? 'Nenhum pedido ainda. Monte a lista acima ou use "Pedir à Sede" na aba Abaixo do mínimo.' : 'Nenhuma base fez pedidos ainda.'}</div> : (
          <div className="est-ped-lista">{lista.map(pd => {
            const [rot, cls] = EST_PED_ST[pd.status] || [pd.status, 'tg-neutro']
            const env = envio && envio.id === pd.id ? envio : null
            const che = chegada && chegada.id === pd.id ? chegada : null
            const envMenos = env && pd.itens.some(i => estNumTxt(env.qtd[i.id]) < i.qtd)
            const saiu = pd.status === 'em_transito' || pd.status === 'recebido'
            const ass = assinaturas[pd.id]
            return (
              <div key={pd.id} id={'est-ped-' + pd.id} className={`est-ped ${EST_PED_ATIVO.includes(pd.status) ? (pd.urgente ? 'urgente' : 'aberto') : ''}`}>
                <div className="est-ped-head">
                  <strong>{pd.numero}</strong>
                  <span className={`badge ${cls}`}>{rot}</span>
                  {pd.origem && <span className="badge tg-cobre">{EST_ORIGEM_ROTULO[pd.origem] || pd.origem}</span>}
                  {pd.urgente ? <span className="badge tg-urgente">Urgente</span> : null}
                  {pd.enviado_a_menos && <span className="badge tg-alerta">Sede enviou menos</span>}
                  {pd.divergencia && <span className="badge tg-perigo">Chegou menos que o enviado</span>}
                  <span className="est-sub" style={{ marginLeft: 'auto' }}>{pd.status === 'aberto' ? `aguardando há ${estDuracao(pd.criado_em)}`
                    : pd.status === 'em_transito' ? `em trânsito há ${estDuracao(pd.respondido_em)}`
                    : pd.status === 'recebido' ? `pedido → chegada: ${estDuracao(pd.criado_em, pd.recebido_em)}` : `respondido em ${estDuracao(pd.criado_em, pd.respondido_em)}`}</span>
                </div>
                <div className="est-sub">{estPedDeQuem(pd)} → {pd.para_nome} · {pd.origem === 'nota' ? 'lançada por' : pd.origem === 'compra' ? 'sem nota fiscal · marcada por' : pd.origem ? 'enviado direto por' : 'pedido por'} {pd.solicitante_nome || '—'} em {estQuando(pd.criado_em)}</div>
                {pd.obs && pd.origem !== 'compra' && <div className="est-ped-resp" style={{ borderLeftColor: 'var(--silver)' }}>{pd.obs}</div>}
                <div>{pd.itens.map(i => {
                  const sSede = i.saldos ? i.saldos[pd.de_deposito_id] : null, sNit = i.saldos ? i.saldos[pd.para_deposito_id] : null
                  const faltou = pd.status === 'recebido' && (i.qtd_recebida || 0) < i.qtd_enviada
                  return (
                    <div key={i.id} className="est-ped-item">
                      <span className="nome">{i.nome}<div className="est-sub">{[i.codigo, i.categoria].filter(Boolean).join(' · ')}</div></span>
                      {!pd.origem && <span>pedido <strong>{estNum(i.qtd)}</strong> <span className="est-sub">{i.unidade || ''}</span></span>}
                      {(saiu || pd.origem) && <span style={{ fontWeight: 700, color: i.qtd_enviada < i.qtd ? 'var(--warning)' : 'var(--ink)' }}>{estPedVeio(pd)} {estNum(i.qtd_enviada)}{pd.origem ? <span className="est-sub" style={{ fontWeight: 400 }}> {i.unidade || ''}</span> : null}</span>}
                      {pd.status === 'recebido' && i.qtd_enviada > 0 && <span style={{ fontWeight: 700, color: faltou ? 'var(--danger)' : 'var(--success)' }}>chegou {estNum(i.qtd_recebida || 0)}</span>}
                      {pd.status === 'aberto' && (sSede != null || sNit != null) && <span className="est-sub">{[sSede != null && `Sede tem ${estNum(sSede)}`, sNit != null && `${pd.para_nome || 'Base'} tem ${estNum(sNit)}`].filter(Boolean).join(' · ')}</span>}
                      {env && <label className="est-chk">Enviar <input type="number" min="0" step="any" value={env.qtd[i.id]} onChange={e => setEnvio({ ...env, qtd: { ...env.qtd, [i.id]: e.target.value } })} /></label>}
                      {che && !che.assinar && i.qtd_enviada > 0 && <label className="est-chk">Chegou <input type="number" min="0" step="any" value={che.qtd[i.id]} onChange={e => setChegada({ ...che, qtd: { ...che.qtd, [i.id]: e.target.value } })} /></label>}
                    </div>)
                })}</div>
                {saiu && <div className="est-ped-resp">
                  <strong>{pd.origem === 'nota' ? 'Lançada na nota por' : pd.origem === 'compra' ? 'Compra sem nota marcada por' : 'Enviado por'} {pd.respondido_nome || '—'}</strong> · {estQuando(pd.respondido_em)}{pd.resposta ? `\n${pd.resposta}` : ''}</div>}
                {pd.status === 'recebido' && <div className="est-ped-resp" style={{ borderLeftColor: pd.divergencia ? 'var(--danger)' : 'var(--success)' }}>
                  <strong>Chegada assinada por {pd.recebido_nome || '—'}</strong> · {estQuando(pd.recebido_em)} · {estDuracao(pd.respondido_em, pd.recebido_em)} em trânsito{pd.recebimento_obs ? `\n${pd.recebimento_obs}` : ''}
                  <div style={{ marginTop: 6 }}>{ass
                    ? <span style={{ display: 'inline-flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
                        <img src={ass.assinatura} alt="assinatura" style={{ height: 56, background: '#fff', border: '1px solid var(--border)', borderRadius: 6 }} />
                        {ass.foto && <img src={ass.foto} alt="foto da chegada" style={{ height: 56, borderRadius: 6, border: '1px solid var(--border)' }} />}
                        <span className="est-sub" title={ass.hash_recebimento}>registro {String(ass.hash_recebimento || '').slice(0, 12)}</span>
                      </span>
                    : <button className="est-link" onClick={() => verAssinatura(pd)}>ver assinatura{pd.tem_foto ? ' e foto' : ''}</button>}
                    {pd.tem_comprovante ? <button className="est-link" style={{ marginLeft: 12 }} onClick={() => baixarComprovante(() => GET(`/estoque/pedidos/${pd.id}/recebimento`)).catch(e => addToast(e.message, 'error'))}>baixar comprovante{pd.comprovante_nome ? ` (${pd.comprovante_nome})` : ''}</button> : null}</div>
                </div>}
                {!saiu && pd.status !== 'aberto' && <div className="est-ped-resp">
                  <strong>{pd.status === 'cancelado' ? 'Cancelado' : 'Recusado'} por {pd.respondido_nome || '—'}</strong> · {estQuando(pd.respondido_em)}{pd.resposta ? `\n${pd.resposta}` : ''}</div>}
                {env && <div className="est-ped-acoes">
                  <input value={env.resposta} onChange={e => setEnvio({ ...env, resposta: e.target.value })}
                    placeholder={envMenos ? 'Por que vai menos que o pedido? (obrigatório) — ex.: sem saldo na Sede' : 'Observação (opcional) — ex.: segue no caminhão de amanhã'} />
                  <button className="btn btn-primary btn-sm" disabled={busy} onClick={() => confirmarEnvio(pd)}><Icon name="send" size={13} /> Registrar envio</button>
                  <button className="btn btn-ghost btn-sm" disabled={busy} onClick={() => setEnvio(null)}>Voltar</button>
                </div>}
                {che && !che.assinar && pd.origem === 'compra' && <div className="est-ped-acoes" style={{ alignItems: 'center' }}>
                  <label className={`btn btn-sm ${che.comprovante ? 'btn-ghost' : 'btn-outline'}`} style={{ cursor: 'pointer' }}>
                    <Icon name={che.comprovante ? 'check' : 'fileText'} size={13} /> {che.lendo ? 'Lendo…' : che.comprovante ? 'Trocar comprovante' : 'Anexar comprovante *'}
                    <input type="file" accept="image/*,application/pdf" style={{ display: 'none' }} onChange={e => { anexarComprovante(e.target.files && e.target.files[0]); e.target.value = '' }} />
                  </label>
                  <span className="est-sub" style={{ flex: 1, minWidth: 0 }}>{che.comprovante ? `Anexado: ${che.comprovante_nome || 'comprovante'}` : 'Sem nota fiscal: foto ou PDF do pedido/recibo (ex.: Mercado Livre). Obrigatório.'}</span>
                </div>}
                {che && !che.assinar && <div className="est-ped-acoes">
                  <input value={che.obs} onChange={e => setChegada({ ...che, obs: e.target.value })}
                    placeholder={chegouMenos(pd) ? 'O que aconteceu? (obrigatório) — ex.: 2 sacos rasgados, faltou 1 caixa' : 'Observação (opcional)'} />
                  <button className="btn btn-primary btn-sm" onClick={() => irParaAssinatura(pd)}><Icon name="check" size={13} /> Conferido — assinar</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => setChegada(null)}>Voltar</button>
                </div>}
                {che && che.assinar && <div style={{ borderTop: '1px dashed var(--border)', paddingTop: 10 }}>
                  <AssinaturaCustodia tipo="recebimento" label={`Assinatura de ${user.nome}`}
                    acaoTexto={`o recebimento, no depósito de ${pd.para_nome}, dos materiais ${pd.origem === 'nota' ? `da NF ${pd.nf_numero || '—'}${pd.nf_emitente ? ` (${pd.nf_emitente})` : ''}, remessa ${pd.numero}`
                      : pd.origem === 'compra' ? `da compra ${pd.compra_numero || '—'}${pd.compra_fornecedor ? ` (${pd.compra_fornecedor})` : ''}, sem nota fiscal, com o comprovante anexado, remessa ${pd.numero}`
                      : `do ${pd.origem ? 'envio' : 'pedido'} ${pd.numero}, enviados pela ${pd.de_nome}`}, nas quantidades que conferi`}
                    onConfirm={(sig, foto) => !busy && confirmarChegada(pd, sig, foto)} onCancel={() => setChegada({ ...che, assinar: false })} />
                </div>}
                {!env && !che && ((atende && pd.status === 'aberto') || (pede && pd.status === 'aberto') || (pede && pd.status === 'em_transito')) && <div className="est-ped-acoes">
                  {atende && pd.status === 'aberto' && iniciado && <button className="btn btn-primary btn-sm" disabled={busy} onClick={() => abrirEnvio(pd)}>Enviar</button>}
                  {atende && pd.status === 'aberto' && <button className="btn btn-outline btn-sm" disabled={busy} onClick={() => recusar(pd)}>Recusar</button>}
                  {pede && pd.status === 'em_transito' && iniciado && <button className="btn btn-accent btn-sm" disabled={busy} onClick={() => abrirChegada(pd)}><Icon name="signature" size={13} /> Confirmar chegada</button>}
                  {pede && pd.status === 'aberto' && <button className="btn btn-ghost btn-sm" disabled={busy} onClick={() => cancelar(pd)}>Cancelar pedido</button>}
                </div>}
                {!env && !che && pd.pode_desfazer && <div className="est-ped-acoes">
                  <span className="est-sub" style={{ flex: 1 }}>Aguardando {pd.para_nome} conferir e assinar a chegada.</span>
                  <button className="btn btn-ghost btn-sm" disabled={busy} onClick={() => desfazer(pd)} title={pd.origem === 'nota' ? 'Base errada ou lançou por engano: as linhas voltam a ficar pendentes na nota'
                    : pd.origem === 'compra' ? 'Marcou sem nota por engano: a compra volta para Comprado' : `Base errada: o material volta para ${pd.de_nome}`}>Desfazer remessa</button>
                </div>}
              </div>)
          })}</div>
        )}
      </div>
    </>
  )
}

// Formulário do almoxarife 2: monta a lista (catálogo inteiro, com o saldo/mínimo só da base dele) e envia.
// "Puxar o que está abaixo do mínimo" traz o que falta na base, já descontado o que foi pedido.
function EstNovoPedido({ iniciado, prefill, onPrefillUsado, addToast, onCriado }) {
  const [cat, setCat] = useState([])
  const [nitId, setNitId] = useState(null)
  const [nitNome, setNitNome] = useState('Sua base')   // nome da base do almoxarife 2 (Niterói, Costellation…)
  const [linhas, setLinhas] = useState([])   // [{ catalogo_id, qtd }]
  const [sel, setSel] = useState({ catalogo_id: '', qtd: '' })
  const [selKey, setSelKey] = useState(0)   // remonta o campo de busca ao limpar
  const [obs, setObs] = useState('')
  const [urgente, setUrgente] = useState(false)
  const [repo, setRepo] = useState([])
  const [busy, setBusy] = useState(false)
  const carregarRepo = () => GET('/estoque/reposicao').then(r => setRepo(r.itens
    .map(i => ({ catalogo_id: i.id, qtd: estQtdPos(i.linhas.reduce((a, l) => a + l.falta, 0) - (i.pedido_sede || 0)) })).filter(i => i.qtd > 0))).catch(() => {})
  // Junta itens à lista sem duplicar (o que já está na lista fica como está).
  const juntar = novos => setLinhas(ls => {
    const m = new Map(ls.map(l => [String(l.catalogo_id), l]))
    for (const n of novos) if (!m.has(String(n.catalogo_id))) m.set(String(n.catalogo_id), { catalogo_id: n.catalogo_id, qtd: String(n.qtd) })
    return [...m.values()]
  })
  useEffect(() => {
    GET('/estoque/saldos?todos=1').then(r => { setCat(r.itens); setNitId(r.depositos.length ? r.depositos[0].id : null); if (r.depositos.length) setNitNome(r.depositos[0].nome) }).catch(e => addToast(e.message, 'error'))
    carregarRepo()
  }, [])
  // Itens vindos da Reposição ("Pedir à Sede") entram na lista uma vez.
  useEffect(() => { if (prefill && prefill.length) { juntar(prefill); onPrefillUsado() } }, [prefill])
  const item = id => cat.find(c => String(c.id) === String(id))
  const nit = id => { const c = item(id); return c && nitId && c.saldos[nitId] ? c.saldos[nitId] : null }
  const infoNit = id => { const s = nit(id), c = item(id); return `${nitNome} tem ${estNum(s ? s.qtd || 0 : 0)} ${(c && c.unidade) || ''}${s && s.minimo > 0 ? ` · mínimo ${estNum(s.minimo)}` : ''}` }
  const adicionar = () => {
    if (!sel.catalogo_id) { addToast('Escolha o item do catálogo.', 'error'); return }
    if (!(estNumTxt(sel.qtd) > 0)) { addToast('Informe a quantidade.', 'error'); return }
    const k = String(sel.catalogo_id)
    setLinhas(ls => ls.some(l => String(l.catalogo_id) === k)
      ? ls.map(l => String(l.catalogo_id) === k ? { ...l, qtd: String(estQtdPos(estNumTxt(l.qtd) + estNumTxt(sel.qtd))) } : l)
      : [...ls, { catalogo_id: sel.catalogo_id, qtd: sel.qtd }])
    setSel({ catalogo_id: '', qtd: '' }); setSelKey(x => x + 1)
  }
  const enviar = async () => {
    const itens = linhas.map(l => ({ catalogo_id: l.catalogo_id, qtd: estNumTxt(l.qtd) })).filter(l => l.qtd > 0)
    if (!itens.length) { addToast('Adicione ao menos um item com quantidade.', 'error'); return }
    setBusy(true)
    try {
      const r = await POST('/estoque/pedidos', { itens, obs, urgente })
      addToast(`Pedido ${r.numero} enviado à Sede.`, 'success')
      setLinhas([]); setObs(''); setUrgente(false); carregarRepo(); onCriado()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  if (!iniciado) return <div className="alert alert-warning">Pedidos à Sede ficam disponíveis após a carga inicial do estoque.</div>
  const faltamRepo = repo.filter(r => !linhas.some(l => String(l.catalogo_id) === String(r.catalogo_id)))
  const selUn = sel.catalogo_id && item(sel.catalogo_id) ? item(sel.catalogo_id).unidade : ''
  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title">Novo pedido à Sede</span>
        {faltamRepo.length > 0 && <button className="btn btn-ghost btn-sm" onClick={() => juntar(faltamRepo)}><Icon name="alertTriangle" size={13} /> Puxar o que está abaixo do mínimo ({faltamRepo.length})</button>}
      </div>
      <div className="card-body">
        <div className="form-grid">
          <div className="form-group full"><label>Item</label>
            <EstItemPicker key={selKey} catalogo={cat} value={sel.catalogo_id} onChange={v => setSel(s => ({ ...s, catalogo_id: v }))} />
            {sel.catalogo_id && <span className="est-sub">{infoNit(sel.catalogo_id)}</span>}</div>
          <div className="form-group"><label>Quantidade {selUn && <span className="est-sub">({selUn})</span>}</label>
            <input type="number" min="0" step="any" value={sel.qtd} onChange={e => setSel({ ...sel, qtd: e.target.value })} onKeyDown={e => e.key === 'Enter' && adicionar()} /></div>
          <div className="form-group" style={{ alignSelf: 'end' }}><button className="btn btn-outline" onClick={adicionar}><Icon name="plus" size={14} /> Adicionar à lista</button></div>
        </div>
        {linhas.length > 0 && <div style={{ marginTop: 12 }}>
          {linhas.map(l => { const c = item(l.catalogo_id); return (
            <div key={l.catalogo_id} className="est-ped-item">
              <span className="nome">{c ? c.nome : 'Carregando…'}<div className="est-sub">{infoNit(l.catalogo_id)}</div></span>
              <label className="est-chk">Pedir <input type="number" min="0" step="any" value={l.qtd} onChange={e => setLinhas(ls => ls.map(x => String(x.catalogo_id) === String(l.catalogo_id) ? { ...x, qtd: e.target.value } : x))} /> <span className="est-sub">{(c && c.unidade) || ''}</span></label>
              <button className="est-link" onClick={() => setLinhas(ls => ls.filter(x => String(x.catalogo_id) !== String(l.catalogo_id)))}>remover</button>
            </div>)
          })}
        </div>}
        <div className="est-ped-acoes" style={{ marginTop: 12 }}>
          <input value={obs} onChange={e => setObs(e.target.value)} placeholder="Observação para a Sede (opcional) — ex.: para a obra X na segunda" />
          <label className="est-chk"><input type="checkbox" checked={urgente} onChange={e => setUrgente(e.target.checked)} /> Urgente</label>
          <button className="btn btn-accent" disabled={busy || !linhas.length} onClick={enviar}><Icon name="send" size={14} /> Enviar pedido à Sede{linhas.length ? ` (${linhas.length})` : ''}</button>
        </div>
      </div>
    </div>
  )
}

// Inventário em lote: contagem física de um depósito inteiro (ou de uma categoria), item a item, e um
// único registro no fim — cada diferença vira ajuste com a mesma justificativa. Rascunho fica salvo
// no aparelho (a contagem no galpão pode levar horas e o celular pode bloquear no meio).
function EstInventario({ iniciado, addToast, onMudou }) {
  const [dados, setDados] = useState(null)
  const [dep, setDep] = useState('')
  const [catF, setCatF] = useState('')
  const [q, setQ] = useState('')
  const [soDif, setSoDif] = useState(false)
  const [cont, setCont] = useState({})
  const [just, setJust] = useState('')
  const [busy, setBusy] = useState(false)
  const chaveRasc = d => 'cautelix-inv-' + d
  const carregar = () => GET('/estoque/saldos?todos=1').then(r => { setDados(r); setDep(x => x || (r.depositos[0] ? String(r.depositos[0].id) : '')) }).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [])
  useEffect(() => { if (!dep) return; let r = {}; try { r = JSON.parse(localStorage.getItem(chaveRasc(dep)) || '{}') } catch {} setCont(r) }, [dep])
  const setC = (id, v) => setCont(c => { const n = { ...c }; if (v === '') delete n[id]; else n[id] = v; try { localStorage.setItem(chaveRasc(dep), JSON.stringify(n)) } catch {} return n })
  if (!iniciado) return <div className="alert alert-warning">O inventário fica disponível após a carga inicial do estoque.</div>
  if (!dados) return <div className="card"><div className="card-body text-muted">Carregando…</div></div>
  const sist = i => (i.saldos[dep] && i.saldos[dep].qtd) || 0
  const cm = i => (i.saldos[dep] && i.saldos[dep].custo_medio) || i.custo_medio || 0
  const dif = i => cont[i.id] === undefined ? null : Math.round((Number(String(cont[i.id]).replace(',', '.')) - sist(i)) * 10000) / 10000
  const cats = [...new Set(dados.itens.map(i => i.categoria).filter(Boolean))].sort()
  const t = q.trim().toLowerCase()
  const lista = dados.itens.filter(i => (!catF || i.categoria === catF) && casaBusca(t, i.nome, i.codigo)
    && (sist(i) || cont[i.id] !== undefined || t) && (!soDif || dif(i)))
  const contados = dados.itens.filter(i => cont[i.id] !== undefined)
  const comDif = contados.filter(i => dif(i))
  const invalidos = contados.filter(i => { const v = Number(String(cont[i.id]).replace(',', '.')); return isNaN(v) || v < 0 })
  const valorDif = comDif.reduce((a, i) => a + dif(i) * cm(i), 0)
  const registrar = async () => {
    if (!contados.length) { addToast('Nenhum item contado.', 'error'); return }
    if (invalidos.length) { addToast(`Contagem inválida em ${invalidos.length} item(ns).`, 'error'); return }
    if (just.trim().length < 5) { addToast('Informe a justificativa (mín. 5 caracteres).', 'error'); return }
    const depNome = (dados.depositos.find(x => String(x.id) === dep) || {}).nome
    if (!confirm(`Registrar inventário de ${depNome}?\n\n${contados.length} item(ns) contado(s), ${comDif.length} com diferença (${estBRL(valorDif)}).\nOs saldos passam a ser os contados.`)) return
    setBusy(true)
    try {
      const r = await POST('/estoque/inventario', { deposito_id: Number(dep), justificativa: just.trim(), contagens: contados.map(i => ({ catalogo_id: i.id, contagem: Number(String(cont[i.id]).replace(',', '.')) })) })
      addToast(`Inventário registrado: ${r.conferidos} conferido(s), ${r.ajustados} ajustado(s) (${estBRL(r.valor_diferenca)}).`, 'success')
      try { localStorage.removeItem(chaveRasc(dep)) } catch {}
      setCont({}); setJust(''); carregar(); onMudou()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title">Inventário (contagem física)</span>
        <div className="est-filtros">
          <select value={dep} onChange={e => setDep(e.target.value)}>{dados.depositos.map(d => <option key={d.id} value={d.id}>{d.nome}</option>)}</select>
          {cats.length > 1 && <select value={catF} onChange={e => setCatF(e.target.value)}><option value="">Todas as categorias</option>{cats.map(c => <option key={c}>{c}</option>)}</select>}
          <input placeholder="Buscar item (inclui sem saldo)…" value={q} onChange={e => setQ(e.target.value)} />
          <label className="est-chk"><input type="checkbox" checked={soDif} onChange={e => setSoDif(e.target.checked)} /> Só com diferença</label>
        </div>
      </div>
      <div className="card-body" style={{ paddingBottom: 0 }}>
        <div className="est-sub">Digite a quantidade contada. Item deixado em branco não é alterado. O rascunho fica salvo neste aparelho até registrar.</div>
      </div>
      {lista.length === 0 ? <div className="empty">Nenhum item com saldo neste filtro. Busque pelo nome para contar um item sem saldo.</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Item</th><th style={{ textAlign: 'right' }}>Sistema</th><th style={{ width: 130 }}>Contado</th><th style={{ textAlign: 'right' }}>Diferença</th></tr></thead>
          <tbody>{lista.slice(0, 300).map(i => { const df = dif(i); return (
            <tr key={i.id}>
              <td data-label="Item"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{i.nome}</div><div className="est-sub">{[i.codigo, i.categoria].filter(Boolean).join(' · ')}</div></td>
              <td data-label="Sistema" className="est-num">{estNum(sist(i))} <span className="est-sub">{i.unidade || ''}</span></td>
              <td data-label="Contado"><input type="number" min="0" step="any" inputMode="decimal" value={cont[i.id] ?? ''} onChange={e => setC(i.id, e.target.value)} style={{ width: 110 }} /></td>
              <td data-label="Diferença" className="est-num" style={{ fontWeight: 700, color: df == null || !df ? 'var(--text-secondary)' : df < 0 ? 'var(--danger)' : 'var(--success)' }}>
                {df == null ? '—' : !df ? 'confere' : <>{df > 0 ? '+' : ''}{estNum(df)}<div className="est-sub">{estBRL(df * cm(i))}</div></>}</td>
            </tr>) })}</tbody>
        </table></div>
      )}
      {lista.length > 300 && <div className="card-body est-sub">Mostrando 300 de {lista.length}. Filtre por categoria ou busque.</div>}
      <div className="est-inv-rodape">
        <div><strong>{contados.length}</strong> contado(s) · <strong style={{ color: comDif.length ? 'var(--warning)' : 'var(--success)' }}>{comDif.length}</strong> com diferença · <strong>{estBRL(valorDif)}</strong></div>
        <input value={just} onChange={e => setJust(e.target.value)} placeholder="Justificativa (ex.: inventário mensal de setembro)" />
        <button className="btn btn-primary" disabled={busy || !contados.length} onClick={registrar}><Icon name="check" size={14} /> {busy ? 'Registrando…' : 'Registrar inventário'}</button>
        {contados.length > 0 && <button className="btn btn-ghost btn-sm" disabled={busy} onClick={() => { if (confirm('Descartar a contagem em andamento deste depósito?')) { setCont({}); try { localStorage.removeItem(chaveRasc(dep)) } catch {} } }}>Descartar</button>}
      </div>
    </div>
  )
}

// Lançamento de uma nota: depósito → de-para por linha (sugerido/memorizado) → conversão →
// compras que chegaram → confirmar. Linha em "Depois" = material que ainda não chegou: a nota fica
// "aguardando material" até alguém conferir e dar entrada. Linha em "EPI" (macacão, luva, bota…) vai
// para Uniformes/EPI — lá se escolhe o tamanho — e não entra neste estoque.
function EstLancarNota({ id, escrita, addToast, onVoltar }) {
  const [n, setN] = useState(null)
  const [dep, setDep] = useState('')
  const [linhas, setLinhas] = useState({})
  const [comprasSel, setComprasSel] = useState({})
  const [busy, setBusy] = useState(false)
  // Compra em aberto deste item pedida PARA uma base (que tem quem assine) → a linha já nasce indo para lá.
  const depDaCompra = (r, cid) => {
    const c = cid && r.compras_abertas.find(c => String(c.catalogo_id) === String(cid) && c.destino_deposito_id)
    const d = c && r.depositos.find(d => d.id === c.destino_deposito_id)
    return d && !d.sem_assinante ? String(d.id) : ''
  }
  const carregar = () => GET('/estoque/notas/' + id).then(r => {
    setN(r)
    const l = {}
    for (const i of r.itens) if (!i.tratado) l[i.id] = { acao: 'lancar', catalogo_id: i.sugestao.catalogo_id || '', fator: i.sugestao.fator || 1, memorizado: i.sugestao.memorizado, novo: null, dep: depDaCompra(r, i.sugestao.catalogo_id) }
    setLinhas(l)
    const sede = r.depositos.find(d => d.tipo === 'sede') || r.depositos[0]
    if (sede) setDep(d => d || String(sede.id))
  }).catch(e => { addToast(e.message, 'error'); onVoltar() })
  useEffect(() => { carregar() }, [id])
  if (!n) return <div className="card"><div className="card-body text-muted">Carregando nota…</div></div>
  const set = (iid, patch) => setLinhas(l => ({ ...l, [iid]: { ...l[iid], ...patch } }))
  const catDe = cid => n.catalogo.find(c => String(c.id) === String(cid))
  const pend = n.itens.filter(i => !i.tratado)
  // Destino de cada linha: o dela (escolhido ou vindo da compra) ou o da nota. Base = remessa com assinatura.
  const depDe = did => n.depositos.find(d => String(d.id) === String(did))
  const destDe = l => l.dep || dep
  const lancando = pend.map(i => linhas[i.id]).filter(l => l && l.acao === 'lancar')
  const mapeados = new Set(lancando.filter(l => l.catalogo_id).map(l => String(l.catalogo_id)))
  const compras = n.compras_abertas.filter(c => mapeados.has(String(c.catalogo_id)))
  const destinosDoItem = cid => new Set(lancando.filter(l => String(l.catalogo_id) === String(cid)).map(l => String(destDe(l))))
  const paraBases = {}   // nome da base → nº de linhas
  for (const l of lancando) { const d = depDe(destDe(l)); if (d && d.base) paraBases[d.nome] = (paraBases[d.nome] || 0) + 1 }
  const trocarDepNota = v => { setDep(v); setLinhas(l => { const o = { ...l }; for (const k of Object.keys(o)) o[k] = { ...o[k], dep: '' }; return o }) }
  const invalidas = pend.filter(i => { const l = linhas[i.id]; return l && ((l.acao === 'lancar' && !l.catalogo_id && !(l.novo && l.novo.nome.trim())) || (l.acao === 'unidade' && !l.rec_compra_id)) })
  // Compras levadas direto do fornecedor à unidade: a linha liga à compra (custo registrado) e não entra no saldo.
  const diretas = n.compras_diretas || []
  const diretaUsada = (cid, iid) => pend.some(x => x.id !== iid && linhas[x.id] && linhas[x.id].acao === 'unidade' && String(linhas[x.id].rec_compra_id) === String(cid))
  const qtdLancar = pend.filter(i => linhas[i.id] && linhas[i.id].acao !== 'depois').length
  const qtdDepois = pend.length - qtdLancar
  const linhasEpi = n.itens.filter(i => i.tratado ? i.tratado.acao === 'epi' : linhas[i.id] && linhas[i.id].acao === 'epi').length
  const acoes = [['lancar', 'Lançar'], ...(n.modulo_epi ? [['epi', 'EPI']] : []), ...(diretas.length ? [['unidade', 'Unidade']] : []), ['ignorar', 'Ignorar'], ['depois', 'Depois']]
  // A nota chegou antes do material: sai da fila de pendentes e espera, sem lançar nada.
  const aguardar = async () => {
    setBusy(true)
    try {
      await POST(`/estoque/notas/${id}/aguardar`, { aguardar: true })
      addToast(`NF ${n.numero || ''} guardada em "Aguardando material". Quando chegar, abra a nota, confira e dê entrada.`, 'success')
      onVoltar()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const confirmar = async () => {
    if (!qtdLancar) { aguardar(); return }   // tudo em "Depois" = o material ainda não chegou
    if (!dep) { addToast('Escolha o depósito de destino.', 'error'); return }
    if (invalidas.length) { addToast(`Escolha o item do catálogo — ou, em "Unidade", a compra — (ou "Ignorar"/"Depois") em ${invalidas.length} linha(s).`, 'error'); return }
    const payload = pend.filter(i => linhas[i.id].acao !== 'depois').map(i => {
      const l = linhas[i.id]
      if (l.acao === 'ignorar' || l.acao === 'epi') return { nfe_item_id: i.id, acao: l.acao }
      if (l.acao === 'unidade') return { nfe_item_id: i.id, acao: 'unidade', rec_compra_id: Number(l.rec_compra_id) }
      return { nfe_item_id: i.id, acao: 'lancar', fator: Number(l.fator) || 1, deposito_id: Number(destDe(l)), ...(l.catalogo_id ? { catalogo_id: l.catalogo_id } : { novo_item: l.novo }) }
    })
    setBusy(true)
    try {
      const r = await POST(`/estoque/notas/${id}/lancar`, { deposito_id: Number(dep), linhas: payload, compras_ids: Object.keys(comprasSel).filter(k => comprasSel[k]).map(Number), aguardar: qtdDepois > 0 })
      const partes = [r.lancadas && `${r.lancadas} lançada(s)`, r.epi && `${r.epi} para Uniformes/EPI`, r.unidade && `${r.unidade} direto na unidade (sem saldo)`, r.ignoradas && `${r.ignoradas} ignorada(s)`, r.novos && `${r.novos} item(ns) novo(s)`, r.compras && `${r.compras} compra(s) marcada(s) como chegou`,
        ...(r.remessas || []).map(x => `${x.numero} a caminho de ${x.para} (entra lá quando o almoxarife 2 assinar)`)].filter(Boolean)
      addToast(`${partes.join(', ')}. ${r.status === 'aguardando' ? `${qtdDepois} linha(s) aguardando o material chegar.` : r.status === 'lancada' || r.status === 'so_epi' ? 'Nota concluída.' : 'Nota parcial.'}`, 'success')
      onVoltar()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  // Correções de destino de uma linha já tratada: EPI ↔ material de obra.
  const paraEpi = async i => {
    const noEstoque = i.tratado && i.tratado.acao === 'lancar'
    if (!confirm(noEstoque
      ? `"${i.descricao}" é EPI/uniforme?\n\nSai do estoque: ${estNum(i.tratado.qtd_estoque)} de "${i.tratado.catalogo_nome}" (${i.tratado.deposito_nome}) e entra em Uniformes/EPI (tamanho pela descrição da nota).`
      : `Mandar "${i.descricao}" para Uniformes/EPI?`)) return
    setBusy(true)
    try {
      const r = await POST(`/estoque/notas/linhas/${i.id}/epi`)
      const u = r.uniformes || {}
      const foi = (u.entradas || []).map(e => `${e.qtd} × ${e.item}${e.tamanho ? ' tam. ' + e.tamanho : ''}`).join(', ')
      addToast(!noEstoque ? 'Linha enviada para Uniformes/EPI.'
        : foi ? `Tirado do estoque e já em Uniformes/EPI: ${foi}.`
        : `Tirado do estoque. Falta escolher o item/tamanho em Uniformes/EPI → Entradas${u.pendentes && u.pendentes[0] ? ` (${u.pendentes[0].motivo})` : ''}.`, 'success')
      carregar()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const paraMaterial = async i => {
    if (i.tratado && i.tratado.uni_entrou) { if (!confirm(`"${i.descricao}" é material de obra?

Sai de Uniformes/EPI: ${i.tratado.uni_entrou}. Depois é só lançar no estoque.`)) return }
    else if (n.usada_uniformes && !confirm('Esta nota já deu entrada em Uniformes/EPI. Se esta linha entrou lá, lançar aqui também conta em dobro. Continuar?')) return
    setBusy(true)
    try { await DEL(`/estoque/notas/linhas/${i.id}/epi`); addToast('A linha voltou para o estoque de material — escolha o item e lance.', 'success'); carregar() }
    catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title"><button className="btn btn-ghost btn-sm" onClick={onVoltar} style={{ marginRight: 8 }}>← Voltar</button>NF {n.numero || '—'} · {n.emitente || 'fornecedor'}</span>
        <span className="est-sub">{estData(n.data_emissao)} · {estBRL(n.valor_total)} · CNPJ {n.emitente_cnpj ? estCnpj(n.emitente_cnpj) : '—'}</span>
        {n.tem_xml && <button className="btn btn-ghost btn-sm" onClick={() => baixarArquivo(`/nfe/vobi/${n.id}/xml`, `${n.chave || 'NFe-' + (n.numero || n.id)}.xml`).catch(e => addToast(e.message, 'error'))}><Icon name="download" size={13} /> XML</button>}
      </div>
      <div className="card-body">
        {/* De quem é a nota e do que se trata — para decidir se é para receber antes de lançar. */}
        <div className="est-nota-info">
          <div><span className="est-sub">Comprador (destinatário)</span><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{n.destinatario || '—'}</div>{n.destinatario_cnpj && <div className="est-sub">{estCnpj(n.destinatario_cnpj)}</div>}</div>
          {n.natureza && <div><span className="est-sub">Natureza da operação</span><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{n.natureza}</div></div>}
          <div><span className="est-sub">Origem</span><div>{EST_ORIGEM[n.origem] || n.origem}{n.chave && <div className="est-sub" style={{ wordBreak: 'break-all' }}>chave {n.chave}</div>}</div></div>
        </div>
        {n.info_complementar && <div className="est-nota-obs"><span className="est-sub">Informações complementares</span><div>{n.info_complementar}</div></div>}
        {n.usada_uniformes ? <div className="alert alert-info">Esta nota já deu entrada (total ou parcial) em <strong>Uniformes/EPI</strong>. Lance aqui só o que for material de obra.</div> : null}
        {n.aguardando_em && pend.length > 0 && <div className="alert alert-warning" style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ flex: 1, minWidth: 220 }}><strong>Aguardando o material chegar</strong> desde {estData(n.aguardando_em)}{n.aguardando_nome ? ` (marcado por ${n.aguardando_nome})` : ''}. Quando chegar, confira as quantidades e dê entrada abaixo.</span>
        </div>}
        {linhasEpi > 0 && !n.usada_uniformes && <div className="alert alert-info"><strong>{linhasEpi} linha(s) de EPI/uniforme</strong> não entram neste estoque: vão para <strong>Uniformes/EPI → Entradas</strong>, onde se dá a entrada com o tamanho. Se alguma for material de obra, use "é material de obra" na linha.</div>}
        {escrita && pend.length > 0 && (
          <div className="form-group" style={{ maxWidth: 320 }}><label>Destino da nota toda *</label>
            <select value={dep} onChange={e => trocarDepNota(e.target.value)}>{n.depositos.map(d => <option key={d.id} value={d.id} disabled={!!d.sem_assinante}>{d.nome}{d.sem_assinante ? ' (sem Almoxarife 2 para assinar)' : ''}</option>)}</select>
            {n.depositos.length > 1 && <div className="est-sub" style={{ marginTop: 4 }}>Dá para mudar linha a linha na coluna Destino.</div>}</div>
        )}
        {escrita && Object.keys(paraBases).length > 0 && <div className="alert alert-warning">
          {Object.entries(paraBases).map(([b, q]) => `${q} linha(s) para ${b}`).join(' · ')}: vão em remessa e só entram no saldo de lá quando o almoxarife 2 conferir e <strong>assinar a chegada</strong> (aba Pedidos). Até lá ficam em trânsito — não entram na Sede.
        </div>}
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Produto na nota</th><th style={{ textAlign: 'right' }}>Qtd NF</th><th>Ação</th><th>Item do estoque</th><th>Conversão</th><th>Destino</th></tr></thead>
          <tbody>{n.itens.map(i => {
            const l = linhas[i.id]
            const c = l && catDe(l.catalogo_id)
            const unEst = c ? c.unidade : (l && l.novo ? l.novo.unidade : '')
            return (
              <tr key={i.id} style={i.tratado ? { opacity: i.tratado.acao === 'epi' ? .8 : .6 } : null}>
                <td data-label="Produto"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{i.descricao}</div>
                  <div className="est-sub">{[i.codigo && 'cód. ' + i.codigo, i.ncm && 'NCM ' + i.ncm, estBRL(i.valor_unit) + '/' + (i.unidade || 'un')].filter(Boolean).join(' · ')}</div></td>
                <td data-label="Qtd NF" className="est-num">{estNum(i.quantidade)} {i.unidade}</td>
                {i.tratado ? (
                  <td data-label="Situação" colSpan="4"><div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                    {i.tratado.acao === 'epi' ? <span><span className="badge tg-cobre">EPI → Uniformes/EPI</span>{i.tratado.uni_entrou && <span className="est-sub" style={{ marginLeft: 6 }}>✓ entrou: {i.tratado.uni_entrou}</span>}</span>
                      : i.tratado.acao === 'ignorar' ? <span className="est-sub">Ignorada</span>
                      : i.tratado.acao === 'unidade' ? <span><span className="badge tg-cobre">Direto p/ unidade</span> <span className="est-sub">{i.tratado.compra_numero || ''}{i.tratado.compra_obra_nome ? ` · ${i.tratado.compra_obra_nome}` : ''} — custo na compra, sem entrada no estoque</span></span>
                      : i.tratado.rp_status === 'em_transito' ? <span>{estNum(i.tratado.qtd_estoque)} → <strong>{i.tratado.catalogo_nome}</strong> <span className="badge tg-aco">a caminho de {i.tratado.deposito_nome} · {i.tratado.rp_numero}</span> <span className="est-sub">aguardando a assinatura da chegada</span></span>
                      : i.tratado.rp_status === 'recebido' ? <span>✓ chegou {estNum(i.tratado.rp_recebida || 0)} de {estNum(i.tratado.qtd_estoque)} → <strong>{i.tratado.catalogo_nome}</strong> <span className="est-sub">({i.tratado.deposito_nome} · {i.tratado.rp_numero} assinado)</span></span>
                      : <span>✓ {estNum(i.tratado.qtd_estoque)} → <strong>{i.tratado.catalogo_nome}</strong> <span className="est-sub">({i.tratado.deposito_nome})</span></span>}
                    {escrita && i.tratado.acao === 'epi' && <button className="est-link" disabled={busy} onClick={() => paraMaterial(i)}>é material de obra</button>}
                    {escrita && n.modulo_epi && (i.tratado.acao === 'ignorar' || (i.tratado.acao === 'lancar' && n.pode_desfazer && i.tratado.rp_status !== 'em_transito')) &&
                      <button className="est-link" disabled={busy} onClick={() => paraEpi(i)} title={i.tratado.acao === 'lancar' ? 'Tira do saldo e manda para Uniformes/EPI' : ''}>{i.tratado.acao === 'lancar' ? 'é EPI — tirar do estoque' : 'mandar p/ EPI'}</button>}
                  </div></td>
                ) : !escrita ? <td colSpan="4" className="est-sub">Pendente</td> : (<>
                  <td data-label="Ação"><div className="uni-switch">
                    {acoes.map(([k, t]) => <button key={k} className={l.acao === k ? 'active' : ''} title={k === 'epi' ? 'EPI ou uniforme: vai para Uniformes/EPI (com tamanho), não para este estoque' : k === 'depois' ? 'O material ainda não chegou' : k === 'unidade' ? 'Compra que foi direto do fornecedor para a unidade: registra o custo, não entra no estoque' : ''} onClick={() => set(i.id, { acao: k })}>{t}</button>)}
                  </div></td>
                  <td data-label="Item"><div className="est-item-cell">{l.acao === 'unidade' ? (
                    <div style={{ display: 'grid', gap: 4 }}>
                      <select value={l.rec_compra_id || ''} onChange={e => set(i.id, { rec_compra_id: e.target.value })}>
                        <option value="">Qual compra foi direto para a unidade?</option>
                        {diretas.map(c => <option key={c.id} value={c.id} disabled={diretaUsada(c.id, i.id)}>{c.numero} · {estNum(c.qtd)} {c.unidade || ''} {c.catalogo_nome || c.descricao || ''}{c.obra_nome ? ` → ${c.obra_nome}` : ''}</option>)}
                      </select>
                      <span className="est-sub">não entra no saldo — o material foi do fornecedor direto para a unidade</span>
                    </div>
                  ) : l.acao === 'epi' ? <span className="est-sub">vai para <strong style={{ color: 'var(--ink)' }}>Uniformes/EPI</strong> — tamanho escolhido lá</span> : l.acao === 'depois' ? <span className="est-sub">aguardando chegar</span> : l.acao !== 'lancar' ? <span className="est-sub">—</span> : l.novo ? (
                    <div className="est-novo">
                      <input value={l.novo.nome} onChange={e => set(i.id, { novo: { ...l.novo, nome: e.target.value } })} placeholder="Nome do item novo" />
                      <input value={l.novo.unidade} onChange={e => set(i.id, { novo: { ...l.novo, unidade: e.target.value } })} style={{ maxWidth: 70 }} placeholder="UN" />
                      <button className="btn btn-ghost btn-sm" onClick={() => set(i.id, { novo: null })}>cancelar</button>
                    </div>
                  ) : (<>
                    <EstItemPicker catalogo={n.catalogo} value={l.catalogo_id} onChange={v => set(i.id, { catalogo_id: v, memorizado: false, ...(!l.dep && depDaCompra(n, v) ? { dep: depDaCompra(n, v) } : {}) })} />
                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 4 }}>
                      {l.memorizado && <span className="badge est-st-ok" title="De-para memorizado deste fornecedor">memorizado</span>}
                      <button className="est-link" onClick={() => set(i.id, { catalogo_id: '', novo: { nome: i.descricao, unidade: i.unidade || 'UN' } })}>+ criar item novo</button>
                    </div>
                  </>)}</div></td>
                  <td data-label="Conversão">{l.acao !== 'lancar' ? <span className="est-sub">—</span> : (
                    <div className="est-conv">
                      <span className="est-sub">1 {i.unidade} =</span>
                      <input type="number" min="0" step="any" value={l.fator} onChange={e => set(i.id, { fator: e.target.value })} />
                      <span className="est-sub">{unEst || 'un'}</span>
                      <div className="est-sub" style={{ width: '100%' }}>entra <strong style={{ color: 'var(--ink)' }}>{estNum((Number(i.quantidade) || 0) * (Number(l.fator) || 0))} {unEst}</strong></div>
                    </div>
                  )}</td>
                  <td data-label="Destino">{l.acao !== 'lancar' ? <span className="est-sub">—</span> : n.depositos.length < 2 ? <span>{(depDe(destDe(l)) || {}).nome || '—'}</span> : (
                    <div className="est-destino">
                      <select value={destDe(l)} onChange={e => set(i.id, { dep: e.target.value === String(dep) ? '' : e.target.value })}>
                        {n.depositos.map(o => <option key={o.id} value={o.id} disabled={!!o.sem_assinante}>{o.nome}{o.sem_assinante ? ' (sem Almoxarife 2)' : ''}</option>)}</select>
                      {(depDe(destDe(l)) || {}).base && <span className="est-sub">remessa · assinatura na chegada</span>}
                    </div>
                  )}</td>
                </>)}
              </tr>)
          })}</tbody>
        </table></div>
        {escrita && compras.length > 0 && (
          <div className="est-compras">
            <div style={{ fontWeight: 700, marginBottom: 6 }}>Compras em aberto destes itens — marcar como "chegou"?</div>
            {compras.map(c => (
              <label key={c.id} className="est-chk" style={{ display: 'flex', marginBottom: 4 }}>
                <input type="checkbox" checked={!!comprasSel[c.id]} onChange={e => setComprasSel({ ...comprasSel, [c.id]: e.target.checked })} />
                <span><strong>{c.numero}</strong> · {c.descricao} · {estNum(c.qtd)} {c.unidade || ''}{c.obra_nome ? ` · ${c.obra_nome}` : ''}{c.destino_nome ? ` · para ${c.destino_nome}` : ''} <span className="est-sub">({c.status.replace(/_/g, ' ')})</span>
                  {c.destino_deposito_id && !destinosDoItem(c.catalogo_id).has(String(c.destino_deposito_id)) ? <span className="badge tg-alerta" style={{ marginLeft: 6 }}>compra para {c.destino_nome} — confira o destino da linha</span> : null}</span>
              </label>
            ))}
          </div>
        )}
        {escrita && pend.length > 0 && (
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 14, flexWrap: 'wrap', alignItems: 'center' }}>
            <button className="btn btn-ghost btn-sm" disabled={busy} title="Nota que não é para este estoque (outra empresa, serviço, uso e consumo…): marca todas as linhas como Ignorar — confira e confirme"
              onClick={() => setLinhas(l => { const o = { ...l }; for (const k of Object.keys(o)) o[k] = { ...o[k], acao: 'ignorar' }; return o })}>Não receber (ignorar tudo)</button>
            {!n.aguardando_em && qtdLancar > 0 && <button className="btn btn-outline btn-sm" disabled={busy} onClick={aguardar}
              title="A nota foi emitida mas o material ainda não chegou para conferir: guarda a nota sem lançar nada">Material ainda não chegou</button>}
            <span className="est-sub">{qtdLancar ? `${qtdLancar} de ${pend.length} linha(s) serão tratadas agora${qtdDepois ? ` · ${qtdDepois} aguardando` : ''}` : 'Nenhuma linha chegou ainda'}</span>
            {qtdLancar ? <button className="btn btn-primary" disabled={busy} onClick={confirmar}><Icon name="check" size={14} /> {busy ? 'Lançando…' : 'Confirmar entrada'}</button>
              : n.aguardando_em ? <button className="btn btn-ghost" onClick={onVoltar}>Voltar (segue aguardando)</button>
              : <button className="btn btn-primary" disabled={busy} onClick={aguardar}><Icon name="clock" size={14} /> {busy ? 'Guardando…' : 'Guardar até o material chegar'}</button>}
          </div>
        )}
      </div>
    </div>
  )
}

function EstMovimentos({ user, addToast }) {
  const hoje = new Date().toISOString().slice(0, 10)
  const [f, setF] = useState({ de: new Date(Date.now() - 30 * 86400000).toISOString().slice(0, 10), ate: hoje, tipo: '', deposito_id: '', q: '' })
  const [deps, setDeps] = useState([])
  const [movs, setMovs] = useState(null)
  const qs = () => '?' + Object.entries(f).filter(([, v]) => v).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
  const carregar = () => GET('/estoque/movimentos' + qs()).then(setMovs).catch(e => addToast(e.message, 'error'))
  useEffect(() => { GET('/rec/depositos').then(r => setDeps(estDepsMov(user, r))).catch(() => {}) }, [])
  useEffect(() => { carregar() }, [f.de, f.ate, f.tipo, f.deposito_id])
  return (
    <div className="card">
      <div className="card-header" style={{ flexWrap: 'wrap', gap: 8 }}>
        <span className="card-title">Movimentações</span>
        <div className="est-filtros">
          <input type="date" value={f.de} onChange={e => setF({ ...f, de: e.target.value })} />
          <input type="date" value={f.ate} onChange={e => setF({ ...f, ate: e.target.value })} />
          <select value={f.tipo} onChange={e => setF({ ...f, tipo: e.target.value })}><option value="">Todos os tipos</option>{Object.entries(EST_TIPO).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
          {deps.length > 1 && <select value={f.deposito_id} onChange={e => setF({ ...f, deposito_id: e.target.value })}><option value="">Todos os depósitos</option>{deps.map(d => <option key={d.id} value={d.id}>{d.nome}</option>)}</select>}
          <input placeholder="Item ou referência…" value={f.q} onChange={e => setF({ ...f, q: e.target.value })} onKeyDown={e => e.key === 'Enter' && carregar()} />
          <button className="btn btn-ghost btn-sm" onClick={() => baixarArquivo('/estoque/movimentos.csv' + qs(), `movimentacoes-estoque-${f.de}-a-${f.ate}.csv`).catch(e => addToast(e.message, 'error'))}><Icon name="download" size={13} /> Excel (CSV)</button>
        </div>
      </div>
      {!movs ? <div className="card-body text-muted">Carregando…</div> : movs.length === 0 ? <div className="empty">Nenhuma movimentação no filtro.</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Data</th><th>Tipo</th><th>Item</th><th>Depósito</th><th style={{ textAlign: 'right' }}>Qtd</th><th style={{ textAlign: 'right' }}>Saldo após</th><th>Referência</th></tr></thead>
          <tbody>{movs.map(m => (
            <tr key={m.id}>
              <td data-label="Data">{(m.criado_em || '').slice(0, 16)}</td>
              <td data-label="Tipo">{EST_TIPO[m.tipo] || m.tipo}</td>
              <td data-label="Item"><div style={{ fontWeight: 600, color: 'var(--ink)' }}>{m.item_nome}</div><div className="est-sub">{m.item_codigo || ''}</div></td>
              <td data-label="Depósito">{m.deposito_nome}</td>
              <td data-label="Qtd" className="est-num">{estQtdMov(m, m.unidade)}</td>
              <td data-label="Saldo após" className="est-num">{estNum(m.saldo_apos)}</td>
              <td data-label="Referência"><span className="est-sub">{m.obs || ''}{m.usuario_nome ? ` · ${m.usuario_nome}` : ''}</span></td>
            </tr>))}</tbody>
        </table></div>
      )}
    </div>
  )
}

// Transferência Sede ↔ bases (almox/compras/administração; almoxarife 2 só saindo da base dele) e
// ajuste de inventário (só almoxarifado).
function EstOperacoes({ user, iniciado, addToast, onMudou }) {
  const [cat, setCat] = useState([])
  const [deps, setDeps] = useState([])
  const [destinos, setDestinos] = useState([])   // todos os depósitos (só nome) — o almoxarife 2 transfere para a Sede sem ver o saldo dela
  const [saldos, setSaldos] = useState({})
  const [tr, setTr] = useState({ catalogo_id: '', de: '', para: '', quantidade: '', obs: '' })
  const [aj, setAj] = useState({ catalogo_id: '', deposito_id: '', contagem: '', justificativa: '' })
  const ME_VAZIO = { novo: false, catalogo_id: '', nome: '', unidade: '', categoria: '', quantidade: '', custo_unit: '', motivo: 'compra_sem_nf', justificativa: '' }
  const [me, setMe] = useState({ ...ME_VAZIO, deposito_id: '' })
  const [cats, setCats] = useState([])
  const [meKey, setMeKey] = useState(0)   // remonta o campo de busca ao limpar o item
  const [cc, setCc] = useState({ catalogo_id: '', custo: '', justificativa: '' })   // correção de custo (Sede)
  const [ccKey, setCcKey] = useState(0)
  const [ccTodos, setCcTodos] = useState(false)
  const [busy, setBusy] = useState(false)
  const podeAjustar = user.role === 'almoxarifado'
  const podeCusto = !!user.is_master && !user.ceo   // Master e perfil Admin (que chega aqui com is_master); o CEO só lê
  const veValor = estVeValor(user)   // almoxarife 2: entrada só com quantidade (o custo é da Sede)
  const carregar = () => GET('/estoque/saldos?todos=1').then(r => {
    const dest = r.destinos || r.depositos
    setDeps(r.depositos); setDestinos(dest); setCat(r.itens)
    const m = {}; for (const i of r.itens) m[i.id] = i.saldos; setSaldos(m)
    const mov = estDepsMov(user, r.depositos)
    // Base sem Almoxarife 2 ativo não recebe transferência (ninguém assina a chegada): não vem escolhida.
    const de = mov[0], para = dest.find(d => (!de || d.id !== de.id) && !d.sem_assinante)
    if (de && para) setTr(t => ({ ...t, de: t.de || String(de.id), para: t.para || String(para.id) }))
    if (r.depositos.length) setAj(a => ({ ...a, deposito_id: a.deposito_id || String(r.depositos[0].id) }))
    if (mov.length) setMe(a => ({ ...a, deposito_id: a.deposito_id || String(mov[0].id) }))
  }).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar(); GET('/rec/categorias').then(setCats).catch(() => {}) }, [])
  const saldo = (cid, did) => { const s = saldos[cid] && saldos[cid][did]; return s ? s.qtd : 0 }
  const unid = cid => { const c = cat.find(x => String(x.id) === String(cid)); return c ? (c.unidade || '') : '' }
  const run = async (fn, ok) => { setBusy(true); try { const r = await fn(); addToast(typeof ok === 'function' ? ok(r) : ok, 'success'); carregar(); onMudou(); return true } catch (e) { addToast(e.message, 'error'); return false } finally { setBusy(false) } }
  const paraBase = (destinos.find(d => String(d.id) === String(tr.para)) || {}).tipo === 'centro'
  const transferir = () => {
    if (!tr.catalogo_id || !(Number(tr.quantidade) > 0)) { addToast('Escolha o item e a quantidade.', 'error'); return }
    run(() => POST('/estoque/transferir', { catalogo_id: tr.catalogo_id, de_deposito_id: Number(tr.de), para_deposito_id: Number(tr.para), quantidade: Number(tr.quantidade), obs: tr.obs }),
      estMsgTransf).then(ok => ok && setTr(t => ({ ...t, quantidade: '', obs: '' })))
  }
  const ajustar = () => {
    if (!aj.catalogo_id || aj.contagem === '') { addToast('Escolha o item e informe a contagem.', 'error'); return }
    run(() => POST('/estoque/ajustar', { catalogo_id: aj.catalogo_id, deposito_id: Number(aj.deposito_id), contagem: Number(aj.contagem), justificativa: aj.justificativa }),
      'Ajuste registrado.').then(ok => ok && setAj(a => ({ ...a, contagem: '', justificativa: '' })))
  }
  // Entrada manual: material que chega sem NF-e (compra sem nota, sobra que volta da obra, doação).
  const ME_MOTIVOS = { compra_sem_nf: ['Compra sem nota fiscal', 'ex.: Depósito São Jorge — recibo 1234'], devolucao_obra: ['Devolução de obra (sobra)', 'ex.: sobra da obra Ed. Atlântico, retirada 12'],
    doacao: ['Doação / bonificação', 'ex.: bonificação do fornecedor X na NF 5566'], outro: ['Outro', 'descreva a origem do material'] }
  const entradaManual = async () => {
    if (me.novo ? !me.nome.trim() : !me.catalogo_id) { addToast(me.novo ? 'Informe o nome do item novo.' : 'Escolha o item (ou cadastre um item novo).', 'error'); return }
    if (!(Number(me.quantidade) > 0)) { addToast('Informe a quantidade.', 'error'); return }
    if (me.justificativa.trim().length < 5) { addToast('Informe a origem/justificativa (mín. 5 caracteres).', 'error'); return }
    setBusy(true)
    try {
      const r = await POST('/estoque/entrada-manual', { ...(me.novo ? { novo_item: { nome: me.nome, unidade: me.unidade, categoria: me.categoria || null } } : { catalogo_id: me.catalogo_id }),
        deposito_id: Number(me.deposito_id), quantidade: Number(me.quantidade), custo_unit: me.custo_unit === '' ? null : Number(me.custo_unit), motivo: me.motivo, justificativa: me.justificativa })
      addToast(r.item_novo ? 'Item cadastrado e entrada registrada.' : 'Entrada registrada.', 'success')
      // Mantém motivo, depósito e justificativa: vários itens do mesmo recibo/obra entram em sequência.
      setMe(a => ({ ...ME_VAZIO, deposito_id: a.deposito_id, motivo: a.motivo, justificativa: a.justificativa })); setMeKey(k => k + 1); carregar(); onMudou()
    } catch (e) {
      addToast(e.message, 'error')
      if (e.data && e.data.catalogo_id) setMe(a => ({ ...a, novo: false, catalogo_id: e.data.catalogo_id }))   // já existia: seleciona o existente
    } finally { setBusy(false) }
  }
  if (!iniciado) return <div className="alert alert-warning">Entradas manuais, transferências e ajustes ficam disponíveis após a carga inicial do estoque.</div>
  const difAj = aj.catalogo_id && aj.contagem !== '' ? Number(aj.contagem) - saldo(aj.catalogo_id, aj.deposito_id) : null
  const meSel = !me.novo && me.catalogo_id ? cat.find(c => String(c.id) === String(me.catalogo_id)) : null
  const meCm = meSel && meSel.saldos[me.deposito_id] ? meSel.saldos[me.deposito_id].custo_medio : null
  const meUn = me.novo ? me.unidade : unid(me.catalogo_id)
  // Correção de custo: só itens que já passaram pela Sede; em destaque os que têm saldo e estão sem preço.
  const sede = deps.find(d => d.tipo === 'sede')
  const naSede = sede ? cat.filter(c => c.saldos && c.saldos[sede.id]) : []
  const semCusto = naSede.filter(c => c.saldos[sede.id].qtd > 0 && !(Number(c.saldos[sede.id].custo_medio) > 0))
  const ccSel = cc.catalogo_id ? naSede.find(c => String(c.id) === String(cc.catalogo_id)) : null
  const ccS = ccSel ? ccSel.saldos[sede.id] : null
  const ccAnt = ccS && Number(ccS.custo_medio) > 0 ? Number(ccS.custo_medio) : null
  const corrigirCusto = () => {
    if (!ccSel) { addToast('Escolha o item.', 'error'); return }
    if (!(Number(cc.custo) > 0)) { addToast('Informe o custo unitário.', 'error'); return }
    if (cc.justificativa.trim().length < 5) { addToast('Informe a justificativa (mín. 5 caracteres).', 'error'); return }
    run(() => POST('/estoque/corrigir-custo', { catalogo_id: ccSel.id, custo_unit: Number(cc.custo), justificativa: cc.justificativa }),
      r => r.sem_diferenca ? 'O custo já era esse — nada mudou.' : `Custo na ${sede.nome}: ${r.custo_anterior == null ? 'sem preço' : estBRL(r.custo_anterior)} → ${estBRL(r.custo_novo)}.`)
      // Mantém a justificativa: vários itens da mesma cotação/nota são corrigidos em sequência.
      .then(ok => { if (ok) { setCc(c => ({ catalogo_id: '', custo: '', justificativa: c.justificativa })); setCcKey(k => k + 1) } })
  }
  return (
    <div className="est-ops">
      <div className="card">
        <div className="card-header"><span className="card-title">Entrada manual (sem nota fiscal)</span></div>
        <div className="card-body"><div className="form-grid">
          <div className="form-group full">
            <label style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>{me.novo ? 'Item novo *' : 'Item *'}
              <button type="button" className="est-link" onClick={() => setMe({ ...me, novo: !me.novo, catalogo_id: '' })}>{me.novo ? '← buscar no catálogo' : '+ item novo (fora do catálogo)'}</button></label>
            {me.novo
              ? <input value={me.nome} onChange={e => setMe({ ...me, nome: e.target.value })} placeholder="nome do material, ex.: Argamassa AC-III 20kg" />
              : <EstItemPicker key={meKey} catalogo={cat} value={me.catalogo_id} onChange={v => setMe({ ...me, catalogo_id: v })} />}
          </div>
          {me.novo && <>
            <div className="form-group"><label>Unidade</label><input value={me.unidade} onChange={e => setMe({ ...me, unidade: e.target.value })} placeholder="UN, SC, M, KG…" /></div>
            <div className="form-group"><label>Categoria</label><select value={me.categoria} onChange={e => setMe({ ...me, categoria: e.target.value })}><option value="">automática (pelo nome)</option>{cats.map(c => <option key={c}>{c}</option>)}</select></div>
          </>}
          <div className="form-group"><label>Motivo *</label><select value={me.motivo} onChange={e => setMe({ ...me, motivo: e.target.value })}>{Object.entries(ME_MOTIVOS).map(([k, v]) => <option key={k} value={k}>{v[0]}</option>)}</select></div>
          <div className="form-group"><label>Depósito</label><select value={me.deposito_id} onChange={e => setMe({ ...me, deposito_id: e.target.value })}>{estDepsMov(user, deps).map(d => <option key={d.id} value={d.id}>{d.nome}{meSel ? ` (${estNum(saldo(meSel.id, d.id))})` : ''}</option>)}</select></div>
          <div className="form-group"><label>Quantidade * {meUn && <span className="est-sub">({meUn})</span>}</label><input type="number" min="0" step="any" value={me.quantidade} onChange={e => setMe({ ...me, quantidade: e.target.value })} /></div>
          {veValor && <div className="form-group"><label>Custo unitário (R$) <span className="est-sub">{meCm != null ? `médio atual ${estBRL(meCm)}` : 'opcional'}</span></label><input type="number" min="0" step="any" value={me.custo_unit} onChange={e => setMe({ ...me, custo_unit: e.target.value })} placeholder={meCm != null ? 'vazio = mantém o médio' : 'sem custo = não soma no valor'} /></div>}
          <div className="form-group full"><label>Origem / justificativa *</label><input value={me.justificativa} onChange={e => setMe({ ...me, justificativa: e.target.value })} placeholder={ME_MOTIVOS[me.motivo][1]} /></div>
          {veValor && Number(me.quantidade) > 0 && Number(me.custo_unit) > 0 && <div className="form-group full"><span className="badge est-st-ok">Valor da entrada: {estBRL(Number(me.quantidade) * Number(me.custo_unit))}</span></div>}
          <div className="form-group full"><button className="btn btn-primary" disabled={busy} onClick={entradaManual}><Icon name="plus" size={14} /> Registrar entrada</button></div>
        </div></div>
      </div>
      <div className="card">
        <div className="card-header"><span className="card-title">Transferir entre depósitos</span></div>
        <div className="card-body"><div className="form-grid">
          <div className="form-group full"><label>Item *</label><EstItemPicker catalogo={cat} value={tr.catalogo_id} onChange={v => setTr({ ...tr, catalogo_id: v })} /></div>
          <div className="form-group"><label>De</label><select value={tr.de} onChange={e => setTr({ ...tr, de: e.target.value })}>{estDepsMov(user, deps).map(d => <option key={d.id} value={d.id}>{d.nome}{tr.catalogo_id ? ` (${estNum(saldo(tr.catalogo_id, d.id))})` : ''}</option>)}</select></div>
          <div className="form-group"><label>Para</label><select value={tr.para} onChange={e => setTr({ ...tr, para: e.target.value })}>{destinos.map(d => <option key={d.id} value={d.id} disabled={!!d.sem_assinante}>{d.nome}{tr.catalogo_id && deps.some(v => v.id === d.id) ? ` (${estNum(saldo(tr.catalogo_id, d.id))})` : ''}{d.sem_assinante ? ' (sem Almoxarife 2 para assinar)' : ''}</option>)}</select></div>
          <div className="form-group"><label>Quantidade * {unid(tr.catalogo_id) && <span className="est-sub">({unid(tr.catalogo_id)})</span>}</label><input type="number" min="0" step="any" value={tr.quantidade} onChange={e => setTr({ ...tr, quantidade: e.target.value })} /></div>
          <div className="form-group"><label>Observação</label><input value={tr.obs} onChange={e => setTr({ ...tr, obs: e.target.value })} placeholder="ex.: reposição da base" /></div>
          {paraBase && <div className="form-group full"><div className="alert alert-info" style={{ margin: 0 }}>Para uma base o material sai de {(deps.find(d => String(d.id) === String(tr.de)) || {}).nome || 'origem'} agora e fica <strong>em trânsito</strong>: só entra no saldo de {(destinos.find(d => String(d.id) === String(tr.para)) || {}).nome} quando o almoxarife 2 de lá conferir e assinar a chegada (aba Pedidos).</div></div>}
          <div className="form-group full"><button className="btn btn-primary" disabled={busy} onClick={transferir}><Icon name={paraBase ? 'send' : 'exchange'} size={14} /> {paraBase ? 'Enviar para a base' : 'Transferir'}</button></div>
        </div></div>
      </div>
      {podeAjustar && (
        <div className="card">
          <div className="card-header"><span className="card-title">Ajuste de inventário (contagem física)</span></div>
          <div className="card-body"><div className="form-grid">
            <div className="form-group full"><label>Item *</label><EstItemPicker catalogo={cat} value={aj.catalogo_id} onChange={v => setAj({ ...aj, catalogo_id: v })} /></div>
            <div className="form-group"><label>Depósito</label><select value={aj.deposito_id} onChange={e => setAj({ ...aj, deposito_id: e.target.value })}>{deps.map(d => <option key={d.id} value={d.id}>{d.nome}</option>)}</select></div>
            <div className="form-group"><label>Contagem física * {aj.catalogo_id && <span className="est-sub">(sistema: {estNum(saldo(aj.catalogo_id, aj.deposito_id))} {unid(aj.catalogo_id)})</span>}</label><input type="number" min="0" step="any" value={aj.contagem} onChange={e => setAj({ ...aj, contagem: e.target.value })} /></div>
            <div className="form-group full"><label>Justificativa *</label><input value={aj.justificativa} onChange={e => setAj({ ...aj, justificativa: e.target.value })} placeholder="ex.: inventário mensal — 2 unidades avariadas descartadas" /></div>
            {difAj != null && !isNaN(difAj) && <div className="form-group full"><span className={`badge ${difAj < 0 ? 'est-bad' : difAj > 0 ? 'est-st-ok' : ''}`}>Diferença: {difAj > 0 ? '+' : ''}{estNum(difAj)} {unid(aj.catalogo_id)}</span></div>}
            <div className="form-group full"><button className="btn btn-primary" disabled={busy} onClick={ajustar}><Icon name="check" size={14} /> Registrar ajuste</button></div>
          </div></div>
        </div>
      )}
      {podeCusto && sede && (
        <div className="card">
          <div className="card-header"><span className="card-title">Corrigir custo — {sede.nome}</span><span className="est-sub">Master e Admin</span></div>
          <div className="card-body">
            <p className="est-sub" style={{ margin: '0 0 12px' }}>Para item que entrou sem preço ou com preço errado. Troca o custo médio da {sede.nome} pelo valor informado; a quantidade não muda. Fica registrado em Movimentações.</p>
            {semCusto.length > 0 && <>
              <div className="est-sub" style={{ marginBottom: 6 }}><strong>{semCusto.length}</strong> {semCusto.length === 1 ? 'item com saldo e sem preço' : 'itens com saldo e sem preço'} na {sede.nome}:</div>
              <div className="est-cc-chips">
                {(ccTodos ? semCusto : semCusto.slice(0, 12)).map(c => (
                  <button key={c.id} type="button" className={`btn btn-ghost btn-sm est-cc-chip ${String(cc.catalogo_id) === String(c.id) ? 'on' : ''}`} onClick={() => setCc({ ...cc, catalogo_id: c.id })}>
                    {c.nome} <span className="est-sub">({estNum(c.saldos[sede.id].qtd)}{c.unidade ? ' ' + c.unidade : ''})</span></button>))}
                {semCusto.length > 12 && <button type="button" className="est-link" onClick={() => setCcTodos(!ccTodos)}>{ccTodos ? 'mostrar menos' : `ver todos (${semCusto.length})`}</button>}
              </div>
            </>}
            <div className="form-grid">
              <div className="form-group full"><label>Item *</label><EstItemPicker key={ccKey} catalogo={naSede} value={cc.catalogo_id} onChange={v => setCc({ ...cc, catalogo_id: v })} placeholder={`Buscar item da ${sede.nome}…`} /></div>
              {ccS && <div className="form-group full"><span className="est-sub">Saldo na {sede.nome}: <strong>{estNum(ccS.qtd)}{ccSel.unidade ? ' ' + ccSel.unidade : ''}</strong> · custo atual: <strong>{ccAnt == null ? 'sem preço' : estBRL(ccAnt)}</strong></span></div>}
              <div className="form-group"><label>Custo unitário correto (R$) *</label><input type="number" min="0" step="any" value={cc.custo} onChange={e => setCc({ ...cc, custo: e.target.value })} placeholder="0,00" /></div>
              <div className="form-group"><label>Justificativa *</label><input value={cc.justificativa} onChange={e => setCc({ ...cc, justificativa: e.target.value })} placeholder="ex.: preço da NF 1234 / cotação do fornecedor" /></div>
              {ccS && Number(cc.custo) > 0 && <div className="form-group full"><span className="badge est-st-ok">Valor do saldo na {sede.nome}: {estBRL(ccS.qtd * (ccAnt || 0))} → {estBRL(ccS.qtd * Number(cc.custo))}</span></div>}
              <div className="form-group full"><button className="btn btn-primary" disabled={busy} onClick={corrigirCusto}><Icon name="check" size={14} /> Salvar custo</button></div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// ─── UNIFORMES / EPI ──────────────────────────────────────────────────────────
function UniformesPage({ user, addToast, openTarget, clearOpenTarget }) {
  // Almoxarife 2: só a Retirada dos funcionários da base dele, o desgaste deles e a assinatura salva — sem
  // estoque/cadastro de itens, entradas nem NF-e (isso é da Sede).
  const base = user.role === 'almoxarife2'
  // Atalhos do Painel/Pendências abrem direto numa sub-aba (navigate('uniformes', 'alertas')).
  const [aba, setAba] = useState(openTarget && openTarget.page === 'uniformes' && openTarget.id ? openTarget.id : (base ? 'retirada' : 'estoque'))
  const [epiPend, setEpiPend] = useState(0)   // notas com EPI separado no Estoque, esperando entrada aqui
  const carregarEpiPend = () => base ? Promise.resolve() : GET('/nfe/epi/pendentes').then(r => setEpiPend(r.notas || 0)).catch(() => {})
  useEffect(() => { if (openTarget && clearOpenTarget) clearOpenTarget(); carregarEpiPend() }, [])
  const abas = (base ? [
    { id: 'retirada', label: 'Retirada', icon: 'signature' },
    { id: 'alertas', label: 'Desgaste', icon: 'alertTriangle' },
    { id: 'assinatura', label: 'Minha assinatura', icon: 'signature' },
  ] : [
    { id: 'estoque', label: 'Estoque', icon: 'shirt' },
    { id: 'alertas', label: 'Alertas', icon: 'alertTriangle' },
    { id: 'retirada', label: 'Retirada', icon: 'signature' },
    { id: 'entradas', label: 'Entradas', icon: 'inbox', badge: epiPend },
    { id: 'assinatura', label: 'Minha assinatura', icon: 'signature' },
  ])
  return (
    <div style={{ maxWidth: 860, margin: '0 auto' }}>
      <div className="topbar"><h2>Uniformes / EPI</h2></div>
      <div className="uni-tabs">
        {abas.map(a => (
          <button key={a.id} className={`uni-tab ${aba === a.id ? 'active' : ''}`} onClick={() => setAba(a.id)}>
            <Icon name={a.icon} size={15} /> {a.label}{a.badge > 0 && <span className="est-tab-badge">{a.badge}</span>}
          </button>
        ))}
      </div>
      {aba !== 'entradas' && epiPend > 0 && (
        <div className="alert alert-info" style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ flex: 1, minWidth: 200 }}><strong>{epiPend} nota(s) de compra com EPI/uniforme</strong> esperando entrada aqui (separados do estoque de material).</span>
          <button className="btn btn-primary btn-sm" onClick={() => setAba('entradas')}>Dar entrada</button>
        </div>
      )}
      {aba === 'estoque' && !base && <UniEstoque user={user} addToast={addToast} />}
      {aba === 'alertas' && <UniAlertas soDesgaste={base} />}
      {aba === 'retirada' && <UniRetirada user={user} addToast={addToast} />}
      {aba === 'entradas' && !base && <UniEntradas user={user} addToast={addToast} epiPend={epiPend} onEpiMudou={carregarEpiPend} />}
      {aba === 'assinatura' && <UniMinhaAssinatura user={user} addToast={addToast} />}
    </div>
  )
}

// Minha assinatura — o responsável registra a assinatura uma vez; ela é aplicada
// automaticamente ("lastreada") como assinatura do responsável nos termos de retirada.
function UniMinhaAssinatura({ user, addToast }) {
  const [assin, setAssin] = useState(null)
  const [editando, setEditando] = useState(false)
  const [loading, setLoading] = useState(true)
  useEffect(() => { GET('/perfil/assinatura').then(r => { setAssin(r.assinatura); setLoading(false) }).catch(() => setLoading(false)) }, [])
  const salvar = async sig => {
    try { await PUT('/perfil/assinatura', { assinatura: sig }); setAssin(sig); setEditando(false); addToast('Assinatura registrada!', 'success') }
    catch (e) { addToast(e.message, 'error') }
  }
  const remover = async () => {
    try { await PUT('/perfil/assinatura', { assinatura: null }); setAssin(null); setEditando(false); addToast('Assinatura removida.', 'success') }
    catch (e) { addToast(e.message, 'error') }
  }
  return (
    <div className="card"><div className="card-body">
      <p className="text-muted" style={{ fontSize: '.88rem', marginBottom: 16 }}>
        Registre sua assinatura uma vez. Ela será aplicada automaticamente como <strong>assinatura do responsável</strong> nos termos de retirada de uniforme/EPI gerados no seu login — sem precisar assinar cada documento. Em qualquer retirada você ainda pode optar por assinar diferente.
      </p>
      {loading ? <p className="text-muted">Carregando...</p> : (!editando && assin) ? (
        <div>
          <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 16, background: '#fff', display: 'inline-block' }}>
            <img src={assin} alt="Minha assinatura" style={{ maxWidth: 300, maxHeight: 120, display: 'block' }} />
          </div>
          <div style={{ marginTop: 8, color: 'var(--success)', display: 'flex', alignItems: 'center', gap: 6, fontSize: '.85rem' }}><Icon name="checkCircle" size={15} /> Assinatura registrada para {user.nome}.</div>
          <div className="gap-8" style={{ marginTop: 14, display: 'flex', flexWrap: 'wrap' }}>
            <button className="btn btn-outline btn-sm" onClick={() => setEditando(true)}><Icon name="signature" size={14} /> Refazer</button>
            <button className="btn btn-danger btn-sm" onClick={remover}><Icon name="trash" size={14} /> Remover</button>
          </div>
        </div>
      ) : (
        <SignaturePad label={`Assine — ${user.nome}`} onConfirm={salvar} onCancel={assin ? () => setEditando(false) : undefined} />
      )}
    </div></div>
  )
}

// Estoque — catálogo de itens com edição em acordeão (mesmo padrão de Ferramentas).
function UniEstoque({ user, addToast }) {
  const [lista, setLista] = useState([])
  const [openId, setOpenId] = useState(null)
  const [form, setForm] = useState({})
  const [confirmDel, setConfirmDel] = useState(false)
  const isMaster = !!(user && user.is_master)
  const load = () => GET('/uniformes/itens').then(setLista)
  useEffect(() => { load() }, [])
  const abrirNovo = () => { setForm({ categoria: 'Uniforme', unidade: 'un', estoque_minimo: 0 }); setConfirmDel(false); setOpenId('new') }
  const toggle = it => { if (openId === it.id) { fechar(); return } setForm({ ...it, min_por_tamanho: parseMinTam(it.min_por_tamanho) }); setConfirmDel(false); setOpenId(it.id) }
  const fechar = () => { setOpenId(null); setConfirmDel(false) }
  const save = async () => {
    if (!form.nome) { addToast('Informe o nome.', 'error'); return }
    try {
      if (form.id) await PUT(`/uniformes/itens/${form.id}`, form)
      else await POST('/uniformes/itens', form)
      addToast(form.id ? 'Atualizado!' : 'Cadastrado!', 'success'); fechar(); load()
    } catch (e) { addToast(e.message, 'error') }
  }
  const del = async () => {
    try { await DEL(`/uniformes/itens/${form.id}`); addToast('Excluído!', 'success'); fechar(); load() }
    catch (e) { addToast(e.message, 'error') }
  }
  const painel = () => {
    const titulo = form.id ? `Editar ${form.nome}` : 'Novo item'
    const footer = confirmDel ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <span style={{ fontSize: '.85rem', color: 'var(--danger)', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 6 }}><Icon name="alertTriangle" size={15} /> Excluir este item?</span>
        <div className="gap-8"><button className="btn btn-ghost btn-sm" onClick={() => setConfirmDel(false)}>Não</button><button className="btn btn-danger btn-sm" onClick={del}>Sim, excluir</button></div>
      </div>
    ) : (<>
      <div>{isMaster && !user.admin && form.id && <button className="btn btn-danger btn-sm" onClick={() => setConfirmDel(true)}><Icon name="trash" size={14} /> Excluir</button>}</div>
      <div className="gap-8"><button className="btn btn-ghost btn-sm" onClick={fechar}>Cancelar</button><button className="btn btn-primary btn-sm" onClick={save}><Icon name="check" size={14} /> Salvar</button></div>
    </>)
    return (
      <PainelEdicao titulo={titulo} onFechar={fechar} footer={footer}>
        <div className="form-grid">
          <div className="form-group full"><label>Nome *</label><input value={form.nome || ''} onChange={e => setForm({ ...form, nome: e.target.value })} /></div>
          <div className="form-group"><label>Categoria</label><select value={form.categoria || 'Uniforme'} onChange={e => setForm({ ...form, categoria: e.target.value })}><option>Uniforme</option><option>EPI</option></select></div>
          <div className="form-group"><label>Unidade</label><input value={form.unidade || 'un'} onChange={e => setForm({ ...form, unidade: e.target.value })} placeholder="un, par..." /></div>
          <div className="form-group"><label>Estoque mínimo (por tamanho)</label><input type="number" min="0" value={form.estoque_minimo ?? 0} onChange={e => setForm({ ...form, estoque_minimo: Math.max(0, parseInt(e.target.value) || 0) })} /></div>
          <div className="form-group"><label>Vida útil (meses)</label><input type="number" min="0" value={form.vida_util_meses ?? ''} onChange={e => setForm({ ...form, vida_util_meses: e.target.value === '' ? null : Math.max(0, parseInt(e.target.value) || 0) })} placeholder="sem prazo" /></div>
          <div className="form-group"><label>Custo de reposição (R$)</label><input type="number" min="0" step="0.01" value={form.custo_reposicao || ''} onChange={e => setForm({ ...form, custo_reposicao: parseFloat(e.target.value) || 0 })} placeholder="0,00" /></div>
          <div className="form-group full"><label>Tamanhos ou cores disponíveis</label><input value={form.tamanhos || ''} onChange={e => setForm({ ...form, tamanhos: e.target.value })} placeholder="P, M, G, GG  —  ou cores (capacete)  —  vazio = variação única" />
            <span style={{ fontSize: '.72rem', color: 'var(--text-secondary)', marginTop: 4, display: 'block' }}>Separe por vírgula. O estoque passa a ser controlado por variação. Capacete: use as cores (Branco, Amarelo, Azul, Preto, Vermelho, Laranja, Verde) — cada cor identifica a função de quem usa.</span>
          </div>
          {gradeDe(form).length > 0 && (() => {
            const minObj = parseMinTam(form.min_por_tamanho)
            const setMinTam = (t, v) => { const o = { ...minObj }; if (v === '') delete o[t]; else o[t] = Math.max(0, parseInt(v) || 0); setForm({ ...form, min_por_tamanho: o }) }
            return (
              <div className="form-group full">
                <label>Mínimo por {eixoVar(form).toLowerCase()} (opcional)</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
                  {gradeDe(form).map(t => (
                    <div key={t} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <span style={{ fontSize: '.78rem', minWidth: 26, color: 'var(--text-secondary)' }}>{rotuloVar(form, t)}</span>
                      <input type="number" min="0" value={minObj[t] ?? ''} placeholder={form.estoque_minimo ?? 0} onChange={e => setMinTam(t, e.target.value)} style={{ width: 64 }} />
                    </div>
                  ))}
                </div>
                <span style={{ fontSize: '.72rem', color: 'var(--text-secondary)', marginTop: 4, display: 'block' }}>Vazio = usa o mínimo geral acima ({form.estoque_minimo ?? 0}).</span>
              </div>
            )
          })()}
          {form.id && (
            <div className="form-group full">
              <span style={{ fontSize: '.75rem', color: 'var(--text-secondary)', display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 6 }}><Icon name="package" size={12} /> {form.estoque_atual ?? 0} em estoque agora</span>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {(form.estoque_por_tamanho || []).map(l => <TamChip key={l.tamanho} {...l} />)}
              </div>
            </div>
          )}
        </div>
      </PainelEdicao>
    )
  }
  const vazio = <div className="empty"><div className="empty-icon"><Icon name="shirt" size={32} /></div><p>Nenhum item cadastrado.</p><button className="btn btn-accent empty-cta" onClick={abrirNovo}><Icon name="plus" size={14} /> Cadastrar item</button></div>
  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Itens em estoque</span><button className="btn btn-accent btn-sm" onClick={abrirNovo}><Icon name="plus" size={14} /> Novo item</button></div>
      <ListaAcordeao
        itens={lista} keyOf={i => i.id} abertoId={openId} onToggle={toggle}
        novoAberto={openId === 'new'} painelNovo={painel()} painel={() => painel()} vazio={vazio}
        resumo={i => {
          const algumBaixo = (i.estoque_por_tamanho || []).some(l => l.baixo)
          return {
            titulo: <>
              <div><span className="nm">{i.nome}</span> <span className={`badge ${i.categoria === 'EPI' ? 'tg-alerta' : 'tg-aco'}`} style={{ fontSize: '.65rem' }}>{i.categoria}</span></div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginTop: 5 }}>{(i.estoque_por_tamanho || []).map(l => <TamChip key={l.tamanho} {...l} />)}</div>
            </>,
            direita: <span className="qtd-badge" title={`${i.estoque_atual} no total`} style={algumBaixo ? { color: 'var(--danger)', borderColor: 'var(--danger)', display: 'inline-flex', alignItems: 'center', gap: 4 } : null}>{i.estoque_atual}{algumBaixo && <Icon name="alertTriangle" size={12} />}</span>
          }
        }}
      />
    </div>
  )
}

// Notas fiscais de entrada já recebidas (Qive a cada 30 min, XML enviado à mão e as antigas do Vobi).
// Sem digitar nem baixar XML: escolhe a nota e segue para o mapeamento. Também exporta a planilha
// (CSV com itens: código, descrição, NCM, unidade, qtd, valores) e baixa o XML original.
function NotasVobi({ addToast, onUsar, onMudou }) {
  const [notas, setNotas] = useState(null)
  const hoje = new Date().toISOString().slice(0, 10)
  const [per, setPer] = useState({ de: new Date(Date.now() - 30 * 86400000).toISOString().slice(0, 10), ate: hoje })
  const carregar = () => GET('/nfe/vobi?limit=30').then(setNotas).catch(() => setNotas([]))
  useEffect(() => { carregar() }, [])
  if (!notas || !notas.length) return null   // nenhuma nota recebida ainda: só o upload manual aparece
  const baixar = (path, nome) => baixarArquivo(path, nome).catch(e => addToast(e.message, 'error'))
  const brl = v => v == null ? '—' : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
  const data = d => d ? d.slice(0, 10).split('-').reverse().join('/') : '—'
  const pendentes = notas.filter(n => n.epi_pendente).length
  // Dispensar = a entrada desse EPI já foi feita de outro jeito (à mão, p. ex.) — sai da lista de pendentes.
  const dispensar = async (n, sim) => {
    if (sim && !confirm(`Dispensar o EPI da NF ${n.numero || ''} (${n.emitente || ''})?\n\nUse quando a entrada já foi feita de outro jeito. A nota sai de "EPI a dar entrada".`)) return
    try { await POST(`/nfe/vobi/${n.id}/epi-dispensar`, { dispensar: sim }); addToast(sim ? 'EPI da nota dispensado.' : 'A nota voltou para "EPI a dar entrada".', 'success'); carregar(); onMudou && onMudou() }
    catch (e) { addToast(e.message, 'error') }
  }
  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div>
          <strong>Notas fiscais recebidas</strong>
          <div className="text-muted" style={{ fontSize: '.75rem' }}>Chegam pelo Qive (a cada 30 min) ou pelo XML enviado no Estoque. As linhas de EPI/uniforme são separadas do estoque de material e ficam aqui.</div>
        </div>
        {pendentes > 0 && <span className="badge tg-cobre">{pendentes} com EPI a dar entrada</span>}
      </div>
      {(
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Emissão</th><th>NF</th><th>Fornecedor</th><th>Itens</th><th>Valor</th><th></th></tr></thead>
          <tbody>{notas.map(n => (
            <tr key={n.id}>
              <td data-label="Emissão">{data(n.data_emissao)}</td>
              <td data-label="NF">{n.numero || '—'}{n.epi_pendente ? <div><span className="badge tg-cobre" style={{ fontSize: '.65rem', marginTop: 3 }}>EPI a dar entrada</span></div> : null}</td>
              <td data-label="Fornecedor">{n.emitente || '—'}</td>
              <td data-label="Itens">{n.completa ? n.qtd_itens : <span className="text-muted" title="A nota chegou só como resumo, sem os itens. Envie o XML completo para usar.">resumo</span>}
                {n.epi_linhas > 0 && <div className="text-muted" style={{ fontSize: '.72rem' }}>{n.epi_linhas === n.qtd_itens ? 'todas de EPI' : `${n.epi_linhas} de EPI`}{n.epi_entraram > 0 ? ` · ${n.epi_entraram === n.epi_linhas ? 'todas' : n.epi_entraram} já entraram` : ''}</div>}</td>
              <td data-label="Valor">{brl(n.valor_total)}</td>
              <td data-label="" style={{ whiteSpace: 'nowrap' }}>
                {n.epi_pendente ? <>
                    <button className="btn btn-primary btn-sm" onClick={() => onUsar(n.id)}>Dar entrada do EPI</button>
                    <button className="btn btn-ghost btn-sm" title="A entrada já foi feita de outro jeito" onClick={() => dispensar(n, true)}>Dispensar</button>
                  </>
                  : n.importada_uniformes ? <span className="badge tg-ok" style={{ fontSize: '.65rem' }}>Já deu entrada</span>
                  : n.epi_linhas > 0 && n.epi_resolvida_em ? <><span className="badge" style={{ fontSize: '.65rem' }}>Dispensada</span> <button className="est-link" onClick={() => dispensar(n, false)}>reabrir</button></>
                  : <button className="btn btn-outline btn-sm" disabled={!n.completa} onClick={() => onUsar(n.id)}>Usar nota</button>}
                {!!n.tem_xml && <button className="btn btn-ghost btn-sm" title="Baixar XML original" onClick={() => baixar(`/nfe/vobi/${n.id}/xml`, `${n.chave || 'NFe-' + (n.numero || n.id)}.xml`)}><Icon name="download" size={13} /> XML</button>}
              </td>
            </tr>))}</tbody>
        </table></div>
      )}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginTop: 10, fontSize: '.8rem' }}>
        <span className="text-muted">Planilha com itens (NCM, qtd, valores):</span>
        <input type="date" value={per.de} onChange={e => setPer({ ...per, de: e.target.value })} />
        <span className="text-muted">a</span>
        <input type="date" value={per.ate} onChange={e => setPer({ ...per, ate: e.target.value })} />
        <button className="btn btn-ghost btn-sm" onClick={() => baixar(`/nfe/vobi/export.csv?de=${per.de}&ate=${per.ate}`, `notas-fiscais-${per.de}-a-${per.ate}.csv`)}><Icon name="download" size={13} /> Excel (CSV)</button>
      </div>
    </div>
  )
}

// Entradas — manual + importação de XML de NF-e (revisão/mapeamento antes de gravar).
function UniEntradas({ user, addToast, epiPend, onEpiMudou }) {
  // Apagar entrada é ação destrutiva → só o Master de verdade (não o braço administrativo).
  const isMaster = !!(user && user.is_master && !user.admin)
  const [itens, setItens] = useState([])
  const [entradas, setEntradas] = useState([])
  const [modo, setModo] = useState(epiPend > 0 ? 'nfe' : 'manual')   // há nota com EPI esperando → abre nas notas
  const [form, setForm] = useState({ item_id: '', quantidade: '', custo_unitario: '', fornecedor: '', tamanho: '' })
  const [nfe, setNfe] = useState(null)
  const load = () => { GET('/uniformes/itens').then(setItens); GET('/uniformes/entradas').then(setEntradas) }
  useEffect(() => { load() }, [])
  const itemSel = itens.find(i => String(i.id) === String(form.item_id))
  const gradeSel = gradeDe(itemSel)
  const salvarManual = async () => {
    if (!form.item_id || !form.quantidade) { addToast('Item e quantidade são obrigatórios.', 'error'); return }
    if (gradeSel.length && !form.tamanho) { addToast('Selecione o tamanho.', 'error'); return }
    try { await POST('/uniformes/entradas', form); addToast('Entrada registrada!', 'success'); setForm({ item_id: '', quantidade: '', custo_unitario: '', fornecedor: '', tamanho: '' }); load() }
    catch (e) { addToast(e.message, 'error') }
  }
  const lerXML = file => {
    const reader = new FileReader()
    reader.onload = async () => {
      try {
        const parsed = await POST('/uniformes/nfe/parse', { xml: reader.result })
        parsed._linhas = uniLinhasIniciais(parsed)
        setNfe(parsed)
        if (parsed.ja_importada) addToast('Atenção: esta NF-e já foi importada antes.', 'warning')
      } catch (e) { addToast(e.message, 'error') }
    }
    reader.readAsText(file)
  }
  // Nota já recebida (Qive/XML/Vobi antigo) → mesmo fluxo de revisão/mapeamento do upload de XML.
  const usarNotaVobi = async id => {
    try {
      const parsed = await POST('/uniformes/nfe/parse', { vobi_nfe_id: id })
      parsed._linhas = uniLinhasIniciais(parsed)
      setNfe(parsed)
      if (parsed.ja_importada) addToast('Atenção: esta NF-e já foi importada antes.', 'warning')
    } catch (e) { addToast(e.message, 'error') }
  }
  const remover = async en => {
    const tam = en.tamanho ? ` (tam. ${en.tamanho})` : ''
    if (!confirm(`Apagar esta entrada de ${en.item_nome}${tam} — +${en.quantidade}?\n\nIsso reduz o estoque calculado desse item e não pode ser desfeito.`)) return
    try { await DEL(`/uniformes/entradas/${en.id}`); addToast('Entrada apagada.', 'success'); load() }
    catch (e) { addToast(e.message, 'error') }
  }
  const setLinha = (idx, patch) => setNfe(n => ({ ...n, _linhas: n._linhas.map((l, i) => i === idx ? { ...l, ...patch } : l) }))
  const gradeCat = id => gradeDe(nfe && nfe.catalogo.find(c => String(c.id) === String(id)))
  const confirmarNFe = async () => {
    const mapeadas = nfe._linhas.filter(l => l.item_id && !l.ja_entrou)
    if (!mapeadas.length) { addToast('Mapeie ao menos uma linha a um item do catálogo.', 'error'); return }
    if (mapeadas.some(l => gradeCat(l.item_id).length && !l.tamanho)) { addToast('Selecione o tamanho das linhas mapeadas a itens com grade.', 'error'); return }
    const linhas = mapeadas.map(l => ({ item_id: l.item_id === 'novo' ? 'novo' : parseInt(l.item_id), quantidade: parseInt(l.quantidade) || 0, custo_unitario: l.custo_unitario || 0, tamanho: l.tamanho || '',
      nfe_item_id: l.nfe_item_id || null, descricao: l.descricao, unidade: l.unidade }))
    try {
      const r = await POST('/uniformes/nfe/confirmar', { chave: nfe.chave, nfe_numero: nfe.nNF, fornecedor: nfe.fornecedor, linhas, nfe_id: nfe.nfe_id })
      addToast(`${r.importadas} entrada(s) importada(s)!${r.itens_criados && r.itens_criados.length ? ` Item(ns) novo(s) no catálogo: ${r.itens_criados.join(', ')}.` : ''}`, 'success')
      setNfe(null); load(); onEpiMudou && onEpiMudou()
    } catch (e) { addToast(e.message, 'error') }
  }
  const comEpi = nfe && nfe._linhas.some(l => l.epi)   // nota separada no Estoque: o resto é material de obra
  return (
    <div>
      <div className="card">
        <div className="card-header"><span className="card-title">Dar entrada em estoque</span>
          <div className="uni-switch"><button className={modo === 'manual' ? 'active' : ''} onClick={() => setModo('manual')}>Manual</button><button className={modo === 'nfe' ? 'active' : ''} onClick={() => setModo('nfe')}>Importar NF-e</button></div>
        </div>
        <div className="card-body">
          {modo === 'manual' ? (
            <div className="form-grid">
              <div className="form-group full"><label>Item *</label><select value={form.item_id} onChange={e => setForm({ ...form, item_id: e.target.value, tamanho: '' })}><option value="">Selecione...</option>{itens.map(i => <option key={i.id} value={i.id}>{i.nome} ({i.estoque_atual} em estoque)</option>)}</select></div>
              {gradeSel.length > 0 && (
                <div className="form-group"><label>{eixoVar(itemSel)} *</label><select value={form.tamanho || ''} onChange={e => setForm({ ...form, tamanho: e.target.value })}><option value="">Selecione...</option>{gradeSel.map(t => <option key={t} value={t}>{rotuloVar(itemSel, t)} ({dispDeTam(itemSel, t)} em estoque)</option>)}</select></div>
              )}
              <div className="form-group"><label>Quantidade *</label><input type="number" min="1" value={form.quantidade} onChange={e => setForm({ ...form, quantidade: e.target.value })} /></div>
              <div className="form-group"><label>Custo unitário (R$)</label><input type="number" min="0" step="0.01" value={form.custo_unitario} onChange={e => setForm({ ...form, custo_unitario: e.target.value })} placeholder="0,00" /></div>
              <div className="form-group full"><label>Fornecedor</label><input value={form.fornecedor} onChange={e => setForm({ ...form, fornecedor: e.target.value })} /></div>
              {itemSel && (itemSel.estoque_por_tamanho || []).length > 0 && (
                <div className="form-group full" style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
                  <span style={{ fontSize: '.75rem', color: 'var(--text-secondary)' }}>Em estoque:</span>
                  {(itemSel.estoque_por_tamanho || []).map(l => <TamChip key={l.tamanho} {...l} />)}
                </div>
              )}
              <div className="form-group full"><button className="btn btn-primary" onClick={salvarManual}><Icon name="check" size={14} /> Registrar entrada</button></div>
            </div>
          ) : !nfe ? (
            <div>
              <NotasVobi addToast={addToast} onUsar={usarNotaVobi} onMudou={onEpiMudou} />
              <p className="text-muted" style={{ margin: '14px 0 10px', fontSize: '.85rem' }}>Ou envie o arquivo <strong>XML</strong> da NF-e (não o PDF/DANFE). Os itens são lidos e você confirma o mapeamento antes de dar entrada.</p>
              <input type="file" accept=".xml,text/xml,application/xml" onChange={e => e.target.files[0] && lerXML(e.target.files[0])} />
            </div>
          ) : (
            <div>
              <div className="alert" style={{ marginBottom: 12 }}>NF-e {nfe.nNF || '—'} · {nfe.fornecedor || 'fornecedor não identificado'}{nfe.ja_importada && <strong style={{ color: 'var(--danger)' }}> · JÁ IMPORTADA</strong>}</div>
              {comEpi && <p className="text-muted" style={{ fontSize: '.8rem', margin: '0 0 10px' }}>As linhas marcadas <strong>EPI</strong> foram separadas do estoque de material. Confira o item e o tamanho de cada uma (EPI que ainda não está no catálogo entra como item novo); as demais são material de obra e ficam em "— ignorar —".</p>}
              <div className="table-wrap"><table className="cards-mobile">
                <thead><tr><th>Produto (NF-e)</th><th>Qtd</th><th>Custo un.</th><th>Mapear para item</th><th>Tamanho / Cor</th></tr></thead>
                <tbody>
                  {nfe._linhas.map((l, idx) => {
                    const grade = gradeCat(l.item_id)
                    const itCat = nfe.catalogo.find(c => String(c.id) === String(l.item_id))
                    return (
                    <tr key={idx} style={(comEpi && !l.epi && !l.item_id) || l.ja_entrou ? { opacity: .55 } : null}>
                      <td data-label="Produto">{l.descricao}{comEpi && (l.epi ? <span className="badge tg-cobre" style={{ fontSize: '.62rem', marginLeft: 6 }}>EPI</span> : <div className="text-muted" style={{ fontSize: '.72rem' }}>material de obra — vai para o Estoque</div>)}</td>
                      {l.ja_entrou ? <td data-label="Situação" colSpan="4"><span className="badge tg-ok" style={{ fontSize: '.65rem' }}>✓ Já entrou</span> <span className="text-muted" style={{ fontSize: '.8rem' }}>{l.ja_entrou}</span></td> : <>
                      <td data-label="Qtd"><input type="number" min="0" value={l.quantidade} onChange={e => setLinha(idx, { quantidade: e.target.value })} style={{ width: 70 }} /></td>
                      <td data-label="Custo">{fmtBRL(l.custo_unitario)}</td>
                      <td data-label="Item"><select value={l.item_id} onChange={e => { const v = e.target.value; setLinha(idx, { item_id: v, tamanho: v === 'novo' ? (l.tamanho_desc || '') : uniTamSug(l.descricao, nfe.catalogo.find(c => String(c.id) === v)) }) }}>
                        <option value="">— ignorar —</option>
                        <option value="novo">+ Cadastrar item novo{l.nome_novo ? `: ${l.nome_novo}` : ''}</option>
                        {nfe.catalogo.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}</select>
                        {l.item_id === 'novo' && <div className="text-muted" style={{ fontSize: '.72rem', marginTop: 3 }}>Entra no catálogo de Uniformes/EPI como <strong>{l.nome_novo || l.descricao}</strong></div>}</td>
                      <td data-label="Tamanho">{!l.item_id ? <span className="text-muted">—</span> : l.item_id === 'novo' ? (
                        <input value={l.tamanho || ''} onChange={e => setLinha(idx, { tamanho: e.target.value.toUpperCase() })} placeholder="único" style={{ width: 70 }} title="Deixe vazio se o item não tem tamanho" />
                      ) : grade.length ? (
                        <select value={l.tamanho || ''} onChange={e => setLinha(idx, { tamanho: e.target.value })}><option value="">{eixoVar(itCat)}...</option>{grade.map(t => <option key={t} value={t}>{rotuloVar(itCat, t)}</option>)}</select>
                      ) : <span className="text-muted" title="Item de variação única">único</span>}</td>
                      </>}
                    </tr>
                  )})}
                </tbody>
              </table></div>
              <div className="gap-8" style={{ marginTop: 12, justifyContent: 'flex-end', display: 'flex' }}>
                <button className="btn btn-ghost btn-sm" onClick={() => setNfe(null)}>Cancelar</button>
                <button className="btn btn-primary btn-sm" onClick={confirmarNFe}><Icon name="check" size={14} /> Confirmar entrada</button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="card">
        <div className="card-header"><span className="card-title">Entradas recentes</span></div>
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Data</th><th>Item</th><th>Tam.</th><th>Qtd</th><th>Origem</th><th>Fornecedor</th>{isMaster && <th></th>}</tr></thead>
          <tbody>
            {entradas.map(en => (
              <tr key={en.id}>
                <td data-label="Data">{fmtDT(en.criado_em)}</td>
                <td data-label="Item"><strong>{en.item_nome}</strong></td>
                <td data-label="Tam.">{en.tamanho || '—'}</td>
                <td data-label="Qtd">+{en.quantidade}</td>
                <td data-label="Origem"><span className={`badge ${en.origem === 'nfe' ? 'tg-aco' : 'tg-ok'}`} style={{ fontSize: '.65rem' }}>{en.origem === 'nfe' ? 'NF-e' : 'Manual'}</span></td>
                <td data-label="Fornecedor" className="text-muted">{en.fornecedor || '—'}</td>
                {isMaster && <td data-label="" style={{ textAlign: 'right' }}><button title="Apagar entrada" style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--danger)', padding: 0, display: 'inline-flex', alignItems: 'center' }} onClick={() => remover(en)}><Icon name="trash" size={14} /></button></td>}
              </tr>
            ))}
            {!entradas.length && <tr><td colSpan={isMaster ? 7 : 6} className="text-muted" style={{ textAlign: 'center', padding: 20 }}>Nenhuma entrada ainda.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  )
}

// Retirada — colaborador + itens (por tamanho, com bloqueio de estoque), conferência do
// termo e as duas assinaturas (responsável pode usar a assinatura salva; colaborador ao vivo).
function UniRetirada({ user, addToast }) {
  const base = user.role === 'almoxarife2'   // Almoxarife 2: só os funcionários da base dele (o servidor recorta)
  const [colaboradores, setColaboradores] = useState([])
  const [itensCat, setItensCat] = useState([])
  const [entregas, setEntregas] = useState([])
  const [novoColab, setNovoColab] = useState(null)  // form do cadastro rápido de colaborador
  const [colId, setColId] = useState('')
  const [linhas, setLinhas] = useState([])
  const [step, setStep] = useState('form')            // form | termo | assinar
  const [termoHTML, setTermoHTML] = useState('')
  const [assinaturas, setAssinaturas] = useState({ colab: null, almox: null })
  const [minhaAssin, setMinhaAssin] = useState(null)  // assinatura salva do responsável
  const [assinarDiferente, setAssinarDiferente] = useState(false)
  const [reauth, setReauth] = useState({ email: '', senha: '' })
  // Contratos que a ficha sem login pode ter (Sede: todos, padrão o principal; Almoxarife 2: os da base dele,
  // padrão o dele). Só com 2+ o cadastro pergunta — com 1 contrato nada muda.
  const [ctFicha, setCtFicha] = useState({ contratos: [], padrao: null })
  const multiFicha = ctFicha.contratos.length > 1
  const load = () => { GET('/uniformes/colaboradores').then(setColaboradores); GET('/uniformes/itens').then(setItensCat); GET('/uniformes/entregas').then(setEntregas) }
  useEffect(() => { load(); GET('/perfil/assinatura').then(r => setMinhaAssin(r.assinatura)).catch(() => {}); GET('/uniformes/contratos').then(setCtFicha).catch(() => {}) }, [])
  // Cadastro rápido de quem recebe EPI sem ter login: salva, recarrega e já seleciona. Se a pessoa
  // já estava na lista (mesmo CPF ou nome), o servidor devolve a ficha dela em vez de duplicar.
  const salvarNovoColab = async () => {
    if (!novoColab.nome || !novoColab.nome.trim()) { addToast('Informe o nome.', 'error'); return }
    try {
      const r = await POST('/uniformes/colaboradores', novoColab)
      const lista = await GET('/uniformes/colaboradores')
      setColaboradores(lista)
      setNovoColab(null)
      const achado = lista.find(c => String(c.id) === String(r.id))
      if (!achado) { addToast('Esta pessoa já tem cadastro, mas está fora da sua lista.', 'error'); return }
      setColId(String(r.id))
      const deOnde = porContrato && achado.contrato_nome ? ` (${achado.contrato_nome})` : ''
      addToast(r.ja_existia ? `${r.nome}${deOnde} já estava na lista — selecionado.` : r.voltou ? `${r.nome} voltou para a lista e foi selecionado.` : 'Colaborador cadastrado e selecionado!', 'success')
    } catch (e) { addToast(e.message, 'error') }
  }
  // A Sede marca/corrige o contrato da ficha sem login (antiga, sem contrato, ou cadastrada no contrato errado):
  // com ele, o termo sai com o contrato certo e o Almoxarife 2 da base passa a atender a pessoa.
  const trocarContrato = async (c, cid) => {
    if ((Number(cid) || null) === (c.contrato_id || null)) return
    try { await PUT(`/uniformes/colaboradores/${c.id}`, { contrato_id: Number(cid) || null }); setColaboradores(await GET('/uniformes/colaboradores')); addToast(`Contrato de ${c.nome} atualizado.`, 'success') }
    catch (e) { addToast(e.message, 'error') }
  }
  const colaborador = colaboradores.find(c => String(c.id) === String(colId))
  const comLogin = colaboradores.filter(c => c.usuario_id), semLogin = colaboradores.filter(c => !c.usuario_id)
  // A Sede atende todos os contratos: com 2+ contratos na lista, quem tem login vem agrupado pelo contrato da conta
  // (principal primeiro) — ~155 nomes de 4 contratos misturados não dava para saber de qual obra era cada um.
  const gruposLogin = [...new Set(comLogin.map(c => c.contrato_id))].sort((a, b) => (a || 0) - (b || 0))
    .map(cid => ({ cid, nome: (comLogin.find(c => c.contrato_id === cid) || {}).contrato_nome, lista: comLogin.filter(c => c.contrato_id === cid) }))
  const porContrato = gruposLogin.length > 1
  const opcaoColab = c => <option key={c.id} value={c.id}>{c.nome}{c.setor ? ` — ${c.setor}` : ''}{porContrato && !c.usuario_id && c.contrato_nome ? ` · ${c.contrato_nome}` : ''}</option>
  const tirarDaLista = async c => {
    if (!confirm(`Tirar ${c.nome} da lista da retirada?\n\nO histórico de termos dele continua guardado. Se cadastrar de novo com o mesmo nome ou CPF, ele volta.`)) return
    try { await PUT(`/uniformes/colaboradores/${c.id}`, { ativo: 0 }); setColId(''); setColaboradores(colaboradores.filter(x => x.id !== c.id)); addToast(`${c.nome} saiu da lista.`, 'success') }
    catch (e) { addToast(e.message, 'error') }
  }
  const addLinha = () => setLinhas([...linhas, { item_id: '', quantidade: 1, tamanho: '', observacao: '' }])
  const setLinha = (i, patch) => setLinhas(linhas.map((l, idx) => idx === i ? { ...l, ...patch } : l))
  const rmLinha = i => setLinhas(linhas.filter((_, idx) => idx !== i))

  // Estado calculado de uma linha (item + tamanho + disponibilidade).
  const infoLinha = l => {
    const it = itensCat.find(x => String(x.id) === String(l.item_id))
    if (!it) return { it: null }
    const grade = gradeDe(it), precisaTam = grade.length > 0, tamOk = !precisaTam || !!l.tamanho
    const disp = !tamOk ? null : dispDeTam(it, precisaTam ? l.tamanho : SEM_TAM_UI)
    const qtd = parseInt(l.quantidade) || 0
    const semEstoque = tamOk && disp != null && disp <= 0
    const excede = tamOk && disp != null && qtd > disp
    return { it, grade, precisaTam, tamOk, disp, qtd, semEstoque, excede }
  }
  const indisponiveis = linhas.filter(l => { const info = infoLinha(l); return info.it && (info.semEstoque || info.excede) })
  const removerIndisponiveis = () => setLinhas(linhas.filter(l => { const info = infoLinha(l); return !(info.it && (info.semEstoque || info.excede)) }))
  const setTamanho = (i, tamanho) => {
    const it = itensCat.find(x => String(x.id) === String(linhas[i].item_id))
    const disp = it ? dispDeTam(it, tamanho) : 0
    const q = Math.min(Math.max(1, parseInt(linhas[i].quantidade) || 1), Math.max(1, disp))
    setLinha(i, { tamanho, quantidade: q })
  }
  const setQtd = (i, v) => {
    const info = infoLinha(linhas[i])
    let q = parseInt(v) || ''
    if (q !== '' && info.disp != null) q = Math.min(Math.max(1, q), Math.max(1, info.disp))
    setLinha(i, { quantidade: q })
  }

  const irRevisar = async () => {
    if (!colId) { addToast('Selecione o colaborador.', 'error'); return }
    const validas = linhas.filter(l => l.item_id)
    if (!validas.length) { addToast('Adicione ao menos um item.', 'error'); return }
    for (const l of validas) {
      const info = infoLinha(l)
      if (info.precisaTam && !info.tamOk) { addToast(`Selecione o tamanho de ${info.it.nome}.`, 'error'); return }
      if (info.semEstoque) { addToast(`${info.it.nome}${l.tamanho ? ' tam. ' + l.tamanho : ''} sem estoque — remova a linha.`, 'error'); return }
      if (info.qtd <= 0) { addToast(`Quantidade inválida para ${info.it.nome}.`, 'error'); return }
      if (info.excede) { addToast(`Quantidade acima do disponível para ${info.it.nome}.`, 'error'); return }
    }
    const itens = validas.map(l => ({ item_id: parseInt(l.item_id), quantidade: parseInt(l.quantidade) || 1, tamanho: l.tamanho || undefined, observacao: l.observacao }))
    try { const r = await POST('/uniformes/entregas/previa-termo', { colaborador_id: parseInt(colId), itens }); setTermoHTML(r.html); setStep('termo') }
    catch (e) { addToast(e.message, 'error') }
  }
  const verTermo = async id => { const t = await GET(`/uniformes/entregas/${id}/termo`); const w = window.open('', '_blank', 'width=900,height=700,scrollbars=yes'); w.document.write(t.html); w.document.close() }

  const usaSalva = !!minhaAssin && !assinarDiferente
  const temResp = usaSalva || !!assinaturas.almox
  const resetTudo = () => { setColId(''); setLinhas([]); setAssinaturas({ colab: null, almox: null }); setReauth({ email: '', senha: '' }); setAssinarDiferente(false); setTermoHTML(''); setStep('form') }
  const finalizar = async () => {
    if (!temResp) { addToast('Falta a assinatura do responsável.', 'error'); return }
    if (!assinaturas.colab) { addToast('Falta a assinatura do colaborador.', 'error'); return }
    const itens = linhas.filter(l => l.item_id).map(l => ({ item_id: parseInt(l.item_id), quantidade: parseInt(l.quantidade) || 1, tamanho: l.tamanho || undefined, observacao: l.observacao }))
    try {
      const r = await POST('/uniformes/entregas', { colaborador_id: parseInt(colId), itens, assinatura_colaborador: assinaturas.colab, assinatura_almoxarife: assinaturas.almox || undefined, email: reauth.email || undefined, senha: reauth.senha || undefined })
      addToast('Retirada registrada!', 'success')
      await verTermo(r.id)
      resetTudo(); load()
    } catch (e) { addToast(e.message, 'error') }
  }
  return (
    <div>
      {step === 'form' && (
        <div className="card"><div className="card-body">
          <div className="form-group">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 6 }}>
              <label style={{ margin: 0 }}>Colaborador *</label>
              <button className="btn btn-outline btn-sm" onClick={() => setNovoColab(multiFicha ? { contrato_id: ctFicha.padrao } : {})}><Icon name="plus" size={13} /> Novo colaborador</button>
            </div>
            <select value={colId} onChange={e => setColId(e.target.value)}>
              <option value="">Selecione...</option>
              {porContrato
                ? gruposLogin.map(g => <optgroup key={g.cid || 0} label={g.nome || 'Sem contrato'}>{g.lista.map(opcaoColab)}</optgroup>)
                : <optgroup label="Usuários do sistema">{comLogin.map(opcaoColab)}</optgroup>}
              {semLogin.length > 0 && <optgroup label="Sem login (cadastrados só aqui no EPI)">{semLogin.map(opcaoColab)}</optgroup>}
            </select>
            <div className="text-muted" style={{ fontSize: '.75rem', marginTop: 4 }}>
              {colaborador && !colaborador.usuario_id
                ? <>Sem login — cadastrado só no EPI. {!base && multiFicha && (
                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 4, margin: '0 8px 0 0', fontSize: '.75rem', fontWeight: 400 }}>Contrato:
                      <select value={colaborador.contrato_id || ''} onChange={e => trocarContrato(colaborador, e.target.value)} style={{ width: 'auto', padding: '2px 6px', fontSize: '.75rem' }}>
                        <option value="">Sem contrato (só a Sede)</option>
                        {ctFicha.contratos.map(k => <option key={k.id} value={k.id}>{k.nome}</option>)}
                      </select>
                    </label>)}
                  {!base && <button className="est-link" onClick={() => tirarDaLista(colaborador)}>Tirar da lista</button>}</>
                : base ? `Funcionários dos contratos da base ${user.base_nome || ''} — a lista segue a aba Usuários: conta nova entra sozinha; conta inativada ou excluída sai.`
                : 'A lista segue a aba Usuários: conta nova entra sozinha; conta inativada ou excluída sai.'}
            </div>
          </div>
          <div style={{ margin: '16px 0 8px', fontWeight: 600, fontSize: '.85rem' }}>Itens a entregar</div>
          {linhas.map((l, i) => {
            const info = infoLinha(l)
            return (
              <div key={i} style={{ marginBottom: 8 }}>
                <div className="uni-linha">
                  <select value={l.item_id} onChange={e => setLinha(i, { item_id: e.target.value, tamanho: '', quantidade: 1 })}><option value="">Item...</option>{itensCat.map(it => <option key={it.id} value={it.id}>{it.nome} ({it.estoque_atual})</option>)}</select>
                  {info.it && info.precisaTam && (
                    <select value={l.tamanho || ''} onChange={e => setTamanho(i, e.target.value)} style={{ width: ehGradeDeCor(info.it) ? 210 : 120 }}>
                      <option value="">{eixoVar(info.it)}...</option>
                      {info.grade.map(t => { const d = dispDeTam(info.it, t); return <option key={t} value={t} disabled={d <= 0}>{rotuloVar(info.it, t)} — {d} disp.{d <= 0 ? ' (esgotado)' : ''}</option> })}
                    </select>
                  )}
                  <input type="number" min="1" value={l.quantidade} onChange={e => setQtd(i, e.target.value)} style={{ width: 60 }} title="Quantidade" disabled={info.it && !info.tamOk} />
                  <input className="obs" value={l.observacao} onChange={e => setLinha(i, { observacao: e.target.value })} placeholder="Obs." />
                  <button className="btn btn-ghost btn-sm" onClick={() => rmLinha(i)}><Icon name="x" size={14} /></button>
                </div>
                {info.it && (
                  <div style={{ fontSize: '.72rem', marginTop: 3, marginLeft: 2, color: info.semEstoque || info.excede ? 'var(--danger)' : 'var(--text-secondary)', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                    {!info.tamOk ? <><Icon name="alertTriangle" size={12} /> selecione {eixoVar(info.it) === 'Cor' ? 'a cor' : 'o tamanho'}</>
                      : info.semEstoque ? <><Icon name="alertTriangle" size={12} /> sem estoque {eixoVar(info.it) === 'Cor' ? 'nesta cor' : 'neste tamanho'}</>
                      : info.excede ? <><Icon name="alertTriangle" size={12} /> só há {info.disp} disponível(is)</>
                      : <>{info.disp} disponível(is){info.precisaTam ? ` · ${rotuloVar(info.it, l.tamanho)}` : ''}</>}
                  </div>
                )}
              </div>
            )
          })}
          {indisponiveis.length > 0 && (
            <div className="alert" style={{ marginTop: 8, marginBottom: 8, fontSize: '.82rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', borderColor: 'var(--danger)' }}>
              <span style={{ color: 'var(--danger)', display: 'inline-flex', alignItems: 'center', gap: 6 }}><Icon name="alertTriangle" size={15} /> {indisponiveis.length} item(ns) sem estoque suficiente.</span>
              <button className="btn btn-danger btn-sm" onClick={removerIndisponiveis}>Remover indisponíveis</button>
            </div>
          )}
          <div><button className="btn btn-outline btn-sm" onClick={addLinha}><Icon name="plus" size={14} /> Adicionar item</button></div>
          <div style={{ marginTop: 16, textAlign: 'right' }}><button className="btn btn-primary" onClick={irRevisar} disabled={indisponiveis.length > 0}><Icon name="fileText" size={15} /> Revisar termo →</button></div>
        </div></div>
      )}

      {step === 'termo' && (
        <div className="card"><div className="card-body">
          <h3 style={{ marginBottom: 6 }}>Confira o termo antes de assinar</h3>
          <p className="text-muted" style={{ fontSize: '.82rem', marginBottom: 12 }}>Verifique itens, tamanhos e quantidades. Ninguém assina sem conferir o que está assinando.</p>
          <iframe title="Prévia do termo" srcDoc={termoHTML} style={{ width: '100%', height: '55vh', border: '1px solid var(--border)', borderRadius: 8, background: '#fff' }} />
          <div className="gap-8" style={{ marginTop: 16, justifyContent: 'space-between', display: 'flex', flexWrap: 'wrap' }}>
            <button className="btn btn-ghost" onClick={() => setStep('form')}>← Voltar e editar</button>
            <button className="btn btn-primary" onClick={() => setStep('assinar')}><Icon name="signature" size={15} /> Conferi — ir para assinatura</button>
          </div>
        </div></div>
      )}

      {step === 'assinar' && (
        <div className="card"><div className="card-body">
          <h3 style={{ marginBottom: 12 }}>Assinaturas — {colaborador && colaborador.nome}</h3>

          {/* Assinatura do responsável: salva ("lastreada") ou desenhada na hora */}
          {!temResp && !minhaAssin && (
            <div className="alert" style={{ marginBottom: 12, fontSize: '.82rem' }}>Você ainda não tem assinatura registrada. Assine abaixo — ou registre a sua em <strong>Minha assinatura</strong> para não repetir a cada retirada.</div>
          )}
          {usaSalva ? (
            <div style={{ border: '1px solid var(--border)', borderRadius: 8, padding: 12, marginBottom: 14, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              <img src={minhaAssin} alt="Assinatura" style={{ maxWidth: 160, maxHeight: 60, background: '#fff', border: '1px solid var(--border)', borderRadius: 4 }} />
              <div style={{ flex: 1, minWidth: 160 }}>
                <div style={{ color: 'var(--success)', display: 'inline-flex', alignItems: 'center', gap: 6, fontWeight: 600 }}><Icon name="checkCircle" size={16} /> Assinatura do responsável registrada</div>
                <div className="text-muted" style={{ fontSize: '.78rem' }}>Será aplicada automaticamente ({user.nome}).</div>
              </div>
              <button className="btn btn-ghost btn-sm" onClick={() => { setAssinarDiferente(true); setAssinaturas(a => ({ ...a, almox: null })) }}>Assinar diferente</button>
            </div>
          ) : !assinaturas.almox ? (
            <div style={{ marginBottom: 8 }}>
              <SignaturePad label={`Assinatura do responsável — ${user.nome}`} onConfirm={sig => setAssinaturas(a => ({ ...a, almox: sig }))} onCancel={() => setStep('termo')} />
              {minhaAssin && <div style={{ textAlign: 'center', marginTop: 6 }}><button className="btn btn-ghost btn-sm" onClick={() => { setAssinarDiferente(false); setAssinaturas(a => ({ ...a, almox: null })) }}>Usar minha assinatura registrada</button></div>}
            </div>
          ) : null}

          {/* Assinatura do colaborador: sempre ao vivo (confere e assina presencialmente) */}
          {temResp && !assinaturas.colab && colaborador && colaborador.usuario_id && (
            <>
              <div className="alert" style={{ marginBottom: 12, fontSize: '.82rem' }}>Este colaborador tem login. Opcionalmente, informe e-mail/senha dele para reautenticar a assinatura.</div>
              <div className="form-grid" style={{ marginBottom: 12 }}>
                <div className="form-group"><label>E-mail (opcional)</label><input value={reauth.email} onChange={e => setReauth({ ...reauth, email: e.target.value })} /></div>
                <div className="form-group"><label>Senha (opcional)</label><input type="password" value={reauth.senha} onChange={e => setReauth({ ...reauth, senha: e.target.value })} /></div>
              </div>
            </>
          )}
          {temResp && !assinaturas.colab && (
            <SignaturePad label={`Assinatura do colaborador — ${colaborador && colaborador.nome}`} onConfirm={sig => setAssinaturas(a => ({ ...a, colab: sig }))} onCancel={() => setStep('termo')} />
          )}
          {temResp && assinaturas.colab && (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <p style={{ color: 'var(--success)', marginBottom: 14, display: 'inline-flex', alignItems: 'center', gap: 6 }}><Icon name="checkCircle" size={16} /> Assinaturas prontas.</p>
              <div className="gap-8" style={{ justifyContent: 'center', display: 'flex', flexWrap: 'wrap' }}>
                <button className="btn btn-ghost" onClick={() => { setAssinaturas(a => ({ ...a, colab: null })) }}>Refazer assinatura</button>
                <button className="btn btn-primary" onClick={finalizar}><Icon name="fileText" size={15} /> Finalizar e gerar termo</button>
              </div>
            </div>
          )}
        </div></div>
      )}

      {novoColab && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header"><h3>Novo colaborador</h3><button className="modal-close" onClick={() => setNovoColab(null)}>×</button></div>
            <div className="modal-body">
              <div className="form-grid">
                <div className="form-group full"><label>Nome completo *</label><input value={novoColab.nome || ''} onChange={e => setNovoColab({ ...novoColab, nome: e.target.value })} autoFocus /></div>
                <div className="form-group"><label>Setor / Departamento</label><input value={novoColab.setor || ''} onChange={e => setNovoColab({ ...novoColab, setor: e.target.value })} /></div>
                <div className="form-group"><label>CPF</label><input value={novoColab.cpf || ''} onChange={e => setNovoColab({ ...novoColab, cpf: e.target.value })} /></div>
                <div className="form-group"><label>Data de admissão</label><input type="date" value={novoColab.data_admissao || ''} onChange={e => setNovoColab({ ...novoColab, data_admissao: e.target.value })} /></div>
                {multiFicha && <div className="form-group"><label>{base ? 'Contrato *' : 'Contrato'}</label><select value={novoColab.contrato_id || ''} onChange={e => setNovoColab({ ...novoColab, contrato_id: Number(e.target.value) || null })}>
                  {!base && <option value="">Sem contrato (só a Sede)</option>}
                  {ctFicha.contratos.map(k => <option key={k.id} value={k.id}>{k.nome}</option>)}
                </select>{!base && <span className="text-muted" style={{ fontSize: '.72rem', marginTop: 4, display: 'block' }}>Com o contrato, o Almoxarife 2 da base dele também atende.</span>}</div>}
              </div>
              <p className="text-muted" style={{ fontSize: '.75rem', marginTop: 6 }}>Só para quem recebe EPI <strong>sem ter login</strong> — quem tem conta na aba Usuários já está na lista. Sem login, a pessoa assina no aparelho do responsável. Se depois ganhar uma conta com o mesmo CPF (ou o mesmo nome, no mesmo contrato), este cadastro passa a seguir a conta.</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setNovoColab(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvarNovoColab}><Icon name="check" size={14} /> Cadastrar e selecionar</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-header"><span className="card-title">Retiradas recentes</span></div>
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Nº</th><th>Colaborador</th><th>Data</th><th>Itens</th><th>Termo</th></tr></thead>
          <tbody>
            {entregas.map(e => (
              <tr key={e.id}>
                <td data-label="Nº"><strong>{e.numero}</strong></td>
                <td data-label="Colaborador">{e.colaborador_nome}{porContrato && e.contrato_nome && <div className="text-muted" style={{ fontSize: '.72rem' }}>{e.contrato_nome}</div>}</td>
                <td data-label="Data">{fmt(e.data_retirada || e.criado_em)}</td>
                <td data-label="Itens">{(e.itens || []).reduce((s, i) => s + i.quantidade, 0)} un</td>
                <td data-label="Termo" className="cell-actions"><button className="btn btn-outline btn-sm" onClick={() => verTermo(e.id)}><Icon name="fileText" size={14} /> Ver termo</button></td>
              </tr>
            ))}
            {!entregas.length && <tr><td colSpan="5" className="text-muted" style={{ textAlign: 'center', padding: 20 }}>Nenhuma retirada ainda.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  )
}

// Alertas — estoque no mínimo + desgaste vencendo (≤ 30 dias).
// soDesgaste (Almoxarife 2): só o desgaste dos funcionários da base dele — o estoque mínimo é da Sede, que repõe.
function UniAlertas({ soDesgaste }) {
  const [dados, setDados] = useState({ minimo: [], desgaste: [] })
  useEffect(() => { GET('/uniformes/alertas').then(setDados).catch(() => {}) }, [])
  // Etiqueta do contrato só quando o desgaste é de 2+ contratos (com 1 contrato nada muda, como na Retirada).
  const multiCt = new Set(dados.desgaste.map(d => d.contrato_nome).filter(Boolean)).size > 1
  return (
    <div>
      {!soDesgaste && <div className="card">
        <div className="card-header"><span className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Icon name="package" size={15} /> Estoque no mínimo</span></div>
        <div className="card-body">
          {dados.minimo.length ? (
            <div className="acard-list">
              {dados.minimo.map(i => {
                const atual = i.estoque_atual || 0
                const min = i.minimo || 0
                const crit = atual <= 0
                const pct = min > 0 ? Math.min(100, atual / min * 100) : 0
                return (
                  <div className={`acard ${crit ? 'crit' : 'warn'}`} key={`${i.id}-${i.tamanho}`}>
                    <span className="ic"><Icon name="package" size={20} /></span>
                    <div className="bd">
                      <div className="tag">{crit ? 'Crítico · sem estoque' : 'Abaixo do mínimo'}</div>
                      <div className="nm">{i.nome} <small>{i.tamanho === '—' ? '· único' : `· ${i.tamanho}`} · {i.categoria}</small></div>
                      <div className="meter"><b>{atual}</b> {i.unidade} em estoque <div className="mini"><span style={{ width: pct + '%' }}></span></div> mín. <b>{min}</b></div>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : <p className="text-muted" style={{ textAlign: 'center', padding: 12 }}>Nenhum item abaixo do mínimo.</p>}
        </div>
      </div>}
      <div className="card">
        <div className="card-header"><span className="card-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Icon name="history" size={15} /> Desgaste vencendo (≤ 30 dias)</span></div>
        <div className="card-body">
          {dados.desgaste.length ? (
            <div className="acard-list">
              {dados.desgaste.map((d, idx) => {
                const dias = d.dias_restantes
                const crit = dias <= 0
                const pct = crit ? 100 : Math.min(100, Math.max(6, (30 - dias) / 30 * 100))
                return (
                  <div className={`acard ${crit ? 'crit' : 'warn'}`} key={idx}>
                    <span className="ic"><Icon name="history" size={20} /></span>
                    <div className="bd">
                      <div className="tag">{crit ? 'Vencido' : 'Desgaste vencendo'}</div>
                      <div className="nm">{d.colaborador_nome} <small>{d.setor ? `· ${d.setor} ` : ''}{multiCt && d.contrato_nome ? `· ${d.contrato_nome} ` : ''}· {d.item_nome}{d.tamanho ? ` (${d.tamanho})` : ''}</small></div>
                      <div className="meter">Vence em <b>{fmt(d.vence_em)}</b> <div className="mini"><span style={{ width: pct + '%' }}></span></div> {crit ? 'Vencido' : `faltam ${dias} d`}</div>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : <p className="text-muted" style={{ textAlign: 'center', padding: 12 }}>Nenhuma reposição próxima.</p>}
        </div>
      </div>
    </div>
  )
}

// ─── BOLSAS ───────────────────────────────────────────────────────────────────
function BolsasPage({ user, addToast }) {
  const [lista, setLista] = useState([])
  const [ferramentas, setFerramentas] = useState([])
  const [modal, setModal] = useState(null)
  const [form, setForm] = useState({})
  const [itens, setItens] = useState([])
  // Com 2+ contratos cada kit mostra de que contrato(s) são as ferramentas dele (o acervo é por contrato).
  const ct = useContratosCadastro(user)
  const contratosDaBolsa = b => [...new Set((b.itens || []).map(i => ferramentas.find(f => f.id === i.ferramenta_id)).filter(Boolean).map(f => ct.de(f)))]
  const load = () => { GET('/bolsas').then(setLista); GET('/ferramentas').then(setFerramentas) }
  useEffect(() => { load() }, [])
  const save = async () => {
    if (!form.nome) { addToast('Informe o nome.','error'); return }
    try {
      if (form.id) await PUT(`/bolsas/${form.id}`, {...form, itens})
      else await POST('/bolsas', {...form, itens})
      addToast(form.id?'Atualizada!':'Criada!','success'); setModal(null); load()
    } catch(e) { addToast(e.message,'error') }
  }
  return (
    <div>
      <div className="topbar"><h2>Bolsas / Kits</h2><button className="btn btn-accent" onClick={()=>{setForm({});setItens([]);setModal('form')}}><Icon name="plus" size={14}/> Nova Bolsa</button></div>
      <div className="card"><div className="table-wrap"><table className="cards-mobile">
        <thead><tr><th>Nome</th><th>Descrição</th><th>Itens</th><th>Valor</th><th>Ações</th></tr></thead>
        <tbody>
          {lista.map(b=>(
            <tr key={b.id}>
              <td data-label="Nome"><strong>{b.nome}</strong>{contratosDaBolsa(b).map(cid => <ContratoTag key={cid} ct={ct} id={cid}/>)}</td>
              <td data-label="Descrição" className="text-muted">{b.descricao||'—'}</td>
              <td data-label="Itens">{b.itens.length} tipo(s)</td>
              <td data-label="Valor" style={{color:'var(--success)',fontWeight:600}}>{fmtBRL(b.valor_total||0)}</td>
              <td className="cell-actions"><button className="btn btn-ghost btn-sm" onClick={()=>{setForm({...b});setItens(b.itens.map(i=>({ferramenta_id:i.ferramenta_id,quantidade:i.quantidade,ferramenta_nome:i.ferramenta_nome,valor_unitario:i.valor_unitario||0})));setModal('form')}} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="edit" size={14}/> Editar</button></td>
            </tr>
          ))}
          {!lista.length && <tr><td colSpan="5"><div className="empty"><div className="empty-icon"><Icon name="backpack" size={32}/></div><p>Nenhuma bolsa ou kit cadastrado.</p><button className="btn btn-accent empty-cta" onClick={()=>{setForm({});setItens([]);setModal('form')}}><Icon name="plus" size={14}/> Nova bolsa</button></div></td></tr>}
        </tbody>
      </table></div></div>
      {modal === 'form' && (
        <div className="modal-overlay open">
          <div className="modal modal-lg">
            <div className="modal-header"><h3>{form.id?'Editar':'Nova'} Bolsa</h3><button className="modal-close" onClick={()=>setModal(null)}>×</button></div>
            <div className="modal-body">
              <div className="form-grid" style={{marginBottom:16}}>
                <div className="form-group"><label>Nome *</label><input value={form.nome||''} onChange={e=>setForm({...form,nome:e.target.value})} /></div>
                <div className="form-group"><label>Descrição</label><input value={form.descricao||''} onChange={e=>setForm({...form,descricao:e.target.value})} /></div>
              </div>
              <label style={{display:'block',marginBottom:6}}>Ferramentas</label>
              <ItemsEditor ferramentas={ferramentas} value={itens} onChange={setItens} ct={ct} />
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setModal(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={save}>Salvar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// ─── USUÁRIOS ─────────────────────────────────────────────────────────────────
// ─── OBRAS / CANTEIROS ────────────────────────────────────────────────────────
function ObrasPage({ user, addToast, openTarget, clearOpenTarget }) {
  const ct = useContratosCadastro(user)
  const [lista, setLista] = useState([])
  const [lideres, setLideres] = useState([])
  const [openId, setOpenId] = useState(null)
  const [form, setForm] = useState({})
  const [confirmDel, setConfirmDel] = useState(false)
  const [filtroP, setFiltroP] = useState(() => filtroDoAlvo(openTarget, 'obras'))  // card do painel
  const visiveis = lista.filter(o => !filtroP || ((filtroP.contrato == null || o.contrato_id === filtroP.contrato)
    && (!filtroP.ativas || o.ativo) && (!filtroP.semLider || (o.ativo && !o.lider_id)) && (!filtroP.comLider || (o.ativo && o.lider_id))))
  const load = () => GET('/obras?all=1').then(setLista).catch(()=>{})
  useEffect(() => { load(); GET('/usuarios/lideres').then(setLideres).catch(()=>{}) }, [])
  // Deep-link da busca/painel: abre direto o painel da obra pedida.
  useEffect(() => {
    if (!openTarget || openTarget.page !== 'obras') return
    if (!openTarget.id) { clearOpenTarget && clearOpenTarget(); return }
    const o = lista.find(x => x.id === openTarget.id)
    if (o) { setForm({ ...o }); setConfirmDel(false); setOpenId(o.id); clearOpenTarget && clearOpenTarget(); scrollPainelParaFoco() }
  }, [openTarget, lista])
  const abrirNovo = () => {
    const cid = (filtroP && filtroP.contrato) || ct.principal
    setForm({ativo:true, ...(ct.multi && cid ? { contrato_id: cid } : {})}); setConfirmDel(false); setOpenId('new')
  }
  const toggle = o => { if (openId === o.id) { fechar(); return } setForm({...o}); setConfirmDel(false); setOpenId(o.id) }
  const fechar = () => { setOpenId(null); setConfirmDel(false) }
  const save = async () => {
    if (!form.nome || !form.nome.trim()) { addToast('Nome da obra é obrigatório.','error'); return }
    try {
      if (form.id) {
        const r = await PUT(`/obras/${form.id}`, form)
        const n = (r && r.operarios_movidos) || 0
        const eng = (lideres.find(l => String(l.id) === String(form.lider_id)) || {}).nome || 'o novo engenheiro'
        addToast(n ? `Obra atualizada! ${n} colaborador${n>1?'es foram':' foi'} junto para ${eng}.` : 'Obra atualizada!', 'success')
      } else { await POST('/obras', form); addToast('Obra criada!','success') }
      fechar(); load()
    } catch(e) { addToast(e.message,'error') }
  }
  const desativar = async () => {
    try { await DEL(`/obras/${form.id}`); addToast('Obra desativada.','success'); fechar(); load() }
    catch(e) { addToast(e.message,'error') }
  }
  const painel = () => {
    // Engenheiros oferecidos = os do contrato da obra (com 2+ contratos).
    const ctForm = ct.multi ? Number(form.contrato_id || ct.de(form)) : null
    const lideresForm = ctForm ? lideres.filter(l => ct.de(l) === ctForm) : lideres
    const footer = confirmDel ? (
      <div style={{display:'flex',alignItems:'center',gap:10,width:'100%',justifyContent:'space-between',flexWrap:'wrap'}}>
        <span style={{fontSize:'.85rem',color:'var(--danger)',fontWeight:600,display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={15}/> Desativar esta obra? O histórico de cautelas é preservado.</span>
        <div className="gap-8"><button className="btn btn-ghost btn-sm" onClick={()=>setConfirmDel(false)}>Não</button><button className="btn btn-danger btn-sm" onClick={desativar}>Sim, desativar</button></div>
      </div>
    ) : (<>
      <div>{form.id && !!form.ativo && <button className="btn btn-danger btn-sm" onClick={()=>setConfirmDel(true)}><Icon name="trash" size={14}/> Desativar</button>}</div>
      <div className="gap-8">
        <button className="btn btn-ghost btn-sm" onClick={fechar}>Cancelar</button>
        <button className="btn btn-primary btn-sm" onClick={save}><Icon name="check" size={14}/> Salvar</button>
      </div>
    </>)
    return (
      <PainelEdicao titulo={form.id ? `Editar ${form.nome}` : 'Nova obra'} onFechar={fechar} footer={footer}>
        <div className="form-grid">
          <div className="form-group"><label>Nome da obra *</label><input value={form.nome||''} onChange={e=>setForm({...form,nome:e.target.value})} placeholder="Ex.: Residencial Vista Mar" /></div>
          {ct.multi && (
            <div className="form-group"><label>Contrato</label>
              <select value={ctForm || ''} onChange={e=>{ const cid = Number(e.target.value); const l = lideres.find(x => String(x.id) === String(form.lider_id)); setForm({...form, contrato_id: cid, ...(l && ct.de(l) !== cid ? { lider_id: '' } : {})}) }}>
                {ct.contratos.map(c=><option key={c.id} value={c.id}>{c.nome}{c.ativo ? '' : ' (inativo)'}</option>)}
              </select>
              <span className="text-muted" style={{fontSize:'.72rem',marginTop:4,display:'block'}}>O engenheiro responsável e quem trabalha na obra são deste contrato. Os pedidos de material da obra chegam a Compras com ele.</span>
            </div>
          )}
          <div className="form-group"><label>Código / Contrato</label><input value={form.codigo||''} onChange={e=>setForm({...form,codigo:e.target.value})} placeholder="OBR-01" /></div>
          <div className="form-group"><label>Responsável (engenharia)</label><input value={form.responsavel||''} onChange={e=>setForm({...form,responsavel:e.target.value})} placeholder="Eng. responsável" /></div>
          <div className="form-group"><label>Engenheiro responsável</label>
            <select value={form.lider_id||''} onChange={e=>setForm({...form,lider_id:e.target.value})}>
              <option value="">Sem engenheiro definido</option>
              {lideresForm.map(l=><option key={l.id} value={l.id}>{l.nome}</option>)}
            </select>
            <span className="text-muted" style={{fontSize:'.72rem',marginTop:4,display:'block'}}>O engenheiro só enxerga a obra depois de ser definido aqui. Ao trocar, os colaboradores alocados nesta obra passam junto para o novo engenheiro.</span>
          </div>
          <div className="form-group"><label>Endereço</label><input value={form.endereco||''} onChange={e=>setForm({...form,endereco:e.target.value})} /></div>
          {form.id && <div className="form-group"><label>Status</label>
            <select value={form.ativo?'1':'0'} onChange={e=>setForm({...form,ativo:e.target.value==='1'})}>
              <option value="1">Ativa</option><option value="0">Inativa</option>
            </select>
          </div>}
        </div>
      </PainelEdicao>
    )
  }
  const vazio = <div className="empty"><div className="empty-icon"><Icon name="building" size={32}/></div><p>Nenhuma obra cadastrada.</p><button className="btn btn-accent empty-cta" onClick={abrirNovo}><Icon name="plus" size={14}/> Nova obra</button></div>
  return (
    <div style={{maxWidth:680,margin:'0 auto'}}>
      <div className="topbar"><h2>Obras</h2><button className="btn btn-accent" onClick={abrirNovo}><Icon name="plus" size={14}/> Nova</button></div>
      <FiltroPainel filtro={filtroP} n={visiveis.length} onLimpar={()=>setFiltroP(null)} />
      <div className="card">
        <ListaAcordeao
          itens={visiveis} keyOf={o=>o.id} abertoId={openId} onToggle={toggle}
          novoAberto={openId==='new'} painelNovo={painel()} painel={()=>painel()} vazio={vazio}
          resumo={o=>({
            titulo: <><span className="nm">{o.nome}</span>{o.codigo && <span className="text-muted" style={{fontSize:'.72rem',marginLeft:6}}>{o.codigo}</span>}{!o.ativo && <span className="badge badge-devolvida" style={{fontSize:'.62rem',padding:'1px 7px',marginLeft:6}}>Inativa</span>}<ContratoTag ct={ct} id={ct.de(o)} compacta/></>,
            direita: o.lider_nome
              ? <span className="badge badge-lider" style={{fontSize:'.68rem'}}>{o.lider_nome}</span>
              : <span style={{fontSize:'.72rem',color:'var(--warning)',display:'inline-flex',alignItems:'center',gap:4,fontWeight:600}}><Icon name="alertTriangle" size={12}/> Sem engenheiro</span>
          })}
        />
      </div>
    </div>
  )
}

// ─── ARRASTAR estilo Trello (mouse e toque) ──────────────────────────────────
// O drag nativo do HTML5 não funciona no celular — lá só sobrava o seletor "Mover para…". Este
// arraste é igual nos dois: no mouse, clicar e mover; no toque, SEGURAR o cartão ~0,35 s (o celular
// vibra) e arrastar. Uma cópia do cartão segue o dedo, a tela rola sozinha perto das bordas e o alvo
// sob o dedo acende. Uso: {...arraste.item(dados)} no cartão e data-drop="chave" em cada coluna;
// aceita(dados, chave) diz se a coluna serve, onSoltar(dados, chave) faz a mudança.
let arrasteToqueAtivo = false
// O Safari do iPhone só respeita preventDefault no touchmove se já existir um ouvinte não-passivo na
// janela ANTES do toque começar — sem ele a página rola junto com o cartão.
window.addEventListener('touchmove', e => { if (arrasteToqueAtivo && e.cancelable) e.preventDefault() }, { passive: false })

function useArrastar({ aceita = () => true, onSoltar }) {
  const [arrastando, setArrastando] = useState(null)   // dados do cartão em arraste
  const [alvo, setAlvo] = useState(null)               // chave da coluna válida sob o dedo/cursor
  const cb = useRef({}); cb.current = { aceita, onSoltar }
  const st = useRef(null)

  // Colunas podem estar uma dentro da outra (obra dentro do quadro do engenheiro): vale a mais
  // próxima do dedo que aceite o cartão.
  const alvoEm = (x, y) => {
    let d = document.elementFromPoint(x, y)
    while (d && (d = d.closest('[data-drop]'))) {
      const k = d.getAttribute('data-drop')
      if (cb.current.aceita(st.current.dados, k)) return k
      d = d.parentElement
    }
    return null
  }
  const marcar = k => { const s = st.current; if (k !== s.alvo) { s.alvo = k; setAlvo(k) } }
  const posicionar = (x, y) => {
    const s = st.current
    s.x = x; s.y = y
    s.copia.style.transform = `translate(${x - s.dx}px, ${y - s.dy}px) rotate(2deg)`
    marcar(alvoEm(x, y))
  }
  // Perto da borda: rola a página (vertical) e o quadro de colunas na altura do dedo (horizontal).
  const rolar = () => {
    const s = st.current; if (!s || !s.ativo) return
    const faixa = 64, topo = window.innerWidth <= 768 ? 52 : 0   // barra fixa do topo no celular
    const vel = dist => Math.round(2 + 10 * Math.max(0, Math.min(1, 1 - dist / faixa)))   // até ~12 px por quadro
    let rolou = false
    if (s.y < topo + faixa && window.scrollY > 0) { window.scrollBy(0, -vel(s.y - topo)); rolou = true }
    else if (s.y > window.innerHeight - faixa) { window.scrollBy(0, vel(window.innerHeight - s.y)); rolou = true }
    for (const q of document.querySelectorAll('[data-drag-scroll]')) {
      const r = q.getBoundingClientRect()
      if (s.y < r.top || s.y > r.bottom || q.scrollWidth <= q.clientWidth) continue
      if (s.x < r.left + faixa && q.scrollLeft > 0) { q.scrollLeft -= vel(s.x - r.left); rolou = true }
      else if (s.x > r.right - faixa) { q.scrollLeft += vel(r.right - s.x); rolou = true }
    }
    if (rolou) marcar(alvoEm(s.x, s.y))
    s.raf = requestAnimationFrame(rolar)
  }
  const ativar = () => {
    const s = st.current
    const r = s.el.getBoundingClientRect()
    s.dx = s.x0 - r.left; s.dy = s.y0 - r.top
    const c = s.el.cloneNode(true)
    c.classList.add('arraste-copia')
    Object.assign(c.style, { position: 'fixed', left: '0', top: '0', width: r.width + 'px', margin: '0', zIndex: 9999, pointerEvents: 'none' })
    document.body.appendChild(c)
    document.body.classList.add('arrastando')
    s.copia = c; s.ativo = true
    if (s.toque) { arrasteToqueAtivo = true; if (navigator.vibrate) navigator.vibrate(25) }
    setArrastando(s.dados)
    posicionar(s.x, s.y)
    s.raf = requestAnimationFrame(rolar)
  }
  const encerrar = soltar => {
    const s = st.current; if (!s) return
    const k = s.ativo && soltar ? alvoEm(s.x, s.y) : null
    st.current = null
    clearTimeout(s.timer); cancelAnimationFrame(s.raf); s.off()
    arrasteToqueAtivo = false
    if (!s.ativo) return
    s.copia.remove(); document.body.classList.remove('arrastando')
    setArrastando(null); setAlvo(null)
    // O clique que o navegador dispara ao soltar o mouse não pode abrir/fechar nada embaixo.
    if (!s.toque) {
      const engole = e => { e.stopPropagation(); e.preventDefault() }
      window.addEventListener('click', engole, { capture: true, once: true })
      setTimeout(() => window.removeEventListener('click', engole, true), 0)
    }
    if (k != null) cb.current.onSoltar(s.dados, k)
  }
  useEffect(() => () => encerrar(false), [])

  const iniciar = (e, dados, toque) => {
    if (st.current) return
    const p = toque ? e.touches[0] : e
    const s = { dados, el: e.currentTarget, toque, x0: p.clientX, y0: p.clientY, x: p.clientX, y: p.clientY, ativo: false, alvo: null }
    st.current = s
    if (toque) {
      const mover = ev => {
        const t = ev.touches[0]; if (!t || st.current !== s) return
        // Mexeu o dedo antes do tempo = é rolagem da tela, não arraste.
        if (!s.ativo) { if (Math.hypot(t.clientX - s.x0, t.clientY - s.y0) > 10) encerrar(false); return }
        if (ev.cancelable) ev.preventDefault()
        posicionar(t.clientX, t.clientY)
      }
      const fim = ev => { if (st.current !== s) return; if (s.ativo && ev.cancelable) ev.preventDefault(); encerrar(ev.type === 'touchend') }
      window.addEventListener('touchmove', mover, { passive: false })
      window.addEventListener('touchend', fim); window.addEventListener('touchcancel', fim)
      s.off = () => { window.removeEventListener('touchmove', mover); window.removeEventListener('touchend', fim); window.removeEventListener('touchcancel', fim) }
      s.timer = setTimeout(ativar, 350)
    } else {
      const mover = ev => {
        if (!s.ativo) { if (Math.hypot(ev.clientX - s.x0, ev.clientY - s.y0) < 5) return; ativar() }
        ev.preventDefault()
        posicionar(ev.clientX, ev.clientY)
      }
      const fim = () => encerrar(true)
      const esc = ev => { if (ev.key === 'Escape') encerrar(false) }
      window.addEventListener('mousemove', mover); window.addEventListener('mouseup', fim); window.addEventListener('keydown', esc)
      s.off = () => { window.removeEventListener('mousemove', mover); window.removeEventListener('mouseup', fim); window.removeEventListener('keydown', esc) }
    }
  }
  // Botões, seletores e campos dentro do cartão continuam funcionando normalmente.
  const interativo = t => t.closest && t.closest('button,select,input,textarea,a,label')
  const item = dados => ({
    'data-arrastavel': '',
    onMouseDown: e => { if (e.button !== 0 || interativo(e.target)) return; e.preventDefault(); e.stopPropagation(); iniciar(e, dados, false) },
    onTouchStart: e => { if (e.touches.length !== 1 || interativo(e.target)) return; e.stopPropagation(); iniciar(e, dados, true) },
    // Android abre o menu de "segurar" (copiar/compartilhar) no mesmo gesto — aqui ele é o arraste.
    onContextMenu: e => { if (st.current && st.current.toque) e.preventDefault() },
  })
  return { arrastando, alvo, item }
}

// ─── OBRAS (líder) — Kanban: arrasta colaborador da equipe entre as obras dele ─
// Colunas = obras atribuídas ao líder (+ "Sem obra"). Mover entre as próprias obras
// é imediato (POST /equipe/mover). Passar p/ outro líder (com aceite) fica na aba equipe.
// Arraste no mouse e no celular (segurar e arrastar) — o seletor do cartão continua como atalho.
function ObrasLiderPage({ user, addToast }) {
  const [obras, setObras] = useState([])
  const [membros, setMembros] = useState([])
  const [loading, setLoading] = useState(true)
  const [busyId, setBusyId] = useState(null)
  // Coluna = id da obra em texto ('sem' = Volantes). Só acende coluna diferente da atual.
  const arraste = useArrastar({
    aceita: (id, k) => obraDe(membros.find(m => m.id === id) || {}) !== (k === 'sem' ? null : Number(k)),
    onSoltar: (id, k) => mover(id, k === 'sem' ? null : Number(k)),
  })

  const load = () => {
    setLoading(true)
    Promise.all([ GET('/obras'), GET('/equipe') ])
      .then(([o, eq]) => { setObras(o||[]); setMembros((eq&&eq.membros)||[]) })
      .catch(e => addToast(e.message,'error'))
      .finally(()=>setLoading(false))
  }
  useEffect(load, [])

  const colObraIds = new Set(obras.map(o=>o.id))
  // obra "efetiva" do membro: só conta se for uma obra do líder; senão cai em "Sem obra".
  const obraDe = (m) => (m.obra_id && colObraIds.has(m.obra_id)) ? m.obra_id : null
  const colunas = [{ id: null, nome: 'Volantes', semObra: true }, ...obras]
  const membrosDaColuna = (colId) => membros.filter(m => obraDe(m) === (colId || null))

  const mover = async (colaborador_id, obra_id) => {
    const atual = membros.find(m=>m.id===colaborador_id)
    const destino = obra_id || null
    if (obraDe(atual||{}) === destino) return
    setBusyId(colaborador_id)
    try {
      await POST('/equipe/mover', { colaborador_id, obra_id: destino, para_lider_id: null })
      const nome = destino ? ((obras.find(o=>o.id===destino)||{}).nome || 'obra') : 'Volantes'
      setMembros(ms => ms.map(m => m.id===colaborador_id ? {...m, obra_id: destino} : m))
      addToast(`${atual?atual.nome:'Colaborador'} movido para ${nome}.`, 'success')
    } catch(e){ addToast(e.message,'error'); load() }
    finally { setBusyId(null) }
  }

  if (loading) return <div style={{padding:24,color:'var(--text-secondary)'}}>Carregando obras…</div>

  return (
    <div>
      <div className="topbar"><h2>Obras</h2></div>
      <p className="text-muted" style={{margin:'-6px 0 14px',fontSize:'.84rem'}}>Suas obras e quem está em cada uma. Arraste o colaborador até outra obra (no celular, segure o card por um instante e arraste) ou use o seletor no card — muda na hora, dentro da sua equipe.</p>

      <div className="stats-grid" style={{marginBottom:16}}>
        <div className="stat-card blue"><div className="stat-label">Minhas obras</div><div className="stat-value">{obras.length}</div></div>
      </div>

      {obras.length === 0 ? (
        <div className="card"><div className="empty"><div className="empty-icon"><Icon name="building" size={32}/></div><p>Nenhuma obra atribuída a você ainda.</p><p className="text-muted" style={{fontSize:'.82rem'}}>O Diretor de Operações ou o Almoxarifado define quais obras são suas.</p></div></div>
      ) : (
        <div className="obras-board" data-drag-scroll style={{display:'flex',gap:12,overflowX:'auto',paddingBottom:10,alignItems:'flex-start'}}>
          {colunas.map(col => {
            const ms = membrosDaColuna(col.id)
            const total = ms.reduce((s,m)=>s+(m.valor_em_posse||0),0)
            const chave = col.id ? String(col.id) : 'sem'
            const over = arraste.alvo === chave
            const pode = arraste.arrastando != null && !over && obraDe(membros.find(m => m.id === arraste.arrastando) || {}) !== (col.id || null)
            return (
              <div key={chave} className="obra-lane" data-drop={chave}
                style={{minWidth:222,maxWidth:264,flex:'0 0 auto',background:over?'var(--tag-aco-bg)':'var(--card)',border:`1.5px ${over||pode?'dashed':'solid'} ${over||pode?'var(--primary-accent)':'var(--border)'}`,borderRadius:12,padding:11,transition:'border-color .15s,background .15s'}}>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                  <span style={{width:30,height:30,borderRadius:8,background:col.semObra?'var(--silver)':'var(--fill-navy)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Icon name={col.semObra?'users':'building'} size={16}/></span>
                  <div style={{minWidth:0}}>
                    <div style={{fontWeight:600,fontSize:'.9rem',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{col.nome}{col.codigo?<span className="text-muted" style={{fontWeight:400,fontSize:'.72rem',marginLeft:5}}>{col.codigo}</span>:null}</div>
                    <div className="text-muted" style={{fontSize:'.72rem'}}>{ms.length} colab. · {fmtBRL(total)}</div>
                  </div>
                </div>
                <div style={{marginTop:9,display:'flex',flexDirection:'column',gap:7,minHeight:44}}>
                  {ms.length===0 && <div className="text-muted" style={{fontSize:'.76rem',textAlign:'center',padding:'14px 4px',border:'1px dashed var(--border)',borderRadius:8}}>{over?'Soltar aqui':'—'}</div>}
                  {ms.map(m => (
                    <div key={m.id} {...arraste.item(m.id)}
                      style={{background:'var(--surface)',border:'1px solid var(--border)',borderRadius:9,padding:'8px 9px',opacity:busyId===m.id?.5:arraste.arrastando===m.id?.35:1}}>
                      <div style={{display:'flex',alignItems:'center',gap:7}}>
                        <span style={{width:24,height:24,borderRadius:'50%',background:'var(--fill-steel)',color:'#fff',fontSize:'.64rem',fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{iniciais(m.nome)}</span>
                        <div style={{minWidth:0,flex:1}}>
                          <div style={{fontWeight:600,fontSize:'.82rem',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{m.nome}</div>
                          <div className="text-muted" style={{fontSize:'.7rem',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{m.cargo || 'Sem função'}</div>
                        </div>
                      </div>
                      <select value="" onChange={e=>{ const v=e.target.value; if(v!=='') mover(m.id, v==='__sem'?null:Number(v)) }}
                        style={{marginTop:7,width:'100%',fontSize:'.74rem',padding:'4px 6px'}} disabled={busyId===m.id}>
                        <option value="">Mover para…</option>
                        {obraDe(m)!==null && <option value="__sem">Volantes</option>}
                        {obras.filter(o=>o.id!==obraDe(m)).map(o=><option key={o.id} value={o.id}>{o.nome}</option>)}
                      </select>
                    </div>
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      )}
      <p className="text-muted" style={{fontSize:'.78rem',marginTop:10,display:'inline-flex',alignItems:'center',gap:6,flexWrap:'wrap'}}><Icon name="handshake" size={13}/> Para passar um colaborador a outro líder (com aceite), use a aba <strong style={{margin:'0 3px'}}>Minha equipe</strong>.</p>
    </div>
  )
}

// ─── ALOCAR PROFISSIONAIS NA OBRA (Kanban de Obras) ───────────────────────────
// Fase de adaptação: enquanto os engenheiros não montam as próprias equipes, o Master/Diretor/
// Gerente escolhe os operários do contrato e põe cada um na unidade certa. Quem vem de outro
// engenheiro passa para o engenheiro da obra (fica no histórico); a cautela vai junto com a pessoa.
function AlocarObraModal({ obra, onClose, addToast }) {
  const [dados, setDados] = useState(null)
  const [sel, setSel] = useState([])
  const [busca, setBusca] = useState('')
  const [filtro, setFiltro] = useState(null)   // 'sem_obra' | 'outra' | 'todos'
  const [busy, setBusy] = useState(false)
  const [mudou, setMudou] = useState(false)
  const load = () => GET(`/obras/${obra.id}/alocacao`)
    .then(d => { setDados(d); setFiltro(f => f || (d.pessoas.some(p => p.situacao === 'sem_obra') ? 'sem_obra' : 'todos')) })
    .catch(e => { addToast(e.message, 'error'); onClose(false) })
  useEffect(() => { load() }, [obra.id])
  const fechar = () => onClose(mudou)

  if (!dados) return (
    <div className="modal-overlay open"><div className="modal modal-md"><div className="modal-body" style={{color:'var(--text-secondary)'}}>Carregando profissionais…</div></div></div>
  )

  const pessoas = dados.pessoas
  const nesta = pessoas.filter(p => p.situacao === 'nesta')
  const candidatos = pessoas.filter(p => p.situacao !== 'nesta')
  const nSem = candidatos.filter(p => p.situacao === 'sem_obra').length
  const nOutra = candidatos.length - nSem
  const q = busca.trim().toLowerCase()
  const visiveis = candidatos.filter(p => (filtro === 'todos' || p.situacao === filtro) &&
    casaBusca(q, p.nome, p.cargo, p.obra_nome, p.obra_codigo, p.lider_nome))
  const grupos = {}
  for (const p of visiveis) { const k = (p.cargo && p.cargo.trim()) || 'Sem função'; (grupos[k] = grupos[k] || []).push(p) }
  const funcoes = Object.keys(grupos).sort((a, b) => a.localeCompare(b, 'pt'))
  const onde = p => p.situacao === 'outra' ? `${p.obra_nome}${p.lider_nome ? ' · ' + p.lider_nome : ''}`
    : (p.lider_nome ? `Volante · ${p.lider_nome}` : 'Sem engenheiro')
  const toggle = id => setSel(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id])
  const toggleGrupo = gente => {
    const ids = gente.map(p => p.id); const todos = ids.every(id => sel.includes(id))
    setSel(s => todos ? s.filter(id => !ids.includes(id)) : [...new Set([...s, ...ids])])
  }
  const escolhidos = pessoas.filter(p => sel.includes(p.id))
  const deOutroEng = escolhidos.filter(p => p.lider_id && p.lider_id !== dados.obra.lider_id).length
  const comFerramenta = escolhidos.filter(p => p.cautelas_ativas > 0)

  const alocar = async () => {
    setBusy(true)
    try {
      const r = await POST(`/obras/${obra.id}/alocar`, { colaboradores: sel })
      addToast(`${r.alocados} profissional(is) alocado(s) em ${dados.obra.nome}.`, 'success')
      onClose(true)
    } catch (e) { addToast(e.message, 'error'); setBusy(false) }
  }
  const tirar = async p => {
    setBusy(true)
    try {
      await POST(`/obras/${obra.id}/desalocar`, { colaborador_id: p.id })
      addToast(`${p.nome} saiu da obra — fica como Volante${p.lider_nome ? ' de ' + p.lider_nome : ''}.`, 'success')
      setMudou(true); await load()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }

  return (
    <div className="modal-overlay open" onClick={e => { if (e.target === e.currentTarget && !busy) fechar() }}>
      <div className="modal modal-md">
        <div className="modal-header">
          <div style={{minWidth:0}}>
            <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="userPlus" size={18}/> Alocar profissionais</h3>
            <div className="text-muted" style={{fontSize:'.8rem',marginTop:2}}>{dados.obra.nome}{dados.obra.codigo ? ` (${dados.obra.codigo})` : ''} · Eng. {dados.obra.lider_nome || '—'}</div>
          </div>
          <button className="modal-close" onClick={fechar}>×</button>
        </div>
        <div className="modal-body" style={{paddingTop:16}}>
          <div style={{fontSize:'.78rem',fontWeight:700,color:'var(--text-secondary)',marginBottom:6}}>NESTA OBRA AGORA ({nesta.length})</div>
          {nesta.length === 0
            ? <div className="text-muted" style={{fontSize:'.8rem'}}>Ninguém alocado ainda.</div>
            : <div className="aloc-nesta">{nesta.map(p => (
                <span key={p.id} title={p.cargo || 'Sem função'}>{p.nome}<button onClick={() => tirar(p)} disabled={busy} title="Tirar da obra (fica como Volante do engenheiro)"><Icon name="x" size={12}/></button></span>
              ))}</div>}

          <div style={{borderTop:'1px solid var(--border)',margin:'16px 0 12px'}}/>
          <div style={{position:'relative'}}>
            <span style={{position:'absolute',left:10,top:'50%',transform:'translateY(-50%)',color:'var(--text-secondary)',display:'flex'}}><Icon name="search" size={15}/></span>
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar nome, função, obra ou engenheiro…" style={{width:'100%',paddingLeft:32}} />
          </div>
          <div className="aloc-filtros">
            <button className={filtro === 'sem_obra' ? 'on' : ''} onClick={() => setFiltro('sem_obra')}>Sem obra ({nSem})</button>
            <button className={filtro === 'outra' ? 'on' : ''} onClick={() => setFiltro('outra')}>Em outras obras ({nOutra})</button>
            <button className={filtro === 'todos' ? 'on' : ''} onClick={() => setFiltro('todos')}>Todos ({candidatos.length})</button>
          </div>
          {visiveis.length === 0 && <div className="text-muted" style={{fontSize:'.82rem',textAlign:'center',padding:'18px 6px',border:'1px dashed var(--border)',borderRadius:9}}>
            {q ? 'Ninguém encontrado com essa busca.' : filtro === 'sem_obra' ? 'Todos os profissionais do contrato já estão em alguma obra.' : 'Nenhum profissional aqui.'}</div>}
          {funcoes.map(fn => {
            const gente = grupos[fn]; const todos = gente.every(p => sel.includes(p.id))
            return (
              <div key={fn}>
                <div className="aloc-grupo-hd"><span>{fn} <span style={{fontWeight:600,whiteSpace:"nowrap"}}>· {gente.length}</span></span>
                  <button onClick={() => toggleGrupo(gente)}>{todos ? 'desmarcar' : 'marcar todos'}</button></div>
                {gente.map(p => (
                  <label key={p.id} className={`aloc-row ${sel.includes(p.id) ? 'sel' : ''}`}>
                    <input type="checkbox" checked={sel.includes(p.id)} onChange={() => toggle(p.id)} />
                    <span style={{width:28,height:28,borderRadius:'50%',background:'var(--fill-navy)',color:'#fff',fontSize:'.62rem',fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{iniciais(p.nome)}</span>
                    <div style={{minWidth:0,flex:1}}>
                      <div style={{fontWeight:600,fontSize:'.86rem',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{p.nome}</div>
                      <div className="aloc-onde">{onde(p)}</div>
                    </div>
                    {p.cautelas_ativas > 0 && <span title="Ferramentas em mãos — a cautela vai junto com a pessoa" style={{flexShrink:0,fontSize:'.68rem',fontWeight:700,color:'var(--tag-cobre-fg)',background:'var(--tag-cobre-bg)',border:'1px solid var(--tag-cobre-bd)',borderRadius:999,padding:'2px 8px'}}>{p.cautelas_ativas} caut.</span>}
                  </label>
                ))}
              </div>
            )
          })}
        </div>
        <div className="modal-footer" style={{justifyContent:'space-between',alignItems:'center'}}>
          <div className="text-muted" style={{fontSize:'.76rem',flex:'1 1 220px',lineHeight:1.4}}>
            {sel.length === 0 ? 'Marque quem vai para esta obra.' : <>
              <b style={{color:'var(--text)'}}>{sel.length} selecionado(s).</b>
              {deOutroEng > 0 && <> {deOutroEng} passa(m) para o engenheiro {dados.obra.lider_nome} — fica registrado no histórico.</>}
              {comFerramenta.length > 0 && <> {comFerramenta.length} com ferramenta em mãos: a cautela vai junto.</>}
            </>}
          </div>
          <div style={{display:'flex',gap:8}}>
            <button className="btn btn-ghost" onClick={fechar} disabled={busy}>Cancelar</button>
            <button className="btn btn-accent" onClick={alocar} disabled={busy || sel.length === 0}><Icon name="check" size={15}/> {busy ? 'Alocando…' : `Alocar ${sel.length || ''} na obra`}</button>
          </div>
        </div>
      </div>
    </div>
  )
}

// ─── KANBAN DE OBRAS (consolidado) — Diretor / Auxiliar Técnica / Gerente / Apontador ──────
// Compilado de todos os "quadros de obras" dos engenheiros/líderes: cada responsável é um bloco,
// suas obras são colunas com os colaboradores, e uma coluna "Volantes" (sem obra). Master/Diretor/
// Gerente ainda têm "Alocar profissionais" em cada obra e arrastam (mouse, ou segurar no celular):
// o profissional para outra obra (ou para os Volantes do mesmo engenheiro) e a obra sem engenheiro
// até o quadro de um engenheiro. Apontador só lê.

// Coluna da obra: em vez de listar cada pessoa, lista as FUNÇÕES (profissões) — ocupa menos
// espaço. Clicar numa função expande quem está nela. Ex.: "Pintor de Manutenção (2)" → os 2 nomes.
// Fica fora do KanbanObrasPage: declarada lá dentro, era recriada a cada render e fechava as
// funções abertas — no meio de um arraste o cartão sumia da mão.
// estado: 'sobre' (alvo sob o dedo) · 'pode' (aceita o que está sendo arrastado) · 'origem' (obra em arraste)
function KanbanLane({ titulo, sub, membros, icon, semObra, onAlocar, drop, estado, arrastavel, itemPessoa, pessoaArrastada }) {
  const [aberto, setAberto] = useState({})
  const grupos = {}
  for (const m of membros) { const k = (m.cargo && m.cargo.trim()) || 'Sem função'; (grupos[k] = grupos[k] || []).push(m) }
  const funcoes = Object.keys(grupos).sort((a, b) => a.localeCompare(b, 'pt'))
  const sobre = estado === 'sobre'
  return (
    <div data-drop={drop} {...(arrastavel || {})}
      style={{minWidth:210,maxWidth:260,flex:'0 0 auto',background:sobre?'var(--tag-aco-bg)':'var(--bg,#f8fafc)',border:'1px solid var(--border,#e5e7eb)',borderRadius:12,padding:10,
        outline:sobre?'2px solid var(--primary-accent)':estado==='pode'?'1.5px dashed var(--primary-accent)':'none',outlineOffset:-1,opacity:estado==='origem'?.35:1,transition:'background .15s'}}>
      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
        <span style={{width:28,height:28,borderRadius:8,background:semObra?'var(--rec-gray)':'var(--fill-navy)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><Icon name={icon} size={15}/></span>
        <div style={{minWidth:0}}>
          <div style={{fontWeight:600,fontSize:'.86rem',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{titulo}</div>
          <div className="text-muted" style={{fontSize:'.7rem',...(sobre?{color:'var(--primary-accent)',fontWeight:700}:{})}}>{sobre ? 'Soltar aqui' : sub}</div>
        </div>
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:6,minHeight:36}}>
        {membros.length===0 ? <div className="text-muted" style={{fontSize:'.74rem',textAlign:'center',padding:'12px 4px',border:'1px dashed var(--border,#e5e7eb)',borderRadius:8}}>—</div>
          : funcoes.map(fn => {
            const gente = grupos[fn]; const open = !!aberto[fn]
            return (
              <div key={fn} style={{background:'var(--card,#fff)',border:'1px solid var(--border,#e5e7eb)',borderRadius:9,overflow:'hidden'}}>
                <button onClick={()=>setAberto(s=>({...s,[fn]:!s[fn]}))}
                  style={{display:'flex',width:'100%',alignItems:'center',gap:6,padding:'7px 9px',background:'transparent',border:'none',cursor:'pointer',textAlign:'left'}}>
                  <span style={{color:'var(--rec-navy)',fontSize:'.7rem',flexShrink:0}}>{open?'▾':'▸'}</span>
                  <span style={{flex:1,minWidth:0,fontWeight:600,fontSize:'.8rem',color:'var(--ink,#111)',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{fn}</span>
                  <span style={{flexShrink:0,fontSize:'.68rem',fontWeight:700,color:'var(--rec-on-accent)',background:'var(--rec-navy)',borderRadius:999,padding:'1px 7px'}}>{gente.length}</span>
                </button>
                {open && (
                  <div style={{borderTop:'1px solid var(--border,#e5e7eb)',padding:'6px 8px 8px',display:'flex',flexDirection:'column',gap:itemPessoa?2:6}}>
                    {gente.map(m => (
                      <div key={m.id} {...(itemPessoa ? itemPessoa(m) : {})}
                        style={{display:'flex',alignItems:'center',gap:7,...(itemPessoa?{padding:'3px 5px',margin:'0 -5px',borderRadius:7}:{}),opacity:pessoaArrastada===m.id?.35:1}}>
                        <span style={{width:22,height:22,borderRadius:'50%',background:'var(--fill-navy)',color:'#fff',fontSize:'.58rem',fontWeight:700,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{iniciais(m.nome)}</span>
                        <div style={{minWidth:0,flex:1}}>
                          <div style={{fontSize:'.78rem',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{m.nome}</div>
                          {m.cautelas_ativas ? <div className="text-muted" style={{fontSize:'.66rem'}}>{m.cautelas_ativas} caut.</div> : null}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          })}
      </div>
      {onAlocar && <button className="aloc-btn" onClick={onAlocar}><Icon name="userPlus" size={14}/> Alocar profissionais</button>}
    </div>
  )
}

// Arraste no Kanban de Obras: mexe na tela antes da resposta (sensação de Trello); a recarga logo
// depois acerta totais e cautelas — e desfaz se o servidor recusar.
const porNomeKb = (a, b) => (a.nome || '').localeCompare(b.nome || '', 'pt')
function moverPessoaNoPanorama(bs, pid, tipo, destino) {
  let pessoa = null
  const tira = lista => lista.filter(m => { if (m.id !== pid) return true; pessoa = m; return false })
  // A mesma pessoa pode aparecer em dois lugares (Volantes do engenheiro + obra sem engenheiro): sai de todos.
  const sem = bs.map(b => ({ ...b, volantes: tira(b.volantes), obras: b.obras.map(o => ({ ...o, membros: tira(o.membros) })) }))
  if (!pessoa) return bs
  return sem.map(b => tipo === 'vol'
    ? (!b.sem_engenheiro && b.lider_id === destino ? { ...b, volantes: [...b.volantes, pessoa].sort(porNomeKb) } : b)
    : { ...b, obras: b.obras.map(o => o.id === destino ? { ...o, membros: [...o.membros, pessoa].sort(porNomeKb) } : o) })
}

function KanbanObrasPage({ user, addToast }) {
  const [blocos, setBlocos] = useState([])
  const [loading, setLoading] = useState(true)
  const [busca, setBusca] = useState('')
  const [alocar, setAlocar] = useState(null)   // obra aberta no modal de alocação
  const podeAlocar = !user.ceo && !user.tour && (user.is_master || ['diretor', 'gerente'].includes(user.role))
  const load = () => GET('/obras/panorama').then(b => setBlocos(b || [])).catch(e => addToast(e.message, 'error')).finally(() => setLoading(false))
  useEffect(() => { load() }, [])

  // Colunas que recebem arraste: 'obra:<id>' (obra com engenheiro), 'vol:<engenheiro>' (Volantes) e
  // 'eng:<engenheiro>' (o quadro inteiro, alvo da obra sem engenheiro — só do mesmo contrato).
  const blocoDe = id => blocos.find(b => !b.sem_engenheiro && b.lider_id === id)
  const aceita = (d, k) => {
    const [tipo, v] = k.split(':'); const id = Number(v)
    if (d.tipo === 'obra') return tipo === 'eng' && (blocoDe(id) || {}).contrato_id === d.contrato
    if (tipo === 'obra') return id !== d.obraId
    if (tipo === 'vol') return !!d.obraId && id === d.liderId
    return false
  }
  const soltar = async (d, k) => {
    const [tipo, v] = k.split(':'); const id = Number(v)
    try {
      if (d.tipo === 'obra') {
        setBlocos(bs => bs.map(b => b.sem_engenheiro ? { ...b, obras: b.obras.filter(o => o.id !== d.id) }
          : b.lider_id === id ? { ...b, obras: [...b.obras, d.obra].sort(porNomeKb) } : b).filter(b => !b.sem_engenheiro || b.obras.length))
        const r = await POST(`/obras/${d.id}/engenheiro`, { lider_id: id })
        addToast(`${d.nome} agora é do eng. ${r.lider_nome}${r.operarios_movidos ? ` — ${r.operarios_movidos} profissional(is) foram junto` : ''}.`, 'success')
      } else if (tipo === 'obra') {
        const destino = blocos.find(b => b.obras.some(o => o.id === id)) || {}
        const nomeObra = ((destino.obras || []).find(o => o.id === id) || {}).nome || 'a obra'
        setBlocos(bs => moverPessoaNoPanorama(bs, d.id, 'obra', id))
        await POST(`/obras/${id}/alocar`, { colaboradores: [d.id] })
        addToast(`${d.nome} → ${nomeObra}${d.liderId !== destino.lider_id ? ` (passa para ${destino.lider_nome})` : ''}.`, 'success')
      } else {
        setBlocos(bs => moverPessoaNoPanorama(bs, d.id, 'vol', id))
        await POST(`/obras/${d.obraId}/desalocar`, { colaborador_id: d.id })
        addToast(`${d.nome} saiu da obra — fica como Volante.`, 'success')
      }
    } catch (e) { addToast(e.message, 'error') }
    load()
  }
  const arraste = useArrastar({ aceita, onSoltar: soltar })
  const emArraste = arraste.arrastando
  const estadoDe = k => !emArraste ? null : arraste.alvo === k ? 'sobre' : aceita(emArraste, k) ? 'pode' : null
  const pessoaArrastada = emArraste && emArraste.tipo === 'pessoa' ? emArraste.id : null
  const itemPessoa = (b, obraId) => podeAlocar ? m => arraste.item({ tipo: 'pessoa', id: m.id, nome: m.nome, obraId, liderId: b.lider_id || null }) : null

  if (loading) return <div style={{padding:24,color:'var(--text-secondary)'}}>Carregando obras…</div>

  const q = busca.trim().toLowerCase()
  const filtrados = q
    ? blocos.filter(b => casaBusca(q, b.lider_nome) || b.obras.some(o => casaBusca(q, o.nome, o.codigo)))
    : blocos
  const totObras = blocos.reduce((s,b)=>s+b.obras.length,0)
  const totColab = blocos.reduce((s,b)=>s+b.obras.reduce((a,o)=>a+o.membros.length,0)+b.volantes.length,0)

  return (
    <div>
      <div className="topbar"><h2>Kanban de Obras</h2></div>
      <p className="text-muted" style={{margin:'-6px 0 12px',fontSize:'.84rem'}}>{podeAlocar
        ? <>Visão consolidada dos quadros de obras dos engenheiros e líderes. <b>Arraste</b> o profissional para outra obra e a obra sem engenheiro até o quadro de um engenheiro — no celular, segure o card por um instante e arraste. <b>Alocar profissionais</b> põe vários de uma vez.</>
        : 'Visão consolidada de todos os quadros de obras dos engenheiros e líderes. Somente leitura.'}</p>
      <div className="stats-grid" style={{marginBottom:14,display:'flex',gap:12,flexWrap:'wrap'}}>
        <div className="stat-card blue"><div className="stat-label">Responsáveis</div><div className="stat-value">{blocos.filter(b => !b.sem_engenheiro).length}</div></div>
        <div className="stat-card"><div className="stat-label">Obras ativas</div><div className="stat-value">{totObras}</div></div>
        <div className="stat-card"><div className="stat-label">Colaboradores</div><div className="stat-value">{totColab}</div></div>
      </div>
      <input style={{width:'100%',maxWidth:420,padding:'8px 12px',border:'1px solid var(--border,#e5e7eb)',borderRadius:8,marginBottom:14,fontSize:'.9rem'}} placeholder="Buscar por engenheiro, obra ou código…" value={busca} onChange={e=>setBusca(e.target.value)} />

      {filtrados.length===0 && <div className="card"><div className="empty"><p>Nenhum quadro de obras para mostrar.</p></div></div>}
      {filtrados.map(b => {
        const chaveEng = b.sem_engenheiro ? undefined : `eng:${b.lider_id}`
        const estBloco = chaveEng && emArraste && emArraste.tipo === 'obra' ? estadoDe(chaveEng) : null
        // Volantes aparece vazio enquanto alguém da obra DESTE engenheiro está na mão — para soltar lá.
        const mostraVolantes = b.volantes.length > 0 || (!b.sem_engenheiro && emArraste && emArraste.tipo === 'pessoa' && !!emArraste.obraId && emArraste.liderId === b.lider_id)
        return (
        <div key={b.lider_id || 'sem-eng'} className="card" data-drop={chaveEng}
          style={{marginBottom:16, padding:14, ...(b.sem_engenheiro ? {borderColor:'var(--tag-alerta-bd)'} : {}),
            ...(estBloco ? {outline:`2px ${estBloco==='sobre'?'solid':'dashed'} var(--primary-accent)`,outlineOffset:-1} : {}),
            ...(estBloco==='sobre' ? {background:'var(--tag-aco-bg)'} : {})}}>
          <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:10,flexWrap:'wrap'}}>
            {b.sem_engenheiro
              ? <span style={{width:34,height:34,borderRadius:'50%',background:'var(--fill-alerta)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center'}}><Icon name="alertTriangle" size={16}/></span>
              : <span style={{width:34,height:34,borderRadius:'50%',background:'var(--fill-navy)',color:'#fff',fontWeight:700,fontSize:'.8rem',display:'flex',alignItems:'center',justifyContent:'center'}}>{iniciais(b.lider_nome)}</span>}
            <div>
              <div style={{fontWeight:700,fontSize:'1rem'}}>{b.lider_nome}</div>
              <div className="text-muted" style={{fontSize:'.76rem'}}>{b.sem_engenheiro
                ? (podeAlocar
                  ? <>{b.obras.length} obra(s) · arraste a obra até o quadro de um engenheiro (ou defina em <b>Obras</b>)</>
                  : <>{b.obras.length} obra(s) · defina o engenheiro na tela <b>Obras</b> para alocar a equipe</>)
                : <>{b.atua_engenheiro ? 'Líder · atua como engenheiro' : (ROLE_LABEL[b.lider_role]||b.lider_cargo||'Responsável')} · {b.obras.length} obra(s)</>}</div>
            </div>
            {estBloco==='sobre' && <span style={{marginLeft:'auto',fontSize:'.76rem',fontWeight:700,color:'#fff',background:'var(--primary-accent)',borderRadius:999,padding:'4px 11px'}}>Soltar: {emArraste.nome} passa para {b.lider_nome}</span>}
          </div>
          <div data-drag-scroll style={{display:'flex',gap:12,overflowX:'auto',paddingBottom:8,alignItems:'flex-start'}}>
            {b.obras.map(o => {
              const chave = b.sem_engenheiro ? undefined : `obra:${o.id}`
              const origem = emArraste && emArraste.tipo === 'obra' && emArraste.id === o.id
              return (
                <KanbanLane key={o.id} titulo={o.nome} sub={`${o.membros.length} colab.${o.total_cautelas?` · ${o.total_cautelas} caut.`:''}`} membros={o.membros} icon="building"
                  drop={chave} estado={origem ? 'origem' : (emArraste && emArraste.tipo === 'pessoa' && chave ? estadoDe(chave) : null)}
                  arrastavel={podeAlocar && b.sem_engenheiro ? arraste.item({ tipo: 'obra', id: o.id, nome: o.nome, contrato: o.contrato_id, obra: o }) : null}
                  itemPessoa={itemPessoa(b, o.id)} pessoaArrastada={pessoaArrastada}
                  onAlocar={podeAlocar && !b.sem_engenheiro ? () => setAlocar(o) : null} />
              )
            })}
            {mostraVolantes && <KanbanLane titulo="Volantes" sub={`${b.volantes.length} sem obra`} membros={b.volantes} icon="users" semObra
              drop={`vol:${b.lider_id}`} estado={emArraste && emArraste.tipo === 'pessoa' ? estadoDe(`vol:${b.lider_id}`) : null}
              itemPessoa={itemPessoa(b, null)} pessoaArrastada={pessoaArrastada} />}
            {b.obras.length===0 && !mostraVolantes && <div className="text-muted" style={{fontSize:'.8rem',padding:12}}>{podeAlocar
              ? <>Nenhuma obra atribuída ainda — arraste uma obra sem engenheiro até aqui, ou defina em <b>Obras</b> → Engenheiro responsável.</>
              : <>Nenhuma obra atribuída ainda — defina em <b>Obras</b> → Engenheiro responsável.</>}</div>}
          </div>
        </div>
        )
      })}
      {alocar && <AlocarObraModal obra={alocar} addToast={addToast} onClose={mudou => { setAlocar(null); if (mudou) load() }} />}
    </div>
  )
}

// ─── MINHA EQUIPE (líder) — colaborador volátil + transferência com aceite ─────
function EquipePage({ user, addToast }) {
  const [data, setData] = useState({ membros: [], pendentes_recebimento: [], pendentes_envio: [], total_valor: 0, total_cautelas: 0 })
  const [obras, setObras] = useState([])
  const [lideres, setLideres] = useState([])
  const [openId, setOpenId] = useState(null)
  const [detalhe, setDetalhe] = useState({})
  const [mov, setMov] = useState({ obra_id: '', para_lider_id: '' })
  const [busy, setBusy] = useState(false)

  const load = () => GET('/equipe').then(setData).catch(e=>addToast(e.message,'error'))
  useEffect(() => {
    load()
    GET('/obras').then(setObras).catch(()=>{})
    // Transferência com registro é engenheiro→engenheiro — só engenheiros entram como destino.
    GET('/usuarios/lideres?role=engenheiro').then(setLideres).catch(()=>{})
  }, [])

  const lideresDisp = lideres.filter(l => l.id !== user.id)
  // Equipe não cruza contratos: o "Mover" só oferece obra e engenheiro do contrato do colaborador (outro
  // contrato é a troca de contrato em Usuários). Sem contrato_id (resposta antiga), não filtra.
  const doContrato = (m, x) => !m.contrato_id || x.contrato_id == null || x.contrato_id === m.contrato_id

  // Agrupa a equipe por função/cargo — indicadores por função + lista por seção.
  const grupos = {}
  for (const m of data.membros) { const k = (m.cargo && m.cargo.trim()) || 'Sem função'; (grupos[k] = grupos[k] || []).push(m) }
  const gruposOrd = Object.keys(grupos).sort((a,b)=>a.localeCompare(b,'pt'))

  const toggle = (m) => {
    if (openId === m.id) { setOpenId(null); return }
    setOpenId(m.id)
    setMov({ obra_id: m.obra_id || '', para_lider_id: '' })
  }

  const mover = async (m) => {
    setBusy(true)
    try {
      // Passando para outro engenheiro, a obra é dele (quem recebe aloca) — não vai obra minha junto.
      const r = await POST('/equipe/mover', { colaborador_id: m.id, obra_id: mov.para_lider_id ? null : (mov.obra_id || null), para_lider_id: mov.para_lider_id || null })
      if (r.pendente) addToast(`Transferência enviada — aguardando ${r.para_lider_nome} confirmar o recebimento.`, 'warning')
      else addToast('Colaborador movido de obra.', 'success')
      setOpenId(null); load()
    } catch(e) { addToast(e.message,'error') } finally { setBusy(false) }
  }

  const responder = async (t, acao) => {
    try {
      await POST(`/equipe/transferencias/${t.id}/${acao}`)
      addToast(acao==='aceitar' ? `${t.colaborador_nome} entrou na sua equipe.` : 'Transferência recusada.', acao==='aceitar'?'success':'warning')
      load()
    } catch(e) { addToast(e.message,'error') }
  }
  const cancelarEnvio = async (t) => {
    try { await POST(`/equipe/transferencias/${t.id}/cancelar`); addToast('Transferência cancelada.','warning'); load() }
    catch(e){ addToast(e.message,'error') }
  }

  return (
    <div className="eq-wrap">
      <div className="topbar"><h2>Minha equipe</h2></div>
      <p className="eq-lead">Gestão à vista da sua equipe — quem está em cada obra e o que cada colaborador tem em campo. O responsável direto por cada ferramenta é o colaborador que a retirou, até a devolução ao almoxarifado.</p>

      {/* Resumo: total em destaque + distribuição por função em chips */}
      <div className="eq-summary">
        <div className="eq-total">
          <span className="eq-total-n">{data.membros.length}</span>
          <span className="eq-total-l">colaboradores<br/>na sua equipe</span>
        </div>
        {gruposOrd.length > 0 && (
          <div className="eq-funcs">
            {gruposOrd.map(g => <span key={g} className="eq-func-chip"><b>{grupos[g].length}</b>{g}</span>)}
          </div>
        )}
      </div>

      {data.pendentes_recebimento.length > 0 && (
        <div className="eq-panel recebe">
          <div className="eq-panel-hd"><Icon name="handshake" size={15}/> Recebimentos pendentes <span className="c">{data.pendentes_recebimento.length}</span></div>
          {data.pendentes_recebimento.map(t => (
            <div key={t.id} className="eq-trow">
              <div className="who">
                <span className="eq-nm" style={{display:'inline'}}><b>{t.colaborador_nome}</b></span> <span className="text-muted">de {t.de_lider_nome||'—'}</span>
                <div className="sub">{t.posse.cautelas} cautela(s) · {fmtBRL(t.posse.valor)}{t.obra_nome ? ` · vai p/ ${t.obra_nome}` : ''}</div>
              </div>
              <div className="gap-8">
                <button className="btn btn-ghost btn-sm" onClick={()=>responder(t,'recusar')}>Recusar</button>
                <button className="btn btn-primary btn-sm" onClick={()=>responder(t,'aceitar')}><Icon name="check" size={14}/> Aceitar</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {data.pendentes_envio.length > 0 && (
        <div className="eq-panel">
          <div className="eq-panel-hd">Aguardando aceite do outro líder <span className="c">{data.pendentes_envio.length}</span></div>
          {data.pendentes_envio.map(t => (
            <div key={t.id} className="eq-trow">
              <div className="who"><b>{t.colaborador_nome}</b> <span className="arrow">→</span> <b>{t.para_lider_nome}</b>{t.obra_nome?<span className="text-muted"> · {t.obra_nome}</span>:''}</div>
              <button className="btn btn-ghost btn-sm" onClick={()=>cancelarEnvio(t)}>Cancelar</button>
            </div>
          ))}
        </div>
      )}

      {data.membros.length === 0 ? (
        <div className="eq-group"><div className="eq-empty">
          <div className="ei"><Icon name="users" size={26}/></div>
          <p style={{fontWeight:600,color:'var(--ink)'}}>Nenhum colaborador na sua equipe ainda.</p>
          <p style={{fontSize:'.82rem',marginTop:4}}>Quem é alocado nas suas obras entra na sua equipe (o Gerente ou o Diretor aloca pelo Kanban de Obras). Operário sem equipe que recebe uma cautela sua também entra.</p>
        </div></div>
      ) : (
        <div className="eq-list">
          {gruposOrd.map(g => (
            <div key={g} className="eq-group">
              <div className="eq-group-hd"><span className="eq-group-t">{g}</span><span className="eq-group-c">{grupos[g].length}</span></div>
              {grupos[g].map(m => (
                <div key={m.id} className={`eq-member ${openId===m.id?'open':''}`}>
                  <button className="eq-member-hd" onClick={()=>toggle(m)}>
                    <span className="eq-av">{iniciais(m.nome)}</span>
                    <div className="eq-id">
                      <div className="eq-nm">{m.nome}</div>
                      <div className="eq-meta"><Icon name="building" size={12}/> {m.obra_nome || 'Volante'}</div>
                    </div>
                    <span className="eq-chev"><Icon name="chevronRight" size={16}/></span>
                  </button>
                  {openId === m.id && (
                    <div className="eq-acc">
                      <div className="form-grid">
                        <div className="form-group"><label>Mover para obra</label>
                          <select value={mov.para_lider_id ? '' : mov.obra_id} disabled={!!mov.para_lider_id} onChange={e=>setMov({...mov, obra_id:e.target.value})}>
                            <option value="">{mov.para_lider_id ? 'Quem recebe escolhe a obra' : 'Volantes'}</option>
                            {obras.filter(o=>doContrato(m, o)).map(o=><option key={o.id} value={o.id}>{o.nome}{o.codigo?` (${o.codigo})`:''}</option>)}
                          </select>
                        </div>
                        <div className="form-group"><label>Passar para outro engenheiro (opcional)</label>
                          <select value={mov.para_lider_id} onChange={e=>setMov({...mov, para_lider_id:e.target.value})}>
                            <option value="">Manter na minha equipe</option>
                            {lideresDisp.filter(l=>doContrato(m, l)).map(l=><option key={l.id} value={l.id}>{l.nome}</option>)}
                          </select>
                        </div>
                      </div>
                      {mov.para_lider_id && <p className="text-muted" style={{fontSize:'.8rem',margin:'8px 0 0',display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={13}/> O colaborador só migra quando o líder que recebe confirmar o recebimento.</p>}
                      <div style={{marginTop:12,justifyContent:'flex-end',display:'flex',gap:8}}>
                        <button className="btn btn-ghost btn-sm" onClick={()=>setOpenId(null)}>Cancelar</button>
                        <button className="btn btn-primary btn-sm" disabled={busy} onClick={()=>mover(m)}><Icon name={mov.para_lider_id?'handshake':'check'} size={14}/> {mov.para_lider_id?'Enviar transferência':'Salvar obra'}</button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// ─── AUDITORIA DA EQUIPE (líder) — histórico só dos colaboradores dele ─────────
function EquipeAuditoriaPage({ addToast }) {
  const [ev, setEv] = useState(null)
  useEffect(()=>{ GET('/equipe/auditoria').then(setEv).catch(e=>{ addToast(e.message,'error'); setEv([]) }) }, [])
  const icone = t => t==='recebeu' ? 'package' : t==='devolveu' ? 'undo' : t==='transferencia' ? 'handshake' : 'history'
  const cor   = t => t==='recebeu' ? '#A07C4E' : t==='devolveu' ? '#4A90A4' : '#6b7280'
  return (
    <div style={{maxWidth:760,margin:'0 auto'}}>
      <div className="topbar"><h2>Auditoria da equipe</h2></div>
      <p className="text-muted" style={{margin:'-6px 0 14px',fontSize:'.84rem'}}>Histórico de retiradas, devoluções e transferências dos colaboradores da sua equipe.</p>
      <div className="card">
        {ev===null ? <p className="text-muted" style={{padding:12}}>Carregando…</p> :
         ev.length===0 ? <div className="empty"><div className="empty-icon"><Icon name="history" size={32}/></div><p>Sem movimentações registradas ainda.</p></div> :
         ev.map((e,i)=>(
          <div key={i} style={{display:'flex',gap:12,alignItems:'flex-start',padding:'10px 2px',borderBottom:'1px solid var(--border,#eee)'}}>
            <span style={{marginTop:2,color:cor(e.tipo),flexShrink:0}}><Icon name={icone(e.tipo)} size={16}/></span>
            <div style={{flex:1}}>
              <div style={{fontSize:'.88rem'}}><strong>{e.colaborador_nome}</strong> {e.descricao}{e.ref?` · ${e.ref}`:''}</div>
              <div className="text-muted" style={{fontSize:'.76rem'}}>{(e.data||'').slice(0,16)}{e.valor?` · ${fmtBRL(e.valor)}`:''}</div>
            </div>
          </div>
         ))}
      </div>
    </div>
  )
}

// ─── MINHA EQUIPE — visão clara e escopada da equipe (somente leitura) ──────────
// Para o Gerente de Contrato multicontrato (Cesar · Costellation): quem está no time,
// com perfil, função (cargo), obra e contato — agrupado por perfil. Os dados já vêm
// escopados pelo /api/usuarios (só as contas dos contratos dele). Para gestão (criar/
// editar/redefinir senha) ele usa a aba Usuários; aqui é leitura organizada.
function MinhaEquipePage({ user, addToast }) {
  const [lista, setLista] = useState([])
  const [obras, setObras] = useState([])
  const [q, setQ] = useState('')
  useEffect(() => {
    GET('/usuarios').then(setLista).catch(() => {})
    GET('/obras').then(setObras).catch(() => {})
  }, [])
  const obraNome = id => { const o = obras.find(o => String(o.id) === String(id)); return o ? o.nome : null }
  const nomeDe = id => { const u = lista.find(x => String(x.id) === String(id)); return u ? u.nome : null }
  const iniciais = n => (n || '?').trim().split(/\s+/).slice(0, 2).map(w => w[0] || '').join('').toUpperCase()
  // Ordem hierárquica de exibição (topo → base). Perfis fora da lista vão ao fim.
  const ORDEM = ['gerente', 'engenheiro', 'lider', 'operario', 'apontador', 'logistica', 'almoxarife2', 'condutor', 'motorista', 'administracao', 'compras', 'auxiliar', 'almoxarifado']
  const termo = q.trim().toLowerCase()
  const bate = u => casaBusca(termo, u.nome, u.cargo, ROLE_LABEL[u.role], obraNome(u.obra_id))
  const filtrada = lista.filter(bate)
  const rolesPresentes = [...new Set(filtrada.map(u => u.role))].sort((a, b) => {
    const ia = ORDEM.indexOf(a), ib = ORDEM.indexOf(b)
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib)
  })
  const grupos = rolesPresentes.map(r => ({
    role: r, label: ROLE_LABEL[r] || r,
    pessoas: filtrada.filter(u => u.role === r).sort((a, b) => (a.nome || '').localeCompare(b.nome || ''))
  }))
  const totalPessoas = lista.length
  const totalAtivos = lista.filter(u => u.ativo).length
  const av = { width: 40, height: 40, borderRadius: 10, flex: '0 0 auto', display: 'grid', placeItems: 'center', fontWeight: 700, fontSize: '.85rem', color: '#fff', background: 'linear-gradient(150deg,var(--primary-light),var(--primary-accent))' }
  const cardPessoa = u => (
    <div key={u.id} style={{ display: 'flex', gap: 12, padding: 14, border: '1px solid var(--border)', borderRadius: 12, background: 'var(--card)', opacity: u.ativo ? 1 : .6 }}>
      <div style={av}>{iniciais(u.nome)}</div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 700, color: 'var(--text)' }}>{u.nome}</span>
          {!u.ativo && <span className="badge badge-devolvida" style={{ fontSize: '.6rem', padding: '1px 7px' }}>Inativo</span>}
        </div>
        <div style={{ marginTop: 5, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span className={`badge badge-${u.role}`}>{ROLE_LABEL[u.role] || u.role}</span>
          {u.cargo && u.cargo.trim() && <span style={{ fontSize: '.8rem', color: 'var(--text-secondary)' }}>{u.cargo}</span>}
        </div>
        {obraNome(u.obra_id) && <div style={{ fontSize: '.78rem', color: 'var(--text-secondary)', marginTop: 6, display: 'inline-flex', alignItems: 'center', gap: 5 }}><Icon name="building" size={13} /> {obraNome(u.obra_id)}</div>}
        {u.role === 'operario' && nomeDe(u.lider_id) && <div style={{ fontSize: '.76rem', color: 'var(--text-secondary)', marginTop: 3, display: 'inline-flex', alignItems: 'center', gap: 5 }}><Icon name="users" size={13} /> Líder: {nomeDe(u.lider_id)}</div>}
        {u.telefone && u.telefone.trim() && <div style={{ fontSize: '.76rem', color: 'var(--text-secondary)', marginTop: 3, display: 'inline-flex', alignItems: 'center', gap: 5 }}><Icon name="phone" size={13} /> {u.telefone}</div>}
      </div>
    </div>
  )
  return (
    <div style={{ maxWidth: 900, margin: '0 auto' }}>
      <div className="topbar"><h2>Minha Equipe</h2></div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
        <div style={{ flex: '1 1 150px', minWidth: 130, background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: '12px 16px' }}>
          <div style={{ fontSize: '1.7rem', fontWeight: 800, color: 'var(--primary-accent)', lineHeight: 1 }}>{totalPessoas}</div>
          <div style={{ fontSize: '.78rem', color: 'var(--text-secondary)', marginTop: 4 }}>pessoas na equipe</div>
        </div>
        <div style={{ flex: '1 1 150px', minWidth: 130, background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: '12px 16px' }}>
          <div style={{ fontSize: '1.7rem', fontWeight: 800, color: 'var(--success)', lineHeight: 1 }}>{totalAtivos}</div>
          <div style={{ fontSize: '.78rem', color: 'var(--text-secondary)', marginTop: 4 }}>ativos</div>
        </div>
        <div style={{ flex: '1 1 150px', minWidth: 130, background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: '12px 16px' }}>
          <div style={{ fontSize: '1.7rem', fontWeight: 800, color: 'var(--accent)', lineHeight: 1 }}>{grupos.length}</div>
          <div style={{ fontSize: '.78rem', color: 'var(--text-secondary)', marginTop: 4 }}>{grupos.length === 1 ? 'perfil' : 'perfis distintos'}</div>
        </div>
      </div>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-body" style={{ padding: 12 }}>
          <div style={{ position: 'relative' }}>
            <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)', display: 'inline-flex' }}><Icon name="search" size={16} /></span>
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Buscar por nome, função, perfil ou obra..." style={{ paddingLeft: 36 }} />
          </div>
        </div>
      </div>
      {grupos.length === 0 ? (
        <div className="empty"><div className="empty-icon"><Icon name="worker" size={32} /></div><p>{termo ? 'Ninguém encontrado com esse termo.' : 'Nenhuma pessoa na sua equipe ainda.'}</p></div>
      ) : grupos.map(g => (
        <div key={g.role} style={{ marginBottom: 22 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
            <h3 style={{ fontSize: '.95rem', fontWeight: 700, color: 'var(--text)', margin: 0 }}>{g.label}</h3>
            <span style={{ fontSize: '.72rem', fontWeight: 700, color: 'var(--text-secondary)', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 20, padding: '2px 10px' }}>{g.pessoas.length}</span>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(min(250px,100%),1fr))', gap: 12 }}>
            {g.pessoas.map(cardPessoa)}
          </div>
        </div>
      ))}
    </div>
  )
}

// ─── USUÁRIOS ─────────────────────────────────────────────────────────────────
// Contratos para os cadastros (Usuários, Obras) de quem cruza contratos — Master, Diretor e Gerente
// multicontrato. Com 2+ contratos o cadastro ganha o campo Contrato (sem ele, a conta/obra caía sempre no
// contrato de quem cadastrou — não dava para criar o engenheiro da Costellation pela tela). Um só: nada muda.
// O almoxarifado também recebe a lista: ele atende ferramentas, bolsas, solicitações e cautelas de TODOS os
// contratos (a Sede atende a Costellation) — etiqueta, filtro e o contrato do acervo novo.
function useContratosCadastro(user) {
  const [contratos, setContratos] = useState([])
  useEffect(() => { if (cruzaContratos(user) || (user && user.role === 'almoxarifado')) GET('/contratos').then(d => setContratos((d && d.contratos) || [])).catch(() => {}) }, [])
  const multi = contratos.length > 1
  // Conta/obra antiga sem contrato = contrato principal (o 1º criado), como no servidor.
  const principal = contratos.length ? Math.min(...contratos.map(c => c.id)) : null
  const de = x => (x && x.contrato_id) || principal
  const nome = id => ((contratos.find(c => c.id === id) || {}).nome) || ''
  const cor = id => { const i = contratos.findIndex(c => c.id === id); return i < 0 ? 'var(--silver)' : corContrato(contratos[i], i) }
  const base = id => ((contratos.find(c => c.id === id) || {}).deposito_nome) || null   // depósito de base (Almoxarife 2)
  return { contratos, multi, principal, de, nome, cor, base }
}
// compacta: no celular só a cor (listas de Usuários/Obras/Ferramentas, em que o nome da linha tem prioridade).
function ContratoTag({ ct, id, compacta }) {
  if (!ct.multi || !id) return null
  return <span className={'text-muted ct-tag' + (compacta ? ' ct-tag-compacta' : '')} style={{display:'inline-flex',alignItems:'center',gap:5,fontSize:'.68rem',fontWeight:600,whiteSpace:'nowrap',marginLeft:6,flex:'none'}} title={'Contrato: ' + ct.nome(id)}><span style={{width:8,height:8,borderRadius:2,background:ct.cor(id),flex:'none'}}/><span className="ct-tag-nome">{ct.nome(id)}</span></span>
}

// Hierarquia de contas na tela de Usuários — espelha o servidor (rolesGerenciaveis e as travas do PUT, do
// DELETE e do redefinir-senha em /usuarios). Botão que o servidor recusa não aparece: o Gerente multicontrato
// via os 13 perfis, Excluir/Redefinir senha num outro Gerente e Salvar na própria conta — tudo dava 403.
// Perfis que este usuário pode criar/gerenciar. Diretor: só um nível abaixo (Gerente/líder/operário).
// Gerente: a equipe operacional do conjunto dele (Engenheiro/líder/operário). Almox: todos os operacionais.
// Master: todos, INCLUSIVE o próprio Almoxarifado (perfil totalmente editável só pelo Master).
function perfisGerenciaveis(user) {
  if (user.role === 'diretor')
    return [{ v:'gerente', l:'Gerente de Contrato' }, { v:'engenheiro', l:'Engenheiro' }, { v:'lider', l:'Líder' }, { v:'operario', l:'Operário' }]
  if (user.role === 'gerente')
    return [{ v:'engenheiro', l:'Engenheiro' }, { v:'lider', l:'Líder' }, { v:'operario', l:'Operário' }]
  return [...(user.is_master ? [{ v:'almoxarifado', l:'Almoxarifado' }] : []), { v:'administracao', l:'Administração' }, { v:'compras', l:'Compras' }, { v:'diretor', l:'Diretor de Operações' }, { v:'auxiliar', l:'Auxiliar Técnica' }, { v:'gerente', l:'Gerente de Contrato' }, ...(user.is_master ? [{ v:'ceo', l:'CEO (somente leitura)' }] : []), { v:'engenheiro', l:'Engenheiro' }, { v:'lider', l:'Líder' }, { v:'operario', l:'Operário' }, { v:'logistica', l:'Logística' }, { v:'almoxarife2', l:'Almoxarife 2 (depósito de base)' }, { v:'condutor', l:'Motorista' }, { v:'motorista', l:'Ajudante de motorista' }, { v:'apontador', l:'Apontador' }]
}
const gerenciaPerfil = (user, u) => perfisGerenciaveis(user).some(p => p.v === u.role)
// Salvar (PUT): Master e Almoxarifado alteram qualquer conta (a do Master, só o Master de verdade); Diretor e
// Gerente, só os perfis que gerenciam — a própria conta do Gerente e a de outro Gerente abrem só para leitura.
// Conta nova: o seletor de perfil já só oferece o que ele cria.
function contaAlteravel(user, u) {
  if (!u || !u.id) return true
  if (u.is_master && !(user.is_master && !user.admin)) return false
  return !!user.is_master || user.role === 'almoxarifado' || gerenciaPerfil(user, u)
}
// Redefinir senha: só quem gerencia aquele perfil, nunca a própria conta.
// Admin redefine senha de todos, menos a conta master de verdade (só outro Master faz isso).
const contaRedefinivel = (user, u) => !!(u && u.id && u.id !== user.id && (!u.is_master || (user.is_master && !user.admin)) && gerenciaPerfil(user, u))
// Excluir: nunca a master nem a própria; almoxarifado só o Master; Diretor/Gerente só os perfis que gerenciam.
// Admin exclui usuários, menos CEO, Diretor, Auxiliar Técnica e outro Admin (espelha o backend).
const ADMIN_NAO_EXCLUI = ['ceo', 'diretor', 'auxiliar']
const contaExcluivel = (user, u) => !!(u && u.id && !u.is_master && u.id !== user.id && (u.role !== 'almoxarifado' || user.is_master)
  && contaAlteravel(user, u) && !(user.admin && (u.is_admin || ADMIN_NAO_EXCLUI.includes(u.role))))
// Quem altera a conta que ele só consulta (a linha do painel em modo leitura). Na tela, a aba Usuários é do
// Master e do Diretor (o Almoxarifado comum não a tem).
const quemAlteraConta = u => ['gerente', 'engenheiro', 'lider', 'operario'].includes(u.role) && !u.is_master
  ? 'pelo Diretor de Operações ou pelo administrador master' : 'pelo administrador master'

function UsuariosPage({ user, addToast, openTarget, clearOpenTarget }) {
  const [lista, setLista] = useState([])
  const [obras, setObras] = useState([])
  const [lideres, setLideres] = useState([])
  const [openId, setOpenId] = useState(null)
  const [form, setForm] = useState({})
  // Card do painel: perfil vai para o seletor; contrato/ativos/sem obra/função ficam na faixa "Mostrando".
  const [filtroP, setFiltroP] = useState(() => filtroDoAlvo(openTarget, 'usuarios'))
  const [filtroRole, setFiltroRole] = useState(() => (filtroDoAlvo(openTarget, 'usuarios') || {}).role || '')
  const [confirmDel, setConfirmDel] = useState(false)
  const [confirmReset, setConfirmReset] = useState(false)
  const [resetResult, setResetResult] = useState(null)  // { nome, senha } após redefinir
  const ct = useContratosCadastro(user)
  const [filtroCt, setFiltroCt] = useState('')   // filtro da lista por contrato (só com 2+ contratos)
  // Perfis que este usuário pode criar/gerenciar (espelha a hierarquia do backend; ver perfisGerenciaveis).
  const perfisDisp = perfisGerenciaveis(user)
  // Filtro da lista: os perfis que ele gerencia + os que aparecem na lista sem ele gerenciar (o Gerente vê a
  // própria conta e a dos outros gerentes do conjunto, só para consulta).
  const perfisFiltro = [...new Set(lista.map(u => u.role))].filter(r => !perfisDisp.some(p => p.v === r))
    .map(r => ({ v: r, l: ROLE_LABEL[r] || r })).concat(perfisDisp)
  const load = () => GET('/usuarios').then(setLista)
  useEffect(() => { load(); GET('/obras').then(setObras).catch(()=>{}); GET('/usuarios/lideres').then(setLideres).catch(()=>{}) }, [])
  // Responsável (ativo) da obra escolhida — define a equipe do operário.
  const respDaObra = id => { const o = id && obras.find(x => String(x.id) === String(id)); return (o && o.lider_id && lideres.find(l => l.id === o.lider_id)) || null }
  // Deep-link da busca: abre direto o painel da pessoa pedida.
  useEffect(() => {
    if (!openTarget || openTarget.page !== 'usuarios') return
    if (!openTarget.id) { clearOpenTarget && clearOpenTarget(); return }
    const u2 = lista.find(x => x.id === openTarget.id)
    if (u2) { setForm({ ...u2, senha: '' }); setConfirmDel(false); setConfirmReset(false); setResetResult(null); setFiltroRole(''); setOpenId(u2.id); clearOpenTarget && clearOpenTarget(); scrollPainelParaFoco() }
  }, [openTarget, lista])
  const abrirNovo = () => {
    // Novo usuário nasce no contrato em foco (filtro da lista ou card do painel); sem foco, no principal.
    const cid = Number(filtroCt) || (filtroP && filtroP.contrato) || ct.principal
    setForm({role:'operario',ativo:true, ...(ct.multi && cid ? { contrato_id: cid } : {})}); setConfirmDel(false); setConfirmReset(false); setResetResult(null); setOpenId('new')
  }
  // Trocar o contrato no formulário solta a obra/equipe que eram do outro contrato.
  const mudarContratoForm = v => setForm(f => {
    const cid = Number(v)
    const obraOk = !f.obra_id || ct.de(obras.find(o => String(o.id) === String(f.obra_id))) === cid
    const lidOk = !f.lider_id || ct.de(lideres.find(l => String(l.id) === String(f.lider_id))) === cid
    return { ...f, contrato_id: cid, ...(obraOk ? {} : { obra_id: '' }), ...(lidOk ? {} : { lider_id: '' }) }
  })
  const toggle = u => {
    if (openId === u.id) { fechar(); return }
    setForm({...u, senha:''}); setConfirmDel(false); setConfirmReset(false); setResetResult(null); setOpenId(u.id)
  }
  const fechar = () => { setOpenId(null); setConfirmDel(false); setConfirmReset(false); setResetResult(null) }
  // Redefinição de senha: o backend gera uma senha temporária e força a troca no
  // próximo acesso do titular (primeiro_acesso=1). O gestor apenas repassa a senha.
  const redefinirSenha = async () => {
    try {
      const r = await POST(`/usuarios/${form.id}/redefinir-senha`, {})
      setResetResult({ nome: r.nome || form.nome, senha: r.senha_temporaria })
      setConfirmReset(false); load()
    } catch(e) { addToast(e.message,'error') }
  }
  // Espelham a hierarquia do backend (ver contaRedefinivel / contaExcluivel / contaAlteravel).
  const podeRedefinir = u => contaRedefinivel(user, u)
  const podeExcluir = u => contaExcluivel(user, u)
  const save = async () => {
    if (!form.nome || !form.email) { addToast('Nome e email obrigatórios.','error'); return }
    if (!form.id && !form.senha) { addToast('Informe a senha.','error'); return }
    try {
      if (form.id) await PUT(`/usuarios/${form.id}`, form)
      else await POST('/usuarios', form)
      addToast(form.id?'Atualizado!':'Criado!','success'); fechar(); load()
    } catch(e) { addToast(e.message,'error') }
  }
  const del = async () => {
    try {
      const r = await DEL(`/usuarios/${form.id}`)
      const obras = r.obras_sem_engenheiro ? ` ${r.obras_sem_engenheiro} obra(s) ficaram sem engenheiro — defina em Obras.` : ''
      addToast((r.historico_preservado ? 'Usuário excluído. No histórico ele aparece como "(excluído)".' : 'Usuário excluído.') + obras,'success')
      fechar(); load()
    }
    catch(e) { addToast(e.message,'error') }
  }
  const noFiltroP = u => !filtroP || ((filtroP.contrato == null || u.contrato_id === filtroP.contrato) && (!filtroP.ativos || u.ativo)
    && (!filtroP.semObra || !u.obra_id) && (filtroP.cargo == null || (String(u.cargo || '').trim() || 'Sem função') === filtroP.cargo))
  const filtrados = lista.filter(u => (!filtroRole || u.role === filtroRole) && noFiltroP(u) && (!filtroCt || ct.de(u) === Number(filtroCt)))
  const painel = () => {
    // Obras e responsáveis oferecidos = os do contrato da conta (com 2+ contratos).
    const ctForm = ct.multi ? Number(form.contrato_id || ct.de(form)) : null
    const obrasForm = ctForm ? obras.filter(o => ct.de(o) === ctForm) : obras
    const lideresForm = ctForm ? lideres.filter(l => ct.de(l) === ctForm) : lideres
    // Conta que ele não altera (a própria do Gerente, outro Gerente): abre só para consulta — campos travados,
    // sem Salvar/Excluir/Redefinir e uma linha dizendo quem altera.
    const soLeitura = !contaAlteravel(user, form)
    // O perfil da conta aberta aparece no seletor mesmo quando ele não cria esse perfil (senão o seletor
    // travado mostraria "Engenheiro" na conta de um Gerente).
    const perfisForm = !form.role || perfisDisp.some(p => p.v === form.role) ? perfisDisp : [{ v: form.role, l: ROLE_LABEL[form.role] || form.role }, ...perfisDisp]
    const footer = soLeitura ? (
      <div className="gap-8" style={{marginLeft:'auto'}}><button className="btn btn-ghost btn-sm" onClick={fechar}>Fechar</button></div>
    ) : confirmDel ? (
      <div style={{display:'flex',alignItems:'center',gap:10,width:'100%',justifyContent:'space-between',flexWrap:'wrap'}}>
        <span style={{fontSize:'.85rem',color:'var(--danger)',fontWeight:600,display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={15}/> Excluir este usuário? Ele sai do sistema de vez; o histórico continua com o nome dele.</span>
        <div className="gap-8"><button className="btn btn-ghost btn-sm" onClick={()=>setConfirmDel(false)}>Não</button><button className="btn btn-danger btn-sm" onClick={del}>Sim, excluir</button></div>
      </div>
    ) : confirmReset ? (
      <div style={{display:'flex',alignItems:'center',gap:10,width:'100%',justifyContent:'space-between',flexWrap:'wrap'}}>
        <span style={{fontSize:'.85rem',color:'var(--warning)',fontWeight:600,display:'inline-flex',alignItems:'center',gap:6}}><Icon name="key" size={15}/> Gerar senha temporária? O usuário criará uma nova senha no próximo acesso.</span>
        <div className="gap-8"><button className="btn btn-ghost btn-sm" onClick={()=>setConfirmReset(false)}>Não</button><button className="btn btn-primary btn-sm" onClick={redefinirSenha}><Icon name="key" size={14}/> Sim, redefinir</button></div>
      </div>
    ) : (<>
      <div className="gap-8">
        {podeExcluir(form) && <button className="btn btn-danger btn-sm" onClick={()=>setConfirmDel(true)}><Icon name="trash" size={14}/> Excluir</button>}
        {podeRedefinir(form) && <button className="btn btn-ghost btn-sm" style={{borderColor:'var(--warning)',color:'var(--warning)'}} onClick={()=>{setResetResult(null);setConfirmReset(true)}}><Icon name="key" size={14}/> Redefinir senha</button>}
      </div>
      <div className="gap-8">
        <button className="btn btn-ghost btn-sm" onClick={fechar}>Cancelar</button>
        <button className="btn btn-primary btn-sm" onClick={save}><Icon name="check" size={14}/> Salvar</button>
      </div>
    </>)
    return (
      <PainelEdicao titulo={soLeitura ? 'Usuário' : form.id ? 'Editar usuário' : 'Novo usuário'} onFechar={fechar} footer={footer}>
        {soLeitura && (
          <div className="alert alert-info" style={{marginBottom:14,display:'flex',alignItems:'flex-start',gap:8,fontSize:'.82rem'}}>
            <span style={{flex:'none',marginTop:1}}><Icon name="lock" size={14}/></span>
            <span>Só consulta: {form.id === user.id ? 'a sua conta' : 'esta conta'} é alterada {quemAlteraConta(form)}.</span>
          </div>
        )}
        {resetResult && (
          <div className="alert" style={{marginBottom:14,borderLeft:'3px solid var(--warning)'}}>
            <div style={{fontWeight:700,marginBottom:8,display:'flex',alignItems:'center',gap:6}}><Icon name="key" size={15}/> Senha temporária de {resetResult.nome}</div>
            <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
              <code style={{fontFamily:'monospace',fontSize:'1.3rem',fontWeight:700,letterSpacing:'2px',background:'var(--bg)',padding:'8px 14px',borderRadius:6,border:'1px solid var(--border)'}}>{resetResult.senha}</code>
              <button type="button" className="btn btn-ghost btn-sm" onClick={()=>{try{navigator.clipboard.writeText(resetResult.senha);addToast('Senha copiada.','success')}catch(e){addToast('Copie manualmente.','error')}}}><Icon name="clipboard" size={14}/> Copiar</button>
            </div>
            <p className="text-muted" style={{fontSize:'.78rem',marginTop:8,lineHeight:1.4}}>Entregue esta senha ao usuário. No próximo login ele será obrigado a criar uma senha pessoal — você não fica com a senha real.</p>
          </div>
        )}
        {/* Só consulta: o fieldset desabilitado trava todos os campos de uma vez. */}
        <fieldset disabled={soLeitura} style={{border:0,margin:0,padding:0,minWidth:0}}>
        <div className="form-grid">
          <div className="form-group"><label>Nome *</label><input value={form.nome||''} onChange={e=>setForm({...form,nome:e.target.value})} /></div>
          <div className="form-group"><label>Email *</label><input type="email" value={form.email||''} onChange={e=>setForm({...form,email:e.target.value})} disabled={!!form.id} /></div>
          <div className="form-group"><label>Cargo</label><input value={form.cargo||''} onChange={e=>setForm({...form,cargo:e.target.value})} placeholder="Pedreiro, Eletricista..." autoComplete="off" /></div>
          <div className="form-group"><label>Perfil</label>
            <select value={form.role||'operario'} onChange={e=>setForm({...form,role:e.target.value})} disabled={!!form.id}>
              {perfisForm.map(p=><option key={p.v} value={p.v}>{p.l}</option>)}
            </select>
          </div>
          {ct.multi && !form.is_master && (
            <div className="form-group"><label>Contrato</label>
              <select value={ctForm || ''} onChange={e=>mudarContratoForm(e.target.value)}>
                {ct.contratos.map(c=><option key={c.id} value={c.id}>{c.nome}{c.ativo ? '' : ' (inativo)'}</option>)}
              </select>
              <span className="text-muted" style={{fontSize:'.72rem',marginTop:4,display:'block'}}>{['compras','administracao','diretor','auxiliar','ceo'].includes(form.role)
                ? 'Este perfil atende todos os contratos; aqui fica só o contrato de cadastro.'
                : form.role === 'almoxarifado'
                  ? 'Atende o REC deste contrato. Contrato sem almoxarifado próprio é atendido pelo almoxarifado do contrato principal (Sede).'
                  : form.role === 'almoxarife2'
                    ? (ct.base(ctForm) ? `Cuida do depósito ${ct.base(ctForm)} (base deste contrato), abastecido pela Sede.` : 'Este contrato ainda não tem depósito de base: defina na tela Contratos.')
                  : ['engenheiro','lider','gerente'].includes(form.role)
                    ? 'Só vê as obras, a equipe e as ferramentas deste contrato. Os pedidos de material chegam a Compras (setor único) marcados com ele.'
                    : 'Só vê as obras, a equipe e as ferramentas deste contrato.'}</span>
            </div>
          )}
          {/* Perfil administrativo (braço direito do Master): só o Master DE VERDADE concede,
              nunca sobre a própria conta master nem sobre um CEO (somente-leitura). */}
          {user.is_master && !user.admin && !form.is_master && form.role !== 'ceo' && (
            <div className="form-group" style={{gridColumn:'1 / -1'}}>
              <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
                <input type="checkbox" style={{width:'auto',margin:0}} checked={!!form.is_admin} onChange={e=>setForm({...form,is_admin:e.target.checked})} />
                <span>Perfil administrativo (braço direito do Master)</span>
              </label>
              <p className="text-muted" style={{fontSize:'.78rem',marginTop:6,lineHeight:1.4}}>
                Tem o mesmo acesso do Master (vê e edita tudo, todos os contratos), <strong>menos</strong> cancelar, estornar, excluir e zerar dados. <strong>Pode</strong> redefinir senhas e excluir usuários (menos CEO, Diretor, Auxiliar Técnica e outro administrador) — e toda ação fica registrada na sua auditoria, com o nome dele.
              </p>
            </div>
          )}
          {/* Líder em promoção que já faz função de engenheiro: ganha a visão e as permissões de
              engenheiro sem mudar o cargo. Concede quem pode criar engenheiro (espelha o backend). */}
          {form.role === 'lider' && perfisDisp.some(p => p.v === 'engenheiro') && (
            <div className="form-group" style={{gridColumn:'1 / -1'}}>
              <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
                <input type="checkbox" style={{width:'auto',margin:0}} checked={!!form.atua_engenheiro} onChange={e=>setForm({...form,atua_engenheiro:e.target.checked})} />
                <span>Atua como engenheiro</span>
              </label>
              <p className="text-muted" style={{fontSize:'.78rem',marginTop:6,lineHeight:1.4}}>
                Para o líder que já faz função de engenheiro. Continua Líder no cadastro, mas passa a ter a mesma visão e as mesmas permissões do Engenheiro: <strong>Obras</strong>, <strong>Minha equipe</strong>, Cronograma e Auditoria, e pode ser escolhido como engenheiro responsável de obra. Vale no próximo carregamento da tela dele.
              </p>
            </div>
          )}
          {/* Volante: atende todas as unidades do contrato (Elétrica, Metálica, Refrigeração, Manutenção).
              Nos pedidos de material e de ferramenta escolhe qualquer obra ativa do contrato (espelha o backend). */}
          {(form.role === 'lider' || form.role === 'engenheiro') && (
            <div className="form-group" style={{gridColumn:'1 / -1'}}>
              <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer'}}>
                <input type="checkbox" style={{width:'auto',margin:0}} checked={!!form.atende_todas_obras} onChange={e=>setForm({...form,atende_todas_obras:e.target.checked})} />
                <span>Volante — atende todas as obras</span>
              </label>
              <p className="text-muted" style={{fontSize:'.78rem',marginTop:6,lineHeight:1.4}}>
                Para quem atende todas as unidades do contrato (Elétrica, Metálica, Refrigeração, Manutenção). No pedido de material e no pedido de ferramenta, escolhe <strong>qualquer obra ativa do contrato</strong>, não só as que estão no nome dele. Não vira o responsável pela obra: o quadro de obras e a equipe dele continuam como estão. Vale no próximo carregamento da tela dele.
              </p>
            </div>
          )}
          {/* Contrato sem obra (ex.: o Estacionamento Costellation no início): o campo fica, travado e
              dizendo o que falta — antes sumia e parecia que não dava para pôr a pessoa na obra. */}
          {(form.role==='lider'||form.role==='operario'||form.role==='engenheiro') && (
            <div className="form-group"><label>Obra padrão</label>
              <select value={form.obra_id||''} disabled={!obrasForm.length} onChange={e=>{ const r = respDaObra(e.target.value); setForm({...form,obra_id:e.target.value,...(form.role==='operario'&&r?{lider_id:r.id}:{})}) }}>
                <option value="">{obrasForm.length ? 'Sem obra fixa' : 'Nenhuma obra cadastrada'}</option>
                {obrasForm.map(o=><option key={o.id} value={o.id}>{o.nome}{o.codigo?` (${o.codigo})`:''}</option>)}
              </select>
              {!obrasForm.length && <span className="text-muted" style={{fontSize:'.72rem',marginTop:4,display:'block'}}>
                {ctForm ? `O contrato ${ct.nome(ctForm)} ainda não tem obra. ` : 'Ainda não há obra cadastrada. '}
                {podeAbrir(user, 'obras') ? 'Cadastre a obra em Obras' + (ctForm ? ' com este contrato' : '') + ' e volte aqui' : 'Peça ao Master ou ao Diretor para cadastrar a obra'}, ou salve sem obra e escolha depois.
              </span>}
            </div>
          )}
          {form.role==='operario' && (() => {
            // A obra define a equipe: obra com responsável põe o operário na equipe dele (o servidor
            // aplica a mesma regra). Sem obra, ou obra sem responsável, escolhe-se à mão.
            const r = respDaObra(form.obra_id)
            return (
              <div className="form-group"><label>Equipe de (engenheiro / líder)</label>
                <select value={r ? r.id : (form.lider_id||'')} disabled={!!r} onChange={e=>setForm({...form,lider_id:e.target.value})}>
                  <option value="">Sem equipe definida</option>
                  {lideresForm.map(l=><option key={l.id} value={l.id}>{l.nome}</option>)}
                </select>
                {r && <span className="text-muted" style={{fontSize:'.72rem',marginTop:4,display:'block'}}>Definido pela obra: quem está numa obra é da equipe do responsável dela.</span>}
                {!r && !lideresForm.length && <span className="text-muted" style={{fontSize:'.72rem',marginTop:4,display:'block'}}>{ctForm ? 'Este contrato ainda não tem engenheiro nem líder.' : 'Ainda não há engenheiro nem líder.'} Quando a obra ganhar um engenheiro responsável, quem está nela entra na equipe dele.</span>}
              </div>
            )
          })()}
          {!soLeitura && <div className="form-group"><label>{form.id?'Nova senha (em branco = não altera)':'Senha *'}</label><input type="password" value={form.senha||''} onChange={e=>setForm({...form,senha:e.target.value})} placeholder="••••••••" autoComplete="new-password" /></div>}
          {form.id && <div className="form-group"><label>Status</label>
            <select value={form.ativo?'1':'0'} onChange={e=>setForm({...form,ativo:e.target.value==='1'})}>
              <option value="1">Ativo</option><option value="0">Inativo</option>
            </select>
          </div>}
          <div className="form-group"><label>CPF / CNPJ</label><input value={form.cpf_cnpj||''} onChange={e=>setForm({...form,cpf_cnpj:e.target.value})} placeholder="000.000.000-00" /></div>
          <div className="form-group"><label>Empresa (razão social)</label><input value={form.empresa||''} onChange={e=>setForm({...form,empresa:e.target.value})} /></div>
          <div className="form-group"><label>Telefone</label><input value={form.telefone||''} onChange={e=>setForm({...form,telefone:e.target.value})} placeholder="(21) 99999-9999" /></div>
          <div className="form-group"><label>Endereço</label><input value={form.endereco||''} onChange={e=>setForm({...form,endereco:e.target.value})} /></div>
        </div>
        </fieldset>
      </PainelEdicao>
    )
  }
  const vazio = <div className="empty"><div className="empty-icon"><Icon name="worker" size={32}/></div><p>{filtroRole ? 'Nenhum usuário com esse perfil.' : 'Nenhum usuário cadastrado.'}</p>{!filtroRole && <button className="btn btn-accent empty-cta" onClick={abrirNovo}><Icon name="plus" size={14}/> Novo usuário</button>}</div>
  return (
    <div style={{maxWidth:680,margin:'0 auto'}}>
      <div className="topbar"><h2>Usuários</h2><button className="btn btn-accent" onClick={abrirNovo}><Icon name="plus" size={14}/> Novo</button></div>
      <FiltroPainel filtro={filtroP} n={filtrados.length} onLimpar={()=>{ setFiltroP(null); setFiltroRole('') }} />
      <div className="card">
        <div className="card-body" style={{paddingBottom:12}}>
          <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
            <select value={filtroRole} onChange={e=>setFiltroRole(e.target.value)} style={{width:'auto'}}>
              <option value="">Todos os perfis</option>
              {perfisFiltro.map(p=><option key={p.v} value={p.v}>{p.l}</option>)}
            </select>
            {ct.multi && (
              <select value={filtroCt} onChange={e=>setFiltroCt(e.target.value)} style={{width:'auto',maxWidth:'100%'}} aria-label="Filtrar por contrato">
                <option value="">Todos os contratos</option>
                {ct.contratos.map(c=><option key={c.id} value={c.id}>{c.nome}</option>)}
              </select>
            )}
          </div>
        </div>
        <ListaAcordeao
          itens={filtrados} keyOf={u=>u.id} abertoId={openId} onToggle={toggle}
          novoAberto={openId==='new'} painelNovo={painel()} painel={()=>painel()} vazio={vazio}
          resumo={u=>({
            titulo: <><span className="nm">{u.nome}</span>{!u.ativo && <span className="badge badge-devolvida" style={{fontSize:'.62rem',padding:'1px 7px'}}>Inativo</span>}{!u.is_master && <ContratoTag ct={ct} id={ct.de(u)} compacta/>}</>,
            direita: <span style={{display:'inline-flex',alignItems:'center',gap:6}}>{!!u.is_admin && <span className="badge" style={{background:'var(--fill-steel)',color:'#fff',fontSize:'.62rem',padding:'1px 7px'}}>Admin</span>}{u.role === 'lider' && !!u.atua_engenheiro && <span className="badge" style={{background:'var(--fill-steel)',color:'#fff',fontSize:'.62rem',padding:'1px 7px'}} title="Atua como engenheiro">Eng.</span>}{(u.role === 'lider' || u.role === 'engenheiro') && !!u.atende_todas_obras && <span className="badge" style={{background:'var(--fill-cobre)',color:'#fff',fontSize:'.62rem',padding:'1px 7px'}} title="Atende todas as obras">Volante</span>}<span className={`badge badge-${u.role}`}>{ROLE_LABEL[u.role]}</span></span>
          })}
        />
      </div>
    </div>
  )
}

// ─── AUDITORIA DO DIRETOR — trilha operacional (até o nível de Gerente) ─────────
const AUD_CATS = {
  retirada:      { l: 'Retirada',      ic: 'download',    cls: 'ac-ret' },
  devolucao:     { l: 'Devolução',     ic: 'check',       cls: 'ac-dev' },
  transferencia: { l: 'Transferência', ic: 'handshake',   cls: 'ac-tra' },
  obra:          { l: 'Obra',          ic: 'building',     cls: 'ac-obr' },
  ciencia:       { l: 'Ciência',       ic: 'checkCircle', cls: 'ac-cie' },
}
function DiretorAuditoriaPage({ addToast, openTarget }) {
  const [data, setData] = useState({ eventos: [], pessoas: [] })
  const [carregando, setCarregando] = useState(true)
  const [tipo, setTipo] = useState(() => (filtroDoAlvo(openTarget, 'diretor-auditoria') || {}).tipo || '')  // card do painel
  const [pessoa, setPessoa] = useState('')
  const [periodo, setPeriodo] = useState('')
  useEffect(() => {
    GET('/diretor/auditoria').then(d => { setData(d); setCarregando(false) })
      .catch(e => { addToast && addToast(e.message, 'error'); setCarregando(false) })
  }, [])

  const agora = Date.now()
  const eventos = data.eventos.filter(e => {
    if (tipo && e.categoria !== tipo) return false
    if (pessoa && e.pessoa !== pessoa && e.ator !== pessoa) return false
    if (periodo) {
      const t = new Date(String(e.data || '').replace(' ', 'T')).getTime()
      const dias = (agora - t) / 86400000
      if (periodo === '7' && dias > 7) return false
      if (periodo === '30' && dias > 30) return false
    }
    return true
  })
  const [eventosTela, fimEventos] = useAosPoucos(eventos)
  const fmtQuando = s => {
    if (!s) return '—'
    const d = new Date(String(s).replace(' ', 'T'))
    if (isNaN(d)) return s
    return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })
  }

  return (
    <div style={{ maxWidth: 860, margin: '0 auto' }}>
      <div className="topbar"><h2>Auditoria</h2></div>
      <p className="eq-lead">Trilha de tudo que acontece na operação — retiradas, devoluções, transferências, movimentações de obra e as ciências do Gerente. Use para rastrear qualquer desentendimento entre as pessoas.</p>

      <div className="aud-filters">
        <select value={tipo} onChange={e => setTipo(e.target.value)}>
          <option value="">Todos os tipos</option>
          {Object.entries(AUD_CATS).map(([k, v]) => <option key={k} value={k}>{v.l}</option>)}
        </select>
        <select value={pessoa} onChange={e => setPessoa(e.target.value)}>
          <option value="">Todas as pessoas</option>
          {data.pessoas.map(p => <option key={p} value={p}>{p}</option>)}
        </select>
        <select value={periodo} onChange={e => setPeriodo(e.target.value)}>
          <option value="">Todo o período</option>
          <option value="7">Últimos 7 dias</option>
          <option value="30">Últimos 30 dias</option>
        </select>
        <span className="aud-count">{eventos.length} evento(s)</span>
      </div>

      {carregando ? (
        <div className="eq-group"><div className="eq-empty">Carregando…</div></div>
      ) : eventos.length === 0 ? (
        <div className="eq-group"><div className="eq-empty">
          <div className="ei"><Icon name="history" size={26} /></div>
          <p style={{ fontWeight: 600, color: 'var(--ink)' }}>Nenhum evento no filtro atual.</p>
        </div></div>
      ) : (
        <div className="aud-timeline">
          {eventosTela.map((e, i) => {
            const c = AUD_CATS[e.categoria] || { l: e.categoria, ic: 'history', cls: '' }
            return (
              <div className="aud-ev" key={i}>
                <span className={`aud-ic ${c.cls}`}><Icon name={c.ic} size={15} /></span>
                <div className="aud-body">
                  <div className="aud-top">
                    <span className="aud-cat">{c.l}</span>
                    {e.pessoa && <span className="aud-pessoa">{e.pessoa}</span>}
                    <span className="aud-when">{fmtQuando(e.data)}</span>
                  </div>
                  <div className="aud-desc">{e.descricao}</div>
                  {(e.obra_nome || e.ref || (e.valor != null && e.valor > 0)) && (
                    <div className="aud-meta">
                      {e.obra_nome && <span><Icon name="building" size={11} /> {e.obra_nome}</span>}
                      {e.ref && <span>#{e.ref}</span>}
                      {e.valor != null && e.valor > 0 && <span className="v">{fmtBRL(e.valor)}</span>}
                    </div>
                  )}
                </div>
              </div>
            )
          })}
          {fimEventos}
        </div>
      )}
    </div>
  )
}

// ─── AUDITORIA ────────────────────────────────────────────────────────────────
function AuditoriaPage({ user, addToast }) {
  const isMaster = !!(user && user.is_master)
  const [logs, setLogs] = useState([])
  const [busca, setBusca] = useState('')
  const [periodo, setPeriodo] = useState('30')
  const [resetModal, setResetModal] = useState(false)
  const [resetConfirm, setResetConfirm] = useState('')
  const [resetSenha, setResetSenha] = useState('')
  const [resetLoading, setResetLoading] = useState(false)
  const [resetErr, setResetErr] = useState('')
  const [zerarQtdModal, setZerarQtdModal] = useState(false)
  const [zerarQtdLoading, setZerarQtdLoading] = useState(false)
  const [zerarQtdErr, setZerarQtdErr] = useState('')
  useEffect(() => {
    GET('/auditoria' + (periodo === 'tudo' ? '' : `?dias=${periodo}`))
      .then(setLogs)
      .catch(e => addToast && addToast(e.message, 'error'))
  }, [periodo])
  const ACAO_ICON = { LOGIN:'key', CRIAR_SOLICITACAO:'clipboard', SOLICITACAO_SEPARANDO:'package', SOLICITACAO_PRONTA:'checkCircle', CANCELAR_SOLICITACAO:'x', RETIRADA_CAUTELA:'signature', DEVOLVER_CAUTELA:'download', ENTREGA_OPERARIO:'send', DEVOLUCAO_ENTREGA:'download', SOLICITAR_EMPRESTIMO:'handshake', CONFIRMAR_EMPRESTIMO:'checkCircle', RECUSAR_EMPRESTIMO:'x', AVAL_LIDER_EMPRESTIMO:'signature', DEVOLVER_EMPRESTIMO:'download', CRIAR_FERRAMENTA:'wrench', EDITAR_FERRAMENTA:'edit', EXCLUIR_FERRAMENTA:'trash', CRIAR_USUARIO:'worker', EDITAR_USUARIO:'edit', EXCLUIR_USUARIO:'trash', REDEFINIR_SENHA:'key', CRIAR_BOLSA:'backpack', EDITAR_BOLSA:'edit', VER_TERMO:'fileText', RESET_TRANSACIONAL:'alertTriangle', PORTE_SAIDA:'truck', PORTE_ENTREGA:'handshake', PORTE_RETORNO:'undo' }
  // Sem usuario_id = o próprio sistema (reparo único no deploy, rotina agendada, sincronização) — ninguém clicou.
  // Conta excluída não cai aqui: com histórico ela fica preservada só como registro do nome.
  const quemFez = l => l.usuario_id == null ? 'Sistema' : (l.usuario_nome || '')
  const filtrados = logs.filter(l => casaBusca(busca, quemFez(l), l.acao))
  const [filtradosTela, fimFiltrados] = useAosPoucos(filtrados)

  async function zerarQuantidades() {
    setZerarQtdLoading(true); setZerarQtdErr('')
    try {
      const r = await POST('/admin/zerar-quantidades', {})
      setZerarQtdModal(false)
      addToast(`Quantidades zeradas em ${r.alteradas} ferramenta(s). Atualize o estoque real.`, 'success')
    } catch(e) { setZerarQtdErr(e.message) }
    finally { setZerarQtdLoading(false) }
  }

  async function executarReset() {
    if (resetConfirm !== 'CONFIRMAR RESET') { setResetErr('Digite exatamente: CONFIRMAR RESET'); return }
    if (!resetSenha) { setResetErr('Informe a senha do gestor'); return }
    setResetLoading(true); setResetErr('')
    try {
      await POST('/admin/reset-transacional', { confirmacao: resetConfirm, senha_gestor: resetSenha })
      setResetModal(false); setResetConfirm(''); setResetSenha(''); setLogs([])
      addToast('Sistema zerado com sucesso. Pronto para uso real.', 'success')
    } catch(e) {
      setResetErr(e.message)
    } finally {
      setResetLoading(false)
    }
  }

  return (
    <div>
      <div className="topbar">
        <h2>Auditoria</h2>
        {isMaster && (<div className="topbar-actions">
          <button className="btn btn-ghost btn-sm" onClick={async ()=>{
            try {
              const res = await fetch('/api/admin/backup', { headers: { Authorization: `Bearer ${token.value}` } })
              if (!res.ok) { const d = await res.json(); alert(d.error || 'Erro ao baixar backup'); return }
              const blob = await res.blob()
              const url = URL.createObjectURL(blob)
              const a = document.createElement('a')
              a.href = url
              a.download = `cautela-backup-${new Date().toISOString().slice(0,10)}.db`
              a.click(); URL.revokeObjectURL(url)
            } catch(e) { alert('Erro: ' + e.message) }
          }} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="download" size={14}/> Baixar Backup</button>
          {!user.admin && <button className="btn btn-ghost btn-sm" style={{borderColor:'var(--warning)',color:'var(--warning)',display:'inline-flex',alignItems:'center',gap:6}} onClick={()=>{setZerarQtdModal(true);setZerarQtdErr('')}}><Icon name="package" size={14}/> Zerar Quantidades</button>}
          {!user.admin && <button className="btn btn-danger btn-sm" onClick={()=>{setResetModal(true);setResetConfirm('');setResetErr('')}} style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={14}/> Zerar Dados de Teste</button>}
        </div>)}
      </div>

      {zerarQtdModal && (
        <div className="modal-overlay open">
          <div className="modal modal-sm">
            <div className="modal-header"><h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="package" size={17}/> Zerar Quantidades</h3><button className="modal-close" onClick={()=>setZerarQtdModal(false)}>×</button></div>
            <div className="modal-body">
              <div className="alert alert-warning" style={{marginBottom:16}}>
                Vai setar <strong>quantidade = 0</strong> em todas as ferramentas <strong>sem código de patrimônio</strong>.<br/>
                Ferramentas patrimoniais (<Icon name="lock" size={11}/>) não serão afetadas.<br/>
                Após isso, edite cada ferramenta com o estoque real.
              </div>
              {zerarQtdErr && <div className="alert alert-error" style={{marginTop:10}}>{zerarQtdErr}</div>}
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setZerarQtdModal(false)}>Cancelar</button>
              <button className="btn btn-danger" onClick={zerarQuantidades} disabled={zerarQtdLoading}>{zerarQtdLoading?'Zerando...':<span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="package" size={14}/> Confirmar</span>}</button>
            </div>
          </div>
        </div>
      )}

      {resetModal && (
        <div className="modal-overlay open">
          <div className="modal modal-sm">
            <div className="modal-header"><h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={17}/> Zerar Dados Transacionais</h3><button className="modal-close" onClick={()=>{setResetModal(false);setResetSenha('');setResetConfirm('')}}>×</button></div>
            <div className="modal-body">
              <div className="alert alert-error" style={{marginBottom:16}}>
                <strong>Ação irreversível.</strong> Serão apagados permanentemente:<br/>
                Todas as solicitações, cautelas, empréstimos e auditoria.<br/>
                <strong>Ferramentas e usuários serão mantidos.</strong>
              </div>
              <div className="form-group" style={{marginBottom:14}}>
                <label>Senha do Gestor</label>
                <input type="password" value={resetSenha} onChange={e=>setResetSenha(e.target.value)} placeholder="Senha exclusiva do gestor" />
              </div>
              <div className="form-group">
                <label>Digite exatamente para confirmar:</label>
                <p style={{fontFamily:'monospace',fontWeight:700,margin:'4px 0 8px',fontSize:'1rem',color:'var(--danger)'}}>CONFIRMAR RESET</p>
                <input value={resetConfirm} onChange={e=>setResetConfirm(e.target.value)} placeholder="CONFIRMAR RESET" />
              </div>
              {resetErr && <div className="alert alert-error" style={{marginTop:10}}>{resetErr}</div>}
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={()=>setResetModal(false)}>Cancelar</button>
              <button className="btn btn-danger" onClick={executarReset} disabled={resetLoading}>{resetLoading?'Zerando...':<span style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="alertTriangle" size={14}/> Confirmar Reset</span>}</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body" style={{paddingBottom:0,display:'flex',gap:12,flexWrap:'wrap',alignItems:'center'}}>
          <CampoBusca placeholder="Buscar por usuário ou ação..." valor={busca} aoMudar={setBusca} style={{flex:'1 1 240px',maxWidth:340,marginBottom:16}} />
          <select value={periodo} onChange={e=>setPeriodo(e.target.value)} style={{maxWidth:200,marginBottom:16}}>
            <option value="7">Últimos 7 dias</option>
            <option value="30">Últimos 30 dias</option>
            <option value="90">Últimos 90 dias</option>
            <option value="365">Último ano</option>
            <option value="tudo">Todo o histórico</option>
          </select>
          <span className="text-muted" style={{marginBottom:16,fontSize:'.82rem',whiteSpace:'nowrap'}}>{filtrados.length} registro(s)</span>
        </div>
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Data/Hora</th><th>Usuário</th><th>Ação</th><th>Detalhe</th></tr></thead>
          <tbody>
            {filtradosTela.map(l=>(
              <tr key={l.id}>
                <td className="text-muted" data-label="Data/Hora" style={{fontSize:'.8rem',whiteSpace:'nowrap'}}>{(l.criado_em||'').replace('T',' ').slice(0,16)}</td>
                <td data-label="Usuário">{l.usuario_id == null
                  ? <>Sistema<br/><span className="badge tg-neutro" style={{fontSize:'.7rem'}} title="Registrado pelo próprio sistema (ajuste automático, rotina ou sincronização), sem ação de usuário">Automático</span></>
                  : <>{l.usuario_nome||'—'}{l.usuario_role&&<><br/><span className={`badge badge-${l.usuario_role}`} style={{fontSize:'.7rem'}}>{ROLE_LABEL[l.usuario_role]}</span></>}</>}</td>
                <td data-label="Ação"><span style={{marginRight:6,display:'inline-flex',verticalAlign:'middle',color:'var(--text-secondary)'}}>{ACAO_ICON[l.acao] ? <Icon name={ACAO_ICON[l.acao]} size={14}/> : <Icon name="fileText" size={14}/>}</span>{l.acao}</td>
                <td className="text-muted" data-label="Detalhe" style={{fontSize:'.82rem',maxWidth:220}}>{l.detalhe ? (typeof l.detalhe==='string'&&l.detalhe.startsWith('{') ? JSON.stringify(JSON.parse(l.detalhe),null,0).slice(0,80) : l.detalhe) : '—'}</td>
              </tr>
            ))}
            {!filtrados.length && <tr><td colSpan="4"><div className="empty"><div className="empty-icon"><Icon name="history" size={32}/></div><p>{busca ? 'Nenhum registro corresponde à busca.' : periodo === 'tudo' ? 'Sem registros de auditoria.' : 'Sem registros neste período. Amplie a janela para ver eventos mais antigos.'}</p></div></td></tr>}
          </tbody>
        </table></div>{fimFiltrados}
      </div>
    </div>
  )
}

// ─── ÍCONES (SVG inline — substituem emoji na navegação por consistência visual
// entre sistemas operacionais; emoji renderiza diferente em Windows/Mac/Android
// e passa impressão amadora, o que pesa contra o produto no primeiro contato) ──
const ICON_PATHS = {
  dashboard: <><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></>,
  trending: <><polyline points="3 3 3 21 21 21"/><polyline points="6 15 10 11 13 14 20 6"/><polyline points="16 6 20 6 20 10"/></>,
  clipboard: <><rect x="5" y="4" width="14" height="17" rx="2"/><rect x="9" y="2" width="6" height="4" rx="1"/><line x1="8" y1="11" x2="16" y2="11"/><line x1="8" y1="15" x2="16" y2="15"/></>,
  plus: <><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></>,
  chevronRight: <polyline points="9 18 15 12 9 6"/>,
  package: <><path d="M21 8l-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/><line x1="12" y1="13" x2="12" y2="21"/></>,
  backpack: <><path d="M6 8a6 6 0 0112 0v11a2 2 0 01-2 2H8a2 2 0 01-2-2V8z"/><path d="M9 8V6a3 3 0 016 0v2"/><line x1="9" y1="13" x2="15" y2="13"/></>,
  exchange: <><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 014-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 01-4 4H3"/></>,
  wrench: <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>,
  users: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
  userPlus: <><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></>,
  phone: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0122 16.92z"/>,
  history: <><path d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8"/><polyline points="3 3 3 8 8 8"/><polyline points="12 7 12 12 16 14"/></>,
  logout: <><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></>,
  eye: <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
  edit: <><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
  check: <polyline points="20 6 9 17 4 12"/>,
  checkCircle: <><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></>,
  signature: <><path d="M3 17s3-1 5-4 3-6 5-6 1 5 3 7 5-1 5-1"/><line x1="3" y1="21" x2="21" y2="21"/></>,
  worker: <><circle cx="12" cy="8" r="3"/><path d="M4 21v-2a6 6 0 0112 0v2"/><path d="M2 10l10-5 10 5"/></>,
  trash: <><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 012-2h2a2 2 0 012 2v2"/></>,
  x: <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>,
  menu: <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>,
  send: <><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></>,
  truck: <><path d="M1 4h13v12H1z"/><path d="M14 8h4l3 3.5V16h-7"/><circle cx="5.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></>,
  camera: <><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></>,
  star: <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>,
  clock: <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
  download: <><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
  inbox: <><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/></>,
  fileText: <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></>,
  alertTriangle: <><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>,
  lock: <><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></>,
  save: <><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></>,
  undo: <path d="M3 7v6h6"/>,
  handshake: <><path d="M11 17l-1.5-1.5a2.12 2.12 0 010-3l4-4a2.12 2.12 0 013 0l1 1"/><path d="M13 19l6-6"/><path d="M2 12l5-5 3 3-5 5z"/><path d="M22 12l-5 5-3-3 5-5z"/></>,
  search: <><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></>,
  eyeOff: <><path d="M17.94 17.94A10.94 10.94 0 0112 20c-7 0-11-8-11-8a18.5 18.5 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></>,
  key: <><circle cx="7.5" cy="15.5" r="5.5"/><path d="M21 2l-9.6 9.6"/><path d="M15.5 7.5l3 3L22 7l-3-3"/></>,
  shirt: <path d="M20 6l-4-2-1.2 1.6a3.5 3.5 0 01-5.6 0L8 4 4 6l2 4 2-1v9a1 1 0 001 1h6a1 1 0 001-1v-9l2 1 2-4z"/>,
  building: <><path d="M3 21h18"/><path d="M5 21V5a2 2 0 012-2h6a2 2 0 012 2v16"/><path d="M15 21V9h4a1 1 0 011 1v11"/><line x1="9" y1="7" x2="9" y2="7.01"/><line x1="9" y1="11" x2="9" y2="11.01"/><line x1="9" y1="15" x2="9" y2="15.01"/></>,
  sun: <><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></>,
  moon: <path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z"/>,
  shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></>,
  mapPin: <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></>,
  layers: <><path d="M12 3 3 8l9 5 9-5-9-5z"/><path d="M3 13l9 5 9-5"/><path d="M3 10.5l9 5 9-5"/></>,
  cart: <><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.6 12.4a2 2 0 002 1.6h8.8a2 2 0 002-1.6L22 7H6.2"/></>,
}
function Icon({ name, size=20 }) {
  const path = ICON_PATHS[name]
  if (!path) return null
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
      {path}
    </svg>
  )
}

// ─── TEMA (claro/escuro) — escolha explícita persiste em localStorage ───────────
// Lógica central compartilhada pelos dois controles (segmentado no desktop e ícone
// no mobile); um evento mantém ambos em sincronia quando um deles altera o tema.
function temaAtual() {
  const t = localStorage.getItem('cf_theme')
  if (t === 'dark' || t === 'light') return t
  return (window.matchMedia && window.matchMedia('(prefers-color-scheme:dark)').matches) ? 'dark' : 'light'
}
function aplicarTema(t) {
  document.documentElement.setAttribute('data-theme', t)
  try { localStorage.setItem('cf_theme', t) } catch (e) {}
  const m = document.querySelector('meta[name="theme-color"]')
  if (m) m.setAttribute('content', t === 'dark' ? '#0F1621' : '#1A2535')
  window.dispatchEvent(new CustomEvent('cf-theme', { detail: t }))
}
function useTema() {
  const [theme, setTheme] = useState(temaAtual)
  useEffect(() => {
    const h = e => setTheme(e.detail)
    window.addEventListener('cf-theme', h)
    return () => window.removeEventListener('cf-theme', h)
  }, [])
  return theme
}
// Controle segmentado (rodapé da sidebar, desktop)
function ThemeToggle() {
  const theme = useTema()
  return (
    <div className="theme-toggle" role="group" aria-label="Tema">
      <button type="button" className={theme === 'light' ? 'active' : ''} aria-pressed={theme === 'light'} onClick={() => aplicarTema('light')}><Icon name="sun" size={14} /> Claro</button>
      <button type="button" className={theme === 'dark' ? 'active' : ''} aria-pressed={theme === 'dark'} onClick={() => aplicarTema('dark')}><Icon name="moon" size={14} /> Escuro</button>
    </div>
  )
}
// Controle minimalista de um toque (barra superior, mobile)
function ThemeToggleIcon() {
  const theme = useTema()
  const alvo = theme === 'dark' ? 'light' : 'dark'
  return (
    <button type="button" className="mtb-theme" onClick={() => aplicarTema(alvo)}
      aria-label={theme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'} title={theme === 'dark' ? 'Tema claro' : 'Tema escuro'}>
      <Icon name={theme === 'dark' ? 'sun' : 'moon'} size={17} />
    </button>
  )
}

// ─── REC · Registro de Eventos de Custódia (Fase 0) ───────────────────────────
// Aba do módulo 'rec' (só aparece quando o deploy contratou o módulo). Fase 0 entrega:
// abrir/listar solicitação de material (engenheiro/líder) e visão consolidada (gestores). Os elos de custódia
// assinados (retirada/transporte/recebimento) entram nas próximas fases.
const REC_STATUS_LABEL = {
  solicitada: 'Solicitada', analisando: 'Em análise', reservada: 'Reservada',
  separada: 'Separada', separando: 'Em separação', pronta: 'Pronta p/ retirada', a_caminho: 'A caminho', em_transporte: 'Em transporte', entregue: 'Entregue', cancelada: 'Cancelada',
  aguardando_aprovacao: 'Aguardando aprovação', recusada: 'Recusado', devolvida: 'Devolvido: é obra', refeita: 'Refeito como obra',
  em_compras: 'Em compras', recebida: 'A cotar', em_cotacao: 'Em cotação', comprada: 'Comprada', aguardando_retirada: 'Aguardando retirada', em_transito: 'Para chegar', em_estoque: 'No estoque',
  a_caminho_unidade: 'A caminho da unidade', entregue_unidade: 'Entregue na unidade'
}
// Tom da tag por status: aço = trilho do estoque · cobre = trilho de compras · ok = concluído · neutro = cancelado.
const REC_STATUS_TOM = { solicitada:'aco', analisando:'aco', reservada:'aco', separada:'aco', separando:'aco', pronta:'aco', a_caminho:'aco', em_transporte:'aco',
  em_compras:'cobre', recebida:'cobre', em_cotacao:'cobre', comprada:'cobre', aguardando_retirada:'cobre', em_transito:'cobre', a_caminho_unidade:'cobre',
  entregue:'ok', em_estoque:'ok', entregue_unidade:'ok', cancelada:'neutro', aguardando_aprovacao:'alerta', recusada:'perigo', devolvida:'perigo', refeita:'neutro' }
function RecStatus({ s }) {
  return <span className={`rtag dot tg-${REC_STATUS_TOM[s] || 'neutro'}`}>{REC_STATUS_LABEL[s]||s}</span>
}
// Prioridade urgente (item/requerimento de compra). Vinho da paleta, caixa-alta, seta de prioridade.
function RecUrgente({ sm }) {
  return (
    <span className={`rtag caps tg-urgente${sm ? ' rtag-sm' : ''}`} title="Prioridade urgente">
      <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"><path d="m6 11 6-6 6 6M6 19l6-6 6 6"/></svg>
      Urgente
    </span>
  )
}

// Tag do CARD FECHADO: mostra a etapa EM ABERTO (nunca a concluída) + o contador X/Y.
// aberto_kind: 'compras' | 'estoque' | 'done' | 'cancel' (vem do backend em recResumoSolicitacao).
function RecTagAberto({ s }) {
  const tom = { compras:'cobre', estoque:'aco', done:'ok', cancel:'neutro', alerta:'alerta', perigo:'perigo' }[s.aberto_kind] || 'cobre'
  const label = s.aberto_label || REC_STATUS_LABEL[s.status] || s.status
  const mostraContador = (s.total||0) > 1 && !['cancel','alerta','perigo'].includes(s.aberto_kind)
  return (
    <span style={{display:'inline-flex', alignItems:'center', gap:8, flexWrap:'wrap'}}>
      <span className={`rtag dot tg-${tom}`}>{label}</span>
      {mostraContador && (
        <span title={`${s.entregues} de ${s.total} itens entregues`} style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace', fontSize:'.7rem', fontWeight:700, color: s.entregues===s.total?'var(--rec-green)':'var(--rec-gray)'}}>
          {s.entregues}/{s.total}
        </span>
      )}
    </span>
  )
}

// Tipo do pedido (rec-tipo-core.js): só o de OBRA ganha etiqueta — Manutenção é o padrão e não polui o card.
function RecTipoTag({ s, sm }) {
  if (!s || s.tipo !== 'obra') return null
  const dica = s.obra_codigo ? `Obra ${s.obra_codigo}${s.obra_codigo_nome ? ` — ${s.obra_codigo_nome}` : ''} · sai só da Sede` : 'Pedido de obra · sai só da Sede'
  return <span className={`rtag caps tg-cobre${sm ? ' rtag-sm' : ''}`} title={dica}>Obra{s.obra_codigo ? ` · ${s.obra_codigo}` : ''}</span>
}

// "De onde sai cada item?" — o almoxarifado da Sede divide o pedido entre a base do contrato (o Almoxarife 2
// separa e assina) e a Sede, item a item, com a sugestão automática já marcada: concordando, é um clique.
// Refazendo, parte da divisão que está valendo (só enquanto todas as remessas estão em separação). Na base não
// passa do saldo; na Sede passa, com aviso (a remessa espera a entrada). O servidor confere tudo de novo.
const recDepRot = d => d.tipo === 'sede' ? 'Sede' : d.nome
const recDepDe = d => d.tipo === 'sede' ? 'da Sede' : `de ${d.nome}`
function RecDivisao({ user, solId, refazer, addToast, onFeito, onCancelar }) {
  const [div, setDiv] = useState(null)
  const [erroCarga, setErroCarga] = useState(null)
  const [esc, setEsc] = useState({})   // item_id → { modo: deposito_id | 'dividir', q: { deposito_id: qtd } }
  const [salvando, setSalvando] = useState(false)
  const [tentou, setTentou] = useState(false)
  const escDe = (d, it, partes) => {
    const q = {}
    for (const p of partes || []) if (p.deposito_id != null) q[p.deposito_id] = (q[p.deposito_id] || 0) + Number(p.qtd)
    const usados = Object.keys(q).filter(k => q[k] > 0)
    const sede = d.depositos.find(x => x.tipo === 'sede') || d.depositos[0]
    return { modo: usados.length === 1 ? Number(usados[0]) : usados.length ? 'dividir' : (sede ? sede.id : null), q: usados.length ? q : sede ? { [sede.id]: it.qtd } : {} }
  }
  const marcar = (d, campo) => setEsc(Object.fromEntries(d.itens.map(it => [it.id, escDe(d, it, campo === 'atual' && it.atual ? it.atual : it.sugestao)])))
  useEffect(() => {
    let vivo = true
    setDiv(null); setErroCarga(null); setTentou(false)
    GET(`/rec/solicitacoes/${solId}/divisao`).then(d => { if (!vivo) return; setDiv(d); marcar(d, refazer ? 'atual' : 'sugestao') }).catch(e => vivo && setErroCarga(e.message))
    return () => { vivo = false }
  }, [solId, refazer])

  if (erroCarga) return <div style={{fontSize:'.84rem', color:'var(--tag-perigo-fg)'}}>{erroCarga}{onCancelar && <> <button className="rec-div-link" onClick={onCancelar}>Fechar</button></>}</div>
  if (!div) return <div style={{fontSize:'.84rem', color:'var(--text-secondary)'}}>Carregando a divisão…</div>

  const deps = div.depositos
  const qDe = (it, e) => e.modo === 'dividir' ? e.q : { [e.modo]: it.qtd }
  const un = it => it.unidade ? ` ${it.unidade}` : ''
  const fmt = n => (Math.round(Number(n) * 10000) / 10000).toLocaleString('pt-BR')
  // Base sem Almoxarife 2 ativo (ex.: Costellation antes da conta dele): ninguém separa nem assina a remessa de lá.
  // O servidor já não a sugere; escolhida à mão, a tela avisa.
  const semA2 = d => d.tipo === 'centro' && !(d.separa && d.separa.length)
  const basesSemA2 = deps.filter(semA2)
  // Conta e saldo de cada item: erro (bloqueia) ou aviso (segue).
  const checar = it => {
    const e = esc[it.id]; if (!e) return {}
    const q = qDe(it, e)
    const soma = Object.values(q).reduce((a, b) => a + (Number(b) || 0), 0)
    if (Math.round((soma - it.qtd) * 10000) !== 0) return { erro: `A soma dá ${fmt(soma)}${un(it)}; o pedido é de ${fmt(it.qtd)}${un(it)}.` }
    const naBaseSemA2 = basesSemA2.find(d => (Number(q[d.id]) || 0) > 0)
    const avisoA2 = naBaseSemA2 ? { aviso: `${naBaseSemA2.nome} não tem Almoxarife 2 ativo: ninguém separa nem assina a remessa de lá.` } : {}
    if (!it.catalogo) return avisoA2
    for (const d of deps) {
      const v = Number(q[d.id]) || 0, s = it.saldos[d.id] || 0
      if (v <= s) continue
      if (d.tipo === 'centro') return { erro: `${s > 0 ? `${d.nome} só tem ${fmt(s)}${un(it)}` : `${d.nome} não tem este item`} — essa remessa travaria no "pronta".` }
      return naBaseSemA2 ? avisoA2 : { aviso: `${s > 0 ? `${recDepRot(d)} tem ${fmt(s)}${un(it)}` : `${recDepRot(d)} não tem este item agora`}: a remessa só fica pronta depois da entrada da nota.` }
    }
    return avisoA2
  }
  const erros = div.itens.filter(it => checar(it).erro).length
  // Resumo: uma remessa por depósito com quantidade.
  const porDep = deps.map(d => ({ d, n: div.itens.filter(it => esc[it.id] && (Number(qDe(it, esc[it.id])[d.id]) || 0) > 0).length })).filter(x => x.n > 0)
  const quemSepara = d => d.tipo === 'centro' ? (d.separa && d.separa.length ? `o Almoxarife 2 (${d.separa.join(', ')})` : `o Almoxarife 2 de ${d.nome}`) : 'você'
  const escolher = (it, modo) => setEsc(s => {
    const atual = s[it.id]
    if (modo !== 'dividir') return { ...s, [it.id]: { modo, q: { [modo]: it.qtd } } }
    // Dividir: parte do que está marcado; se estava tudo num depósito, sugere o que a base tem e o resto na Sede.
    let q = atual ? { ...qDe(it, atual) } : {}
    if (Object.keys(q).filter(k => q[k] > 0).length < 2 && deps.length >= 2) {
      const base = deps.find(d => d.tipo === 'centro') || deps[0], outro = deps.find(d => d.id !== base.id)
      const naBase = Math.min(it.qtd, it.catalogo ? (it.saldos[base.id] || 0) : 0)
      q = { [base.id]: naBase, [outro.id]: Math.round((it.qtd - naBase) * 10000) / 10000 }
    }
    return { ...s, [it.id]: { modo: 'dividir', q } }
  })
  const digitar = (it, depId, v) => setEsc(s => ({ ...s, [it.id]: { modo: 'dividir', q: { ...s[it.id].q, [depId]: v === '' ? '' : Number(v) } } }))
  const tudo = d => setEsc(Object.fromEntries(div.itens.map(it => [it.id, { modo: d.id, q: { [d.id]: it.qtd } }])))
  const salvar = async () => {
    setTentou(true)
    if (erros) { addToast(erros === 1 ? 'Corrija o item marcado em vermelho.' : `Corrija os ${erros} itens marcados em vermelho.`, 'error'); return }
    const divisao = div.itens.map(it => ({ item_id: it.id, partes: Object.entries(qDe(it, esc[it.id])).map(([k, v]) => ({ deposito_id: Number(k), qtd: Number(v) || 0 })).filter(p => p.qtd > 0) }))
    setSalvando(true)
    try { onFeito(await POST('/rec/remessas', { solicitacao_id: solId, divisao, ...(refazer ? { refazer: true } : {}) })) }
    catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }
  const btnP = { padding:'9px 16px', background:'var(--fill-navy)', color:'#fff', border:'none', borderRadius:8, fontWeight:600, cursor:'pointer' }
  const btnG = { padding:'9px 16px', background:'transparent', color:'var(--ink)', border:'1px solid var(--border)', borderRadius:8, fontWeight:600, cursor:'pointer' }

  // Um depósito só (pedido de Obra, ou contrato sem base): não há o que escolher.
  if (deps.length < 2) {
    const so = deps[0]
    return (
      <div style={{display:'grid', gap:8}}>
        <div style={{fontSize:'.82rem', color:'var(--text-secondary)'}}>{div.tipo === 'obra'
          ? <>Pedido de <strong>obra</strong>: sai só da <strong>Sede</strong> — a base do contrato não entra. O que a Sede não tiver já foi para Compras.</>
          : <>Só {so ? <strong>{recDepRot(so)}</strong> : 'um depósito'} separa este pedido: não há o que dividir.</>}</div>
        <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
          {!refazer && !div.previa && <button style={{...btnP, opacity:salvando?0.6:1}} disabled={salvando} onClick={async()=>{ setSalvando(true); try { onFeito(await POST('/rec/remessas', { solicitacao_id: solId })) } catch (e) { addToast(e.message, 'error') } setSalvando(false) }}>{salvando?'Gerando…':'Gerar remessa'}</button>}
          {onCancelar && <button style={btnG} onClick={onCancelar}>Fechar</button>}
        </div>
      </div>
    )
  }
  return (
    <div className="rec-div">
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'8px 12px', flexWrap:'wrap'}}>
        <div style={{minWidth:0, flex:'1 1 240px'}}>
          <strong style={{fontSize:'.92rem', color:'var(--ink)'}}>{refazer ? 'Refazer a divisão' : div.previa ? 'Prévia: de onde sai cada item?' : 'De onde sai cada item?'}</strong>
          <div style={{fontSize:'.78rem', color:'var(--text-secondary)', marginTop:2}}>{refazer ? 'Nada saiu do estoque ainda: mude o que precisar e salve.'
            : div.previa ? 'Modo apresentação: no uso real, esta escolha aparece depois de "Reservar". Dá para clicar à vontade — nada é gravado.'
            : 'A sugestão do sistema já vem marcada. Mude só o que quiser.'}</div>
          {basesSemA2.map(d => <div key={d.id} className="rec-div-msg aviso" style={{marginTop:6}}>{d.nome} não tem Almoxarife 2 ativo: a sugestão não usa a base (ninguém separaria nem assinaria). {user && podeAbrir(user, 'usuarios') ? 'Para mandar de lá, crie a conta dele na aba Usuários, no contrato da base.' : 'Para mandar de lá, peça ao administrador master para criar a conta do Almoxarife 2 (aba Usuários, no contrato da base).'}</div>)}
        </div>
        <div style={{display:'flex', gap:6, flexWrap:'wrap'}}>
          {deps.map(d => <button key={d.id} className="rec-div-tudo" onClick={()=>tudo(d)}>Tudo {recDepDe(d)}</button>)}
        </div>
      </div>
      {div.itens.map(it => {
        const e = esc[it.id] || {}
        const c = checar(it)
        const q = e.modo ? qDe(it, e) : {}
        return (
          <div key={it.id} className="rec-div-item">
            <div style={{display:'flex', gap:'4px 8px', flexWrap:'wrap', alignItems:'baseline'}}>
              <span style={{fontSize:'.9rem', color:'var(--ink)', minWidth:0, overflowWrap:'anywhere'}}><strong style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace'}}>{fmt(it.qtd)}</strong>{un(it)} · {it.nome}</span>
              <span style={{display:'inline-flex', gap:4, flexWrap:'wrap'}}>
                {it.catalogo
                  ? deps.map(d => <span key={d.id} className="rec-div-saldo">{recDepRot(d)} · <strong>{fmt(it.saldos[d.id] || 0)}</strong></span>)
                  : <span className="rec-div-saldo">fora do catálogo · sem saldo controlado</span>}
              </span>
            </div>
            {it.devolvido && <div style={{fontSize:'.76rem', color:'var(--tag-alerta-fg)', marginTop:4}}>↩ {it.devolvido.de || 'A base'} devolveu{it.devolvido.por ? ` (${it.devolvido.por})` : ''}: “{it.devolvido.motivo}”</div>}
            <div className="rec-div-seg" role="radiogroup" aria-label={`De onde sai ${it.nome}`}>
              {deps.map(d => <button key={d.id} type="button" role="radio" aria-checked={e.modo === d.id} className={e.modo === d.id ? 'on' : ''} onClick={()=>escolher(it, d.id)}>{recDepRot(d)}</button>)}
              <button type="button" role="radio" aria-checked={e.modo === 'dividir'} className={e.modo === 'dividir' ? 'on' : ''} onClick={()=>escolher(it, 'dividir')}>Dividir</button>
            </div>
            {e.modo === 'dividir' && (
              <div className="rec-div-qtds">
                {deps.map(d => (
                  <label key={d.id}>
                    <span>{recDepRot(d)}</span>
                    <input type="number" inputMode="decimal" min="0" step="any" value={q[d.id] === undefined ? 0 : q[d.id]} onChange={ev=>digitar(it, d.id, ev.target.value)} />
                  </label>
                ))}
              </div>
            )}
            {c.erro && <div className="rec-div-msg erro">{c.erro}</div>}
            {c.aviso && <div className="rec-div-msg aviso">{c.aviso}</div>}
          </div>
        )
      })}
      <div className="rec-div-resumo">
        <div style={{fontWeight:700, color:'var(--ink)', marginBottom:4}}>{refazer ? 'Fica assim:' : `Vai gerar ${porDep.length} remessa${porDep.length > 1 ? 's' : ''}:`}</div>
        {porDep.map(({ d, n }) => (
          <div key={d.id}><strong>{recDepRot(d)}</strong> · {n} {n > 1 ? 'itens' : 'item'} — {semA2(d)
            ? <span style={{color:'var(--tag-alerta-fg)'}}>sem Almoxarife 2 ativo: ninguém separa nem assina</span>
            : <>separa e assina {quemSepara(d)}</>}</div>
        ))}
        {refazer && <div style={{marginTop:4, color:'var(--text-secondary)'}}>Quem separa vê o aviso "alterada pela Sede" na remessa que mudar.</div>}
      </div>
      {tentou && erros > 0 && <div className="rec-div-msg erro" style={{marginTop:8}}>Corrija {erros === 1 ? 'o item marcado' : `os ${erros} itens marcados`} em vermelho.</div>}
      <div style={{display:'flex', gap:8, flexWrap:'wrap', justifyContent:'flex-end', marginTop:10}}>
        <button className="rec-div-link" style={{marginRight:'auto'}} onClick={()=>marcar(div, 'sugestao')}>Voltar à sugestão</button>
        {onCancelar && <button style={btnG} onClick={onCancelar}>Cancelar</button>}
        {!div.previa && <button style={{...btnP, opacity:salvando?0.6:1}} disabled={salvando} onClick={salvar}>{salvando ? 'Salvando…' : refazer ? 'Salvar nova divisão' : porDep.length > 1 ? 'Gerar remessas' : 'Gerar remessa'}</button>}
      </div>
    </div>
  )
}
// Itens que a base devolveu à Sede ("Não consigo enviar"): o quê, quem devolveu e por quê — na remessa da Sede.
function RecItensDevolvidos({ itens }) {
  const dv = (itens || []).filter(i => i.devolvido_de)
  if (!dv.length) return null
  return (
    <div style={{display:'grid', gap:3, padding:'7px 10px', borderRadius:8, background:'var(--tag-alerta-bg)', border:'1px solid var(--tag-alerta-bd)', fontSize:'.76rem', color:'var(--tag-alerta-fg)', overflowWrap:'anywhere'}}>
      {dv.map(i => <div key={i.id}>↩ <strong>{Number(i.qtd)}{i.unidade ? ` ${i.unidade}` : ''} · {i.catalogo_nome || i.descricao || '(item)'}</strong> — {i.devolvido_de_nome || 'a base'} devolveu à Sede{i.devolvido_por_nome ? ` (${i.devolvido_por_nome})` : ''}: “{i.devolvido_motivo}”</div>)}
    </div>
  )
}
// Alertas do pedido (vêm do servidor, rec-tipo-core.js): SÓ aviso, nunca bloqueia nem muda a origem.
// compacto = etiqueta curta no card; senão, a caixa com o texto (e a ação, se houver).
const REC_ALERTA_CURTO = { unidade_com_obra_ativa: 'Unidade com obra ativa' }
// Texto do critério "unidade com obra ativa" — o MESMO do servidor (rec-tipo-core.js), para o aviso ao vivo do formulário.
function recTextoObraAtiva(obras) {
  const lista = obras.map(o => `${o.codigo} — ${o.nome}`).join(', ')
  return obras.length === 1
    ? `Esta unidade tem obra ativa (${lista}). Se o material for da obra, o pedido deve ser do tipo Obra (sai da Sede).`
    : `Esta unidade tem obras ativas (${lista}). Se o material for de uma delas, o pedido deve ser do tipo Obra (sai da Sede).`
}
function RecAlertas({ alertas, compacto, children }) {
  if (!alertas || !alertas.length) return null
  if (compacto) return alertas.map(a => <span key={a.codigo} className="rtag dot tg-alerta" title={a.texto}>{REC_ALERTA_CURTO[a.codigo] || 'Atenção'}</span>)
  return (
    <div style={{background:'var(--tag-alerta-bg)', border:'1px solid var(--tag-alerta-bd)', color:'var(--tag-alerta-fg)', borderRadius:10, padding:'10px 12px', marginBottom:12, display:'grid', gap:8, fontSize:'.84rem'}}>
      {alertas.map(a => <div key={a.codigo} style={{display:'flex', gap:8, alignItems:'flex-start'}}><Icon name="alertTriangle" size={15}/><span>{a.texto}</span></div>)}
      {children}
    </div>
  )
}

// Situação do PRAZO de um item de compra ainda em aberto (fora de estoque/cancelada):
// 'atrasado' (o prazo já passou) ou 'hoje' (vence hoje). Comparação feita no relógio do
// cliente (Brasília), então independe do fuso do servidor. Retorna null quando não há alerta.
function recPrazoInfo(prazo, status) {
  if (!prazo || status === 'em_estoque' || status === 'entregue_unidade' || status === 'cancelada') return null
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0)
  const d = new Date(String(prazo).slice(0, 10) + 'T00:00:00')
  if (isNaN(d)) return null
  const dias = Math.round((d - hoje) / 86400000)
  if (dias < 0) return { kind: 'atrasado', dias: -dias, label: `Atrasado ${-dias} dia${-dias > 1 ? 's' : ''}` }
  if (dias === 0) return { kind: 'hoje', dias: 0, label: 'Vence hoje' }
  return null
}
// Tag do alerta de prazo: atrasado = vinho cheio (prazo estourado) · vence hoje = âmbar de alerta.
function RecPrazoBadge({ prazo, status }) {
  const info = recPrazoInfo(prazo, status)
  if (!info) return null
  return (
    <span className={`rtag tg-${info.kind === 'atrasado' ? 'perigo' : 'alerta'}`} title={info.kind === 'atrasado' ? 'Prazo necessário já passou' : 'Prazo necessário vence hoje'}>
      <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
      {info.label}
    </span>
  )
}

// ── Prazo de pedidos (antecedência da solicitação de material) ─────────────────
// A regra é do servidor (rec-prazo-core.js): a faixa gravada vem dele. Aqui só a MESMA conta para o aviso
// ao vivo do formulário, com o "hoje" do servidor (GET /rec/prazo-config) para não depender do relógio do celular.
const recYMD = s => String(s || '').slice(0, 10)
const recDiaUTC = s => { const [y, m, d] = recYMD(s).split('-').map(Number); return Date.UTC(y, m - 1, d) }
const recAddDias = (s, n) => new Date(recDiaUTC(s) + n * 864e5).toISOString().slice(0, 10)
const recDM = s => s ? `${recYMD(s).slice(8, 10)}/${recYMD(s).slice(5, 7)}` : ''
const recDMA = s => s ? `${recDM(s)}/${recYMD(s).slice(0, 4)}` : ''
const recDiasUteis = n => `${n} dia${n === 1 ? ' útil' : 's úteis'}`
const recDiaSem = s => ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'][new Date(recDiaUTC(s)).getUTCDay()]
const recMesNome = s => ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'][Number(recYMD(s).slice(5, 7)) - 1]
// O prazo conta só dia útil: sem sábado, domingo e os feriados nacionais que o servidor manda (cfg.feriados).
const recDiaUtil = (s, cfg) => { const w = new Date(recDiaUTC(s)).getUTCDay(); return w !== 0 && w !== 6 && !((cfg && cfg.feriados) || []).includes(s) }
function recContarUteis(de, ate, cfg) {   // dias úteis depois de `de` até `ate` inclusive
  let n = 0
  for (let d = recAddDias(de, 1); d <= ate; d = recAddDias(d, 1)) if (recDiaUtil(d, cfg)) n++
  return n
}
function recAddDiasUteis(s, n, cfg) {
  let d = recYMD(s)
  for (let k = 0; k < n;) { d = recAddDias(d, 1); if (recDiaUtil(d, cfg)) k++ }
  return d
}
// Primeira data fora do "fora do prazo" (o que o calendário libera no modo justificar) — sempre dia útil.
const recPrimeiraData = cfg => recAddDiasUteis(cfg.hoje, cfg.vigente, cfg)
// Modo justificar: antes do mínimo a data fica travada; só a emergência destrava.
const recTrava = cfg => !!cfg && cfg.modo === 'justificar' && cfg.vigente > 0
// Emergências da pessoa no mês × limite da regra (0 = sem limite). excedeu → a próxima espera o gerente.
function recEmergencias(cfg) {
  const usadas = (cfg && cfg.meus && cfg.meus.emergencias_mes) || 0, limite = (cfg && cfg.emergencias) || 0
  return { usadas, limite, excedeu: limite > 0 && usadas >= limite }
}
function recClassificar(data, cfg) {
  if (!cfg || !/^\d{4}-\d{2}-\d{2}$/.test(data || '')) return null
  if (data < cfg.hoje) return { ant: -1, faixa: null, passada: true }
  const ant = recContarUteis(cfg.hoje, data, cfg)
  return { ant, faixa: ant >= cfg.alvo ? 'no_prazo' : ant >= cfg.vigente ? 'tolerado' : 'fora_prazo' }
}
const REC_MOTIVO_LABEL = {
  emergencia: 'Emergência: risco à segurança ou unidade parada',
  cliente: 'Demanda nova do cliente ou da fiscalização',
  imprevisto: 'Imprevisto em campo: quebra, dano, furto, clima',
  quantitativo: 'Erro de levantamento ou de quantidade',
  planejamento: 'Não foi previsto a tempo',
}
const REC_MODO_LABEL = { medir: 'Só medir', justificar: 'Justificar', aprovar: 'Aprovar' }
// Tag da faixa: fora do prazo = vinho com contorno (mesma família do "Urgente"); tolerado = âmbar.
// No prazo não ganha tag — a data sozinha basta (menos ruído no card).
function RecFaixaTag({ faixa, sm }) {
  if (faixa === 'fora_prazo') return <span className={`rtag caps tg-urgente${sm ? ' rtag-sm' : ''}`} title="Pedido com menos antecedência que o mínimo">Fora do prazo</span>
  if (faixa === 'tolerado') return <span className={`rtag tg-alerta${sm ? ' rtag-sm' : ''}`} title="Abaixo do prazo padrão, acima do mínimo">Tolerado</span>
  return null
}
// Aviso logo abaixo da data: verde discreto (no prazo) · âmbar (tolerado) · vinho (fora do prazo).
// Modo justificar: antes do mínimo a data está travada ("Usar dd/mm" ou marcar emergência); com a
// emergência marcada, o aviso diz o que acontece com o pedido (Urgente, gerente avisado, limite do mês).
function RecAvisoPrazo({ cls, cfg, emergencia, onUsar }) {
  if (!cls || !cfg) return null
  const base = { display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', borderRadius: 8, padding: '8px 11px', fontSize: '.82rem', lineHeight: 1.4 }
  const perigo = { ...base, background: 'var(--tag-perigo-bg)', border: '1px solid var(--tag-perigo-bd)', color: 'var(--tag-perigo-fg)' }
  if (cls.passada) return <div style={perigo}>Escolha hoje ou uma data futura.</div>
  if (cls.faixa === 'no_prazo') return <div style={{ ...base, padding: '2px 0', color: 'var(--success)' }}><Icon name="check" size={14} /> Dentro do prazo: {recDiasUteis(cls.ant)} de antecedência.</div>
  if (cls.faixa === 'tolerado') return (
    <div style={{ ...base, background: 'var(--tag-alerta-bg)', border: '1px solid var(--tag-alerta-bd)', color: 'var(--tag-alerta-fg)' }}>
      Aceito: {recDiasUteis(cls.ant)} de antecedência. O prazo padrão é de {recDiasUteis(cfg.alvo)}.
    </div>
  )
  const prim = recPrimeiraData(cfg)
  if (recTrava(cfg) && emergencia) {
    const em = recEmergencias(cfg)
    return (
      <div style={{ ...perigo, display: 'grid', gap: 4 }}>
        <span>Emergência com {recDiasUteis(cls.ant)} de antecedência. Vai como <strong>Urgente</strong> para Compras e o gerente do contrato é avisado.</span>
        {em.limite > 0 && (em.excedeu
          ? <strong>Você já usou {em.usadas} de {em.limite} emergências em {recMesNome(cfg.hoje)}: esta espera o gerente do contrato liberar antes de chegar ao almoxarifado.</strong>
          : <span style={{ fontSize: '.76rem' }}>Emergências em {recMesNome(cfg.hoje)}: {em.usadas} de {em.limite}. Passando disso, o gerente precisa liberar.</span>)}
      </div>
    )
  }
  const usar = <button type="button" onClick={() => onUsar(prim)} style={{ padding: '5px 11px', borderRadius: 7, border: '1px solid var(--tag-perigo-line)', background: 'var(--card)', color: 'var(--tag-perigo-fg)', fontWeight: 700, fontSize: '.78rem', cursor: 'pointer' }}>Usar {recDM(prim)}</button>
  if (recTrava(cfg)) return (
    <div style={perigo}>
      <span style={{ flex: '1 1 220px' }}>Data bloqueada: antes do mínimo de {recDiasUteis(cfg.vigente)} (sem sábado, domingo e feriado). A primeira data possível é {recDiaSem(prim)} {recDM(prim)}. Só emergência libera data antes disso.</span>
      {usar}
    </div>
  )
  return (
    <div style={perigo}>
      <span style={{ flex: '1 1 220px' }}>Fora do prazo mínimo de {recDiasUteis(cfg.vigente)} (sem sábado, domingo e feriado). A primeira data dentro do prazo é {recDiaSem(prim)} {recDM(prim)}.</span>
      {usar}
    </div>
  )
}
// Data de necessidade + aviso + justificativa. Usado no formulário novo e no reenvio de pedido recusado.
// v = { data, motivo, impacto }. Modo justificar: o calendário começa na primeira data no mínimo; a caixa
// "É emergência" (motivo = emergencia) destrava as datas anteriores e pede o impacto. Modo aprovar: data
// livre e, fora do prazo, motivo da lista + impacto. Modo medir: só a data.
function RecCamposPrazo({ cfg, v, set, inp, rotulo }) {
  const cls = recClassificar(v.data, cfg)
  const trava = recTrava(cfg)
  const emergencia = v.motivo === 'emergencia'
  const fora = cls && cls.faixa === 'fora_prazo'
  const exige = fora && (trava ? emergencia : cfg.modo !== 'medir')
  const lbl = { fontSize: '.8rem', color: 'var(--text-secondary)' }
  const falta = Math.max(0, (cfg.impacto_min || 20) - v.impacto.trim().length)
  const prim = recPrimeiraData(cfg)
  return (
    <div style={{ display: 'grid', gap: 8 }}>
      <label style={{ display: 'grid', gap: 4 }}>
        <span style={{ ...lbl, fontWeight: 700, color: 'var(--ink)' }}>{rotulo || 'Preciso do material na obra em'} *</span>
        <input style={{ ...inp, maxWidth: 220 }} type="date" min={trava && !emergencia ? prim : cfg.hoje} required value={v.data} onChange={e => set({ ...v, data: e.target.value })} />
      </label>
      {trava && (
        <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: '.82rem', color: 'var(--ink)', cursor: 'pointer' }}>
          <input type="checkbox" checked={emergencia} onChange={e => set({ ...v, motivo: e.target.checked ? 'emergencia' : '' })} style={{ width: 'auto', marginTop: 2 }} />
          <span>É emergência: risco à segurança ou obra parada <span style={{ color: 'var(--text-secondary)' }}>(libera datas antes de {recDM(prim)})</span></span>
        </label>
      )}
      <RecAvisoPrazo cls={cls} cfg={cfg} emergencia={emergencia} onUsar={d => set({ ...v, data: d })} />
      {exige && <>
        {!trava && <label style={{ display: 'grid', gap: 4 }}>
          <span style={lbl}>Motivo do pedido fora do prazo *</span>
          <select style={inp} value={v.motivo} onChange={e => set({ ...v, motivo: e.target.value })}>
            <option value="">— escolha —</option>
            {Object.entries(REC_MOTIVO_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </label>}
        <label style={{ display: 'grid', gap: 4 }}>
          <span style={lbl}>O que acontece se não chegar nesta data? *</span>
          <textarea style={{ ...inp, minHeight: 56 }} maxLength={1000} value={v.impacto} onChange={e => set({ ...v, impacto: e.target.value })}
            placeholder={trava ? 'ex.: quadro elétrico exposto, equipe parada até trocar o disjuntor' : 'ex.: a equipe de pintura fica parada a partir de quinta'} />
          {falta > 0 && <span style={{ fontSize: '.72rem', color: 'var(--text-secondary)' }}>Faltam {falta} caracteres.</span>}
        </label>
        {cfg.modo === 'aprovar' && <div style={{ fontSize: '.78rem', color: 'var(--text-secondary)' }}>
          {v.motivo === 'emergencia'
            ? (recEmergencias(cfg).excedeu ? 'Você passou do limite de emergências do mês: esta espera o gerente do contrato aprovar.' : 'Emergência segue direto; o gerente do contrato toma ciência depois.')
            : 'Vai para aprovação do gerente do contrato antes de chegar ao almoxarifado.'}
        </div>}
      </>}
    </div>
  )
}
// "Pedido para 02/10 · Almoxarifado prometeu 06/10" (card e detalhe). Pedido antigo: "sem data".
function RecLinhaPrazo({ s }) {
  if (!s.necessario_em) return <span style={{ color: 'var(--text-secondary)' }}>sem data</span>
  const atrasa = s.data_prometida && s.data_prometida > s.necessario_em
  return <span>Pedido para <strong style={{ color: 'var(--ink)' }}>{recDM(s.necessario_em)}</strong>
    {s.data_prometida && <> · Almoxarifado prometeu <strong style={{ color: atrasa ? 'var(--tag-perigo-fg)' : 'var(--ink)' }}>{recDM(s.data_prometida)}</strong></>}</span>
}

// Passos da esteira de UM item, conforme o trilho (estoque × compras) e o estado atual.
function recItemSteps(it, solStatus, remStatus) {
  if (it.destino === 'compras' && ['aguardando_aprovacao', 'recusada'].includes(solStatus))
    return { steps: ['Solicitado','A cotar','Cotação','Comprado','Retirada','No estoque','Entregue'], cur: 0, entregue: false, trilho: 'compras', espera: false }
  // Compra direto para a unidade: do fornecedor à unidade, sem a etapa do estoque.
  if (it.destino === 'compras' && it.compra && it.compra.remessa_id && it.compra.status !== 'cancelada') {
    const steps = ['Solicitado','A cotar','Cotação','Comprado','No fornecedor','A caminho','Entregue']
    const cur = { aguardando_retirada:4, a_caminho_unidade:5, entregue_unidade:6 }[it.compra.status] || 4
    return { steps, cur, entregue: it.compra.status === 'entregue_unidade', trilho:'compras', espera: false }
  }
  if (it.destino === 'compras' && !(it.compra && it.compra.status === 'em_estoque')) {
    const steps = ['Solicitado','A cotar','Cotação','Comprado','Retirada','No estoque','Entregue']
    const cs = (it.compra && it.compra.status) || 'recebida'
    const cur = { recebida:1, em_cotacao:2, comprada:3, aguardando_retirada:4, em_transito:4, em_estoque:5 }[cs] || 1
    return { steps, cur, entregue:false, trilho:'compras', espera: false }
  }
  // Trilho de estoque — a etapa de Separação/Transporte é refinada pelo status da REMESSA:
  //   separando → Separação (atual) · pronta → Separação concluída, Transporte aguardando ·
  //   a_caminho → Transporte "a caminho" (bolinha com borda azul) · em_transporte → Transporte pleno.
  const steps = ['Solicitado','Reservado','Separação','Transporte','Entregue']
  // Status da remessa DESTE item (vem do servidor): com 2 remessas, cada item anda na sua.
  const rs = it.remessa_status
  if (rs && solStatus !== 'cancelada') {
    if (rs === 'entregue')      return { steps, cur:4, entregue:true, trilho:'estoque' }
    if (rs === 'em_transporte') return { steps, cur:3, entregue:false, trilho:'estoque', transporte:'em_transito' }
    if (rs === 'a_caminho')     return { steps, cur:3, entregue:false, trilho:'estoque', transporte:'a_caminho' }
    if (rs === 'pronta')        return { steps, cur:3, entregue:false, trilho:'estoque', transporte:'aguardando' }
    return { steps, cur:2, entregue:false, trilho:'estoque' }
  }
  if (solStatus === 'entregue') return { steps, cur:4, entregue:true, trilho:'estoque' }
  if (solStatus === 'em_transporte') return { steps, cur:3, entregue:false, trilho:'estoque', transporte:'em_transito' }
  if (solStatus === 'separada') {
    if (remStatus === 'a_caminho') return { steps, cur:3, entregue:false, trilho:'estoque', transporte:'a_caminho' }
    if (remStatus === 'pronta')    return { steps, cur:3, entregue:false, trilho:'estoque', transporte:'aguardando' }
    return { steps, cur:2, entregue:false, trilho:'estoque' }
  }
  const cur = { solicitada:0, analisando:0, reservada:1, em_compras:0 }[solStatus] ?? 0
  return { steps, cur, entregue:false, trilho:'estoque' }
}

// Stepper HORIZONTAL com bolinhas: check nas concluídas, realce na atual, apagadas as próximas.
// Largura LIMITADA (não estica na largura do desktop) e com scroll-x de segurança no mobile.
function RecEsteira({ steps, cur, entregue, transporte }) {
  const done = 'var(--rec-done)', accent = 'var(--rec-cur)', line = 'var(--rec-line)'
  const COL = 62
  const check = <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="#fff" strokeWidth="3.6" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
  const truck = <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h11v9H3z"/><path d="M14 9h3l3 3v3h-6z"/><circle cx="7" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/></svg>
  // A etapa "Transporte" pode assumir sub-estados vindos da remessa (só no trilho de estoque).
  const tIdx = transporte ? steps.indexOf('Transporte') : -1
  const stateOf = i => {
    if (i === tIdx) {
      if (transporte === 'em_transito') return 'transit'   // motorista retirou, a caminho da obra → azul cheio
      if (transporte === 'a_caminho')   return 'current'   // motorista a caminho de retirar → borda azul + ponto
      if (transporte === 'aguardando')  return 'pending'   // separado, aguardando motorista
    }
    if (entregue || i < cur) return 'done'
    if (!entregue && i === cur) return 'current'
    return 'pending'
  }
  const connOn = i => ['done','transit','current'].includes(stateOf(i))
  return (
    <div style={{overflowX:'auto', paddingBottom:2}}>
      <div style={{display:'flex', alignItems:'flex-start', width:'100%', maxWidth:steps.length*COL, minWidth:steps.length*44}}>
        {steps.map((label, i) => {
          const st = stateOf(i)
          const bd = st==='done'||st==='transit' ? (st==='transit'?accent:done) : st==='current' ? accent : line
          const bg = st==='done' ? done : st==='transit' ? accent : 'var(--card)'
          const lblColor = st==='current'||st==='transit' ? accent : st==='done' ? 'var(--rec-sub)' : 'var(--rec-pending)'
          return (
            <React.Fragment key={i}>
              {i > 0 && <div style={{flex:'1 1 auto', minWidth:6, height:0, marginTop:8, borderTop:'2px '+(connOn(i)?'solid':'dashed')+' '+(connOn(i)?done:line)}}/>}
              <div style={{display:'flex', flexDirection:'column', alignItems:'center', flex:'0 0 auto', width:42}}>
                <div style={{width:18, height:18, borderRadius:'50%', background:bg, border:'2px solid '+bd, display:'grid', placeItems:'center', boxShadow:st==='current'?'0 0 0 3px var(--rec-cur-ring)':'none'}}>
                  {st==='done' ? check : st==='transit' ? truck : st==='current' ? <span style={{width:6, height:6, borderRadius:'50%', background:accent}}/> : null}
                </div>
                <div style={{fontSize:'.58rem', lineHeight:1.15, marginTop:6, textAlign:'center', color:lblColor, fontWeight:st==='current'||st==='transit'?700:400}}>{label}</div>
              </div>
            </React.Fragment>
          )
        })}
      </div>
    </div>
  )
}

// Chat em tempo real (WebSocket) com histórico persistido. Canal ex.: 'remessa:<id>'.
// Envia por REST (grava + faz broadcast) e recebe ao vivo pelo WS; reconecta sozinho.
function RecChat({ canal, titulo, user, readonly }) {
  const [msgs, setMsgs] = React.useState([])
  const [texto, setTexto] = React.useState('')
  const [online, setOnline] = React.useState(false)
  const wsRef = React.useRef(null)
  const fimRef = React.useRef(null)
  const append = m => setMsgs(prev => prev.some(x => x.id === m.id) ? prev : [...prev, m])
  React.useEffect(() => {
    let vivo = true, retry = null
    GET('/chat/' + encodeURIComponent(canal)).then(h => { if (vivo) setMsgs(h || []) }).catch(() => {})
    const conectar = () => {
      if (!vivo) return
      const proto = location.protocol === 'https:' ? 'wss' : 'ws'
      let ws
      // Token vai no subprotocolo (Sec-WebSocket-Protocol), não na URL — evita vazar o
      // JWT em logs de proxy/acesso. Marcador 'cautelix' + o token como 2º protocolo.
      const tk = token.value || ''
      const subprotos = tk ? ['cautelix', tk] : undefined
      try { ws = new WebSocket(`${proto}://${location.host}/ws/chat`, subprotos) }
      catch { retry = setTimeout(conectar, 3000); return }
      wsRef.current = ws
      ws.onopen = () => { setOnline(true); try { ws.send(JSON.stringify({ type: 'sub', canal })) } catch {} }
      ws.onmessage = ev => { let m; try { m = JSON.parse(ev.data) } catch { return } if (m.type === 'msg' && m.canal === canal) append(m.msg) }
      ws.onclose = () => { setOnline(false); if (vivo) retry = setTimeout(conectar, 3000) }
      ws.onerror = () => { try { ws.close() } catch {} }
    }
    conectar()
    return () => { vivo = false; if (retry) clearTimeout(retry); try { wsRef.current && wsRef.current.close() } catch {} }
  }, [canal])
  React.useEffect(() => { if (fimRef.current) fimRef.current.scrollIntoView({ block: 'nearest' }) }, [msgs])
  const enviar = async () => {
    const t = texto.trim(); if (!t) return
    setTexto('')
    try { append(await POST('/chat/' + encodeURIComponent(canal), { texto: t })) }
    catch (e) { setTexto(t) }
  }
  return (
    <div style={{marginTop:10, border:'1px solid var(--border,#e5e7eb)', borderRadius:10, overflow:'hidden', background:'var(--card,#fff)'}}>
      <div style={{padding:'8px 12px', borderBottom:'1px solid var(--border,#e5e7eb)', display:'flex', alignItems:'center', gap:8, fontSize:'.8rem', fontWeight:700, color:'var(--ink,#111)'}}>
        <span style={{width:8, height:8, borderRadius:'50%', background: online?'var(--rec-green)':'var(--rec-gray)'}}/>
        {titulo || 'Conversa'}
        <span style={{marginLeft:'auto', fontWeight:400, fontSize:'.7rem', color:'var(--text-secondary)'}}>{online?'online':'reconectando…'}</span>
      </div>
      <div style={{maxHeight:240, overflowY:'auto', padding:12, display:'flex', flexDirection:'column', gap:8, background:'var(--silver-light,#f8fafc)'}}>
        {msgs.length===0 && <div style={{fontSize:'.8rem', color:'var(--text-secondary)', textAlign:'center', padding:'12px 0'}}>Nenhuma mensagem ainda. Diga olá 👋</div>}
        {msgs.map(m => {
          const meu = m.de_id === user.id
          return (
            <div key={m.id} style={{alignSelf: meu?'flex-end':'flex-start', maxWidth:'82%'}}>
              {!meu && <div style={{fontSize:'.64rem', color:'var(--text-secondary)', marginBottom:2, marginLeft:3}}>{m.de_nome||'—'}{m.de_role?` · ${ROLE_LABEL[m.de_role]||m.de_role}`:''}</div>}
              <div style={{padding:'7px 11px', borderRadius:12, fontSize:'.85rem', lineHeight:1.35, whiteSpace:'pre-wrap', wordBreak:'break-word', background: meu?'var(--rec-navy)':'var(--card,#fff)', color: meu?'var(--rec-on-accent)':'var(--ink,#111)', border: meu?'none':'1px solid var(--border,#e5e7eb)', borderBottomRightRadius: meu?3:12, borderBottomLeftRadius: meu?12:3}}>{m.texto}</div>
              <div style={{fontSize:'.6rem', color:'var(--text-secondary)', marginTop:2, textAlign: meu?'right':'left'}}>{(m.criado_em||'').slice(11,16)}</div>
            </div>
          )
        })}
        <div ref={fimRef}/>
      </div>
      {readonly
        ? <div style={{padding:'9px 12px', borderTop:'1px solid var(--border,#e5e7eb)', fontSize:'.72rem', color:'var(--text-secondary)', textAlign:'center'}}>👁️ Somente leitura — acompanhamento anônimo</div>
        : <div style={{display:'flex', gap:8, padding:10, borderTop:'1px solid var(--border,#e5e7eb)'}}>
            <input style={{flex:1, padding:'8px 10px', border:'1px solid var(--border,#d1d5db)', borderRadius:8, background:'var(--card,#fff)', color:'var(--ink,#111)', fontSize:'.9rem'}} placeholder="Escreva uma mensagem…" value={texto} onChange={e=>setTexto(e.target.value)} onKeyDown={e=>{ if(e.key==='Enter' && !e.shiftKey){ e.preventDefault(); enviar() } }} />
            <button style={{padding:'9px 16px', background:'var(--fill-navy)', color:'#fff', border:'none', borderRadius:8, fontWeight:600, cursor:'pointer'}} onClick={enviar}>Enviar</button>
          </div>}
    </div>
  )
}

// ─── ENTREGAS DE BOLSAS (Apontador) ───────────────────────────────────────────
// Bolsas que o apontador retirou no almoxarifado para o operário que não consegue ir buscar. A entrega
// só se completa quando o operário se identifica e assina NESTE aparelho — é aí que a cautela fica ativa
// em nome dele e a guarda deixa de ser do apontador. Os operários ainda não têm login: o padrão é ele
// digitar o CPF do cadastro (o aparelho nunca recebe o número); sem CPF cadastrado, vale a foto do
// recebimento; quem já usa o sistema pode entrar com a senha. Sem entrega, a bolsa volta ao balcão.
function EntregasBolsasPage({ user, navigate, addToast }) {
  const [dados, setDados] = useState(null)
  const [aberto, setAberto] = useState(null)    // cautela com os itens à mostra
  const [entrega, setEntrega] = useState(null)  // { p, step: id | termo | sign, modo: cpf | login | foto, cpf, email, senha, foto, consent, geo, err, termo }
  const load = () => GET('/portes').then(setDados).catch(e => { setDados({ em_maos: [], buscar: [], preparando: [], historico: [] }); addToast(e.message, 'error') })
  useEffect(() => { load() }, [])
  const set = patch => setEntrega(m => m && ({ ...m, ...patch }))
  const primeiro = n => String(n || '').trim().split(/\s+/)[0] || n
  const papel = p => p.cautela_tipo === 'direto' ? 'operário' : 'líder'
  const mapa = q => 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(q)
  const modoInicial = p => p.destinatario_tem_login ? 'login' : (p.destinatario_tem_cpf ? 'cpf' : 'foto')
  const abrirEntrega = p => {
    setEntrega({ p, step: 'id', modo: modoInicial(p), cpf: '', email: p.destinatario_email || '', senha: '', foto: null, consent: false, geo: null, err: '', termo: '' })
    // Local da entrega, se o celular permitir — não segura a entrega se negar ou demorar.
    try { navigator.geolocation && navigator.geolocation.getCurrentPosition(pos => set({ geo: { lat: pos.coords.latitude, lng: pos.coords.longitude } }), () => {}, { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }) } catch {}
  }
  const identificacao = m => m.modo === 'login' ? { email: m.email, senha: m.senha } : m.modo === 'cpf' ? { cpf: m.cpf } : {}
  const conferir = async () => {
    const m = entrega
    if (m.modo === 'cpf' && m.cpf.replace(/\D/g, '').length < 11) { set({ err: 'Digite o CPF completo (11 números).' }); return }
    set({ err: '' })
    try {
      await POST(`/portes/${m.p.cautela_id}/conferir`, identificacao(m))
      let termo = ''
      try { termo = (await GET(`/cautelas/${m.p.cautela_id}/termo/${m.p.cautela_tipo === 'direto' ? 'ciencia_direta' : 'comodato'}`)).html || '' } catch {}
      set({ step: 'termo', termo })
    } catch(e) { set({ err: e.message }) }
  }
  const anexarFoto = async file => {
    if (!file) return
    try { set({ foto: await comprimirImagem(file), err: '' }) } catch(e) { set({ err: e.message || 'Não foi possível usar a foto.' }) }
  }
  const confirmar = async sig => {
    const m = entrega
    if (m.modo === 'foto' && !m.foto) { set({ err: `Tire a foto de ${primeiro(m.p.destinatario_nome)} recebendo a bolsa — o cadastro dele não tem CPF.` }); return }
    if (m.foto && !m.consent) { set({ err: 'Marque a autorização de uso da foto (ou remova a foto).' }); return }
    try {
      const r = await POST(`/portes/${m.p.cautela_id}/entregar`, { ...identificacao(m), assinatura: sig, foto: m.foto || null, geo_lat: m.geo ? m.geo.lat : null, geo_lng: m.geo ? m.geo.lng : null })
      addToast(`Entregue a ${r.responsavel_nome}. A cautela está ativa em nome dele.`, 'success')
      setEntrega(null); load()
    } catch(e) { set({ err: e.message, step: 'id', senha: '', cpf: '' }) }
  }
  const verTermoPorte = async cautelaId => {
    try {
      const { html } = await GET(`/cautelas/${cautelaId}/termo/porte`)
      const w = window.open('', '_blank', 'width=900,height=700,scrollbars=yes')
      w.document.write(html); w.document.close()
    } catch(e) { addToast(e.message, 'error') }
  }

  if (!dados) return <div style={{padding:24,color:'var(--text-secondary)'}}>Carregando...</div>
  const { em_maos, buscar, preparando, historico } = dados
  const valorEmMaos = em_maos.reduce((t, p) => t + (p.valor_total || 0), 0)
  // O apontador leva para todos os contratos: com bolsas de 2+ contratos, cada uma diz de qual é (sem repetir
  // quando a obra tem o nome do contrato, como na Costellation).
  const multiCt = new Set([...em_maos, ...buscar, ...preparando].map(x => x.contrato_id).filter(Boolean)).size > 1
  const ctDe = x => multiCt && x.contrato_nome !== x.obra_nome ? x.contrato_nome : null
  const linha = { display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, padding:'9px 0', borderBottom:'1px solid var(--border)', fontSize:'.85rem' }
  return (
    <div>
      <div className="topbar"><h2>Entregas de bolsas</h2></div>
      <p style={{color:'var(--text-secondary)',fontSize:'.88rem',margin:'-6px 0 16px'}}>Bolsas que você retira no almoxarifado para o operário que não consegue ir buscar. Cada passagem fica assinada: almoxarifado → você → operário.</p>
      <div className="stats-grid">
        <div className="stat-card red"><div className="stat-label">Valor sob sua guarda</div><ValorCard v={valorEmMaos} /></div>
        <div className="stat-card"><div className="stat-label">Com você</div><div className="stat-value">{em_maos.length}</div></div>
        <div className="stat-card"><div className="stat-label">Prontas para buscar</div><div className="stat-value">{buscar.length}</div></div>
      </div>

      <div className="card">
        <div className="card-header"><span className="card-title" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="truck" size={15}/> Com você — para entregar</span></div>
        <div className="card-body">
          {!em_maos.length && <p className="text-muted" style={{fontSize:'.88rem'}}>Nenhuma bolsa com você agora.</p>}
          {em_maos.map(p => (
            <div key={p.cautela_id} style={{border:'1px solid var(--border)',borderRadius:12,padding:12,marginBottom:10,background:'var(--surface)'}}>
              <div style={{display:'flex',alignItems:'center',gap:10}}>
                <span className="cbav">{iniciais(p.destinatario_nome)}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontWeight:700}}>{p.destinatario_nome}</div>
                  <div style={{fontSize:'.78rem',color:'var(--text-secondary)'}}>{[p.destinatario_cargo || ROLE_LABEL[p.destinatario_role], p.numero, p.bolsa_nome && `Bolsa ${p.bolsa_nome}`, ctDe(p)].filter(Boolean).join(' · ')}</div>
                </div>
                <span style={{fontWeight:700,whiteSpace:'nowrap'}}>{fmtBRL(p.valor_total)}</span>
              </div>
              {(p.obra_nome || p.obra_endereco) && (
                <a href={mapa(p.obra_endereco || p.obra_nome)} target="_blank" rel="noopener noreferrer" style={{display:'flex',alignItems:'center',gap:6,marginTop:10,fontSize:'.84rem',color:'var(--primary-accent)',textDecoration:'none'}}><Icon name="mapPin" size={14}/> {p.obra_nome}{p.obra_endereco ? ` — ${p.obra_endereco}` : ''}</a>
              )}
              <div style={{fontSize:'.76rem',color:'var(--text-secondary)',marginTop:6}}>Com você desde {tlHora(p.desde)}</div>
              <button className="btn btn-ghost btn-sm" style={{marginTop:4,paddingLeft:0}} onClick={()=>setAberto(aberto === p.cautela_id ? null : p.cautela_id)}>{aberto === p.cautela_id ? 'Ocultar itens' : `Ver ${p.itens.length} item(ns)`}</button>
              {aberto === p.cautela_id && (
                <div style={{background:'var(--bg)',borderRadius:8,padding:'2px 12px'}}>
                  {p.itens.map((i, k) => (
                    <div key={i.id} style={{display:'flex',justifyContent:'space-between',gap:8,fontSize:'.84rem',padding:'7px 0',borderBottom:k === p.itens.length - 1 ? 'none' : '1px solid var(--border)'}}>
                      <span style={{minWidth:0}}>{i.ferramenta_nome}{i.codigo ? <span className="text-muted"> ({i.codigo})</span> : ''}</span><strong>{i.quantidade}×</strong>
                    </div>
                  ))}
                </div>
              )}
              <div style={{display:'flex',gap:8,marginTop:10,flexWrap:'wrap'}}>
                <button className="btn btn-accent" style={{flex:'1 1 200px',justifyContent:'center',display:'inline-flex',alignItems:'center',gap:6}} onClick={()=>abrirEntrega(p)}><Icon name="signature" size={15}/> Entregar a {primeiro(p.destinatario_nome)}</button>
                <button className="btn btn-outline btn-sm" onClick={()=>verTermoPorte(p.cautela_id)} style={{display:'inline-flex',alignItems:'center',gap:5}}><Icon name="fileText" size={14}/> Termo</button>
              </div>
            </div>
          ))}
          {em_maos.length > 0 && <p style={{fontSize:'.78rem',color:'var(--text-secondary)'}}>Não conseguiu entregar? Leve a bolsa de volta ao almoxarifado — o almoxarife registra o retorno com a sua assinatura.</p>}
        </div>
      </div>

      {(buscar.length > 0 || preparando.length > 0) && (
        <div className="card">
          <div className="card-header"><span className="card-title" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="backpack" size={15}/> Para buscar no almoxarifado</span></div>
          <div className="card-body">
            {[...buscar, ...preparando].map(b => (
              <div key={b.solicitacao_id} style={linha}>
                <span style={{minWidth:0}}>
                  <strong>{b.destinatario_nome}</strong> <span className="text-muted">· {b.numero}</span>
                  <span style={{display:'block',fontSize:'.76rem',color:'var(--text-secondary)'}}>{[b.bolsa_nome && `Bolsa ${b.bolsa_nome}`, `${b.n_itens} item(ns)`, b.obra_nome, ctDe(b)].filter(Boolean).join(' · ')}</span>
                </span>
                <span className={`badge ${b.status === 'pronta' ? 'tg-ok' : 'tg-aco'}`}>{b.status === 'pronta' ? 'Pronta' : 'Em separação'}</span>
              </div>
            ))}
            <p style={{fontSize:'.78rem',color:'var(--text-secondary)',marginTop:10}}>Na retirada, o almoxarife pede o seu login e a sua assinatura no aparelho dele.</p>
          </div>
        </div>
      )}

      {historico.length > 0 && (
        <div className="card">
          <div className="card-header"><span className="card-title" style={{display:'inline-flex',alignItems:'center',gap:6}}><Icon name="history" size={15}/> Últimas entregas</span></div>
          <div className="card-body">
            {historico.map(h => (
              <div key={h.id} style={linha}>
                <span style={{minWidth:0}}>
                  <strong>{h.destinatario_nome}</strong> <span className="text-muted">· {h.numero}</span>
                  {h.obs && <span style={{display:'block',fontSize:'.76rem',color:'var(--text-secondary)'}}>{h.obs}</span>}
                </span>
                <span style={{textAlign:'right',flexShrink:0}}>
                  <span className={`badge ${h.tipo === 'entrega' ? 'tg-ok' : 'tg-neutro'}`}>{h.tipo === 'entrega' ? 'Entregue' : 'Voltou ao almox.'}</span>
                  <span style={{display:'block',fontSize:'.74rem',color:'var(--text-secondary)',marginTop:3}}>{tlHora(h.criado_em)}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Entrega: o operário entra com a senha dele, lê o termo e assina NESTE aparelho */}
      {entrega && (
        <div className="modal-overlay open">
          <div className="modal modal-md">
            <div className="modal-header">
              <h3 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="handshake" size={17}/> Entregar a {entrega.p.destinatario_nome}</h3>
              <button className="modal-close" onClick={()=>setEntrega(null)}>×</button>
            </div>
            <div className="modal-body">
              {entrega.err && entrega.step !== 'sign' && <div className="alert alert-error" style={{marginBottom:12,display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {entrega.err}</div>}
              {entrega.step === 'id' && (() => {
                const p = entrega.p, nome = primeiro(p.destinatario_nome)
                const trocar = modo => set({ modo, err: '', senha: '', cpf: '' })
                const linkModo = (modo, texto) => <button className="btn btn-ghost btn-sm" style={{paddingLeft:0,marginTop:8}} onClick={()=>trocar(modo)}>{texto}</button>
                return (<>
                  <div className="alert alert-info" style={{marginBottom:12}}>Passe o aparelho para {nome}. Ele confirma quem é, lê o termo e assina o recebimento — a partir daí a bolsa fica sob a responsabilidade dele, não mais sua.</div>
                  <div className="auth-device-box">
                    <h4 style={{display:'flex',alignItems:'center',gap:8}}><Icon name="lock" size={16}/> {p.destinatario_nome} — confirme quem é você</h4>
                    <p style={{fontSize:'.82rem',color:'var(--text-secondary)',marginBottom:12}}>{p.numero} · {p.itens.length} item(ns) · {fmtBRL(p.valor_total)}</p>
                    {entrega.modo === 'cpf' && (<>
                      <div className="form-group">
                        <label>CPF de {nome} (o do cadastro)</label>
                        <input value={entrega.cpf} onChange={e=>set({ cpf: e.target.value.replace(/[^\d.\-\/]/g, '').slice(0, 18) })} inputMode="numeric" autoComplete="off" placeholder="000.000.000-00" onKeyDown={e=>e.key==='Enter'&&conferir()} />
                        <p className="text-muted" style={{fontSize:'.75rem',marginTop:4}}>Não precisa de login nem senha. O número é conferido no servidor e não fica salvo.</p>
                      </div>
                      {linkModo('login', 'Ele já tem login no sistema? Entrar com a senha')}
                    </>)}
                    {entrega.modo === 'login' && (<>
                      <div className="form-grid">
                        <div className="form-group"><label>Email</label><input type="email" value={entrega.email} onChange={e=>set({ email: e.target.value })} autoComplete="off" /></div>
                        <div className="form-group"><label>Senha de {nome}</label><input type="password" value={entrega.senha} onChange={e=>set({ senha: e.target.value })} placeholder="••••••••" autoComplete="new-password" onKeyDown={e=>e.key==='Enter'&&conferir()} /></div>
                      </div>
                      {linkModo(p.destinatario_tem_cpf ? 'cpf' : 'foto', p.destinatario_tem_cpf ? 'Sem login? Confirmar com o CPF' : 'Sem login? Entregar com assinatura e foto')}
                    </>)}
                    {entrega.modo === 'foto' && (<>
                      <p style={{fontSize:'.86rem',lineHeight:1.5}}>O cadastro de {nome} não tem CPF. A entrega vale com a <strong>assinatura dele e a foto do recebimento</strong>, tiradas por você na próxima etapa.</p>
                      <p className="text-muted" style={{fontSize:'.75rem',marginTop:6}}>Peça ao almoxarifado para completar o CPF no cadastro — nas próximas entregas basta digitá-lo.</p>
                      {linkModo('login', 'Ele já tem login no sistema? Entrar com a senha')}
                    </>)}
                    <div style={{marginTop:12,textAlign:'right'}}>
                      <button className="btn btn-primary" onClick={conferir}>{entrega.modo === 'foto' ? 'Continuar →' : 'Conferir →'}</button>
                    </div>
                  </div>
                </>)
              })()}
              {entrega.step === 'termo' && (<>
                <div className="alert alert-success" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="checkCircle" size={16}/> {entrega.modo === 'foto' ? `Entrega para ${entrega.p.destinatario_nome}.` : `${entrega.modo === 'cpf' ? 'CPF conferido' : 'Login conferido'}: ${entrega.p.destinatario_nome}.`} Leia o termo antes de assinar.</div>
                {entrega.termo
                  ? <iframe title="Termo da cautela" srcDoc={entrega.termo} style={{ width: '100%', height: '50vh', border: '1px solid var(--border)', borderRadius: 8, background: '#fff', marginBottom: 16 }} />
                  : <p style={{color:'var(--text-secondary)',marginBottom:16}}>Termo indisponível agora — confira os itens na próxima etapa antes de assinar.</p>}
                <div style={{textAlign:'right'}}>
                  <button className="btn btn-primary" onClick={()=>set({ step: 'sign', err: '' })} style={{display:'inline-flex',alignItems:'center',gap:6}}>Li e concordo → Assinar <Icon name="signature" size={14}/></button>
                </div>
              </>)}
              {entrega.step === 'sign' && (<>
                <div style={{background:'rgba(46,125,107,.08)',border:'1px solid rgba(46,125,107,.35)',borderRadius:8,padding:12,marginBottom:16}}>
                  {entrega.p.itens.map(i => (
                    <div key={i.id} style={{display:'flex',justifyContent:'space-between',gap:8,fontSize:'.85rem',marginBottom:4}}>
                      <span>{i.ferramenta_nome} × {i.quantidade}</span>
                      <span style={{color:'var(--success)',fontWeight:600}}>{fmtBRL(i.valor_item || 0)}</span>
                    </div>
                  ))}
                  <div style={{borderTop:'1px solid rgba(46,125,107,.35)',marginTop:8,paddingTop:8,display:'flex',justifyContent:'space-between',fontWeight:700}}>
                    <span>TOTAL SOB RESPONSABILIDADE:</span>
                    <span style={{color:'var(--success)'}}>{fmtBRL(entrega.p.valor_total)}</span>
                  </div>
                </div>
                <div style={{marginBottom:14}}>
                  <div style={{fontSize:'.82rem',fontWeight:600,color:'var(--text-secondary)',marginBottom:6}}>
                    Foto do recebimento {entrega.modo === 'foto' ? '* (o cadastro não tem CPF)' : '(opcional)'} — {primeiro(entrega.p.destinatario_nome)} com a bolsa
                  </div>
                  {entrega.foto ? (
                    <div style={{display:'inline-block',position:'relative'}}>
                      <img src={entrega.foto} alt="foto do recebimento" style={{maxHeight:130,borderRadius:8,border:'1px solid var(--border)',display:'block'}} />
                      <button onClick={()=>set({ foto: null, consent: false })} title="Remover foto" style={{position:'absolute',top:-8,right:-8,width:24,height:24,borderRadius:'50%',border:'none',background:'var(--fill-danger)',color:'#fff',cursor:'pointer',padding:0,display:'grid',placeItems:'center'}}><Icon name="x" size={13}/></button>
                    </div>
                  ) : (
                    <label className="btn btn-outline btn-sm" style={{display:'inline-flex',alignItems:'center',gap:6,cursor:'pointer'}}>
                      <Icon name="camera" size={14}/> Tirar foto
                      <input type="file" accept="image/*" capture="environment" style={{display:'none'}} onChange={e=>{ anexarFoto(e.target.files && e.target.files[0]); e.target.value = '' }} />
                    </label>
                  )}
                  {entrega.foto && (
                    <label className="porte-op" style={{marginTop:10,border:'none',padding:0,background:'none',fontSize:'.8rem',color:'var(--text-secondary)'}}>
                      <input type="checkbox" checked={entrega.consent} onChange={e=>set({ consent: e.target.checked, err: '' })} />
                      <span>{entrega.p.destinatario_nome} autoriza o uso desta foto exclusivamente para comprovar a entrega desta bolsa (LGPD, Lei nº 13.709/2018).</span>
                    </label>
                  )}
                </div>
                <div className="alert alert-warning" style={{display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={16}/> Ao assinar, {entrega.p.destinatario_nome} confirma o recebimento e assume a responsabilidade perante a {empresaInfo.razaoSocial}.</div>
                {/* Erro da assinatura perto do botão: no celular, o topo do modal fica fora da vista. */}
                {entrega.err && <div className="alert alert-error" style={{margin:'0 0 12px',display:'flex',alignItems:'center',gap:8}}><Icon name="alertTriangle" size={15}/> {entrega.err}</div>}
                <SignaturePad label={`Assinatura de ${entrega.p.destinatario_nome} (${papel(entrega.p)})`} onConfirm={confirmar} onCancel={()=>set({ step: 'termo', err: '' })} />
              </>)}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// Fiscalização (Apontador): panorama de obras/colaboradores, cautela+EPI, ocorrências com
// fotos e canal exclusivo com o Diretor. Gestão (diretor/gerente) conversa; Master acompanha
// anônimo (só leitura). Papel-adaptável pelo user.role.
const OC_TIPO_LABEL = { seguranca:'Segurança', epi:'EPI', disciplina:'Disciplina', qualidade:'Qualidade', outro:'Outro' }
const OC_GRAV = { baixa:{l:'Baixa', c:'var(--rec-green)', bg:'var(--rec-green-soft)'}, media:{l:'Média', c:'var(--rec-amber)', bg:'var(--rec-amber-soft)'}, alta:{l:'Alta', c:'var(--rec-urg-fg)', bg:'var(--rec-urg-bg)'} }
function FiscPage({ user, addToast }) {
  const inp = { padding:'8px 10px', border:'1px solid var(--border,#d1d5db)', borderRadius:8, background:'var(--card,#fff)', color:'var(--ink,#111)', fontSize:'.9rem', width:'100%' }
  const btnP = { padding:'9px 16px', background:'var(--fill-navy)', color:'#fff', border:'none', borderRadius:8, fontWeight:600, cursor:'pointer' }
  const btnG = { padding:'9px 16px', background:'transparent', color:'var(--ink,#111)', border:'1px solid var(--border,#d1d5db)', borderRadius:8, fontWeight:600, cursor:'pointer' }
  const card = { background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderRadius:12, padding:16, marginBottom:14 }
  const souApontador = user.role === 'apontador'
  const souGestor = user.role === 'diretor' || user.role === 'gerente' || user.is_master
  const veCanais = user.role === 'diretor' || !!user.is_master  // canal Apontador ↔ Diretor (o Gerente não abre)
  const soLeitura = !!user.is_master && !souApontador          // Master acompanha anônimo
  const [tab, setTab] = useState(souApontador ? 'panorama' : 'ocorrencias')
  const [obras, setObras] = useState([])
  const [colExp, setColExp] = useState(null)
  const [colDet, setColDet] = useState(null)
  const [ocs, setOcs] = useState([])
  const [aps, setAps] = useState([])
  const [apChat, setApChat] = useState(null)

  useEffect(() => {
    GET('/apontador/panorama').then(setObras).catch(()=>{})
    GET('/ocorrencias').then(setOcs).catch(()=>{})
    if (veCanais) GET('/apontador/canais').then(setAps).catch(()=>{})
  }, [])

  const abrirColaborador = async (id) => {
    if (colExp === id) { setColExp(null); setColDet(null); return }
    setColExp(id); setColDet(null)
    try { setColDet(await GET('/apontador/colaborador/' + id)) } catch (e) { addToast(e.message, 'error') }
  }

  // Nova ocorrência (apontador)
  const [novo, setNovo] = useState(false)
  const [oform, setOform] = useState({ obra_id:'', colaborador_id:'', tipo:'seguranca', gravidade:'media', descricao:'' })
  const [fotos, setFotos] = useState([])
  const [enviando, setEnviando] = useState(false)
  const addFotos = (files) => {
    Array.from(files || []).slice(0, 6 - fotos.length).forEach(f => {
      const r = new FileReader(); r.onload = () => setFotos(prev => prev.length < 6 ? [...prev, r.result] : prev); r.readAsDataURL(f)
    })
  }
  const enviarOcorrencia = async () => {
    if (!oform.obra_id) { addToast('Selecione a obra.', 'error'); return }
    if (!oform.descricao.trim()) { addToast('Descreva a ocorrência.', 'error'); return }
    setEnviando(true)
    try {
      await POST('/ocorrencias', { ...oform, colaborador_id: oform.colaborador_id || null, fotos })
      addToast('Ocorrência registrada.', 'success')
      setNovo(false); setFotos([]); setOform({ obra_id:'', colaborador_id:'', tipo:'seguranca', gravidade:'media', descricao:'' })
      setOcs(await GET('/ocorrencias'))
    } catch (e) { addToast(e.message, 'error') }
    setEnviando(false)
  }
  const colsDaObra = (obras.find(o => String(o.id) === String(oform.obra_id)) || {}).colaboradores || []
  const tabBtn = (id, label) => <button style={tab===id?btnP:btnG} onClick={()=>setTab(id)}>{label}</button>

  return (
    <div style={{padding:'16px 0'}}>
      <h2 style={{margin:'0 0 4px', color:'var(--ink,#111)'}}>Fiscalização</h2>
      <p style={{margin:'0 0 14px', color:'var(--text-secondary)', fontSize:'.9rem'}}>
        {souApontador ? 'Acompanhamento de obras e equipes, registro de ocorrências e canal direto com o Diretor de Operações.'
          : soLeitura ? 'Visão de fiscalização — acompanhe obras, ocorrências e os canais dos apontadores (somente leitura).'
          : 'Visão de fiscalização — obras, ocorrências e conversa com os apontadores.'}
      </p>
      <div style={{display:'flex', gap:8, flexWrap:'wrap', marginBottom:16}}>
        {tabBtn('panorama', 'Panorama')}
        {tabBtn('ocorrencias', `Ocorrências${ocs.length?` (${ocs.length})`:''}`)}
        {souApontador && tabBtn('conversa', 'Falar com o Diretor')}
        {veCanais && tabBtn('apontadores', `Apontadores${aps.length?` (${aps.length})`:''}`)}
      </div>

      {tab === 'panorama' && <>
        {obras.length === 0 && <div style={{...card, color:'var(--text-secondary)'}}>Nenhuma obra ativa.</div>}
        {obras.map(o => (
          <div key={o.id} style={{...card, padding:0, overflow:'hidden'}}>
            <div style={{padding:16}}>
              <div style={{fontWeight:700, color:'var(--ink,#111)'}}>{o.nome}{o.codigo?` · ${o.codigo}`:''}</div>
              <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:3}}>
                Responsável: <strong style={{color:'var(--rec-navy)'}}>{o.responsavel_nome||'— sem responsável'}</strong>
                {o.responsavel_cargo?` · ${o.responsavel_cargo}`:''} · {o.colaboradores.length} colaborador(es)
              </div>
            </div>
            {o.colaboradores.length > 0 && (
              <div style={{borderTop:'1px solid var(--border,#e5e7eb)', background:'var(--silver-light,#f8fafc)'}}>
                {o.colaboradores.map(c => (
                  <div key={c.id} style={{borderBottom:'1px solid var(--border,#e5e7eb)'}}>
                    <div onClick={()=>abrirColaborador(c.id)} style={{display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, padding:'11px 16px', cursor:'pointer', flexWrap:'wrap'}}>
                      <div style={{fontSize:'.9rem', color:'var(--ink,#111)'}}>{colExp===c.id?'▾ ':'▸ '}{c.nome} <span style={{color:'var(--text-secondary)', fontSize:'.82rem'}}>· {c.cargo||'—'}</span></div>
                      <div style={{fontSize:'.78rem', color:'var(--text-secondary)'}}>{c.cautelas||0} cautela(s){user.is_master?` · ${fmtBRLc(c.valor_posse||0)}`:''}</div>
                    </div>
                    {colExp===c.id && (
                      <div style={{padding:'0 16px 14px'}}>
                        {!colDet && <div style={{color:'var(--text-secondary)', fontSize:'.85rem'}}>Carregando…</div>}
                        {colDet && colDet.colaborador.id===c.id && <div style={{display:'grid', gap:12, gridTemplateColumns:'repeat(auto-fit,minmax(min(220px,100%),1fr))'}}>
                          <div>
                            <div style={{fontSize:'.75rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.04em', color:'var(--rec-navy)', marginBottom:6}}>Cautela (ferramentas)</div>
                            {colDet.cautelas.length===0 && <div style={{fontSize:'.82rem', color:'var(--text-secondary)'}}>Nada em posse.</div>}
                            {colDet.cautelas.map((k,i)=>(<div key={i} style={{fontSize:'.82rem', color:'var(--ink,#111)', padding:'2px 0'}}>• <strong>{k.quantidade}×</strong> {k.ferramenta}{k.codigo?` (${k.codigo})`:''}</div>))}
                          </div>
                          <div>
                            <div style={{fontSize:'.75rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.04em', color:'var(--rec-amber)', marginBottom:6}}>EPI / Uniforme</div>
                            {colDet.epis.length===0 && <div style={{fontSize:'.82rem', color:'var(--text-secondary)'}}>Nenhum EPI ativo.</div>}
                            {colDet.epis.map((e,i)=>(<div key={i} style={{fontSize:'.82rem', color:'var(--ink,#111)', padding:'2px 0'}}>• <strong>{e.quantidade}×</strong> {e.item_nome}{e.tamanho?` · ${e.tamanho}`:''}</div>))}
                          </div>
                        </div>}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </>}

      {tab === 'ocorrencias' && <>
        {souApontador && !novo && <button style={{...btnP, marginBottom:14}} onClick={()=>setNovo(true)}>+ Nova ocorrência</button>}
        {souApontador && novo && (
          <div style={card}>
            <h3 style={{marginTop:0, color:'var(--ink,#111)'}}>Nova ocorrência</h3>
            <div style={{display:'grid', gap:10}}>
              <label style={{display:'grid', gap:4}}><span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Obra</span>
                <select style={inp} value={oform.obra_id} onChange={e=>setOform({...oform, obra_id:e.target.value, colaborador_id:''})}>
                  <option value="">— selecionar —</option>
                  {obras.map(o=><option key={o.id} value={o.id}>{o.nome}</option>)}
                </select>
              </label>
              <label style={{display:'grid', gap:4}}><span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Colaborador (opcional)</span>
                <select style={inp} value={oform.colaborador_id} onChange={e=>setOform({...oform, colaborador_id:e.target.value})} disabled={!oform.obra_id}>
                  <option value="">— geral da obra —</option>
                  {colsDaObra.map(c=><option key={c.id} value={c.id}>{c.nome}{c.cargo?` · ${c.cargo}`:''}</option>)}
                </select>
              </label>
              <div style={{display:'flex', gap:10, flexWrap:'wrap'}}>
                <label style={{display:'grid', gap:4, flex:'1 1 150px'}}><span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Tipo</span>
                  <select style={inp} value={oform.tipo} onChange={e=>setOform({...oform, tipo:e.target.value})}>
                    {Object.keys(OC_TIPO_LABEL).map(k=><option key={k} value={k}>{OC_TIPO_LABEL[k]}</option>)}
                  </select>
                </label>
                <label style={{display:'grid', gap:4, flex:'1 1 150px'}}><span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Gravidade</span>
                  <select style={inp} value={oform.gravidade} onChange={e=>setOform({...oform, gravidade:e.target.value})}>
                    <option value="baixa">Baixa</option><option value="media">Média</option><option value="alta">Alta</option>
                  </select>
                </label>
              </div>
              <label style={{display:'grid', gap:4}}><span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Descrição</span>
                <textarea style={{...inp, minHeight:80}} value={oform.descricao} onChange={e=>setOform({...oform, descricao:e.target.value})} placeholder="O que foi observado…" />
              </label>
              <div>
                <span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Fotos ({fotos.length}/6)</span>
                <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:6, alignItems:'center'}}>
                  {fotos.map((f,i)=>(
                    <div key={i} style={{position:'relative'}}>
                      <img src={f} alt="" style={{width:64, height:64, objectFit:'cover', borderRadius:8, border:'1px solid var(--border,#e5e7eb)'}} />
                      <button onClick={()=>setFotos(fotos.filter((_,j)=>j!==i))} style={{position:'absolute', top:-6, right:-6, width:20, height:20, borderRadius:'50%', border:'none', background:'var(--fill-danger)', color:'#fff', cursor:'pointer', fontSize:12, lineHeight:'20px', padding:0}}>×</button>
                    </div>
                  ))}
                  {fotos.length<6 && (
                    <label style={{...btnG, display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer'}}>
                      📷 Adicionar
                      <input type="file" accept="image/*" capture="environment" multiple style={{display:'none'}} onChange={e=>{ addFotos(e.target.files); e.target.value='' }} />
                    </label>
                  )}
                </div>
              </div>
              <div style={{display:'flex', gap:8}}>
                <button style={{...btnP, opacity:enviando?0.6:1}} disabled={enviando} onClick={enviarOcorrencia}>Registrar</button>
                <button style={btnG} onClick={()=>{setNovo(false); setFotos([])}}>Cancelar</button>
              </div>
            </div>
          </div>
        )}
        {ocs.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>Nenhuma ocorrência registrada.</div>}
        {ocs.map(oc => { const g = OC_GRAV[oc.gravidade]||OC_GRAV.media; return (
          <div key={oc.id} style={card}>
            <div style={{display:'flex', justifyContent:'space-between', gap:10, flexWrap:'wrap', alignItems:'flex-start'}}>
              <div>
                <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
                  <span style={{fontWeight:700, color:'var(--ink,#111)'}}>{OC_TIPO_LABEL[oc.tipo]||oc.tipo}</span>
                  <span style={{fontSize:'.68rem', fontWeight:700, color:g.c, background:g.bg, padding:'2px 8px', borderRadius:999}}>{g.l}</span>
                </div>
                <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:3}}>
                  {oc.obra_nome||'—'}{oc.colaborador_nome?` · ${oc.colaborador_nome}`:''}{souGestor?` · por ${oc.apontador_nome||'—'}`:''}
                </div>
              </div>
              <div style={{fontSize:'.76rem', color:'var(--text-secondary)'}}>{(oc.criado_em||'').slice(0,16).replace('T',' ')}</div>
            </div>
            <div style={{fontSize:'.9rem', color:'var(--ink,#111)', marginTop:8, whiteSpace:'pre-wrap'}}>{oc.descricao}</div>
            {oc.fotos && oc.fotos.length>0 && (
              <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:10}}>
                {oc.fotos.map((f,i)=>(<a key={i} href={f} target="_blank" rel="noopener noreferrer"><img src={f} alt="" style={{width:76, height:76, objectFit:'cover', borderRadius:8, border:'1px solid var(--border,#e5e7eb)'}} /></a>))}
              </div>
            )}
          </div>
        )})}
      </>}

      {tab === 'conversa' && souApontador && (
        <div style={card}>
          <div style={{fontSize:'.85rem', color:'var(--text-secondary)', marginBottom:4}}>Canal direto e exclusivo com o Diretor de Operações.</div>
          <RecChat canal={'apontador:' + user.id} titulo="Diretor de Operações" user={user} />
        </div>
      )}

      {tab === 'apontadores' && veCanais && <>
        {aps.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>Nenhum apontador cadastrado.</div>}
        {aps.map(a => (
          <div key={a.id} style={{...card, padding:0, overflow:'hidden'}}>
            <div onClick={()=>setApChat(apChat===a.id?null:a.id)} style={{display:'flex', justifyContent:'space-between', gap:10, alignItems:'center', padding:16, cursor:'pointer', flexWrap:'wrap'}}>
              <div>
                <div style={{fontWeight:700, color:'var(--ink,#111)'}}>{apChat===a.id?'▾ ':'▸ '}{a.nome}</div>
                <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:3}}>{a.ultima_msg?`"${a.ultima_msg.slice(0,60)}${a.ultima_msg.length>60?'…':''}"`:'Sem mensagens ainda'}</div>
              </div>
              <div style={{fontSize:'.72rem', color:'var(--text-secondary)'}}>{a.ultima_em?String(a.ultima_em).slice(0,16).replace('T',' '):''}</div>
            </div>
            {apChat===a.id && <div style={{padding:'0 16px 16px'}}><RecChat canal={a.canal} titulo={soLeitura?`${a.nome} ↔ Diretor`:`Conversa com ${a.nome}`} user={user} readonly={soLeitura} /></div>}
          </div>
        ))}
      </>}
    </div>
  )
}

// Indicadores do PRAZO DE PEDIDOS (GET /rec/painel → prazo): últimos 30 dias × 30 anteriores, série de
// 8 semanas, rankings por solicitante/obra e motivos. Cores das faixas = tokens de status (ok / alerta /
// perigo), sempre com rótulo. irFora: abre a lista filtrada em "Fora do prazo". configSlot: editor do Master.
const REC_FAIXA_COR = { fora: 'var(--tag-perigo-dot)', tolerado: 'var(--tag-alerta-dot)', no_prazo: 'var(--tag-ok-dot)' }
function RecPrazoIndicadores({ prazo, irFora, configSlot }) {
  const [semHover, setSemHover] = useState(null)
  if (!prazo) return null
  const { atual, anterior, config: cfg } = prazo
  const card = { background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderRadius:12, padding:16 }
  const sub = { fontSize:'.76rem', color:'var(--rec-sub)' }
  const num = v => String(Math.round(v * 10) / 10).replace('.', ',')
  // Variação contra os 30 dias anteriores. bomSeSobe: antecedência maior é melhor; % fora maior é pior.
  const delta = (a, b, unid, bomSeSobe) => {
    if (a == null || b == null || !anterior.total) return <span style={sub}>sem base nos 30 dias anteriores</span>
    const d = Math.round((a - b) * 10) / 10
    if (!d) return <span style={sub}>igual aos 30 dias anteriores</span>
    const bom = (d > 0) === bomSeSobe
    const u = typeof unid === 'function' ? unid(Math.abs(d)) : unid
    return <span style={{ ...sub, color: bom ? 'var(--success)' : 'var(--danger)', fontWeight:600 }}>{d > 0 ? '▲' : '▼'} {num(Math.abs(d))} {u} vs 30 dias anteriores</span>
  }
  const tile = (rotulo, valor, linha2, linha3, go) => (
    <div className="rec-kpi" {...linkProps(go)} style={{ ...card, flex:'1 1 180px', padding:'14px 16px' }}>
      <div style={sub}>{rotulo}</div>
      <div style={{ fontSize:'1.9rem', fontWeight:800, color:'var(--ink)', lineHeight:1.1, margin:'6px 0 4px', fontVariantNumeric:'tabular-nums' }}>{valor}</div>
      {linha2 && <div style={{ fontSize:'.8rem', color:'var(--text-secondary)' }}>{linha2}</div>}
      {linha3 && <div style={{ marginTop:3 }}>{linha3}</div>}
    </div>
  )
  // Composição (no prazo / tolerado / fora): barra única com 2px de folga entre os trechos.
  const meter = (r) => {
    const partes = [['fora', r.fora, 'Fora do prazo'], ['tolerado', r.tolerado, 'Tolerado'], ['no_prazo', r.no_prazo, 'No prazo']].filter(p => p[1] > 0)
    return (
      <div style={{ display:'flex', gap:2, height:8, borderRadius:4, overflow:'hidden', background:'var(--rec-gray-soft)', marginTop:8 }} role="img"
        aria-label={partes.map(p => `${p[2]}: ${p[1]}`).join(', ')}>
        {partes.map(p => <div key={p[0]} title={`${p[2]}: ${p[1]}`} style={{ flex:`${p[1]} 1 0`, background:REC_FAIXA_COR[p[0]] }} />)}
      </div>
    )
  }
  const legenda = (
    <div style={{ display:'flex', gap:14, flexWrap:'wrap', fontSize:'.74rem', color:'var(--text-secondary)' }}>
      {[['fora', 'Fora do prazo'], ['tolerado', 'Tolerado'], ['no_prazo', 'No prazo']].map(([k, l]) => (
        <span key={k} style={{ display:'inline-flex', alignItems:'center', gap:6 }}><span style={{ width:10, height:10, borderRadius:2, background:REC_FAIXA_COR[k] }} />{l}</span>))}
    </div>
  )
  const semanas = prazo.semanas || []
  const maxSem = Math.max(1, ...semanas.map(w => w.total))
  const H = 120
  const tabela = (titulo, linhas, vazio) => (
    <div style={{ ...card, flex:'1 1 300px', minWidth:0 }}>
      <div style={{ fontWeight:700, color:'var(--ink)', marginBottom:8 }}>{titulo}</div>
      {!linhas.length ? <div style={sub}>{vazio}</div> : (
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'.82rem', tableLayout:'fixed' }}>
          <colgroup><col /><col style={{ width:62 }} /><col style={{ width:44 }} /><col style={{ width:54 }} /></colgroup>
          <thead><tr>
            {['Nome', 'Pedidos', 'Fora', '%'].map((h, i) => <th key={h} style={{ padding:'6px 0 6px ' + (i ? '6px' : '0'), textAlign: i ? 'right' : 'left', background:'transparent', fontSize:'.68rem', borderBottomWidth:1 }}>{h}</th>)}
          </tr></thead>
          <tbody>{linhas.map((l, i) => (
            <tr key={i}>
              <td style={{ padding:'7px 6px 7px 0', color:'var(--ink)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={l.nome || ''}>{l.nome || '— sem obra —'}</td>
              <td style={{ padding:'7px 0', textAlign:'right', fontVariantNumeric:'tabular-nums' }}>{l.total}</td>
              <td style={{ padding:'7px 0', textAlign:'right', fontVariantNumeric:'tabular-nums', color: l.fora ? 'var(--tag-perigo-fg)' : 'var(--text-secondary)', fontWeight: l.fora ? 700 : 400 }}>{l.fora}</td>
              <td style={{ padding:'7px 0', textAlign:'right', fontVariantNumeric:'tabular-nums' }}>{num(l.pct)}%</td>
            </tr>))}</tbody>
        </table>
      )}
    </div>
  )
  const maxMot = Math.max(1, ...(prazo.por_motivo || []).map(m => m.n))
  const vazioTudo = !atual.total && !anterior.total
  return (
    <div style={{ marginBottom:14 }}>
      <div style={{ display:'flex', alignItems:'baseline', gap:10, flexWrap:'wrap', margin:'4px 0 10px' }}>
        <span style={{ fontWeight:800, color:'var(--ink)', fontSize:'1rem', display:'inline-flex', alignItems:'center', gap:7 }}><Icon name="clock" size={16} /> Prazo de pedidos</span>
        <span style={sub}>últimos 30 dias · mínimo {recDiasUteis(cfg.vigente)}, padrão {recDiasUteis(cfg.alvo)} · modo {REC_MODO_LABEL[cfg.modo]}</span>
      </div>
      {vazioTudo ? <div style={{ ...card, ...sub, marginBottom:12 }}>Nenhum pedido com data de necessidade ainda. Os pedidos abertos a partir de agora aparecem aqui; os antigos ficam "sem data".</div> : <>
        <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:12 }}>
          {tile('Fora do prazo', `${num(atual.pct_fora)}%`, `${atual.fora} de ${atual.total} pedido${atual.total === 1 ? '' : 's'}`, delta(atual.pct_fora, anterior.pct_fora, 'p.p.', false), atual.fora && irFora ? irFora : null)}
          {tile('Antecedência mediana', atual.mediana == null ? '—' : recDiasUteis(Math.round(atual.mediana * 10) / 10).replace('.', ','), `padrão: ${recDiasUteis(cfg.alvo)}`, delta(atual.mediana, anterior.mediana, n => n === 1 ? 'dia útil' : 'dias úteis', true))}
          <div style={{ ...card, flex:'1 1 220px', padding:'14px 16px' }}>
            <div style={sub}>Pedidos com data</div>
            <div style={{ fontSize:'1.9rem', fontWeight:800, color:'var(--ink)', lineHeight:1.1, margin:'6px 0 0', fontVariantNumeric:'tabular-nums' }}>{atual.total}</div>
            {atual.total > 0 && meter(atual)}
            <div style={{ fontSize:'.76rem', color:'var(--text-secondary)', marginTop:6 }}>{atual.fora} fora · {atual.tolerado} tolerado{atual.tolerado === 1 ? '' : 's'} · {atual.no_prazo} no prazo</div>
          </div>
        </div>

        <div style={{ ...card, marginBottom:12 }}>
          <div style={{ display:'flex', justifyContent:'space-between', gap:10, flexWrap:'wrap', marginBottom:10 }}>
            <span style={{ fontWeight:700, color:'var(--ink)' }}>Últimas 8 semanas</span>{legenda}
          </div>
          <div style={{ display:'flex', alignItems:'flex-end', gap:6, height:H + 22, borderBottom:'1px solid var(--border)', paddingTop:4 }} onMouseLeave={() => setSemHover(null)}>
            {semanas.map((w, i) => {
              const h = w.total ? Math.max(4, Math.round(w.total / maxSem * H)) : 0
              const seg = [['fora', w.fora], ['tolerado', w.tolerado], ['no_prazo', w.total - w.fora - w.tolerado]].filter(x => x[1] > 0)
              return (
                <div key={w.inicio} style={{ flex:1, minWidth:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'flex-end', height:'100%', cursor: w.total ? 'pointer' : 'default' }}
                  onMouseEnter={() => setSemHover(i)} onClick={() => setSemHover(semHover === i ? null : i)}>
                  {w.total > 0 && (semHover === i || i === semanas.length - 1) && <div style={{ fontSize:'.68rem', fontWeight:700, color:'var(--ink)', marginBottom:3, fontVariantNumeric:'tabular-nums' }}>{num(w.pct_fora)}%</div>}
                  <div style={{ width:'100%', maxWidth:34, height:h, display:'flex', flexDirection:'column-reverse', gap: h > 8 ? 2 : 0, borderRadius:'4px 4px 0 0', overflow:'hidden', opacity: semHover == null || semHover === i ? 1 : .55 }}>
                    {seg.map(([k, n]) => <div key={k} style={{ flex:`${n} 1 0`, background:REC_FAIXA_COR[k] }} />)}
                  </div>
                </div>
              )
            })}
          </div>
          <div style={{ display:'flex', gap:6, marginTop:5 }}>
            {semanas.map(w => <div key={w.inicio} style={{ flex:1, minWidth:0, textAlign:'center', fontSize:'.66rem', color:'var(--rec-sub)', fontVariantNumeric:'tabular-nums' }}>{recDM(w.inicio)}</div>)}
          </div>
          {/* Leitura da semana apontada (toque ou mouse); sem seleção, a semana atual. */}
          {(() => {
            const w = semanas[semHover == null ? semanas.length - 1 : semHover]
            if (!w) return null
            return (
              <div aria-live="polite" style={{ marginTop:10, fontSize:'.78rem', color:'var(--text-secondary)' }}>
                <strong style={{ color:'var(--ink)' }}>Semana de {recDM(w.inicio)}{semHover == null ? ' (atual)' : ''}:</strong>{' '}
                {w.total ? <>{w.total} pedido{w.total === 1 ? '' : 's'} · {w.fora} fora ({num(w.pct_fora)}%) · {w.tolerado} tolerado{w.tolerado === 1 ? '' : 's'} · {w.total - w.fora - w.tolerado} no prazo</> : 'nenhum pedido'}
              </div>
            )
          })()}
        </div>

        <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginBottom:12 }}>
          {tabela('Por solicitante', prazo.por_solicitante || [], 'Nenhum pedido nos últimos 30 dias.')}
          {tabela('Por obra', prazo.por_obra || [], 'Nenhum pedido nos últimos 30 dias.')}
        </div>

        <div style={{ ...card, marginBottom:12 }}>
          <div style={{ fontWeight:700, color:'var(--ink)', marginBottom:8 }}>Motivos dos pedidos fora do prazo</div>
          {!(prazo.por_motivo || []).length && <div style={sub}>Nenhum pedido fora do prazo nos últimos 30 dias.</div>}
          {(prazo.por_motivo || []).map(m => (
            <div key={m.motivo || 'sem'} style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr) minmax(60px,34%) 28px', gap:10, alignItems:'center', padding:'4px 0' }}>
              <span style={{ fontSize:'.8rem', color:'var(--ink)' }}>{m.rotulo}</span>
              <div style={{ height:8, borderRadius:4, background:'var(--rec-gray-soft)', overflow:'hidden' }}><div style={{ width:`${Math.round(m.n / maxMot * 100)}%`, height:'100%', background:'var(--rec-navy)', borderRadius:4 }} /></div>
              <strong style={{ fontSize:'.82rem', textAlign:'right', fontVariantNumeric:'tabular-nums' }}>{m.n}</strong>
            </div>
          ))}
        </div>
      </>}
      {configSlot}
    </div>
  )
}

// Configuração do prazo (só o Master): prazo padrão, mínimo cobrado hoje (rampa 3 → 7 → 10 → 15) e o
// modo do fora do prazo. Cada troca vai para a auditoria no servidor.
const REC_MODO_DESC = {
  medir: 'Classifica e mede. Não pede nada a quem faz o pedido.',
  justificar: 'Antes do mínimo a data fica bloqueada. Só emergência passa, com o impacto descrito; vai como Urgente e o gerente é avisado.',
  aprovar: 'Fora do prazo espera o gerente do contrato aprovar. Emergência segue direto.',
}
function RecPrazoConfig({ cfg, addToast, onSalvo }) {
  const doCfg = () => ({ alvo: cfg.alvo, vigente: cfg.vigente, modo: cfg.modo, emergencias: cfg.emergencias })
  const [f, setF] = useState(doCfg)
  const [salvando, setSalvando] = useState(false)
  useEffect(() => { setF(doCfg()) }, [cfg.alvo, cfg.vigente, cfg.modo, cfg.emergencias])
  const mudou = Number(f.alvo) !== cfg.alvo || Number(f.vigente) !== cfg.vigente || f.modo !== cfg.modo || Number(f.emergencias) !== cfg.emergencias
  const salvar = async (nova) => {
    setSalvando(true)
    try {
      const r = await PUT('/rec/prazo-config', { alvo: Number(nova.alvo), vigente: Number(nova.vigente), modo: nova.modo, emergencias: Number(nova.emergencias) })
      addToast(r.liberados ? `Regra salva. ${r.liberados} pedido(s) que esperavam aprovação seguiram.` : 'Regra do prazo salva.', 'success')
      onSalvo && onSalvo()
    } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }
  const inp = { padding:'7px 9px', border:'1px solid var(--border)', borderRadius:8, background:'var(--surface)', color:'var(--ink)', fontSize:'.9rem', width:84 }
  const lbl = { display:'grid', gap:4, fontSize:'.78rem', color:'var(--text-secondary)' }
  const rampa = (cfg.rampa || [3, 7, 10, 15]).filter(d => d <= cfg.alvo)
  return (
    <div style={{ background:'var(--card)', border:'1px solid var(--border)', borderLeft:'4px solid var(--accent)', borderRadius:12, padding:16, display:'grid', gap:12 }}>
      <div style={{ display:'flex', alignItems:'baseline', gap:10, flexWrap:'wrap' }}>
        <strong style={{ color:'var(--ink)' }}>Regra do prazo</strong>
        <span style={{ fontSize:'.74rem', color:'var(--text-secondary)' }}>só o administrador master altera{cfg.alterado ? ` · última alteração: ${cfg.alterado.por || '—'} em ${recDM(cfg.alterado.em)}` : ''}</span>
      </div>
      <div style={{ display:'flex', gap:14, flexWrap:'wrap', alignItems:'flex-end' }}>
        <label style={lbl}>Prazo padrão (dias úteis)<input style={inp} type="number" min="1" max="60" value={f.alvo} onChange={e => setF({ ...f, alvo: e.target.value })} /></label>
        <label style={lbl}>Mínimo cobrado hoje (dias úteis)<input style={inp} type="number" min="0" value={f.vigente} onChange={e => setF({ ...f, vigente: e.target.value })} /></label>
        <label style={lbl} title="Depois disso, a emergência só segue com o OK do gerente do contrato. 0 = sem limite.">Emergências por pessoa no mês<input style={inp} type="number" min="0" max="30" value={f.emergencias} onChange={e => setF({ ...f, emergencias: e.target.value })} /></label>
        <div style={{ display:'grid', gap:4 }}>
          <span style={{ fontSize:'.78rem', color:'var(--text-secondary)' }}>Rampa sugerida</span>
          <div style={{ display:'flex', alignItems:'center', gap:4, flexWrap:'wrap', fontSize:'.8rem' }}>
            {rampa.map((d, i) => <React.Fragment key={d}>
              {i > 0 && <span style={{ color:'var(--silver)' }}>→</span>}
              <span style={{ padding:'3px 9px', borderRadius:999, fontWeight:700, fontVariantNumeric:'tabular-nums',
                background: d === cfg.vigente ? 'var(--fill-steel)' : 'transparent', color: d === cfg.vigente ? '#fff' : d < cfg.vigente ? 'var(--text-secondary)' : 'var(--ink)',
                border: '1px solid ' + (d === cfg.vigente ? 'var(--fill-steel)' : 'var(--border)') }}>{d}</span>
            </React.Fragment>)}
          </div>
        </div>
        {cfg.proximo_degrau != null && !mudou && (
          <button className="btn btn-outline btn-sm" disabled={salvando} onClick={() => salvar({ ...cfg, vigente: cfg.proximo_degrau })}>Avançar o mínimo para {recDiasUteis(cfg.proximo_degrau)}</button>
        )}
      </div>
      <div style={{ display:'grid', gap:6 }}>
        <span style={{ fontSize:'.78rem', color:'var(--text-secondary)' }}>Pedido fora do prazo</span>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(190px, 1fr))', gap:8 }}>
          {['medir', 'justificar', 'aprovar'].map(m => (
            <label key={m} style={{ display:'flex', gap:8, alignItems:'flex-start', padding:'9px 11px', borderRadius:10, cursor:'pointer',
              border: '1px solid ' + (f.modo === m ? 'var(--primary-accent)' : 'var(--border)'), background: f.modo === m ? 'var(--surface)' : 'transparent' }}>
              <input type="radio" name="rec-modo" checked={f.modo === m} onChange={() => setF({ ...f, modo: m })} style={{ marginTop:3, width:'auto' }} />
              <span><strong style={{ color:'var(--ink)', fontSize:'.86rem' }}>{REC_MODO_LABEL[m]}</strong><br /><span style={{ fontSize:'.76rem', color:'var(--text-secondary)' }}>{REC_MODO_DESC[m]}</span></span>
            </label>
          ))}
        </div>
      </div>
      {mudou && <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
        <button className="btn btn-primary btn-sm" disabled={salvando} onClick={() => salvar(f)}>{salvando ? 'Salvando…' : 'Salvar regra'}</button>
        <button className="btn btn-ghost btn-sm" disabled={salvando} onClick={() => setF(doCfg())}>Descartar</button>
      </div>}
    </div>
  )
}

// Indicadores do REC (dados de GET /rec/painel). Componente ÚNICO usado na sub-aba REC › Painel e
// no Painel Geral do almoxarifado — o que mudar aqui muda nos dois lugares.
// irAba(tab, filtro): abre a sub-aba do REC já filtrada (no Painel Geral navega; na aba Painel do
// REC só troca a sub-aba). irEstoque: abre Estoque › Saldo. Nulos = indicador só de leitura.
// Compras não tem destino aqui: a aba Compras é só do time de Compras/Administração.
function RecPainelIndicadores({ painel, irAba, irEstoque, prazoConfig, veEmCompras }) {
  const card = { background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderRadius:12, padding:16, marginBottom:14 }
  if (!painel) return <div style={{...card, color:'var(--text-secondary)'}}>Carregando indicadores…</div>
  const sol = painel.solicitacoes||{}, rem = painel.remessas||{}, comp = painel.compras||{}
  const prio = painel.prioridades_compras||[]
  const venceHoje = o => o.vence_hoje || 0
  const totAtraso = prio.reduce((s,o)=>s+(o.atrasadas||0),0)
  const totHoje = prio.reduce((s,o)=>s+venceHoje(o),0)
  const fmtDM = p => p ? `${String(p).slice(8,10)}/${String(p).slice(5,7)}` : '—'
  const ir = (tab, filtro) => irAba ? () => irAba(tab, filtro) : null
  // KPI com ícone + faixa de cor no topo; aceita um "extra" (ex.: pílula de atraso) e o destino (go).
  const kpi = (label, valor, cor, corSoft, icon, extra, go) => (
    <div className="rec-kpi" {...linkProps(go)} style={{...card, flex:'1 1 140px', margin:0, paddingTop:18, position:'relative', overflow:'hidden'}}>
      <div style={{position:'absolute', top:0, left:0, right:0, height:3, background:cor}}/>
      <div style={{width:34, height:34, borderRadius:9, background:corSoft, display:'flex', alignItems:'center', justifyContent:'center', marginBottom:11, color:cor}}>{icon}</div>
      <div style={{display:'flex', alignItems:'baseline', gap:8, flexWrap:'wrap'}}>
        <div style={{fontSize:'2rem', fontWeight:800, color:cor, lineHeight:1}}>{valor||0}</div>
        {extra}
      </div>
      <div style={{fontSize:'.78rem', color:'var(--rec-sub)', marginTop:6}}>{label}</div>
    </div>
  )
  // Mini-barras proporcionais para "por status"; cada linha abre a sub-aba filtrada naquele status.
  const barras = (obj, cor, tab) => {
    const es = Object.entries(obj)
    const max = Math.max(1, ...es.map(([,v])=>v))
    // 'em_compras' não chega à lista do almoxarife (é do time de Compras) → para ele, linha só informativa.
    return es.map(([k,v])=>(
      <div key={k} className="lk-row" {...linkProps(k === 'em_compras' && !veEmCompras ? null : ir(tab, { [tab === 'remessas' ? 'rem' : 'sol']: [k], rotulo: `${tab === 'remessas' ? 'Remessas' : 'Solicitações'} · ${REC_STATUS_LABEL[k] || k}` }))} style={{display:'flex', alignItems:'center', gap:10, padding:'4px 0'}}>
        <span style={{minWidth:100, flexShrink:0}}><RecStatus s={k}/></span>
        <div style={{flex:1, height:8, borderRadius:999, background:'var(--rec-gray-soft)', overflow:'hidden'}}><div style={{width:`${Math.round(v/max*100)}%`, height:'100%', background:cor}}/></div>
        <strong style={{fontSize:'.85rem', minWidth:18, textAlign:'right'}}>{v}</strong>
      </div>
    ))
  }
  const ANDAMENTO = ['solicitada','analisando','reservada','separada','em_transporte']
  const emAndamento = ANDAMENTO.reduce((t, k) => t + (sol[k] || 0), 0)
  const pill = (txt, cls) => <span className={`rtag rtag-sm ${cls}`}>{txt}</span>
  const ic = { clip:<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="8" y="3" width="8" height="4" rx="1"/><path d="M9 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3"/><path d="M9 12h6M9 16h4"/></svg>,
    truck:<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h11v9H3z"/><path d="M14 9h3l3 3v3h-6z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>,
    cart:<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h2l2.4 12.2a1.5 1.5 0 0 0 1.5 1.2h9.1a1.5 1.5 0 0 0 1.5-1.2L21 7H5"/></svg>,
    alert:<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M10.3 3.7 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.7a2 2 0 0 0-3.4 0Z"/><path d="M12 9v4M12 17h.01"/></svg>,
    check:<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.1V12a9 9 0 1 1-5.3-8.2"/><path d="m9 11 3 3L22 4"/></svg>,
    build:<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01"/></svg> }
  return <>
    <div style={{display:'flex', gap:12, flexWrap:'wrap', marginBottom:14}}>
      {kpi('Solicitações em andamento', emAndamento, 'var(--rec-navy)', 'var(--rec-navy-soft)', ic.clip, null, ir('solicitacoes', { sol: ANDAMENTO, rotulo: 'Solicitações em andamento' }))}
      {kpi('Remessas em trânsito', rem.em_transporte, 'var(--rec-amber)', 'var(--rec-amber-soft)', ic.truck, null, ir('remessas', { rem: ['em_transporte'], rotulo: 'Remessas em trânsito' }))}
      {kpi('Compras em aberto', (comp.recebida||0)+(comp.em_cotacao||0)+(comp.comprada||0), 'var(--rec-amber)', 'var(--rec-amber-soft)', ic.cart,
        totAtraso>0 ? pill(`${totAtraso} atrasada${totAtraso>1?'s':''}`, 'tg-perigo')
        : totHoje>0 ? pill(`${totHoje} p/ hoje`, 'tg-alerta') : null)}
      {kpi('Divergências abertas', painel.divergencias_abertas, painel.divergencias_abertas?'var(--rec-urg-fg)':'var(--rec-gray)', painel.divergencias_abertas?'var(--rec-urg-bg)':'var(--rec-gray-soft)', ic.alert, null, ir('remessas', { div: true, rotulo: 'Remessas com divergência aberta' }))}
      {kpi('Entregues', sol.entregue, 'var(--rec-green)', 'var(--rec-green-soft)', ic.check, null, ir('solicitacoes', { sol: ['entregue'], rotulo: 'Solicitações entregues' }))}
    </div>

    <RecPrazoIndicadores prazo={painel.prazo} irFora={ir('solicitacoes', { fora: true, rotulo: 'Solicitações fora do prazo' })} configSlot={prazoConfig} />

    {(painel.valor_compras_aberto||0) > 0 && (
      <div style={{...card, margin:'0 0 12px', borderLeft:'4px solid var(--accent, #A07C4E)', display:'flex', alignItems:'center', gap:10, flexWrap:'wrap'}}>
        <span style={{fontSize:'.82rem', color:'var(--rec-sub)'}}>Valor total em compras (em aberto):</span>
        <strong style={{fontSize:'1.15rem', color:'var(--accent, #A07C4E)'}}>{fmtBRL(painel.valor_compras_aberto)}</strong>
      </div>
    )}

    {/* Prioridades do comprador: obras com compras em aberto, mais críticas primeiro. */}
    <div style={{...card, margin:'0 0 12px'}}>
      <div style={{display:'flex', alignItems:'center', gap:9, marginBottom:12, flexWrap:'wrap'}}>
        <span style={{color:'var(--rec-navy)', display:'flex'}}>{ic.build}</span>
        <span style={{fontWeight:700, color:'var(--ink,#111)'}}>Prioridades — obras com compras em aberto</span>
      </div>
      {prio.length===0 && <div style={{color:'var(--rec-sub)', fontSize:'.85rem'}}>Nenhuma compra em aberto.</div>}
      {prio.map((o,i)=>{
        const nome = o.obra_nome || '— sem obra —'
        const pi = recPrazoInfo(o.proximo_prazo, 'recebida')
        const prazoCor = pi ? (pi.kind==='atrasado'?'var(--rec-urg-fg)':'var(--rec-amber)') : 'var(--ink,#111)'
        const prazoTag = pi ? (pi.kind==='atrasado'?' (atrasado)':' (hoje)') : ''
        const pct = o.abertas ? Math.round(((o.atrasadas||0)/o.abertas)*100) : 0
        const barCor = o.atrasadas ? 'var(--rec-urg-fg)' : venceHoje(o) ? 'var(--rec-amber)' : 'var(--rec-green)'
        return (
          <div key={i} style={{display:'flex', alignItems:'center', gap:14, padding:'11px 0', borderTop:'1px solid var(--border,#eef1f4)', flexWrap:'wrap'}}>
            <div style={{flex:'1 1 240px', minWidth:0}}>
              <div style={{fontWeight:700, fontSize:'.9rem', color:'var(--ink,#111)'}}>{nome}</div>
              <div style={{fontSize:'.76rem', color:'var(--rec-sub)', marginTop:2}}>{o.abertas} em aberto · prazo mais próximo <strong style={{color:prazoCor}}>{fmtDM(o.proximo_prazo)}{prazoTag}</strong></div>
            </div>
            <div style={{display:'flex', alignItems:'center', gap:8, flexShrink:0, flexWrap:'wrap'}}>
              {o.atrasadas>0 && pill(`${o.atrasadas} atrasada${o.atrasadas>1?'s':''}`, 'tg-perigo')}
              {venceHoje(o)>0 && pill(`${venceHoje(o)} vence hoje`, 'tg-alerta')}
              {o.urgentes>0 && pill(`${o.urgentes} urgente${o.urgentes>1?'s':''}`, 'caps tg-urgente')}
            </div>
            <div style={{width:140, flexShrink:0}}>
              <div style={{height:8, borderRadius:999, background:'var(--rec-gray-soft)', overflow:'hidden'}}><div style={{width:`${Math.max(pct,o.abertas?8:0)}%`, height:'100%', background:barCor}}/></div>
            </div>
          </div>
        )
      })}
      {prio.length>0 && <div style={{marginTop:10, fontSize:'.72rem', color:'var(--rec-sub)'}}>Ordenado por atraso e prazo mais próximo. Detalhe e ações na aba <strong>Compras</strong>.</div>}
    </div>

    <div style={{display:'flex', gap:12, flexWrap:'wrap'}}>
      <div style={{...card, flex:'1 1 300px', margin:0}}>
        <div style={{fontWeight:700, color:'var(--ink,#111)', marginBottom:8}}>Solicitações por status</div>
        {Object.keys(sol).length===0 && <div style={{color:'var(--rec-sub)', fontSize:'.85rem'}}>Nenhuma.</div>}
        {barras(sol, 'var(--rec-navy)', 'solicitacoes')}
      </div>
      <div style={{...card, flex:'1 1 300px', margin:0}}>
        <div style={{fontWeight:700, color:'var(--ink,#111)', marginBottom:8}}>Remessas por status</div>
        {Object.keys(rem).length===0 && <div style={{color:'var(--rec-sub)', fontSize:'.85rem'}}>Nenhuma.</div>}
        {barras(rem, 'var(--rec-amber)', 'remessas')}
      </div>
      <div className="rec-kpi" {...linkProps(irEstoque)} style={{...card, flex:'1 1 200px', margin:0}}>
        <div style={{fontWeight:700, color:'var(--ink,#111)', marginBottom:8}}>Base</div>
        <div style={{display:'flex', justifyContent:'space-between', fontSize:'.85rem', padding:'3px 0'}}><span style={{color:'var(--rec-sub)'}}>Itens cadastrados</span><strong>{painel.catalogo}</strong></div>
        <div style={{display:'flex', justifyContent:'space-between', fontSize:'.85rem', padding:'3px 0'}}><span style={{color:'var(--rec-sub)'}}>Depósitos ativos</span><strong>{painel.depositos}</strong></div>
      </div>
    </div>
  </>
}

// Busca de item do catálogo na solicitação do REC: lupa + lista dividida em "disponíveis" e
// "sem estoque" — o engenheiro não precisa rolar o catálogo inteiro num menu suspenso. Diz só SE
// tem (não quanto): o split por quantidade (parte que excede o saldo vai para Compras) é do sistema.
const recNorm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
const REC_BUSCA_MAX = 60   // por seção; acima disso pede para refinar (catálogo pode ter milhares)
const recTem = c => c.saldo_total > 0
// Fotos de item do REC (engenheiro anexa para Compras acertar item específico). As listas trazem só
// os ids; cada foto é buscada uma vez e fica em memória enquanto o app estiver aberto.
const REC_FOTOS_ITEM = 3
const recFotoCache = new Map()
function recFotoCarregar(id) {
  if (!recFotoCache.has(id)) recFotoCache.set(id, GET('/rec/fotos/' + id).then(r => r.foto).catch(e => { recFotoCache.delete(id); throw e }))
  return recFotoCache.get(id)
}
// destino: 'estoque' (retirada comum, chega à Sede) | 'unidade' (o motorista leva do fornecedor direto à unidade do
// pedido, numa remessa direta); junto = outras compras do mesmo pedido que vão na mesma viagem.
const ENC_VAZIO = { resp: '', fornecedor: '', endereco: '', contato: '', obs: '', destino: 'estoque', junto: [] }
const REC_TRANSPORTADORES_FRONT = ['logistica', 'motorista', 'condutor']
// Onde buscar o material comprado: o FORNECEDOR (é pelo nome que a equipe conhece o local), endereço
// se houver (abre no mapa; sem endereço, o mapa busca pelo nome), contato (liga) e observação.
function RecRetiradaLocal({ rc }) {
  if (!rc.retirada_endereco && !rc.fornecedor) return null
  const tel = (rc.retirada_contato || '').replace(/\D/g, '')
  const lnk = { color: 'var(--primary-accent)', fontWeight: 600, textDecoration: 'none', whiteSpace: 'nowrap' }
  const mapa = q => 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(q)
  return (
    <div style={{marginTop:8, padding:'10px 12px', background:'var(--rec-amber-soft)', borderRadius:8, fontSize:'.84rem', color:'var(--ink,#111)', display:'grid', gap:4}}>
      <div style={{display:'flex', gap:8, alignItems:'flex-start'}}>
        <span style={{color:'var(--rec-amber)', marginTop:1}}><Icon name="mapPin" size={16}/></span>
        <div style={{minWidth:0}}>
          {rc.fornecedor && <div style={{fontWeight:700}}>{rc.fornecedor}{!rc.retirada_endereco && <> · <a href={mapa(rc.fornecedor)} target="_blank" rel="noopener noreferrer" style={lnk}>Buscar no mapa ↗</a></>}</div>}
          {rc.retirada_endereco && <div>{rc.retirada_endereco} · <a href={mapa(rc.retirada_endereco)} target="_blank" rel="noopener noreferrer" style={lnk}>Abrir no mapa ↗</a></div>}
        </div>
      </div>
      {rc.retirada_contato && <div style={{display:'flex', gap:8, alignItems:'center', paddingLeft:24}}>
        <span style={{color:'var(--rec-sub)'}}><Icon name="phone" size={13}/></span>
        {tel.length >= 8 ? <a href={'tel:' + tel} style={lnk}>{rc.retirada_contato}</a> : <span>{rc.retirada_contato}</span>}
      </div>}
      {rc.retirada_obs && <div style={{paddingLeft:24, color:'var(--rec-sub)', fontStyle:'italic'}}>{rc.retirada_obs}</div>}
    </div>
  )
}
function RecFotos({ ids, size = 56 }) {
  const [srcs, setSrcs] = useState({})
  const [zoom, setZoom] = useState(null)
  const chave = (ids || []).join(',')
  useEffect(() => {
    let vivo = true
    ;(ids || []).forEach(id => recFotoCarregar(id).then(src => { if (vivo) setSrcs(m => ({ ...m, [id]: src })) }).catch(() => {}))
    return () => { vivo = false }
  }, [chave])
  if (!ids || !ids.length) return null
  return (
    <div style={{display:'flex', gap:6, flexWrap:'wrap', marginTop:8}}>
      {ids.map(id => srcs[id]
        ? <img key={id} src={srcs[id]} alt="foto do item" title="Ampliar" onClick={() => setZoom(srcs[id])} style={{width:size, height:size, objectFit:'cover', borderRadius:8, border:'1px solid var(--border,#e5e7eb)', cursor:'zoom-in'}} />
        : <div key={id} style={{width:size, height:size, borderRadius:8, background:'var(--silver-light,#f1f5f9)', border:'1px solid var(--border,#e5e7eb)'}} />)}
      {zoom && (
        <div className="foto-lightbox" onClick={() => setZoom(null)}>
          <img src={zoom} alt="foto do item ampliada" onClick={e => e.stopPropagation()} />
          <button className="foto-lightbox-x" onClick={() => setZoom(null)}><Icon name="x" size={20} /></button>
        </div>
      )}
    </div>
  )
}
function RecItemBusca({ cat, value, onEscolher, onDescrever, style }) {
  const [aberto, setAberto] = useState(false)
  const sel = value ? cat.find(c => String(c.id) === String(value)) : null
  return <>
    <button type="button" className="rib-campo" style={style} onClick={() => setAberto(true)} title="Buscar item do catálogo">
      <Icon name="search" size={15} />
      {sel ? <span className="rib-campo-tt">{sel.nome}</span> : <span className="rib-campo-tt rib-ph">Buscar item do catálogo…</span>}
      {sel && <span className={`rib-tag ${recTem(sel) ? 'ok' : 'falta'}`}>{recTem(sel) ? 'disponível' : 'sem estoque'}</span>}
    </button>
    {aberto && <RecItemBuscaLista cat={cat} onFechar={() => setAberto(false)}
      onEscolher={c => { onEscolher(c); setAberto(false) }} onDescrever={t => { onDescrever(t); setAberto(false) }} />}
  </>
}
function RecItemBuscaLista({ cat, onFechar, onEscolher, onDescrever }) {
  const [q, setQ] = useState('')
  const [sel, setSel] = useState(0)
  const inputRef = useRef(null)
  const listRef = useRef(null)
  const indice = React.useMemo(() => cat.map(c => [c, semAcento([c.nome, c.codigo_vobi, c.categoria].filter(Boolean).join(' '))])
    .sort((a, b) => a[0].nome.localeCompare(b[0].nome, 'pt')), [cat])
  const termos = termosBusca(q)
  const achados = indice.filter(([, t]) => casaTermos(termos, t)).map(([c]) => c)
  const disp = achados.filter(recTem), falta = achados.filter(c => !recTem(c))
  const vDisp = disp.slice(0, REC_BUSCA_MAX), vFalta = falta.slice(0, REC_BUSCA_MAX)
  const texto = q.trim()
  const nav = [...vDisp, ...vFalta, ...(texto ? ['descrever'] : [])]   // ordem das setas do teclado
  useEffect(() => { if (inputRef.current) inputRef.current.focus() }, [])
  useEffect(() => { setSel(0) }, [q])
  useEffect(() => { const el = listRef.current && listRef.current.querySelector('.cmd-item.on'); if (el) el.scrollIntoView({ block: 'nearest' }) }, [sel])
  const escolher = x => { if (x === 'descrever') onDescrever(texto); else if (x) onEscolher(x) }
  const onKey = e => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setSel(s => Math.min(s + 1, nav.length - 1)) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setSel(s => Math.max(s - 1, 0)) }
    else if (e.key === 'Enter') { e.preventDefault(); escolher(nav[sel]) }
    else if (e.key === 'Escape') { e.preventDefault(); onFechar() }
  }
  const linha = (c, i) => (
    <button key={c.id} type="button" className={`cmd-item ${i === sel ? 'on' : ''}`} onMouseEnter={() => setSel(i)} onClick={() => escolher(c)}>
      <span className="cmd-tt">{c.nome}{c.unidade ? <span className="cmd-sub"> ({c.unidade})</span> : null}
        {(c.codigo_vobi || c.categoria) && <span className="rib-sub">{[c.codigo_vobi, c.categoria].filter(Boolean).join(' · ')}</span>}</span>
      <span className={`rib-tag ${recTem(c) ? 'ok' : 'falta'}`}>{recTem(c) ? 'disponível' : 'sem estoque'}</span>
    </button>)
  const secao = (cls, titulo, total, vis, base, vazio) => <>
    <div className={`rib-sec ${cls}`}>{titulo}<span className="rib-sec-n">{total}</span></div>
    {vis.length ? vis.map((c, k) => linha(c, base + k)) : <div className="rib-vazio">{vazio}</div>}
    {total > vis.length && <div className="rib-vazio">+ {total - vis.length} item(ns) — digite mais para refinar</div>}
  </>
  return (
    <div className="cmd-overlay rib-overlay" onClick={onFechar}>
      <div className="cmd-box" onClick={e => e.stopPropagation()}>
        <div className="cmd-inrow">
          <Icon name="search" size={18} />
          <input ref={inputRef} className="cmd-input" value={q} onChange={e => setQ(e.target.value)} onKeyDown={onKey}
            placeholder="Nome, código ou categoria…" />
          <button type="button" className="rib-fechar" onClick={onFechar} title="Fechar">×</button>
        </div>
        <div className="cmd-list" ref={listRef}>
          {secao('ok', 'Disponíveis em estoque', disp.length, vDisp, 0, termos.length ? 'Nenhum item disponível com esse nome.' : 'Nenhum item com saldo no momento.')}
          {secao('falta', 'Sem estoque — vai para Compras', falta.length, vFalta, vDisp.length, termos.length ? 'Nenhum.' : 'Todos os itens têm saldo.')}
          {texto && <button type="button" className={`cmd-item rib-descrever ${sel === nav.length - 1 ? 'on' : ''}`} onMouseEnter={() => setSel(nav.length - 1)} onClick={() => escolher('descrever')}>
            <span className="cmd-tt">Não achou? Pedir “{texto}” fora do catálogo <span className="cmd-sub">— vai para Compras</span></span></button>}
        </div>
      </div>
    </div>
  )
}

// Barra de filtros das listas do REC. Linha 1: situação com contagem ("Aguardando você" = o que está na mão
// de quem olha, mesma conta do badge do menu) + atalhos liga/desliga (fora do prazo, divergência). Linha 2,
// só em lista longa: busca, seletores (obra, quem pediu…) e ordem. `sit` null = filtro de um card do painel
// no lugar (a faixa "Mostrando…" diz qual); clicar numa situação volta para a barra.
function RecFiltros({ sit, onSit, sits, atalhos = [], campos, busca, onBusca, placeholder, selects = [], ordem, n, onLimpar }) {
  const algum = !!busca || selects.some(s => s.value) || atalhos.some(a => a.on)
  const [buscaCampo, mudarBusca] = useBuscaAdiada(busca, onBusca)
  return (
    <div className="recf">
      <div className="recf-sit" role="group" aria-label="Situação">
        {sits.map(o => (
          <button key={o.id} type="button" aria-pressed={sit === o.id} onClick={() => onSit(o.id)}
            className={'recf-chip' + (sit === o.id ? ' on' : '') + (o.alerta && o.n > 0 ? ' alerta' : '')}>
            {o.label}<span className="recf-n">{o.n}</span>
          </button>
        ))}
        {atalhos.filter(a => a.n > 0 || a.on).map(a => (
          <button key={a.id} type="button" aria-pressed={a.on} onClick={a.onClick} title={a.title}
            className={`recf-chip recf-tg tg-${a.tom}` + (a.on ? ' on' : '')}>
            <span className="recf-dot"/>{a.label}<span className="recf-n">{a.n}</span>
          </button>
        ))}
      </div>
      {(campos || algum) && (
        <div className="recf-campos">
          <label className="recf-busca">
            <Icon name="search" size={15}/>
            <input type="search" value={buscaCampo} onChange={e => mudarBusca(e.target.value)} placeholder={placeholder} aria-label="Buscar na lista" />
          </label>
          {selects.filter(s => s.options.length > 1 || s.value).map(s => (
            <select key={s.id} className={s.value ? 'on' : ''} value={s.value} onChange={e => s.onChange(e.target.value)} title={s.title} aria-label={s.title}>
              <option value="">{s.todos}</option>
              {s.options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          ))}
          {ordem && (
            <select value={ordem.value} onChange={e => ordem.onChange(e.target.value)} title="Ordenar a lista" aria-label="Ordenar a lista">
              {ordem.options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          )}
        </div>
      )}
      {algum && (
        <div className="recf-rod">
          <span>{n} {n === 1 ? 'resultado' : 'resultados'} com estes filtros</span>
          <button type="button" onClick={onLimpar}>Limpar filtros</button>
        </div>
      )}
    </div>
  )
}
const REC_SOL_FIM = ['entregue', 'cancelada', 'refeita']
// Pedido ainda em atendimento: é quando os alertas aparecem e o "Isto é obra" ainda cabe.
const REC_SOL_ATIVA = ['solicitada', 'analisando', 'reservada', 'separada']
const REC_SEM_OBRA = '— sem obra —'
const recOpcoes = vals => [...new Set(vals.filter(Boolean))].sort((a, b) => a.localeCompare(b, 'pt')).map(v => [v, v])

// ─── Esteira de Compras (REC) ─────────────────────────────────────────────────
// Um setor de Compras para TODOS os contratos: a mesma esteira aparece na aba REC → Compras e no Painel de
// Compras (o comprador faz tudo de um lugar só). Cada requerimento traz o contrato (o da obra; sem obra, o
// de quem pediu — o servidor resolve); com 2+ contratos na fila, o cartão mostra o contrato e há filtro por ele.
// A lista é do pai (o Painel calcula os indicadores com ela); aqui ficam os filtros, formulários e ações.
//   lista / recarregar  → requerimentos (/rec/compras) e como buscá-los de novo depois de uma ação
//   filtro              → { compraStatus, compraObra, compraContrato } vindo de um card (aplicado quando muda)
//   contrato/onContrato → filtro de contrato controlado pelo pai (Painel); sem eles, fica aqui dentro
const RC_STAT_LABEL = { recebida:'A cotar', em_cotacao:'Em cotação', comprada:'Comprado', aguardando_retirada:'Aguardando retirada', em_transito:'Para chegar', em_estoque:'No estoque', cancelada:'Cancelada',
  a_caminho_unidade:'A caminho da unidade', entregue_unidade:'Entregue na unidade',
  _abertas:'Em aberto', _atrasadas:'Atrasadas', _hoje:'Vencem hoje', _andamento:'Em andamento' }
const RC_FINAL = ['em_estoque', 'entregue_unidade', 'cancelada']   // chegou (estoque ou unidade) ou cancelada
const rcAberta = rc => !RC_FINAL.includes(rc.status)
// Status do filtro de Compras. Os "_…" são grupos dos cards do painel de Compras (mesma conta:
// aberta = fora de em_estoque/cancelada; atraso/hoje pelo prazo, como no recPrazoInfo).
const rcStatusOk = (rc, st) => {
  if (!st) return true
  const aberta = rcAberta(rc)
  if (st === '_abertas') return aberta
  if (st === '_andamento') return ['comprada','aguardando_retirada','em_transito','a_caminho_unidade'].includes(rc.status)
  if (st === '_atrasadas' || st === '_hoje') { const pi = recPrazoInfo(rc.prazo, rc.status); return aberta && !!pi && pi.kind === (st === '_atrasadas' ? 'atrasado' : 'hoje') }
  return rc.status === st
}
// Contratos que aparecem numa lista de requerimentos (na ordem do /api/contratos → mesma cor das outras telas).
const rcContratos = lista => {
  const m = new Map()
  for (const rc of lista) if (rc.contrato_id && !m.has(rc.contrato_id))
    m.set(rc.contrato_id, { id: rc.contrato_id, nome: rc.contrato_nome || 'Contrato', cor: corContrato({ cor: rc.contrato_cor }, rc.contrato_idx || 0), idx: rc.contrato_idx || 0 })
  return [...m.values()].sort((a, b) => a.idx - b.idx)
}
function RcContratoTag({ rc }) {
  if (!rc.contrato_nome) return null
  const cor = corContrato({ cor: rc.contrato_cor }, rc.contrato_idx || 0)
  return (
    <span title="Contrato" style={{display:'inline-flex', alignItems:'center', gap:5, fontSize:'.68rem', fontWeight:700, padding:'2px 8px', borderRadius:999, border:'1px solid var(--border,#e5e7eb)', background:'var(--surface-alt,#EEF1F5)', color:'var(--ink,#111)', maxWidth:'100%', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>
      <span style={{width:8, height:8, borderRadius:2, background:cor, flex:'none'}}/>{rc.contrato_nome}
    </span>
  )
}

// Termo da remessa (HTML do servidor) numa aba nova — o fetch leva o token (o termo não é página pública).
async function recAbrirTermoRemessa(id, addToast) {
  try {
    const resp = await fetch('/api/rec/remessas/' + id + '/termo', { headers: { Authorization: `Bearer ${token.value}` } })
    if (!resp.ok) throw new Error('Erro ' + resp.status)
    const html = await resp.text()
    const w = window.open('', '_blank')
    if (w) { w.document.open(); w.document.write(html); w.document.close() }
    else addToast('Permita pop-ups para ver o termo.', 'error')
  } catch (e) { addToast(e.message, 'error') }
}
// Compra que vai DIRETO do fornecedor para a unidade: a remessa dela (número, etapa, motorista) e os elos já
// assinados — retirada no fornecedor e entrega na unidade —, com o termo. Substitui o "Marcar retirado": quem
// registra a retirada é o motorista, assinando no celular.
const RC_DIRETA_ETAPA = { pronta: 'Aguardando o motorista', a_caminho: 'Motorista a caminho do fornecedor', em_transporte: 'Retirado — a caminho da unidade', entregue: 'Entregue na unidade', cancelada: 'Remessa cancelada' }
function RcDireta({ rc, addToast }) {
  const elos = rc.remessa_elos || []
  const quando = e => recDM(e.ocorrido_em || e.criado_em) + ' ' + String(e.criado_em || '').slice(11, 16)
  return (
    <div style={{marginTop:8, padding:'10px 12px', borderRadius:8, background:'var(--rec-navy-soft)', border:'1px solid var(--border,#e5e7eb)', fontSize:'.84rem', color:'var(--ink,#111)', display:'grid', gap:6}}>
      <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
        <span style={{color:'var(--rec-navy)'}}><Icon name="truck" size={16}/></span>
        <strong>Direto para a unidade{rc.obra_nome ? ` · ${rc.obra_nome}` : ''}</strong>
        <span style={{color:'var(--rec-sub)'}}>remessa {rc.remessa_numero}</span>
        <span className="rtag rtag-sm tg-aco">{RC_DIRETA_ETAPA[rc.remessa_status] || rc.remessa_status}</span>
      </div>
      <div style={{color:'var(--text-secondary)'}}>Motorista: <strong style={{color:'var(--ink,#111)'}}>{rc.remessa_motorista_nome || rc.retirada_responsavel_nome || '—'}</strong>{rc.fornecedor ? <> · busca em <strong style={{color:'var(--ink,#111)'}}>{rc.fornecedor}</strong></> : null}</div>
      {elos.length > 0 && <div style={{display:'grid', gap:3}}>
        {elos.map((e, i) => <div key={i} style={{display:'grid', gridTemplateColumns:'auto 1fr', columnGap:6, alignItems:'baseline'}}>
          <span style={{color:'var(--rec-green)', fontWeight:700}}>✓</span>
          <span>{e.tipo === 'retirada' ? `Retirado no fornecedor — entregou ${e.contraparte_nome || '—'}${e.tem_foto ? ' · com foto' : ''}`
            : e.tipo === 'regularizacao' ? `Entrega registrada sem assinatura${e.contraparte_nome ? ` — recebeu ${e.contraparte_nome}` : ''}`
            : `Entregue na unidade — recebeu ${e.para_nome || e.contraparte_nome || '—'}`}</span>
          <span style={{color:'var(--rec-sub)', fontSize:'.76rem', gridColumn:2}}>{quando(e)} · #{e.hash_evento}</span>
        </div>)}
      </div>}
      <div><button type="button" onClick={() => recAbrirTermoRemessa(rc.remessa_id, addToast)} style={{padding:'5px 12px', background:'transparent', color:'var(--ink,#111)', border:'1px solid var(--border,#d1d5db)', borderRadius:8, fontWeight:600, cursor:'pointer', fontSize:'.78rem'}}>Ver termo</button></div>
    </div>
  )
}

function ComprasEsteira({ user, addToast, lista, recarregar, filtro, contrato: contratoExt, onContrato, inicioStatus = '' }) {
  const comprasList = lista || []
  const inp = { padding:'8px 10px', border:'1px solid var(--border,#d1d5db)', borderRadius:8, background:'var(--card,#fff)', color:'var(--ink,#111)', fontSize:'.9rem' }
  const btnP = { padding:'9px 16px', background:'var(--fill-navy)', color:'#fff', border:'none', borderRadius:8, fontWeight:600, cursor:'pointer' }
  const btnG = { padding:'9px 16px', background:'transparent', color:'var(--ink,#111)', border:'1px solid var(--border,#d1d5db)', borderRadius:8, fontWeight:600, cursor:'pointer' }
  const card = { background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderRadius:12, padding:16, marginBottom:14 }
  const [compraLoad, setCompraLoad] = useState(false)
  const [respsRetirada, setRespsRetirada] = useState([])   // candidatos a responsável pela retirada
  const [encaminhaId, setEncaminhaId] = useState(null)     // card com o formulário de retirada aberto
  const [encForm, setEncForm] = useState(ENC_VAZIO)        // quem busca + onde (fornecedor, endereço, contato, obs.)
  const [fornecedores, setFornecedores] = useState([])     // fornecedores já usados (autocompletar nome, endereço e contato)
  const fornecedorConhecido = nome => fornecedores.find(x => semAcento(x.nome).trim() === semAcento(nome).trim())
  const fornOpcoes = fornecedores.map(f => ({ chave: f.nome, rotulo: f.nome, titulo: f.nome, sub: f.endereco || '', busca: semAcento(f.nome) }))
  const carregarFornecedores = () => GET('/rec/compras/fornecedores').then(setFornecedores).catch(() => {})
  // "Comprado" pede o fornecedor antes de mudar o status (formulário curto dentro do card).
  const [compraFornId, setCompraFornId] = useState(null)
  const [compraFornVal, setCompraFornVal] = useState('')
  // Sem nota fiscal (ex.: Mercado Livre), compra pedida para uma base: o fornecedor entrega lá e o Almoxarife 2
  // confere, anexa o comprovante e assina — dá entrada no saldo da base e fecha a compra.
  const [compraSemNota, setCompraSemNota] = useState(false)
  const podeSemNota = rc => !!(rc.destino_deposito_id && rc.catalogo_id && !rc.remessa_id)
  const [semNotaId, setSemNotaId] = useState(null)
  // Cancelar pede o motivo: quem pediu lê no pedido; o almoxarifado, em Estoque › Compras pedidas.
  const [cancelaId, setCancelaId] = useState(null)
  const [cancelaMotivo, setCancelaMotivo] = useState('')
  const fecharFormsCompra = () => { setCompraFornId(null); setEncaminhaId(null); setSemNotaId(null); setCancelaId(null) }
  const abrirComprado = (rc) => {
    if (compraFornId === rc.id) { setCompraFornId(null); return }
    fecharFormsCompra()
    setCompraFornId(rc.id); setCompraFornVal(rc.fornecedor || ''); setCompraSemNota(false)
  }
  const abrirSemNota = (rc) => { const ab = semNotaId === rc.id; fecharFormsCompra(); if (!ab) setSemNotaId(rc.id) }
  const abrirCancelar = (rc) => {
    if (user.admin) { addToast('Seu perfil administrativo não pode cancelar.', 'error'); return }
    const ab = cancelaId === rc.id; fecharFormsCompra()
    if (!ab) { setCancelaId(rc.id); setCancelaMotivo('') }
  }
  const confirmarCancelar = async (rc) => {
    if (cancelaMotivo.trim().length < 5 || compraLoad) return
    if (await acaoCompra(rc.id, 'cancelar', { motivo: cancelaMotivo.trim() })) { setCancelaId(null); setCancelaMotivo('') }
  }
  const desfazerSemNota = async (rc) => {
    const m = prompt(`Desfazer o "sem nota" de ${rc.numero}?\nA compra volta para "Comprado" e sai da lista de chegadas de ${rc.base_rp_para || 'base'}.\nMotivo (obrigatório):`, '')
    if (m == null) return
    setCompraLoad(true)
    try { await POST('/estoque/pedidos/' + rc.base_rp_id + '/desfazer', { motivo: m }); addToast(`${rc.numero} voltou para Comprado.`, 'success'); await recarregar() }
    catch (e) { addToast(e.message, 'error') }
    setCompraLoad(false)
  }
  const baixarComprovanteRc = (rc) => baixarComprovante(() => GET('/estoque/pedidos/' + rc.base_rp_id + '/recebimento')).catch(e => addToast(e.message, 'error'))
  const abrirEncaminhar = (rc) => {
    if (encaminhaId === rc.id) { setEncaminhaId(null); return }
    fecharFormsCompra()
    setEncaminhaId(rc.id)
    // Encaminhar: o fornecedor já vem do "Comprado", com o último endereço/contato usado para ele.
    const fc = fornecedorConhecido(rc.fornecedor) || {}
    setEncForm({ resp: rc.retirada_responsavel_id ? String(rc.retirada_responsavel_id) : '', fornecedor: rc.fornecedor || '',
      endereco: rc.retirada_endereco || fc.endereco || '', contato: rc.retirada_contato || fc.contato || '', obs: rc.retirada_obs || '',
      destino: rc.remessa_id ? 'unidade' : 'estoque', junto: [] })
  }
  // Escolheu um fornecedor já usado → traz o endereço/contato dele (sem sobrescrever o que já foi digitado).
  const encFornecedor = (v) => setEncForm(f => {
    const l = fornecedorConhecido(v)
    return l ? { ...f, fornecedor: v, endereco: f.endereco || l.endereco || '', contato: f.contato || l.contato || '' } : { ...f, fornecedor: v }
  })
  const acaoCompra = async (id, acao, extra) => {
    if (acao === 'cancelar' && user.admin) { addToast('Seu perfil administrativo não pode cancelar.', 'error'); return false }
    setCompraLoad(true)
    let ok = false
    // Chegou ao estoque num pedido cuja parte de estoque já tinha remessa: o servidor diz em que remessa o item entrou.
    try {
      const r = await POST('/rec/compras/' + id + '/acao', { acao, ...(extra || {}) })
      addToast(r && r.remessa ? `No estoque — seguiu na remessa ${r.remessa.numero} do almoxarifado.`
        : r && r.remessa_base ? `Sem nota: aguardando ${r.remessa_base.para} conferir e assinar a chegada (${r.remessa_base.numero}).` : 'Requerimento atualizado.', 'success')
      await recarregar(); ok = true
    }
    catch (e) { addToast(e.message, 'error') }
    setCompraLoad(false)
    return ok
  }
  const [valorEditId, setValorEditId] = useState(null)   // card com o ajuste de valor aberto
  const [valorEditVal, setValorEditVal] = useState('')
  const salvarValor = async (id) => {
    setCompraLoad(true)
    try { await POST('/rec/compras/' + id + '/valor', { valor_unit: valorEditVal === '' ? null : Number(valorEditVal) }); addToast('Valor atualizado.', 'success'); setValorEditId(null); await recarregar() }
    catch (e) { addToast(e.message, 'error') }
    setCompraLoad(false)
  }
  // Encaminhar (item comprado) ou corrigir uma retirada já encaminhada — mesmo formulário.
  const encaminharRetirada = async (rc) => {
    if (!encForm.resp || !encForm.fornecedor.trim()) return
    const direto = encForm.destino === 'unidade'
    const dados = { responsavel_id: Number(encForm.resp), fornecedor: encForm.fornecedor, endereco: encForm.endereco, contato: encForm.contato, obs: encForm.obs,
      destino: encForm.destino, ...(direto && !rc.remessa_id && encForm.junto.length ? { junto: encForm.junto } : {}) }
    const editar = rc.status === 'aguardando_retirada'
    setCompraLoad(true)
    try {
      const r = editar ? await POST('/rec/compras/' + rc.id + '/retirada', dados) : await POST('/rec/compras/' + rc.id + '/acao', { acao: 'encaminhar', ...dados })
      const rem = r && r.remessa && r.remessa.numero
      addToast(direto ? (rem ? `Direto para a unidade — remessa ${rem} no painel do motorista.` : 'Retirada direta atualizada.')
        : editar ? (rc.remessa_id ? 'A compra saiu da remessa direta e volta para o estoque.' : 'Retirada atualizada.') : 'Retirada encaminhada.', 'success')
      setEncaminhaId(null); setEncForm(ENC_VAZIO)
      await recarregar()
      carregarFornecedores()
    }
    catch (e) { addToast(e.message, 'error') }
    setCompraLoad(false)
  }
  const confirmarComprado = async (rc) => {
    if (!compraFornVal.trim() || compraLoad) return
    setCompraLoad(true)
    try {
      const semNota = compraSemNota && podeSemNota(rc)
      const r = await POST('/rec/compras/' + rc.id + '/acao', { acao: 'comprar', fornecedor: compraFornVal, ...(semNota ? { sem_nota: true } : {}) })
      addToast(r && r.remessa_base ? `Compra registrada sem nota: ${r.remessa_base.para} confere e assina a chegada (${r.remessa_base.numero}).` : 'Compra registrada.', 'success')
      setCompraFornId(null); setCompraFornVal(''); setCompraSemNota(false)
      await recarregar()
      carregarFornecedores()
    }
    catch (e) { addToast(e.message, 'error') }
    setCompraLoad(false)
  }
  const [compraCat, setCompraCat] = useState('')   // filtro de categoria na aba Compras
  const [compraStatus, setCompraStatus] = useState(inicioStatus)   // filtro de status (estágio da esteira)
  const [compraObra, setCompraObra] = useState('')   // filtro por obra solicitante (priorização do comprador)
  // Contrato em foco: controlado pelo Painel (chips do topo) ou aqui dentro (aba REC → Compras).
  const [ctInterno, setCtInterno] = useState('')
  const compraContrato = onContrato ? String(contratoExt || '') : ctInterno
  const setCompraContrato = v => { if (onContrato) onContrato(v); else setCtInterno(v) }
  useEffect(() => { GET('/rec/retirada/responsaveis').then(setRespsRetirada).catch(() => {}); carregarFornecedores() }, [])
  // Card do painel/Pendências: aplica o filtro que veio com ele.
  // Busca global (Ctrl+K) traz compraId: a esteira abre sem filtro e com o requerimento em destaque.
  const [foco, setFoco] = useState(null)
  const focoRecarregou = useRef(false)
  useEffect(() => {
    if (!filtro) return
    if (filtro.compraStatus != null) setCompraStatus(filtro.compraStatus)
    if (filtro.compraObra != null) setCompraObra(filtro.compraObra)
    if (filtro.compraContrato != null) setCompraContrato(String(filtro.compraContrato))
    if (filtro.compraId != null) {
      setCompraCat(''); setCompraStatus(''); setCompraObra(''); setCompraContrato('')
      focoRecarregou.current = false; setFoco(filtro.compraId)
    }
  }, [filtro])
  useEffect(() => {
    if (!foco) return
    // Fila carregada antes de o requerimento existir → recarrega uma vez.
    if (!comprasList.some(rc => rc.id === foco)) { if (lista && !focoRecarregou.current) { focoRecarregou.current = true; recarregar() } return }
    const t = setTimeout(() => { const el = document.getElementById('rc-' + foco); if (el) el.scrollIntoView({ block:'center', behavior:'smooth' }) }, 80)
    return () => clearTimeout(t)
  }, [foco, lista])
  const contratosLista = rcContratos(comprasList)
  const multiCt = contratosLista.length > 1
  const ctNome = compraContrato ? ((contratosLista.find(c => String(c.id) === compraContrato) || {}).nome || '') : ''
  // Base = a fila do contrato em foco (todos, sem filtro). Obras, categorias e a faixa de prioridade saem dela.
  const base = compraContrato ? comprasList.filter(rc => String(rc.contrato_id) === compraContrato) : comprasList
  const SEM_OBRA = '— sem obra —'
  const obraDe = rc => rc.obra_nome || SEM_OBRA
  // Resumo por obra das compras AINDA EM ABERTO (fora de estoque/cancelada): total, atrasadas
  // e "vence hoje" — insumo da faixa de priorização e da ordenação (mais crítica primeiro).
  const resumoObras = (() => {
    const m = new Map()
    for (const rc of base) {
      if (!rcAberta(rc)) continue
      const nome = obraDe(rc)
      const o = m.get(nome) || { nome, abertas: 0, atrasadas: 0, hoje: 0 }
      o.abertas++
      const pi = recPrazoInfo(rc.prazo, rc.status)
      if (pi && pi.kind === 'atrasado') o.atrasadas++
      else if (pi && pi.kind === 'hoje') o.hoje++
      m.set(nome, o)
    }
    return [...m.values()].sort((a, b) => (b.atrasadas - a.atrasadas) || (b.hoje - a.hoje) || (b.abertas - a.abertas) || a.nome.localeCompare(b.nome, 'pt'))
  })()
  const obrasOpts = [...new Set(base.map(obraDe))].sort((a, b) => a.localeCompare(b, 'pt'))
  // Trocou de contrato e a obra escolhida não é dele → solta a obra.
  useEffect(() => { if (compraObra && !obrasOpts.includes(compraObra)) setCompraObra('') }, [compraContrato])
  // Imprimir a lista como ESPELHO de status: uma seção por categoria, com a situação atual de
  // cada item (A cotar / Em cotação / Comprado / Para chegar / Espera). Respeita os filtros ativos
  // (categoria + status). Sem filtro de status, mostra o conjunto de trabalho — exclui o que já
  // chegou ao estoque e o cancelado. Serve tanto para recordação de Compras quanto para o fornecedor.
  const imprimirCotacao = () => {
    const trabalho = ['recebida','em_cotacao','comprada','aguardando_retirada','em_transito','a_caminho_unidade']
    const pend = base.filter(rc =>
      (compraStatus ? rcStatusOk(rc, compraStatus) : trabalho.includes(rc.status))
      && (!compraCat || rc.categoria===compraCat)
      && (!compraObra || (rc.obra_nome||'— sem obra —')===compraObra))
    if (!pend.length) { addToast('Nada para listar' + (ctNome?` · ${ctNome}`:'') + (compraCat?` em ${compraCat}`:'') + (compraStatus?` · ${RC_STAT_LABEL[compraStatus]||compraStatus}`:'') + (compraObra?` · ${compraObra}`:'') + '.', 'info'); return }
    // Lista com mais de um contrato (setor de Compras único): coluna do contrato, para o fornecedor e a conferência.
    const multiPend = new Set(pend.map(rc => rc.contrato_id)).size > 1
    const grupos = {}
    for (const rc of pend) { const k = rc.categoria || 'Sem categoria'; (grupos[k]=grupos[k]||[]).push(rc) }
    const esc = t => String(t==null?'':t).replace(/[&<>]/g, c=>({'&':'&amp;','<':'&lt;','>':'&gt;'}[c]))
    const hoje = new Date().toLocaleDateString('pt-BR')
    const secoes = Object.keys(grupos).sort((a,b)=>a.localeCompare(b,'pt')).map(cat=>{
      const linhas = grupos[cat].map(rc=>`<tr>
        <td>${esc(rc.descricao||'(item)')}</td>
        <td style="text-align:right">${esc(Number(rc.qtd))}</td>
        <td>${esc(rc.unidade||'')}</td>
        <td><strong>${esc(RC_STAT_LABEL[rc.status]||rc.status)}</strong></td>
        ${multiPend?`<td>${esc(rc.contrato_nome||'—')}</td>`:''}<td>${esc(rc.obra_nome||'—')}</td>
        <td>${rc.prazo?esc(rc.prazo):'—'}</td>
        <td>${rc.prioridade==='urgente'?'<strong style="color:#7A2E2E">URGENTE</strong>':''}</td>
        <td style="width:120px"></td></tr>`).join('')
      return `<h2>${esc(cat)} <span style="font-weight:400;font-size:.8rem;color:#666">(${grupos[cat].length} item(ns))</span></h2>
        <table><thead><tr><th>Item</th><th>Qtd.</th><th>Un.</th><th>Status</th>${multiPend?'<th>Contrato</th>':''}<th>Obra</th><th>Prazo</th><th>Prior.</th><th>Valor unit. cotado</th></tr></thead><tbody>${linhas}</tbody></table>`
    }).join('')
    const html = `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8"><title>Lista de cotação — ${hoje}</title>
      <style>body{font-family:Arial,Helvetica,sans-serif;color:#111;max-width:820px;margin:20px auto;padding:0 16px}
      h1{font-size:1.3rem;border-bottom:2px solid #1E3A5F;padding-bottom:6px} h2{font-size:1.05rem;color:#1E3A5F;margin:18px 0 6px}
      table{width:100%;border-collapse:collapse;margin-bottom:8px} th,td{border:1px solid #cbd5e1;padding:5px 8px;font-size:.85rem;text-align:left}
      th{background:#eef2f7} @media print{button{display:none}}</style></head><body>
      <h1>Lista de cotação de material — Markat Engenharia</h1>
      <p>Emitida em ${hoje}${ctNome?` · contrato: <strong>${esc(ctNome)}</strong>`:''}${compraCat?` · categoria: <strong>${esc(compraCat)}</strong>`:''}${compraStatus?` · status: <strong>${esc(RC_STAT_LABEL[compraStatus]||compraStatus)}</strong>`:''}. Situação atual de cada item; preencher o valor unitário cotado e devolver.</p>
      ${secoes}
      <p style="margin-top:24px;font-size:.85rem">Fornecedor: ____________________________  ·  Validade da proposta: ______/______/________</p>
      <button onclick="window.print()" style="margin-top:16px;padding:8px 16px;background:#1E3A5F;color:#fff;border:none;border-radius:6px;cursor:pointer">Imprimir</button>
      </body></html>`
    const w = window.open('', '_blank')
    if (!w) { addToast('Permita pop-ups para imprimir a lista.', 'error'); return }
    w.document.write(html); w.document.close()
  }

  // Cartões: filtrados, agrupados por categoria e desenhados aos poucos (a fila soma todos os contratos).
  const filtrada = base.filter(rc=>(!compraCat || (rc.categoria||'Sem categoria')===compraCat) && rcStatusOk(rc, compraStatus) && (!compraObra || obraDe(rc)===compraObra))
  const catDe = rc => rc.categoria || 'Sem categoria'
  const ordenada = filtrada.map((rc, i) => [rc, i]).sort((a, b) => catDe(a[0]).localeCompare(catDe(b[0]), 'pt') || a[1] - b[1]).map(x => x[0])
  const nPorCat = {}
  for (const rc of filtrada) nPorCat[catDe(rc)] = (nPorCat[catDe(rc)] || 0) + 1
  const [cartoesTela, fimCartoes] = useAosPoucos(ordenada, 60, foco ? (rc => rc.id === foco) : null)
  const gruposTela = []
  for (const rc of cartoesTela) {
    const k = catDe(rc), g = gruposTela[gruposTela.length - 1]
    if (g && g[0] === k) g[1].push(rc); else gruposTela.push([k, [rc]])
  }

  return <>
        {/* Toolbar: filtros (contrato + categoria + status + obra) + impressão da lista de cotação */}
        <div style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center', marginBottom:12}}>
          {multiCt && (
            <select style={{...inp, maxWidth:260, ...(compraContrato ? {borderColor:'var(--primary-accent, #4A90A4)', boxShadow:'0 0 0 3px rgba(74,144,164,.14)'} : {})}} value={compraContrato} onChange={e=>setCompraContrato(e.target.value)} title="Filtrar por contrato" aria-label="Filtrar por contrato">
              <option value="">Todos os contratos</option>
              {contratosLista.map(c=><option key={c.id} value={String(c.id)}>{c.nome}</option>)}
            </select>
          )}
          <select style={{...inp, maxWidth:230}} value={compraCat} onChange={e=>setCompraCat(e.target.value)}>
            <option value="">Todas as categorias</option>
            {[...new Set(base.map(rc=>rc.categoria||'Sem categoria'))].sort((a,b)=>a.localeCompare(b,'pt')).map(c=><option key={c} value={c}>{c}</option>)}
          </select>
          <select style={{...inp, maxWidth:200}} value={compraStatus} onChange={e=>setCompraStatus(e.target.value)}>
            <option value="">Todos os status</option>
            <optgroup label="Situação">
              {[['_abertas','Em aberto (todas)'],['_atrasadas','Atrasadas'],['_hoje','Vencem hoje'],['_andamento','Em andamento (comprado → chegar)']].map(([v,l])=><option key={v} value={v}>{l}</option>)}
            </optgroup>
            <optgroup label="Etapa da esteira">
              {[['recebida','A cotar'],['em_cotacao','Em cotação'],['comprada','Comprado'],['aguardando_retirada','Aguardando retirada'],['em_transito','Para chegar'],['a_caminho_unidade','A caminho da unidade'],['em_estoque','No estoque'],['entregue_unidade','Entregue na unidade'],['cancelada','Cancelada']].map(([v,l])=><option key={v} value={v}>{l}</option>)}
            </optgroup>
          </select>
          <select style={{...inp, maxWidth:280, ...(compraObra ? {borderColor:'var(--primary-accent, #4A90A4)', boxShadow:'0 0 0 3px rgba(74,144,164,.14)'} : {})}} value={compraObra} onChange={e=>setCompraObra(e.target.value)} title="Filtrar por obra solicitante">
            <option value="">Todas as obras</option>
            {obrasOpts.map(o=><option key={o} value={o}>{o}</option>)}
          </select>
          <button style={btnG} onClick={imprimirCotacao}>🖨️ Imprimir lista de cotação</button>
          <span style={{marginLeft:'auto', fontSize:'.74rem', color:'var(--rec-sub)'}}>Esteira: A cotar → Cotação → Comprado → Retirada → No estoque (ou direto na unidade)</span>
        </div>
        {/* Faixa de priorização por obra: chips com contagem em aberto + atrasadas; clique filtra. */}
        {resumoObras.length > 1 && (
          <div style={{...card, padding:'11px 13px', marginBottom:16}}>
            <div style={{display:'flex', alignItems:'center', gap:8, marginBottom:9, flexWrap:'wrap'}}>
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="var(--rec-navy)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><path d="M4 22v-7"/></svg>
              <span style={{fontWeight:700, fontSize:'.82rem', color:'var(--ink,#111)'}}>Priorizar por obra</span>
              <span style={{fontSize:'.72rem', color:'var(--rec-sub)'}}>— clique numa obra para filtrar. Mais atrasadas primeiro.</span>
            </div>
            <div style={{display:'flex', gap:9, flexWrap:'wrap'}}>
              {resumoObras.map(o=>{
                const ativo = compraObra===o.nome
                const cor = o.atrasadas ? 'var(--rec-urg-fg)' : o.hoje ? 'var(--rec-amber)' : 'var(--rec-green)'
                return (
                  <button key={o.nome} onClick={()=>setCompraObra(ativo?'':o.nome)} style={{display:'inline-flex', alignItems:'center', gap:8, padding:'7px 12px', borderRadius:999, cursor:'pointer', fontSize:'.78rem', background: ativo?'var(--rec-navy)':'var(--card,#fff)', color: ativo?'var(--rec-on-accent)':'var(--ink,#111)', border:`1px solid ${ativo?'var(--rec-navy)':'var(--border,#e5e7eb)'}`}}>
                    <span style={{width:8, height:8, borderRadius:'50%', background:cor, flexShrink:0}}/>
                    <strong style={{fontWeight:700}}>{o.nome}</strong>
                    <span style={{opacity:.7}}>{o.abertas}</span>
                    {o.atrasadas>0 && <span style={{fontSize:'.66rem', fontWeight:800, color: ativo?'var(--rec-on-accent)':'var(--rec-urg-fg)', background: ativo?'rgba(255,255,255,.18)':'var(--rec-urg-bg)', padding:'1px 7px', borderRadius:999}}>{o.atrasadas} atrasada{o.atrasadas>1?'s':''}</span>}
                    {!o.atrasadas && o.hoje>0 && <span style={{fontSize:'.66rem', fontWeight:800, color: ativo?'var(--rec-on-accent)':'var(--rec-amber)', background: ativo?'rgba(255,255,255,.18)':'var(--rec-amber-soft)', padding:'1px 7px', borderRadius:999}}>{o.hoje} hoje</span>}
                  </button>
                )
              })}
            </div>
          </div>
        )}
        {base.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>Nenhum requerimento de compra{ctNome?` de ${ctNome}`:''}.</div>}
        {base.length>0 && !filtrada.length && <div style={{...card, color:'var(--text-secondary)'}}>Nenhum item{compraStatus?' neste status':''}{compraCat?' nesta categoria':''}{compraObra?' nesta obra':''}{ctNome?` em ${ctNome}`:''}.</div>}
        {gruposTela.map(([cat, itens])=>(
            <div key={cat} style={{marginBottom:16}}>
              <div style={{fontSize:'.78rem', fontWeight:800, letterSpacing:'.03em', textTransform:'uppercase', color:'var(--rec-navy)', margin:'2px 0 8px', display:'flex', alignItems:'center', gap:8}}>
                <span style={{width:8, height:8, borderRadius:2, background:'var(--rec-navy)'}}/>{cat} <span style={{fontWeight:600, color:'var(--rec-sub)'}}>({nPorCat[cat]})</span>
              </div>
              {itens.map(rc=>{
                const pi = recPrazoInfo(rc.prazo, rc.status)
                const barra = pi ? (pi.kind==='atrasado' ? 'var(--rec-urg-fg)' : 'var(--rec-amber)') : null
                return (
                <div key={rc.id} id={'rc-' + rc.id} style={{...card, marginBottom:10, ...(barra ? {borderLeft:`4px solid ${barra}`} : {}), ...(foco === rc.id ? {boxShadow:'0 0 0 3px rgba(74,144,164,.35)'} : {})}}>
                  <div style={{display:'flex', justifyContent:'space-between', gap:12, flexWrap:'wrap', alignItems:'baseline'}}>
                    <div style={{fontWeight:700, color:'var(--ink,#111)', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap'}}>{rc.numero} {multiCt && <RcContratoTag rc={rc}/>}<RecStatus s={rc.status}/> {rc.prioridade==='urgente' && <RecUrgente/>}<RecPrazoBadge prazo={rc.prazo} status={rc.status}/></div>
                    <div style={{fontSize:'.78rem', color:'var(--silver)'}}>{(rc.criado_em||'').slice(0,16).replace('T',' ')}</div>
                  </div>
                  <div style={{marginTop:4, color:'var(--ink,#111)'}}><strong>{Number(rc.qtd)}</strong>{rc.unidade?` ${rc.unidade}`:''} · {rc.descricao||'(item)'}</div>
                  <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:3}}>
                    {rc.solicitacao_numero?`sol. ${rc.solicitacao_numero} · `:''}{rc.origem==='almoxarifado'?'via almoxarifado · ':''}{rc.solicitante_nome?`por ${rc.solicitante_nome} · `:''}{rc.obra_nome?`obra ${rc.obra_nome} · `:''}{rc.prazo?`prazo ${rc.prazo}`:''}
                  </div>
                  {rc.destino_nome && <div style={{fontSize:'.82rem', color:'var(--ink,#111)', marginTop:3}}><span style={{color:'var(--text-secondary)'}}>Entregar em:</span> <strong>depósito {rc.destino_nome}</strong> <span style={{color:'var(--text-secondary)'}}>(pedido pela base)</span></div>}
                  {rc.especificacao && <div style={{fontSize:'.82rem', color:'var(--ink,#111)', marginTop:3}}><span style={{color:'var(--text-secondary)'}}>Especificação:</span> {rc.especificacao}</div>}
                  {rc.justificativa && <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:3, fontStyle:'italic'}}>"{rc.justificativa}"</div>}
                  {/* O almoxarifado mandou o item de volta (não chegou) ou pediu a compra do que faltou no estoque. */}
                  {rc.almox_aviso && rc.status!=='em_estoque' && rc.status!=='cancelada' && (
                    <div style={{fontSize:'.82rem', color:'var(--ink,#111)', marginTop:6, padding:'6px 10px', borderRadius:8, background:'var(--rec-amber-soft)'}}>
                      <strong>{rc.almox_aviso==='nao_chegou' ? 'Almoxarifado: não chegou ao estoque' : 'Almoxarifado: sem estoque para o pedido'}</strong>
                      <span style={{color:'var(--text-secondary)'}}> · {recDM(rc.almox_em)}{rc.almox_por_nome ? ` · ${rc.almox_por_nome}` : ''}</span>
                      {rc.almox_motivo && <div style={{fontStyle:'italic', marginTop:2}}>"{rc.almox_motivo}"</div>}
                    </div>
                  )}
                  <RecFotos ids={rc.fotos} size={64}/>
                  {rc.fornecedor && rc.status!=='aguardando_retirada' && <div style={{fontSize:'.82rem', color:'var(--ink,#111)', marginTop:5}}><span style={{color:'var(--text-secondary)'}}>Fornecedor:</span> <strong>{rc.fornecedor}</strong></div>}
                  <div style={{fontSize:'.82rem', marginTop:5, display:'flex', alignItems:'center', gap:8, flexWrap:'wrap'}}>
                    <span style={{color:'var(--ink,#111)'}}>Valor:<strong>{rc.valor_unit!=null ? fmtBRL(Number(rc.valor_unit)*Number(rc.qtd||0)) : <span style={{color:'var(--rec-sub)', fontWeight:400, fontStyle:'italic'}}>sem custo</span>}</strong>{rc.valor_unit!=null && <span style={{color:'var(--rec-sub)'}}> · {fmtBRL(rc.valor_unit)}/{rc.unidade||'un'}</span>}</span>
                    {valorEditId===rc.id
                      ? <span style={{display:'inline-flex', gap:6, alignItems:'center'}}>
                          <input type="number" step="any" min="0" value={valorEditVal} onChange={e=>setValorEditVal(e.target.value)} placeholder="valor unit." style={{...inp, width:110, padding:'4px 8px', fontSize:'.8rem'}} />
                          <button style={{...btnP, padding:'4px 10px', fontSize:'.78rem', opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>salvarValor(rc.id)}>Salvar</button>
                          <button style={{...btnG, padding:'4px 10px', fontSize:'.78rem'}} onClick={()=>setValorEditId(null)}>×</button>
                        </span>
                      : rcAberta(rc) && <button style={{...btnG, padding:'3px 10px', fontSize:'.74rem'}} onClick={()=>{setValorEditId(rc.id); setValorEditVal(rc.valor_unit!=null?String(rc.valor_unit):'')}}>{rc.valor_unit!=null?'Ajustar valor':'Informar valor'}</button>}
                  </div>
                  {rc.remessa_id && encaminhaId!==rc.id && <RcDireta rc={rc} addToast={addToast}/>}
                  {/* Sem nota, entregue na base: quem fecha a compra é o Almoxarife 2 ao assinar a chegada. */}
                  {rc.base_rp_status==='em_transito' && (
                    <div style={{fontSize:'.82rem', color:'var(--ink,#111)', marginTop:6, padding:'6px 10px', borderRadius:8, background:'var(--rec-amber-soft)', display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
                      <span style={{flex:1, minWidth:0}}><strong>Sem nota fiscal</strong> · aguardando {rc.base_rp_para||'a base'} conferir, anexar o comprovante e assinar a chegada <span style={{color:'var(--text-secondary)'}}>({rc.base_rp_numero})</span></span>
                      {!user.admin && <button style={{...btnG, padding:'3px 10px', fontSize:'.74rem', opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>desfazerSemNota(rc)}>Desfazer</button>}
                    </div>
                  )}
                  {rc.base_rp_status==='recebido' && (
                    <div style={{fontSize:'.82rem', color:'var(--ink,#111)', marginTop:6, padding:'6px 10px', borderRadius:8, background:'var(--rec-green-soft)'}}>
                      <strong>Chegada assinada em {rc.base_rp_para||'base'}</strong> por {rc.base_rp_recebido_nome||'—'} em {recDM(rc.base_rp_recebido_em)} · chegou {Number(rc.base_rp_qtd_recebida||0)}{rc.unidade?` ${rc.unidade}`:''}
                      {rc.base_rp_obs && <div style={{fontStyle:'italic', marginTop:2}}>"{rc.base_rp_obs}"</div>}
                      {rc.base_rp_comprovante ? <div style={{marginTop:4}}><button style={{...btnG, padding:'3px 10px', fontSize:'.74rem'}} onClick={()=>baixarComprovanteRc(rc)}>Baixar comprovante</button></div> : null}
                    </div>
                  )}
                  {rc.status==='cancelada' && rc.cancelada_motivo && (
                    <div style={{fontSize:'.82rem', color:'var(--ink,#111)', marginTop:6, padding:'6px 10px', borderRadius:8, background:'var(--rec-urg-bg)'}}>
                      <strong style={{color:'var(--rec-urg-fg)'}}>Cancelada{rc.cancelada_por_nome ? ` por ${rc.cancelada_por_nome}` : ''}{rc.cancelada_em ? ` em ${recDM(rc.cancelada_em)}` : ''}</strong>
                      <div style={{fontStyle:'italic', marginTop:2}}>"{rc.cancelada_motivo}"</div>
                    </div>
                  )}
                  {rc.status==='aguardando_retirada' && !rc.remessa_id && <>
                    <div style={{fontSize:'.8rem', color:'var(--rec-amber)', fontWeight:600, marginTop:6}}>Retirada designada a {rc.retirada_responsavel_nome||'—'}</div>
                    {encaminhaId!==rc.id && (rc.fornecedor || rc.retirada_endereco
                      ? <RecRetiradaLocal rc={rc}/>
                      : <div style={{fontSize:'.8rem', color:'var(--rec-urg-fg)', marginTop:4}}>Sem fornecedor de retirada — clique em "Editar retirada" e informe onde buscar.</div>)}
                  </>}
                  {rcAberta(rc) && rc.status!=='a_caminho_unidade' && (
                    <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:10}}>
                      {rc.status==='recebida' && <button style={{...btnG, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>acaoCompra(rc.id,'cotar')}>Em cotação</button>}
                      {(rc.status==='recebida'||rc.status==='em_cotacao') && <button style={{...btnP, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>abrirComprado(rc)}>Comprado</button>}
                      {rc.status==='comprada' && <button style={{...btnP, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>abrirEncaminhar(rc)}>Encaminhar retirada</button>}
                      {rc.status==='comprada' && <button style={{...btnG, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>acaoCompra(rc.id,'transito')}>Fornecedor entrega</button>}
                      {rc.status==='aguardando_retirada' && !rc.remessa_id && <button style={{...btnP, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>acaoCompra(rc.id,'retirar')}>Marcar retirado</button>}
                      {rc.status==='aguardando_retirada' && <button style={{...btnG, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>abrirEncaminhar(rc)}>{rc.remessa_id ? 'Editar retirada direta' : 'Editar retirada'}</button>}
                      {(rc.status==='comprada'||rc.status==='em_transito') && podeSemNota(rc) && rc.base_rp_status!=='em_transito' && <button style={{...btnG, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>abrirSemNota(rc)}>Chega em {rc.destino_nome||'base'} sem nota</button>}
                      {(rc.status==='comprada'||rc.status==='em_transito') && rc.base_rp_status!=='em_transito' && <button style={{...btnG, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>acaoCompra(rc.id,'estoque')}>Chegou ao estoque</button>}
                      {!user.admin && <button style={{...btnG, color:'var(--danger)', borderColor:'var(--tag-perigo-line)', opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={()=>abrirCancelar(rc)}>Cancelar</button>}
                    </div>
                  )}
                  {semNotaId===rc.id && (rc.status==='comprada' || rc.status==='em_transito') && (
                    <div style={{marginTop:10, padding:12, background:'var(--rec-navy-soft)', borderRadius:8, display:'grid', gap:8}}>
                      <div style={{fontSize:'.82rem', color:'var(--ink,#111)'}}><strong>Compra sem nota fiscal entregue em {rc.destino_nome||'base'}</strong> (ex.: Mercado Livre)</div>
                      <div style={{fontSize:'.78rem', color:'var(--rec-sub)'}}>Quando o fornecedor entregar, o Almoxarife 2 de {rc.destino_nome||'lá'} confere, anexa o comprovante (foto ou PDF) e assina. Isso dá entrada no saldo de {rc.destino_nome||'base'}{rc.valor_unit!=null ? ` com o valor desta compra (${fmtBRL(rc.valor_unit)}/${rc.unidade||'un'})` : ' (sem valor informado ainda — ajuste antes, se souber)'} e fecha esta compra.</div>
                      <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                        <button style={{...btnP, opacity:compraLoad?0.6:1}} disabled={compraLoad} onClick={async()=>{ if (await acaoCompra(rc.id,'sem_nota')) setSemNotaId(null) }}>Confirmar</button>
                        <button style={btnG} onClick={()=>setSemNotaId(null)}>Voltar</button>
                      </div>
                    </div>
                  )}
                  {cancelaId===rc.id && rcAberta(rc) && (() => {
                    const pode = cancelaMotivo.trim().length >= 5 && !compraLoad
                    return (
                    <form onSubmit={e=>{e.preventDefault(); confirmarCancelar(rc)}} style={{marginTop:10, padding:12, background:'var(--rec-urg-bg)', borderRadius:8, display:'grid', gap:8}}>
                      <label style={{fontSize:'.76rem', fontWeight:600, color:'var(--ink,#111)', display:'grid', gap:4}}>Por que esta compra está sendo cancelada? *
                        <textarea autoFocus rows={2} maxLength={500} value={cancelaMotivo} onChange={e=>setCancelaMotivo(e.target.value)} placeholder="ex.: item descontinuado no fornecedor; pedido em duplicidade com a RC-2026-0123" style={{...inp, width:'100%', boxSizing:'border-box', resize:'vertical'}}/>
                      </label>
                      <div style={{fontSize:'.76rem', color:'var(--rec-sub)'}}>{rc.origem==='almoxarifado' ? 'O almoxarifado lê o motivo em Estoque › Compras pedidas.' : 'Quem pediu lê o motivo no pedido.'}{rc.base_rp_status==='em_transito' ? ` A chegada em ${rc.base_rp_para||'base'} também é cancelada.` : ''}</div>
                      <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                        <button type="submit" style={{...btnP, background:'var(--danger)', borderColor:'var(--danger)', opacity:pode?1:0.6}} disabled={!pode}>Cancelar compra</button>
                        <button type="button" style={btnG} onClick={()=>setCancelaId(null)}>Voltar</button>
                      </div>
                    </form>
                    )
                  })()}
                  {compraFornId===rc.id && (rc.status==='recebida' || rc.status==='em_cotacao') && (() => {
                    const pode = compraFornVal.trim() && !compraLoad
                    return (
                    <form onSubmit={e=>{e.preventDefault(); confirmarComprado(rc)}} style={{marginTop:10, padding:12, background:'var(--rec-navy-soft)', borderRadius:8, display:'grid', gap:8}}>
                      <label style={{fontSize:'.76rem', fontWeight:600, color:'var(--ink,#111)', display:'grid', gap:4}}>De qual fornecedor foi comprado? *
                        <CampoSugestoes livre autoFocus style={{...inp, width:'100%', boxSizing:'border-box'}} valor={compraFornVal} aoMudar={v=>setCompraFornVal(v)} opcoes={fornOpcoes} placeholder="ex.: Casa do Construtor" maxLength={120}/>
                      </label>
                      <div style={{fontSize:'.76rem', color:'var(--rec-sub)'}}>Use o nome pelo qual a equipe conhece o local — ele segue para a retirada.</div>
                      {podeSemNota(rc) && (
                        <label style={{display:'flex', gap:8, alignItems:'flex-start', fontSize:'.8rem', color:'var(--ink,#111)', cursor:'pointer'}}>
                          <input type="checkbox" checked={compraSemNota} onChange={e=>setCompraSemNota(e.target.checked)} style={{marginTop:3, width:'auto', flex:'none'}}/>
                          <span><strong>Sem nota fiscal — entregue em {rc.destino_nome||'base'}</strong> (ex.: Mercado Livre)<br/><span style={{color:'var(--rec-sub)'}}>O Almoxarife 2 confere, anexa o comprovante e assina a chegada: entra no saldo de {rc.destino_nome||'base'} e esta compra fecha.</span></span>
                        </label>
                      )}
                      <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                        <button type="submit" style={{...btnP, opacity:pode?1:0.6}} disabled={!pode}>Registrar compra</button>
                        <button type="button" style={btnG} onClick={()=>setCompraFornId(null)}>Cancelar</button>
                      </div>
                    </form>
                    )
                  })()}
                  {encaminhaId===rc.id && (rc.status==='comprada' || rc.status==='aguardando_retirada') && (() => {
                    const lbl = { fontSize:'.76rem', fontWeight:600, color:'var(--ink,#111)', display:'grid', gap:4 }
                    const campo = { ...inp, width:'100%', boxSizing:'border-box' }
                    // Direto para a unidade: só compra de pedido com unidade; quem busca é motorista (assina no celular).
                    const podeDireto = !!(rc.obra_nome && rc.solicitacao_id && rc.solicitacao_item_id)
                    const direto = encForm.destino === 'unidade'
                    const resps = direto ? respsRetirada.filter(u => REC_TRANSPORTADORES_FRONT.includes(u.role)) : respsRetirada
                    const respOk = encForm.resp && resps.some(u => String(u.id) === String(encForm.resp))
                    const juntoOpts = direto && !rc.remessa_id ? comprasList.filter(x => x.id !== rc.id && x.solicitacao_id === rc.solicitacao_id && x.solicitacao_item_id && !x.remessa_id
                      && (x.status === 'comprada' || x.status === 'aguardando_retirada')) : []
                    const pode = respOk && encForm.fornecedor.trim() && !compraLoad
                    const radio = (v, titulo, sub) => (
                      <label style={{display:'flex', gap:8, alignItems:'flex-start', padding:'8px 10px', borderRadius:8, cursor:'pointer', background:'var(--card,#fff)',
                        border:`1px solid ${encForm.destino===v ? 'var(--primary-accent,#4A90A4)' : 'var(--border,#e5e7eb)'}`, boxShadow: encForm.destino===v ? '0 0 0 3px rgba(74,144,164,.14)' : 'none'}}>
                        <input type="radio" name={'rc-dest-' + rc.id} checked={encForm.destino===v} onChange={()=>setEncForm(f=>({...f, destino:v, junto:[]}))} style={{marginTop:3, width:'auto', flex:'none'}}/>
                        <span style={{display:'grid', gap:2}}><strong style={{fontSize:'.84rem', color:'var(--ink,#111)'}}>{titulo}</strong><span style={{fontSize:'.76rem', color:'var(--rec-sub)'}}>{sub}</span></span>
                      </label>)
                    return (
                    <div style={{marginTop:10, padding:12, background:'var(--rec-amber-soft)', borderRadius:8, display:'grid', gap:10}}>
                      <div style={{fontSize:'.82rem', fontWeight:700, color:'var(--ink,#111)'}}>{rc.status==='comprada' ? 'Encaminhar retirada' : rc.remessa_id ? 'Editar retirada direta' : 'Editar retirada'}</div>
                      {podeDireto && <div role="radiogroup" aria-label="Para onde vai o material" style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(min(240px,100%),1fr))', gap:8}}>
                        {radio('estoque', 'Estoque da Sede', 'Chega ao almoxarifado e segue numa remessa normal.')}
                        {radio('unidade', `Direto para a unidade · ${rc.obra_nome}`, 'O motorista busca no fornecedor e entrega na unidade, sem passar pelo estoque.')}
                      </div>}
                      {direto && <div style={{fontSize:'.78rem', color:'var(--ink,#111)', padding:'8px 10px', borderRadius:8, background:'var(--card,#fff)', border:'1px dashed var(--border,#d1d5db)'}}>
                        No fornecedor, o motorista confere o material, anota quem entregou, tira a foto e assina; na unidade, quem recebe assina. Tudo fica na cadeia de custódia e no termo — o saldo do estoque não muda.
                      </div>}
                      <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(min(220px,100%),1fr))', gap:10}}>
                        <label style={lbl}>{direto ? 'Motorista *' : 'Quem vai buscar *'}
                          <select style={campo} value={respOk ? encForm.resp : ''} onChange={e=>setEncForm(f=>({...f, resp:e.target.value}))}>
                            <option value="">Selecione…</option>
                            {resps.map(u=><option key={u.id} value={u.id}>{u.nome} · {ROLE_LABEL[u.role]||u.role}</option>)}
                          </select>
                          {direto && !resps.length && <span style={{fontSize:'.74rem', fontWeight:400, color:'var(--rec-urg-fg)'}}>Nenhum motorista ativo cadastrado.</span>}
                        </label>
                        <label style={lbl}>Fornecedor *
                          <CampoSugestoes livre style={campo} valor={encForm.fornecedor} aoMudar={v=>encFornecedor(v)} opcoes={fornOpcoes} placeholder="ex.: Casa do Construtor" maxLength={120}/>
                        </label>
                      </div>
                      <label style={lbl}><span>Endereço <span style={{fontWeight:400, color:'var(--rec-sub)'}}>(opcional)</span></span>
                        <input style={campo} value={encForm.endereco} onChange={e=>setEncForm(f=>({...f, endereco:e.target.value}))} placeholder="Só se o motorista não conhecer o fornecedor" maxLength={300}/>
                      </label>
                      <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(min(220px,100%),1fr))', gap:10}}>
                        <label style={lbl}>Contato no local
                          <input style={campo} value={encForm.contato} onChange={e=>setEncForm(f=>({...f, contato:e.target.value}))} placeholder="ex.: João · (21) 99999-0000" maxLength={120}/>
                        </label>
                        <label style={lbl}>Observação
                          <input style={campo} value={encForm.obs} onChange={e=>setEncForm(f=>({...f, obs:e.target.value}))} placeholder="nº do pedido, horário, retirar no balcão…" maxLength={300}/>
                        </label>
                      </div>
                      {juntoOpts.length > 0 && <div style={{display:'grid', gap:6}}>
                        <div style={{fontSize:'.76rem', fontWeight:600, color:'var(--ink,#111)'}}>Levar junto <span style={{fontWeight:400, color:'var(--rec-sub)'}}>(mesmo pedido {rc.solicitacao_numero} — uma viagem só)</span></div>
                        {juntoOpts.map(x => <label key={x.id} style={{display:'flex', gap:8, alignItems:'center', fontSize:'.82rem', color:'var(--ink,#111)', cursor:'pointer'}}>
                          <input type="checkbox" style={{width:'auto', flex:'none'}} checked={encForm.junto.includes(x.id)} onChange={e=>setEncForm(f=>({...f, junto: e.target.checked ? [...f.junto, x.id] : f.junto.filter(i => i !== x.id)}))}/>
                          <span><strong>{x.numero}</strong> · {Number(x.qtd)}{x.unidade ? ` ${x.unidade}` : ''} {x.descricao || '(item)'}{x.fornecedor ? <span style={{color:'var(--rec-sub)'}}> · {x.fornecedor}</span> : null}</span>
                        </label>)}
                      </div>}
                      <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                        <button style={{...btnP, opacity:pode?1:0.6}} disabled={!pode} onClick={()=>encaminharRetirada(rc)}>{rc.status==='comprada' ? (direto ? 'Mandar direto' : 'Encaminhar') : 'Salvar'}</button>
                        <button style={btnG} onClick={()=>{setEncaminhaId(null);setEncForm(ENC_VAZIO)}}>Cancelar</button>
                      </div>
                    </div>
                    )
                  })()}
                  {rc.status==='em_estoque' && <div style={{fontSize:'.8rem', color:'var(--rec-green)', marginTop:8}}>✓ Chegou ao estoque — seguiu para o fluxo do almoxarifado (separação/remessa).</div>}
                  {rc.status==='entregue_unidade' && <div style={{fontSize:'.8rem', color:'var(--rec-green)', marginTop:8}}>✓ Entregue na unidade — veio direto do fornecedor, sem passar pelo estoque.</div>}
                </div>
                )})}
            </div>
        ))}
        {fimCartoes}
  </>
}

// ─── REC · Códigos de obra ────────────────────────────────────────────────────
// Obra executada DENTRO de uma unidade do contrato de manutenção (o que o sistema chama de "obra" é a
// unidade). Pedido do tipo Obra escolhe um código ATIVO daqui e sai só da Sede. O almoxarifado da Sede
// cadastra, edita, encerra e reabre (nunca apaga: o histórico dos pedidos fica); Diretor e Gerente
// consultam. Relatório por código: o que foi pedido × o que chegou, com exportação para Excel (CSV).
const fmtQtdRec = n => Number(n || 0).toLocaleString('pt-BR', { maximumFractionDigits: 3 })
function RecObraCodigos({ user, addToast, onMudou }) {
  const edita = user.role === 'almoxarifado'
  const [lista, setLista] = useState(null)
  const [unidades, setUnidades] = useState([])
  const [form, setForm] = useState(null)          // null | { id?, codigo, nome, unidade_id, aberta_em, status, encerrada_em }
  const [salvando, setSalvando] = useState(false)
  const [relId, setRelId] = useState(null)
  const [rel, setRel] = useState(null)
  const [verEnc, setVerEnc] = useState(false)
  const carregar = async () => { try { setLista(await GET('/rec/obra-codigos')) } catch (e) { addToast(e.message, 'error'); setLista([]) } }
  useEffect(() => { carregar(); if (edita) GET('/obras').then(setUnidades).catch(() => {}) }, [])
  const avisar = async () => { await carregar(); onMudou && onMudou() }
  const salvar = async () => {
    if (!form.codigo.trim() || !form.nome.trim() || !form.unidade_id) { addToast('Preencha código, nome da obra e unidade.', 'error'); return }
    setSalvando(true)
    try {
      const corpo = { codigo: form.codigo, nome: form.nome, unidade_id: Number(form.unidade_id), aberta_em: form.aberta_em || null,
        ...(form.id ? { status: form.status, encerrada_em: form.status === 'encerrada' ? (form.encerrada_em || null) : null } : {}) }
      if (form.id) await PUT('/rec/obra-codigos/' + form.id, corpo)
      else await POST('/rec/obra-codigos', corpo)
      addToast(form.id ? 'Obra atualizada.' : `Obra ${form.codigo.trim().toUpperCase()} cadastrada.`, 'success')
      setForm(null); await avisar()
    } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }
  const mudarStatus = async (o, status) => {
    try {
      await PUT('/rec/obra-codigos/' + o.id, { status })
      addToast(status === 'encerrada' ? `Obra ${o.codigo} encerrada: não recebe pedido novo.` : `Obra ${o.codigo} reaberta.`, 'success')
      await avisar()
      if (relId === o.id) setRel(await GET('/rec/obra-codigos/' + o.id + '/relatorio'))
    } catch (e) { addToast(e.message, 'error') }
  }
  const abrirRel = async o => {
    if (relId === o.id) { setRelId(null); setRel(null); return }
    setRelId(o.id); setRel(null)
    try { setRel(await GET('/rec/obra-codigos/' + o.id + '/relatorio')) } catch (e) { addToast(e.message, 'error') }
  }
  const card = { background:'var(--card)', border:'1px solid var(--border)', borderRadius:12, marginBottom:12 }
  const sub = { fontSize:'.8rem', color:'var(--text-secondary)' }
  const mono = 'ui-monospace,SFMono-Regular,Menlo,monospace'
  const dm = d => d ? `${String(d).slice(8, 10)}/${String(d).slice(5, 7)}/${String(d).slice(0, 4)}` : ''
  const ativas = (lista || []).filter(o => o.status === 'ativa')
  const encerradas = (lista || []).filter(o => o.status !== 'ativa')
  const visiveis = verEnc ? (lista || []) : ativas
  const unidadesForm = form && form.unidade_id && !unidades.some(u => String(u.id) === String(form.unidade_id))
    ? [...unidades, { id: form.unidade_id, nome: form.unidade_nome || 'Unidade atual' }] : unidades

  const formulario = form && (
    <div style={{...card, padding:16}}>
      <h3 style={{margin:'0 0 12px'}}>{form.id ? `Editar obra ${form.codigo}` : 'Nova obra'}</h3>
      <div className="form-grid">
        <div className="form-group"><label>Código *</label><input value={form.codigo} maxLength={30} placeholder="Ex.: OB07" onChange={e => setForm({ ...form, codigo: e.target.value })} /></div>
        <div className="form-group"><label>Nome da obra *</label><input value={form.nome} maxLength={120} placeholder="Ex.: Reforma da recepção" onChange={e => setForm({ ...form, nome: e.target.value })} /></div>
        <div className="form-group"><label>Unidade *</label>
          <select value={form.unidade_id} onChange={e => setForm({ ...form, unidade_id: e.target.value })} disabled={!!(form.id && form.pedidos)}>
            <option value="">— escolha a unidade —</option>
            {unidadesForm.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
          </select>
          {!!(form.id && form.pedidos) && <span className="text-muted" style={{fontSize:'.72rem', marginTop:4, display:'block'}}>Já tem pedidos: a unidade não muda (encerre e cadastre outra, se preciso).</span>}
        </div>
        <div className="form-group"><label>Abertura</label><input type="date" value={form.aberta_em} onChange={e => setForm({ ...form, aberta_em: e.target.value })} /></div>
        {form.id && <div className="form-group"><label>Situação</label>
          <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
            <option value="ativa">Ativa (recebe pedidos)</option><option value="encerrada">Encerrada</option>
          </select>
        </div>}
        {form.id && form.status === 'encerrada' && <div className="form-group"><label>Encerramento</label><input type="date" value={form.encerrada_em} onChange={e => setForm({ ...form, encerrada_em: e.target.value })} /></div>}
      </div>
      <div style={{display:'flex', gap:8, justifyContent:'flex-end', flexWrap:'wrap', marginTop:4}}>
        <button className="btn btn-ghost btn-sm" onClick={() => setForm(null)}>Cancelar</button>
        <button className="btn btn-primary btn-sm" disabled={salvando} onClick={salvar}><Icon name="check" size={14}/> {salvando ? 'Salvando…' : 'Salvar'}</button>
      </div>
    </div>
  )

  const relatorio = r => (
    <div style={{display:'grid', gap:14}}>
      <div style={{display:'flex', justifyContent:'space-between', gap:8, flexWrap:'wrap', alignItems:'center'}}>
        <strong style={{color:'var(--ink)'}}>Material da obra {r.obra.codigo}</strong>
        <button className="btn btn-ghost btn-sm" onClick={() => baixarArquivo('/rec/obra-codigos/' + r.obra.id + '/relatorio.csv', `obra-${r.obra.codigo}.csv`).catch(e => addToast(e.message, 'error'))}><Icon name="download" size={13}/> Excel (CSV)</button>
      </div>
      {r.itens.length === 0 ? <div style={sub}>Nenhum item pedido para esta obra ainda.</div> : (
        <div className="table-wrap"><table className="cards-mobile">
          <thead><tr><th>Item</th><th>Unid.</th><th style={{textAlign:'right'}}>Pedido</th><th style={{textAlign:'right'}}>Entregue</th><th style={{textAlign:'right'}}>Falta</th></tr></thead>
          <tbody>{r.itens.map((i, k) => (
            <tr key={k}>
              <td data-label="Item" style={{fontWeight:600}}>{i.item}</td>
              <td data-label="Unid.">{i.unidade || '—'}</td>
              <td data-label="Pedido" style={{textAlign:'right', fontFamily:mono}}>{fmtQtdRec(i.solicitado)}</td>
              <td data-label="Entregue" style={{textAlign:'right', fontFamily:mono, color:'var(--rec-green)'}}>{fmtQtdRec(i.entregue)}</td>
              <td data-label="Falta" style={{textAlign:'right', fontFamily:mono, fontWeight: i.pendente ? 700 : 400, color: i.pendente ? 'var(--rec-amber)' : 'var(--text-secondary)'}}>{fmtQtdRec(i.pendente)}</td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
      {r.pedidos.length > 0 && (
        <div style={{display:'grid', gap:6}}>
          <div style={{...sub, fontWeight:700}}>Pedidos ({r.pedidos.length})</div>
          {r.pedidos.map(p => (
            <div key={p.id} style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', fontSize:'.84rem', color:'var(--ink)'}}>
              <strong style={{fontFamily:mono}}>{p.numero}</strong>
              <RecTagAberto s={p}/>
              <span style={sub}>{dm(String(p.criado_em || '').slice(0, 10))} · {p.solicitante_nome || '—'} · {p.itens} item(ns)</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )

  return (
    <div>
      <p style={{margin:'-6px 0 14px', fontSize:'.86rem', color:'var(--text-secondary)'}}>
        Obra executada dentro de uma unidade do contrato. O pedido do tipo <strong style={{color:'var(--ink)'}}>Obra</strong> escolhe um código ativo daqui e sai só da Sede.
        {edita ? ' Obra encerrada não recebe pedido novo; o histórico fica.' : ' O cadastro é do almoxarifado da Sede.'}
      </p>
      <div style={{display:'flex', gap:'8px 14px', alignItems:'center', flexWrap:'wrap', marginBottom:14}}>
        {edita && !form && <button className="btn btn-accent" onClick={() => setForm({ codigo:'', nome:'', unidade_id:'', aberta_em:'', status:'ativa', encerrada_em:'' })}><Icon name="plus" size={14}/> Nova obra</button>}
        <span style={sub}>{ativas.length} ativa(s){encerradas.length ? ` · ${encerradas.length} encerrada(s)` : ''}</span>
        {encerradas.length > 0 && <label style={{...sub, display:'inline-flex', gap:6, alignItems:'center', cursor:'pointer'}}><input type="checkbox" checked={verEnc} onChange={e => setVerEnc(e.target.checked)} /> Mostrar encerradas</label>}
      </div>
      {formulario}
      {lista === null && <div style={{...card, padding:16, ...sub}}>Carregando…</div>}
      {lista !== null && visiveis.length === 0 && (
        <div style={{...card, padding:16, ...sub}}>{lista.length ? 'Nenhuma obra ativa agora.' : edita ? 'Nenhuma obra cadastrada. Cadastre os códigos que a técnica de edificações enviar.' : 'Nenhuma obra cadastrada.'}</div>
      )}
      {visiveis.map(o => (
        <div key={o.id} style={{...card, overflow:'hidden', opacity: o.status === 'ativa' ? 1 : 0.85}}>
          <div style={{display:'flex', gap:'8px 14px', alignItems:'center', flexWrap:'wrap', padding:'12px 14px'}}>
            <span style={{fontFamily:mono, fontWeight:800, fontSize:'1rem', color:'var(--ink)', minWidth:56}}>{o.codigo}</span>
            <div style={{flex:'1 1 220px', minWidth:0}}>
              <div style={{fontWeight:600, color:'var(--ink)', overflowWrap:'anywhere'}}>{o.nome}</div>
              <div style={{...sub, overflowWrap:'anywhere'}}>{o.unidade_nome}{o.aberta_em ? ` · aberta em ${dm(o.aberta_em)}` : ''}{o.status !== 'ativa' && o.encerrada_em ? ` · encerrada em ${dm(o.encerrada_em)}` : ''}</div>
            </div>
            <span className={`rtag dot tg-${o.status === 'ativa' ? 'ok' : 'neutro'}`}>{o.status === 'ativa' ? 'Ativa' : 'Encerrada'}</span>
            <span style={sub}>{o.pedidos ? `${o.pedidos} pedido(s)${o.pedidos_abertos ? ` · ${o.pedidos_abertos} em aberto` : ''}` : 'sem pedidos'}</span>
            <div style={{display:'flex', gap:6, flexWrap:'wrap'}}>
              <button className="btn btn-ghost btn-sm" onClick={() => abrirRel(o)}>{relId === o.id ? 'Fechar' : 'Relatório'}</button>
              {edita && <button className="btn btn-ghost btn-sm" onClick={() => setForm({ ...o, aberta_em: o.aberta_em || '', encerrada_em: o.encerrada_em || '' })}>Editar</button>}
              {edita && (o.status === 'ativa'
                ? <button className="btn btn-ghost btn-sm" style={{color:'var(--danger)'}} onClick={() => mudarStatus(o, 'encerrada')}>Encerrar</button>
                : <button className="btn btn-ghost btn-sm" onClick={() => mudarStatus(o, 'ativa')}>Reabrir</button>)}
            </div>
          </div>
          {relId === o.id && (
            <div style={{borderTop:'1px solid var(--border)', padding:14, background:'var(--silver-light,#f8fafc)'}}>
              {rel && rel.obra.id === o.id ? relatorio(rel) : <div style={sub}>Carregando…</div>}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

function RecPage({ user, navigate, addToast, openTarget, clearOpenTarget }) {
  const [deps, setDeps] = useState([])
  const [cat, setCat] = useState([])
  const [sols, setSols] = useState([])
  const [obras, setObras] = useState([])
  const [obraCods, setObraCods] = useState([])   // códigos de obra (REC → Códigos de obra): quem pede escolhe; a gestão vê todos
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState('solicitacoes')
  const gestor = ['almoxarifado','diretor','gerente'].includes(user.role)
  const almox = user.role === 'almoxarifado'
  const almox2 = user.role === 'almoxarife2'
  const logistica = user.role === 'logistica'
  const motorista = user.role === 'motorista'
  const transportador = logistica || motorista           // quem opera A caminho / Retirar
  const solicitante = ['engenheiro','lider','gerente'].includes(user.role)
  const compras = ['compras','administracao'].includes(user.role)
  const recebe = ['lider','engenheiro'].includes(user.role)
  const veRemessas = almox || almox2 || transportador || recebe || ['diretor','gerente'].includes(user.role)
  const veRetiradas = compras || almox || almox2 || transportador || ['diretor','gerente'].includes(user.role)  // fila de retirada de material comprado
  const aprovador = ['gerente','diretor'].includes(user.role)   // modo 'aprovar': decide pedido fora do prazo (não o próprio)
  const masterReal = !!(user.is_master && !user.admin && !user.ceo)
  const [prazoCfg, setPrazoCfg] = useState(null)              // regra do prazo de pedidos + hoje do servidor + placar do solicitante

  const [remessas, setRemessas] = useState([])
  const [painel, setPainel] = useState(null)
  const [comprasList, setComprasList] = useState([])
  const [retiradas, setRetiradas] = useState([])           // fila de itens aguardando retirada
  const [motoristas, setMotoristas] = useState([])         // quem pode retirar uma remessa (ajudante/logística)
  const [motEsc, setMotEsc] = useState({})                 // remessa → motorista escolhido no seletor
  const [trocaMot, setTrocaMot] = useState(null)           // remessa com o "trocar motorista" aberto
  const [foraApp, setForaApp] = useState(null)             // "entregue por fora do app": { id, entregue_em, recebido_por, motivo }
  const carregarRemessas = async () => { try { setRemessas(await GET('/rec/remessas')) } catch (e) { addToast && addToast(e.message, 'error') } }
  const carregarCompras = async () => { try { setComprasList(await GET('/rec/compras')) } catch (e) { addToast && addToast(e.message, 'error') } }
  const carregarRetiradas = async () => { try { setRetiradas(await GET('/rec/retiradas')) } catch (e) { addToast && addToast(e.message, 'error') } }
  const [retLoad, setRetLoad] = useState(false)
  const retMultiCt = new Set(retiradas.map(rc => rc.contrato_id).filter(Boolean)).size > 1
  const confirmarRetirada = async (id) => {
    setRetLoad(true)
    try { const r = await POST('/rec/retiradas/' + id + '/confirmar', {}); addToast('Retirada confirmada.' + (r && r.remessa ? ` Seguiu na remessa ${r.remessa.numero}.` : ''), 'success'); await carregarRetiradas() }
    catch (e) { addToast(e.message, 'error') }
    setRetLoad(false)
  }
  const [compraFiltro, setCompraFiltro] = useState(null)   // card do painel/Pendências → filtro da esteira de Compras
  // Filtro vindo de um card de painel: { sol:[status] } | { rem:[status] } | { div:true } — com a faixa
  // "Mostrando: …". Os de Compras (compraStatus/compraObra/compraContrato) vão para a esteira (ComprasEsteira).
  const [recFiltro, setRecFiltro] = useState(null)
  // Barra de filtros das listas (Solicitações / Remessas). A situação e a ordem ficam guardadas neste
  // aparelho, por usuário; busca e seletores valem só enquanto a tela está aberta.
  const RECF_KEY = 'rec_filtros:' + user.id
  const [recfSalvo] = useState(() => { try { return JSON.parse(localStorage.getItem(RECF_KEY) || '{}') || {} } catch { return {} } })
  const SOL_F_VAZIO = { q: '', obra: '', pessoa: '', tipo: '', fora: false }
  const REM_F_VAZIO = { q: '', obra: '', dep: '', mot: '', div: false }
  const [solSit, setSolSit] = useState(recfSalvo.sol || 'andamento')
  const [solOrdem, setSolOrdem] = useState(recfSalvo.ordem || 'recentes')
  const [remSit, setRemSit] = useState(recfSalvo.rem || 'andamento')
  const [solF, setSolF] = useState(SOL_F_VAZIO)
  const [remF, setRemF] = useState(REM_F_VAZIO)
  useEffect(() => {
    try { localStorage.setItem(RECF_KEY, JSON.stringify({ sol: solSit, ordem: solOrdem, rem: remSit })) } catch {}
  }, [solSit, solOrdem, remSit])
  // Card do painel/Pendências chega com o filtro dele: começa limpo para não somar com o que já estava.
  const aplicarFiltroRec = f => {
    const doPainel = f && (f.sol || f.rem || f.div || f.fora)
    setRecFiltro(doPainel ? f : null)
    if (doPainel) { setSolF(SOL_F_VAZIO); setRemF(REM_F_VAZIO) }
    if (f && (f.compraStatus != null || f.compraObra != null || f.compraContrato != null || f.compraId != null)) setCompraFiltro({ ...f })
  }

  // ── Fila offline-first (telas de campo): guarda a ação assinada quando sem rede e
  // sincroniza sozinha ao reconectar. Assim uma assinatura no canteiro nunca se perde. ──
  const FILA_KEY = 'rec_fila_custodia'
  const lerFila = () => { try { return JSON.parse(localStorage.getItem(FILA_KEY) || '[]') } catch { return [] } }
  const salvarFila = f => { try { localStorage.setItem(FILA_KEY, JSON.stringify(f)) } catch {} }
  const [filaPend, setFilaPend] = useState(() => lerFila().length)
  const semRede = e => !navigator.onLine || /Sem conexão|Failed to fetch|NetworkError|Load failed|Erro 503/i.test(e && e.message || '')
  // Cada ação guarda quem a fez (uid): no celular compartilhado, ela só sobe com o login de quem assinou — nunca
  // em nome de outra pessoa. Sessão encerrada (401 de sessão) não descarta: fica na fila até a pessoa entrar de novo.
  const enfileirar = (acao, remessa_id, body) => {
    const f = lerFila(); f.push({ id: Date.now() + '-' + Math.random().toString(36).slice(2, 7), uid: user.id, acao, remessa_id, body }); salvarFila(f); setFilaPend(f.length)
  }
  const sincronizarFila = async () => {
    let f = lerFila(); if (!f.length) return
    const resta = []
    let parou = false
    for (const it of f) {
      if (parou || (it.uid && it.uid !== user.id)) { resta.push(it); continue }
      try { await POST('/rec/remessas/' + it.remessa_id + '/' + it.acao, it.body) }
      catch (e) {
        if (e.data && e.data.sessao) { parou = true; resta.push(it) }   // sessão encerrada: guarda tudo para depois
        else if (semRede(e)) resta.push(it) /* 4xx/409 = estado já mudou → descarta */
      }
    }
    salvarFila(resta); setFilaPend(resta.length)
    if (resta.length < f.length) { addToast('Ações offline sincronizadas.', 'success'); carregarRemessas() }
  }
  useEffect(() => {
    if (veRemessas) sincronizarFila()
    const on = () => sincronizarFila()
    window.addEventListener('online', on)
    return () => window.removeEventListener('online', on)
  }, [])
  const load = async () => {
    setLoading(true)
    try {
      const tarefas = veRemessas
        ? [GET('/rec/depositos'), GET('/rec/catalogo'), GET('/rec/solicitacoes'), GET('/rec/remessas')]
        : [GET('/rec/depositos'), GET('/rec/catalogo'), GET('/rec/solicitacoes')]
      const [d,c,s,rem] = await Promise.all(tarefas)
      setDeps(d); setCat(c); setSols(s); if (rem) setRemessas(rem)
      try { setPrazoCfg(await GET('/rec/prazo-config')) } catch {}
      if (solicitante) { try { setObras(await GET('/obras?escolha=1')) } catch {} }
      if (solicitante || gestor) { try { setObraCods(await GET('/rec/obra-codigos')) } catch {} }
      if (almox || almox2) { try { setMotoristas(await GET('/rec/motoristas')) } catch {} }
      if (gestor) { try { setPainel(await GET('/rec/painel')) } catch {} }
      if (compras) { try { setComprasList(await GET('/rec/compras')) } catch {} }
      if (veRetiradas) { try { setRetiradas(await GET('/rec/retiradas')) } catch {} }
    } catch (e) { addToast && addToast(e.message, 'error') }
    setLoading(false)
  }
  useEffect(() => { load() }, [])
  // default: papéis de estoque/logística começam em Remessas; compras em Compras. Vindo de
  // Pendências ou da busca global, abre direto na sub-aba onde está a demanda (openTarget.id = id da
  // sub-aba). Com o REC já aberto a tela não remonta (busca Ctrl+K): o alvo novo também é lido aqui.
  const iniciou = useRef(false)
  useEffect(() => {
    const alvo = openTarget && openTarget.page === 'rec' && openTarget.id
    if (alvo) {
      setTab(alvo); aplicarFiltroRec(openTarget.filtro)
      if (openTarget.filtro && openTarget.filtro.remessa) setAbrirRem(openTarget.filtro)
      if (openTarget.filtro && openTarget.filtro.solicitacao) setAbrirSol(openTarget.filtro.solicitacao)
      clearOpenTarget && clearOpenTarget()
    }
    else if (!iniciou.current) { if (compras) setTab('compras'); else if (almox2 || transportador) setTab('remessas') }
    iniciou.current = true
  }, [openTarget])
  // Vindo do Painel do Motorista ({ remessa, assinar }): depois de carregar, abre a remessa e — se pedido —
  // já na assinatura (Retirar/Entregar), para o motorista não ter de procurar o card de novo.
  const [abrirRem, setAbrirRem] = useState(null)
  useEffect(() => {
    if (loading || !abrirRem) return
    verNaAbaRemessas({ id: abrirRem.remessa })
    if (abrirRem.assinar) setAssinarRem(abrirRem.remessa)
    setAbrirRem(null)
  }, [loading, abrirRem])

  // Detalhe/ações da solicitação (Fase 1).
  const [abertaId, setAbertaId] = useState(null)
  const [detalhe, setDetalhe] = useState(null)
  const [acaoLoad, setAcaoLoad] = useState(false)
  const [promData, setPromData] = useState('')       // data prometida pelo almoxarifado (pedido fora do prazo)
  const [promEdit, setPromEdit] = useState(false)     // editor da data prometida aberto
  const [aprovCom, setAprovCom] = useState('')        // comentário do gerente (obrigatório para recusar)
  const PRAZO_VAZIO = { data:'', motivo:'', impacto:'' }
  const [reenvio, setReenvio] = useState(PRAZO_VAZIO) // nova data do pedido recusado
  const abrirDetalhe = async (s) => {
    if (abertaId === s.id) { setAbertaId(null); setDetalhe(null); return }
    setAbertaId(s.id); setDetalhe(null); setPromEdit(false); setAprovCom(''); setReenvio(PRAZO_VAZIO)
    // Sugestão da data prometida: a data pedida (ou hoje, se já passou).
    const hoje = (prazoCfg && prazoCfg.hoje) || hojeYMD()
    setPromData(s.data_prometida || (s.necessario_em && s.necessario_em > hoje ? s.necessario_em : hoje))
    try { setDetalhe(await GET('/rec/solicitacoes/' + s.id)) } catch (e) { addToast(e.message, 'error') }
  }
  const recarregarSol = async (id) => {
    const [novas, det] = await Promise.all([GET('/rec/solicitacoes'), GET('/rec/solicitacoes/' + id)])
    setSols(novas); setDetalhe(det)
  }
  // Busca global (Ctrl+K): abre o card da solicitação procurada, sem busca/filtro da lista escondendo.
  // Lista carregada antes de o pedido existir → busca de novo.
  const [abrirSol, setAbrirSol] = useState(null)
  useEffect(() => {
    if (loading || !abrirSol) return
    const id = abrirSol
    setAbrirSol(null)
    ;(async () => {
      let s = sols.find(x => x.id === id)
      if (!s) { try { const novas = await GET('/rec/solicitacoes'); setSols(novas); s = novas.find(x => x.id === id) } catch {} }
      if (!s) { addToast('Esta solicitação não está na sua lista do REC.', 'error'); return }
      setTab('solicitacoes'); setRecFiltro(null); setSolF(SOL_F_VAZIO)
      if (abertaId !== s.id) abrirDetalhe(s)
      setTimeout(() => { const el = document.getElementById('sol-' + s.id); if (el) el.scrollIntoView({ block:'start', behavior:'smooth' }) }, 80)
    })()
  }, [loading, abrirSol])
  const acaoSolicitacao = async (id, acao, extra) => {
    if (acao === 'cancelar' && user.admin) { addToast('Seu perfil administrativo não pode cancelar.', 'error'); return }
    setAcaoLoad(true)
    try {
      await POST('/rec/solicitacoes/' + id + '/acao', { acao, ...(extra || {}) })
      await recarregarSol(id)
      addToast('Solicitação atualizada.', 'success')
    } catch (e) { addToast(e.message, 'error') }
    setAcaoLoad(false)
  }
  // Prazo: data prometida (almox), aprovação (gerente/diretor), reenvio/desistência (quem pediu).
  const postSol = async (id, rota, body, msg) => {
    setAcaoLoad(true)
    try { await POST('/rec/solicitacoes/' + id + '/' + rota, body || {}); await recarregarSol(id); addToast(msg, 'success'); setAcaoLoad(false); return true }
    catch (e) { addToast(e.message, 'error'); setAcaoLoad(false); return false }
  }
  const salvarPrometida = async id => { if (await postSol(id, 'data-prometida', { data_prometida: promData }, 'Data prometida salva.')) setPromEdit(false) }
  const decidir = async (id, decisao) => {
    if (decisao === 'recusar' && aprovCom.trim().length < 5) { addToast('Escreva o motivo da recusa para quem pediu.', 'error'); return }
    const msg = { aprovar: 'Pedido aprovado: segue para o almoxarifado.', recusar: 'Pedido recusado: voltou para quem pediu.', ciente: 'Ciência registrada.' }[decisao]
    if (await postSol(id, 'aprovacao', { decisao, comentario: aprovCom.trim() || null }, msg)) { setAprovCom(''); try { setSols(await GET('/rec/solicitacoes')) } catch {} }
  }
  const prazoInvalido = (v) => {
    const cls = recClassificar(v.data, prazoCfg)
    if (!cls) return 'Informe a data em que precisa do material na obra.'
    if (cls.passada) return 'A data de necessidade não pode estar no passado.'
    if (cls.faixa === 'fora_prazo' && recTrava(prazoCfg) && v.motivo !== 'emergencia')
      return `Data bloqueada: antes do mínimo de ${recDiasUteis(prazoCfg.vigente)} só entra emergência. A primeira data possível é ${recDM(recPrimeiraData(prazoCfg))}.`
    if (cls.faixa === 'fora_prazo' && prazoCfg.modo !== 'medir') {
      if (!v.motivo) return 'Escolha o motivo do pedido fora do prazo.'
      if (v.impacto.trim().length < (prazoCfg.impacto_min || 20)) return `Descreva o impacto (mínimo ${prazoCfg.impacto_min || 20} caracteres).`
    }
    return null
  }
  const reenviar = async id => {
    const erro = prazoInvalido(reenvio)
    if (erro) { addToast(erro, 'error'); return }
    if (await postSol(id, 'reenviar', { necessario_em: reenvio.data, motivo_fora_prazo: reenvio.motivo || null, impacto_fora_prazo: reenvio.impacto || null }, 'Pedido reenviado.')) {
      setReenvio(PRAZO_VAZIO); try { setPrazoCfg(await GET('/rec/prazo-config')) } catch {}
    }
  }

  // "Isto é obra": o almoxarifado da Sede (na análise) ou o Almoxarife 2 (na separação da remessa da base)
  // devolve o pedido de Manutenção para quem pediu refazer como Obra. O motivo é o que a pessoa lê.
  const [devObra, setDevObra] = useState(null)   // { sol: id, motivo }
  const devolverObra = async solId => {
    const motivo = ((devObra && devObra.motivo) || '').trim()
    if (motivo.length < 5) { addToast('Escreva para quem pediu por que isto é obra.', 'error'); return }
    setAcaoLoad(true)
    try {
      const r = await POST('/rec/solicitacoes/' + solId + '/devolver-obra', { motivo })
      addToast('Pedido devolvido: quem pediu refaz como Obra (sai da Sede).' + (r.remessas_canceladas ? ' A remessa foi cancelada.' : ''), 'success')
      setDevObra(null)
      if (almox2) { setRemAberta(null); setRemDet(null) }
      await carregarRemessas()
      if (!almox2) { try { setSols(await GET('/rec/solicitacoes')); if (abertaId === solId) setDetalhe(await GET('/rec/solicitacoes/' + solId)) } catch {} }
    } catch (e) { addToast(e.message, 'error') }
    setAcaoLoad(false)
  }
  const botaoIstoEObra = solId => !(devObra && devObra.sol === solId) && (
    <button style={{...btnG, color:'var(--tag-cobre-fg)', borderColor:'var(--tag-cobre-dot)'}} onClick={()=>{ setDevObra({ sol: solId, motivo: '' }); setCancSol(null) }}
      title="Pedido de obra sai só da Sede: devolve para quem pediu refazer como Obra">Isto é obra</button>
  )
  const formIstoEObra = solId => devObra && devObra.sol === solId && (
    <div style={{display:'grid', gap:8, marginTop:10, padding:'10px 12px', border:'1px solid var(--tag-cobre-dot)', borderRadius:10, background:'var(--card)'}}>
      <strong style={{fontSize:'.86rem', color:'var(--ink)'}}>Devolver como obra</strong>
      <textarea style={{...inp, minHeight:56}} maxLength={500} autoFocus value={devObra.motivo} onChange={e=>setDevObra({ ...devObra, motivo: e.target.value })}
        placeholder="Por que é obra? Ex.: material da reforma geral (OB05). Quem pediu lê isto." />
      <span style={{fontSize:'.76rem', color:'var(--text-secondary)'}}>
        O pedido volta para quem pediu refazer como Obra (sai da Sede). {almox2 ? 'A remessa da base é cancelada: nada sai daqui.' : 'Remessa em separação e compra ainda não feita são canceladas.'}
      </span>
      <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
        <button style={{...btnP, background:'var(--fill-cobre)', opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>devolverObra(solId)}>Devolver para quem pediu</button>
        <button style={btnG} onClick={()=>setDevObra(null)}>Cancelar</button>
      </div>
    </div>
  )

  // Cancelar o pedido (almoxarifado): o motivo é o que quem pediu lê. Com a remessa ainda em separação ela é cancelada
  // junto; compra ainda não feita também (compra já feita o servidor recusa: fala-se antes com Compras).
  const [cancSol, setCancSol] = useState(null)   // { sol: id, motivo }
  const cancelarPedido = async solId => {
    const motivo = ((cancSol && cancSol.motivo) || '').trim()
    if (motivo.length < 5) { addToast('Escreva para quem pediu por que o pedido foi cancelado.', 'error'); return }
    setAcaoLoad(true)
    try {
      const r = await POST('/rec/solicitacoes/' + solId + '/acao', { acao: 'cancelar', motivo })
      addToast('Pedido cancelado.' + (r.remessas_canceladas ? ' A remessa em separação foi cancelada.' : '') + (r.compras_canceladas ? ' A compra que não tinha sido feita também.' : ''), 'success')
      setCancSol(null)
      await recarregarSol(solId)
      if (r.remessas_canceladas) carregarRemessas()
    } catch (e) { addToast(e.message, 'error') }
    setAcaoLoad(false)
  }
  const botaoCancelarPedido = (solId, d) => !user.admin && !(cancSol && cancSol.sol === solId) && (
    <button style={{...btnG, color:'var(--danger)', borderColor:'var(--tag-perigo-line)', opacity:acaoLoad?0.6:1}} disabled={acaoLoad}
      onClick={()=>{ setCancSol({ sol: solId, motivo: '' }); setDevObra(null) }}>Cancelar pedido</button>
  )
  const formCancelarPedido = (solId, d) => cancSol && cancSol.sol === solId && (
    <div style={{display:'grid', gap:8, marginTop:10, padding:'10px 12px', border:'1px solid var(--tag-perigo-line)', borderRadius:10, background:'var(--card)'}}>
      <strong style={{fontSize:'.86rem', color:'var(--ink)'}}>Cancelar o pedido {d.numero}</strong>
      <textarea style={{...inp, minHeight:56}} maxLength={500} autoFocus value={cancSol.motivo} onChange={e=>setCancSol({ ...cancSol, motivo: e.target.value })}
        placeholder="Por que está cancelando? Ex.: falta a informação da obra — refaça o pedido com a obra. Quem pediu lê isto." />
      <span style={{fontSize:'.76rem', color:'var(--text-secondary)'}}>
        Quem pediu vê o motivo no pedido. {d.so_separacao ? 'A remessa em separação é cancelada (nada saiu do estoque). ' : ''}Compra ainda não feita também é cancelada.
      </span>
      <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
        <button style={{...btnP, background:'var(--danger)', opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>cancelarPedido(solId)}>Cancelar pedido</button>
        <button style={btnG} onClick={()=>setCancSol(null)}>Voltar</button>
      </div>
    </div>
  )

  // Item que o estoque não atende → Compras (almoxarifado da Sede, antes da remessa). "Não chegou": item digitado que
  // Compras marcou "Chegou ao estoque" e não está aqui (a compra volta à etapa de antes). "Sem estoque": o saldo do
  // catálogo não cobre mais a linha (abre a compra do que falta). O motivo é o que Compras lê.
  const [paraCompras, setParaCompras] = useState(null)   // { item: id, motivo }
  const naoChegou = it => !it.catalogo_id && it.compra && it.compra.status === 'em_estoque'
  const mandarParaCompras = async (solId, it) => {
    const motivo = ((paraCompras && paraCompras.motivo) || '').trim()
    if (motivo.length < 5) { addToast('Escreva para Compras o que aconteceu.', 'error'); return }
    setAcaoLoad(true)
    try {
      const r = await POST(`/rec/solicitacoes/${solId}/itens/${it.id}/para-compras`, { motivo })
      const rm = r.remessas || {}
      addToast(`Item enviado para Compras (${r.compra}).` + (r.status === 'em_compras' ? ' O pedido inteiro está em Compras agora.' : '')
        + ((rm.canceladas || []).length ? ` Remessa cancelada: ${rm.canceladas.join(', ')}.` : '') + ((rm.alteradas || []).length ? ` Saiu da remessa ${rm.alteradas.join(', ')}.` : ''), 'success')
      setParaCompras(null)
      await recarregarSol(solId)
      if (r.remessas) carregarRemessas()
    } catch (e) { addToast(e.message, 'error') }
    setAcaoLoad(false)
  }
  const blocoParaCompras = (solId, it) => {
    const un = it.catalogo_unidade || it.unidade || ''
    const parte = Number(it.falta_estoque) < Number(it.qtd)
    if (!(paraCompras && paraCompras.item === it.id)) return (
      <button style={{background:'none', border:'none', padding:0, marginTop:8, cursor:'pointer', fontSize:'.76rem', fontWeight:600, color:'var(--tag-cobre-fg)', textDecoration:'underline'}}
        onClick={()=>setParaCompras({ item: it.id, motivo: '' })}>
        {naoChegou(it) ? 'Não chegou? Voltar para Compras' : parte ? `Enviar os ${Number(it.falta_estoque)}${un ? ' ' + un : ''} que faltam para Compras` : 'Sem estoque? Enviar para Compras'}
      </button>
    )
    return (
      <div style={{display:'grid', gap:8, marginTop:10, padding:'10px 12px', border:'1px solid var(--tag-cobre-dot)', borderRadius:10, background:'var(--card)'}}>
        <strong style={{fontSize:'.86rem', color:'var(--ink)'}}>{naoChegou(it) ? 'Não chegou ao estoque' : 'Enviar para Compras'}</strong>
        <textarea style={{...inp, minHeight:56}} maxLength={500} autoFocus value={paraCompras.motivo} onChange={e=>setParaCompras({ ...paraCompras, motivo: e.target.value })}
          placeholder={naoChegou(it) ? 'O que aconteceu? Ex.: não está na Sede, ninguém recebeu. Compras lê isto.' : 'O que aconteceu? Ex.: o saldo foi para outro pedido. Compras lê isto.'} />
        <span style={{fontSize:'.76rem', color:'var(--text-secondary)'}}>
          {naoChegou(it)
            ? `A compra ${it.compra.numero} volta para Compras na etapa de antes do "Chegou ao estoque" e o item sai da sua fila até chegar de verdade.`
            : `Abre um requerimento de compra de ${Number(it.falta_estoque)}${un ? ' ' + un : ''} (A cotar).${parte ? ` O resto (${Number(it.qtd) - Number(it.falta_estoque)}${un ? ' ' + un : ''}) segue no estoque.` : ''}`}
          {detalhe && detalhe.so_separacao ? ` ${parte ? 'O que vai para Compras sai' : 'O item sai'} da remessa em separação${parte ? '' : ' (remessa que fica vazia é cancelada)'}.` : ''}
        </span>
        <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
          <button style={{...btnP, background:'var(--fill-cobre)', opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>mandarParaCompras(solId, it)}>Mandar para Compras</button>
          <button style={btnG} onClick={()=>setParaCompras(null)}>Cancelar</button>
        </div>
      </div>
    )
  }

  // Fase 2: gerar remessa (a partir de solicitação reservada), separar/pronta, retirar assinando.
  // A divisão (de onde sai cada item) é o RecDivisao; refazDiv = pedido com a divisão sendo refeita.
  const [refazDiv, setRefazDiv] = useState(null)
  const aposDivisao = async (solId, r, refez) => {
    const rems = r.remessas || []
    if (refez) {
      const mudou = (r.alteradas || []).length + (r.canceladas || []).length + rems.filter(x => !(remessas || []).some(y => y.id === x.id)).length
      addToast(mudou ? `Divisão refeita: ${rems.map(x => `${x.numero} (${x.deposito || '—'})`).join(', ')}.` : 'Nada mudou na divisão.', 'success')
    } else addToast(rems.length > 1 ? `${rems.length} remessas geradas: ${rems.map(x => x.deposito || '—').join(' + ')}.` : `Remessa ${r.numero} gerada.`, 'success')
    setRefazDiv(null)
    try {
      const [novas, det] = await Promise.all([GET('/rec/solicitacoes'), GET('/rec/solicitacoes/' + solId)])
      setSols(novas); setDetalhe(det)
    } catch {}
    carregarRemessas()
  }
  // "Não consigo enviar" (Almoxarife 2): devolve à Sede um item da remessa da base em separação, com motivo.
  const REC_MOTIVOS_DEV = ['Saldo físico menor que o do sistema', 'Material com avaria', 'Sem condição de separar no prazo']
  const [devItem, setDevItem] = useState(null)   // { rem, item, motivo, outro }
  const devolverItem = async () => {
    const motivo = (devItem.motivo === 'outro' ? devItem.outro : devItem.motivo || '').trim()
    if (motivo.length < 5) { addToast(devItem.motivo === 'outro' ? 'Escreva o motivo para a Sede (mínimo 5 caracteres).' : 'Escolha o motivo.', 'error'); return }
    setRemLoad(true)
    try {
      const r = await POST(`/rec/remessas/${devItem.rem}/devolver-item`, { item_id: devItem.item, motivo })
      addToast(r.remessa_cancelada ? 'Item devolvido à Sede. A remessa ficou vazia e foi cancelada.' : `Item devolvido à Sede (${r.para.numero}). A Sede foi avisada.`, 'success')
      setDevItem(null)
      if (r.remessa_cancelada) { setRemAberta(null); setRemDet(null) }
      else { try { setRemDet(await GET('/rec/remessas/' + devItem.rem)) } catch {} }
      carregarRemessas()
    } catch (e) { addToast(e.message, 'error') }
    setRemLoad(false)
  }
  const [remAberta, setRemAberta] = useState(null)
  const [remDet, setRemDet] = useState(null)
  const [remLoad, setRemLoad] = useState(false)
  const [chatRem, setChatRem] = useState(null)   // remessa cujo chat está aberto
  const [assinarRem, setAssinarRem] = useState(null)
  const abrirRemessa = async (r) => {
    if (remAberta === r.id) { setRemAberta(null); setRemDet(null); return }
    setRemAberta(r.id); setRemDet(null)
    try { setRemDet(await GET('/rec/remessas/' + r.id)) } catch (e) { addToast(e.message, 'error') }
  }
  // Depois de mexer numa remessa, atualiza a lista, o detalhe aberto em Remessas e a solicitação
  // aberta em Solicitações (a esteira dela depende do status da remessa).
  const aposAcaoRemessa = async (id) => {
    await carregarRemessas()
    if (remAberta === id) { try { setRemDet(await GET('/rec/remessas/' + id)) } catch {} }
    if (abertaId) { try { const [novas, det] = await Promise.all([GET('/rec/solicitacoes'), GET('/rec/solicitacoes/' + abertaId)]); setSols(novas); setDetalhe(det) } catch {} }
  }
  const motPadrao = motoristas.length === 1 ? String(motoristas[0].id) : ''
  const marcarPronta = async (id) => {
    const mid = motEsc[id] || motPadrao
    if (motoristas.length && !mid) { addToast('Escolha o motorista que vai retirar.', 'error'); return }
    setRemLoad(true)
    try {
      const r = await POST('/rec/remessas/' + id + '/pronta', { motorista_id: mid ? Number(mid) : null })
      addToast(r.motorista_nome ? `Pronta — ${r.motorista_nome} já pode retirar.` : 'Remessa pronta para retirada.', 'success')
      await aposAcaoRemessa(id)
    } catch (e) { addToast(e.message, 'error') }
    setRemLoad(false)
  }
  const trocarMotorista = async (id) => {
    const mid = motEsc[id]
    if (!mid) { addToast('Escolha o motorista.', 'error'); return }
    setRemLoad(true)
    try {
      const r = await POST('/rec/remessas/' + id + '/motorista', { motorista_id: Number(mid) })
      addToast(`Retirada passada para ${r.motorista_nome}.`, 'success'); setTrocaMot(null)
      await aposAcaoRemessa(id)
    } catch (e) { addToast(e.message, 'error') }
    setRemLoad(false)
  }
  // Material que já chegou à obra sem o motorista registrar no app: a Sede fecha a remessa (sem assinatura).
  const registrarForaApp = async () => {
    const f = foraApp
    if (!f) return
    if (!f.entregue_em) { addToast('Informe o dia em que o material chegou à obra.', 'error'); return }
    if (String(f.motivo || '').trim().length < 10) { addToast('Escreva por que a entrega não passou pelo app (mínimo 10 caracteres).', 'error'); return }
    setRemLoad(true)
    try {
      const r = await POST('/rec/remessas/' + f.id + '/entregue-fora-do-app', { entregue_em: f.entregue_em, recebido_por: f.recebido_por || null, motivo: f.motivo })
      addToast('Entrega registrada' + (r.itens_baixados ? ` e baixa no estoque (${r.itens_baixados} item(ns))` : '') + '.' + (r.solicitacao_status === 'entregue' ? ' Pedido concluído.' : ''), 'success')
      setForaApp(null)
      await aposAcaoRemessa(f.id)
    } catch (e) { addToast(e.message, 'error') }
    setRemLoad(false)
  }
  const marcarACaminho = async (id) => {
    setRemLoad(true)
    try { await POST('/rec/remessas/' + id + '/a-caminho'); addToast('Marcado: a caminho da retirada.', 'success'); await carregarRemessas(); setRemDet(await GET('/rec/remessas/' + id)) }
    catch (e) { addToast(e.message, 'error') }
    setRemLoad(false)
  }
  // Retirada com assinatura dupla (ajudante + almoxarifado). p: {ator, contra, reauth, contraNome, foto}.
  const retirarRemessa = async (id, p) => {
    setRemLoad(true)
    const body = { assinatura: p.ator, assinatura_de: p.contra, contraparte_nome: p.contraNome || null, reauth: p.reauth || null, foto: p.foto || null,
      ...(p.divergencia ? { divergencia: p.divergencia } : {}) }
    if (!navigator.onLine) { enfileirar('retirar', id, body); addToast('Sem conexão — retirada guardada e enviada ao reconectar.', 'success'); setAssinarRem(null); setRemLoad(false); return }
    try {
      await POST('/rec/remessas/' + id + '/retirar', body)
      addToast('Custódia retirada — elo assinado.', 'success')
      setAssinarRem(null); await carregarRemessas(); setRemDet(await GET('/rec/remessas/' + id))
    } catch (e) {
      if (semRede(e)) { enfileirar('retirar', id, body); addToast('Sem conexão — retirada guardada offline.', 'success'); setAssinarRem(null) }
      else addToast(e.message, 'error')
    }
    setRemLoad(false)
  }
  const [diverg, setDiverg] = useState('')
  // Entrega na obra pelo aparelho do ajudante, assinatura dupla (ajudante + recebedor). p igual à retirada.
  const entregarRemessa = async (id, p) => {
    setRemLoad(true)
    const body = { assinatura: p.ator, assinatura_para: p.contra, contraparte_nome: p.contraNome || null, reauth: p.reauth || null, foto: p.foto || null, divergencia: diverg || null, condicao: diverg ? 'divergencia' : 'ok' }
    if (!navigator.onLine) { enfileirar('entregar', id, body); addToast('Sem conexão — entrega guardada e enviada ao reconectar.', 'success'); setAssinarRem(null); setDiverg(''); setRemLoad(false); return }
    try {
      const r = await POST('/rec/remessas/' + id + '/entregar', body)
      addToast(r.divergencia ? 'Entregue com divergência registrada.' : 'Entrega confirmada — assinada pelas duas partes.', 'success')
      setAssinarRem(null); setDiverg(''); await carregarRemessas(); setRemDet(await GET('/rec/remessas/' + id))
    } catch (e) {
      if (semRede(e)) { enfileirar('entregar', id, body); addToast('Sem conexão — entrega guardada offline.', 'success'); setAssinarRem(null); setDiverg('') }
      else addToast(e.message, 'error')
    }
    setRemLoad(false)
  }
  const receberRemessa = async (id, assinatura, foto) => {
    setRemLoad(true)
    const body = { assinatura, foto: foto || null, divergencia: diverg || null, condicao: diverg ? 'divergencia' : 'ok' }
    if (!navigator.onLine) { enfileirar('receber', id, body); addToast('Sem conexão — recebimento guardado e enviado ao reconectar.', 'success'); setAssinarRem(null); setDiverg(''); setRemLoad(false); return }
    try {
      const r = await POST('/rec/remessas/' + id + '/receber', body)
      addToast(r.divergencia ? 'Recebido com divergência registrada.' : 'Recebimento confirmado — entregue.', 'success')
      setAssinarRem(null); setDiverg(''); await carregarRemessas(); setRemDet(await GET('/rec/remessas/' + id))
    } catch (e) {
      if (semRede(e)) { enfileirar('receber', id, body); addToast('Sem conexão — recebimento guardado offline.', 'success'); setAssinarRem(null); setDiverg('') }
      else addToast(e.message, 'error')
    }
    setRemLoad(false)
  }
  const verTermo = async (id) => {
    try {
      const resp = await fetch('/api/rec/remessas/' + id + '/termo', { headers: { Authorization: `Bearer ${token.value}` } })
      if (!resp.ok) throw new Error('Erro ' + resp.status)
      const html = await resp.text()
      const w = window.open('', '_blank')
      if (w) { w.document.open(); w.document.write(html); w.document.close() }
      else addToast('Permita pop-ups para ver o termo.', 'error')
    } catch (e) { addToast(e.message, 'error') }
  }

  // ── Nova solicitação (engenheiro/líder) ──
  const [novo, setNovo] = useState(false)
  const [obraId, setObraId] = useState('')
  const [obs, setObs] = useState('')
  const ITEM_VAZIO = { catalogo_id:'', descricao:'', unidade:'', qtd:1, fotos:[], especificacao:'' }
  const [itens, setItens] = useState([ITEM_VAZIO])
  // Tipo do pedido (um por solicitação; pedido misto = dois): Manutenção segue o fluxo de sempre (base do
  // contrato primeiro); Obra pede o código de uma obra ATIVA da unidade e sai só da Sede.
  const [tipo, setTipo] = useState('manutencao')
  const [obraCodId, setObraCodId] = useState('')
  const [refazendo, setRefazendo] = useState(null)   // { id, numero } do pedido devolvido que vira Obra
  const codsAtivos = obraCods.filter(o => o.status === 'ativa')
  const codsDaUnidade = uid => uid ? codsAtivos.filter(o => String(o.unidade_id) === String(uid)) : []
  const codsForm = codsDaUnidade(obraId)
  const unidadesComObra = obras.filter(o => codsDaUnidade(o.id).length > 0)
  const temObraNasMinhas = unidadesComObra.length > 0
  // Manutenção × Obra é coisa do contrato de manutenção (FMS): obra executada dentro de uma unidade, com código.
  // Contrato sem nenhum código de obra ativo (ex.: Costellation, que já é a obra) não tem o que escolher: o
  // formulário esconde o Tipo (o pedido segue como sempre — base do contrato + Sede) em vez de falar de "obra ativa".
  const usaTipoObra = codsAtivos.length > 0 || !!refazendo || tipo === 'obra'
  // Pedido de Obra: o menu de unidades mostra só as que têm obra ativa. A unidade já escolhida fica na
  // lista mesmo sem obra (só no "Refazer como Obra"), para o aviso de "sem obra ativa" aparecer.
  const unidadesForm = tipo === 'obra' ? obras.filter(o => codsDaUnidade(o.id).length > 0 || String(o.id) === String(obraId)) : obras
  const escolherTipo = t => {
    setTipo(t)
    if (t !== 'obra') { setObraCodId(''); return }
    // Unidade sem obra sai da seleção; com uma unidade só com obra, ela já vem escolhida.
    const uid = codsForm.length ? obraId : unidadesComObra.length === 1 ? String(unidadesComObra[0].id) : ''
    const cods = codsDaUnidade(uid)
    setObraId(uid)
    setObraCodId(cods.length === 1 ? String(cods[0].id) : '')
  }
  const escolherUnidade = v => {
    setObraId(v)
    const cods = codsDaUnidade(v)
    setObraCodId(tipo === 'obra' && cods.length === 1 ? String(cods[0].id) : '')
  }
  // Mesmo aviso do servidor (rec-tipo-core.js), ao vivo no formulário: só avisa, não trava.
  const alertasForm = tipo === 'manutencao' && codsForm.length ? [{ codigo: 'unidade_com_obra_ativa', texto: recTextoObraAtiva(codsForm) }] : []
  const limparNovo = () => { setNovo(false); setRevisando(false); setObs(''); setObraId(''); setItens([ITEM_VAZIO]); setTipo('manutencao'); setObraCodId(''); setRefazendo(null); setPrazoNovo({ data:'', motivo:'', impacto:'' }) }
  // "Refazer como Obra": o pedido devolvido pelo almoxarifado volta ao formulário com a mesma unidade e os
  // mesmos itens (as partes estoque + compras de um item somadas de novo), já no tipo Obra. Fotos não vêm.
  const refazerComoObra = d => {
    const porItem = new Map()
    for (const it of d.itens || []) {
      const k = it.catalogo_id ? 'c' + it.catalogo_id : 'd' + String(it.descricao || '').trim().toLowerCase()
      const ja = porItem.get(k)
      if (ja) { ja.qtd = Number(ja.qtd) + Number(it.qtd); continue }
      porItem.set(k, { ...ITEM_VAZIO, catalogo_id: it.catalogo_id ? String(it.catalogo_id) : '', descricao: it.catalogo_id ? '' : (it.descricao || ''),
        unidade: it.catalogo_id ? '' : (it.unidade || ''), qtd: Number(it.qtd), especificacao: it.especificacao || '' })
    }
    const cods = codsDaUnidade(d.obra_id)
    const hoje = (prazoCfg && prazoCfg.hoje) || hojeYMD()
    setItens(porItem.size ? [...porItem.values()] : [ITEM_VAZIO])
    setObraId(d.obra_id ? String(d.obra_id) : '')
    setTipo('obra'); setObraCodId(cods.length === 1 ? String(cods[0].id) : '')
    setObs(d.obs || '')
    setPrazoNovo({ data: d.necessario_em && d.necessario_em >= hoje ? d.necessario_em : '', motivo:'', impacto:'' })
    setRefazendo({ id: d.id, numero: d.numero })
    setAbertaId(null); setDetalhe(null); setNovo(true)
    setTimeout(() => { const el = document.getElementById('rec-nova'); if (el) el.scrollIntoView({ block:'start', behavior:'smooth' }) }, 60)
  }
  // Data de necessidade (obrigatória): vale para o pedido inteiro, inclusive o que cair em Compras.
  // Fora do prazo pede motivo + impacto (exceto no modo "medir"); urgente em Compras = só emergência.
  const [prazoNovo, setPrazoNovo] = useState({ data:'', motivo:'', impacto:'' })
  const setItem = (i, k, v) => setItens(arr => arr.map((it, idx) => idx===i ? { ...it, [k]:v } : it))
  const addItem = () => setItens(arr => [...arr, ITEM_VAZIO])
  // Foto do item: comprime no celular (1024 px) antes de guardar — o pedido vai inteiro num POST só.
  const addFotoItem = async (i, files) => {
    for (const f of Array.from(files || [])) {
      try {
        const d = await comprimirImagem(f, 1024, 0.7)
        setItens(arr => arr.map((it, idx) => idx===i && it.fotos.length < REC_FOTOS_ITEM ? { ...it, fotos:[...it.fotos, d] } : it))
      } catch (e) { addToast(e.message, 'error') }
    }
  }
  const rmFotoItem = (i, k) => setItens(arr => arr.map((it, idx) => idx===i ? { ...it, fotos: it.fotos.filter((_, j) => j!==k) } : it))
  const rmItem = i => setItens(arr => arr.length>1 ? arr.filter((_,idx)=>idx!==i) : arr)
  // Cue visual "vai para Compras": item digitado (fora do catálogo) ou item do catálogo sem estoque.
  // É só um indicador de status — o split por quantidade (parte que excede o saldo) o sistema faz sozinho.
  // Catálogo do formulário: no pedido de Obra, "disponível" é só o que a Sede tem — a base (Almoxarife 2) não
  // atende obra. Assim a busca, a etiqueta e o "vai para Compras" batem com a divisão que o servidor faz.
  const catForm = React.useMemo(() => tipo !== 'obra' ? cat
    : cat.map(c => ({ ...c, saldo_total: (c.saldos || []).filter(s => s.deposito_tipo !== 'centro').reduce((a, s) => a + (Number(s.quantidade) || 0), 0) })), [cat, tipo])
  const itemEhCompra = it => {
    if (!it.catalogo_id) return !!it.descricao.trim()
    const c = catForm.find(x => String(x.id) === String(it.catalogo_id))
    return !c || !(c.saldo_total > 0)
  }
  // ── Revisão antes de enviar ── Os engenheiros erravam pedido porque o formulário fica difuso e só o detalhe,
  // depois de aberto, mostra claro o que foi pedido. "Revisar pedido" valida e mostra o pedido no formato do
  // detalhe (qtd + unidade grandes, nome inteiro, especificação, fotos, via estoque/compras); só "Confirmar e
  // enviar" grava. Item repetido e item digitado sem unidade só avisam; item sem quantidade trava.
  const [revisando, setRevisando] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const [focoItem, setFocoItem] = useState(null)
  const temItem = it => !!(it.catalogo_id || it.descricao.trim())
  const catDe = it => it.catalogo_id ? catForm.find(c => String(c.id) === String(it.catalogo_id)) || null : null
  const unidadeDe = it => it.catalogo_id ? ((catDe(it) || {}).unidade || '') : it.unidade.trim()
  const nomeDe = it => it.catalogo_id ? ((catDe(it) || {}).nome || '(item)') : it.descricao.trim()
  // Mesmo item em duas linhas (mesmo do catálogo, ou mesma descrição digitada): repetidoDe[i] = linha da 1ª vez.
  const chaveItem = it => it.catalogo_id ? 'c' + it.catalogo_id : it.descricao.trim() ? 'd' + recNorm(it.descricao.trim()) : null
  const repetidoDe = (() => { const prim = new Map(); return itens.map((it, i) => { const k = chaveItem(it); if (!k) return null; if (prim.has(k)) return prim.get(k); prim.set(k, i); return null }) })()
  const gruposRepetidos = [...new Set(repetidoDe.filter(x => x !== null))].map(p => [p, ...repetidoDe.flatMap((x, i) => x === p ? [i] : [])])
  const fmtQtd = q => Number(q).toLocaleString('pt-BR', { maximumFractionDigits: 3 })
  const focarItem = i => {
    setFocoItem(i)
    setTimeout(() => { const el = document.getElementById('rec-it-' + i); if (el) el.scrollIntoView({ block:'center', behavior:'smooth' }) }, 60)
    setTimeout(() => setFocoItem(f => f === i ? null : f), 2400)
  }
  const corrigirItem = i => { setRevisando(false); focarItem(i) }
  // Juntar: soma na 1ª linha; especificações diferentes ficam juntas e as fotos vão até o limite do item.
  const juntarRepetidos = grupo => {
    const [p, ...resto] = grupo
    const soma = Math.round(grupo.reduce((n, i) => n + (Number(itens[i].qtd) || 0), 0) * 1000) / 1000
    const esp = [...new Set(grupo.map(i => itens[i].especificacao.trim()).filter(Boolean))].join(' / ').slice(0, 500)
    const fotos = grupo.flatMap(i => itens[i].fotos)
    if (fotos.length > REC_FOTOS_ITEM) addToast(`Ficaram as ${REC_FOTOS_ITEM} primeiras fotos (limite por item).`, 'warning')
    setItens(itens.map((it, i) => i === p ? { ...it, qtd: soma, especificacao: esp, fotos: fotos.slice(0, REC_FOTOS_ITEM) } : it).filter((_, i) => !resto.includes(i)))
  }
  const tirarRepetidos = grupo => setItens(itens.filter((_, i) => !grupo.slice(1).includes(i)))
  // Mesmas checagens do servidor, antes de abrir a revisão. Item escolhido sem quantidade não some mais calado.
  const erroNovo = lista => {
    if (!lista.length) return { msg: 'Informe ao menos um item com quantidade.' }
    const semQtd = lista.findIndex(it => !(Number(it.qtd) > 0))
    if (semQtd >= 0) return { msg: `Item ${semQtd + 1} está sem quantidade: informe a quantidade ou tire a linha.`, item: semQtd }
    if (lista.reduce((n, it) => n + it.fotos.length, 0) > 20) return { msg: 'Máximo de 20 fotos por solicitação. Divida em duas.' }
    if (tipo === 'obra') {
      if (!obraId) return { msg: 'Pedido de Obra: escolha a unidade onde a obra acontece.' }
      if (!obraCodId) return { msg: codsForm.length ? 'Escolha o código da obra.' : 'Esta unidade não tem obra ativa: peça o cadastro à Sede ou escolha Manutenção.' }
    }
    const erroPrazo = prazoInvalido(prazoNovo)
    return erroPrazo ? { msg: erroPrazo } : null
  }
  const revisarPedido = () => {
    const lista = itens.filter(temItem)   // linha em branco sai antes da revisão, para a numeração bater
    if (lista.length && lista.length !== itens.length) setItens(lista)
    const erro = erroNovo(lista)
    if (erro) { addToast(erro.msg, 'error'); if (erro.item != null) focarItem(erro.item); return }
    setRevisando(true)
  }
  const enviarSolicitacao = async () => {
    if (enviando) return
    const erro = erroNovo(itens.filter(temItem))
    if (erro) { setRevisando(false); addToast(erro.msg, 'error'); return }
    const lista = itens.filter(temItem)
      .map(i => ({ catalogo_id: i.catalogo_id || null, descricao: i.descricao.trim() || null, unidade: i.unidade.trim() || null, qtd: Number(i.qtd),
        fotos: i.fotos, especificacao: i.especificacao.trim() || null }))
    setEnviando(true)
    try {
      const r = await POST('/rec/solicitacoes', { obra_id: obraId || null, obs, itens: lista, tipo,
        obra_codigo_id: tipo === 'obra' ? Number(obraCodId) : null, refeita_de_id: refazendo ? refazendo.id : null,
        necessario_em: prazoNovo.data, motivo_fora_prazo: prazoNovo.motivo || null, impacto_fora_prazo: prazoNovo.impacto || null })
      addToast(r.aprovacao_status === 'pendente' ? `Solicitação ${r.numero} enviada para aprovação do gerente.`
        : refazendo ? `Solicitação ${r.numero} aberta como Obra (no lugar da ${refazendo.numero}).` : `Solicitação ${r.numero} aberta.`, 'success')
      limparNovo()
      load()
      try { setPrazoCfg(await GET('/rec/prazo-config')) } catch {}
    } catch (e) { addToast(e.message, 'error') }
    finally { setEnviando(false) }
  }
  // Barra "Revisar pedido" flutuante: presa ao rodapé, na largura do card, enquanto o formulário aparece e o
  // fim dele está abaixo da tela. Some com o teclado aberto no celular (cobriria o campo em edição).
  const novoRef = useRef(null), barraRef = useRef(null)
  const [barraFlutua, setBarraFlutua] = useState(null)
  useEffect(() => {
    if (!novo || revisando) { setBarraFlutua(null); return }
    let raf = 0
    const medir = () => {
      raf = 0
      const c = novoRef.current, b = barraRef.current
      if (!c || !b) return
      const cr = c.getBoundingClientRect(), br = b.getBoundingClientRect(), h = window.innerHeight
      const vv = window.visualViewport, teclado = !!vv && vv.height < h * 0.75
      const vai = !teclado && cr.top < h - 200 && br.bottom > h + 2
      setBarraFlutua(f => !vai ? null : f && f.left === cr.left && f.width === cr.width ? f : { left: cr.left, width: cr.width })
    }
    const agenda = () => { if (!raf) raf = requestAnimationFrame(medir) }
    medir()
    const vv = window.visualViewport
    window.addEventListener('scroll', agenda, { passive: true })
    window.addEventListener('resize', agenda)
    if (vv) vv.addEventListener('resize', agenda)
    return () => {
      window.removeEventListener('scroll', agenda); window.removeEventListener('resize', agenda)
      if (vv) vv.removeEventListener('resize', agenda)
      if (raf) cancelAnimationFrame(raf)
    }
  }, [novo, revisando, itens])

  const inp = { padding:'8px 10px', border:'1px solid var(--border,#d1d5db)', borderRadius:8, background:'var(--card,#fff)', color:'var(--ink,#111)', fontSize:'.9rem' }
  const btnP = { padding:'9px 16px', background:'var(--fill-navy)', color:'#fff', border:'none', borderRadius:8, fontWeight:600, cursor:'pointer' }
  const btnG = { padding:'9px 16px', background:'transparent', color:'var(--ink,#111)', border:'1px solid var(--border,#d1d5db)', borderRadius:8, fontWeight:600, cursor:'pointer' }
  const card = { background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderRadius:12, padding:16, marginBottom:14 }

  // Próximo passo de UMA remessa para o almoxarifado: escolher o motorista e marcar pronta; depois só
  // acompanha (quem retira, trânsito, termo). Aparece dentro da solicitação (almox) e na aba Remessas (almox2).
  // Remessa direta (compra do fornecedor direto para a unidade): a origem é o fornecedor, não um depósito.
  const depRotulo = r => r.direta ? `Fornecedor ${r.fornecedor || ''}`.trim() : r.deposito_tipo==='sede' ? 'Sede' : (r.deposito_nome || 'Depósito')
  const seletorMotorista = (r, valor) => (
    <select style={{...inp, padding:'6px 9px', minWidth:200, flex:'1 1 200px', maxWidth:300}} value={valor} onChange={e=>{ const v = e.target.value; setMotEsc(m=>({...m, [r.id]: v})) }}>
      <option value="">Quem vai retirar?</option>
      {motoristas.map(u=><option key={u.id} value={u.id}>{u.nome} · {ROLE_LABEL[u.role]||u.role}</option>)}
    </select>
  )
  const passoRemessaAlmox = r => {
    if (r.status === 'separando') return (
      <div style={{display:'grid', gap:6}}>
        <div style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center'}}>
          {motoristas.length > 0
            ? seletorMotorista(r, motEsc[r.id] || motPadrao)
            : <span style={{fontSize:'.76rem', color:'var(--rec-amber)'}}>Nenhum motorista ou ajudante cadastrado: qualquer logística poderá retirar.</span>}
          <button style={{...btnP, padding:'7px 14px', opacity:remLoad?0.6:1}} disabled={remLoad} onClick={()=>marcarPronta(r.id)}>Pronta p/ retirada</button>
        </div>
        {motoristas.length > 0 && <span style={{fontSize:'.74rem', color:'var(--rec-sub)'}}>Quem você escolher recebe a remessa no painel dele com o destino{r.obra_nome ? <> (<strong style={{color:'var(--ink,#111)'}}>{r.obra_nome}</strong>)</> : ''} e o mapa.</span>}
      </div>
    )
    if (r.status === 'pronta' || r.status === 'a_caminho') return trocaMot === r.id ? (
      <div style={{display:'grid', gap:6}}>
        <div style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center'}}>
          {seletorMotorista(r, motEsc[r.id] || '')}
          <button style={{...btnP, padding:'7px 14px', opacity:remLoad?0.6:1}} disabled={remLoad} onClick={()=>trocarMotorista(r.id)}>Salvar</button>
          <button style={{...btnG, padding:'7px 12px'}} onClick={()=>setTrocaMot(null)}>Cancelar</button>
        </div>
        {r.status === 'a_caminho' && <span style={{fontSize:'.74rem', color:'var(--rec-amber)'}}>{r.motorista_nome || 'O motorista'} já saiu para buscar. Trocando, a remessa volta para "pronta" e só o novo motorista vê.</span>}
      </div>
    ) : (
      <div style={{display:'flex', gap:10, flexWrap:'wrap', alignItems:'center', fontSize:'.82rem', color:'var(--ink,#111)'}}>
        <span>Retirada{r.direta ? ` no fornecedor ${r.fornecedor || ''}` : ''}: <strong>{r.motorista_nome || 'qualquer motorista'}</strong> <span style={{color:'var(--rec-sub)'}}>· {r.status==='a_caminho' ? (r.direta ? 'a caminho do fornecedor' : 'a caminho do depósito') : 'aguardando o motorista'}</span></span>
        {r.direta && <span style={{fontSize:'.74rem', color:'var(--rec-sub)'}}>Compra direto para a unidade: o motorista é trocado por Compras.</span>}
        {!r.direta && motoristas.length > 0 && <button style={{...btnG, padding:'4px 10px', fontSize:'.76rem'}} onClick={()=>{ setTrocaMot(r.id); setMotEsc(m=>({...m, [r.id]: r.motorista_id ? String(r.motorista_id) : ''})) }}>{r.motorista_id ? 'Trocar motorista' : 'Definir motorista'}</button>}
      </div>
    )
    if (r.status === 'em_transporte') return <div style={{fontSize:'.82rem', color:'var(--ink,#111)'}}>Em trânsito para a obra com <strong>{r.motorista_nome || '—'}</strong></div>
    if (r.status === 'entregue') {
      const fa = (r.eventos || []).find(e => e.tipo === 'regularizacao')
      return <div style={{display:'flex', gap:10, alignItems:'center', flexWrap:'wrap', fontSize:'.82rem', color:'var(--rec-green)', fontWeight:600}}>✓ Entregue na obra{fa && <span style={{fontWeight:400, color:'var(--text-secondary)'}}>em {recDM(fa.ocorrido_em)} · fora do app, registrada sem assinatura por {fa.de_id ? (fa.de_nome || '—') : 'Sistema'}</span>} <button style={{...btnG, padding:'4px 10px', fontSize:'.76rem'}} onClick={()=>verTermo(r.id)}>Ver termo</button></div>
    }
    return null
  }
  // Material que já chegou à obra sem o motorista registrar "Retirar"/"Entregar" no celular: só o almoxarifado da
  // Sede fecha, com o dia, quem recebeu e o motivo. Formulário aberto ocupa o lugar do passo normal da remessa.
  const entregaForaApp = r => {
    if (!almox || user.tour || !['separando','pronta','a_caminho','em_transporte'].includes(r.status)) return null
    const f = foraApp && foraApp.id === r.id ? foraApp : null
    if (!f) return (
      <button style={{justifySelf:'start', background:'none', border:'none', padding:0, color:'var(--text-secondary)', fontSize:'.74rem', textDecoration:'underline', cursor:'pointer'}}
        onClick={()=>setForaApp({ id: r.id, entregue_em: estHojeISO(), recebido_por: '', motivo: '' })}>Já foi entregue por fora do app?</button>
    )
    const lbl = { display:'grid', gap:3, fontSize:'.74rem', color:'var(--text-secondary)' }
    return (
      <div style={{display:'grid', gap:8, padding:'10px 12px', border:'1px solid var(--tag-alerta-bd)', borderRadius:10, background:'var(--card)'}}>
        <strong style={{fontSize:'.84rem', color:'var(--ink)'}}>Registrar entrega feita fora do app</strong>
        <span style={{fontSize:'.76rem', color:'var(--text-secondary)'}}>Para material que já chegou à obra sem o motorista registrar no celular. A remessa fecha como entregue{r.status !== 'em_transporte' && !r.direta ? ` e o estoque ${r.deposito_tipo==='sede' ? 'da Sede' : `de ${depRotulo(r)}`} dá baixa dos itens` : ''}. Fica registrado, com o seu nome, que não houve assinatura: na cadeia de custódia, no termo e na Auditoria.</span>
        <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
          <label style={lbl}>Chegou à obra em
            <input type="date" style={{...inp, padding:'6px 9px'}} value={f.entregue_em} min={recYMD(r.criado_em)} max={estHojeISO()} onChange={e=>setForaApp({ ...f, entregue_em: e.target.value })} /></label>
          <label style={{...lbl, flex:'1 1 200px'}}>Quem recebeu na obra (se souber)
            <input style={{...inp, padding:'6px 9px'}} maxLength={120} value={f.recebido_por} onChange={e=>setForaApp({ ...f, recebido_por: e.target.value })} placeholder="Nome" /></label>
        </div>
        <textarea style={{...inp, minHeight:52, width:'100%'}} maxLength={500} value={f.motivo} onChange={e=>setForaApp({ ...f, motivo: e.target.value })} placeholder="Por que não passou pelo app? Ex.: o motorista levou e não registrou no celular." />
        <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
          <button style={{...btnP, background:'var(--fill-cobre)', padding:'7px 14px', opacity:remLoad?0.6:1}} disabled={remLoad} onClick={registrarForaApp}>Registrar entrega</button>
          <button style={{...btnG, padding:'7px 12px'}} onClick={()=>setForaApp(null)}>Cancelar</button>
        </div>
      </div>
    )
  }
  const acaoRemessaAlmox = r => {
    const fora = entregaForaApp(r)
    if (fora && foraApp && foraApp.id === r.id) return fora
    return fora ? <>{passoRemessaAlmox(r)}{fora}</> : passoRemessaAlmox(r)
  }
  // "ver detalhes" da remessa: abre a aba Remessas já com ela expandida (itens, cadeia de custódia, chat).
  const verNaAbaRemessas = async (r) => {
    setTab('remessas'); setRemAberta(r.id); setRemDet(null)
    setTimeout(() => { const el = document.getElementById('rem-' + r.id); if (el) el.scrollIntoView({ block:'start', behavior:'smooth' }) }, 60)
    try { setRemDet(await GET('/rec/remessas/' + r.id)) } catch (e) { addToast(e.message, 'error') }
  }

  // Fora do prazo e ainda sem data prometida: a data vai junto da ação "analisar"/"reservar".
  const exigePromessa = d => d.faixa === 'fora_prazo' && !d.data_prometida
  // Bloco do PRAZO no detalhe: antecedência, motivo/impacto, data prometida (almox edita), aprovação
  // (gerente/diretor decide) e reenvio do recusado (quem pediu).
  const recBlocoPrazo = d => {
    if (!d.necessario_em) return null
    const meu = d.solicitante_id === user.id
    const ativo = !['entregue','cancelada','recusada','aguardando_aprovacao'].includes(d.status)
    const sub = { fontSize:'.78rem', color:'var(--text-secondary)' }
    const box = { background:'var(--card)', border:'1px solid var(--border)', borderRadius:10, padding:'11px 13px', marginBottom:12, display:'grid', gap:8, fontSize:'.84rem', color:'var(--ink)' }
    const quem = (nome, em) => <>{nome ? ` por ${nome}` : ''}{em ? ` em ${recDM(em)}` : ''}</>
    const dataIn = { ...inp, padding:'5px 8px', width:'auto', minWidth:150, flex:'0 0 auto' }
    const ap = d.aprovacao_status
    return (
      <div style={box}>
        <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
          <Icon name="clock" size={15}/>
          <span>Pedido com <strong>{recDiasUteis(d.antecedencia_dias)}</strong> de antecedência</span>
          <span style={sub}>(mínimo {d.prazo_vigente_dias} · padrão {d.prazo_alvo_dias})</span>
        </div>
        {d.motivo_fora_prazo && <div><span style={sub}>Motivo: </span>{REC_MOTIVO_LABEL[d.motivo_fora_prazo] || d.motivo_fora_prazo}</div>}
        {d.impacto_fora_prazo && <div><span style={sub}>Se não chegar: </span>{d.impacto_fora_prazo}</div>}

        {/* Data prometida pelo almoxarifado (o pedido inteiro em Compras, que o Master vê, não passa por ele) */}
        {almox && ativo && d.status !== 'em_compras' && (d.faixa === 'fora_prazo' || d.data_prometida) && (
          exigePromessa(d) && ['solicitada','analisando'].includes(d.status) ? (
            <label style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
              <span style={{fontWeight:600}}>Consigo entregar em</span>
              <input type="date" style={dataIn} min={prazoCfg ? prazoCfg.hoje : undefined} value={promData} onChange={e=>setPromData(e.target.value)} />
              <span style={sub}>obrigatório para analisar ou reservar</span>
            </label>
          ) : promEdit || !d.data_prometida ? (
            <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
              <span style={{fontWeight:600}}>Consigo entregar em</span>
              <input type="date" style={dataIn} min={prazoCfg ? prazoCfg.hoje : undefined} value={promData} onChange={e=>setPromData(e.target.value)} />
              <button style={{...btnP, padding:'6px 12px', opacity:acaoLoad?0.6:1}} disabled={acaoLoad || !promData} onClick={()=>salvarPrometida(d.id)}>Salvar</button>
              {d.data_prometida && <button style={{...btnG, padding:'6px 12px'}} onClick={()=>{ setPromEdit(false); setPromData(d.data_prometida) }}>Cancelar</button>}
            </div>
          ) : (
            <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
              <span style={sub}>Data prometida definida{quem(d.data_prometida_por_nome, d.data_prometida_em)}</span>
              <button style={{...btnG, padding:'4px 10px', fontSize:'.76rem'}} onClick={()=>{ setPromData(d.data_prometida); setPromEdit(true) }}>Alterar data</button>
            </div>
          )
        )}
        {!almox && d.data_prometida && <div style={sub}>Data prometida definida{quem(d.data_prometida_por_nome, d.data_prometida_em)}</div>}

        {/* Aprovação (modo "aprovar") */}
        {ap === 'pendente' && d.status === 'aguardando_aprovacao' && (aprovador && !meu ? (
          <div style={{display:'grid', gap:8, borderTop:'1px dashed var(--border)', paddingTop:9}}>
            <strong>Aguardando a sua aprovação</strong>
            {d.motivo_fora_prazo === 'emergencia' && <span style={sub}>Emergência acima do limite do mês de quem pediu: só segue com o seu OK.</span>}
            <textarea style={{...inp, minHeight:52}} placeholder="Comentário (obrigatório para recusar)" value={aprovCom} maxLength={1000} onChange={e=>setAprovCom(e.target.value)} />
            <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
              <button style={{...btnP, opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>decidir(d.id, 'aprovar')}>Aprovar</button>
              <button style={{...btnG, color:'var(--danger)', borderColor:'var(--tag-perigo-line)', opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>decidir(d.id, 'recusar')}>Recusar</button>
            </div>
          </div>
        ) : <div style={{color:'var(--tag-alerta-fg)'}}>Aguardando aprovação do gerente do contrato. Só depois chega ao almoxarifado.</div>)}
        {ap === 'ciencia' && (aprovador && !meu ? (
          <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', borderTop:'1px dashed var(--border)', paddingTop:9}}>
            <span style={{flex:'1 1 220px'}}>Emergência: seguiu direto, sem esperar aprovação.</span>
            <button style={{...btnG, opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>decidir(d.id, 'ciente')}>Dar ciência</button>
          </div>
        ) : <div style={sub}>Emergência: seguiu direto; o gerente do contrato toma ciência depois.</div>)}
        {ap === 'aprovada' && <div style={sub}>Aprovado{quem(d.aprovacao_por_nome, d.aprovacao_em)}{d.aprovacao_comentario ? `: ${d.aprovacao_comentario}` : ''}</div>}
        {ap === 'ciente' && <div style={sub}>Ciência dada{quem(d.aprovacao_por_nome, d.aprovacao_em)}</div>}
        {ap === 'dispensada' && <div style={sub}>Seguiu sem aprovação: o modo de aprovação foi desligado.</div>}
        {d.status === 'recusada' && <>
          <div style={{color:'var(--tag-perigo-fg)'}}>Recusado{quem(d.aprovacao_por_nome, d.aprovacao_em)}{d.aprovacao_comentario ? <>: <strong>{d.aprovacao_comentario}</strong></> : null}</div>
          {meu && prazoCfg && (
            <div style={{display:'grid', gap:9, borderTop:'1px dashed var(--border)', paddingTop:9}}>
              <RecCamposPrazo cfg={prazoCfg} v={reenvio} set={setReenvio} inp={inp} rotulo="Nova data na obra" />
              <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                <button style={{...btnP, opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>reenviar(d.id)}>Reenviar pedido</button>
                <button style={{...btnG, opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>postSol(d.id, 'desistir', {}, 'Pedido cancelado.')}>Desistir do pedido</button>
              </div>
            </div>
          )}
        </>}
      </div>
    )
  }

  // Bloco do TIPO no detalhe: pedido de Obra (código, sai da Sede), devolvido como obra (motivo + refazer/
  // desistir para quem pediu), refeito, e os alertas do pedido enquanto há o que fazer.
  const recBlocoTipo = d => {
    const meu = d.solicitante_id === user.id
    const sub = { fontSize:'.78rem', color:'var(--text-secondary)' }
    const box = { background:'var(--card)', border:'1px solid var(--border)', borderRadius:10, padding:'11px 13px', marginBottom:12, display:'grid', gap:8, fontSize:'.84rem', color:'var(--ink)' }
    return <>
      {d.tipo === 'obra' && (
        <div style={{...box, borderLeft:'4px solid var(--fill-cobre)'}}>
          <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
            <Icon name="building" size={15}/>
            <span>Pedido de <strong>obra {d.obra_codigo}</strong>{d.obra_codigo_nome ? ` — ${d.obra_codigo_nome}` : ''}</span>
          </div>
          <span style={sub}>Sai só da Sede.{d.refeita_de_numero ? ` Refeito a partir do ${d.refeita_de_numero}, devolvido como obra.` : ''}</span>
        </div>
      )}
      {d.status === 'devolvida' && (
        <div style={{...box, borderColor:'var(--tag-perigo-line)'}}>
          <div style={{color:'var(--tag-perigo-fg)'}}>
            Devolvido como obra{d.devolvida_por_nome ? ` por ${d.devolvida_por_nome}` : ''}{d.devolvida_em ? ` em ${recDM(String(d.devolvida_em).slice(0, 10))}` : ''}{d.devolvida_motivo ? <>: <strong>{d.devolvida_motivo}</strong></> : null}
          </div>
          {meu ? (
            <div style={{display:'grid', gap:8, borderTop:'1px dashed var(--border)', paddingTop:9}}>
              <span style={sub}>Material de obra sai só da Sede. Refaça o pedido como Obra (mesmos itens, já preenchidos) ou desista.</span>
              <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                <button style={{...btnP, background:'var(--fill-cobre)'}} onClick={()=>refazerComoObra(d)}>Refazer como Obra</button>
                <button style={{...btnG, opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>postSol(d.id, 'desistir', {}, 'Pedido cancelado.')}>Desistir do pedido</button>
              </div>
            </div>
          ) : <span style={sub}>Aguardando quem pediu refazer como Obra.</span>}
        </div>
      )}
      {d.status === 'cancelada' && d.cancelada_motivo && (
        <div style={{...box, borderColor:'var(--tag-perigo-line)'}}>
          <div style={{color:'var(--tag-perigo-fg)'}}>
            Cancelado{d.cancelada_por_nome ? ` por ${d.cancelada_por_nome}` : ''}{d.cancelada_em ? ` em ${recDM(String(d.cancelada_em).slice(0, 10))}` : ''}: <strong>{d.cancelada_motivo}</strong>
          </div>
        </div>
      )}
      {d.status === 'refeita' && <div style={{...box, color:'var(--text-secondary)'}}><span>Devolvido como obra e refeito{d.refeita_numero ? <> no pedido <strong style={{color:'var(--ink)'}}>{d.refeita_numero}</strong></> : ''}.</span></div>}
      {REC_SOL_ATIVA.includes(d.status) && <RecAlertas alertas={d.alertas} />}
    </>
  }

  // ── Filtros das listas ──
  // "Aguardando você": o que está na mão de quem olha — mesmas regras e mesmo número do badge do menu
  // (recPendencias). A ciência de emergência fica de fora, como lá (é aviso, não pendência).
  const SOL_ATIVA_FORA = ['solicitada','analisando','reservada','separada','em_transporte']
  // Pedidos com remessa em separação (era um remessas.some() por pedido, a cada tecla e para cada contador). Só a
  // que a Sede separa: a da base é do Almoxarife 2 de lá (o badge, no servidor, conta igual).
  const solComSeparando = React.useMemo(() => new Set(remessas.filter(r => r.status === 'separando' && r.deposito_tipo !== 'centro').map(r => r.solicitacao_id)), [remessas])
  const solMinha = s => {
    if (almox && (['solicitada','analisando','reservada'].includes(s.status)
      || solComSeparando.has(s.id)
      || (s.faixa === 'fora_prazo' && !s.data_prometida && SOL_ATIVA_FORA.includes(s.status)))) return true
    if (aprovador && s.solicitante_id !== user.id && s.status === 'aguardando_aprovacao' && s.aprovacao_status === 'pendente') return true
    return solicitante && s.solicitante_id === user.id && (s.status === 'recusada' || s.status === 'devolvida')
  }
  const temSolMinha = almox || aprovador || solicitante
  const solSitEf = solSit === 'voce' && !temSolMinha ? 'andamento' : solSit
  // Devolvido como obra: para quem pediu ainda está em aberto (refazer ou desistir); para o almoxarifado, acabou.
  const solFim = s => REC_SOL_FIM.includes(s.status) || (s.status === 'devolvida' && s.solicitante_id !== user.id)
  const solSitOk = (s, sit) => sit === 'todas' || (sit === 'voce' ? solMinha(s) : sit === 'concluidas' ? solFim(s) : !solFim(s))
  const solFora = s => s.faixa === 'fora_prazo'
  const solsSemFora = sols.filter(s => (!solF.obra || (s.obra_nome || REC_SEM_OBRA) === solF.obra)
    && (!solF.pessoa || String(s.solicitante_id) === solF.pessoa)
    && (!solF.tipo || (s.tipo || 'manutencao') === solF.tipo)
    && casaBusca(solF.q, s.numero, s.obra_nome, s.obra_codigo, s.obra_codigo_nome, s.solicitante_nome, s.obs, s.itens_txt))
  const solsBase = solF.fora ? solsSemFora.filter(solFora) : solsSemFora
  const solNoPainel = s => (!recFiltro.sol || recFiltro.sol.includes(s.status)) && (!recFiltro.fora || solFora(s))
  const filtroSolPainel = !!(recFiltro && (recFiltro.sol || recFiltro.fora))
  const solNaSit = s => filtroSolPainel ? solNoPainel(s) : solSitOk(s, solSitEf)
  // A solicitação aberta nunca some da lista (ex.: o almox age e ela sai de "Aguardando você").
  const solsVis = solsBase.filter(s => s.id === abertaId || solNaSit(s))
  if (solOrdem === 'necessidade') {
    const dia = s => s.data_prometida || s.necessario_em || '9999-12-31'
    solsVis.sort((a, b) => dia(a).localeCompare(dia(b)) || String(b.criado_em || '').localeCompare(String(a.criado_em || '')))
  }
  const [solsTela, fimSols] = useAosPoucos(solsVis, 60, abertaId ? (s => s.id === abertaId) : null)
  const nSolSit = sit => solsBase.filter(s => solSitOk(s, sit)).length
  const filtrosSol = sols.length > 0 && (
    <RecFiltros
      sit={filtroSolPainel ? null : solSitEf} onSit={v => { setRecFiltro(null); setSolSit(v) }}
      sits={[
        ...(temSolMinha ? [{ id: 'voce', label: 'Aguardando você', n: nSolSit('voce'), alerta: true }] : []),
        { id: 'andamento', label: 'Em andamento', n: nSolSit('andamento') },
        { id: 'concluidas', label: 'Concluídas', n: nSolSit('concluidas') },
        { id: 'todas', label: 'Todas', n: solsBase.length },
      ]}
      atalhos={[{ id: 'fora', label: 'Fora do prazo', tom: 'perigo', on: solF.fora, title: 'Pedidos feitos com menos antecedência que a regra do prazo',
        n: solsSemFora.filter(s => solFora(s) && solNaSit(s)).length, onClick: () => setSolF(f => ({ ...f, fora: !f.fora })) }]}
      campos={sols.length > 5}
      busca={solF.q} onBusca={q => setSolF(f => ({ ...f, q }))}
      placeholder={gestor ? 'Buscar nº, item, obra ou quem pediu…' : 'Buscar nº, item ou obra…'}
      selects={[
        { id: 'obra', title: 'Filtrar por obra', todos: 'Obra', value: solF.obra, onChange: obra => setSolF(f => ({ ...f, obra })),
          options: recOpcoes(sols.map(s => s.obra_nome || REC_SEM_OBRA)) },
        ...(sols.some(s => s.tipo === 'obra') ? [{ id: 'tipo', title: 'Filtrar por tipo do pedido', todos: 'Tipo', value: solF.tipo, onChange: tipo => setSolF(f => ({ ...f, tipo })),
          options: [['manutencao', 'Manutenção'], ['obra', 'Obra']] }] : []),
        ...(gestor ? [{ id: 'pessoa', title: 'Filtrar por quem pediu', todos: 'Quem pediu', value: solF.pessoa, onChange: pessoa => setSolF(f => ({ ...f, pessoa })),
          options: [...new Map(sols.filter(s => s.solicitante_id).map(s => [String(s.solicitante_id), s.solicitante_nome || '—'])).entries()].sort((a, b) => a[1].localeCompare(b[1], 'pt')) }] : []),
      ]}
      ordem={{ value: solOrdem, onChange: setSolOrdem, options: [['recentes', 'Mais recentes primeiro'], ['necessidade', 'Data na obra (mais próxima)']] }}
      n={solsVis.length} onLimpar={() => setSolF(SOL_F_VAZIO)} />
  )

  // Remessas: "Aguardando você" = separar (almox/almox2), levar (motorista/logística), chegando à obra (líder/engenheiro).
  // Para a Sede, só a remessa que ela separa: a da base é do Almoxarife 2 de lá (como solComSeparando e o badge).
  const remMinha = r => almox ? (r.status === 'separando' && r.deposito_tipo !== 'centro')
    : almox2 ? r.status === 'separando'
    : transportador ? ['pronta','a_caminho','em_transporte'].includes(r.status)
    : recebe ? r.status === 'em_transporte' : false
  const temRemMinha = almox || almox2 || transportador || recebe
  // Motorista/logística só recebem o que ainda está com eles (nunca a entregue): lista curta, sem barra.
  const remSitEf = transportador ? 'todas' : remSit === 'voce' && !temRemMinha ? 'andamento' : remSit
  const remSitOk = (r, sit) => sit === 'todas' || (sit === 'voce' ? remMinha(r) : sit === 'concluidas' ? r.status === 'entregue' : r.status !== 'entregue')
  const remDivAberta = r => (r.divergencias || []).some(d => d.status !== 'resolvida')
  const remsSemDiv = remessas.filter(r => (!remF.obra || (r.obra_nome || REC_SEM_OBRA) === remF.obra)
    && (!remF.dep || depRotulo(r) === remF.dep)
    && (!remF.mot || (r.motorista_nome || '') === remF.mot)
    && casaBusca(remF.q, r.numero, r.solicitacao_numero, r.obra_nome, r.solicitante_nome, r.motorista_nome,
      ...(r.itens || []).map(it => it.catalogo_nome || it.descricao)))
  const remsBase = remF.div ? remsSemDiv.filter(remDivAberta) : remsSemDiv
  const remNoPainel = r => (!recFiltro.rem || recFiltro.rem.includes(r.status)) && (!recFiltro.div || remDivAberta(r))
  const filtroRemPainel = !!(recFiltro && (recFiltro.rem || recFiltro.div))
  // Divergência só nasce na entrega (remessa já 'entregue'): o atalho vale sobre todas as situações.
  const remNaSit = r => filtroRemPainel ? remNoPainel(r) : (remF.div || remSitOk(r, remSitEf))
  const remsVis = remsBase.filter(r => r.id === remAberta || remNaSit(r))
  const [remsTela, fimRems] = useAosPoucos(remsVis, 60, remAberta ? (r => r.id === remAberta) : null)
  const nRemSit = sit => remsBase.filter(r => remSitOk(r, sit)).length
  const filtrosRem = remessas.length > 0 && !transportador && (
    <RecFiltros
      sit={filtroRemPainel || remF.div ? null : remSitEf} onSit={v => { setRecFiltro(null); setRemF(f => ({ ...f, div: false })); setRemSit(v) }}
      sits={[
        ...(temRemMinha ? [{ id: 'voce', label: 'Aguardando você', n: nRemSit('voce'), alerta: true }] : []),
        { id: 'andamento', label: 'Em andamento', n: nRemSit('andamento') },
        { id: 'concluidas', label: 'Entregues', n: nRemSit('concluidas') },
        { id: 'todas', label: 'Todas', n: remsBase.length },
      ]}
      atalhos={[{ id: 'div', label: 'Com divergência', tom: 'alerta', on: remF.div, title: 'Entrega com falta, avaria ou troca ainda não resolvida',
        n: remsSemDiv.filter(remDivAberta).length, onClick: () => setRemF(f => ({ ...f, div: !f.div })) }]}
      campos={remessas.length > 5}
      busca={remF.q} onBusca={q => setRemF(f => ({ ...f, q }))}
      placeholder="Buscar nº, item, obra ou pessoa…"
      selects={[
        { id: 'obra', title: 'Filtrar por obra', todos: 'Obra', value: remF.obra, onChange: obra => setRemF(f => ({ ...f, obra })),
          options: recOpcoes(remessas.map(r => r.obra_nome || REC_SEM_OBRA)) },
        ...(!almox2 ? [{ id: 'dep', title: 'Filtrar por depósito de saída', todos: 'Depósito', value: remF.dep, onChange: dep => setRemF(f => ({ ...f, dep })),
          options: recOpcoes(remessas.map(depRotulo)) }] : []),
        { id: 'mot', title: 'Filtrar por motorista', todos: 'Motorista', value: remF.mot, onChange: mot => setRemF(f => ({ ...f, mot })),
          options: recOpcoes(remessas.map(r => r.motorista_nome)) },
      ]}
      n={remsVis.length} onLimpar={() => setRemF(REM_F_VAZIO)} />
  )
  const faixaRec = aba => aba === 'solicitacoes' ? (filtroSolPainel ? <FiltroPainel filtro={recFiltro} n={solsVis.length} onLimpar={() => setRecFiltro(null)} /> : null)
    : (filtroRemPainel ? <FiltroPainel filtro={recFiltro} n={remsVis.length} onLimpar={() => setRecFiltro(null)} /> : null)

  if (loading) return <div style={{padding:24, color:'var(--text-secondary)'}}>Carregando REC…</div>

  return (
    <div>
      <div className="topbar"><h2>REC — Registro de Eventos de Custódia</h2></div>
      {filaPend>0 && (
        <div style={{background:'var(--tag-alerta-bg)', border:'1px solid var(--tag-alerta-bd)', color:'var(--tag-alerta-fg)', borderRadius:8, padding:'8px 12px', marginBottom:10, fontSize:'.85rem', display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
          <span>📴 {filaPend} ação(ões) assinada(s) guardada(s) offline.</span>
          <button style={{padding:'3px 10px', border:'1px solid var(--tag-alerta-bd)', background:'transparent', color:'var(--tag-alerta-fg)', borderRadius:6, cursor:'pointer', fontWeight:600}} onClick={sincronizarFila}>Sincronizar agora</button>
        </div>
      )}
      <p style={{color:'var(--text-secondary)', marginTop:-6, marginBottom:16, fontSize:'.9rem'}}>
        Cadeia de custódia de material (Markat). O saldo vem da aba Estoque; aqui registra-se a movimentação e a responsabilidade.
      </p>

      {/* Sub-abas */}
      <div style={{display:'flex', gap:8, marginBottom:16, flexWrap:'wrap'}}>
        {gestor && <button style={tab==='painel'?btnP:btnG} onClick={()=>setTab('painel')}>Painel</button>}
        {!compras && <button style={tab==='solicitacoes'?btnP:btnG} onClick={()=>setTab('solicitacoes')}>Solicitações</button>}
        {compras && <button style={tab==='compras'?btnP:btnG} onClick={()=>{setTab('compras');carregarCompras()}}>Compras{comprasList.length?` (${comprasList.length})`:''}</button>}
        {veRetiradas && <button style={tab==='retiradas'?btnP:btnG} onClick={()=>{setTab('retiradas');carregarRetiradas()}}>Retiradas{retiradas.length?` (${retiradas.length})`:''}</button>}
        {veRemessas && <button style={tab==='remessas'?btnP:btnG} onClick={()=>{setTab('remessas');carregarRemessas()}}>Remessas{remessas.length?` (${remessas.length})`:''}</button>}
        {gestor && <button style={tab==='obras-cod'?btnP:btnG} onClick={()=>setTab('obras-cod')}>Códigos de obra</button>}
        {deps.length>0 && <span style={{marginLeft:'auto', alignSelf:'center', fontSize:'.8rem', color:'var(--text-secondary)'}}>Depósitos: {deps.map(d=>d.nome).join(' · ')}</span>}
      </div>

      {tab==='solicitacoes' && <>
        {solicitante && !novo && <div style={{display:'flex', gap:'8px 14px', alignItems:'center', flexWrap:'wrap', marginBottom:14}}>
          <button style={btnP} onClick={()=>setNovo(true)}>+ Nova solicitação de material</button>
          {prazoCfg && prazoCfg.vigente > 0 && prazoCfg.modo !== 'medir' && <span style={{fontSize:'.84rem', color:'var(--text-secondary)'}}>
            Pedindo hoje, a data mais próxima é <strong style={{color:'var(--ink)'}}>{recDiaSem(recPrimeiraData(prazoCfg))} {recDM(recPrimeiraData(prazoCfg))}</strong> ({recDiasUteis(prazoCfg.vigente)} de antecedência).
          </span>}
        </div>}
        {solicitante && novo && (
          <div id="rec-nova" ref={novoRef} style={{...card, scrollMarginTop:12}}>
            <h3 style={{marginTop:0, marginBottom: refazendo ? 4 : 12}}>{refazendo ? `Refazer ${refazendo.numero} como Obra` : 'Nova solicitação'}</h3>
            {refazendo && <p style={{margin:'0 0 12px', fontSize:'.82rem', color:'var(--text-secondary)'}}>O pedido devolvido fica no histórico. Este novo sai da Sede, com o código da obra.</p>}
            <div style={{display:'grid', gap:10}}>
              {usaTipoObra && <div style={{display:'grid', gap:6}}>
                <span style={{fontSize:'.8rem', fontWeight:700, color:'var(--ink)'}}>Tipo do pedido *</span>
                <div className="rec-tipo-seg" role="radiogroup" aria-label="Tipo do pedido">
                  {[['manutencao','Manutenção'],['obra','Obra']].map(([v, l]) => (
                    <button key={v} type="button" role="radio" aria-checked={tipo===v} className={`${tipo===v ? 'on' : ''} ${v}`}
                      disabled={(!!refazendo && v!=='obra') || (v==='obra' && tipo!=='obra' && !temObraNasMinhas)}
                      title={v==='obra' && !temObraNasMinhas ? 'Nenhuma unidade sua tem obra ativa cadastrada' : undefined}
                      onClick={()=>escolherTipo(v)}>{l}</button>
                  ))}
                </div>
                <span style={{fontSize:'.78rem', color:'var(--text-secondary)'}}>
                  {tipo==='obra'
                    ? 'Obra: o material sai só da Sede (exigência do fiscal). Material de manutenção vai em outro pedido.'
                    : temObraNasMinhas ? 'Manutenção: atendido pelo almoxarifado da base; a Sede completa o que faltar.' : 'Manutenção: atendido pelo almoxarifado da base; a Sede completa o que faltar. Nenhuma unidade sua tem obra ativa agora.'}
                </span>
              </div>}
              {prazoCfg && <RecCamposPrazo cfg={prazoCfg} v={prazoNovo} set={setPrazoNovo} inp={inp} />}
              <label style={{display:'grid', gap:4}}>
                <span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Obra / unidade{tipo==='obra' ? ' *' : ' (opcional)'}</span>
                <select style={inp} value={obraId} onChange={e=>escolherUnidade(e.target.value)}>
                  <option value="">— selecionar —</option>
                  {unidadesForm.map(o=><option key={o.id} value={o.id}>{o.nome}</option>)}
                </select>
              </label>
              {tipo==='obra' && (!obraId
                ? <span style={{fontSize:'.78rem', color:'var(--text-secondary)', marginTop:-4}}>Escolha a unidade para ver as obras dela.</span>
                : codsForm.length
                  ? <label style={{display:'grid', gap:4}}>
                      <span style={{fontSize:'.8rem', fontWeight:700, color:'var(--ink)'}}>Código da obra *</span>
                      <select style={inp} value={obraCodId} onChange={e=>setObraCodId(e.target.value)}>
                        {codsForm.length > 1 && <option value="">— escolha a obra —</option>}
                        {codsForm.map(o=><option key={o.id} value={o.id}>{o.codigo} — {o.nome}</option>)}
                      </select>
                    </label>
                  : <RecAlertas alertas={[{ codigo:'sem_obra', texto:'Esta unidade não tem obra ativa. Peça o cadastro ao almoxarifado da Sede ou faça o pedido como Manutenção.' }]} />)}
              <RecAlertas alertas={alertasForm}>
                <div><button type="button" style={{...btnG, padding:'6px 12px', fontSize:'.82rem', color:'var(--tag-alerta-fg)', borderColor:'var(--tag-alerta-bd)'}} onClick={()=>escolherTipo('obra')}>É da obra: mudar para Obra</button></div>
              </RecAlertas>
              <div>
                <span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Itens</span>
                {itens.map((it, i)=>{
                  const compra = temItem(it) && itemEhCompra(it)
                  const rep = repetidoDe[i]
                  const unCat = it.catalogo_id ? unidadeDe(it) : ''
                  const comEsp = !!(it.abrirEsp || it.especificacao || it.fotos.length)
                  return (
                  <div key={i} id={'rec-it-' + i} className={`rec-it${compra ? ' compra' : ''}${rep != null ? ' dup' : ''}${focoItem === i ? ' foco' : ''}`}>
                    <div className="rec-it-l1">
                      <span className="rec-it-n" aria-hidden="true">{i + 1}</span>
                      <div className="rec-it-busca">
                        <RecItemBusca cat={catForm} value={it.catalogo_id} style={inp}
                          onEscolher={c=>setItem(i,'catalogo_id',String(c.id))}
                          onDescrever={t=>setItens(arr=>arr.map((x, idx)=>idx===i ? { ...x, catalogo_id:'', descricao:t } : x))} />
                      </div>
                      {!it.catalogo_id && <input className="rec-it-desc" style={inp} placeholder="ou descreva o item" value={it.descricao} onChange={e=>setItem(i,'descricao',e.target.value)} />}
                      <div className="rec-it-qtd">
                        <input type="number" inputMode="decimal" min="0" step="any" aria-label={`Quantidade do item ${i + 1}`} value={it.qtd} onChange={e=>setItem(i,'qtd',e.target.value)} />
                        {it.catalogo_id
                          ? unCat && <span className="rec-it-un">{unCat}</span>
                          : <input className="rec-it-un" placeholder="unid." aria-label={`Unidade do item ${i + 1}`} value={it.unidade} onChange={e=>setItem(i,'unidade',e.target.value)} />}
                      </div>
                      <button className="rec-it-rm" style={{...btnG, padding:'6px 10px'}} onClick={()=>rmItem(i)} title="Remover item" aria-label={`Remover item ${i + 1}`}>✕</button>
                      {!comEsp && <button type="button" className="rec-it-mais" onClick={()=>setItem(i,'abrirEsp',true)}>+ especificação ou foto</button>}
                    </div>
                    {comEsp && <div className="rec-it-l2">
                      <input className="rec-it-esp" style={{...inp, padding:'6px 9px', fontSize:'.82rem'}} placeholder="especificação: marca, modelo, medida (opcional)" value={it.especificacao} maxLength={500} onChange={e=>setItem(i,'especificacao',e.target.value)} />
                      {it.fotos.map((f, k)=>(
                        <div key={k} style={{position:'relative'}}>
                          <img src={f} alt="" style={{width:44, height:44, objectFit:'cover', borderRadius:8, border:'1px solid var(--border,#e5e7eb)', display:'block'}} />
                          <button onClick={()=>rmFotoItem(i, k)} title="Remover foto" style={{position:'absolute', top:-6, right:-6, width:20, height:20, borderRadius:'50%', border:'none', background:'var(--fill-danger)', color:'#fff', cursor:'pointer', fontSize:12, lineHeight:'20px', padding:0}}>×</button>
                        </div>
                      ))}
                      {it.fotos.length < REC_FOTOS_ITEM && (
                        <label style={{...btnG, padding:'6px 10px', fontSize:'.8rem', display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer'}} title={'Até ' + REC_FOTOS_ITEM + ' fotos por item'}>
                          <Icon name="camera" size={15}/> Foto
                          <input type="file" accept="image/*" multiple style={{display:'none'}} onChange={e=>{ addFotoItem(i, e.target.files); e.target.value='' }} />
                        </label>
                      )}
                    </div>}
                    {rep != null && <div className="rec-it-aviso"><Icon name="alertTriangle" size={14}/> Mesmo item do nº {rep + 1}: some numa linha só ou tire esta.</div>}
                    {compra && <div style={{marginTop:6, fontSize:'.72rem', fontWeight:700, color:'var(--rec-amber)'}}>{tipo==='obra' ? '→ Sem estoque na Sede: vai para Compras' : '→ Sem estoque: vai para Compras'}</div>}
                  </div>
                )})}
                <button style={{...btnG, marginTop:8, padding:'6px 12px'}} onClick={addItem}>+ item</button>
              </div>
              <label style={{display:'grid', gap:4}}>
                <span style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Observação (opcional)</span>
                <textarea style={{...inp, minHeight:60}} value={obs} onChange={e=>setObs(e.target.value)} />
              </label>
              {(() => {
                const nItens = itens.filter(temItem).length
                const nCompra = itens.filter(it => temItem(it) && itemEhCompra(it)).length
                const nRep = repetidoDe.filter(x => x !== null).length
                const extra = [nCompra > 0 && `${nCompra} ${nCompra === 1 ? 'vai' : 'vão'} para Compras`, nRep > 0 && `${nRep} repetido${nRep > 1 ? 's' : ''}`].filter(Boolean).join(' · ')
                const barra = fl => (
                  <div ref={fl ? undefined : barraRef} className={`rec-nova-barra${fl ? ' flutua' : ''}`} style={fl ? { left: barraFlutua.left, width: barraFlutua.width } : undefined}>
                    <div className="rec-nova-barra-txt">
                      <strong>{nItens} {nItens === 1 ? 'item' : 'itens'}</strong>
                      {extra && <span>{extra}</span>}
                    </div>
                    {!fl && <button style={btnG} onClick={()=>refazendo ? limparNovo() : setNovo(false)}>Cancelar</button>}
                    <button style={{...btnP, display:'inline-flex', alignItems:'center', gap:4, whiteSpace:'nowrap'}} onClick={revisarPedido}>Revisar pedido <Icon name="chevronRight" size={16}/></button>
                  </div>
                )
                return <>{barra(false)}{barraFlutua && barra(true)}</>
              })()}
            </div>
            {revisando && (() => {
              const lista = itens.map((it, i) => ({ it, i })).filter(({ it }) => temItem(it))
              const nC = lista.filter(({ it }) => itemEhCompra(it)).length, nE = lista.length - nC
              const unid = obras.find(o => String(o.id) === String(obraId))
              const cod = tipo === 'obra' ? codsForm.find(o => String(o.id) === String(obraCodId)) : null
              const cls = recClassificar(prazoNovo.data, prazoCfg)
              const emerg = prazoNovo.motivo === 'emergencia'
              const vaiAprovar = !!(cls && cls.faixa === 'fora_prazo' && prazoCfg.modo === 'aprovar' && (!emerg || recEmergencias(prazoCfg).excedeu))
              const semUn = lista.filter(({ it }) => !it.catalogo_id && !it.unidade.trim())
              const nums = arr => arr.map(i => i + 1).join(', ').replace(/, (\d+)$/, ' e $1')
              const fechar = () => { if (!enviando) setRevisando(false) }
              return (
                <div className="modal-overlay open rec-rev-ov" onClick={e => { if (e.target === e.currentTarget) fechar() }}>
                  <div className="modal modal-lg rec-rev" role="dialog" aria-modal="true" aria-labelledby="rec-rev-tt">
                    <div className="modal-header">
                      <div style={{minWidth:0}}>
                        <h3 id="rec-rev-tt">Confira o pedido antes de enviar</h3>
                        <div className="rec-rev-sub">{refazendo ? `Vai no lugar da ${refazendo.numero}, que fica no histórico.` : 'É assim que ele chega ao almoxarifado e a Compras.'}</div>
                      </div>
                      <button className="modal-close" onClick={fechar} title="Voltar e corrigir" aria-label="Voltar e corrigir">×</button>
                    </div>
                    <div className="modal-body">
                      <div className="rec-rev-resumo">
                        {usaTipoObra && <div className="rec-rev-cel"><div className="rec-rev-rot">Tipo</div><div className="rec-rev-val">{tipo === 'obra' ? <span className="rtag caps tg-cobre">Obra</span> : <span className="rtag caps tg-aco">Manutenção</span>}</div></div>}
                        <div className="rec-rev-cel"><div className="rec-rev-rot">Unidade</div><div className="rec-rev-val">{unid ? unid.nome : <span style={{fontWeight:400, color:'var(--text-secondary)'}}>não informada</span>}</div></div>
                        {cod && <div className="rec-rev-cel"><div className="rec-rev-rot">Obra</div><div className="rec-rev-val">{cod.codigo} — {cod.nome}</div></div>}
                        <div className="rec-rev-cel"><div className="rec-rev-rot">Preciso na obra em</div><div className="rec-rev-val">
                          {recDiaSem(prazoNovo.data)} {recDM(prazoNovo.data)}
                          {cls && cls.faixa === 'no_prazo' ? <span className="rtag tg-ok">no prazo</span> : <RecFaixaTag faixa={cls && cls.faixa}/>}
                          {emerg && <span className="rtag caps tg-urgente">Emergência</span>}
                        </div></div>
                        <div className="rec-rev-cel"><div className="rec-rev-rot">Destino</div><div className="rec-rev-val">{[nE > 0 && `${nE} do estoque`, nC > 0 && `${nC} para Compras`].filter(Boolean).join(' · ')}</div></div>
                      </div>
                      {prazoNovo.motivo && !emerg && REC_MOTIVO_LABEL[prazoNovo.motivo] && <div className="rec-rev-sub" style={{marginTop:8}}>Fora do prazo · {REC_MOTIVO_LABEL[prazoNovo.motivo]}</div>}
                      {vaiAprovar && <div className="rec-rev-sub" style={{marginTop:8}}>Antes de chegar ao almoxarifado, vai para aprovação do gerente do contrato.</div>}
                      {gruposRepetidos.map(g => {
                        const un = unidadeDe(itens[g[0]])
                        const soma = Math.round(g.reduce((n, i) => n + (Number(itens[i].qtd) || 0), 0) * 1000) / 1000
                        return (
                          <div key={'rep' + g[0]} className="rec-rev-aviso" role="alert">
                            <Icon name="alertTriangle" size={16}/>
                            <div style={{flex:1, minWidth:0}}>
                              <strong>{nomeDe(itens[g[0]])} aparece {g.length} vezes</strong>
                              <div>Itens {nums(g)}. Era um pedido só?</div>
                              <div className="rec-rev-aviso-bt">
                                <button type="button" onClick={()=>juntarRepetidos(g)}>Juntar: {fmtQtd(soma)}{un ? ' ' + un : ''}</button>
                                <button type="button" onClick={()=>tirarRepetidos(g)}>{g.length > 2 ? `Tirar os itens ${nums(g.slice(1))}` : `Tirar o item ${g[1] + 1}`}</button>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                      {semUn.length > 0 && (
                        <div className="rec-rev-aviso" role="alert">
                          <Icon name="alertTriangle" size={16}/>
                          <div style={{flex:1, minWidth:0}}>
                            <strong>{semUn.length === 1 ? `Item ${semUn[0].i + 1} está sem unidade` : `Itens ${nums(semUn.map(x => x.i))} estão sem unidade`}</strong>
                            <div>Compras compra pelo que estiver escrito: é metro, rolo, caixa, peça?</div>
                            <div className="rec-rev-aviso-bt"><button type="button" onClick={()=>corrigirItem(semUn[0].i)}>Corrigir</button></div>
                          </div>
                        </div>
                      )}
                      <div className="rec-rev-topo"><strong>{lista.length} {lista.length === 1 ? 'item' : 'itens'}</strong><span>toque num item para corrigir</span></div>
                      <div className="rec-rev-lista">
                        <div className="rec-rev-cab" aria-hidden="true"><span>Nº</span><span>Quantidade</span><span>Item</span><span>Destino</span><span></span></div>
                        {lista.map(({ it, i }) => {
                          const compra = itemEhCompra(it), un = unidadeDe(it), rep = repetidoDe[i]
                          const via = cls2 => <span className={`rec-rev-via ${cls2}${compra ? ' compra' : ''}`}>{compra ? 'Via compras' : 'Via estoque'}</span>
                          return (
                            <button key={i} type="button" className={`rec-rev-it${rep != null ? ' dup' : ''}`} onClick={()=>corrigirItem(i)} title="Corrigir este item">
                              <span className="rec-rev-n">{i + 1}</span>
                              <span className="rec-rev-q"><b>{fmtQtd(it.qtd)}</b>{un ? <span>{un}</span> : <span className="falta">sem unid.</span>}</span>
                              <span style={{minWidth:0}}>
                                <span className="rec-rev-nome">{nomeDe(it)}</span>
                                {!it.catalogo_id && <span className="rec-rev-esp">Fora do catálogo</span>}
                                {it.especificacao.trim() && <span className="rec-rev-esp">Especificação: {it.especificacao.trim()}</span>}
                                {rep != null && <span className="rec-rev-esp" style={{color:'var(--tag-alerta-fg)', fontWeight:600}}>Repetido: igual ao item {rep + 1}</span>}
                                {it.fotos.length > 0 && <span className="rec-rev-fotos">{it.fotos.map((f, k) => <img key={k} src={f} alt={`Foto ${k + 1} do item ${i + 1}`}/>)}</span>}
                                {via('cel')}
                              </span>
                              <span className="rec-rev-dest">{via('desk')}</span>
                              <span className="rec-rev-corr">Corrigir</span>
                            </button>
                          )
                        })}
                      </div>
                      {obs.trim() && <div className="rec-rev-obs"><span>Observação:</span> {obs.trim()}</div>}
                    </div>
                    <div className="modal-footer rec-rev-pe">
                      <span className="rec-rev-pe-txt"><strong>{lista.length} {lista.length === 1 ? 'item' : 'itens'}</strong>{nC > 0 ? ` · ${nC} ${nC === 1 ? 'vai' : 'vão'} para Compras` : ''}</span>
                      <button style={btnG} onClick={fechar} disabled={enviando}>Voltar e corrigir</button>
                      <button className="rec-rev-ok" style={{...btnP, display:'inline-flex', alignItems:'center', justifyContent:'center', gap:6, opacity: enviando ? .6 : 1}} disabled={enviando} onClick={enviarSolicitacao}>
                        <Icon name="check" size={16}/> {enviando ? 'Enviando…' : refazendo ? 'Confirmar e abrir como Obra' : 'Confirmar e enviar'}
                      </button>
                    </div>
                  </div>
                </div>
              )
            })()}
          </div>
        )}

        {solicitante && prazoCfg && prazoCfg.meus && prazoCfg.meus.total > 0 && (
          <div style={{fontSize:'.84rem', color:'var(--text-secondary)', margin:'-4px 0 12px'}}>
            Seus pedidos nos últimos 30 dias: <strong style={{color: prazoCfg.meus.fora ? 'var(--tag-perigo-fg)' : 'var(--success)'}}>{prazoCfg.meus.fora} de {prazoCfg.meus.total}</strong> fora do prazo
            {prazoCfg.meus.emergencias_mes > 0 && <> · emergências em {recMesNome(prazoCfg.hoje)}: <strong style={{color:'var(--ink)'}}>{prazoCfg.meus.emergencias_mes}{prazoCfg.emergencias > 0 ? ` de ${prazoCfg.emergencias}` : ''}</strong></>}
          </div>
        )}
        {filtrosSol}
        {faixaRec('solicitacoes')}
        {sols.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>Nenhuma solicitação {gestor?'registrada':'sua'} ainda.</div>}
        {sols.length>0 && solsVis.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>{!filtroSolPainel && solSitEf==='voce' && solsBase.length===sols.length ? 'Nada esperando por você agora.' : 'Nenhuma solicitação neste filtro agora.'}</div>}
        {solsTela.map(s=>(
          <div key={s.id} id={'sol-' + s.id} style={{...card, padding:0, overflow:'hidden'}}>
            <div onClick={()=>abrirDetalhe(s)} style={{display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, flexWrap:'wrap', padding:16, cursor:'pointer'}}>
              <div>
                <div style={{fontWeight:700, color:'var(--ink,#111)', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap'}}><span style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace'}}>{abertaId===s.id?'▾ ':'▸ '}{s.numero}</span> <RecTagAberto s={s}/>
                  <RecTipoTag s={s}/>
                  <RecFaixaTag faixa={s.faixa}/>
                  {gestor && REC_SOL_ATIVA.includes(s.status) && <RecAlertas alertas={s.alertas} compacto/>}
                  {almox && remessas.some(r => r.solicitacao_id===s.id && r.status==='separando') && <span className="rtag dot tg-alerta">Falta: motorista e pronta</span>}
                  {almox && remessas.some(r => r.solicitacao_id===s.id && r.status==='separando' && (r.itens||[]).some(i => i.devolvido_de)) && <span className="rtag dot tg-alerta">Base devolveu item</span>}
                  {almox && s.faixa==='fora_prazo' && !s.data_prometida && SOL_ATIVA_FORA.includes(s.status) && <span className="rtag dot tg-alerta">Falta: data prometida</span>}
                </div>
                <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:4}}><RecLinhaPrazo s={s}/></div>
                <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:2}}>
                  {(gestor || s.solicitante_id !== user.id) && <>por {s.solicitante_nome||'—'} · </>}
                  {s.obra_nome ? `obra ${s.obra_nome} · ` : ''}{s.itens} item(ns){s.obs?` · ${s.obs}`:''}
                </div>
              </div>
              <div style={{fontSize:'.78rem', color:'var(--silver)'}}>{(s.criado_em||'').slice(0,16).replace('T',' ')}</div>
            </div>
            {abertaId===s.id && (
              <div style={{borderTop:'1px solid var(--border,#e5e7eb)', padding:16, background:'var(--silver-light,#f8fafc)'}}>
                {!detalhe && <div style={{color:'var(--text-secondary)'}}>Carregando…</div>}
                {detalhe && detalhe.id===s.id && <>
                  {recBlocoTipo(detalhe)}
                  {recBlocoPrazo(detalhe)}
                  {[...detalhe.itens].sort((a,b)=>(recItemSteps(a,detalhe.status).trilho==='estoque'?0:1)-(recItemSteps(b,detalhe.status).trilho==='estoque'?0:1)).map((it,idx,arr)=>{
                    const st = recItemSteps(it, detalhe.status, detalhe.remessa_status)
                    const entregue = st.entregue
                    const viaEstoque = st.trilho==='estoque'
                    return (
                    <div key={idx} style={{padding:'13px 0', borderBottom: idx<arr.length-1?'1px dashed var(--border,#e5e7eb)':'none', opacity: entregue?0.72:1}}>
                      <div style={{display:'flex', justifyContent:'space-between', gap:8, alignItems:'flex-start', flexWrap:'wrap'}}>
                        <span style={{fontSize:'.9rem', color: entregue?'var(--rec-pending)':'var(--ink,#111)', textDecoration: entregue?'line-through':'none'}}>
                          <strong style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace'}}>{Number(it.qtd)}</strong>{it.catalogo_unidade||it.unidade?` ${it.catalogo_unidade||it.unidade}`:''} · {it.catalogo_nome||it.descricao||'(item)'}
                        </span>
                        {/* Almoxarife só recebe itens do trilho de estoque (filtro no servidor) — a etiqueta não diz nada a ele. */}
                        {!(almox || almox2) && <span style={{flex:'none', fontSize:'.64rem', fontWeight:700, letterSpacing:'.03em', textTransform:'uppercase', padding:'3px 8px', borderRadius:6, whiteSpace:'nowrap', color:'var(--rec-on-accent)', background: viaEstoque?'var(--rec-navy)':'var(--rec-amber)'}}>
                          {viaEstoque?'Via estoque':'Via compras'}
                        </span>}
                      </div>
                      {/* O pedido mostra o item como foi pedido; renomeado no catálogo depois, o nome de hoje vem junto. */}
                      {it.catalogo_nome_hoje && <div style={{fontSize:'.74rem', color:'var(--text-secondary)', marginTop:4}}>No catálogo hoje: {it.catalogo_nome_hoje}</div>}
                      {it.especificacao && <div style={{fontSize:'.78rem', color:'var(--text-secondary)', marginTop:4}}>Especificação: {it.especificacao}</div>}
                      <RecFotos ids={it.fotos} size={52}/>
                      {!['devolvida','refeita'].includes(detalhe.status) && <div style={{marginTop:10}}><RecEsteira steps={st.steps} cur={st.cur} entregue={entregue} transporte={st.transporte}/></div>}
                      {it.destino==='compras' && it.compra && (
                        <div style={{marginTop:10, fontSize:'.74rem', color:'var(--rec-sub)', display:'flex', gap:10, flexWrap:'wrap', alignItems:'center'}}>
                          <span style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace', fontWeight:600, color:'var(--rec-amber)'}}>{it.compra.numero}</span>
                          {it.compra.prazo && <span>prazo {String(it.compra.prazo).length>=10?String(it.compra.prazo).slice(8,10)+'/'+String(it.compra.prazo).slice(5,7):it.compra.prazo}</span>}
                          {it.compra.prioridade==='urgente' && <RecUrgente sm/>}
                        </div>
                      )}
                      {/* Compras cancelou a compra do item: o motivo é obrigatório e quem pediu lê aqui. */}
                      {it.destino==='compras' && it.compra && it.compra.status==='cancelada' && it.compra.cancelada_motivo && (
                        <div style={{marginTop:8, fontSize:'.78rem', color:'var(--ink,#111)', padding:'6px 10px', borderRadius:8, background:'var(--rec-urg-bg)'}}>
                          <strong style={{color:'var(--rec-urg-fg)'}}>Compra cancelada{it.compra.cancelada_em ? ` em ${recDM(it.compra.cancelada_em)}` : ''}</strong>
                          <div style={{fontStyle:'italic', marginTop:2}}>"{it.compra.cancelada_motivo}"</div>
                        </div>
                      )}
                      {/* Item que Compras marcou "Chegou ao estoque": mostra de onde veio (o digitado só chega ao almoxarifado assim). */}
                      {it.destino==='estoque' && it.compra && it.compra.status==='em_estoque' && (
                        <div style={{marginTop:10, fontSize:'.74rem', color:'var(--rec-sub)', display:'flex', gap:8, flexWrap:'wrap', alignItems:'center'}}>
                          <span>Veio de Compras</span>
                          <span style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace', fontWeight:600, color:'var(--rec-amber)'}}>{it.compra.numero}</span>
                          {it.compra.fornecedor && <span>{it.compra.fornecedor}</span>}
                          <span>chegou ao estoque{it.compra.retirado_em ? ` em ${recDM(it.compra.retirado_em)}` : ''}{it.compra.marcado_por_nome ? ` · marcado por ${it.compra.marcado_por_nome}` : ''}</span>
                        </div>
                      )}
                      {gestor && (() => {
                        const sv = (it.saldos||[]).filter(sl => Number(sl.quantidade) > 0)
                        if (sv.length) return (
                          <div style={{display:'flex', gap:6, flexWrap:'wrap', marginTop:9}}>
                            {sv.map((sl,i)=>(
                              <span key={i} style={{fontSize:'.7rem', color:'var(--text-secondary)', background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderRadius:999, padding:'2px 9px'}}>
                                {sl.deposito_tipo==='sede'?'Sede':(sl.deposito_nome||'Depósito')} · <strong>{sl.quantidade}</strong>
                              </span>
                            ))}
                          </div>
                        )
                        if (it.destino==='estoque' && it.catalogo_id) return <div style={{fontSize:'.72rem', color:'var(--rec-amber)', marginTop:9}}>sem saldo no estoque</div>
                        return null
                      })()}
                      {almox && (['solicitada','analisando','reservada'].includes(detalhe.status) || detalhe.so_separacao) && it.destino==='estoque' && Number(it.falta_estoque) > 0 && blocoParaCompras(s.id, it)}
                    </div>
                  )})}
                  {almox && ['solicitada','analisando','reservada'].includes(detalhe.status) && <>
                    <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:12}}>
                      {detalhe.status==='solicitada' && <button style={{...btnG, opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>acaoSolicitacao(s.id,'analisar', exigePromessa(detalhe) ? { data_prometida: promData } : null)}>Marcar em análise</button>}
                      {(detalhe.status==='solicitada'||detalhe.status==='analisando') && <button style={{...btnP, opacity:acaoLoad?0.6:1}} disabled={acaoLoad} onClick={()=>acaoSolicitacao(s.id,'reservar', exigePromessa(detalhe) ? { data_prometida: promData } : null)}>Reservar</button>}
                      {detalhe.aceita_isto_e_obra && botaoIstoEObra(s.id)}
                      {botaoCancelarPedido(s.id, detalhe)}
                    </div>
                    {formIstoEObra(s.id)}
                    {formCancelarPedido(s.id, detalhe)}
                  </>}
                  {almox && detalhe.status==='reservada' && (
                    <div style={{marginTop:12, paddingTop:12, borderTop:'1px dashed var(--border,#e5e7eb)'}}>
                      <RecDivisao user={user} solId={s.id} refazer={false} addToast={addToast} onFeito={r=>aposDivisao(s.id, r, false)} />
                    </div>
                  )}
                  {/* Modo apresentação: o perfil não reserva (somente leitura) — o pedido em análise mostra a divisão como prévia. */}
                  {almox && user.tour && ['solicitada','analisando'].includes(detalhe.status) && detalhe.itens.length > 0 && (
                    <div style={{marginTop:12, paddingTop:12, borderTop:'1px dashed var(--border,#e5e7eb)'}}>
                      <RecDivisao user={user} solId={s.id} refazer={false} addToast={addToast} onFeito={()=>{}} />
                    </div>
                  )}
                  {/* Remessas geradas: o almoxarife segue daqui (motorista + pronta), sem trocar de aba. */}
                  {almox && (() => {
                    const rems = remessas.filter(r => r.solicitacao_id === s.id)
                    if (!rems.length) return null
                    return (
                      <div style={{marginTop:12, paddingTop:12, borderTop:'1px dashed var(--border,#e5e7eb)'}}>
                        <div style={{fontSize:'.78rem', fontWeight:700, color:'var(--rec-navy)', marginBottom:8}}>{rems.length > 1 ? `Remessas (${rems.length})` : 'Remessa'}</div>
                        {rems.map(r => (
                          <div key={r.id} style={{background:'var(--card,#fff)', border:'1px solid var(--border,#e5e7eb)', borderRadius:10, padding:'10px 12px', marginBottom:8, display:'grid', gap:9}}>
                            <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', fontSize:'.82rem'}}>
                              <strong style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace', color:'var(--ink,#111)'}}>{r.numero}</strong>
                              <RecStatus s={r.status}/>
                              <span style={{color:'var(--rec-sub)'}}>sai de {depRotulo(r)} · {(r.itens||[]).length} item(ns)</span>
                              <button style={{marginLeft:'auto', background:'none', border:'none', color:'var(--primary-accent,#4A90A4)', cursor:'pointer', fontSize:'.76rem', fontWeight:600, padding:0}} onClick={()=>verNaAbaRemessas(r)}>ver detalhes ›</button>
                            </div>
                            {r.status==='separando' && r.deposito_tipo==='centro' && <div style={{fontSize:'.72rem', color:'var(--rec-sub)', marginTop:-4}}>Normalmente marcada pelo Almoxarife 2 de {r.deposito_nome || 'lá'}.</div>}
                            <RecItensDevolvidos itens={r.itens} />
                            {acaoRemessaAlmox(r)}
                          </div>
                        ))}
                        {/* Tudo ainda em separação: a Sede pode refazer a divisão (nada saiu do estoque). */}
                        {detalhe.tipo !== 'obra' && detalhe.status === 'separada' && rems.every(r => r.status === 'separando') && (refazDiv === s.id
                          ? <div style={{margin:'4px 0 10px'}}><RecDivisao user={user} solId={s.id} refazer addToast={addToast} onFeito={r=>aposDivisao(s.id, r, true)} onCancelar={()=>setRefazDiv(null)} /></div>
                          : <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', margin:'2px 0 10px'}}>
                              <button style={{...btnG, padding:'6px 12px', fontSize:'.8rem'}} onClick={()=>setRefazDiv(s.id)}>Refazer divisão</button>
                              <span style={{fontSize:'.74rem', color:'var(--rec-sub)'}}>Mudar o que sai da base e o que sai da Sede — só até alguém marcar "pronta".</span>
                            </div>)}
                        {/* Ainda tudo em separação (nada saiu do estoque): dá para devolver como obra ou cancelar — as remessas são canceladas. */}
                        {detalhe.so_separacao && <>
                          <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                            {detalhe.aceita_isto_e_obra && botaoIstoEObra(s.id)}
                            {botaoCancelarPedido(s.id, detalhe)}
                          </div>
                          {formIstoEObra(s.id)}
                          {formCancelarPedido(s.id, detalhe)}
                        </>}
                      </div>
                    )
                  })()}
                </>}
              </div>
            )}
          </div>
        ))}
        {fimSols}
      </>}


      {tab==='compras' && <ComprasEsteira user={user} addToast={addToast} lista={comprasList} recarregar={carregarCompras} filtro={compraFiltro} />}

      {tab==='obras-cod' && gestor && <RecObraCodigos user={user} addToast={addToast} onMudou={async () => { try { setObraCods(await GET('/rec/obra-codigos')) } catch {} }} />}

      {tab==='retiradas' && <>
        {/* Retiradas de mais de um contrato (Compras vê todas): o cartão diz de qual contrato é. */}
        <p style={{margin:'-6px 0 14px', fontSize:'.84rem', color:'var(--rec-sub)'}}>Material já comprado, aguardando retirada — com o fornecedor onde buscar. {compras?'Encaminhe pela aba Compras; o':'O'} responsável designado confirma a retirada aqui.</p>
        {retiradas.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>Nenhuma retirada pendente.</div>}
        {retiradas.map(rc=>(
          <div key={rc.id} style={{...card, marginBottom:10, borderLeft:'4px solid var(--rec-amber)'}}>
            <div style={{display:'flex', justifyContent:'space-between', gap:12, flexWrap:'wrap', alignItems:'baseline'}}>
              <div style={{fontWeight:700, color:'var(--ink,#111)', display:'flex', alignItems:'center', gap:8, flexWrap:'wrap'}}>{rc.numero} {retMultiCt && <RcContratoTag rc={rc}/>}<RecStatus s={rc.status}/> {rc.prioridade==='urgente' && <RecUrgente/>}<RecPrazoBadge prazo={rc.prazo} status={rc.status}/></div>
              <div style={{fontSize:'.78rem', color:'var(--silver)'}}>{(rc.atualizado_em||rc.criado_em||'').slice(0,16).replace('T',' ')}</div>
            </div>
            <div style={{marginTop:4, color:'var(--ink,#111)'}}><strong>{Number(rc.qtd)}</strong>{rc.unidade?` ${rc.unidade}`:''} · {rc.descricao||'(item)'}</div>
            <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:3}}>
              {rc.obra_nome?`obra ${rc.obra_nome} · `:''}{rc.prazo?`prazo ${rc.prazo} · `:''}Responsável: <strong style={{color:'var(--rec-amber)'}}>{rc.retirada_responsavel_nome||'—'}</strong>
            </div>
            {rc.fornecedor || rc.retirada_endereco
              ? <RecRetiradaLocal rc={rc}/>
              : <div style={{fontSize:'.8rem', color:'var(--rec-sub)', marginTop:6, fontStyle:'italic'}}>Fornecedor não informado — confirme com Compras onde buscar.</div>}
            <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:10}}>
              <button style={{...btnP, opacity:retLoad?0.6:1}} disabled={retLoad} onClick={()=>confirmarRetirada(rc.id)}>Confirmar retirada</button>
            </div>
          </div>
        ))}
      </>}

      {tab==='painel' && <RecPainelIndicadores painel={painel} veEmCompras={aprovador || !!user.is_master}
        irAba={(t, f) => { aplicarFiltroRec(f); setTab(t); if (t === 'remessas') carregarRemessas() }}
        irEstoque={navigate && podeAbrir(user, 'estoque') ? () => navigate('estoque', 'saldo') : null}
        prazoConfig={masterReal && prazoCfg ? <RecPrazoConfig cfg={prazoCfg} addToast={addToast}
          onSalvo={async () => { try { const [c, p] = await Promise.all([GET('/rec/prazo-config'), GET('/rec/painel')]); setPrazoCfg(c); setPainel(p) } catch {} }} /> : null} />}

      {tab==='remessas' && <>
        {filtrosRem}
        {faixaRec('remessas')}
        {remessas.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>Nenhuma remessa {logistica?'pronta/em trânsito':''} ainda.</div>}
        {remessas.length>0 && remsVis.length===0 && <div style={{...card, color:'var(--text-secondary)'}}>{!filtroRemPainel && remSitEf==='voce' && remsBase.length===remessas.length ? 'Nada esperando por você agora.' : 'Nenhuma remessa neste filtro agora.'}</div>}
        {almox && remessas.length>0 && <p style={{margin:'-6px 0 14px', fontSize:'.84rem', color:'var(--rec-sub)'}}>Consulta. Para escolher o motorista e marcar a remessa pronta, abra a solicitação em Solicitações.</p>}
        {remsTela.map(r=>(
          <div key={r.id} id={'rem-' + r.id} style={{...card, padding:0, overflow:'hidden', scrollMarginTop:12}}>
            <div onClick={()=>abrirRemessa(r)} style={{display:'flex', justifyContent:'space-between', alignItems:'center', gap:12, flexWrap:'wrap', padding:16, cursor:'pointer'}}>
              <div style={{minWidth:0, flex:'1 1 240px'}}>
                <div style={{fontWeight:700, color:'var(--ink,#111)', display:'flex', alignItems:'center', gap:6, flexWrap:'wrap'}}>{remAberta===r.id?'▾ ':'▸ '}{r.numero} <RecStatus s={r.status}/>
                  {!transportador && <RecTipoTag s={r} sm/>}
                  {almox2 && r.status==='separando' && <RecAlertas alertas={r.alertas} compacto/>}
                  {almox2 && r.status==='separando' && r.alterada_em && <span className="rtag dot tg-alerta" title={`A Sede refez a divisão em ${recDM(r.alterada_em)} ${String(r.alterada_em).slice(11,16)}`}>Alterada pela Sede</span>}
                </div>
                {/* Para onde vai: quem separa precisa saber o destino para orientar o motorista. */}
                {!transportador && (
                  <div style={{marginTop:5, display:'flex', alignItems:'center', gap:'4px 8px', flexWrap:'wrap', fontSize:'.86rem', color:'var(--ink,#111)', overflowWrap:'anywhere'}}>
                    <span><span style={{color:'var(--text-secondary)'}}>Para:</span> <strong>{r.obra_nome || 'Obra não informada'}</strong>{r.obra_endereco ? <span style={{color:'var(--text-secondary)'}}> · {r.obra_endereco}</span> : null}</span>
                    {r.status !== 'entregue' && <MotPrazoTag d={motPrazoRem(r)} />}
                  </div>
                )}
                <div style={{fontSize:'.82rem', color:'var(--text-secondary)', marginTop:3}}>
                  {r.solicitacao_numero?`sol. ${r.solicitacao_numero} · `:''}{!transportador && r.solicitante_nome ? `pediu ${r.solicitante_nome} · ` : ''}{r.direta || r.deposito_nome ? `${depRotulo(r)} · ` : ''}{r.itens?r.itens.length:0} item(ns){r.eventos&&r.eventos.length?` · ${r.eventos.length} elo(s)`:''}{!transportador && r.motorista_nome ? ` · motorista ${r.motorista_nome}` : ''}
                </div>
                {transportador && (
                  <div style={{marginTop:7, display:'flex', flexDirection:'column', gap:3, fontSize:'.8rem'}}>
                    <span style={{color:'var(--ink,#111)'}}><strong style={{color:'var(--rec-navy)'}}>Retirar:</strong> {r.direta || r.deposito_nome ? depRotulo(r) : '—'}{r.direta && r.fornecedor_endereco ? ` · ${r.fornecedor_endereco}` : ''}</span>
                    <span style={{color:'var(--ink,#111)'}}><strong style={{color:'var(--rec-amber)'}}>Entregar:</strong> {r.obra_nome||'—'}{r.obra_endereco?` · ${r.obra_endereco}`:''}</span>
                    {r.sol_criado_em && <span style={{color:'var(--text-secondary)'}}>Solicitado em {String(r.sol_criado_em).slice(0,16).replace('T',' ')}</span>}
                    {r.motorista_id===user.id && <span style={{fontWeight:700, color:'var(--rec-green)'}}>Designada a você</span>}
                  </div>
                )}
              </div>
              <div style={{fontSize:'.78rem', color:'var(--silver)'}}>{(r.criado_em||'').slice(0,16).replace('T',' ')}</div>
            </div>
            {remAberta===r.id && (
              <div style={{borderTop:'1px solid var(--border,#e5e7eb)', padding:16, background:'var(--silver-light,#f8fafc)'}}>
                {!remDet && <div style={{color:'var(--text-secondary)'}}>Carregando…</div>}
                {remDet && remDet.id===r.id && <>
                  {/* A mesma rota que o motorista recebe no painel dele: de onde sai, para onde vai, quem pediu. */}
                  {!transportador && !recebe && (
                    <div style={{marginBottom:14}}>
                      <div className="mot-rota" style={{margin:'0 0 4px'}}>
                        <div className={`mot-pt${['em_transporte','entregue'].includes(remDet.status) ? ' feito' : ''}`}><span className="mot-dot"/>
                          <div className="mot-pt-tx"><div className="mot-pt-l">Sai de</div><div className="mot-pt-v">{depRotulo(remDet)}</div></div>
                        </div>
                        <MotDestino r={remDet} alvo={remDet.status !== 'entregue'} />
                      </div>
                      <MotContato r={remDet} />
                    </div>
                  )}
                  {almox2 && remDet.status==='separando' && remDet.alterada_em && (
                    <div style={{fontSize:'.78rem', color:'var(--tag-alerta-fg)', marginBottom:8}}>A Sede refez a divisão em {recDM(remDet.alterada_em)} às {String(remDet.alterada_em).slice(11,16)}{remDet.alterada_por_nome ? ` (${remDet.alterada_por_nome})` : ''}: confira os itens abaixo.</div>
                  )}
                  {remDet.itens.map((it,i)=>(
                    <div key={it.id||i} style={{padding:'3px 0'}}>
                      <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap', fontSize:'.85rem', color:'var(--ink,#111)'}}>
                        <span style={{minWidth:0, overflowWrap:'anywhere'}}><strong>{Number(it.qtd)}</strong>{it.unidade?` ${it.unidade}`:''} · {it.catalogo_nome||it.descricao||'(item)'}</span>
                        {almox2 && remDet.status==='separando' && !(devItem && devItem.item===it.id) && (
                          <button style={{...btnG, padding:'3px 9px', fontSize:'.72rem', marginLeft:'auto'}} onClick={()=>setDevItem({ rem: remDet.id, item: it.id, motivo: '', outro: '' })}>Não consigo enviar</button>
                        )}
                      </div>
                      {almox2 && devItem && devItem.item===it.id && (
                        <div style={{display:'grid', gap:8, margin:'6px 0 8px', padding:'10px 12px', border:'1px solid var(--tag-alerta-bd)', borderRadius:10, background:'var(--card)'}}>
                          <strong style={{fontSize:'.84rem', color:'var(--ink)'}}>Devolver à Sede</strong>
                          <select style={{...inp, width:'100%'}} value={devItem.motivo} onChange={e=>setDevItem({ ...devItem, motivo: e.target.value })}>
                            <option value="">Por que não consegue enviar?</option>
                            {REC_MOTIVOS_DEV.map(m => <option key={m} value={m}>{m}</option>)}
                            <option value="outro">Outro motivo…</option>
                          </select>
                          {devItem.motivo==='outro' && <textarea style={{...inp, minHeight:52, width:'100%'}} maxLength={300} autoFocus value={devItem.outro} onChange={e=>setDevItem({ ...devItem, outro: e.target.value })} placeholder="Explique para a Sede." />}
                          <span style={{fontSize:'.74rem', color:'var(--text-secondary)'}}>O item inteiro passa para a remessa da Sede, que vê o motivo.{remDet.itens.length===1 ? ' É o único item: esta remessa é cancelada.' : ''}</span>
                          <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>
                            <button style={{...btnP, background:'var(--fill-cobre)', opacity:remLoad?0.6:1}} disabled={remLoad} onClick={devolverItem}>Devolver à Sede</button>
                            <button style={btnG} onClick={()=>setDevItem(null)}>Cancelar</button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                  {!almox2 && !transportador && <div style={{marginTop:6}}><RecItensDevolvidos itens={remDet.itens} /></div>}
                  {remDet.eventos && remDet.eventos.length>0 && (
                    <div style={{marginTop:10}}>
                      <div style={{fontSize:'.78rem', color:'var(--text-secondary)', marginBottom:4}}>Cadeia de custódia:</div>
                      {remDet.eventos.map((e,i)=> e.tipo==='regularizacao' ? (
                        <div key={i} style={{fontSize:'.76rem', color:'var(--text-secondary)', padding:'3px 0', display:'grid', gap:2}}>
                          <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
                            <span style={{fontWeight:700, color:'var(--tag-alerta-fg)'}}>entrega fora do app · sem assinatura</span>
                            <span>chegou em {recDM(e.ocorrido_em)}{e.contraparte_nome ? ` · recebeu ${e.contraparte_nome}` : ''} · registrada por {e.de_id ? (e.de_nome||'—') : 'Sistema'}</span>
                            <span style={{color:'var(--silver)', fontFamily:'monospace'}} title={e.hash_evento}>#{(e.hash_evento||'').slice(0,8)}</span>
                          </div>
                          {e.obs && <div style={{overflowWrap:'anywhere'}}>Motivo: {e.obs}</div>}
                        </div>
                      ) : (
                        <div key={i} style={{fontSize:'.76rem', color:'var(--text-secondary)', display:'flex', gap:8, alignItems:'center', padding:'3px 0', flexWrap:'wrap'}}>
                          <span style={{fontWeight:700}}>{e.tipo}</span>
                          <span>{e.de_nome||'—'} → {e.para_nome||'—'}</span>
                          {e.assinatura && <span title="assinado">✍️</span>}
                          {e.foto && <span title="com registro fotográfico">📷</span>}
                          <span style={{color:'var(--silver)', fontFamily:'monospace'}} title={e.hash_evento}>#{(e.hash_evento||'').slice(0,8)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {almox2 && ['separando','pronta','a_caminho'].includes(remDet.status) && <div style={{marginTop:12}}>{acaoRemessaAlmox(remDet)}</div>}
                  {/* Almoxarife 2: pedido de manutenção que na verdade é de obra volta para quem pediu (sai da Sede). Só no
                      contrato com código de obra ativo (aceita_isto_e_obra): sem ele não há como refazer como Obra. */}
                  {almox2 && remDet.status==='separando' && remDet.aceita_isto_e_obra && (
                    <div style={{marginTop:14, paddingTop:12, borderTop:'1px dashed var(--border,#e5e7eb)'}}>
                      <RecAlertas alertas={remDet.alertas} />
                      <div style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center'}}>
                        {botaoIstoEObra(remDet.solicitacao_id)}
                        {!(devObra && devObra.sol === remDet.solicitacao_id) && <span style={{fontSize:'.76rem', color:'var(--text-secondary)'}}>Material de obra sai da Sede, não da base.</span>}
                      </div>
                      {formIstoEObra(remDet.solicitacao_id)}
                    </div>
                  )}
                  {!almox2 && !transportador && remDet.motorista_nome && ['pronta','a_caminho','em_transporte'].includes(remDet.status) && <div style={{marginTop:10, fontSize:'.82rem', color:'var(--ink,#111)'}}>Motorista: <strong>{remDet.motorista_nome}</strong>{remDet.motorista_telefone ? ` · ${remDet.motorista_telefone}` : ''}</div>}
                  <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:12}}>
                    {transportador && remDet.status==='pronta' && <button style={{...btnG, opacity:remLoad?0.6:1}} disabled={remLoad} onClick={()=>marcarACaminho(r.id)}>A caminho</button>}
                    {transportador && (remDet.status==='pronta'||remDet.status==='a_caminho') && assinarRem!==r.id && <button style={{...btnP}} onClick={()=>setAssinarRem(r.id)}>Retirar (assinar)</button>}
                    {transportador && remDet.status==='em_transporte' && assinarRem!==r.id && <button style={{...btnP}} onClick={()=>setAssinarRem(r.id)}>Entregar (assinar)</button>}
                    {recebe && remDet.status==='em_transporte' && assinarRem!==r.id && <button style={{...btnG}} onClick={()=>setAssinarRem(r.id)}>Receber pelo líder (alternativa)</button>}
                    {(transportador||recebe||gestor) && <button style={btnG} onClick={()=>setChatRem(chatRem===r.id?null:r.id)}>{chatRem===r.id?'Fechar conversa':'💬 Conversar'}</button>}
                    {remDet.status==='entregue' && <button style={btnG} onClick={()=>verTermo(r.id)}>Ver termo</button>}
                  </div>
                  {chatRem===r.id && <RecChat canal={'remessa:'+r.id} titulo={transportador ? `Solicitante: ${remDet.solicitante_nome||'—'}` : 'Motorista / Logística'} user={user} />}
                  {transportador && (remDet.status==='pronta'||remDet.status==='a_caminho') && assinarRem===r.id && (
                    <div style={{marginTop:10}}>
                      {remDet.direta
                        ? <AssinaturaFornecedor fornecedor={remDet.fornecedor} itens={remDet.itens} atorNome={user.nome} onConfirm={p=>retirarRemessa(r.id, p)} onCancel={()=>setAssinarRem(null)} />
                        : <AssinaturaDupla tipo="retirada" atorNome={user.nome} onConfirm={p=>retirarRemessa(r.id, p)} onCancel={()=>setAssinarRem(null)} />}
                    </div>
                  )}
                  {transportador && remDet.status==='em_transporte' && assinarRem===r.id && (
                    <div style={{marginTop:10}}>
                      <textarea style={{...inp, minHeight:52, width:'100%', marginBottom:8}} placeholder="Divergência (opcional): falta, avaria, troca…" value={diverg} onChange={e=>setDiverg(e.target.value)} />
                      <AssinaturaDupla tipo="entrega" atorNome={user.nome} onConfirm={p=>entregarRemessa(r.id, p)} onCancel={()=>{setAssinarRem(null);setDiverg('')}} />
                    </div>
                  )}
                  {recebe && remDet.status==='em_transporte' && assinarRem===r.id && (
                    <div style={{marginTop:10}}>
                      <div style={{fontSize:'.78rem', color:'var(--rec-sub,#6b7280)', marginBottom:8}}>Caminho alternativo (aparelho do líder), caso o do ajudante falhe.</div>
                      <textarea style={{...inp, minHeight:52, width:'100%', marginBottom:8}} placeholder="Divergência (opcional): falta, avaria, troca…" value={diverg} onChange={e=>setDiverg(e.target.value)} />
                      <AssinaturaCustodia tipo="recebimento" label={`Recebimento — ${user.nome} (Obra)`} onConfirm={(sig,foto)=>receberRemessa(r.id, sig, foto)} onCancel={()=>{setAssinarRem(null);setDiverg('')}} />
                    </div>
                  )}
                  {remDet.divergencias && remDet.divergencias.length>0 && (
                    <div style={{marginTop:10, fontSize:'.8rem', color:'var(--tag-alerta-fg)'}}>
                      {remDet.divergencias.map((d,i)=><div key={i}>⚠️ {d.tipo}: {d.descricao} <span style={{color:'var(--silver)'}}>({d.aberta_por_nome})</span></div>)}
                    </div>
                  )}
                </>}
              </div>
            )}
          </div>
        ))}
        {fimRems}
      </>}
    </div>
  )
}

// ─── SERVIÇOS EXTRAS (mão de obra fora do escopo) ────────────────────────────
// O engenheiro registra cada envio de equipe para serviço pedido por fiscal fora do contrato:
// quem pediu, onde, o quê, quem foi, horas, fotos e o aceite assinado. Gestores (Master, Diretor,
// Gerente) acompanham no painel: horas-homem e custo estimado por fiscal, unidade, engenheiro,
// tipo e pessoa, mês a mês.
const SE_STATUS = {
  em_execucao: ['Aguardando aceite', 'tg-alerta'],
  concluido: ['Aceite assinado', 'tg-ok'],
  sem_aceite: ['Sem assinatura', 'tg-perigo'],
  cancelado: ['Cancelado', 'tg-neutro'],
}
const seStatusKey = s => s.status === 'concluido' ? (s.tem_aceite ? 'concluido' : 'sem_aceite') : s.status
function SeTag({ s }) {
  const [rot, cls] = SE_STATUS[seStatusKey(s)] || [s.status, 'tg-neutro']
  return <span className={`rtag dot ${cls}`}>{rot}</span>
}
const seFmtH = h => h == null ? '—' : `${(Math.round(Number(h) * 10) / 10).toLocaleString('pt-BR')} h`
const seHojeISO = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10) }
const SE_MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
const seMesRot = m => `${SE_MESES[Number(m.slice(5, 7)) - 1]}/${m.slice(2, 4)}`
// Períodos do filtro (de/até pela data do serviço).
function sePeriodo(p) {
  const hoje = seHojeISO()
  const [y, m] = hoje.split('-').map(Number)
  const ini = (yy, mm) => new Date(Date.UTC(yy, mm - 1, 1)).toISOString().slice(0, 10)
  const fimMes = (yy, mm) => new Date(Date.UTC(yy, mm, 0)).toISOString().slice(0, 10)
  if (p === 'mes') return { de: ini(y, m), ate: hoje }
  if (p === 'mes_ant') return { de: ini(y, m - 1), ate: fimMes(y, m - 1) }
  if (p === '3m') return { de: ini(y, m - 2), ate: hoje }
  if (p === '12m') return { de: ini(y, m - 11), ate: hoje }
  return { de: '', ate: '' }
}
const SE_PERIODOS = [['mes', 'Este mês'], ['mes_ant', 'Mês passado'], ['3m', 'Últimos 3 meses'], ['12m', 'Últimos 12 meses'], ['tudo', 'Tudo']]

// Fotos de uma etapa (antes/depois): câmera ou galeria, comprimidas no celular.
function SeFotosInput({ fotos, setFotos, max = 6, addToast }) {
  const add = async files => {
    for (const f of Array.from(files || [])) {
      try { const d = await comprimirImagem(f, 1024, 0.7); setFotos(arr => arr.length < max ? [...arr, d] : arr) }
      catch (e) { addToast(e.message, 'error') }
    }
  }
  return (
    <div style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center'}}>
      {fotos.map((f, i) => (
        <div key={i} style={{position:'relative'}}>
          <img src={f} alt="" style={{width:56, height:56, objectFit:'cover', borderRadius:8, border:'1px solid var(--border)', display:'block'}} />
          <button onClick={() => setFotos(arr => arr.filter((_, j) => j !== i))} title="Remover foto" style={{position:'absolute', top:-6, right:-6, width:20, height:20, borderRadius:'50%', border:'none', background:'var(--fill-danger)', color:'#fff', cursor:'pointer', fontSize:12, lineHeight:'20px', padding:0}}>×</button>
        </div>
      ))}
      {fotos.length < max && (
        <label className="btn btn-outline btn-sm" style={{cursor:'pointer'}}>
          <Icon name="camera" size={14}/> Foto
          <input type="file" accept="image/*" multiple style={{display:'none'}} onChange={e => { add(e.target.files); e.target.value = '' }} />
        </label>
      )}
    </div>
  )
}

// Linha de ranking do painel: nome, barra proporcional às horas (série única) e os números em texto.
function SeRanking({ titulo, linhas, vazio }) {
  const max = Math.max(1, ...linhas.map(l => l.horas || 0))
  return (
    <div className="card" style={{marginBottom:0}}>
      <div className="card-header"><span className="card-title">{titulo}</span></div>
      <div style={{padding:'4px 16px 14px'}}>
        {!linhas.length && <div className="text-muted" style={{fontSize:'.85rem', padding:'8px 0'}}>{vazio || 'Nada no período.'}</div>}
        {linhas.map((l, i) => (
          <div key={i} style={{padding:'7px 0', borderBottom: i < linhas.length - 1 ? '1px solid var(--border)' : 'none'}}>
            <div style={{display:'flex', justifyContent:'space-between', gap:10, fontSize:'.85rem'}}>
              <span style={{color:'var(--text)', fontWeight:600, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}} title={l.nome}>{l.nome}{l.cargo ? <span style={{fontWeight:400, color:'var(--text-secondary)'}}> · {l.cargo}</span> : null}</span>
              <span style={{color:'var(--text-secondary)', whiteSpace:'nowrap', fontVariantNumeric:'tabular-nums'}}><strong style={{color:'var(--text)'}}>{seFmtH(l.horas)}</strong> · {l.pedidos} pedido{l.pedidos === 1 ? '' : 's'}{l.custo > 0 ? ` · ${fmtBRL(l.custo)}` : ''}</span>
            </div>
            <div style={{height:8, marginTop:5, background:'var(--bg)', borderRadius:4}}>
              <div style={{height:8, width:`${Math.max(2, (l.horas || 0) / max * 100)}%`, background:'var(--primary-accent)', borderRadius:4}} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

// Horas-homem por mês (12 meses): colunas finas, valor no hover e no último mês.
function SeMensal({ mensal }) {
  const [hover, setHover] = useState(null)
  const max = Math.max(1, ...mensal.map(m => m.horas || 0))
  const alvo = hover != null ? mensal[hover] : mensal[mensal.length - 1]
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Horas-homem por mês</span>
        {alvo && <span style={{fontSize:'.82rem', color:'var(--text-secondary)'}}>{seMesRot(alvo.mes)}: <strong style={{color:'var(--text)'}}>{seFmtH(alvo.horas)}</strong> · {alvo.pedidos} pedido{alvo.pedidos === 1 ? '' : 's'}{alvo.custo > 0 ? ` · ${fmtBRL(alvo.custo)}` : ''}</span>}
      </div>
      <div style={{padding:'6px 16px 12px'}}>
        <div style={{display:'flex', alignItems:'flex-end', height:140, borderBottom:'1px solid var(--border)'}} onMouseLeave={() => setHover(null)}>
          {mensal.map((m, i) => (
            <div key={m.mes} onMouseEnter={() => setHover(i)} onClick={() => setHover(i)} title={`${seMesRot(m.mes)}: ${seFmtH(m.horas)} · ${m.pedidos} pedido(s)`}
              style={{flex:1, height:'100%', display:'flex', alignItems:'flex-end', justifyContent:'center', cursor:'default', background: hover === i ? 'var(--bg)' : 'transparent', borderRadius:'4px 4px 0 0'}}>
              <div style={{width:'60%', maxWidth:24, height: m.horas > 0 ? `${Math.max(3, m.horas / max * 100)}%` : 0, background:'var(--primary-accent)', borderRadius:'4px 4px 0 0'}} />
            </div>
          ))}
        </div>
        <div style={{display:'flex'}}>
          {mensal.map((m, i) => <div key={m.mes} style={{flex:1, textAlign:'center', fontSize:'.68rem', color: hover === i ? 'var(--text)' : 'var(--text-secondary)', paddingTop:4}}>{SE_MESES[Number(m.mes.slice(5, 7)) - 1]}</div>)}
        </div>
      </div>
    </div>
  )
}

function ServicosExtrasPage({ user, addToast }) {
  const gestor = user.is_master || ['diretor', 'gerente'].includes(user.role)
  const responsavel = ['engenheiro', 'lider', 'gerente'].includes(user.role)
  const [tab, setTab] = useState(gestor ? 'painel' : 'registros')
  const [periodo, setPeriodo] = useState('3m')
  const [lista, setLista] = useState(null)
  const [painel, setPainel] = useState(null)
  const [vh, setVh] = useState(null)
  const [det, setDet] = useState(null)          // registro aberto (detalhe completo)
  const [conclui, setConclui] = useState(null)  // registro sendo concluído
  const [novo, setNovo] = useState(false)
  const [ops, setOps] = useState(null)
  const [salvando, setSalvando] = useState(false)
  const [zoom, setZoom] = useState(null)       // foto ampliada

  const qs = () => { const p = sePeriodo(periodo); return `?de=${p.de}&ate=${p.ate}` }
  const carregarLista = () => GET('/servicos-extras' + qs()).then(setLista).catch(e => addToast(e.message, 'error'))
  const carregarPainel = () => gestor && GET('/servicos-extras/painel' + qs()).then(setPainel).catch(e => addToast(e.message, 'error'))
  const carregarVh = () => gestor && GET('/servicos-extras/valor-hora').then(setVh).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregarLista(); carregarPainel() }, [periodo])
  useEffect(() => { if (tab === 'valor' && !vh) carregarVh() }, [tab])

  const abrir = async id => { try { setDet(await GET('/servicos-extras/' + id)) } catch (e) { addToast(e.message, 'error') } }
  const verTermo = async id => {
    const w = window.open('', '_blank')   // abre antes do await: pop-up aberto depois de uma espera é bloqueado
    if (!w) { addToast('Permita pop-ups para ver o registro.', 'error'); return }
    try {
      const resp = await fetch('/api/servicos-extras/' + id + '/termo', { headers: { Authorization: `Bearer ${token.value}` } })
      if (!resp.ok) throw new Error('Erro ' + resp.status)
      const html = await resp.text()
      w.document.open(); w.document.write(html); w.document.close()
    } catch (e) { w.close(); addToast(e.message, 'error') }
  }
  const cancelar = async s => {
    const motivo = window.prompt(`Cancelar ${s.numero}? O registro fica guardado, mas sai das somas.\n\nMotivo:`)
    if (motivo == null) return
    try { await POST(`/servicos-extras/${s.id}/cancelar`, { motivo }); addToast('Registro cancelado.', 'success'); setDet(null); carregarLista(); carregarPainel() }
    catch (e) { addToast(e.message, 'error') }
  }
  const exportarCSV = () => {
    const col = ['Número', 'Data', 'Obra/unidade', 'Quem pediu', 'Cargo de quem pediu', 'Responsável', 'Tipo', 'Status', 'Pessoas', 'Horas-homem', 'Custo estimado', 'Serviço']
    const q = v => `"${String(v == null ? '' : v).replace(/"/g, '""').replace(/\r?\n/g, ' ')}"`
    const linhas = (lista || []).map(s => [s.numero, fmt(s.data), s.obra_nome, s.solicitante_nome, s.solicitante_cargo, s.responsavel_nome, s.tipo,
      SE_STATUS[seStatusKey(s)][0], s.pessoas, s.horas != null ? String(s.horas).replace('.', ',') : '', s.custo ? String(Math.round(s.custo * 100) / 100).replace('.', ',') : '', s.descricao].map(q).join(';'))
    const blob = new Blob(['﻿' + [col.map(q).join(';'), ...linhas].join('\r\n')], { type: 'text/csv;charset=utf-8' })
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `servicos-extras-${sePeriodo(periodo).de || 'tudo'}.csv`; a.click()
    setTimeout(() => URL.revokeObjectURL(a.href), 2000)
  }

  // ── Novo registro ──
  const F_VAZIO = () => ({ data: seHojeISO(), obra_id: '', solicitante_nome: '', solicitante_cargo: '', tipo: '', descricao: '', pessoas: [{ usuario_id: '', nome: '', cargo: '', horas: '' }] })
  const [f, setF] = useState(F_VAZIO)
  const [fotosAntes, setFotosAntes] = useState([])
  const abrirNovo = async () => {
    setNovo(true); setF(F_VAZIO()); setFotosAntes([])
    if (!ops) try { setOps(await GET('/servicos-extras/opcoes')) } catch (e) { addToast(e.message, 'error') }
  }
  const setP = (i, k, v) => setF(x => ({ ...x, pessoas: x.pessoas.map((p, j) => j === i ? { ...p, [k]: v } : p) }))
  const escolheSolicitante = nome => {
    const s = ops && ops.solicitantes.find(x => x.nome.toLowerCase() === nome.trim().toLowerCase())
    setF(x => ({ ...x, solicitante_nome: nome, solicitante_cargo: s && !x.solicitante_cargo ? (s.cargo || '') : x.solicitante_cargo }))
  }
  const registrar = async (concluirDepois) => {
    const pessoas = f.pessoas.filter(p => p.usuario_id || p.nome.trim()).map(p =>
      p.usuario_id && p.usuario_id !== 'outra' ? { usuario_id: Number(p.usuario_id), horas: p.horas } : { nome: p.nome, cargo: p.cargo, horas: p.horas })
    if (!f.obra_id) { addToast('Escolha a obra/unidade.', 'error'); return }
    if (f.solicitante_nome.trim().length < 2) { addToast('Informe quem pediu o serviço.', 'error'); return }
    if (f.descricao.trim().length < 5) { addToast('Descreva o serviço.', 'error'); return }
    if (!pessoas.length) { addToast('Informe quem foi fazer o serviço.', 'error'); return }
    setSalvando(true)
    try {
      const r = await POST('/servicos-extras', { ...f, obra_id: Number(f.obra_id), tipo: f.tipo || null, pessoas, fotos_antes: fotosAntes })
      addToast(`Serviço extra ${r.numero} registrado.`, 'success')
      setNovo(false); carregarLista(); carregarPainel()
      setOps(null)   // recarrega "quem pediu" no próximo registro
      if (concluirDepois) { const d = await GET('/servicos-extras/' + r.id); setConclui(d) }
    } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }

  // ── Concluir (horas + fotos depois + aceite) ──
  const [horas, setHoras] = useState({})
  const [fotosDepois, setFotosDepois] = useState([])
  const [aceite, setAceite] = useState({ nome: '', cargo: '' })
  const [semAssinatura, setSemAssinatura] = useState(false)
  const [recusa, setRecusa] = useState('')
  useEffect(() => {
    if (!conclui) return
    setHoras(Object.fromEntries(conclui.lista_pessoas.map(p => [p.id, p.horas != null ? String(p.horas).replace('.', ',') : ''])))
    setFotosDepois([]); setAceite({ nome: conclui.solicitante_nome || '', cargo: conclui.solicitante_cargo || '' }); setSemAssinatura(false); setRecusa('')
  }, [conclui && conclui.id])
  const horasOk = () => {
    const falta = conclui.lista_pessoas.find(p => !(Number(String(horas[p.id] || '').replace(',', '.')) > 0))
    if (falta) { addToast(`Informe as horas de ${falta.nome}.`, 'error'); return false }
    return true
  }
  const enviarConclusao = async (assinatura) => {
    if (!horasOk()) return
    if (assinatura && aceite.nome.trim().length < 2) { addToast('Informe o nome de quem assinou.', 'error'); return }
    if (!assinatura && recusa.trim().length < 5) { addToast('Diga por que não assinou (mín. 5 caracteres).', 'error'); return }
    setSalvando(true)
    try {
      await POST(`/servicos-extras/${conclui.id}/concluir`, {
        horas, fotos_depois: fotosDepois,
        ...(assinatura ? { aceite_assinatura: assinatura, aceite_nome: aceite.nome, aceite_cargo: aceite.cargo } : { recusa_motivo: recusa }),
      })
      addToast(`${conclui.numero} concluído${assinatura ? ' com aceite assinado' : ''}.`, 'success')
      const id = conclui.id
      setConclui(null); carregarLista(); carregarPainel()
      abrir(id)
    } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }

  const pendentes = (lista || []).filter(s => s.status === 'em_execucao' && s.responsavel_id === user.id)
  const opcaoPessoa = p => <option key={p.id} value={p.id}>{p.nome}{p.cargo ? ` · ${p.cargo}` : ''}{!p.minha_equipe && p.lider_nome ? ` (equipe de ${p.lider_nome})` : ''}</option>
  const t = painel && painel.totais

  return (
    <div>
      <div className="topbar"><h2>Serviços extras</h2></div>
      <p style={{color:'var(--text-secondary)', marginTop:-6, marginBottom:16, fontSize:'.9rem'}}>
        Mão de obra enviada para serviço fora do escopo do contrato, a pedido de fiscal. Cada envio fica registrado com equipe, horas, fotos e aceite de quem pediu.
      </p>

      <div className="dt-tabs" style={{margin:'0 0 14px', flexWrap:'wrap', alignItems:'center'}}>
        {gestor && <button className={`dt-tab ${tab === 'painel' ? 'on' : ''}`} onClick={() => setTab('painel')}><Icon name="trending" size={14}/> Painel</button>}
        <button className={`dt-tab ${tab === 'registros' ? 'on' : ''}`} onClick={() => setTab('registros')}><Icon name="fileText" size={14}/> {responsavel && !gestor ? 'Meus registros' : 'Registros'}</button>
        {gestor && <button className={`dt-tab ${tab === 'valor' ? 'on' : ''}`} onClick={() => setTab('valor')}><Icon name="layers" size={14}/> Valor/hora</button>}
        {tab !== 'valor' && (
          <select value={periodo} onChange={e => setPeriodo(e.target.value)} style={{marginLeft:'auto', marginBottom:6, width:'auto', padding:'6px 10px', borderRadius:8, border:'1px solid var(--border)', background:'var(--card)', color:'var(--text)', fontSize:'.85rem'}} aria-label="Período">
            {SE_PERIODOS.map(([k, r]) => <option key={k} value={k}>{r}</option>)}
          </select>
        )}
      </div>

      {tab === 'painel' && gestor && (!painel ? <div className="text-muted">Carregando…</div> : <>
        {painel.sem_valor.length > 0 && (
          <div className="alert alert-warning" style={{marginBottom:14, display:'flex', gap:10, alignItems:'center', flexWrap:'wrap'}}>
            <span><strong>Custo subestimado:</strong> {painel.sem_valor.map(s => `${seFmtH(s.horas)} de ${s.cargo || 'função não informada'}`).join(', ')} sem valor/hora.</span>
            <button className="btn btn-outline btn-sm" onClick={() => setTab('valor')}>Cadastrar valor/hora</button>
          </div>
        )}
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-label">Pedidos</div><div className="stat-value">{t.pedidos}</div></div>
          <div className="stat-card blue"><div className="stat-label">Horas-homem</div><div className="stat-value">{seFmtH(t.horas)}</div></div>
          <div className="stat-card"><div className="stat-label">Custo estimado</div><ValorCard v={t.custo || 0} /></div>
          <div className="stat-card green"><div className="stat-label">Com aceite assinado</div><div className="stat-value">{t.concluidos ? `${Math.round(t.com_aceite / t.concluidos * 100)}%` : '—'}</div><div style={{fontSize:'.74rem', color:'var(--text-secondary)'}}>{t.com_aceite} de {t.concluidos} concluído(s)</div></div>
          <div className="stat-card"><div className="stat-label">Aguardando aceite</div><div className="stat-value">{t.em_execucao}</div></div>
        </div>
        <SeMensal mensal={painel.mensal} />
        <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(min(300px,100%),1fr))', gap:14, marginBottom:16}}>
          <SeRanking titulo="Por quem pediu" linhas={painel.por_fiscal} />
          <SeRanking titulo="Por obra / unidade" linhas={painel.por_obra} />
          <SeRanking titulo="Por engenheiro responsável" linhas={painel.por_responsavel} />
          <SeRanking titulo="Por pessoa enviada" linhas={painel.por_pessoa} />
          <SeRanking titulo="Por tipo de serviço" linhas={painel.por_tipo} />
        </div>
      </>)}

      {tab === 'registros' && <>
        {pendentes.length > 0 && (
          <div className="pending-banner">
            <div><div className="msg" style={{display:'flex', alignItems:'center', gap:6}}><Icon name="alertTriangle" size={15}/> {pendentes.length} envio(s) aguardando conclusão</div>
              <div style={{fontSize:'.85rem', marginTop:4, color:'var(--tag-alerta-fg)'}}>Informe as horas e colha a assinatura de quem pediu.</div></div>
          </div>
        )}
        <div style={{display:'flex', gap:8, flexWrap:'wrap', marginBottom:14}}>
          {responsavel && !novo && <button className="btn btn-accent" onClick={abrirNovo}><Icon name="plus" size={14}/> Registrar serviço extra</button>}
          {gestor && (lista || []).length > 0 && <button className="btn btn-outline" onClick={exportarCSV}><Icon name="download" size={14}/> Exportar planilha</button>}
        </div>

        {novo && (
          <div className="card">
            <div className="card-header"><span className="card-title">Registrar serviço extra</span></div>
            <div className="card-body">
              {!ops ? <div className="text-muted">Carregando…</div> : <>
                <div className="form-grid">
                  <div className="form-group"><label>Data do serviço *</label><input type="date" value={f.data} max={seHojeISO()} onChange={e => setF({ ...f, data: e.target.value })} /></div>
                  <div className="form-group"><label>Obra / unidade *</label>
                    <select value={f.obra_id} onChange={e => setF({ ...f, obra_id: e.target.value })}>
                      <option value="">Selecione…</option>
                      {ops.obras.some(o => o.minha) && <optgroup label="Minhas obras">{ops.obras.filter(o => o.minha).map(o => <option key={o.id} value={o.id}>{o.nome}</option>)}</optgroup>}
                      <optgroup label={ops.obras.some(o => o.minha) ? 'Outras obras do contrato' : 'Obras do contrato'}>{ops.obras.filter(o => !o.minha).map(o => <option key={o.id} value={o.id}>{o.nome}</option>)}</optgroup>
                    </select></div>
                  <div className="form-group"><label>Quem pediu *</label>
                    <input list="se-solicitantes" value={f.solicitante_nome} onChange={e => escolheSolicitante(e.target.value)} placeholder="Nome do fiscal" maxLength={120} />
                    <datalist id="se-solicitantes">{ops.solicitantes.map(s => <option key={s.nome} value={s.nome}>{s.cargo || ''}</option>)}</datalist></div>
                  <div className="form-group"><label>Cargo / órgão de quem pediu</label><input value={f.solicitante_cargo} onChange={e => setF({ ...f, solicitante_cargo: e.target.value })} placeholder="Fiscal da contratante" maxLength={120} /></div>
                  <div className="form-group"><label>Tipo</label>
                    <select value={f.tipo} onChange={e => setF({ ...f, tipo: e.target.value })}><option value="">—</option>{ops.tipos.map(x => <option key={x}>{x}</option>)}</select></div>
                  <div className="form-group full"><label>O que foi pedido / feito *</label><textarea rows={3} value={f.descricao} onChange={e => setF({ ...f, descricao: e.target.value })} placeholder="Trocar 6 luminárias da recepção" maxLength={2000} /></div>
                </div>
                <div style={{marginTop:14}}>
                  <label style={{fontSize:'.82rem', fontWeight:600, color:'var(--text-secondary)'}}>Quem foi *</label>
                  {f.pessoas.map((p, i) => (
                    <div key={i} style={{display:'flex', gap:8, flexWrap:'wrap', alignItems:'center', marginTop:8}}>
                      <select value={p.usuario_id} onChange={e => setP(i, 'usuario_id', e.target.value)} style={{flex:'2 1 220px'}}>
                        <option value="">Selecione…</option>
                        {ops.pessoas.some(x => x.minha_equipe) && <optgroup label="Minha equipe">{ops.pessoas.filter(x => x.minha_equipe).map(opcaoPessoa)}</optgroup>}
                        {ops.pessoas.some(x => !x.minha_equipe) && <optgroup label="Outras equipes">{ops.pessoas.filter(x => !x.minha_equipe).map(opcaoPessoa)}</optgroup>}
                        <option value="outra">Outra pessoa (sem conta no sistema)…</option>
                      </select>
                      {p.usuario_id === 'outra' && <input value={p.nome} onChange={e => setP(i, 'nome', e.target.value)} placeholder="Nome" style={{flex:'1 1 140px'}} maxLength={120} />}
                      {p.usuario_id === 'outra' && <input value={p.cargo} onChange={e => setP(i, 'cargo', e.target.value)} placeholder="Função" style={{flex:'1 1 110px'}} maxLength={60} />}
                      <input value={p.horas} onChange={e => setP(i, 'horas', e.target.value)} inputMode="decimal" placeholder="horas" title="Horas trabalhadas (pode informar depois)" style={{width:80}} />
                      <button className="btn btn-ghost btn-sm" title="Remover" onClick={() => setF(x => ({ ...x, pessoas: x.pessoas.length > 1 ? x.pessoas.filter((_, j) => j !== i) : x.pessoas }))}>×</button>
                    </div>
                  ))}
                  <button className="btn btn-outline btn-sm" style={{marginTop:8}} onClick={() => setF(x => ({ ...x, pessoas: [...x.pessoas, { usuario_id: '', nome: '', cargo: '', horas: '' }] }))}><Icon name="plus" size={13}/> pessoa</button>
                  <div style={{fontSize:'.76rem', color:'var(--text-secondary)', marginTop:6}}>As horas podem ser informadas agora ou na conclusão.</div>
                </div>
                <div style={{marginTop:14}}>
                  <label style={{fontSize:'.82rem', fontWeight:600, color:'var(--text-secondary)', display:'block', marginBottom:6}}>Fotos — antes (opcional)</label>
                  <SeFotosInput fotos={fotosAntes} setFotos={setFotosAntes} addToast={addToast} />
                </div>
                <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:16}}>
                  <button className="btn btn-primary" disabled={salvando} onClick={() => registrar(false)}>Registrar envio</button>
                  <button className="btn btn-accent" disabled={salvando} onClick={() => registrar(true)}><Icon name="signature" size={14}/> Registrar e colher aceite agora</button>
                  <button className="btn btn-ghost" onClick={() => setNovo(false)}>Cancelar</button>
                </div>
              </>}
            </div>
          </div>
        )}

        <div className="card">
          <div className="table-wrap"><table className="cards-mobile">
            <thead><tr><th>Número</th><th>Data</th><th>Obra / unidade</th><th>Quem pediu</th>{gestor && <th>Responsável</th>}<th>Equipe</th><th>Status</th></tr></thead>
            <tbody>
              {lista == null && <tr><td colSpan={7} className="text-muted" style={{textAlign:'center', padding:20}}>Carregando…</td></tr>}
              {lista && !lista.length && <tr><td colSpan={7} className="text-muted" style={{textAlign:'center', padding:20}}>Nenhum serviço extra no período.</td></tr>}
              {(lista || []).map(s => (
                <tr key={s.id} onClick={() => abrir(s.id)} style={{cursor:'pointer', opacity: s.status === 'cancelado' ? .6 : 1}}>
                  <td className="fw-bold" data-label="Número" style={{fontFamily:'ui-monospace,SFMono-Regular,Menlo,monospace'}}>{s.numero}</td>
                  <td data-label="Data">{fmt(s.data)}</td>
                  <td data-label="Obra">{s.obra_nome || '—'}</td>
                  <td data-label="Quem pediu">{s.solicitante_nome}{s.solicitante_cargo ? <div style={{fontSize:'.74rem', color:'var(--text-secondary)'}}>{s.solicitante_cargo}</div> : null}</td>
                  {gestor && <td data-label="Responsável">{s.responsavel_nome || '—'}</td>}
                  <td data-label="Equipe">{s.pessoas} pessoa{s.pessoas === 1 ? '' : 's'} · {seFmtH(s.horas)}</td>
                  <td data-label="Status"><SeTag s={s} /></td>
                </tr>
              ))}
            </tbody>
          </table></div>
        </div>
      </>}

      {tab === 'valor' && gestor && <SeValorHora vh={vh} recarregar={() => { carregarVh(); carregarPainel(); carregarLista() }} addToast={addToast} />}

      {det && (
        <div className="modal-overlay open" onClick={e => { if (e.target === e.currentTarget) setDet(null) }}>
          <div className="modal">
            <div className="modal-header">
              <h3 style={{display:'flex', alignItems:'center', gap:8, flexWrap:'wrap'}}><Icon name="worker" size={17}/> {det.numero} <SeTag s={det} /></h3>
              <button className="modal-close" onClick={() => setDet(null)}>×</button>
            </div>
            <div className="modal-body">
              <div style={{display:'grid', gridTemplateColumns:'minmax(0,150px) minmax(0,1fr)', gap:'6px 12px', fontSize:'.88rem', overflowWrap:'anywhere'}}>
                <span className="text-muted">Data</span><span>{fmt(det.data)}</span>
                <span className="text-muted">Obra / unidade</span><span>{det.obra_nome || '—'}</span>
                <span className="text-muted">Quem pediu</span><span>{det.solicitante_nome}{det.solicitante_cargo ? ` — ${det.solicitante_cargo}` : ''}</span>
                <span className="text-muted">Responsável</span><span>{det.responsavel_nome || '—'}</span>
                {det.tipo && <><span className="text-muted">Tipo</span><span>{det.tipo}</span></>}
                <span className="text-muted">Serviço</span><span style={{whiteSpace:'pre-wrap'}}>{det.descricao}</span>
              </div>
              <div style={{marginTop:14, fontWeight:600, fontSize:'.85rem'}}>Equipe</div>
              <table style={{width:'100%', fontSize:'.86rem', marginTop:4}}>
                <tbody>
                  {det.lista_pessoas.map(p => <tr key={p.id}><td style={{padding:'4px 0'}}>{p.nome}{p.cargo ? <span className="text-muted"> · {p.cargo}</span> : null}</td><td style={{textAlign:'right', fontVariantNumeric:'tabular-nums'}}>{seFmtH(p.horas)}</td></tr>)}
                  <tr><td style={{padding:'6px 0', borderTop:'1px solid var(--border)', fontWeight:600}}>Total</td><td style={{textAlign:'right', borderTop:'1px solid var(--border)', fontWeight:600}}>{seFmtH(det.horas)}{gestor && det.custo > 0 ? ` · ${fmtBRL(det.custo)}` : ''}</td></tr>
                </tbody>
              </table>
              {[['Fotos — antes', det.fotos_antes], ['Fotos — depois', det.fotos_depois]].filter(([, a]) => a.length).map(([tit, a]) => (
                <div key={tit} style={{marginTop:12}}>
                  <div style={{fontWeight:600, fontSize:'.85rem', marginBottom:6}}>{tit}</div>
                  <div style={{display:'flex', gap:8, flexWrap:'wrap'}}>{a.map((src, i) => <img key={i} src={src} alt={tit} title="Ampliar" onClick={() => setZoom(src)} style={{width:84, height:84, objectFit:'cover', borderRadius:8, border:'1px solid var(--border)', cursor:'zoom-in'}} />)}</div>
                </div>
              ))}
              {det.status === 'concluido' && (det.aceite_assinatura
                ? <div style={{marginTop:14, padding:12, border:'1px solid var(--border)', borderRadius:10, background:'var(--bg)'}}>
                    <div style={{fontSize:'.8rem', color:'var(--text-secondary)'}}>Aceite assinado por</div>
                    <div style={{fontWeight:600}}>{det.aceite_nome}{det.aceite_cargo ? ` — ${det.aceite_cargo}` : ''}</div>
                    <img src={det.aceite_assinatura} alt="assinatura" style={{maxHeight:70, marginTop:6, background:'#fff', borderRadius:6}} />
                    <div style={{fontSize:'.74rem', color:'var(--text-secondary)'}}>{fmt(String(det.concluido_em || '').slice(0, 10))} {String(det.concluido_em || '').slice(11, 16)}</div>
                  </div>
                : <div className="alert alert-warning" style={{marginTop:14}}><strong>Quem pediu não assinou.</strong> Motivo: {det.recusa_motivo}</div>)}
              {det.status === 'cancelado' && <div className="alert alert-error" style={{marginTop:14}}>Cancelado em {fmt(String(det.cancelado_em || '').slice(0, 10))}{det.cancelado_por_nome ? ` por ${det.cancelado_por_nome}` : ''}: {det.cancelado_motivo}</div>}
            </div>
            <div className="modal-footer">
              {((det.responsavel_id === user.id && det.status === 'em_execucao') || (user.is_master && !user.admin && !user.ceo && det.status !== 'cancelado')) &&
                <button className="btn btn-ghost" style={{color:'var(--danger)'}} onClick={() => cancelar(det)}>Cancelar registro</button>}
              <button className="btn btn-outline" onClick={() => verTermo(det.id)}><Icon name="fileText" size={14}/> Ver registro para impressão</button>
              {det.responsavel_id === user.id && det.status === 'em_execucao' && <button className="btn btn-accent" onClick={() => { setConclui(det); setDet(null) }}><Icon name="signature" size={14}/> Concluir e colher aceite</button>}
            </div>
          </div>
        </div>
      )}

      {zoom && (
        <div className="foto-lightbox" onClick={() => setZoom(null)}>
          <img src={zoom} alt="foto ampliada" onClick={e => e.stopPropagation()} />
          <button className="foto-lightbox-x" onClick={() => setZoom(null)}><Icon name="x" size={20} /></button>
        </div>
      )}

      {conclui && (
        <div className="modal-overlay open">
          <div className="modal">
            <div className="modal-header">
              <h3 style={{display:'flex', alignItems:'center', gap:8}}><Icon name="signature" size={17}/> Concluir {conclui.numero}</h3>
              <button className="modal-close" onClick={() => setConclui(null)}>×</button>
            </div>
            <div className="modal-body">
              <div style={{fontSize:'.85rem', color:'var(--text-secondary)', marginBottom:10}}>{conclui.obra_nome} · pedido por {conclui.solicitante_nome} · {fmt(conclui.data)}</div>
              <div style={{fontWeight:600, fontSize:'.85rem'}}>Horas de cada pessoa *</div>
              {conclui.lista_pessoas.map(p => (
                <div key={p.id} style={{display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, padding:'6px 0', borderBottom:'1px solid var(--border)'}}>
                  <span style={{fontSize:'.88rem'}}>{p.nome}{p.cargo ? <span className="text-muted"> · {p.cargo}</span> : null}</span>
                  <input value={horas[p.id] || ''} onChange={e => setHoras(h => ({ ...h, [p.id]: e.target.value }))} inputMode="decimal" placeholder="horas" style={{width:90}} />
                </div>
              ))}
              <div style={{marginTop:14}}>
                <div style={{fontWeight:600, fontSize:'.85rem', marginBottom:6}}>Fotos — depois (opcional)</div>
                <SeFotosInput fotos={fotosDepois} setFotos={setFotosDepois} addToast={addToast} />
              </div>
              <div style={{marginTop:16, paddingTop:12, borderTop:'1px solid var(--border)'}}>
                {!semAssinatura ? <>
                  <div className="form-grid">
                    <div className="form-group"><label>Nome de quem assina *</label><input value={aceite.nome} onChange={e => setAceite({ ...aceite, nome: e.target.value })} maxLength={120} /></div>
                    <div className="form-group"><label>Cargo / órgão</label><input value={aceite.cargo} onChange={e => setAceite({ ...aceite, cargo: e.target.value })} maxLength={120} /></div>
                  </div>
                  <div style={{fontSize:'.8rem', color:'var(--text-secondary)', margin:'10px 0 4px'}}>Ao assinar, quem pediu confirma que solicitou o serviço e que ele foi feito pela equipe acima, nas horas indicadas.</div>
                  {salvando ? <div className="text-muted" style={{padding:12}}>Enviando…</div>
                    : <SignaturePad label="Assinatura de quem pediu o serviço" onConfirm={enviarConclusao} onCancel={() => setConclui(null)} />}
                  <button className="btn btn-ghost btn-sm" style={{marginTop:8}} onClick={() => setSemAssinatura(true)}>Quem pediu não vai assinar</button>
                </> : <>
                  <div className="form-group"><label>Por que não assinou? *</label><textarea rows={3} value={recusa} onChange={e => setRecusa(e.target.value)} placeholder="Fiscal não estava no local na conclusão" maxLength={500} /></div>
                  <div style={{fontSize:'.78rem', color:'var(--text-secondary)', marginTop:6}}>O registro fica marcado como "sem assinatura" no painel.</div>
                  <div style={{display:'flex', gap:8, marginTop:12, flexWrap:'wrap'}}>
                    <button className="btn btn-primary" disabled={salvando} onClick={() => enviarConclusao(null)}>Concluir sem assinatura</button>
                    <button className="btn btn-ghost" onClick={() => setSemAssinatura(false)}>Voltar para a assinatura</button>
                  </div>
                </>}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// Valor/hora por função: base do custo estimado do painel (custo interno — não sai no registro impresso).
function SeValorHora({ vh, recarregar, addToast }) {
  const [edit, setEdit] = useState({})
  const [nova, setNova] = useState({ cargo: '', valor: '' })
  if (!vh) return <div className="text-muted">Carregando…</div>
  const salvar = async (cargo, valor) => {
    try { await PUT('/servicos-extras/valor-hora', { cargo, valor }); addToast('Valor/hora salvo.', 'success'); setEdit({}); setNova({ cargo: '', valor: '' }); recarregar() }
    catch (e) { addToast(e.message, 'error') }
  }
  return (
    <div className="card">
      <div className="card-header"><span className="card-title">Valor/hora por função</span></div>
      <div className="card-body">
        <p style={{fontSize:'.85rem', color:'var(--text-secondary)', marginTop:0}}>Custo estimado de uma hora de cada função (salário + encargos). Usado só no painel; não aparece no registro impresso.{!vh.pode_editar && ' Só o Master e o Diretor alteram.'}</p>
        <div className="table-wrap"><table>
          <thead><tr><th>Função</th><th style={{textAlign:'right'}}>Horas registradas</th><th style={{textAlign:'right'}}>Valor/hora</th>{vh.pode_editar && <th></th>}</tr></thead>
          <tbody>
            {!vh.funcoes.length && <tr><td colSpan={4} className="text-muted" style={{textAlign:'center', padding:16}}>Nenhuma função ainda.</td></tr>}
            {vh.funcoes.map(fn => {
              const ed = edit[fn.cargo_chave]
              return (
                <tr key={fn.cargo_chave}>
                  <td>{fn.cargo}</td>
                  <td style={{textAlign:'right', fontVariantNumeric:'tabular-nums'}}>{fn.horas ? seFmtH(fn.horas) : '—'}</td>
                  <td style={{textAlign:'right'}}>
                    {ed != null
                      ? <input autoFocus value={ed} onChange={e => setEdit({ [fn.cargo_chave]: e.target.value })} inputMode="decimal" placeholder="R$/h" style={{width:100, textAlign:'right'}} onKeyDown={e => e.key === 'Enter' && salvar(fn.cargo, ed)} />
                      : fn.valor != null ? fmtBRL(fn.valor) : <span style={{color:'var(--tag-alerta-fg)'}}>sem valor</span>}
                  </td>
                  {vh.pode_editar && <td style={{textAlign:'right', whiteSpace:'nowrap'}}>
                    {ed != null
                      ? <><button className="btn btn-primary btn-sm" onClick={() => salvar(fn.cargo, ed)}>Salvar</button> <button className="btn btn-ghost btn-sm" onClick={() => setEdit({})}>×</button></>
                      : <button className="btn btn-outline btn-sm" onClick={() => setEdit({ [fn.cargo_chave]: fn.valor != null ? String(fn.valor).replace('.', ',') : '' })}>{fn.valor != null ? 'Alterar' : 'Definir'}</button>}
                  </td>}
                </tr>
              )
            })}
          </tbody>
        </table></div>
        {vh.pode_editar && (
          <div style={{display:'flex', gap:8, flexWrap:'wrap', marginTop:12, alignItems:'center'}}>
            <input value={nova.cargo} onChange={e => setNova({ ...nova, cargo: e.target.value })} placeholder="Outra função (ex.: Ajudante)" maxLength={60} style={{flex:'1 1 200px'}} />
            <input value={nova.valor} onChange={e => setNova({ ...nova, valor: e.target.value })} inputMode="decimal" placeholder="R$/h" style={{width:100}} />
            <button className="btn btn-outline btn-sm" onClick={() => nova.cargo.trim() && salvar(nova.cargo, nova.valor)}>Adicionar</button>
          </div>
        )}
      </div>
    </div>
  )
}

// ─── SIDEBAR ──────────────────────────────────────────────────────────────────
// Favoritos do sidebar — cada pessoa fixa no topo as abas que mais usa (padrão "starred"
// do Slack). Persiste por usuário no localStorage; some no logout do navegador só se ele
// limpar os dados. Ordem = ordem de fixação, reordenável arrastando no desktop.
const favsKey = u => 'cf_favs_' + ((u && u.id) || 'x')
const lerFavs = u => { try { return JSON.parse(localStorage.getItem(favsKey(u)) || '[]') } catch { return [] } }
const salvarFavs = (u, arr) => { try { localStorage.setItem(favsKey(u), JSON.stringify(arr)) } catch {} }

// Menu do usuário (abas visíveis para o papel/módulos dele). Fonte única — usada pelo
// Sidebar e pela busca global (Cmd+K) para sugerir "Ir para <aba>". Não inclui o override
// multicontrato (que o Sidebar aplica por cima).
// ─── DIÁRIO DE OBRA (RDO) — Fase 3: telas ─────────────────────────────────────
// Aba "Diário de obra": seletor (contrato e o RDO do contrato ou de uma obra — D2: o padrão é o do contrato), calendário
// do mês com a situação de cada dia e o editor mobile-first em blocos. O servidor decide tudo (prazo D6, quem lança e
// assina D1, visão por papel); a tela só esconde o que a pessoa não pode fazer. Sinal ruim: o que foi digitado fica no
// aparelho (localStorage) até salvar. No RDO do contrato, cada engenheiro salva a SEÇÃO da unidade dele (o servidor
// troca só aquelas linhas); "Todas" grava o RDO inteiro, conferindo que ninguém salvou no meio.
const RDO_CLIMAS = [['bom', 'Bom'], ['nublado', 'Nublado'], ['chuva', 'Chuva'], ['impraticavel', 'Impraticável']]
const RDO_CONDICOES = [['normal', 'Normal'], ['parcial', 'Parcial'], ['impraticavel', 'Impraticável']]
const RDO_ATIV = [['executada', 'Executada', 'ok'], ['parcial', 'Parcial'], ['nao_executada', 'Não executada', 'no']]
const RDO_OCORR = [['impedimento', 'Impedimento'], ['chuva', 'Chuva'], ['falta_material', 'Falta de material'], ['falta_mao_obra', 'Falta de mão de obra'],
  ['acidente', 'Acidente'], ['quase_acidente', 'Quase acidente'], ['seguranca', 'Segurança'], ['qualidade', 'Qualidade'], ['pedido_fiscal', 'Pedido do fiscal'],
  ['visita', 'Visita'], ['outro', 'Outro']]
const RDO_STATUS_TXT = { rascunho: 'Rascunho', assinado: 'Assinado', retificado: 'Retificado', cancelado: 'Cancelado' }
const RDO_STATUS_TAG = { rascunho: 'var(--tag-alerta-bg);color:var(--tag-alerta-fg)', assinado: 'var(--tag-ok-bg);color:var(--tag-ok-fg)' }
const RDO_DIA_TXT = { sem_rdo: '', rascunho: 'Rasc.', assinado: 'Assinado', sem_expediente: 'Sem exp.', futuro: '' }
// Contrato que fecha por confirmação (sem assinatura desenhada): "Fechado" no lugar de "Assinado".
const rdoTxtFechado = conf => (conf ? 'Fechado' : 'Assinado')
// Dia do calendário: o rótulo do RDO assinado vem do PRÓPRIO registro (sem imagem = fechado por confirmação), não do modo
// de hoje do contrato — trocar o modo depois não muda o que um dia já fechado diz.
const rdoDiaTxt = x => (x.situacao === 'assinado' ? rdoTxtFechado(!!(x.rdo && x.rdo.sem_desenho)) : RDO_DIA_TXT[x.situacao])

// Configuração do diário por contrato (gestor): quem fecha o RDO do contrato, como fecha e se colhe o ciente do fiscal.
// Dados do contrato no documento (Fase 4, D10): contratada (empresa do grupo), contratante, nº/objeto/processo, registro
// e ART do responsável técnico e quem fiscaliza (com portaria e período). Cada dado é gravado onde mora (o servidor sabe:
// no contrato de manutenção, nº/objeto/processo/contratante são os mesmos da configuração do Cronograma). O RDO copia
// tudo na assinatura: mudar aqui não muda RDO já fechado.
const rdoDiaSoma = (d, n) => { const x = new Date(d + 'T12:00:00Z'); x.setUTCDate(x.getUTCDate() + n); return x.toISOString().slice(0, 10) }
const RDO_FISCAL_FUNCAO = { gestor: 'Gestor do contrato', fiscal: 'Fiscal', fiscal_substituto: 'Fiscal substituto', representante: 'Representante do contratante' }
function RdoDadosContrato({ cid, cfg, addToast, onSalvo }) {
  const l = cfg.legal || {}
  const inicial = () => ({ empresa_id: l.contratada && l.contratada.empresa_id ? String(l.contratada.empresa_id) : '', contratante: l.contratante || '',
    contratante_cnpj: l.contratante_cnpj || '', contratante_publico: l.contratante_publico == null ? '' : String(l.contratante_publico),
    contrato_numero: l.contrato_numero || '', contrato_objeto: l.contrato_objeto || '', contrato_processo: l.contrato_processo || '',
    responsavel_registro: l.responsavel_registro || '', responsavel_art: l.responsavel_art || '' })
  const [aberto, setAberto] = useState(false)
  const [f, setF] = useState(inicial)
  const [busy, setBusy] = useState(false)
  const [novaEmp, setNovaEmp] = useState(null)       // { razao_social, cnpj }
  const [novoFiscal, setNovoFiscal] = useState(null) // { nome, funcao, cargo, portaria, desde }
  const [encerrar, setEncerrar] = useState(null)     // { id, ate }
  const [base, setBase] = useState(null)             // o gravado quando o formulário abriu: o salvar manda só o que mudou desde então
  const abrir = () => { const i = inicial(); setBase(i); setF(i); setAberto(true) }
  // Recarregou do servidor (salvou, incluiu fiscal, cadastrou empresa): com o formulário aberto, o que está sendo
  // digitado fica; fechado, ele parte do gravado.
  useEffect(() => { if (!aberto) setF(inicial()) }, [cfg, aberto])
  const falta = l.faltando || []
  const lim = l.limites || { contratante: 160, contrato_numero: 60, contrato_objeto: 600, contrato_processo: 60 }
  // Registro e ART são do técnico do contrato: gravados para outra pessoa (o técnico mudou), não saem no RDO.
  const registroDeOutro = !!(l.responsavel_registro || l.responsavel_art) && !l.registro_valido
  const tecnicoInvalido = !!cfg.responsavel_tecnico_id && !cfg.responsavel_tecnico_valido
  // Novo fiscal: começa no dia seguinte ao último período encerrado (a troca não sobrepõe dois no mesmo dia); sem
  // ninguém encerrado (ex.: completar a portaria de quem veio do Cronograma), sem data.
  const ultimoFim = (cfg.fiscais || []).map(x => x.ate).filter(Boolean).sort().pop()
  const publico = f.contratante_publico !== '0'
  const vigentes = (cfg.fiscais || []).filter(x => !x.ate || x.ate >= (cfg.hoje || '')).length
  const salvar = async () => {
    const ini = base || inicial(), corpo = {}
    for (const k of Object.keys(ini)) if (f[k] !== ini[k])
      corpo[k] = k === 'contratante_publico' ? (f[k] === '' ? null : Number(f[k])) : k === 'empresa_id' ? (f[k] ? Number(f[k]) : null) : f[k]
    // Registro/ART gravados para outra pessoa: salvar confirma os do formulário para o técnico atual (mesmo sem mudar o texto).
    if (registroDeOutro && !tecnicoInvalido && (f.responsavel_registro || f.responsavel_art)) Object.assign(corpo, { responsavel_registro: f.responsavel_registro, responsavel_art: f.responsavel_art })
    if (!Object.keys(corpo).length) { addToast('Nada mudou.', 'info'); setAberto(false); return }
    setBusy(true)
    try { await PUT(`/rdo/config/${cid}/legal`, corpo); addToast('Dados do contrato salvos.', 'success'); setAberto(false); onSalvo() }
    catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const criarEmpresa = async () => {
    setBusy(true)
    try {
      const r = await POST('/empresas', novaEmp)
      addToast('Empresa cadastrada — salve os dados para usá-la neste contrato.', 'success'); setNovaEmp(null)
      setF(x => ({ ...x, empresa_id: String(r.id) })); onSalvo()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const incluirFiscal = async () => {
    setBusy(true)
    try { await POST(`/rdo/config/${cid}/fiscais`, { ...novoFiscal, desde: novoFiscal.desde || null }); addToast('Incluído.', 'success'); setNovoFiscal(null); onSalvo() }
    catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const encerrarFiscal = async () => {
    setBusy(true)
    try { await POST(`/rdo/config/${cid}/fiscais/${encerrar.id}/encerrar`, { ate: encerrar.ate }); addToast('Período encerrado.', 'success'); setEncerrar(null); onSalvo() }
    catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const excluirFiscal = async x => {
    if (!window.confirm(`Excluir "${x.nome}" (lançado por engano)? RDOs já fechados não mudam.`)) return
    try { await DEL(`/rdo/config/${cid}/fiscais/${x.id}`); addToast('Excluído.', 'success'); onSalvo() } catch (e) { addToast(e.message, 'error') }
  }
  const periodo = x => (x.desde || x.ate ? `${x.desde ? estData(x.desde) : 'início não informado'} a ${x.ate ? estData(x.ate) : 'hoje'}` : 'período não informado')
  const empresaTxt = l.contratada ? `${l.contratada.razao_social || '—'}${l.contratada.cnpj ? ` — CNPJ ${l.contratada.cnpj}` : ''}` : '—'
  return (
    <div style={{ borderTop: '1px solid var(--border)', marginTop: 12, paddingTop: 12 }}>
      <div className="rdo-linha-top"><span className="nm">Dados do contrato no documento
        <span className="sub">{empresaTxt} · {l.contrato_numero ? `contrato nº ${l.contrato_numero}` : 'sem nº do contrato'} · {vigentes === 1 ? '1 pessoa' : `${vigentes} pessoas`} na fiscalização</span></span>
        {!aberto && <button className="btn btn-ghost btn-sm" onClick={abrir}><Icon name="edit" size={14} /> {falta.length ? 'Completar' : 'Alterar'}</button>}</div>
      {falta.length > 0 && <div className="rdo-falta">Para o documento valer como prova, falta: {falta.join(', ')}. O RDO fecha assim mesmo e registra o que faltava.</div>}
      {aberto && <div className="form-grid" style={{ marginTop: 10 }}>
        <div className="form-group full"><label>Contratada (empresa do grupo que assina o contrato)</label>
          <select value={f.empresa_id} onChange={e => setF({ ...f, empresa_id: e.target.value })}>
            <option value="">Padrão do sistema{l.contratada && l.contratada.origem === 'env' ? ` — ${l.contratada.razao_social}` : ''}</option>
            {(cfg.empresas || []).map(e => <option key={e.id} value={e.id}>{e.razao_social} — {e.cnpj}</option>)}</select>
          {cfg.pode_empresas ? (novaEmp ? <div className="rdo-inline" style={{ marginTop: 6 }}>
              <input placeholder="Razão social" value={novaEmp.razao_social} maxLength={200} onChange={e => setNovaEmp({ ...novaEmp, razao_social: e.target.value })} style={{ flex: '2 1 200px' }} />
              <input placeholder="CNPJ" inputMode="numeric" value={novaEmp.cnpj} onChange={e => setNovaEmp({ ...novaEmp, cnpj: e.target.value })} style={{ flex: '1 1 150px' }} />
              <button className="btn btn-primary btn-sm" disabled={busy} onClick={criarEmpresa}>Cadastrar</button>
              <button className="btn btn-ghost btn-sm" onClick={() => setNovaEmp(null)}>Cancelar</button></div>
            : <button className="btn btn-ghost btn-sm" style={{ marginTop: 6, alignSelf: 'flex-start' }} onClick={() => setNovaEmp({ razao_social: '', cnpj: '' })}><Icon name="plus" size={14} /> Nova empresa</button>)
            : <span className="est-sub">Empresa que não está na lista: peça ao Master ou ao Diretor para cadastrar.</span>}</div>
        <div className="form-group full"><label>Contratante (órgão ou empresa)</label>
          <input value={f.contratante} maxLength={lim.contratante} onChange={e => setF({ ...f, contratante: e.target.value })} placeholder="Ex.: Fundação Municipal de Saúde" />
          {l.cliente_e_a_contratada && !l.contratante ? <span className="est-sub">O cadastro do contrato tinha a própria empresa como cliente — informe aqui quem contratou.</span> : null}</div>
        <div className="form-group"><label>CNPJ do contratante</label><input inputMode="numeric" value={f.contratante_cnpj} onChange={e => setF({ ...f, contratante_cnpj: e.target.value })} /></div>
        <div className="form-group"><label>Contratante é</label>
          <RdoSeg opcoes={[['1', 'Público'], ['0', 'Privado']]} valor={f.contratante_publico} onChange={v => setF({ ...f, contratante_publico: v || '' })} limpar /></div>
        <div className="form-group"><label>Nº do contrato</label><input value={f.contrato_numero} maxLength={lim.contrato_numero} onChange={e => setF({ ...f, contrato_numero: e.target.value })} /></div>
        <div className="form-group"><label>Processo administrativo</label><input value={f.contrato_processo} maxLength={lim.contrato_processo} onChange={e => setF({ ...f, contrato_processo: e.target.value })} /></div>
        <div className="form-group full"><label>Objeto do contrato</label><textarea rows={3} value={f.contrato_objeto} maxLength={lim.contrato_objeto} onChange={e => setF({ ...f, contrato_objeto: e.target.value })} />
          {l.casa && l.casa.numero === 'manut' && <span className="est-sub">Nº, objeto, processo e contratante são os mesmos da configuração do Cronograma deste contrato (um cadastro só).</span>}</div>
        {registroDeOutro && <div className="rdo-falta" style={{ gridColumn: '1 / -1' }}>{tecnicoInvalido
          ? `O responsável técnico do contrato${cfg.responsavel_tecnico_nome ? ` (${cfg.responsavel_tecnico_nome})` : ''} não vale mais (inativo ou fora do contrato): escolha outro em “Configurar o diário”. O registro e a ART não saem no RDO até lá.`
          : `O registro e a ART abaixo foram informados para ${l.registro_de_nome || 'outra pessoa'}, que não é o responsável técnico atual: não saem no RDO. Confira e salve os do técnico atual.`}</div>}
        <div className="form-group"><label>Registro do responsável técnico{cfg.responsavel_tecnico_nome && cfg.responsavel_tecnico_valido ? ` (${cfg.responsavel_tecnico_nome})` : ''}</label><input value={f.responsavel_registro} maxLength={60} placeholder="Ex.: CREA-RJ 2012345678" onChange={e => setF({ ...f, responsavel_registro: e.target.value })} /></div>
        <div className="form-group"><label>ART / RRT</label><input value={f.responsavel_art} maxLength={60} onChange={e => setF({ ...f, responsavel_art: e.target.value })} /></div>
        <div className="form-group full rdo-inline"><button className="btn btn-primary btn-sm" disabled={busy} onClick={salvar}><Icon name="save" size={14} /> Salvar dados</button>
          <button className="btn btn-ghost btn-sm" onClick={() => { setAberto(false); setF(inicial()); setNovaEmp(null); setNovoFiscal(null); setEncerrar(null) }}>Fechar</button></div>
        <div className="form-group full"><label>{publico ? 'Fiscalização (com a portaria de designação)' : 'Representante do contratante'}</label>
          <div>{(cfg.fiscais || []).length ? cfg.fiscais.map(x => (
            <div key={x.id} className="rdo-fiscal"><span className="nm"><strong>{x.nome}</strong> — {RDO_FISCAL_FUNCAO[x.funcao] || x.funcao}{x.cargo ? `, ${x.cargo}` : ''}
              <span className="sub">{x.portaria ? `${/^\s*portaria\b/i.test(x.portaria) ? x.portaria.trim() : `Portaria ${x.portaria}`} · ` : publico && (x.funcao === 'fiscal' || x.funcao === 'fiscal_substituto') ? 'sem portaria · ' : ''}{periodo(x)}{x.origem === 'manut' ? ' · veio da configuração do Cronograma' : ''}</span></span>
              <span className="rdo-inline" style={{ flexWrap: 'nowrap' }}>{!x.ate && <button className="btn btn-ghost btn-sm" onClick={() => setEncerrar({ id: x.id, ate: cfg.hoje ? rdoDiaSoma(cfg.hoje, -1) : '' })}>Encerrar</button>}
                <button className="btn btn-ghost btn-sm" aria-label={`Excluir ${x.nome}`} title="Excluir (lançado por engano)" onClick={() => excluirFiscal(x)}><Icon name="trash" size={14} /></button></span>
            </div>)) : <p className="est-sub" style={{ margin: 0 }}>Ninguém cadastrado.</p>}</div>
          {encerrar && <div className="rdo-inline" style={{ marginTop: 6 }}><span className="est-sub">Último dia de fiscalização:</span>
            <input type="date" value={encerrar.ate} onChange={e => setEncerrar({ ...encerrar, ate: e.target.value })} style={{ width: 'auto' }} />
            <button className="btn btn-primary btn-sm" disabled={busy || !encerrar.ate} onClick={encerrarFiscal}>Encerrar</button>
            <button className="btn btn-ghost btn-sm" onClick={() => setEncerrar(null)}>Cancelar</button></div>}
          {novoFiscal ? <div className="form-grid" style={{ marginTop: 8 }}>
              <div className="form-group"><label>Nome</label><input value={novoFiscal.nome} maxLength={120} onChange={e => setNovoFiscal({ ...novoFiscal, nome: e.target.value })} /></div>
              <div className="form-group"><label>Função</label><select value={novoFiscal.funcao} onChange={e => setNovoFiscal({ ...novoFiscal, funcao: e.target.value })}>
                {Object.entries(RDO_FISCAL_FUNCAO).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select></div>
              <div className="form-group"><label>Cargo / matrícula</label><input value={novoFiscal.cargo} maxLength={120} onChange={e => setNovoFiscal({ ...novoFiscal, cargo: e.target.value })} /></div>
              <div className="form-group"><label>Portaria de designação</label><input value={novoFiscal.portaria} maxLength={120} placeholder={publico ? 'Ex.: Portaria nº 123/2026' : 'Não se aplica'} onChange={e => setNovoFiscal({ ...novoFiscal, portaria: e.target.value })} /></div>
              <div className="form-group"><label>Desde</label><input type="date" value={novoFiscal.desde} onChange={e => setNovoFiscal({ ...novoFiscal, desde: e.target.value })} /></div>
              <div className="form-group rdo-inline" style={{ alignSelf: 'flex-end' }}><button className="btn btn-primary btn-sm" disabled={busy} onClick={incluirFiscal}>Incluir</button>
                <button className="btn btn-ghost btn-sm" onClick={() => setNovoFiscal(null)}>Cancelar</button></div>
            </div>
            : <button className="btn btn-ghost btn-sm" style={{ marginTop: 6 }} onClick={() => setNovoFiscal({ nome: '', funcao: publico ? 'fiscal' : 'representante', cargo: '', portaria: '', desde: ultimoFim ? rdoDiaSoma(ultimoFim, 1) : '' })}><Icon name="plus" size={14} /> Incluir {publico ? 'fiscal' : 'representante'}</button>}
          <span className="est-sub">Trocou o fiscal? Encerre o período do anterior e inclua o novo com a data de início: o RDO de cada dia sai com quem fiscalizava naquele dia.</span></div>
      </div>}
    </div>
  )
}
function RdoConfigDiario({ cid, addToast, onSalvo }) {
  const [cfg, setCfg] = useState(null)
  const [f, setF] = useState(null)
  const [aberto, setAberto] = useState(false)
  const [busy, setBusy] = useState(false)
  // O que estava gravado quando o formulário abriu (uma recarga no meio — pelo cartão dos dados — não vira mudança).
  const baseCfg = useRef(null)
  // O técnico gravado que não vale mais (inativo, fora do contrato, sem papel técnico) não aparece como escolhido — o
  // formulário começa vazio para ele, e o salvar só manda o que a pessoa mudou (mudar o modo não mexe no técnico).
  const tecnicoInicial = c => (c.responsavel_tecnico_id && c.responsavel_tecnico_valido ? String(c.responsavel_tecnico_id) : '')
  // soCfg: recarga pedida pelo cartão dos dados do contrato — não mexe no formulário do técnico (pode estar aberto).
  const carregar = ({ soCfg = false } = {}) => GET('/rdo/config').then(r => {
    const c = r.contratos.find(x => x.contrato_id === cid)
    setCfg(c ? { ...c, pode_editar: r.pode_editar, empresas: r.empresas || [], pode_empresas: r.pode_empresas, hoje: r.hoje } : null)
    if (c && !soCfg) setF({ responsavel_tecnico_id: tecnicoInicial(c), fechamento: c.fechamento, ciente_fiscal: !!c.ciente_fiscal })
  }).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [cid])
  if (!cfg || !f || !cfg.pode_editar) return null
  const salvar = async () => {
    const corpo = {}, b0 = baseCfg.current || { resp: tecnicoInicial(cfg), fechamento: cfg.fechamento, ciente: !!cfg.ciente_fiscal }
    if (f.responsavel_tecnico_id !== b0.resp) corpo.responsavel_tecnico_id = f.responsavel_tecnico_id ? Number(f.responsavel_tecnico_id) : null
    if (f.fechamento !== b0.fechamento) corpo.fechamento = f.fechamento
    if (f.ciente_fiscal !== b0.ciente) corpo.ciente_fiscal = f.ciente_fiscal
    if (!Object.keys(corpo).length) { setAberto(false); return }
    setBusy(true)
    try {
      await PUT(`/rdo/config/${cid}`, corpo)
      addToast('Configuração do diário salva.', 'success'); setAberto(false); await carregar(); onSalvo()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const conf = cfg.fechamento === 'confirmacao'
  return (
    <div className="card" style={{ marginTop: 12 }}><div className="card-body" style={{ padding: 14 }}>
      <div className="rdo-linha-top"><span className="nm">Configurar o diário — {cfg.contrato_nome}
        <span className="sub">{!cfg.responsavel_tecnico_id ? 'Sem responsável técnico'
          : cfg.responsavel_tecnico_valido ? `${conf ? 'Fecha' : 'Assina'} o RDO do contrato: ${cfg.responsavel_tecnico_nome}`
          : `${cfg.responsavel_tecnico_nome || 'O responsável técnico'} não vale mais (inativo ou fora do contrato) — escolha outro`} · {conf ? 'fechamento com o login (sem desenho)' : 'assinatura desenhada'} · {cfg.ciente_fiscal ? 'com ciente do fiscal' : 'sem ciente do fiscal'}</span></span>
        {!aberto && <button className="btn btn-ghost btn-sm" onClick={() => { baseCfg.current = { resp: tecnicoInicial(cfg), fechamento: cfg.fechamento, ciente: !!cfg.ciente_fiscal }; setAberto(true) }}><Icon name="edit" size={14} /> Alterar</button>}</div>
      {aberto && <div className="form-grid" style={{ marginTop: 10 }}>
        <div className="form-group full"><label>Responsável técnico (fecha o RDO do contrato)</label>
          <select value={f.responsavel_tecnico_id} onChange={e => setF({ ...f, responsavel_tecnico_id: e.target.value })}>
            <option value="">— sem responsável —</option>{(cfg.candidatos || []).map(c => <option key={c.id} value={c.id}>{c.nome}{c.cargo ? ` — ${c.cargo}` : ''}</option>)}</select></div>
        <div className="form-group full"><label>Como o RDO fecha</label>
          <RdoSeg opcoes={[['assinatura', 'Assinatura desenhada'], ['confirmacao', 'Confirmação com o login']]} valor={f.fechamento} onChange={v => v && setF({ ...f, fechamento: v })} />
          <span className="est-sub">{f.fechamento === 'confirmacao'
            ? 'Para contrato cujo contratante não cobra assinatura: o responsável fecha com um toque e a declaração; o RDO congela igual (quem, quando e o código de integridade).'
            : 'O responsável assina na tela (ou com a assinatura salva).'}</span></div>
        <div className="form-group full"><label style={{ display: 'flex', gap: 8, alignItems: 'center' }}><input type="checkbox" style={{ width: 'auto' }} checked={f.ciente_fiscal}
          onChange={e => setF({ ...f, ciente_fiscal: e.target.checked })} /> Colher o ciente do fiscal depois do fechamento</label></div>
        <div className="form-group full rdo-inline"><button className="btn btn-primary btn-sm" disabled={busy} onClick={salvar}><Icon name="save" size={14} /> Salvar</button>
          <button className="btn btn-ghost btn-sm" onClick={() => { setAberto(false); carregar() }}>Cancelar</button></div>
      </div>}
      <RdoDadosContrato cid={cid} cfg={cfg} addToast={addToast} onSalvo={() => carregar({ soCfg: true })} />
    </div></div>
  )
}
const RDO_SEMANA = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb']
const RDO_MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
const rdoSemana = d => { const [a, m, x] = d.split('-').map(Number); return new Date(Date.UTC(a, m - 1, x)).getUTCDay() }
const rdoDataLonga = d => (d ? `${RDO_SEMANA[rdoSemana(d)]}, ${estData(d)}` : '—')
const rdoMesNome = m => { const [a, mm] = m.split('-').map(Number); const n = RDO_MESES[mm - 1]; return `${n[0].toUpperCase()}${n.slice(1)} de ${a}` }
const rdoMesSoma = (m, n) => { const [a, mm] = m.split('-').map(Number); const t = a * 12 + mm - 1 + n; return `${Math.floor(t / 12)}-${String(t % 12 + 1).padStart(2, '0')}` }
const rdoGuardar = (k, v) => { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, JSON.stringify(v)) } catch {} }
const rdoLerGuardado = k => { try { return JSON.parse(localStorage.getItem(k) || 'null') } catch { return null } }
const rdoSemSinal = e => !e || !e.status   // o pedido nem chegou ao servidor
const RDO_CHAVE_LOCAL = 'cautelix-rdo:'
const rdoLimparAparelho = () => { try { for (const k of Object.keys(localStorage)) if (k.startsWith(RDO_CHAVE_LOCAL)) localStorage.removeItem(k) } catch {} }
// Documento do RDO (Fase 4: PDF do dia, relatório do período): o HTML autenticado numa prévia DENTRO do app — aba nova
// é bloqueada no app instalado e no navegador embutido (WhatsApp). "Imprimir / Salvar PDF" imprime o iframe no próprio
// toque e só depois de as imagens decodificarem (senão o PDF sai com fotos em branco); "Abrir em nova aba" de reserva.
// abrir(url da API sem /api, título) → a prévia; el = o elemento para pôr na tela.
function useRdoDocumento(addToast) {
  const [doc, setDoc] = useState(null)   // { titulo, carregando } | { titulo, html }
  // Pedido em curso: fechar a prévia (ou abrir outro documento) cancela o anterior — a resposta que chega depois não
  // reabre a prévia nem troca o documento pedido por último.
  const pedido = useRef(null)
  const fechar = () => { if (pedido.current) pedido.current.abort(); pedido.current = null; setDoc(null) }
  const abrir = async (url, titulo) => {
    if (pedido.current) pedido.current.abort()
    const ctl = new AbortController()
    pedido.current = ctl
    setDoc({ titulo, carregando: true })
    try {
      const resp = await fetch('/api' + url, { headers: { Authorization: `Bearer ${token.value}` }, signal: ctl.signal })
      if (!resp.ok) {
        let msg = 'Não foi possível montar o documento (erro ' + resp.status + ').'
        try { const j = await resp.json(); if (j && j.error) msg = j.error } catch {}
        throw new Error(msg)
      }
      const html = await resp.text()
      if (pedido.current !== ctl) return
      setDoc({ titulo, html })
    } catch (e) {
      if (pedido.current !== ctl) return   // cancelado: quem cancelou já fechou ou abriu outro
      setDoc(null); addToast(e.message, 'error')
    } finally { if (pedido.current === ctl) pedido.current = null }
  }
  return [abrir, doc ? <RdoDocumentoModal doc={doc} onFechar={fechar} addToast={addToast} /> : null]
}
const rdoIos = () => /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
function RdoDocumentoModal({ doc, onFechar, addToast }) {
  const ref = useRef(null)
  const [pronto, setPronto] = useState(false)
  // O documento traz o botão dele (para quando aberto sozinho); na prévia, quem imprime é a barra — e o iframe não roda
  // script (sandbox), então o botão sai do HTML (o onclick dele só geraria aviso de bloqueio).
  const html = React.useMemo(() => (doc.html ? doc.html.split('<div class="no-print">').map((p, i) => (i ? p.slice(p.indexOf('</div>') + 6) : p)).join('') : ''), [doc.html])
  useEffect(() => {
    const k = e => { if (e.key === 'Escape') onFechar() }
    window.addEventListener('keydown', k)
    return () => window.removeEventListener('keydown', k)
  }, [])
  const carregou = async () => {
    setPronto(false)
    try {
      const d = ref.current && ref.current.contentDocument
      // O load do iframe já espera as imagens carregarem; o decode() é só um reforço — no iframe sem scripts (sandbox) ele
      // pode não resolver nunca, então tem prazo.
      if (d) await Promise.race([Promise.all([...d.images].map(i => (i.decode ? i.decode() : Promise.resolve()).catch(() => {}))), new Promise(r => setTimeout(r, 1500))])
    } catch {}
    setPronto(true)
  }
  const imprimir = () => {
    try { const w = ref.current.contentWindow; w.focus(); w.print() } catch { addToast('Não foi possível abrir a impressão aqui: use "Abrir em nova aba".', 'error') }
  }
  const novaAba = () => {
    const url = URL.createObjectURL(new Blob([doc.html], { type: 'text/html' }))
    const w = window.open(url, '_blank')
    if (!w) addToast('O navegador bloqueou a aba nova. Use "Imprimir / Salvar PDF".', 'error')
    setTimeout(() => URL.revokeObjectURL(url), 120000)
  }
  return (
    <div className="rdo-docmodal" role="dialog" aria-modal="true" aria-label={doc.titulo}>
      <div className="rdo-docmodal-bar">
        <strong className="t">{doc.titulo}</strong>
        <button className="btn btn-primary btn-sm" disabled={!doc.html || !pronto} onClick={imprimir}><Icon name="fileText" size={14} /> {doc.html && !pronto ? 'Preparando…' : 'Imprimir / Salvar PDF'}</button>
        <button className="btn btn-ghost btn-sm" disabled={!doc.html} onClick={novaAba}>Abrir em nova aba</button>
        <button className="modal-close" onClick={onFechar} aria-label="Fechar">×</button>
      </div>
      {rdoIos() && doc.html && <div className="rdo-docmodal-dica">No iPhone: na tela de impressão, toque em Compartilhar e escolha "Salvar em Arquivos" para guardar o PDF.</div>}
      {doc.carregando ? <div className="empty" style={{ flex: 1 }}><p>Montando o documento…</p></div>
        : <iframe ref={ref} title={doc.titulo} srcDoc={html} onLoad={carregou} className="rdo-docmodal-frame" sandbox="allow-same-origin allow-modals" />}
    </div>
  )
}

// ── Indicadores do diário (Fase 5) ──
// Só o gestor. Gráficos em HTML/CSS (rótulos em texto real: no celular o SVG encolhe a letra), cores só por token.
const rdoNum = (n, casas = 1) => (n == null ? '—' : Number(n).toLocaleString('pt-BR', { maximumFractionDigits: casas }))
const RDO_COR_PONT = { no_prazo: 'var(--tag-ok-dot)', com_atraso: 'var(--tag-alerta-dot)', regularizados: 'var(--tag-neutro-dot)', pendentes: 'var(--tag-perigo-dot)' }
const RDO_COR_DIA = { trabalhados: 'var(--tag-ok-dot)', parciais: 'var(--tag-alerta-dot)', impraticaveis: 'var(--tag-aco-dot)', sem_expediente: 'var(--tag-neutro-dot)', nao_informados: 'var(--border)', sem_servico: 'var(--border)' }
function RdoMedidor({ partes, vazio }) {
  const total = partes.reduce((s, p) => s + (p.n || 0), 0)
  if (!total) return <p className="est-sub" style={{ margin: 0 }}>{vazio || 'Nada no período.'}</p>
  return <>
    <div className="rdo-medidor" role="img" aria-label={partes.filter(p => p.n).map(p => `${p.rotulo}: ${p.n}`).join(', ')}>
      {partes.filter(p => p.n).map(p => <i key={p.k} style={{ width: `${(p.n / total) * 100}%`, background: p.cor }} title={`${p.rotulo}: ${p.n}`} />)}
    </div>
    <div className="rdo-legenda" style={{ marginTop: 6 }}>{partes.map(p => <span key={p.k}><i style={{ background: p.cor, border: 'none' }} />{p.rotulo}: <strong>{p.n || 0}</strong></span>)}</div>
  </>
}
function RdoBarras({ itens, valor, rotulo, sub, cor, max: maxItens = 12 }) {
  const lista = itens.slice(0, maxItens)
  const max = Math.max(1, ...lista.map(valor))
  return <div className="rdo-barras">
    {lista.map((x, i) => (
      <div key={i} className="rdo-barra"><div className="rt"><span className="nm" title={rotulo(x)}>{rotulo(x)}</span><span className="vl">{rdoNum(valor(x))}{sub ? <small> {sub(x)}</small> : null}</span></div>
        <div className="tr"><i style={{ width: `${(valor(x) / max) * 100}%`, background: cor || 'var(--primary-accent)' }} /></div></div>))}
    {itens.length > maxItens && <p className="est-sub" style={{ margin: 0 }}>Mais {itens.length - maxItens} abaixo destes.</p>}
  </div>
}
// Colunas por dia: tocar mostra o dia e o valor (aria-live).
function RdoColunas({ pontos, valor, rotulo, unidade }) {
  const [sel, setSel] = useState(null)
  const max = Math.max(1, ...pontos.map(valor))
  const atual = sel != null ? pontos[sel] : null
  return <>
    <div className="rdo-colunas">{pontos.map((p, i) => (
      <button key={i} type="button" className={`${valor(p) ? '' : 'zero'} ${sel === i ? 'sel' : ''}`} style={{ height: `${Math.max(3, (valor(p) / max) * 100)}%` }}
        aria-label={`${rotulo(p)}: ${rdoNum(valor(p))} ${unidade}`} onClick={() => setSel(sel === i ? null : i)} />))}</div>
    <p className="est-sub" aria-live="polite" style={{ margin: '4px 0 0' }}>{atual ? `${rotulo(atual)}: ${rdoNum(valor(atual))} ${unidade}` : 'Toque numa coluna para ver o dia.'}</p>
  </>
}
// Todos os dias do período (o eixo não pula dia sem lançamento).
const rdoDiasDe = (de, ate) => { const out = []; for (let d = de; d <= ate; d = rdoDiaSoma(d, 1)) out.push(d); return out }

function RdoIndicadores({ ct, mes, setMes, hoje, abrirDoc }) {
  const [d, setD] = useState(null)
  const [erro, setErro] = useState(null)
  useEffect(() => {
    let vivo = true
    setD(null); setErro(null)
    GET(`/rdo/indicadores?contrato_id=${ct.contrato_id}&mes=${mes}`).then(x => { if (vivo) setD(x) }).catch(e => { if (vivo) setErro(e.message) })
    return () => { vivo = false }
  }, [ct.contrato_id, mes])
  const nav = (
    <div className="rdo-mes">
      <button className="btn btn-ghost btn-sm" aria-label="Mês anterior" onClick={() => setMes(rdoMesSoma(mes, -1))}><span style={{ transform: 'rotate(180deg)', display: 'inline-flex' }}><Icon name="chevronRight" size={15} /></span></button>
      <strong>{rdoMesNome(mes)}</strong>
      <button className="btn btn-ghost btn-sm" aria-label="Próximo mês" disabled={mes >= hoje.slice(0, 7)} onClick={() => setMes(rdoMesSoma(mes, 1))}><Icon name="chevronRight" size={15} /></button>
    </div>
  )
  if (erro) return <div className="card"><div className="card-body">{nav}<div className="alert alert-error">{erro}</div></div></div>
  if (!d) return <div className="card"><div className="card-body">{nav}<p className="est-sub">Calculando…</p></div></div>
  const p = d.pontualidade, dias = d.dias, hh = d.homem_hora, atv = d.atividades
  const vazio = !d.rdos_fechados && !p.esperados && !p.em_aberto
  const parcialHH = hh.presentes_sem_horas + hh.nao_confirmados
  const relatorio = () => abrirDoc(`/rdo/periodo?contrato_id=${ct.contrato_id}&de=${d.de}&ate=${d.ate}&fotos=lista`, `RDOs de ${estData(d.de)} a ${estData(d.ate)}`)
  const sec = (titulo, corpo, extra) => <div className="card rdo-ind-sec" style={{ marginBottom: 12 }}><div className="card-body" style={{ padding: 14 }}>
    <div className="rdo-linha-top" style={{ marginBottom: 10 }}><h3 style={{ margin: 0 }}>{titulo}</h3>{extra || null}</div>{corpo}</div></div>
  return (
    <div>
      <div className="card" style={{ marginBottom: 12 }}><div className="card-body" style={{ padding: 14 }}>
        {nav}
        <p className="est-sub" style={{ margin: 0 }}>{estData(d.de)} a {estData(d.ate)}{d.ate === d.hoje ? ' (até hoje)' : ''} · {ct.contrato_nome}
          {d.ativado_em ? ` · diário ligado em ${estData(d.ativado_em)}` : ''}</p>
      </div></div>
      {vazio ? <div className="card"><div className="card-body"><div className="empty" style={{ padding: '18px 8px' }}><Icon name="fileText" size={30} />
        <p>Os indicadores aparecem quando o primeiro RDO do mês for fechado.</p>
        <p className="est-sub" style={{ margin: 0 }}>{d.ativado_em && d.ativado_em > d.ate ? 'O diário foi ligado depois deste mês.' : 'Nada fechado neste mês ainda.'}</p></div></div></div> : <>
        <div className="stats-grid" style={{ marginBottom: 12 }}>
          <div className={`stat-card ${p.pct_no_prazo == null ? '' : p.pct_no_prazo >= 90 ? 'green' : p.pct_no_prazo >= 70 ? '' : 'red'}`}><div className="stat-label">Fechados no prazo</div>
            <div className="stat-value">{p.pct_no_prazo == null ? '—' : `${rdoNum(p.pct_no_prazo)}%`}</div><div className="est-sub">{p.no_prazo} de {p.esperados} dia(s) esperado(s)</div></div>
          <div className={`stat-card ${p.pendentes ? 'red' : 'green'}`}><div className="stat-label">Em atraso agora</div><div className="stat-value">{p.pendentes}</div>
            <div className="est-sub">dia(s) útil(eis) sem RDO fechado</div></div>
          <div className="stat-card"><div className="stat-label">Dias impraticáveis</div><div className="stat-value">{dias.impraticaveis}</div>
            <div className="est-sub">{rdoNum(dias.horas_paralisadas)} h paralisadas</div></div>
          <div className="stat-card"><div className="stat-label">Homem-hora</div><div className="stat-value">{rdoNum(hh.total, 0)}</div>
            <div className="est-sub">{parcialHH ? 'parcial — ver abaixo' : `${hh.presentes} presença(s)`}</div></div>
        </div>
        {d.integridade.com_aviso.length > 0 && <div className="alert alert-warning" style={{ marginBottom: 12 }}>{d.integridade.com_aviso.length} RDO(s) com aviso de integridade ficaram fora dos números: {d.integridade.com_aviso.map(x => `${x.numero} v${x.versao} (${estData(x.data)})`).join(', ')}. Abra o PDF deles para conferir.</div>}
        {sec('Pontualidade do RDO do contrato', <>
          <RdoMedidor vazio="Nenhum dia útil com o prazo vencido neste mês." partes={[
            { k: 'no_prazo', n: p.no_prazo, rotulo: 'No prazo', cor: RDO_COR_PONT.no_prazo },
            { k: 'com_atraso', n: p.com_atraso, rotulo: 'Fechado com atraso', cor: RDO_COR_PONT.com_atraso },
            { k: 'regularizados', n: p.regularizados, rotulo: 'Lançado pelo gestor', cor: RDO_COR_PONT.regularizados },
            { k: 'pendentes', n: p.pendentes, rotulo: 'Em atraso', cor: RDO_COR_PONT.pendentes }]} />
          <p className="est-sub" style={{ margin: '8px 0 0' }}>{[p.atraso_medio_du != null ? `Atraso médio: ${rdoNum(p.atraso_medio_du)} dia(s) útil(eis)` : null,
            p.em_aberto ? `${p.em_aberto} dia(s) com o prazo ainda correndo` : null, p.antes_do_diario ? `${p.antes_do_diario} dia(s) antes de ligar o diário` : null,
            p.nao_uteis_com_rdo ? `${p.nao_uteis_com_rdo} RDO(s) em dia não útil` : null].filter(Boolean).join(' · ')}</p>
          {p.por_responsavel.length > 0 && <div className="rdo-tab-wrap" style={{ marginTop: 10 }}><table className="rdo-tab">
            <thead><tr><th>Responsável do dia</th><th>Esperados</th><th>No prazo</th><th>Com atraso</th><th>Pelo gestor</th><th>Em atraso</th><th>%</th></tr></thead>
            <tbody>{p.por_responsavel.map((r, i) => <tr key={i}><td>{r.nome || 'Sem responsável definido'}{r.atual ? <span className="est-sub"> (responsável atual)</span> : null}</td>
              <td>{r.esperados}</td><td>{r.no_prazo}</td><td>{r.com_atraso}</td><td>{r.regularizados}</td><td style={{ color: r.pendentes ? 'var(--tag-perigo-fg)' : undefined, fontWeight: r.pendentes ? 700 : undefined }}>{r.pendentes}</td>
              <td>{r.pct_no_prazo == null ? '—' : `${rdoNum(r.pct_no_prazo)}%`}</td></tr>)}</tbody></table></div>}
          <p className="est-sub" style={{ margin: '8px 0 0' }}>Vale a 1ª assinatura do dia (retificar não vira atraso). Prazo: o próximo dia útil, às 23:59.</p>
        </>)}
        {sec('Dias do contrato', <>
          <RdoMedidor vazio="Nenhum RDO do contrato fechado neste mês." partes={[
            { k: 'trabalhados', n: dias.trabalhados, rotulo: 'Normal', cor: RDO_COR_DIA.trabalhados },
            { k: 'parciais', n: dias.parciais, rotulo: 'Parcial', cor: RDO_COR_DIA.parciais },
            { k: 'impraticaveis', n: dias.impraticaveis, rotulo: 'Impraticável', cor: RDO_COR_DIA.impraticaveis },
            { k: 'sem_expediente', n: dias.sem_expediente, rotulo: 'Sem expediente', cor: RDO_COR_DIA.sem_expediente },
            { k: 'nao_informados', n: dias.nao_informados, rotulo: 'Condição não informada', cor: RDO_COR_DIA.nao_informados }]} />
          <p className="est-sub" style={{ margin: '8px 0 0' }}>{dias.fechados} RDO(s) do contrato fechado(s) · {rdoNum(dias.horas_paralisadas)} h paralisadas (declaradas no RDO)</p>
          {dias.sem_expediente_lista.length > 0 && <ul className="rdo-ind-lista">{dias.sem_expediente_lista.map((x, i) => <li key={i}><strong>{estData(x.data)}</strong> — sem expediente: {x.motivo || 'motivo não informado'}</li>)}</ul>}
        </>, <button className="btn btn-outline btn-sm" onClick={relatorio}><Icon name="fileText" size={14} /> PDF do período</button>)}
        {d.unidades.length > 0 && sec('Por unidade (unidade·dia)', <>
          <div className="rdo-tab-wrap"><table className="rdo-tab">
            <thead><tr><th>Unidade</th><th>Com serviço</th><th>Parcial</th><th>Cond. não inf.</th><th>Impraticável</th><th>Sem exped.</th><th>Sem serviço</th></tr></thead>
            <tbody>{d.unidades.map(u => <tr key={u.obra_id}><td>{u.nome || '—'}{u.em_dois_rdos ? <span className="est-sub"> · {u.em_dois_rdos} dia(s) em dois RDOs</span> : null}</td>
              <td>{u.trabalhados}</td><td>{u.parciais}</td><td>{u.nao_informados}</td><td style={{ fontWeight: u.impraticaveis ? 700 : undefined }}>{u.impraticaveis}</td><td>{u.sem_expediente}</td><td>{u.sem_servico}</td></tr>)}</tbody></table></div>
          <p className="est-sub" style={{ margin: '8px 0 0' }}>"Com serviço" = presença confirmada ou atividade feita na unidade ("cond. não inf." = teve serviço, sem a condição marcada). Unidade·dia não se soma aos dias do contrato; quando a obra tem RDO próprio no dia, vale o dela.</p>
        </>)}
        {sec('Homem-hora', hh.total || parcialHH ? <>
          {hh.por_dia.length > 0 && (() => { const mapa = new Map(hh.por_dia.map(x => [x.data, x.hh])); const pts = rdoDiasDe(d.de, d.ate).map(dt => ({ data: dt, hh: mapa.get(dt) || 0 }))
            return <RdoColunas pontos={pts} valor={x => x.hh} rotulo={x => rdoDataLonga(x.data)} unidade="homem-hora" /> })()}
          {parcialHH > 0 && <div className="rdo-falta" style={{ marginTop: 8 }}>Número parcial: {hh.presentes_sem_horas} presença(s) sem horas e {hh.nao_confirmados} presença(s) não confirmada(s) não entram (nenhuma hora é presumida).</div>}
          <div className="rdo-ind-duas" style={{ marginTop: 12 }}>
            <div><div className="est-sub" style={{ fontWeight: 700, marginBottom: 6 }}>Por função</div>
              <RdoBarras itens={hh.por_funcao} valor={x => x.hh} rotulo={x => x.funcao || 'Função não informada'} sub={x => `· ${x.pessoas} pessoa(s)`} /></div>
            <div><div className="est-sub" style={{ fontWeight: 700, marginBottom: 6 }}>Por unidade</div>
              <RdoBarras itens={hh.por_obra} valor={x => x.hh} rotulo={x => (x.obra_id == null ? 'Volantes / sem unidade' : x.nome || '—')} sub={x => `· ${x.pessoas} pessoa(s)`} cor="var(--tag-aco-dot)" /></div>
          </div>
        </> : <p className="est-sub" style={{ margin: 0 }}>Nenhuma presença com horas nos RDOs fechados do mês.</p>)}
        {sec('Ocorrências por tipo', d.ocorrencias.length
          ? <RdoBarras itens={d.ocorrencias} valor={x => x.n} rotulo={x => x.rotulo} sub={x => `· ${x.com_impacto} com impacto no prazo${x.horas ? ` · ${rdoNum(x.horas)} h` : ''}`} cor="var(--tag-alerta-dot)" />
          : <p className="est-sub" style={{ margin: 0 }}>Nenhuma ocorrência registrada nos RDOs fechados do mês.</p>)}
        {sec('Atividades', <>
          <div className="rdo-legenda" style={{ marginBottom: 8 }}>
            <span><i style={{ background: 'var(--tag-ok-dot)', border: 'none' }} />Executadas: <strong>{atv.por_situacao.executada || 0}</strong></span>
            <span><i style={{ background: 'var(--tag-alerta-dot)', border: 'none' }} />Parciais: <strong>{atv.por_situacao.parcial || 0}</strong></span>
            <span><i style={{ background: 'var(--tag-perigo-dot)', border: 'none' }} />Não executadas: <strong>{atv.por_situacao.nao_executada || 0}</strong></span>
            <span><i style={{ background: 'var(--border)', border: 'none' }} />Sem situação: <strong>{atv.por_situacao.sem_situacao || 0}</strong></span>
          </div>
          {atv.nao_executadas.length > 0 ? <ul className="rdo-ind-lista">{atv.nao_executadas.map((a, i) => <li key={i}><strong>{estData(a.data)}</strong>{a.obra_nome ? ` · ${a.obra_nome}` : ''} — {a.descricao}
            <span className="est-sub"> · {a.motivo ? `motivo: ${a.motivo}` : 'sem motivo informado'}{a.origem === 'auto' ? ' · do cronograma' : ''}</span></li>)}</ul>
            : <p className="est-sub" style={{ margin: 0 }}>Nenhuma atividade não executada.</p>}
          {atv.nao_executadas_total > atv.nao_executadas.length && <p className="est-sub" style={{ margin: '6px 0 0' }}>Mostrando as {atv.nao_executadas.length} mais recentes de {atv.nao_executadas_total}.</p>}
          {atv.sem_motivo > 0 && <p className="est-sub" style={{ margin: '6px 0 0' }}>{atv.sem_motivo} sem motivo informado.</p>}
        </>)}
        <p className="est-sub" style={{ margin: '4px 0 0' }}>Calculado pelo calendário atual do contrato. Números de campo só de RDOs fechados{d.integridade.conferidos ? `; ${d.integridade.conferidos} RDO(s) conferido(s) pelo código de integridade` : ''}.</p>
      </>}
    </div>
  )
}

// Bloco do Painel (Diretor, Gerente, Master/CEO): o mês de cada contrato com o diário; abre os Indicadores dele.
function RdoPainelResumo({ navigate }) {
  const [r, setR] = useState(null)
  useEffect(() => { GET('/rdo/indicadores/resumo').then(setR).catch(() => setR(null)) }, [])
  if (!r || !r.contratos || !r.contratos.length) return null
  return (
    <div className="dc-sec">
      <div className="dc-head"><span className="k">Diário de obra</span><h3>{rdoMesNome(r.mes)}{r.ate && r.ate.slice(0, 7) === r.mes && r.ate < rdoDiaSoma(rdoMesSoma(r.mes, 1) + '-01', -1) ? ' (até hoje)' : ''}</h3></div>
      <div className="rdo-resumo">{r.contratos.map(c => (
        <button key={c.contrato_id} type="button" className="rdo-resumo-lin" onClick={() => navigate('rdo', null, { aba: 'indicadores', contrato: c.contrato_id, rotulo: `Indicadores · ${c.contrato_nome}` })}>
          <span className="nm">{c.contrato_nome}</span>
          <span className="kpi"><strong>{c.pct_no_prazo == null ? '—' : `${rdoNum(c.pct_no_prazo)}%`}</strong> no prazo</span>
          <span className={`kpi ${c.pendentes ? 'perigo' : ''}`}><strong>{c.pendentes}</strong> em atraso no mês</span>
          <span className="kpi"><strong>{c.impraticaveis}</strong> impraticáveis</span>
          <span className="kpi"><strong>{rdoNum(c.homem_hora, 0)}</strong> homem-hora</span>
          <span className="kpi" style={{ marginLeft: 'auto', color: 'var(--primary-accent)', fontWeight: 600 }}>Ver →</span>
        </button>))}
      </div>
    </div>
  )
}

function RdoSeg({ opcoes, valor, onChange, disabled, limpar }) {
  return (
    <div className="rdo-seg" role="group">
      {opcoes.map(([v, l, cls]) => (
        <button key={String(v)} type="button" className={`${valor === v ? 'on' : ''} ${cls || ''}`} disabled={disabled} aria-pressed={valor === v}
          onClick={() => onChange(limpar && valor === v ? null : v)}>{l}</button>
      ))}
    </div>
  )
}
function RdoBloco({ id, icon, titulo, cont, abertos, setAbertos, children }) {
  const on = !!abertos[id]
  return (
    <div className="card rdo-bloco">
      <button type="button" className="rdo-bloco-hd" aria-expanded={on} onClick={() => setAbertos(a => ({ ...a, [id]: !on }))}>
        <Icon name={icon} size={17} /><span className="t">{titulo}</span>{cont != null && <span className="c">{cont}</span>}
        <span style={{ transform: on ? 'rotate(90deg)' : 'none', display: 'inline-flex', transition: 'transform .15s' }}><Icon name="chevronRight" size={16} /></span>
      </button>
      {on && <div className="rdo-bloco-bd">{children}</div>}
    </div>
  )
}
const RdoSelo = () => <span className="rdo-selo" title="Trazido pelo sistema (alocação, cautelas, cronograma, apontador)">do sistema</span>

function RdoPage({ user, addToast, openTarget, clearOpenTarget }) {
  const [alvos, setAlvos] = useState(null)
  const [cid, setCid] = useState(null)
  const [alvo, setAlvo] = useState('contrato')
  const [mes, setMes] = useState(null)
  const [cal, setCal] = useState(null)
  const [sel, setSel] = useState(null)
  const [aberto, setAberto] = useState(openTarget && openTarget.page === 'rdo' && openTarget.id ? Number(openTarget.id) : null)
  const [motivo, setMotivo] = useState('')
  const [busy, setBusy] = useState(false)
  const [rel, setRel] = useState(null)           // relatório do período: { de, ate, fotos }
  const [abrirDoc, docEl] = useRdoDocumento(addToast)
  // Fase 5: Calendário | Indicadores (só o gestor). O atalho do Painel abre os Indicadores de um contrato.
  const pedeInd = t => !!(t && t.page === 'rdo' && t.filtro && t.filtro.aba === 'indicadores')
  const [aba, setAba] = useState(() => (pedeInd(openTarget) ? 'indicadores' : 'calendario'))
  const contratoPedido = useRef(pedeInd(openTarget) && openTarget.filtro.contrato ? Number(openTarget.filtro.contrato) : null)
  const trocarAba = a => setAba(a)
  // Deep-link (Ctrl+K, Pendências) também com a aba já aberta: a página não remonta, então reage ao alvo novo.
  useEffect(() => {
    if (!openTarget) return
    if (openTarget.page === 'rdo' && openTarget.id) setAberto(Number(openTarget.id))
    if (pedeInd(openTarget)) {
      setAba('indicadores'); setAberto(null)
      if (openTarget.filtro.contrato) { contratoPedido.current = Number(openTarget.filtro.contrato); setCid(Number(openTarget.filtro.contrato)) }
    }
    if (clearOpenTarget) clearOpenTarget()
  }, [openTarget])
  useEffect(() => {
    GET('/rdo/alvos').then(a => {
      setAlvos(a); setMes(a.hoje.slice(0, 7)); setSel(a.hoje)
      const pref = contratoPedido.current
      if (a.contratos.length) setCid(pref && a.contratos.some(c => c.contrato_id === pref) ? pref : a.contratos[0].contrato_id)
    })
      .catch(e => { setAlvos({ contratos: [], erro: e.message }) })
  }, [])
  const carregarCal = () => {
    if (!cid || !mes) return
    GET(`/rdo/calendario?${alvo === 'contrato' ? `contrato_id=${cid}` : `obra_id=${alvo}`}&mes=${mes}`).then(setCal).catch(e => { setCal(null); addToast(e.message, 'error') })
  }
  useEffect(carregarCal, [cid, alvo, mes])
  if (!alvos) return <div className="empty"><p>Carregando…</p></div>
  if (aberto) return <RdoEditor key={aberto} id={aberto} user={user} alvos={alvos} addToast={addToast} onAbrir={setAberto} onVoltar={() => { setAberto(null); carregarCal() }} />
  if (!alvos.contratos.length) return <div className="empty"><Icon name="fileText" size={36} /><p>{alvos.erro || 'Nenhum contrato com o diário de obra ligado.'}</p></div>
  const ct = alvos.contratos.find(c => c.contrato_id === cid) || alvos.contratos[0]
  const hoje = alvos.hoje
  const confirmacao = ((cal && cal.fechamento) || ct.fechamento) === 'confirmacao'   // o contrato fecha sem assinatura desenhada
  const gestorDiario = alvos.papel === 'gestor'
  const verInd = gestorDiario && aba === 'indicadores'
  const dias = (cal && cal.dias) || []
  const dia = dias.find(x => x.data === sel) || null
  const atrasados = dias.filter(x => x.atrasado).length
  const lancar = async fora => {
    if (fora && motivo.trim().length < 10) { addToast('Fora do prazo: informe o motivo (mín. 10 caracteres).', 'error'); return }
    setBusy(true)
    try {
      const r = await POST('/rdo', { ...(alvo === 'contrato' ? { contrato_id: ct.contrato_id } : { obra_id: Number(alvo) }), data: dia.data, ...(fora ? { motivo_fora_prazo: motivo } : {}) })
      setMotivo(''); setAberto(r.id)
    } catch (e) { addToast(e.message, 'error'); carregarCal() } finally { setBusy(false) }
  }
  const rdoDeHoje = () => {
    if (verInd) setAba('calendario')
    if (mes !== hoje.slice(0, 7)) { setMes(hoje.slice(0, 7)); setSel(hoje); return }
    const h = dias.find(x => x.data === hoje)
    if (h && h.rdo) setAberto(h.rdo.id); else setSel(hoje)
  }
  const primeiro = dias.length ? rdoSemana(dias[0].data) : 0
  // Relatório do período: padrão = o mês da tela (até hoje, no mês corrente).
  const abrirRel = () => {
    const fim = rdoMesSoma(mes, 1) + '-01'
    const ultimo = new Date(Date.UTC(Number(fim.slice(0, 4)), Number(fim.slice(5, 7)) - 1, 0)).toISOString().slice(0, 10)
    setRel({ de: `${mes}-01`, ate: ultimo > hoje ? hoje : ultimo, fotos: 'miniaturas' })
  }
  const gerarRel = () => {
    if (!rel.de || !rel.ate || rel.de > rel.ate) { addToast('Confira o período: o início vem antes do fim.', 'error'); return }
    if (rel.ate > hoje) { addToast('O período não pode passar de hoje.', 'error'); return }
    const q = `${alvo === 'contrato' ? `contrato_id=${ct.contrato_id}` : `obra_id=${alvo}`}&de=${rel.de}&ate=${rel.ate}&fotos=${rel.fotos}`
    setRel(null)
    abrirDoc(`/rdo/periodo?${q}`, `RDOs de ${estData(rel.de)} a ${estData(rel.ate)}`)
  }
  const noPrazo = dia && hoje <= dia.prazo
  return (
    <div style={{ maxWidth: 860, margin: '0 auto' }}>
      <div className="topbar"><h2>Diário de obra</h2>
        <div className="topbar-actions">{!alvos.visao_apontador && <button className="btn btn-outline" onClick={abrirRel}><Icon name="fileText" size={15} /> Relatório do período</button>}
          <button className="btn btn-primary" onClick={rdoDeHoje}><Icon name="fileText" size={15} /> RDO de hoje</button></div></div>
      {docEl}
      {rel && <div className="modal-overlay open" onClick={() => setRel(null)}>
        <div className="modal" onClick={e => e.stopPropagation()} role="dialog" aria-label="Relatório do período">
          <div className="modal-header"><h3>Relatório do período</h3><button className="modal-close" onClick={() => setRel(null)} aria-label="Fechar">×</button></div>
          <div className="modal-body">
            <p className="est-sub" style={{ marginTop: 0, marginBottom: 12 }}>{ct.contrato_nome} · {alvo === 'contrato' ? 'RDO do contrato (todas as unidades)' : (ct.obras.find(o => String(o.id) === String(alvo)) || {}).nome}. Entram os RDOs fechados; rascunhos e dias sem RDO aparecem no índice. Até 62 dias.</p>
            <div className="form-grid">
              <div className="form-group"><label>De</label><input type="date" value={rel.de} max={hoje} onChange={e => setRel({ ...rel, de: e.target.value })} /></div>
              <div className="form-group"><label>Até</label><input type="date" value={rel.ate} max={hoje} onChange={e => setRel({ ...rel, ate: e.target.value })} /></div>
              <div className="form-group full"><label>Fotos</label>
                <RdoSeg opcoes={[['miniaturas', 'Miniaturas'], ['lista', 'Só a lista']]} valor={rel.fotos} onChange={v => v && setRel({ ...rel, fotos: v })} />
                <span className="est-sub">A foto inteira sai no PDF de cada dia; aqui, a miniatura (ou só a legenda e o código, para um arquivo menor).</span></div>
            </div>
          </div>
          <div className="modal-footer"><button className="btn btn-ghost" onClick={() => setRel(null)}>Cancelar</button>
            <button className="btn btn-primary" onClick={gerarRel}><Icon name="fileText" size={14} /> Gerar</button></div>
        </div>
      </div>}
      {gestorDiario && <div className="dt-tabs" style={{ margin: '0 0 14px' }}>
        <button className={`dt-tab ${verInd ? '' : 'on'}`} onClick={() => trocarAba('calendario')}><Icon name="fileText" size={14} /> Calendário</button>
        <button className={`dt-tab ${verInd ? 'on' : ''}`} onClick={() => trocarAba('indicadores')}><Icon name="trending" size={14} /> Indicadores</button>
      </div>}
      {verInd ? <>
        {alvos.contratos.length > 1 && <div className="rdo-filtros"><div className="form-group"><label>Contrato</label>
          <select value={ct.contrato_id} onChange={e => { setCid(Number(e.target.value)); setAlvo('contrato') }}>{alvos.contratos.map(c => <option key={c.contrato_id} value={c.contrato_id}>{c.contrato_nome}</option>)}</select></div></div>}
        <RdoIndicadores ct={ct} mes={mes} setMes={setMes} hoje={hoje} abrirDoc={abrirDoc} />
      </> : <>
      <div className="rdo-filtros">
        {alvos.contratos.length > 1 && <div className="form-group"><label>Contrato</label>
          <select value={ct.contrato_id} onChange={e => { setCid(Number(e.target.value)); setAlvo('contrato') }}>{alvos.contratos.map(c => <option key={c.contrato_id} value={c.contrato_id}>{c.contrato_nome}</option>)}</select></div>}
        <div className="form-group"><label>Diário</label>
          <select value={alvo} onChange={e => setAlvo(e.target.value)}>
            <option value="contrato">RDO do contrato (todas as unidades)</option>
            {ct.obras.map(o => <option key={o.id} value={o.id}>{o.nome}</option>)}
          </select></div>
      </div>
      <div className="card"><div className="card-body">
        <div className="rdo-mes">
          <button className="btn btn-ghost btn-sm" aria-label="Mês anterior" onClick={() => setMes(rdoMesSoma(mes, -1))}><span style={{ transform: 'rotate(180deg)', display: 'inline-flex' }}><Icon name="chevronRight" size={15} /></span></button>
          <strong>{rdoMesNome(mes)}</strong>
          <button className="btn btn-ghost btn-sm" aria-label="Próximo mês" disabled={mes >= hoje.slice(0, 7)} onClick={() => setMes(rdoMesSoma(mes, 1))}><Icon name="chevronRight" size={15} /></button>
        </div>
        {atrasados > 0 && <div className="alert alert-error" style={{ marginBottom: 10 }}>{atrasados === 1 ? '1 dia útil em atraso' : `${atrasados} dias úteis em atraso`} neste mês: o prazo terminou sem RDO {confirmacao ? 'fechado' : 'assinado'}.</div>}
        <div className="rdo-cal">
          {RDO_SEMANA.map(s => <div key={s} className="rdo-cal-sem">{s}</div>)}
          {Array.from({ length: primeiro }).map((_, i) => <div key={'v' + i} className="rdo-dia vazio" />)}
          {dias.map(x => {
            const cls = ['rdo-dia', x.situacao === 'futuro' ? 'futuro' : x.atrasado ? 'atrasado' : x.situacao !== 'sem_rdo' ? x.situacao : !x.util ? 'nu' : '',
              x.data === hoje ? 'hoje' : '', x.data === sel ? 'sel' : ''].filter(Boolean).join(' ')
            return (
              <button key={x.data} type="button" className={cls} disabled={x.situacao === 'futuro'} onClick={() => setSel(x.data)}
                aria-label={`${rdoDataLonga(x.data)}: ${x.atrasado ? 'em atraso' : rdoDiaTxt(x) || (x.util ? 'sem RDO' : 'não útil')}`}>
                <span className="n">{x.dia}</span>
                <span className="s">{x.atrasado ? 'Atraso' : rdoDiaTxt(x) || (x.feriado ? 'Feriado' : '')}</span>
                {x.retificacao && <span className="retif" />}
              </button>
            )
          })}
        </div>
        <div className="rdo-legenda">
          <span><i style={{ background: 'var(--tag-ok-bg)', borderColor: 'var(--tag-ok-bd)' }} />{rdoTxtFechado(confirmacao)}</span>
          <span><i style={{ background: 'var(--tag-alerta-bg)', borderColor: 'var(--tag-alerta-bd)' }} />Rascunho</span>
          <span><i style={{ background: 'var(--tag-perigo-bg)', borderColor: 'var(--tag-perigo-dot)' }} />Em atraso</span>
          <span><i style={{ background: 'var(--tag-neutro-bg)', borderColor: 'var(--tag-neutro-bd)' }} />Sem expediente</span>
          <span><i style={{ background: 'var(--surface-alt)' }} />Fim de semana / feriado</span>
          <span><i style={{ background: 'var(--fill-cobre)', borderRadius: '50%', width: 8, height: 8, border: 'none' }} />Retificação aberta</span>
        </div>
        {dia && (
          <div className={`rdo-painel-dia ${dia.atrasado ? 'perigo' : ''}`}>
            <div style={{ fontWeight: 700, color: 'var(--ink)', marginBottom: 4 }}>{rdoDataLonga(dia.data)}{dia.feriado ? ` · Feriado: ${dia.feriado}` : !dia.util ? ' · não útil' : ''}</div>
            {dia.rdo ? <>
              <div className="rdo-cab"><span>RDO <strong>{dia.rdo.numero}</strong>{dia.rdo.versao > 1 ? ` · versão ${dia.rdo.versao}` : ''}</span>
                <span>{dia.rdo.sem_expediente && dia.rdo.status === 'assinado' ? 'Sem expediente' : dia.rdo.status === 'assinado' ? rdoTxtFechado(!!dia.rdo.sem_desenho) : RDO_STATUS_TXT[dia.rdo.status]}</span>
                {dia.atrasado ? <span style={{ color: 'var(--tag-perigo-fg)', fontWeight: 700 }}>{confirmacao ? 'prazo vencido sem fechar' : 'prazo vencido sem assinatura'}</span> : null}</div>
              <div className="rdo-acoes">
                <button className="btn btn-primary btn-sm" onClick={() => setAberto(dia.rdo.id)}><Icon name="fileText" size={14} /> Abrir o RDO</button>
                <button className="btn btn-outline btn-sm" onClick={() => abrirDoc(`/rdo/${dia.rdo.id}/termo`, `${dia.rdo.numero} — ${estData(dia.data)}`)}><Icon name="fileText" size={14} /> PDF</button>
                {dia.retificacao && <button className="btn btn-outline btn-sm" onClick={() => setAberto(dia.retificacao.id)}><Icon name="edit" size={14} /> Retificação (versão {dia.retificacao.versao})</button>}
              </div>
            </> : dia.situacao === 'futuro' ? <p className="est-sub" style={{ margin: 0 }}>Dia que ainda não chegou.</p>
            : noPrazo ? (cal.pode_lancar ? <>
                <p className="est-sub" style={{ margin: '0 0 6px' }}>Sem RDO. Editável até {estData(dia.prazo)} às 23:59. O rascunho já vem com o que o sistema registrou no dia.</p>
                <div className="rdo-acoes"><button className="btn btn-primary btn-sm" disabled={busy} onClick={() => lancar(false)}><Icon name="plus" size={14} /> Lançar o RDO de {estData(dia.data).slice(0, 5)}</button></div>
              </> : <p className="est-sub" style={{ margin: 0 }}>Sem RDO. {cal.gestor ? 'Dentro do prazo, quem lança é a equipe da obra (apontador, engenheiro ou líder).' : 'Você não lança o RDO deste diário.'} Prazo: {estData(dia.prazo)} às 23:59.</p>)
            : cal.gestor ? <>
                <p className="est-sub" style={{ margin: '0 0 6px' }}>O prazo terminou em {estData(dia.prazo)} às 23:59. Fora do prazo, só o gestor lança — com o motivo, que sai no documento.</p>
                <input value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Motivo do lançamento fora do prazo (mín. 10 caracteres)" />
                <div className="rdo-acoes"><button className="btn btn-accent btn-sm" disabled={busy} onClick={() => lancar(true)}><Icon name="plus" size={14} /> Lançar fora do prazo</button></div>
              </> : <p className="est-sub" style={{ margin: 0 }}>O prazo terminou em {estData(dia.prazo)} às 23:59 sem RDO. Fora do prazo, só o gestor lança, com motivo.</p>}
          </div>
        )}
      </div></div>
      {ct.responsavel_tecnico ? <p className="est-sub" style={{ marginTop: 10 }}>{confirmacao ? 'Fecha' : 'Assina'} o RDO do contrato: <strong>{ct.responsavel_tecnico.nome}</strong>. O RDO de uma obra é {confirmacao ? 'fechado' : 'assinado'} pelo engenheiro dela.</p>
        : <div className="alert alert-warning" style={{ marginTop: 10 }}>O contrato ainda não tem o responsável técnico que {confirmacao ? 'fecha' : 'assina'} o RDO do contrato.{ct.pode_configurar ? ' Defina-o em “Configurar o diário”, abaixo.' : ' Peça ao gestor.'}</div>}
      {/* key: trocar de contrato monta um cartão novo (nada do anterior fica aberto nem é salvo no outro). */}
      {ct.pode_configurar ? <RdoConfigDiario key={ct.contrato_id} cid={ct.contrato_id} addToast={addToast} onSalvo={() => GET('/rdo/alvos').then(setAlvos).then(carregarCal).catch(() => {})} /> : null}
      </>}
    </div>
  )
}

function RdoEditor({ id, user, alvos, addToast, onVoltar, onAbrir }) {
  const [d, setD] = useState(null)              // o RDO como está no servidor
  const [f, setF] = useState(null)              // a cópia que a pessoa edita
  const [sujo, setSujo] = useState(false)
  const [secao, setSecao] = useState(null)
  const [abertos, setAbertos] = useState({ cond: true, efetivo: true, atividades: true })
  const [diaInfo, setDiaInfo] = useState(null)
  const [recuperar, setRecuperar] = useState(null)
  const [motivoFora, setMotivoFora] = useState('')
  const [busy, setBusy] = useState(false)
  const [pad, setPad] = useState(null)          // 'responsavel' | 'fiscal'
  const [ciente, setCiente] = useState({ nome: '', cargo: '', recusa: '', semAssinar: false })
  const [fotoVer, setFotoVer] = useState(null)
  const [fotoForm, setFotoForm] = useState({ legenda: '', obra_id: '' })
  const [nova, setNova] = useState({})          // formulários de "+ adicionar" por bloco
  const [declara, setDeclara] = useState(false) // fechamento por confirmação: a declaração marcada
  const [abrirDoc, docEl] = useRdoDocumento(addToast)   // PDF do dia (Fase 4)
  // A aba da seção escolhida aparece na faixa (no celular a da unidade do engenheiro ficava fora da tela, à direita);
  // a unidade escolhida para a foto em "Todas" não vale para outra seção.
  useEffect(() => {
    const el = document.querySelector('.rdo-secoes .uni-tab.active'); if (el) el.scrollIntoView({ block: 'nearest', inline: 'center' })
    setFotoForm(x => ({ ...x, obra_id: '' }))
  }, [secao])
  // Cópia no aparelho POR PESSOA (celular da obra é compartilhado); sair do sistema apaga as de todos (ver logout).
  const chave = `${RDO_CHAVE_LOCAL}${user.id}:${id}`
  const copia = x => JSON.parse(JSON.stringify({
    campos: { sem_expediente: x.sem_expediente ? 1 : 0, sem_expediente_motivo: x.sem_expediente_motivo || null, clima_manha: x.clima_manha || null, clima_tarde: x.clima_tarde || null,
      condicao_trabalho: x.condicao_trabalho || null, horas_paralisadas: x.horas_paralisadas ?? null, observacoes: x.observacoes || null },
    unidades: x.unidades || [], efetivo: x.efetivo || [], atividades: x.atividades || [], ocorrencias: x.ocorrencias || [], equipamentos: x.equipamentos || [] }))
  const carregar = async () => {
    const r = await GET('/rdo/' + id)
    setD(r)
    const c = copia(r)
    setF(c); setSujo(false)
    const g = rdoLerGuardado(chave)
    setRecuperar(g && r.status === 'rascunho' && JSON.stringify(g.f) !== JSON.stringify(c) ? g : null)
    if (!g || r.status !== 'rascunho') rdoGuardar(chave, null)
    return r
  }
  useEffect(() => {
    carregar().then(r => {
      // Seção padrão: o engenheiro abre na unidade dele; quem cuida de tudo (apontador, gestor, técnico), em "Todas".
      const ct = alvos.contratos.find(c => c.contrato_id === r.contrato_id)
      const minhas = !r.obra_id && ct && !ct.gestor && !alvos.visao_apontador && !ct.sou_responsavel ? ct.obras.filter(o => o.pode_lancar).map(o => o.id) : []
      setSecao(minhas.length && (r.unidades || []).some(u => u.obra_id === minhas[0]) ? minhas[0] : 'todas')
      GET(`/rdo/calendario?${r.obra_id ? `obra_id=${r.obra_id}` : `contrato_id=${r.contrato_id}`}&mes=${r.data.slice(0, 7)}`)
        .then(c => setDiaInfo(c.dias.find(x => x.data === r.data) || null)).catch(() => {})
    }).catch(e => { addToast(e.message, 'error'); onVoltar() })
  }, [])
  if (!d || !f) return <div className="empty"><p>Carregando o RDO…</p></div>
  const ct = alvos.contratos.find(c => c.contrato_id === d.contrato_id) || {}
  const alvoInfo = d.obra_id ? (ct.obras || []).find(o => o.id === d.obra_id) : ct
  const gestor = !!ct.gestor
  const rascunho = d.status === 'rascunho'
  const precisaMotivo = rascunho && d.versao === 1 && !d.no_prazo
  const podeRascunhar = !!(alvoInfo && alvoInfo.pode_lancar) || d.responsavel_id === user.id
  const podeEditar = rascunho && (precisaMotivo ? gestor : podeRascunhar)
  const souResp = d.responsavel_id === user.id
  // Rascunho: segue como o contrato fecha hoje. Assinado: como ESTE registro foi fechado (sem imagem = confirmação).
  const confirmar = rascunho && d.fechamento === 'confirmacao'
  const txtFechado = rdoTxtFechado(rascunho ? d.fechamento === 'confirmacao' : !!d.fechado_confirmacao)
  const apontador = !!d.resumo
  const doContrato = d.obra_id == null
  const unid = new Map((d.unidades || []).map(u => [u.obra_id, u.obra_nome]))
  const nomeUnid = o => (o == null ? (doContrato ? 'Volantes / sem unidade' : d.obra_nome) : unid.get(o) || d.obra_nome || 'Unidade')
  const sec = secao || 'todas'
  const naSecao = l => !doContrato || sec === 'todas' || (sec === 'volantes' ? l.obra_id == null : l.obra_id === sec)
  const obraNova = () => (!doContrato ? d.obra_id : sec === 'todas' || sec === 'volantes' ? null : sec)
  const mudar = fn => {
    setF(prev => {
      const n = fn(JSON.parse(JSON.stringify(prev)))
      rdoGuardar(chave, { f: n, edicao: d.edicao, sec, em: new Date().toISOString() })
      return n
    })
    setSujo(true)
  }
  const muda = (lista, i, campo, v) => mudar(n => { n[lista][i][campo] = v; return n })
  const tira = (lista, i) => mudar(n => { n[lista].splice(i, 1); return n })
  const salvar = async () => {
    if (precisaMotivo && motivoFora.trim().length < 10) { addToast('Fora do prazo: informe o motivo desta edição (mín. 10 caracteres).', 'error'); return false }
    const so = l => naSecao(l)
    // Seção: a versão dela que a tela leu (a da unidade + a do RDO inteiro) — outra pessoa salvou a MESMA unidade → 409.
    const es = d.edicao_secoes || {}
    const body = doContrato && sec !== 'todas'
      ? { secao: sec, base_edicao_secao: (es[String(sec)] || 0) + (es['*'] || 0),
          efetivo: f.efetivo.filter(so), atividades: f.atividades.filter(so), ocorrencias: f.ocorrencias.filter(so), equipamentos: f.equipamentos.filter(so),
          ...(sec !== 'volantes' ? { unidades: f.unidades.filter(u => u.obra_id === sec) } : {}) }
      : { ...f.campos, ...(doContrato ? { unidades: f.unidades } : {}), efetivo: f.efetivo, atividades: f.atividades, ocorrencias: f.ocorrencias, equipamentos: f.equipamentos, base_edicao: d.edicao }
    if (precisaMotivo) body.motivo_fora_prazo = motivoFora
    setBusy(true)
    try {
      await PUT('/rdo/' + id, body)
      rdoGuardar(chave, null)
      setMotivoFora('')   // fora do prazo, o motivo é pedido a cada gravação (um motivo não libera o RDO para sempre)
      addToast(doContrato && sec !== 'todas' ? `Seção ${nomeUnid(sec === 'volantes' ? null : sec)} salva.` : 'RDO salvo.', 'success')
      return await carregar()   // o RDO como ficou (quem chama — assinar, trocar de seção — usa a versão nova)
    } catch (e) {
      addToast(rdoSemSinal(e) ? 'Sem sinal: o que você digitou ficou guardado neste aparelho. Salve de novo quando o sinal voltar.' : e.message, rdoSemSinal(e) ? 'warning' : 'error')
      return false
    } finally { setBusy(false) }
  }
  const copiarOntem = async () => {
    try {
      const c = await GET(`/rdo/ontem?${doContrato ? `contrato_id=${d.contrato_id}` : `obra_id=${d.obra_id}`}&data=${d.data}`)
      if (!c.rdo) { addToast('Não há RDO anterior a este dia para copiar.', 'warning'); return }
      const so = l => naSecao(l)
      const ja = (lista, l, k) => lista.some(x => String(x[k] || '').trim() === String(l[k] || '').trim() && (x.obra_id ?? null) === (l.obra_id ?? null))
      // O que entra é decidido aqui, com a tela de agora (o atualizador do estado roda depois — contar lá dava sempre 0).
      const novas = Object.fromEntries([['efetivo', 'nome'], ['atividades', 'descricao'], ['equipamentos', 'descricao']]
        .map(([lista, campo]) => [lista, c[lista].filter(so).filter(l => !ja(f[lista], l, campo))]))
      const k = Object.values(novas).reduce((s, l) => s + l.length, 0)
      if (k) mudar(n => { for (const lista of Object.keys(novas)) n[lista].push(...novas[lista]); return n })
      addToast(k ? `Copiado do RDO de ${estData(c.rdo.data)}: ${k} linha(s). Confira a presença e salve.` : `Nada novo para copiar do RDO de ${estData(c.rdo.data)}.`, k ? 'success' : 'warning')
    } catch (e) { addToast(e.message, 'error') }
  }
  const assinar = async assinatura => {
    // Assina o que está na tela: a versão lida e as fotos mostradas (outra pessoa mexeu depois → 409, abrir de novo).
    // Com alteração pendente, salva antes e assina a versão que o salvar trouxe. Contrato que fecha por confirmação:
    // sem imagem, com a declaração marcada.
    let atual = d
    if (sujo) { const r = await salvar(); if (!r) return; atual = r }
    setBusy(true)
    try {
      // `modo`: o jeito de fechar que a tela mostrou — o gestor mudou depois → 409 e a tela recarrega (nunca fecha de
      // outro jeito sem a pessoa ver).
      const r = await POST(`/rdo/${id}/assinar`, { ...(confirmar ? { confirmacao: true } : assinatura ? { assinatura } : {}), modo: confirmar ? 'confirmacao' : 'assinatura',
        base_edicao: atual.edicao, base_fotos: (atual.fotos || []).map(p => p.id) })
      setPad(null); setDeclara(false); addToast(r.modo === 'confirmacao' ? 'RDO fechado.' : 'RDO assinado.', 'success'); await carregar()
    } catch (e) {
      const mudou = e.data && e.data.modo && e.data.modo !== d.fechamento
      if (mudou) { setPad(null); setDeclara(false); await carregar().catch(() => {}) }
      else if (!assinatura && /Assine na tela/.test(e.message)) setPad('responsavel')
      addToast(e.message, 'error')
    } finally { setBusy(false) }
  }
  const registrarCiente = async assinatura => {
    setBusy(true)
    try {
      await POST(`/rdo/${id}/ciente-fiscal`, assinatura ? { nome: ciente.nome, cargo: ciente.cargo, assinatura } : { nome: ciente.nome || null, recusa: ciente.recusa })
      setPad(null); addToast('Ciente do fiscal registrado.', 'success'); await carregar()
    } catch (e) { addToast(e.message, 'error') } finally { setBusy(false) }
  }
  const retificar = async () => {
    const motivo = window.prompt(`Retificar o RDO ${d.numero}? Abre uma versão nova em rascunho; a versão ${d.fechado_confirmacao ? 'fechada' : 'assinada'} continua valendo até o responsável ${d.fechamento === 'confirmacao' ? 'fechar' : 'assinar'} a nova.\n\nMotivo (mín. 10 caracteres):`)
    if (motivo == null) return
    try { const r = await POST(`/rdo/${id}/retificar`, { motivo }); addToast(`Versão ${r.versao} aberta.`, 'success'); onAbrir(r.id) } catch (e) { addToast(e.message, 'error') }
  }
  const cancelar = async () => {
    const motivo = window.prompt(`Cancelar o rascunho ${d.numero}? O dia volta a aceitar um RDO novo.\n\nMotivo:`)
    if (motivo == null) return
    try { await POST(`/rdo/${id}/cancelar`, { motivo }); rdoGuardar(chave, null); addToast('Rascunho cancelado.', 'success'); onVoltar() } catch (e) { addToast(e.message, 'error') }
  }
  const enviarFoto = async file => {
    if (!file) return
    setBusy(true)
    try {
      const [imagem, miniatura] = await Promise.all([comprimirImagem(file, 1600, 0.75), comprimirImagem(file, 240, 0.6)])
      // A unidade escolhida no formulário só vale em "Todas"; numa seção, a foto é daquela seção.
      const obra = !doContrato ? null : sec !== 'todas' ? obraNova() : fotoForm.obra_id === '' ? null : Number(fotoForm.obra_id)
      if (precisaMotivo && motivoFora.trim().length < 10) { addToast('Fora do prazo: informe o motivo (mín. 10 caracteres).', 'error'); return }
      const r = await POST(`/rdo/${id}/fotos`, { imagem, miniatura, legenda: fotoForm.legenda, obra_id: obra, ...(precisaMotivo ? { motivo_fora_prazo: motivoFora } : {}) })
      setD(x => ({ ...x, fotos: [...(x.fotos || []), r.foto] })); setFotoForm(ff => ({ ...ff, legenda: '' })); setMotivoFora(''); addToast('Foto anexada.', 'success')
    } catch (e) { addToast(rdoSemSinal(e) ? 'Sem sinal: a foto não foi enviada. Tente de novo.' : e.message, 'error') } finally { setBusy(false) }
  }
  const verFoto = async ft => {
    setFotoVer({ ...ft, src: null })
    try {
      const resp = await fetch(`/api/rdo/${id}/fotos/${ft.id}`, { headers: { Authorization: `Bearer ${token.value}` } })
      if (!resp.ok) throw new Error((await resp.json().catch(() => ({}))).error || 'Foto indisponível.')
      const confere = resp.headers.get('X-Foto-Confere') !== '0'
      const blob = await resp.blob()
      const src = await new Promise((ok, erro) => { const fr = new FileReader(); fr.onload = () => ok(fr.result); fr.onerror = erro; fr.readAsDataURL(blob) })
      setFotoVer({ ...ft, src, confere })
    } catch (e) { setFotoVer(null); addToast(e.message, 'error') }
  }
  const apagarFoto = async ft => {
    if (precisaMotivo && motivoFora.trim().length < 10) { addToast('Fora do prazo: informe o motivo (mín. 10 caracteres).', 'error'); return }
    if (!window.confirm('Tirar esta foto do RDO?')) return
    try {
      await DEL(`/rdo/${id}/fotos/${ft.id}${precisaMotivo ? '?motivo_fora_prazo=' + encodeURIComponent(motivoFora) : ''}`)
      setD(x => ({ ...x, fotos: x.fotos.filter(p => p.id !== ft.id) })); setFotoVer(null); setMotivoFora('')
    } catch (e) { addToast(e.message, 'error') }
  }
  const novaLinha = (bloco, linha) => { mudar(n => { n[bloco].push({ obra_id: obraNova(), ...linha }); return n }); setNova(x => ({ ...x, [bloco]: null })) }
  const Lista = (lista, vazio, render) => {
    const linhas = f[lista].map((l, i) => [l, i]).filter(([l]) => naSecao(l))
    return linhas.length ? linhas.map(([l, i]) => <div key={i} className="rdo-linha">{render(l, i)}</div>) : <p className="est-sub" style={{ margin: 0 }}>{vazio}</p>
  }
  const UnidTag = ({ o }) => (doContrato && sec === 'todas' ? <span className="sub">{nomeUnid(o)}</span> : null)
  const calc = lista => (d[lista] || []).filter(naSecao)
  const ef = f.efetivo.filter(naSecao)
  const ro = !podeEditar
  const ausentes = d.calculadas_ausentes
  const integro = d.integridade && d.integridade.hash_confere !== null
    ? d.integridade.hash_confere && d.integridade.conteudo_confere && d.integridade.cadeia_confere && d.ciente_confere !== false : null
  const unidSec = doContrato && sec !== 'todas' && sec !== 'volantes' ? f.unidades.findIndex(u => u.obra_id === sec) : -1
  // PDF do dia: mostra o que está SALVO no servidor — com alteração não salva nesta tela, avisa antes.
  const pdfDoDia = () => {
    if (sujo && !window.confirm('O PDF mostra o que está salvo. Há alterações não salvas nesta tela — abrir assim mesmo?')) return
    abrirDoc(`/rdo/${id}/termo`, `${d.numero}${d.versao > 1 ? ` v${d.versao}` : ''} — ${estData(d.data)}`)
  }
  return (
    <div style={{ maxWidth: 860, margin: '0 auto' }}>
      {docEl}
      <div className="topbar"><h2>{d.numero}{d.versao > 1 ? ` · v${d.versao}` : ''}</h2>
        <div className="topbar-actions"><button className="btn btn-outline btn-sm" onClick={pdfDoDia}><Icon name="fileText" size={14} /> PDF</button>
          <button className="btn btn-ghost btn-sm" onClick={() => { if (!sujo || window.confirm('Sair sem salvar? O que você digitou fica guardado neste aparelho.')) onVoltar() }}>← Calendário</button></div></div>
      <div className="card" style={{ marginBottom: 12 }}><div className="card-body" style={{ padding: 14 }}>
        <div className="rdo-cab" style={{ marginBottom: 6 }}>
          <strong style={{ fontSize: '.95rem' }}>{rdoDataLonga(d.data)}</strong>
          <span className="badge" style={{ background: `var(--tag-${d.status === 'assinado' ? 'ok' : d.status === 'rascunho' ? 'alerta' : 'neutro'}-bg)`, color: `var(--tag-${d.status === 'assinado' ? 'ok' : d.status === 'rascunho' ? 'alerta' : 'neutro'}-fg)` }}>{d.status === 'assinado' ? txtFechado : RDO_STATUS_TXT[d.status]}</span>
          {integro === true && <span className="badge" style={{ background: 'var(--tag-ok-bg)', color: 'var(--tag-ok-fg)' }}><Icon name="shield" size={12} /> Íntegro</span>}
          {integro === false && <span className="badge" style={{ background: 'var(--tag-perigo-bg)', color: 'var(--tag-perigo-fg)' }}><Icon name="alertTriangle" size={12} /> Verificar integridade</span>}
        </div>
        <div className="rdo-cab">
          <span>{doContrato ? <>RDO do contrato <strong>{d.contrato_nome}</strong></> : <>Obra <strong>{d.obra_nome}</strong></>}</span>
          <span>{(rascunho ? d.fechamento === 'confirmacao' : !!d.fechado_confirmacao) ? 'Fecha' : 'Assina'}: <strong>{d.responsavel_nome || '— a definir'}</strong></span>
          {rascunho && d.versao === 1 && <span>{d.no_prazo ? `Editável até ${estData(d.prazo_edicao)} às 23:59` : `Prazo terminou em ${estData(d.prazo_edicao)}`}</span>}
          {d.assinado_em && <span>{txtFechado} por {d.assinado_por_nome} em {String(d.assinado_em).slice(0, 16).split(' ').map((p, i) => i ? p : estData(p)).join(' ')}</span>}
        </div>
        {d.lancado_fora_prazo ? <div className="alert alert-warning" style={{ margin: '10px 0 0' }}>Registrado fora do prazo — motivo: {d.motivo_fora_prazo}</div> : null}
        {d.versao > 1 && <div className="alert alert-info" style={{ margin: '10px 0 0' }}>Retificação{d.versao_origem ? ` da versão ${d.versao_origem}` : ''}: {d.retificacao_motivo}</div>}
        {(d.versoes || []).length > 1 && <div className="rdo-inline" style={{ marginTop: 8 }}>{d.versoes.map(v => (
          <button key={v.id} className={`btn btn-sm ${v.id === d.id ? 'btn-primary' : 'btn-ghost'}`} onClick={() => v.id !== d.id && onAbrir(v.id)}>v{v.versao} · {v.status === 'assinado' ? rdoTxtFechado(!!v.sem_desenho) : RDO_STATUS_TXT[v.status]}{v.vigente ? ' (vale)' : ''}</button>))}</div>}
      </div></div>
      {recuperar && <div className="alert alert-warning">
        Há alterações deste aparelho que não foram enviadas ({new Date(recuperar.em).toLocaleString('pt-BR').slice(0, 17)}).{recuperar.edicao !== d.edicao ? ' Depois disso, alguém salvou o RDO: recuperar troca o que está na tela pelo que você digitou.' : ''}
        <div className="rdo-acoes"><button className="btn btn-primary btn-sm" onClick={() => { setF(recuperar.f); if (recuperar.sec != null) setSecao(recuperar.sec); setSujo(true); setRecuperar(null) }}>Recuperar</button>
          <button className="btn btn-ghost btn-sm" onClick={() => { rdoGuardar(chave, null); setRecuperar(null) }}>Descartar</button></div>
      </div>}
      {rascunho && !podeEditar && <div className="alert alert-info">{precisaMotivo ? 'O prazo terminou: só o gestor edita, com motivo.' : 'Você pode ler este rascunho; quem lança é a equipe da obra.'}</div>}
      {diaInfo && !diaInfo.util && rascunho && !f.campos.sem_expediente && podeEditar && sec === 'todas' && (
        <div className="alert alert-info">{diaInfo.feriado ? `Feriado: ${diaInfo.feriado}` : RDO_SEMANA[rdoSemana(d.data)] === 'sáb' ? 'Sábado' : RDO_SEMANA[rdoSemana(d.data)] === 'dom' ? 'Domingo' : 'Dia não útil'} no calendário do contrato.
          <div className="rdo-acoes"><button className="btn btn-outline btn-sm" onClick={() => mudar(n => { n.campos.sem_expediente = 1; n.campos.sem_expediente_motivo = diaInfo.feriado ? `Feriado: ${diaInfo.feriado}` : RDO_SEMANA[rdoSemana(d.data)] === 'sáb' ? 'Sábado' : 'Domingo'; return n })}>Marcar dia sem expediente</button></div></div>
      )}
      {doContrato && (
        <div className="rdo-secoes" role="tablist" aria-label="Seção">
          {[['todas', 'Todas'], ...f.unidades.map(u => [u.obra_id, u.obra_nome]), ['volantes', 'Volantes']].map(([v, l]) => (
            <button key={String(v)} role="tab" aria-selected={sec === v} className={`uni-tab ${sec === v ? 'active' : ''}`} onClick={async () => {
              // Cada gravação leva só a seção da tela: com alteração pendente, salva antes de trocar (senão o que foi
              // digitado aqui não iria com a próxima gravação, de outra seção).
              if (v === sec) return
              if (sujo) {
                if (!ro && !window.confirm('Há alterações não salvas nesta seção. Salvar agora e trocar?')) return
                if (!ro && !(await salvar())) return
              }
              setSecao(v)
            }}>{l}</button>))}
        </div>
      )}
      {doContrato && sec !== 'todas' && <p className="est-sub" style={{ margin: '-4px 0 10px' }}>Salvar grava só a seção {nomeUnid(sec === 'volantes' ? null : sec)} — as outras unidades ficam como estão.</p>}

      <RdoBloco id="cond" icon="sun" titulo="Condições do dia" abertos={abertos} setAbertos={setAbertos}
        cont={sec === 'todas' ? (f.campos.sem_expediente ? 'sem expediente' : [f.campos.clima_manha, f.campos.clima_tarde].filter(Boolean).length + '/2 climas') : null}>
        {(sec === 'todas' || !doContrato) ? <>
          <div className="form-group" style={{ marginBottom: 10 }}>
            <label style={{ display: 'flex', gap: 8, alignItems: 'center' }}><input type="checkbox" style={{ width: 'auto' }} disabled={ro} checked={!!f.campos.sem_expediente}
              onChange={e => mudar(n => { n.campos.sem_expediente = e.target.checked ? 1 : 0; return n })} /> Dia sem expediente</label>
            {!!f.campos.sem_expediente && <input value={f.campos.sem_expediente_motivo || ''} disabled={ro} placeholder="Motivo (ex.: Feriado, Chuva forte o dia todo)" onChange={e => mudar(n => { n.campos.sem_expediente_motivo = e.target.value; return n })} />}
          </div>
          {!f.campos.sem_expediente && <>
            <div className="form-group" style={{ marginBottom: 10 }}><label>Clima — manhã</label><RdoSeg opcoes={RDO_CLIMAS} valor={f.campos.clima_manha} disabled={ro} limpar onChange={v => mudar(n => { n.campos.clima_manha = v; return n })} /></div>
            <div className="form-group" style={{ marginBottom: 10 }}><label>Clima — tarde</label><RdoSeg opcoes={RDO_CLIMAS} valor={f.campos.clima_tarde} disabled={ro} limpar onChange={v => mudar(n => { n.campos.clima_tarde = v; return n })} /></div>
            <div className="form-group" style={{ marginBottom: 10 }}><label>Condição de trabalho</label><RdoSeg opcoes={RDO_CONDICOES} valor={f.campos.condicao_trabalho} disabled={ro} limpar onChange={v => mudar(n => { n.campos.condicao_trabalho = v; return n })} /></div>
            <div className="form-group" style={{ marginBottom: 10, maxWidth: 220 }}><label>Horas paralisadas</label><input type="number" min="0" max="24" step="0.5" disabled={ro} value={f.campos.horas_paralisadas ?? ''} onChange={e => mudar(n => { n.campos.horas_paralisadas = e.target.value === '' ? null : e.target.value; return n })} /></div>
          </>}
          <div className="form-group"><label>Observações</label><textarea rows={3} disabled={ro} value={f.campos.observacoes || ''} onChange={e => mudar(n => { n.campos.observacoes = e.target.value; return n })} /></div>
        </> : unidSec >= 0 ? <>
          <p className="est-sub" style={{ margin: '0 0 8px' }}>Em branco, vale o clima geral do RDO.</p>
          <div className="form-group" style={{ marginBottom: 10 }}><label>Clima — manhã</label><RdoSeg opcoes={RDO_CLIMAS} valor={f.unidades[unidSec].clima_manha || null} disabled={ro} limpar onChange={v => muda('unidades', unidSec, 'clima_manha', v)} /></div>
          <div className="form-group" style={{ marginBottom: 10 }}><label>Clima — tarde</label><RdoSeg opcoes={RDO_CLIMAS} valor={f.unidades[unidSec].clima_tarde || null} disabled={ro} limpar onChange={v => muda('unidades', unidSec, 'clima_tarde', v)} /></div>
          <div className="form-group" style={{ marginBottom: 10 }}><label>Condição de trabalho</label><RdoSeg opcoes={RDO_CONDICOES} valor={f.unidades[unidSec].condicao_trabalho || null} disabled={ro} limpar onChange={v => muda('unidades', unidSec, 'condicao_trabalho', v)} /></div>
          <div className="form-group" style={{ marginBottom: 10 }}><label style={{ display: 'flex', gap: 8, alignItems: 'center' }}><input type="checkbox" style={{ width: 'auto' }} disabled={ro} checked={!!f.unidades[unidSec].afetou_servico} onChange={e => muda('unidades', unidSec, 'afetou_servico', e.target.checked ? 1 : 0)} /> O clima afetou o serviço nesta unidade</label></div>
          <div className="form-group"><label>Observações da unidade</label><textarea rows={2} disabled={ro} value={f.unidades[unidSec].observacoes || ''} onChange={e => muda('unidades', unidSec, 'observacoes', e.target.value)} /></div>
        </> : <p className="est-sub" style={{ margin: 0 }}>As condições gerais do dia ficam em “Todas”.</p>}
      </RdoBloco>

      <RdoBloco id="efetivo" icon="users" titulo="Efetivo" abertos={abertos} setAbertos={setAbertos}
        cont={`${ef.length} · ${ef.filter(p => p.presente === 1).length} presentes · ${ef.filter(p => p.presente == null).length} a confirmar`}>
        {Lista('efetivo', 'Ninguém no efetivo desta seção.', (p, i) => <>
          <div className="rdo-linha-top"><span className="nm">{p.nome} {p.origem === 'auto' && <RdoSelo />}<span className="sub">{[p.funcao, p.empresa || (p.proprio ? null : 'terceiro')].filter(Boolean).join(' · ')}</span><UnidTag o={p.obra_id} /></span>
            {!ro && p.origem !== 'auto' && <button className="btn btn-ghost btn-sm" aria-label="Tirar" onClick={() => tira('efetivo', i)}><Icon name="trash" size={14} /></button>}</div>
          <div className="rdo-inline"><RdoSeg opcoes={[[null, 'A confirmar'], [1, 'Presente', 'ok'], [0, 'Ausente', 'no']]} valor={p.presente ?? null} disabled={ro} onChange={v => muda('efetivo', i, 'presente', v)} />
            <input type="number" min="0" max="24" step="0.5" placeholder="horas" aria-label="Horas" disabled={ro} value={p.horas ?? ''} onChange={e => muda('efetivo', i, 'horas', e.target.value === '' ? null : e.target.value)} /></div>
        </>)}
        {!ro && <div className="rdo-acoes">
          {nova.efetivo ? <div className="form-grid" style={{ width: '100%' }}>
            <div className="form-group"><label>Nome *</label><input value={nova.efetivo.nome || ''} onChange={e => setNova(x => ({ ...x, efetivo: { ...x.efetivo, nome: e.target.value } }))} /></div>
            <div className="form-group"><label>Função</label><input value={nova.efetivo.funcao || ''} onChange={e => setNova(x => ({ ...x, efetivo: { ...x.efetivo, funcao: e.target.value } }))} /></div>
            <div className="form-group"><label>Empresa (terceiro)</label><input value={nova.efetivo.empresa || ''} placeholder="vazio = própria" onChange={e => setNova(x => ({ ...x, efetivo: { ...x.efetivo, empresa: e.target.value } }))} /></div>
            <div className="form-group full rdo-inline"><button className="btn btn-primary btn-sm" onClick={() => { const v = nova.efetivo; if (!String(v.nome || '').trim()) { addToast('Informe o nome.', 'error'); return } novaLinha('efetivo', { nome: v.nome.trim(), funcao: v.funcao || null, empresa: v.empresa || null, proprio: v.empresa ? 0 : 1, presente: 1, horas: null, origem: 'manual' }) }}>Incluir</button>
              <button className="btn btn-ghost btn-sm" onClick={() => setNova(x => ({ ...x, efetivo: null }))}>Cancelar</button></div>
          </div> : <>
            <button className="btn btn-outline btn-sm" onClick={() => setNova(x => ({ ...x, efetivo: {} }))}><Icon name="userPlus" size={14} /> Pessoa</button>
            <button className="btn btn-ghost btn-sm" onClick={copiarOntem}><Icon name="history" size={14} /> Copiar de ontem</button>
          </>}
        </div>}
      </RdoBloco>

      <RdoBloco id="ferramentas" icon="wrench" titulo="Ferramentas e equipamentos" abertos={abertos} setAbertos={setAbertos} cont={`${calc('ferramentas').length} + ${f.equipamentos.filter(naSecao).length} locados`}>
        {ausentes ? <p className="est-sub">{ausentes}</p> : calc('ferramentas').length ? calc('ferramentas').map((x, i) => (
          <div key={i} className="rdo-linha"><div className="rdo-linha-top"><span className="nm">{x.ferramenta}{x.quantidade > 1 ? ` ×${x.quantidade}` : ''}<span className="sub">{[x.codigo, x.responsavel_nome && `com ${x.responsavel_nome}`, x.cautela_numero, x.via_apontador ? 'entregue pelo apontador' : null].filter(Boolean).join(' · ')}</span><UnidTag o={x.obra_id} /></span>
            {x.valor_unitario != null && <span className="est-sub">{estBRL(x.valor_unitario)}</span>}</div></div>))
          : <p className="est-sub" style={{ margin: 0 }}>Nenhuma ferramenta em cautela no fim do dia, pelos registros do sistema.</p>}
        <div style={{ fontWeight: 700, fontSize: '.82rem', margin: '12px 0 4px', color: 'var(--text-secondary)' }}>Locados ou de terceiros</div>
        {Lista('equipamentos', 'Nenhum equipamento locado ou de terceiro.', (e, i) => <>
          <div className="rdo-linha-top"><span className="nm">{e.descricao}{e.quantidade != null ? ` ×${String(e.quantidade).replace('.', ',')}` : ''}<span className="sub">{[e.empresa, e.observacao].filter(Boolean).join(' · ')}</span><UnidTag o={e.obra_id} /></span>
            {!ro && <button className="btn btn-ghost btn-sm" aria-label="Tirar" onClick={() => tira('equipamentos', i)}><Icon name="trash" size={14} /></button>}</div>
        </>)}
        {!ro && (nova.equipamentos ? <div className="form-grid" style={{ marginTop: 8 }}>
          <div className="form-group"><label>Equipamento *</label><input value={nova.equipamentos.descricao || ''} placeholder="ex.: Betoneira 400 L" onChange={e => setNova(x => ({ ...x, equipamentos: { ...x.equipamentos, descricao: e.target.value } }))} /></div>
          <div className="form-group"><label>Quantidade</label><input type="number" min="0" value={nova.equipamentos.quantidade ?? ''} onChange={e => setNova(x => ({ ...x, equipamentos: { ...x.equipamentos, quantidade: e.target.value } }))} /></div>
          <div className="form-group"><label>Empresa</label><input value={nova.equipamentos.empresa || ''} onChange={e => setNova(x => ({ ...x, equipamentos: { ...x.equipamentos, empresa: e.target.value } }))} /></div>
          <div className="form-group full rdo-inline"><button className="btn btn-primary btn-sm" onClick={() => { const v = nova.equipamentos; if (!String(v.descricao || '').trim()) { addToast('Descreva o equipamento.', 'error'); return } novaLinha('equipamentos', { descricao: v.descricao.trim(), quantidade: v.quantidade === '' ? null : v.quantidade ?? null, empresa: v.empresa || null, observacao: null }) }}>Incluir</button>
            <button className="btn btn-ghost btn-sm" onClick={() => setNova(x => ({ ...x, equipamentos: null }))}>Cancelar</button></div>
        </div> : <div className="rdo-acoes"><button className="btn btn-outline btn-sm" onClick={() => setNova(x => ({ ...x, equipamentos: {} }))}><Icon name="plus" size={14} /> Locado / de terceiro</button></div>)}
      </RdoBloco>

      <RdoBloco id="materiais" icon="truck" titulo="Materiais recebidos" abertos={abertos} setAbertos={setAbertos} cont={apontador ? d.resumo.materiais : calc('materiais').length}>
        {ausentes ? <p className="est-sub">{ausentes}</p> : apontador ? <p className="est-sub" style={{ margin: 0 }}>{d.resumo.materiais} entrega(s) registrada(s) no sistema neste dia — o detalhe fica com quem assina o RDO.</p>
          : calc('materiais').length ? calc('materiais').map((m, i) => (
            <div key={i} className="rdo-linha"><div className="rdo-linha-top"><span className="nm">{m.remessa_numero}{m.pedido_numero ? <span className="sub">pedido {m.pedido_numero}</span> : null}<span className="sub">{(m.itens || []).map(it => `${it.nome}: ${String(it.qtd).replace('.', ',')}${it.unidade ? ' ' + it.unidade : ''}`).join(' · ')}</span><UnidTag o={m.obra_id} /></span>
              {m.sem_assinatura ? <span className="badge" style={{ background: 'var(--tag-alerta-bg)', color: 'var(--tag-alerta-fg)', whiteSpace: 'normal' }}>Entrega registrada sem assinatura</span> : <span className="badge" style={{ background: 'var(--tag-ok-bg)', color: 'var(--tag-ok-fg)' }}>{m.forma === 'recebimento' ? 'Recebimento assinado' : 'Entrega assinada'}</span>}</div></div>))
          : <p className="est-sub" style={{ margin: 0 }}>Nenhuma entrega de material registrada no sistema neste dia.</p>}
        {!ausentes && !apontador && <p className="est-sub" style={{ margin: '8px 0 0', fontSize: '.72rem' }}>{d.nota_materiais}</p>}
      </RdoBloco>

      <RdoBloco id="epi" icon="shirt" titulo="EPI e uniformes" abertos={abertos} setAbertos={setAbertos} cont={calc('epi').length}>
        {ausentes ? <p className="est-sub">{ausentes}</p> : calc('epi').length ? calc('epi').map((e, i) => (
          <div key={i} className="rdo-linha"><div className="rdo-linha-top"><span className="nm">{e.item}<span className="sub">{e.categoria}</span><UnidTag o={e.obra_id} /></span><strong>{String(e.quantidade).replace('.', ',')}</strong></div></div>))
          : <p className="est-sub" style={{ margin: 0 }}>Nenhuma entrega de EPI ou uniforme registrada neste dia.</p>}
      </RdoBloco>

      <RdoBloco id="atividades" icon="clipboard" titulo="Atividades" abertos={abertos} setAbertos={setAbertos}
        cont={`${f.atividades.filter(naSecao).length}${apontador && d.resumo.atividades_manutencao ? ` + ${d.resumo.atividades_manutencao} do cronograma` : ''}`}>
        {apontador && d.resumo.atividades_manutencao > 0 && <p className="est-sub" style={{ margin: '0 0 6px' }}>Mais {d.resumo.atividades_manutencao} atividade(s) de manutenção do cronograma — o detalhe fica com quem assina.</p>}
        {Lista('atividades', 'Nenhuma atividade nesta seção.', (a, i) => <>
          <div className="rdo-linha-top"><span className="nm">{a.origem === 'auto' || ro ? a.descricao : null}{a.origem === 'auto' && <> <RdoSelo /></>}
            <span className="sub">{[a.local, a.etapa_nome].filter(Boolean).join(' · ')}</span><UnidTag o={a.obra_id} /></span>
            {!ro && a.origem !== 'auto' && <button className="btn btn-ghost btn-sm" aria-label="Tirar" onClick={() => tira('atividades', i)}><Icon name="trash" size={14} /></button>}</div>
          {!ro && a.origem !== 'auto' && <textarea rows={2} value={a.descricao} onChange={e => muda('atividades', i, 'descricao', e.target.value)} />}
          <div className="rdo-inline"><RdoSeg opcoes={RDO_ATIV} valor={a.status || null} disabled={ro} limpar onChange={v => muda('atividades', i, 'status', v)} />
            <span className="rdo-inline" style={{ gap: 4 }}><input type="number" min="0" max="100" placeholder="0" aria-label="% de avanço" disabled={ro} value={a.pct_avanco ?? ''} onChange={e => muda('atividades', i, 'pct_avanco', e.target.value === '' ? null : e.target.value)} /><span className="est-sub">% feito</span></span></div>
          {(a.status === 'nao_executada' || a.status === 'parcial' || a.motivo) && <input value={a.motivo || ''} disabled={ro} placeholder={a.status === 'nao_executada' ? 'Por que não foi executada?' : 'Observação / motivo'} onChange={e => muda('atividades', i, 'motivo', e.target.value)} />}
        </>)}
        {!ro && (nova.atividades ? <div className="form-grid" style={{ marginTop: 8 }}>
          <div className="form-group full"><label>Atividade *</label><textarea rows={2} value={nova.atividades.descricao || ''} onChange={e => setNova(x => ({ ...x, atividades: { ...x.atividades, descricao: e.target.value } }))} /></div>
          <div className="form-group"><label>Local</label><input value={nova.atividades.local || ''} onChange={e => setNova(x => ({ ...x, atividades: { ...x.atividades, local: e.target.value } }))} /></div>
          <div className="form-group full rdo-inline"><button className="btn btn-primary btn-sm" onClick={() => { const v = nova.atividades; if (!String(v.descricao || '').trim()) { addToast('Descreva a atividade.', 'error'); return } novaLinha('atividades', { descricao: v.descricao.trim(), local: v.local || null, status: null, pct_avanco: null, motivo: null, origem: 'manual' }) }}>Incluir</button>
            <button className="btn btn-ghost btn-sm" onClick={() => setNova(x => ({ ...x, atividades: null }))}>Cancelar</button></div>
        </div> : <div className="rdo-acoes"><button className="btn btn-outline btn-sm" onClick={() => setNova(x => ({ ...x, atividades: {} }))}><Icon name="plus" size={14} /> Atividade</button></div>)}
      </RdoBloco>

      <RdoBloco id="servicos" icon="worker" titulo="Serviços extras" abertos={abertos} setAbertos={setAbertos} cont={apontador ? d.resumo.servicos_extras : calc('servicos_extras').length}>
        {ausentes ? <p className="est-sub">{ausentes}</p> : apontador ? <p className="est-sub" style={{ margin: 0 }}>{d.resumo.servicos_extras} serviço(s) extra(s) neste dia — o detalhe fica com quem assina o RDO.</p>
          : calc('servicos_extras').length ? calc('servicos_extras').map((s, i) => (
            <div key={i} className="rdo-linha"><div className="rdo-linha-top"><span className="nm">{s.numero} — {s.descricao}<span className="sub">{[s.solicitante_nome && `pedido por ${s.solicitante_nome}`, (s.pessoas || []).map(p => p.nome).join(', '), s.horas_total != null ? `${String(s.horas_total).replace('.', ',')} h` : null].filter(Boolean).join(' · ')}</span><UnidTag o={s.obra_id} /></span>
              <span className="est-sub">{s.aceite === 'assinado' ? 'Fiscal assinou' : s.aceite === 'recusado' ? 'Sem assinatura do fiscal' : s.status === 'em_execucao' ? 'Em execução' : ''}</span></div></div>))
          : <p className="est-sub" style={{ margin: 0 }}>Nenhum serviço extra registrado neste dia.</p>}
      </RdoBloco>

      <RdoBloco id="ocorrencias" icon="alertTriangle" titulo="Ocorrências" abertos={abertos} setAbertos={setAbertos} cont={f.ocorrencias.filter(naSecao).length}>
        {Lista('ocorrencias', 'Nenhuma ocorrência nesta seção.', (o, i) => <>
          <div className="rdo-linha-top"><span className="nm">{(RDO_OCORR.find(t => t[0] === o.tipo) || [0, o.tipo])[1]} {o.origem === 'auto' && <RdoSelo />}<UnidTag o={o.obra_id} /></span>
            {!ro && o.origem !== 'auto' && <button className="btn btn-ghost btn-sm" aria-label="Tirar" onClick={() => tira('ocorrencias', i)}><Icon name="trash" size={14} /></button>}</div>
          {o.origem === 'auto' || ro ? <p style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: '.88rem' }}>{o.descricao}</p>
            : <><select value={o.tipo} onChange={e => muda('ocorrencias', i, 'tipo', e.target.value)}>{RDO_OCORR.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
              <textarea rows={2} value={o.descricao} onChange={e => muda('ocorrencias', i, 'descricao', e.target.value)} /></>}
          <div className="rdo-inline"><label style={{ display: 'flex', gap: 6, alignItems: 'center', fontWeight: 600 }}><input type="checkbox" style={{ width: 'auto' }} disabled={ro} checked={!!o.impacto_prazo} onChange={e => muda('ocorrencias', i, 'impacto_prazo', e.target.checked ? 1 : 0)} /> Impacta o prazo</label>
            <input type="number" min="0" max="24" step="0.5" placeholder="horas" aria-label="Horas" disabled={ro} value={o.horas ?? ''} onChange={e => muda('ocorrencias', i, 'horas', e.target.value === '' ? null : e.target.value)} /></div>
        </>)}
        {!ro && (nova.ocorrencias ? <div className="form-grid" style={{ marginTop: 8 }}>
          <div className="form-group"><label>Tipo *</label><select value={nova.ocorrencias.tipo || ''} onChange={e => setNova(x => ({ ...x, ocorrencias: { ...x.ocorrencias, tipo: e.target.value } }))}><option value="">Escolha…</option>{RDO_OCORR.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select></div>
          <div className="form-group full"><label>Descrição *</label><textarea rows={2} value={nova.ocorrencias.descricao || ''} onChange={e => setNova(x => ({ ...x, ocorrencias: { ...x.ocorrencias, descricao: e.target.value } }))} /></div>
          <div className="form-group full rdo-inline"><button className="btn btn-primary btn-sm" onClick={() => { const v = nova.ocorrencias; if (!v.tipo || !String(v.descricao || '').trim()) { addToast('Escolha o tipo e descreva a ocorrência.', 'error'); return } novaLinha('ocorrencias', { tipo: v.tipo, descricao: v.descricao.trim(), impacto_prazo: 0, horas: null, origem: 'manual' }) }}>Incluir</button>
            <button className="btn btn-ghost btn-sm" onClick={() => setNova(x => ({ ...x, ocorrencias: null }))}>Cancelar</button></div>
        </div> : <div className="rdo-acoes"><button className="btn btn-outline btn-sm" onClick={() => setNova(x => ({ ...x, ocorrencias: {} }))}><Icon name="plus" size={14} /> Ocorrência</button></div>)}
      </RdoBloco>

      <RdoBloco id="fotos" icon="camera" titulo="Fotos" abertos={abertos} setAbertos={setAbertos} cont={(d.fotos || []).filter(naSecao).length}>
        {(d.fotos || []).filter(naSecao).length ? <div className="rdo-fotos">{d.fotos.filter(naSecao).map(ft => (
          <button key={ft.id} type="button" className="rdo-foto" onClick={() => verFoto(ft)} aria-label={ft.legenda || 'Foto'}>
            {ft.miniatura ? <img src={ft.miniatura} alt="" /> : <Icon name="camera" size={22} />}<span className="lg">{ft.legenda || (doContrato ? nomeUnid(ft.obra_id) : 'Sem legenda')}</span></button>))}</div>
          : <p className="est-sub" style={{ margin: 0 }}>Nenhuma foto.</p>}
        {!ro && (d.fotos_ativas ? <div className="form-grid" style={{ marginTop: 10 }}>
          <div className="form-group"><label>Legenda</label><input value={fotoForm.legenda} maxLength={200} placeholder="ex.: Fachada norte — reboco concluído" onChange={e => setFotoForm(x => ({ ...x, legenda: e.target.value }))} /></div>
          {doContrato && sec === 'todas' && <div className="form-group"><label>Unidade</label><select value={fotoForm.obra_id} onChange={e => setFotoForm(x => ({ ...x, obra_id: e.target.value }))}>
            <option value="">Volantes / sem unidade</option>{f.unidades.map(u => <option key={u.obra_id} value={u.obra_id}>{u.obra_nome}</option>)}</select></div>}
          <div className="form-group full"><label className="btn btn-outline btn-sm" style={{ alignSelf: 'flex-start', cursor: busy ? 'wait' : 'pointer' }}><Icon name="camera" size={14} /> Tirar ou escolher foto
            <input type="file" accept="image/*" capture="environment" style={{ display: 'none' }} disabled={busy} onChange={e => { const fl = e.target.files && e.target.files[0]; e.target.value = ''; enviarFoto(fl) }} /></label></div>
        </div> : <p className="est-sub" style={{ margin: '8px 0 0' }}>As fotos do RDO ainda não estão ligadas neste servidor.</p>)}
      </RdoBloco>

      {podeEditar && <div className="card" style={{ marginBottom: 12 }}><div className="card-body" style={{ padding: 14 }}>
        {precisaMotivo && <div className="form-group" style={{ marginBottom: 10 }}><label>Motivo da edição fora do prazo *</label><input value={motivoFora} onChange={e => setMotivoFora(e.target.value)} placeholder="mín. 10 caracteres — sai no documento" /></div>}
        <div className="rdo-acoes" style={{ marginTop: 0 }}>
          <button className="btn btn-primary" disabled={busy || !sujo} onClick={salvar}><Icon name="save" size={15} /> {doContrato && sec !== 'todas' ? `Salvar a seção` : 'Salvar'}</button>
          {sujo && <span className="est-sub" style={{ alignSelf: 'center' }}>Alterações não salvas (guardadas neste aparelho)</span>}
        </div>
      </div></div>}

      {rascunho && souResp && <div className="card" style={{ marginBottom: 12 }}><div className="card-body" style={{ padding: 14 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>{confirmar ? 'Fechar o RDO' : 'Assinar o RDO'}</div>
        <p className="est-sub" style={{ margin: '0 0 8px' }}>Ao {confirmar ? 'fechar' : 'assinar'}, o RDO fica congelado — inclusive o que o sistema trouxe do dia. Para corrigir depois, só por retificação.</p>
        {f.efetivo.some(p => p.presente == null) && <div className="alert alert-warning" style={{ marginBottom: 8 }}>{f.efetivo.filter(p => p.presente == null).length} pessoa(s) com a presença a confirmar — saem como “não confirmada”.</div>}
        {confirmar ? <>
          <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontWeight: 600, color: 'var(--text)', margin: '4px 0 10px' }}>
            <input type="checkbox" style={{ width: 22, height: 22, minWidth: 22, marginTop: 1, flexShrink: 0 }} checked={declara} onChange={e => setDeclara(e.target.checked)} />
            <span>Declaro que as informações deste diário correspondem ao que ocorreu na obra em {estData(d.data)}.</span></label>
          <div className="rdo-acoes"><button className="btn btn-success" disabled={busy || !declara} onClick={() => assinar(null)}><Icon name="check" size={15} /> Fechar o RDO do dia</button></div>
          <p className="est-sub" style={{ margin: '8px 0 0', fontSize: '.75rem' }}>Sem desenhar: o documento registra que você fechou, com o seu login, e quando.</p>
        </>
        : pad === 'responsavel' ? <SignaturePad label="Sua assinatura" onConfirm={assinar} onCancel={() => setPad(null)} />
          : <div className="rdo-acoes">
            <button className="btn btn-success" disabled={busy} onClick={() => assinar(null)}><Icon name="signature" size={15} /> Assinar com a assinatura salva</button>
            <button className="btn btn-ghost" disabled={busy} onClick={() => setPad('responsavel')}><Icon name="edit" size={15} /> Desenhar a assinatura</button>
          </div>}
      </div></div>}

      {d.status === 'assinado' && (d.ciente_fiscal_contrato || d.ciente_fiscal_em) && <div className="card" style={{ marginBottom: 12 }}><div className="card-body" style={{ padding: 14 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Ciente do fiscal</div>
        {d.ciente_fiscal_em ? <p style={{ margin: 0 }}>{d.ciente_fiscal_recusa ? <>O fiscal não assinou: {d.ciente_fiscal_recusa}</> : <>Ciente de <strong>{d.ciente_fiscal_nome}</strong>{d.ciente_fiscal_cargo ? ` — ${d.ciente_fiscal_cargo}` : ''}</>} · {String(d.ciente_fiscal_em).slice(0, 16)}</p>
          : (podeRascunhar || d.assinado_por_id === user.id) ? (pad === 'fiscal' ? <SignaturePad label={`Assinatura de ${ciente.nome || 'o fiscal'}`} onConfirm={registrarCiente} onCancel={() => setPad(null)} /> : <>
            {(d.fiscais_vigentes || []).length > 0 && <div className="form-group" style={{ marginBottom: 8 }}><label>Fiscal cadastrado</label>
              <select value="" onChange={e => { const x = d.fiscais_vigentes[Number(e.target.value)]; if (x) setCiente(c => ({ ...c, nome: x.nome, cargo: x.cargo || '' })) }}>
                <option value="">— escolher para preencher —</option>{d.fiscais_vigentes.map((x, i) => <option key={i} value={i}>{x.nome}{x.cargo ? ` — ${x.cargo}` : ''}</option>)}</select></div>}
            <div className="form-grid">
              <div className="form-group"><label>Nome do fiscal</label><input value={ciente.nome} onChange={e => setCiente(c => ({ ...c, nome: e.target.value }))} /></div>
              <div className="form-group"><label>Cargo</label><input value={ciente.cargo} onChange={e => setCiente(c => ({ ...c, cargo: e.target.value }))} /></div>
            </div>
            {ciente.semAssinar && <div className="form-group" style={{ marginTop: 8 }}><label>Por que o fiscal não assinou?</label><input value={ciente.recusa} onChange={e => setCiente(c => ({ ...c, recusa: e.target.value }))} /></div>}
            <div className="rdo-acoes">
              {!ciente.semAssinar ? <>
                <button className="btn btn-primary btn-sm" onClick={() => { if (ciente.nome.trim().length < 2 || ciente.cargo.trim().length < 2) { addToast('Informe o nome e o cargo do fiscal.', 'error'); return } setPad('fiscal') }}><Icon name="signature" size={14} /> Fiscal assina aqui</button>
                <button className="btn btn-ghost btn-sm" onClick={() => setCiente(c => ({ ...c, semAssinar: true }))}>O fiscal não assinou</button>
              </> : <>
                <button className="btn btn-primary btn-sm" disabled={busy} onClick={() => registrarCiente(null)}>Registrar sem a assinatura</button>
                <button className="btn btn-ghost btn-sm" onClick={() => setCiente(c => ({ ...c, semAssinar: false }))}>Voltar</button>
              </>}
            </div>
          </>) : <p className="est-sub" style={{ margin: 0 }}>Ainda sem o ciente do fiscal.</p>}
      </div></div>}

      <div className="rdo-acoes" style={{ marginBottom: 24 }}>
        <button className="btn btn-outline" onClick={pdfDoDia}><Icon name="fileText" size={15} /> PDF do dia</button>
        {d.status === 'assinado' && d.vigente === 1 && (podeRascunhar || d.assinado_por_id === user.id) && <button className="btn btn-ghost" onClick={retificar}><Icon name="edit" size={15} /> Retificar</button>}
        {rascunho && (d.criado_por === user.id || souResp || gestor) && !user.admin && <button className="btn btn-ghost" onClick={cancelar}><Icon name="x" size={15} /> Cancelar rascunho</button>}
      </div>

      {fotoVer && <div className="modal-overlay open" onClick={() => setFotoVer(null)}>
        <div className="modal modal-lg" onClick={e => e.stopPropagation()}>
          <div className="modal-header"><h3>{fotoVer.legenda || 'Foto'}</h3><button className="modal-close" onClick={() => setFotoVer(null)} aria-label="Fechar">×</button></div>
          <div className="modal-body" style={{ padding: 12, textAlign: 'center' }}>
            {fotoVer.src ? <img src={fotoVer.src} alt={fotoVer.legenda || 'Foto do RDO'} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} /> : <p>Carregando…</p>}
            {fotoVer.src && fotoVer.confere === false && <div className="alert alert-error" style={{ marginTop: 8 }}>Esta imagem não confere com a registrada no RDO.</div>}
            <p className="est-sub" style={{ margin: '8px 0 0' }}>{doContrato ? nomeUnid(fotoVer.obra_id) + ' · ' : ''}{fotoVer.bytes ? `${Math.round(fotoVer.bytes / 1024)} KB` : ''}</p>
          </div>
          {podeEditar && <div className="modal-footer"><button className="btn btn-danger btn-sm" onClick={() => apagarFoto(fotoVer)}><Icon name="trash" size={14} /> Tirar do RDO</button></div>}
        </div>
      </div>}
    </div>
  )
}

function construirMenu(user, notif = {}) {
  const alm = user.role === 'almoxarifado'
  const almMaster = alm && user.is_master
  const lider = user.role === 'lider'
  const eng = user.role === 'engenheiro'
  const op = user.role === 'operario'
  const diretor = user.role === 'diretor'
  const gerente = user.role === 'gerente'
  const logistica = user.role === 'logistica'
  const almox2 = user.role === 'almoxarife2'
  const unif = PERFIS_UNIFORME.includes(user.role)
  // Motorista e Ajudante: o Painel É a rota com as pendências deles — menu só com Painel e REC, e o
  // número fica no Painel (é o mesmo do REC; mostrar nos dois parecia o dobro de tarefas).
  const mot = user.role === 'motorista'
  return [
    { id: 'dashboard', icon: 'dashboard', label: 'Painel', show: true, badge: mot ? totalPendencias(notif, user) : 0 },
    { id: 'pendencias', icon: 'inbox', label: 'Pendências', show: !mot, badge: totalPendencias(notif, user) },
    // Diretor/Gerente: Solicitações e Cautelas só para consulta (abertas pelos cards do painel). Sem
    // número no menu deles — nada ali espera a ação deles (mesma regra do badge do REC).
    { id: 'solicitacoes', icon: 'clipboard', label: 'Solicitações', show: alm || lider || eng || diretor || gerente, badge: alm ? ((notif.solicitacoes_novas||0)+(notif.solicitacoes_prontas||0)) : ((lider || eng) ? (notif.sol_prontas||0) : 0) },
    { id: 'nova-solicitacao', icon: 'plus', label: 'Nova Solicitação', show: lider || eng },
    { id: 'equipe', icon: 'users', label: 'Minha equipe', show: eng, badge: notif.transferencias_recebidas||0 },
    { id: 'obras', icon: 'building', label: 'Obras', show: almMaster || diretor || gerente || eng },
    { id: 'kanban-obras', icon: 'building', label: 'Kanban de Obras', show: diretor || gerente || user.role==='apontador' || user.is_master },
    { id: 'cautelas', icon: 'package', label: 'Cautelas', show: alm || lider || eng || op || diretor || gerente },
    { id: 'emprestimos', icon: 'exchange', label: 'Empréstimos', show: almMaster || lider || eng || op, badge: op?(notif.emprestimos_aguardando_confirmacao||0):((lider||eng)?(notif.emprestimos_aguardando_aval||0):0) },
    { id: 'uniformes', icon: 'shirt', label: 'Uniformes / EPI', show: unif, badge: (notif.uniforme_estoque_minimo||0)+(notif.uniforme_desgaste||0)+(notif.uniforme_epi_notas||0) },
    { id: 'estoque', icon: 'layers', label: 'Estoque', show: alm || almox2 || diretor || gerente || user.role==='compras' || user.role==='administracao', badge: (notif.estoque_notas_pendentes||0) + (alm ? (notif.estoque_pedidos_abertos||0) : 0) + (almox2 ? (notif.estoque_pedidos_a_receber||0) : 0) },
    // O servidor só manda as chaves do REC que valem para o papel — a soma é o que está na mão da pessoa.
    { id: 'rec', icon: 'clipboard', label: 'REC — Custódia', show: alm || eng || lider || diretor || gerente || logistica || almox2 || user.role==='motorista' || user.role==='compras' || user.role==='administracao', badge: mot ? 0 : (notif.rec_solicitacoes_abertas||0) + (notif.rec_remessas_separar||0) + (notif.rec_remessas_transporte||0) + (notif.rec_remessas_receber||0) + (notif.rec_compras_abertas||0) + (notif.rec_retiradas_minhas||0) + (notif.rec_aprovacoes_prazo||0) + (notif.rec_recusadas||0) + (notif.rec_devolvidas_obra||0) },
    { id: 'entregas-bolsas', icon: 'truck', label: 'Entregas de bolsas', show: user.role==='apontador', badge: (notif.portes_em_maos||0) + (notif.portes_buscar||0) },
    { id: 'fiscalizacao', icon: 'clipboard', label: 'Fiscalização', show: user.role==='apontador' || diretor || gerente || user.is_master },
    { id: 'servicos-extras', icon: 'worker', label: 'Serviços extras', show: eng || lider || diretor || gerente || user.is_master },
    // Diário de obra (RDO): o servidor diz na sessão se o papel tem RDO num contrato com o módulo (rdo_ativo).
    { id: 'rdo', icon: 'fileText', label: 'Diário de obra', show: !!user.rdo_ativo, badge: (notif.rdo_assinar||0) + (notif.rdo_sem_lancar||0) + (notif.rdo_atrasados||0) },
    { id: 'ferramentas', icon: 'wrench', label: 'Ferramentas', show: alm },
    { id: 'bolsas', icon: 'backpack', label: 'Bolsas / Kits', show: alm },
    { id: 'contratos', icon: 'layers', label: 'Contratos', show: almMaster || diretor },
    { id: 'cronograma', icon: 'trending', label: 'Cronograma', show: gerente || diretor || eng || almMaster || ((alm || lider) && temModulo(user, 'manutencao')) },
    { id: 'minhas-atividades', icon: 'clock', label: 'Atividades da semana', show: op && !!notif.manut_ativo, badge: op ? (notif.manut_semana||0) : 0 },
    { id: 'usuarios', icon: 'users', label: 'Usuários', show: almMaster || diretor },
    // Auditoria fica sempre por último, após Empréstimos (regra de layout do sidebar).
    { id: 'equipe-auditoria', icon: 'history', label: 'Auditoria', show: eng },
    { id: 'diretor-auditoria', icon: 'history', label: 'Auditoria', show: diretor },
    { id: 'auditoria', icon: 'history', label: 'Auditoria', show: almMaster },
  ].filter(i => i.show && abaAtiva(user, i.id))
}

// Gerente multicontrato (Cesar · Costellation): visão Diretor-like ESCOPADA ao conjunto dele.
// Cada aba é filtrada por contrato no backend — Painel consolidado, Pendências (o que espera o OK
// dele: pedido do REC fora do prazo), Ferramentas, Usuários, Cautelas/Solicitações (só consulta),
// REC (solicitações/remessas/custódia das obras dele; catálogo/depósitos/compras são camada
// compartilhada), Estoque (só consulta, como o do gerente comum) e Auditoria só do conjunto. Obras/Kanban
// ficam de fora (cada contrato é uma obra só). Fiscalização segue fora até ter dimensão de contrato.
const MENU_MULTI = [
  { id: 'dashboard', icon: 'dashboard', label: 'Painel' },
  { id: 'pendencias', icon: 'inbox', label: 'Pendências' },
  { id: 'cronograma', icon: 'trending', label: 'Cronograma' },
  { id: 'ferramentas', icon: 'wrench', label: 'Ferramentas' },
  { id: 'cautelas', icon: 'package', label: 'Cautelas' },
  { id: 'solicitacoes', icon: 'clipboard', label: 'Solicitações' },
  { id: 'estoque', icon: 'layers', label: 'Estoque' },
  { id: 'rec', icon: 'clipboard', label: 'REC — Custódia' },
  { id: 'rdo', icon: 'fileText', label: 'Diário de obra' },
  { id: 'minha-equipe', icon: 'users', label: 'Minha Equipe' },
  { id: 'usuarios', icon: 'users', label: 'Usuários' },
  { id: 'diretor-auditoria', icon: 'history', label: 'Auditoria' },
]
// Multicontrato: as abas fixas acima (menos as de módulo não contratado) com os números do menu do papel,
// aba por aba — o /notificacoes já vem escopado ao conjunto dele. Antes o menu não tinha número nenhum e o
// pedido do REC esperando o OK do gerente não avisava em lugar algum.
const menuDe = (user, notif) => {
  const doPapel = construirMenu(user, notif)
  if (!user.multi_contrato) return doPapel
  return MENU_MULTI.filter(i => abaAtiva(user, i.id) && (i.id !== 'rdo' || user.rdo_ativo)).map(i => {
    const p = doPapel.find(x => x.id === i.id)
    return p && p.badge ? { ...i, badge: p.badge } : i
  })
}
// A aba está no menu de quem clica? Card do painel só vira link se o destino existir para o papel.
const podeAbrir = (user, page) => menuDe(user).some(i => i.id === page)

// Props de um card/linha do painel que abre o assunto: clique, Enter ou Espaço navegam.
// `go` nulo (papel sem a aba de destino) = fica só leitura, sem cursor nem chevron.
// cta=true quando o card já mostra o texto "Ver … →" (não repete o chevron).
const linkProps = (go, cta) => go ? {
  'data-link': cta ? 'cta' : '', role: 'link', tabIndex: 0,
  onClick: e => { e.stopPropagation(); go() },
  onKeyDown: e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); go() } },
} : {}

// Listas longas: desenha as primeiras `passo` linhas e acrescenta mais conforme a pessoa rola até perto do
// fim (marcador invisível observado por IntersectionObserver, com folga de ~1,5 tela). Layout e textos
// iguais; contadores, filtros e buscas continuam sobre a lista INTEIRA — só o desenho chega aos poucos.
// `fixo`: item que tem de estar na tela mesmo além do limite (o aberto, para onde a tela rola).
// Navegador sem IntersectionObserver: desenha tudo, como antes.
function useAosPoucos(lista, passo = 60, fixo) {
  const [limite, setLimite] = useState(passo)
  const io = useRef(null)
  const iFixo = fixo ? lista.findIndex(fixo) : -1
  const ate = Math.max(limite, iFixo + 1)
  const falta = lista.length > ate
  // Ref de callback (não useEffect): o marcador pode aparecer depois — lista que chega enquanto a tela ainda
  // mostra "Carregando…", aba trocada — e a cada crescimento o observador é refeito para seguir enchendo
  // enquanto o fim estiver perto (observe() sempre avisa a situação atual). Sai da tela → desliga.
  const marca = useCallback(el => {
    if (io.current) { io.current.disconnect(); io.current = null }
    if (!el) return
    io.current = new IntersectionObserver(es => { if (es.some(e => e.isIntersecting)) setLimite(l => Math.max(l, ate) + passo) }, { rootMargin: '0px 0px 1500px 0px' })
    io.current.observe(el)
  }, [ate, passo])
  if (typeof IntersectionObserver === 'undefined' || !falta) return [lista, null]
  return [lista.slice(0, ate), <div ref={marca} aria-hidden="true" style={{ height: 1 }} />]
}

// Campo de busca com atraso: a tecla só redesenha o campo; quem filtra (a tela inteira, com milhares de
// registros) é avisado quando a pessoa para de digitar. Valor trocado por fora (ex.: "Limpar filtros")
// vale na hora. Devolve [valor do campo, onChange do campo].
function useBuscaAdiada(valor, aoMudar, ms = 200) {
  const [campo, setCampo] = useState(valor)
  const espera = useRef(null)
  const enviado = useRef(valor)
  useEffect(() => { if (valor !== enviado.current) { enviado.current = valor; clearTimeout(espera.current); setCampo(valor) } }, [valor])
  useEffect(() => () => clearTimeout(espera.current), [])
  const mudar = v => {
    setCampo(v); clearTimeout(espera.current)
    espera.current = setTimeout(() => { enviado.current = v; aoMudar(v) }, ms)
  }
  return [campo, mudar]
}
// O campo com o estado dentro dele: cada tecla redesenha só o <input>, não a tela que filtra.
function CampoBusca({ valor, aoMudar, ms, ...props }) {
  const [campo, mudar] = useBuscaAdiada(valor, aoMudar, ms)
  return <input {...props} value={campo} onChange={e => mudar(e.target.value)} />
}

// Filtro trazido de um card do painel (navigate(page, id, filtro)). `rotulo` é o que a faixa
// "Mostrando: …" exibe; os demais campos dizem o que filtrar. Consumido uma vez, na montagem.
const filtroDoAlvo = (openTarget, page) => (openTarget && openTarget.page === page && openTarget.filtro) || null
function FiltroPainel({ filtro, n, onLimpar }) {
  if (!filtro) return null
  return (
    <div className="filtro-painel">
      <Icon name="search" size={15}/>
      <span>Mostrando <b>{filtro.rotulo}</b>{n != null && <span className="fp-n"> · {n} {n === 1 ? 'registro' : 'registros'}</span>}</span>
      <button className="btn btn-ghost btn-sm" onClick={onLimpar}><Icon name="x" size={13}/> Ver tudo</button>
    </div>
  )
}
// Dias desde uma data local "AAAA-MM-DD HH:MM:SS" — mesma conta do servidor (julianday now − data).
const diasDesde = s => { const t = new Date(String(s || '').replace(' ', 'T')).getTime(); return isNaN(t) ? 0 : (Date.now() - t) / 86400000 }
const hojeYMD = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}` }
// Cautela × filtro do painel. Mesmos critérios dos indicadores (dias em campo contam de
// COALESCE(data_retirada, criado_em); obra/colaborador = posse atual, como no painel do Diretor).
const cautelaNoFiltro = (c, f) => {
  if (!f) return true
  if (f.status && c.status !== f.status) return false
  if (f.dias) { const d = Math.floor(diasDesde(c.data_retirada || c.criado_em)); if (d < f.dias[0] || (f.dias[1] != null && d >= f.dias[1])) return false }
  if (f.retiradaDias != null && !(c.data_retirada && diasDesde(c.data_retirada) <= f.retiradaDias)) return false
  if (f.movHoje) { const h = hojeYMD(); if (String(c.data_retirada || '').slice(0, 10) !== h && String(c.data_devolucao || '').slice(0, 10) !== h) return false }
  if (f.contrato != null && c.lider_contrato_id !== f.contrato) return false
  if ('obra' in f && !(c.posse_obras || []).includes(f.obra)) return false
  if (f.colaborador != null && !(c.posse_colaboradores || []).includes(f.colaborador)) return false
  if (f.colaboradores && !(c.posse_colaboradores || []).some(id => f.colaboradores.includes(id))) return false
  if (f.comEntrega && !c.entregas_ativas) return false
  return true
}
// Solicitação de ferramenta × filtro do painel.
const SOL_ENCERRADAS = ['retirada', 'cancelada', 'estornada']
const solNoFiltro = (s, f) => {
  if (!f) return true
  if (f.status && s.status !== f.status) return false
  if (f.ativas && SOL_ENCERRADAS.includes(s.status)) return false
  if (f.criadaMaisDe != null && !(diasDesde(s.criado_em) > f.criadaMaisDe)) return false
  if (f.contrato != null && s.lider_contrato_id !== f.contrato) return false
  if (f.lider != null && s.lider_id !== f.lider) return false
  return true
}

function Sidebar({ user, page, navigate, onLogout, notif, open, onOpenSearch, tour, canPresent, onTourEnter, onTourSelect }) {
  const itensFinais = menuDe(user, notif)

  // Favoritos: itens fixados no topo, na ordem de fixação (reordenável por arrastar).
  // Só valem os ids que existem no menu atual do usuário — muda de perfil, os órfãos somem.
  const [favs, setFavs] = useState(() => lerFavs(user))
  const dragFrom = useRef(null)
  const toggleFav = (id, e) => {
    e.stopPropagation()
    setFavs(prev => { const next = prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]; salvarFavs(user, next); return next })
  }
  const reordenar = (from, to) => {
    if (from == null || from === to) return
    setFavs(prev => { const a = [...prev]; const [m] = a.splice(from, 1); a.splice(to, 0, m); salvarFavs(user, a); return a })
  }
  const favItems = favs.map(id => itensFinais.find(i => i.id === id)).filter(Boolean)
  const normalItems = itensFinais.filter(i => !favs.includes(i.id))
  const renderNav = (item, isFav, idx) => (
    <div key={item.id}
      className={`nav-item-wrap ${isFav ? 'fav' : ''}`}
      draggable={isFav}
      onDragStart={isFav ? (() => { dragFrom.current = idx }) : undefined}
      onDragOver={isFav ? (e => e.preventDefault()) : undefined}
      onDrop={isFav ? (e => { e.preventDefault(); reordenar(dragFrom.current, idx); dragFrom.current = null }) : undefined}>
      <button className={`nav-item ${page === item.id ? 'active' : ''}`} onClick={() => navigate(item.id)}>
        <span className="nav-icon"><Icon name={item.icon} size={18} /></span>
        {item.label}
        {item.badge > 0 && <span className="nav-badge">{item.badge}</span>}
      </button>
      <button className={`nav-star ${isFav ? 'on' : ''}`} onClick={e => toggleFav(item.id, e)}
        title={isFav ? 'Desafixar do topo' : 'Fixar no topo'} aria-label={isFav ? 'Desafixar' : 'Fixar'}>
        <Icon name="star" size={14} />
      </button>
    </div>
  )

  return (
    <div className={`sidebar ${open?'open':''}`}>
      <div className="sidebar-header">
        <div className="sidebar-logo">
          {empresaInfo.logoUrl && <img src={empresaInfo.logoUrl} alt={empresaInfo.nome} style={{maxWidth:36,maxHeight:36,borderRadius:6}} />}
          <div><h2>Cautelix</h2><p>{empresaInfo.nome}</p></div>
        </div>
      </div>
      <div className="sidebar-user">
        <div className="name">{user.nome}</div>
        <div className="role">{user.admin ? 'Administrativo' : user.is_master ? 'Administrador Master' : (roleLabelDe(user) + ((user.cargo && user.cargo.trim().toLowerCase() !== roleLabelDe(user).toLowerCase()) ? ` — ${user.cargo}` : ''))}</div>
        <div style={{fontSize:'.7rem',color:'rgba(255,255,255,.45)',marginTop:4,wordBreak:'break-all'}}>{user.email}</div>
      </div>
      {tour && (
        <div className="tour-switch">
          <div className="ts-cap">Apresentando o perfil</div>
          {tour.perfis.map(p => (
            <button key={p.role}
              className={`tour-perfil ${tour.role===p.role?'active':''}`}
              disabled={!p.disponivel}
              onClick={()=>p.disponivel && onTourSelect(p.role)}>
              <span className="tp-role"><Icon name={TOUR_ICON[p.role]||'users'} size={15}/>{p.label}</span>
              <span className="tp-ex">{p.disponivel ? (p.exemplo || 'ver como este perfil') : 'sem usuário cadastrado'}</span>
            </button>
          ))}
        </div>
      )}
      <nav className="sidebar-nav">
        <button className="nav-search" onClick={onOpenSearch}>
          <Icon name="search" size={16}/> <span>Buscar</span>
          <span className="nav-search-kbd">Ctrl K</span>
        </button>
        {favItems.length > 0 && (
          <div className="nav-group">
            <div className="nav-group-cap"><Icon name="star" size={11}/> Favoritos</div>
            {favItems.map((item, idx) => renderNav(item, true, idx))}
          </div>
        )}
        {normalItems.map(item => renderNav(item, false))}
      </nav>
      <div className="sidebar-footer">
        {canPresent && !tour && (
          <button className="btn-tour" onClick={onTourEnter}><Icon name="eye" size={16}/> Modo apresentação</button>
        )}
        <div className="sb-tools">
          <button className="btn-logout" onClick={onLogout} style={{width:'auto',flex:'0 0 auto'}}><Icon name="logout" size={16}/> Sair</button>
          <ThemeToggle/>
        </div>
      </div>
    </div>
  )
}

// ─── MULTICONTRATO — helpers de cor/formatação ────────────────────────────────
const CONTRATO_CORES = ['#A07C4E', '#4A90A4', '#8A9BB0', '#2E3F55', '#6B7B8F', '#B8860B']
const corContrato = (c, i) => (c && c.cor) || CONTRATO_CORES[i % CONTRATO_CORES.length]
const kMoedaMil = v => v >= 1000 ? 'R$ ' + (v / 1000).toFixed(1).replace('.', ',') + ' mil' : fmtBRL(v)
const MOD_LABEL = { cautela: 'Ferramentas & Cautelas', obras: 'Obras', equipe: 'Equipe', emprestimos: 'Empréstimos', uniformes: 'Uniformes / EPI', rec: 'REC · Custódia', manutencao: 'Manutenção (Gantt)', rdo: 'Diário de obra (RDO)' }
const cruzaContratos = u => !!(u && (u.is_master || u.role === 'diretor' || u.multi_contrato))

// ─── PAINEL POR CONTRATO ──────────────────────────────────────────────────────
// Aparece no TOPO do Painel Geral (Master / CEO / Diretor) SÓ quando há 2+ contratos —
// com um único contrato o painel segue idêntico ao de sempre (zero mudança visual).
// Consolida o grupo e quebra por contrato; "Ver contrato" faz o drill-in no layout
// completo daquele contrato, tudo dentro da mesma aba.
function PainelContratos({ user, navigate, selExt, onSel, onVisivel }) {
  const [data, setData] = useState(null)
  const [selInt, setSelInt] = useState(null)  // null = todos os contratos
  // O Painel do Master controla a seleção (onSel) p/ esconder, no mesmo render, o que este bloco já mostra.
  const selId = onSel ? selExt : selInt, setSelId = onSel || setSelInt
  useEffect(() => { GET('/contratos?indicadores=1').then(setData).catch(() => setData({})) }, [])
  const ativos = ((data && data.contratos) || []).filter(c => c.ativo)
  // Multicontrato só faz sentido com 2+. null = ainda carregando.
  const visivel = data ? (cruzaContratos(user) && ativos.length >= 2) : null
  useEffect(() => { if (onVisivel) onVisivel(visivel) }, [visivel])
  if (!visivel) return null
  const cor = {}; ativos.forEach((c, i) => { cor[c.id] = corContrato(c, i) })
  const cons = data.consolidado || {}
  const sel = selId ? ativos.find(c => c.id === selId) : null
  // Cada número abre a tela de destino já filtrada no contrato (só se o papel tem a aba).
  const ir = (page, filtro) => navigate && podeAbrir(user, page) ? () => navigate(page, null, filtro) : null
  const doContrato = (c, rotulo, f) => ({ ...f, contrato: c.id, rotulo: `${rotulo} · ${c.nome}` })
  const irCampo = c => ir('cautelas', c ? doContrato(c, 'Cautelas ativas', { status: 'ativa' }) : { status: 'ativa', rotulo: 'Cautelas ativas (ferramenta em campo)' })
  const ir15 = c => ir('cautelas', doContrato(c, 'Em campo há +15 dias', { status: 'ativa', dias: [15, null] }))
  const irSol = (c, status, rotulo) => ir('solicitacoes', doContrato(c, rotulo, { status }))

  const chip = (id, label, dot) => (
    <button key={id ?? 'all'} onClick={() => setSelId(id)}
      style={{ padding: '8px 14px', borderRadius: 22, border: '1px solid var(--border)',
        background: selId === id ? 'var(--fill-navy)' : 'var(--surface)', color: selId === id ? '#fff' : 'var(--text-secondary)',
        fontSize: '.82rem', fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      {dot && <span style={{ width: 9, height: 9, borderRadius: 3, background: dot }} />}{label}
    </button>
  )
  const kpiCell = (label, val, tone, sub, go) => (
    <div className="lk-row" {...linkProps(go)} style={{ borderLeft: '1px solid var(--border)', paddingLeft: 14 }}>
      <div style={{ fontSize: '.68rem', color: 'var(--text-secondary)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em' }}>{label}</div>
      <div style={{ fontSize: '1.5rem', fontWeight: 800, marginTop: 5, lineHeight: 1, fontVariantNumeric: 'tabular-nums',
        color: tone === 'red' ? 'var(--danger)' : tone === 'ok' ? 'var(--success)' : tone === 'blue' ? 'var(--primary-text)' : 'var(--accent)' }}>{val}</div>
      {sub && <div style={{ fontSize: '.7rem', color: 'var(--text-secondary)', marginTop: 3 }}>{sub}</div>}
    </div>
  )

  return (
    <div className="stat-section" style={{ marginBottom: 26 }}>
      <div className="stat-section-title"><span className="st-ic"><Icon name="layers" size={14} /></span>{sel ? `Contrato · ${sel.nome}` : 'Visão por contrato'}</div>

      {/* Switcher */}
      <div style={{ display: 'flex', gap: 9, flexWrap: 'wrap', alignItems: 'center', marginBottom: 18 }}>
        {chip(null, 'Todos os contratos', null)}
        {ativos.map(c => chip(c.id, c.codigo ? `${c.nome} · ${c.codigo}` : c.nome, cor[c.id]))}
      </div>

      {!sel && (<>
        {/* Consolidado do grupo */}
        <div className="fin-hero" style={{ marginBottom: 16 }} {...linkProps(irCampo(null))}>
          <span className="fh-chip">tempo real</span>
          <div className="fh-label"><Icon name="shield" size={14} /> Patrimônio sob responsabilidade · em campo · {user.multi_contrato ? 'seus contratos' : 'todos os contratos'}</div>
          <div className="fh-value"><span className="cur">R$</span>{fmtBRL(cons.valor_em_campo || 0).replace('R$ ', '')}</div>
          <div className="fh-sub">{cons.cautelas_ativas || 0} cautela(s) ativa(s) · {cons.obras_ativas || 0} obra(s) · {ativos.length} contratos</div>
          {(cons.valor_em_campo || 0) > 0 && (<>
            <div className="fh-bar">{ativos.map(c => (c.kpis.valor_em_campo || 0) > 0 &&
              <span key={c.id} style={{ width: (c.kpis.valor_em_campo / cons.valor_em_campo * 100) + '%', background: cor[c.id] }} />)}</div>
            <div className="fh-legend">{ativos.map(c => <span className="lg" key={c.id}><i style={{ background: cor[c.id] }} />{c.nome} <b>{kMoedaMil(c.kpis.valor_em_campo || 0)}</b></span>)}</div>
          </>)}
        </div>

        {/* Cards por contrato */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {ativos.map(c => (
            <div key={c.id} className="stat-card" style={{ padding: '18px 22px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
                <span style={{ width: 11, height: 11, borderRadius: 3, background: cor[c.id], flex: 'none' }} />
                <span style={{ fontSize: '1.05rem', fontWeight: 700, color: 'var(--ink)' }}>{c.nome}</span>
                {c.codigo && <span style={{ fontSize: '.74rem', color: 'var(--text-secondary)', fontWeight: 600, border: '1px solid var(--border)', background: 'var(--surface)', padding: '2px 9px', borderRadius: 20 }}>{c.codigo}</span>}
                <button onClick={() => setSelId(c.id)} style={{ marginLeft: 'auto', color: 'var(--primary-accent)', fontWeight: 600, fontSize: '.82rem', border: '1px solid var(--border)', background: 'var(--surface)', padding: '7px 13px', borderRadius: 9, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 5 }}>Ver contrato <Icon name="chevronRight" size={13} /></button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 16 }}>
                <div style={{ paddingLeft: 0 }}>{kpiCell('Patrimônio em campo', kMoedaMil(c.kpis.valor_em_campo || 0), 'accent', `${c.kpis.cautelas_ativas || 0} cautela(s) ativa(s)`, irCampo(c))}</div>
                {kpiCell('Ferramentas em campo', c.kpis.unidades_em_campo || 0, 'blue', 'un. sob responsabilidade', irCampo(c))}
                {kpiCell('Obras ativas', c.kpis.obras_ativas || 0, 'blue', 'canteiros com equipe', ir('obras', doContrato(c, 'Obras ativas', { ativas: true })))}
                {kpiCell('Em campo +15 dias', c.kpis.atencao_15d || 0, (c.kpis.atencao_15d || 0) > 0 ? 'red' : 'ok', (c.kpis.atencao_15d || 0) > 0 ? 'cobrar devolução' : 'tudo em dia', ir15(c))}
                {kpiCell('Solicitações novas', c.kpis.sol_novas || 0, 'accent', 'aguardando separação', irSol(c, 'solicitada', 'Solicitações novas'))}
              </div>
            </div>
          ))}
        </div>
      </>)}

      {sel && (() => {
        const k = sel.kpis || {}
        return (<>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, background: 'linear-gradient(135deg,rgba(74,144,164,.12),rgba(74,144,164,.04))', border: '1px solid var(--tag-aco-bd)', borderLeft: `4px solid ${cor[sel.id]}`, borderRadius: 12, padding: '13px 18px', marginBottom: 20, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: '.95rem', fontWeight: 700, color: 'var(--ink)' }}>{sel.nome}{sel.codigo ? ` · ${sel.codigo}` : ''}</div>
              <div style={{ fontSize: '.8rem', color: 'var(--text-secondary)' }}>Mesmo layout e módulos — indicadores restritos a este contrato</div>
            </div>
            {sel.cliente && <span style={{ marginLeft: 'auto', fontSize: '.74rem', color: 'var(--text-secondary)', border: '1px solid var(--border)', background: 'var(--surface)', padding: '4px 10px', borderRadius: 20, fontWeight: 600 }}>Cliente: {sel.cliente}</span>}
          </div>
          <div className="fin-hero" style={{ marginBottom: 18 }} {...linkProps(irCampo(sel))}>
            <span className="fh-chip">tempo real</span>
            <div className="fh-label"><Icon name="shield" size={14} /> Patrimônio sob responsabilidade · em campo</div>
            <div className="fh-value"><span className="cur">R$</span>{fmtBRL(k.valor_em_campo || 0).replace('R$ ', '')}</div>
            <div className="fh-sub">{k.cautelas_ativas || 0} cautela(s) ativa(s) em {k.obras_ativas || 0} obra(s) · {sel.nome}</div>
          </div>
          <div className="stat-section">
            <div className="stat-section-title"><span className="st-ic"><Icon name="package" size={14} /></span>Estoque</div>
            <div className="stats-grid">
              <div className="stat-card blue" {...linkProps(ir('ferramentas', doContrato(sel, 'Acervo de ferramentas', {})))}><div className="stat-label">Ferramentas</div><div className="stat-value">{k.ferramentas || 0}</div><div style={{ fontSize: '.74rem', color: 'var(--text-secondary)', marginTop: 3 }}>acervo do contrato</div></div>
              <div className="stat-card green" {...linkProps(ir('ferramentas', doContrato(sel, 'Acervo de ferramentas', {})))}><div className="stat-label">Valor total cadastrado</div><ValorCard v={k.valor_estoque || 0} className="green" /></div>
              <div className="stat-card blue" {...linkProps(ir('usuarios', doContrato(sel, 'Colaboradores ativos', { role: 'operario', ativos: true })))}><div className="stat-label">Colaboradores ativos</div><div className="stat-value">{k.colaboradores || 0}</div></div>
            </div>
          </div>
          <div className="stat-section">
            <div className="stat-section-title"><span className="st-ic"><Icon name="exchange" size={14} /></span>Panorama operacional</div>
            <div className="stats-grid">
              <div className="stat-card blue" {...linkProps(irCampo(sel))}><div className="stat-label">Ferramentas em campo</div><div className="stat-value">{k.unidades_em_campo || 0}</div><div style={{ fontSize: '.74rem', color: 'var(--text-secondary)', marginTop: 3 }}>{k.cautelas_ativas || 0} cautela(s) ativa(s)</div></div>
              <div className={`stat-card ${(k.atencao_15d || 0) > 0 ? 'red' : ''}`} {...linkProps(ir15(sel))}><div className="stat-label">Em campo há +15 dias</div><div className="stat-value">{k.atencao_15d || 0}</div><div style={{ fontSize: '.74rem', color: 'var(--text-secondary)', marginTop: 3 }}>atenção — cobrar devolução</div></div>
              <div className="stat-card" {...linkProps(irCampo(sel))}><div className="stat-label">Patrimônio em campo</div><ValorCard v={k.valor_em_campo || 0} /></div>
            </div>
          </div>
          <div className="stat-section">
            <div className="stat-section-title"><span className="st-ic"><Icon name="clipboard" size={14} /></span>Fila de solicitações</div>
            <div className="stats-grid">
              <div className="stat-card" {...linkProps(irSol(sel, 'solicitada', 'Solicitações novas'))}><div className="stat-label">Solicitações novas</div><div className="stat-value">{k.sol_novas || 0}</div></div>
              <div className="stat-card" {...linkProps(irSol(sel, 'separando', 'Solicitações em separação'))}><div className="stat-label">Separando</div><div className="stat-value">{k.sol_separando || 0}</div></div>
              <div className="stat-card" {...linkProps(irSol(sel, 'pronta', 'Solicitações prontas p/ retirada'))}><div className="stat-label">Prontas p/ retirada</div><div className="stat-value">{k.sol_prontas || 0}</div></div>
            </div>
          </div>
        </>)
      })()}
    </div>
  )
}

// ─── PÁGINA CONTRATOS (gestão — Master / Diretor; CEO só leitura) ──────────────
// ─── CRONOGRAMA — Painel do Gerente de Contrato (Curva S físico-financeiro) ──────
function CurvaSPage({ user, addToast, seletorVisao }) {
  const [contratos, setContratos] = useState([])
  const [sel, setSel] = useState(null)          // contrato selecionado
  const [cron, setCron] = useState(undefined)   // undefined=carregando · null=sem cronograma · obj
  const [form, setForm] = useState(null)        // form de criar/reconfigurar
  const [salvando, setSalvando] = useState(false)
  const podeEditar = user.role === 'gerente' || user.role === 'diretor' || user.is_master
  const podeMedir = podeEditar || user.role === 'engenheiro'

  const brl = v => 'R$ ' + Math.round(Number(v) || 0).toLocaleString('pt-BR')
  const pct = (v, d = 1) => ((Number(v) || 0) * 100).toLocaleString('pt-BR', { minimumFractionDigits: d, maximumFractionDigits: d }) + '%'
  const inp = { padding: '9px 11px', border: '1px solid var(--border)', borderRadius: 9, background: 'var(--surface)', color: 'var(--ink)', fontSize: '.9rem', width: '100%', fontFamily: 'inherit' }
  const lbl = { display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }

  const carregar = id => { setCron(undefined); GET('/contratos/' + id + '/cronograma').then(d => setCron(d.cronograma || null)).catch(e => { addToast(e.message || 'Erro ao carregar.', 'error'); setCron(null) }) }
  useEffect(() => {
    GET('/cronograma/contratos').then(d => {
      const list = d.contratos || []
      setContratos(list)
      const first = list.find(c => c.tem_cronograma) || list[0]
      if (first) setSel(first.id); else setCron(null)
    }).catch(e => { addToast(e.message || 'Erro ao carregar contratos.', 'error'); setCron(null) })
  }, [])
  useEffect(() => { if (sel) carregar(sel) }, [sel])

  const statusInfo = d => {
    if (d === null || d === undefined) return { label: '—', color: 'var(--text-secondary)', bg: 'var(--surface-alt)' }
    if (d >= -0.005) return { label: 'No prazo', color: 'var(--success)', bg: 'rgba(46,125,107,.14)' }
    if (d >= -0.05) return { label: 'Atenção', color: 'var(--warning)', bg: 'rgba(184,134,11,.16)' }
    return { label: 'Atraso', color: 'var(--danger)', bg: 'rgba(122,46,46,.14)' }
  }

  // ── métricas derivadas ──
  const P = (cron && cron.periodos) || []
  const total = (cron && cron.valor_sem_bdi) || P.reduce((s, p) => s + (p.planejado || 0), 0) || 0
  let accP = 0, accM = 0, accC = 0
  const linhas = P.map(p => {
    accP += (p.planejado || 0)
    const medido = (p.medido === null || p.medido === undefined) ? null : Number(p.medido)
    const custo = (p.custo === null || p.custo === undefined) ? null : Number(p.custo)
    if (medido !== null) accM += medido
    if (custo !== null) accC += custo
    const pctPlan = total ? accP / total : 0
    const pctReal = (medido !== null && total) ? accM / total : null
    return { ...p, medido, custo, accP, accM: medido !== null ? accM : null, accC: custo !== null ? accC : null, pctPlan, pctReal, desvio: pctReal !== null ? pctReal - pctPlan : null }
  })
  const atual = [...linhas].reverse().find(l => l.pctReal !== null) || null
  const kpiPlan = atual ? atual.pctPlan : 0
  const kpiReal = atual ? atual.pctReal : 0
  const kpiDesv = atual ? atual.desvio : null
  const kpiFin = atual ? atual.accM : 0
  const sit = statusInfo(kpiDesv)
  // ── Valor Agregado (EVM) — usa o custo real acumulado até a medição atual ──
  const prazo = (cron && cron.prazo_dias) || (P.length ? P[P.length - 1].dias : 0) || 0
  const evm = (() => {
    if (!atual || !total) return null
    const PV = atual.accP, EV = atual.accM, AC = atual.accC   // AC null se custo não apontado
    const spi = PV ? EV / PV : 0
    const cpi = (AC && AC > 0) ? EV / AC : null
    const eac = (cpi && cpi > 0) ? total / cpi : null
    const termino = spi > 0 && prazo ? prazo / spi : null
    return { PV, EV, AC, spi, cpi, eac, prazo, termino, diasExtra: termino !== null ? termino - prazo : null, vpr: EV - PV, vc: AC !== null ? EV - AC : null }
  })()

  const salvarPeriodo = (p, campo, valorRaw) => {
    const num = valorRaw === '' ? null : Number(String(valorRaw).replace(/\./g, '').replace(',', '.'))
    if (num !== null && (isNaN(num) || num < 0)) { addToast('Valor inválido.', 'warning'); return }
    const orig = campo === 'medido' ? p.medido : (campo === 'custo' ? p.custo : p.planejado)
    if ((orig === null ? '' : orig) === (num === null ? '' : num)) return
    const body = campo === 'medido' ? { medido: num } : (campo === 'custo' ? { custo: num } : { planejado: num, medido: p.medido })
    PUT('/cronograma-periodos/' + p.id, body).then(d => setCron(d.cronograma)).catch(e => addToast(e.message || 'Erro ao salvar.', 'error'))
  }

  // ── form de criar / reconfigurar ──
  const abrirNovo = () => setForm({ modo: 'novo', nome: '', inicio: '', num_medicoes: 7, dias_por_medicao: 30, valor_sem_bdi: '', bdi: 20, etapas: [], planejado: [] })
  const abrirReconfig = () => setForm({
    modo: 'reconfig', nome: cron.nome || '', inicio: cron.inicio || '', num_medicoes: P.length || 7,
    dias_por_medicao: (P[0] && P[0].dias) || 30, valor_sem_bdi: cron.valor_sem_bdi || '', bdi: Math.round((cron.bdi || 0) * 100),
    etapas: (cron.etapas || []).map(e => ({ nome: e.nome, valor_sem_bdi: e.valor_sem_bdi })), planejado: P.map(p => p.planejado || 0)
  })
  const addEtapa = () => setForm(f => ({ ...f, etapas: [...f.etapas, { nome: '', valor_sem_bdi: '' }] }))
  const setEtapa = (i, k, v) => setForm(f => ({ ...f, etapas: f.etapas.map((e, j) => j === i ? { ...e, [k]: v } : e) }))
  const delEtapa = i => setForm(f => ({ ...f, etapas: f.etapas.filter((_, j) => j !== i) }))
  const salvarForm = async () => {
    if (!form.num_medicoes || form.num_medicoes < 1) { addToast('Informe o número de medições.', 'warning'); return }
    setSalvando(true)
    try {
      const body = {
        nome: form.nome, inicio: form.inicio, num_medicoes: Number(form.num_medicoes),
        dias_por_medicao: Number(form.dias_por_medicao), valor_sem_bdi: Number(form.valor_sem_bdi) || 0,
        bdi: (Number(form.bdi) || 0) / 100, planejado: form.planejado || [],
        etapas: (form.etapas || []).filter(e => (e.nome || '').trim()).map(e => ({ nome: e.nome, valor_sem_bdi: Number(e.valor_sem_bdi) || 0 }))
      }
      const d = await POST('/contratos/' + sel + '/cronograma', body)
      setCron(d.cronograma); setForm(null)
      addToast('Cronograma salvo.')
      setContratos(cs => cs.map(c => c.id === sel ? { ...c, tem_cronograma: true } : c))
    } catch (e) { addToast(e.message || 'Erro ao salvar cronograma.', 'error') }
    setSalvando(false)
  }

  // ── curva S (SVG) ──
  const CurvaS = () => {
    const W = 680, H = 250, padL = 40, padR = 14, padT = 14, padB = 26
    const iW = W - padL - padR, iH = H - padT - padB, n = linhas.length || 1
    const xAt = i => padL + (i / n) * iW
    const yAt = c => padT + iH - Math.max(0, Math.min(1, c)) * iH
    const planPts = [[xAt(0), yAt(0)]].concat(linhas.map((l, i) => [xAt(i + 1), yAt(l.pctPlan)]))
    const realArr = linhas.filter(l => l.pctReal !== null)
    const realPts = [[xAt(0), yAt(0)]].concat(realArr.map(l => [xAt(l.numero), yAt(l.pctReal)]))
    const str = a => a.map(p => p[0].toFixed(1) + ',' + p[1].toFixed(1)).join(' ')
    const area = str(planPts) + ' ' + xAt(n).toFixed(1) + ',' + yAt(0).toFixed(1)
    return (
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }}>
        {[0, .25, .5, .75, 1].map(g => <line key={g} x1={padL} y1={yAt(g)} x2={W - padR} y2={yAt(g)} stroke="var(--border)" strokeWidth="1" />)}
        {[0, .25, .5, .75, 1].map(g => <text key={g} x={padL - 6} y={yAt(g) + 3} textAnchor="end" fontSize="10" fill="var(--text-secondary)">{Math.round(g * 100)}</text>)}
        {linhas.map((l, i) => <text key={i} x={xAt(i + 1)} y={H - 8} textAnchor="middle" fontSize="9.5" fill="var(--text-secondary)">{l.dias}</text>)}
        <polygon points={area} fill="var(--primary-accent)" opacity=".08" />
        <polyline points={str(planPts)} fill="none" stroke="var(--silver)" strokeWidth="2.5" strokeDasharray="6 5" strokeLinejoin="round" />
        {realArr.length > 0 && <polyline points={str(realPts)} fill="none" stroke="var(--primary-accent)" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />}
        {realArr.map((l, i) => <circle key={i} cx={xAt(l.numero)} cy={yAt(l.pctReal)} r={i === realArr.length - 1 ? 5 : 3.5} fill="var(--primary-accent)" stroke="var(--card)" strokeWidth={i === realArr.length - 1 ? 2 : 0} />)}
        {atual && <line x1={xAt(atual.numero)} y1={padT} x2={xAt(atual.numero)} y2={padT + iH} stroke="var(--accent)" strokeWidth="1.5" strokeDasharray="3 3" />}
        {atual && <text x={xAt(atual.numero) + 4} y={padT + 9} fontSize="10" fontWeight="700" fill="var(--accent)">hoje</text>}
      </svg>
    )
  }

  // Curva de Valor Agregado: VP planejado (silver), VA agregado (aço), CR custo real (cobre).
  const CurvaEVM = () => {
    const W = 680, H = 210, padL = 52, padR = 14, padT = 14, padB = 26
    const iW = W - padL - padR, iH = H - padT - padB, n = linhas.length || 1
    const yM = Math.max(total, ...linhas.map(l => l.accM || 0), ...linhas.map(l => l.accC || 0)) || 1
    const xAt = i => padL + (i / n) * iW
    const yAt = v => padT + iH - Math.max(0, Math.min(1, v / yM)) * iH
    const mi = v => (v / 1e6).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
    const str = a => a.map(p => p[0].toFixed(1) + ',' + p[1].toFixed(1)).join(' ')
    const vp = [[xAt(0), yAt(0)]].concat(linhas.map((l, i) => [xAt(i + 1), yAt(l.accP)]))
    const va = [[xAt(0), yAt(0)]].concat(linhas.filter(l => l.accM !== null).map(l => [xAt(l.numero), yAt(l.accM)]))
    const cr = [[xAt(0), yAt(0)]].concat(linhas.filter(l => l.accC !== null).map(l => [xAt(l.numero), yAt(l.accC)]))
    return (
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto', display: 'block' }}>
        {[0, .5, 1].map(g => <line key={g} x1={padL} y1={yAt(g * yM)} x2={W - padR} y2={yAt(g * yM)} stroke="var(--border)" strokeWidth="1" />)}
        {[0, .5, 1].map(g => <text key={g} x={padL - 6} y={yAt(g * yM) + 3} textAnchor="end" fontSize="10" fill="var(--text-secondary)">{mi(g * yM)}</text>)}
        {linhas.map((l, i) => <text key={i} x={xAt(i + 1)} y={H - 8} textAnchor="middle" fontSize="9.5" fill="var(--text-secondary)">{l.dias}</text>)}
        {atual && <line x1={xAt(atual.numero)} y1={padT} x2={xAt(atual.numero)} y2={padT + iH} stroke="var(--accent)" strokeWidth="1.5" strokeDasharray="3 3" />}
        <polyline points={str(vp)} fill="none" stroke="var(--silver)" strokeWidth="2.5" strokeDasharray="6 5" strokeLinejoin="round" />
        {va.length > 1 && <polyline points={str(va)} fill="none" stroke="var(--primary-accent)" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />}
        {cr.length > 1 && <polyline points={str(cr)} fill="none" stroke="var(--accent)" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />}
      </svg>
    )
  }

  const KPI = ({ label, value, color, sub }) => (
    <div className="card" style={{ padding: '13px 15px' }}>
      <div style={{ fontSize: '.68rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', color: 'var(--text-secondary)' }}>{label}</div>
      <div style={{ fontSize: '1.5rem', fontWeight: 800, marginTop: 4, color: color || 'var(--ink)', lineHeight: 1 }}>{value}</div>
      {sub && <div style={{ fontSize: '.72rem', color: 'var(--text-secondary)', marginTop: 4 }}>{sub}</div>}
    </div>
  )

  const contratoSel = contratos.find(c => c.id === sel)

  return (
    <div>
      <div className="topbar">
        <h2><Icon name="trending" size={20} /> Cronograma</h2>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          {contratos.length > 0 && (
            <select style={{ ...inp, width: 'auto', minWidth: 200 }} value={sel || ''} onChange={e => setSel(Number(e.target.value))}>
              {contratos.map(c => <option key={c.id} value={c.id}>{c.nome}{c.tem_cronograma ? '' : ' — sem cronograma'}</option>)}
            </select>
          )}
          {cron && podeEditar && !form && <button className="btn btn-outline btn-sm" onClick={abrirReconfig}><Icon name="edit" size={13} /> Reconfigurar</button>}
          {seletorVisao}
        </div>
      </div>
      <p style={{ fontSize: '.85rem', color: 'var(--text-secondary)', margin: '0 0 20px' }}>
        Curva S física-financeira por contrato: o planejado × o medido a cada período. O gerente lança a medição e os KPIs, a curva e o semáforo se atualizam sozinhos — sem planilha externa.
      </p>

      {/* FORM criar/reconfigurar */}
      {form && (
        <div className="card" style={{ padding: 20, marginBottom: 20 }}>
          <div style={{ fontSize: '.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', color: 'var(--text-secondary)', marginBottom: 14 }}>{form.modo === 'novo' ? 'Novo cronograma' : 'Reconfigurar cronograma'}</div>
          {form.modo === 'reconfig' && <div style={{ background: 'rgba(184,134,11,.12)', border: '1px solid var(--warning)', borderRadius: 10, padding: '10px 13px', fontSize: '.8rem', color: 'var(--ink)', marginBottom: 16 }}>⚠️ Reconfigurar recria os períodos — os valores <b>medidos</b> lançados serão apagados. O planejado e as etapas são preservados abaixo.</div>}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 12, marginBottom: 14 }}>
            <div style={{ gridColumn: '1 / -1' }}><label style={lbl}>Nome da obra / cronograma</label><input style={inp} value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} placeholder="Ex.: Construção do Galpão" /></div>
            <div><label style={lbl}>Início</label><input type="date" style={inp} value={form.inicio} onChange={e => setForm({ ...form, inicio: e.target.value })} /></div>
            <div><label style={lbl}>Nº de medições</label><input type="number" min="1" style={inp} value={form.num_medicoes} onChange={e => setForm({ ...form, num_medicoes: e.target.value })} /></div>
            <div><label style={lbl}>Dias por medição</label><input type="number" min="1" style={inp} value={form.dias_por_medicao} onChange={e => setForm({ ...form, dias_por_medicao: e.target.value })} /></div>
            <div><label style={lbl}>Valor sem BDI (R$)</label><input type="number" min="0" style={inp} value={form.valor_sem_bdi} onChange={e => setForm({ ...form, valor_sem_bdi: e.target.value })} placeholder="0" /></div>
            <div><label style={lbl}>BDI (%)</label><input type="number" min="0" style={inp} value={form.bdi} onChange={e => setForm({ ...form, bdi: e.target.value })} /></div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Etapas (opcional — peso por etapa)</label>
            {form.etapas.map((e, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <input style={{ ...inp, flex: 2 }} value={e.nome} onChange={ev => setEtapa(i, 'nome', ev.target.value)} placeholder="Nome da etapa" />
                <input type="number" min="0" style={{ ...inp, flex: 1 }} value={e.valor_sem_bdi} onChange={ev => setEtapa(i, 'valor_sem_bdi', ev.target.value)} placeholder="R$ s/ BDI" />
                <button className="btn btn-outline btn-sm" onClick={() => delEtapa(i)}><Icon name="trash" size={13} /></button>
              </div>
            ))}
            <button className="btn btn-outline btn-sm" onClick={addEtapa}><Icon name="plus" size={13} /> Adicionar etapa</button>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <button className="btn btn-primary" disabled={salvando} onClick={salvarForm}>{salvando ? 'Salvando…' : 'Salvar cronograma'}</button>
            <button className="btn btn-outline" onClick={() => setForm(null)}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Estados */}
      {cron === undefined && <div className="card" style={{ padding: 30, textAlign: 'center', color: 'var(--text-secondary)' }}>Carregando…</div>}
      {cron === null && !form && (
        <div className="card" style={{ padding: 34, textAlign: 'center' }}>
          <div style={{ color: 'var(--text-secondary)', marginBottom: 14 }}>{contratoSel ? <>O contrato <b>{contratoSel.nome}</b> ainda não tem cronograma.</> : 'Nenhum contrato disponível.'}</div>
          {contratoSel && podeEditar && <button className="btn btn-accent" onClick={abrirNovo}><Icon name="plus" size={14} /> Criar cronograma</button>}
        </div>
      )}

      {cron && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          {/* meta */}
          <div style={{ fontSize: '.8rem', color: 'var(--text-secondary)' }}>
            {cron.nome && <b style={{ color: 'var(--ink)' }}>{cron.nome}</b>}
            {cron.inicio && <> · início {cron.inicio.split('-').reverse().join('/')}</>}
            {cron.prazo_dias ? <> · prazo {cron.prazo_dias} dias</> : null}
            {cron.valor_com_bdi ? <> · contrato {brl(cron.valor_com_bdi)} (c/ BDI)</> : null}
          </div>

          {/* KPIs */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 12 }}>
            <KPI label="Físico planejado" value={pct(kpiPlan)} color="var(--primary-accent)" sub={atual ? `até a ${atual.numero}ª medição` : 'sem medição'} />
            <KPI label="Físico realizado" value={atual ? pct(kpiReal) : '—'} color="var(--success)" sub="acumulado medido" />
            <KPI label="Desvio (R−P)" value={kpiDesv === null ? '—' : (kpiDesv >= 0 ? '+' : '') + pct(kpiDesv)} color={sit.color} sub="realizado − planejado" />
            <KPI label="Financeiro medido" value={brl(kpiFin)} sub={`de ${brl(total)} sem BDI`} />
            <div className="card" style={{ padding: '13px 15px' }}>
              <div style={{ fontSize: '.68rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', color: 'var(--text-secondary)' }}>Situação</div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: 7, marginTop: 7, padding: '4px 11px', borderRadius: 999, background: sit.bg, color: sit.color, fontWeight: 700, fontSize: '.95rem' }}><span style={{ width: 9, height: 9, borderRadius: '50%', background: sit.color }} />{sit.label.toUpperCase()}</div>
            </div>
          </div>

          {/* Curva S */}
          <div className="card" style={{ padding: 18 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 8, marginBottom: 6 }}>
              <div style={{ fontWeight: 700 }}>Curva S — avanço acumulado (% do contrato)</div>
              <div style={{ display: 'flex', gap: 16, fontSize: '.78rem', color: 'var(--text-secondary)' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><span style={{ width: 16, borderTop: '3px dashed var(--silver)' }} /> Planejado</span>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><span style={{ width: 16, borderTop: '3px solid var(--primary-accent)' }} /> Realizado</span>
              </div>
            </div>
            <CurvaS />
            <div style={{ textAlign: 'center', fontSize: '.72rem', color: 'var(--text-secondary)', marginTop: 2 }}>dias de obra</div>
          </div>

          {/* Tabela de medição */}
          <div className="card">
            <div style={{ padding: '14px 16px 4px', fontWeight: 700 }}>Medição por período</div>
            {podeMedir && <div style={{ padding: '0 16px 10px', fontSize: '.75rem', color: 'var(--text-secondary)' }}>Clique nas células de <b style={{ color: 'var(--primary-accent)' }}>Medido</b> e <b style={{ color: 'var(--accent)' }}>Custo real</b>{podeEditar ? ' (ou Planejado)' : ''} para lançar valores. O custo real alimenta os índices de Valor Agregado abaixo.</div>}
            <div className="table-wrap"><table className="cards-mobile">
              <thead><tr>
                <th>Med.</th><th>Dias</th><th style={{ textAlign: 'right' }}>Planejado</th><th style={{ textAlign: 'right' }}>Plan. acum.</th><th style={{ textAlign: 'center' }}>% Plan.</th>
                <th style={{ textAlign: 'right' }}>Medido</th><th style={{ textAlign: 'right' }}>% Real.</th><th style={{ textAlign: 'right' }}>Custo real</th><th style={{ textAlign: 'center' }}>Desvio</th><th style={{ textAlign: 'center' }}>Status</th>
              </tr></thead>
              <tbody>
                {linhas.map(l => {
                  const st = statusInfo(l.desvio)
                  return (
                    <tr key={l.id}>
                      <td data-label="Med."><b>{l.numero}ª</b></td>
                      <td data-label="Dias">{l.dias}</td>
                      <td data-label="Planejado" style={{ textAlign: 'right' }}>
                        {podeEditar
                          ? <input key={'p' + l.id + l.planejado} defaultValue={l.planejado || ''} onBlur={e => salvarPeriodo(l, 'planejado', e.target.value)} onKeyDown={e => { if (e.key === 'Enter') e.target.blur() }} style={{ ...inp, textAlign: 'right', padding: '5px 8px', maxWidth: 120 }} />
                          : brl(l.planejado)}
                      </td>
                      <td data-label="Plan. acum." style={{ textAlign: 'right', color: 'var(--text-secondary)' }}>{brl(l.accP)}</td>
                      <td data-label="% Plan." style={{ textAlign: 'center', fontWeight: 600, color: 'var(--primary-accent)' }}>{pct(l.pctPlan)}</td>
                      <td data-label="Medido" style={{ textAlign: 'right' }}>
                        {podeMedir
                          ? <input key={'m' + l.id + (l.medido === null ? 'x' : l.medido)} defaultValue={l.medido === null ? '' : l.medido} onBlur={e => salvarPeriodo(l, 'medido', e.target.value)} onKeyDown={e => { if (e.key === 'Enter') e.target.blur() }} placeholder="—" style={{ ...inp, textAlign: 'right', padding: '5px 8px', maxWidth: 120, background: 'var(--surface-alt)', fontWeight: 600 }} />
                          : (l.medido === null ? '—' : brl(l.medido))}
                      </td>
                      <td data-label="% Real." style={{ textAlign: 'center', fontWeight: 600, color: 'var(--success)' }}>{l.pctReal === null ? '—' : pct(l.pctReal)}</td>
                      <td data-label="Custo real" style={{ textAlign: 'right' }}>
                        {podeMedir
                          ? <input key={'c' + l.id + (l.custo === null ? 'x' : l.custo)} defaultValue={l.custo === null ? '' : l.custo} onBlur={e => salvarPeriodo(l, 'custo', e.target.value)} onKeyDown={e => { if (e.key === 'Enter') e.target.blur() }} placeholder="—" style={{ ...inp, textAlign: 'right', padding: '5px 8px', maxWidth: 120, background: 'rgba(160,124,78,.14)', fontWeight: 600 }} />
                          : (l.custo === null ? '—' : brl(l.custo))}
                      </td>
                      <td data-label="Desvio" style={{ textAlign: 'center', fontWeight: 600, color: st.color }}>{l.desvio === null ? '—' : (l.desvio >= 0 ? '+' : '') + pct(l.desvio)}</td>
                      <td data-label="Status" style={{ textAlign: 'center' }}><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 9px', borderRadius: 999, background: st.bg, color: st.color, fontWeight: 700, fontSize: '.72rem' }}><span style={{ width: 7, height: 7, borderRadius: '50%', background: st.color }} />{st.label}</span></td>
                    </tr>
                  )
                })}
              </tbody>
            </table></div>
          </div>

          {/* Valor Agregado (EVM) — Opção C */}
          {evm && evm.cpi !== null && (
            <div className="card" style={{ padding: 18 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
                <div style={{ fontWeight: 700 }}>Valor Agregado (EVM) — desempenho de prazo e custo</div>
                <div style={{ fontSize: '.75rem', color: 'var(--text-secondary)' }}>na {atual.numero}ª medição · alimentado pelo custo real</div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 11 }}>
                <KPI label="IDP · prazo" value={evm.spi.toFixed(2)} color={evm.spi >= 1 ? 'var(--success)' : 'var(--danger)'} sub={evm.spi >= 1 ? 'no ritmo do plano' : `${Math.round((1 - evm.spi) * 100)}% mais lento que o plano`} />
                <KPI label="IDC · custo" value={evm.cpi.toFixed(2)} color={evm.cpi >= 1 ? 'var(--success)' : 'var(--danger)'} sub={evm.cpi >= 1 ? `rende ${Math.round((evm.cpi - 1) * 100)}% acima do custo` : `custo ${Math.round((1 - evm.cpi) * 100)}% acima`} />
                <KPI label="Término previsto" value={(evm.diasExtra >= 0 ? '+' : '') + Math.round(evm.diasExtra) + ' d'} color={evm.diasExtra > 2 ? 'var(--warning)' : 'var(--success)'} sub={`≈ ${Math.round(evm.termino)} dias vs. ${evm.prazo} contratados`} />
                <KPI label="Custo final (EAC)" value={brl(evm.eac)} color={evm.eac <= total ? 'var(--success)' : 'var(--danger)'} sub={evm.eac <= total ? 'dentro do orçamento' : 'acima do orçamento'} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(min(260px,100%),1fr))', gap: 14, marginTop: 14, alignItems: 'start' }}>
                <div>
                  <div style={{ fontSize: '.82rem', fontWeight: 700 }}>VP planejado × VA agregado × CR custo real</div>
                  <div style={{ fontSize: '.72rem', color: 'var(--text-secondary)', marginBottom: 6 }}>acumulado (R$ milhões)</div>
                  <CurvaEVM />
                  <div style={{ display: 'flex', gap: 14, fontSize: '.75rem', color: 'var(--text-secondary)', marginTop: 6, flexWrap: 'wrap' }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><span style={{ width: 16, borderTop: '3px dashed var(--silver)' }} /> VP planejado</span>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><span style={{ width: 16, borderTop: '3px solid var(--primary-accent)' }} /> VA agregado</span>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><span style={{ width: 16, borderTop: '3px solid var(--accent)' }} /> CR custo real</span>
                  </div>
                </div>
                <div style={{ background: 'var(--surface-alt)', borderRadius: 10, padding: 13 }}>
                  <div style={{ fontWeight: 700, fontSize: '.85rem', marginBottom: 8 }}>Leitura do gerente</div>
                  <div style={{ fontSize: '.82rem', color: 'var(--text)', display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <div>{evm.vc >= 0 ? <><b style={{ color: 'var(--success)' }}>Custo sob controle.</b> Variação de custo {brl(evm.vc)} — cada real medido rende.</> : <><b style={{ color: 'var(--danger)' }}>Custo estourando.</b> Variação de custo {brl(evm.vc)}.</>}</div>
                    <div>{evm.spi < 1 ? <><b style={{ color: 'var(--danger)' }}>Prazo é o risco.</b> Físico atrás do plano — a Execução (73% do valor) puxa o IDP.</> : <><b style={{ color: 'var(--success)' }}>Prazo em dia.</b></>}</div>
                    <div><b style={{ color: 'var(--warning)' }}>Ação:</b> reforçar a frente da Execução na próxima medição recupera o IDP.</div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Peso por etapa */}
          {cron.etapas && cron.etapas.length > 0 && (
            <div className="card">
              <div style={{ padding: '14px 16px 4px', fontWeight: 700 }}>Peso de cada etapa no contrato</div>
              <div className="table-wrap"><table className="cards-mobile">
                <thead><tr><th>Etapa</th><th style={{ textAlign: 'right' }}>R$ (sem BDI)</th><th style={{ textAlign: 'center' }}>% do contrato</th><th style={{ width: '30%' }}></th></tr></thead>
                <tbody>
                  {cron.etapas.map(e => {
                    const peso = total ? (e.valor_sem_bdi || 0) / total : 0
                    return (
                      <tr key={e.id}>
                        <td data-label="Etapa"><b>{e.nome}</b></td>
                        <td data-label="R$ (sem BDI)" style={{ textAlign: 'right', color: 'var(--text-secondary)' }}>{brl(e.valor_sem_bdi)}</td>
                        <td data-label="% do contrato" style={{ textAlign: 'center', fontWeight: 700, color: 'var(--accent)' }}>{pct(peso)}</td>
                        <td data-label=""><div style={{ height: 8, borderRadius: 99, background: 'var(--surface-alt)', overflow: 'hidden' }}><div style={{ width: (peso * 100).toFixed(1) + '%', height: '100%', background: 'var(--accent)', borderRadius: 99 }} /></div></td>
                      </tr>
                    )
                  })}
                </tbody>
              </table></div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

// ─── CRONOGRAMA DE MANUTENÇÃO — Gantt (contrato de serviço contínuo) ─────────────
// Visualização nova da aba Cronograma (alternância "Curva S | Gantt"). Desenhada aqui mesmo, sem
// biblioteca: a rotina recorrente fica numa linha só (várias barras), com linha de base, faixa de
// marcos e medição e o cruzamento com as cautelas — o que nas bibliotecas gratuitas é recurso PRO.
// Só as linhas visíveis são desenhadas, então a visão de 1 ano com todas as unidades não trava.
const MNT_STATUS = {
  PLANEJADA: { rotulo: 'Planejada', tom: 'tg-aco', glifo: '' },
  EM_EXECUCAO: { rotulo: 'Em execução', tom: 'tg-aco', glifo: '▸' },
  CONCLUIDA: { rotulo: 'Concluída', tom: 'tg-ok', glifo: '✓' },
  ATRASADA: { rotulo: 'Atrasada', tom: 'tg-perigo', glifo: '!' },
  REPROGRAMADA: { rotulo: 'Reprogramada', tom: 'tg-alerta', glifo: '↻' },
  CANCELADA: { rotulo: 'Cancelada', tom: 'tg-neutro', glifo: '✕' },
}
const MNT_TIPO = { PREVENTIVA: 'Preventiva', PMOC: 'PMOC', CORRETIVA_OS: 'OS corretiva', ADMINISTRATIVA: 'Administrativa', MARCO_CONTRATUAL: 'Marco contratual' }
const MNT_CAUTELA = {
  com: { rotulo: 'Com cautela', tom: 'tg-ok' }, pendente: { rotulo: 'Cautela pendente', tom: 'tg-alerta' },
  sem: { rotulo: 'Sem cautela', tom: 'tg-perigo' }, sem_kit: { rotulo: 'Sem kit definido', tom: 'tg-neutro' },
}
const MNT_FECHADO = ['CONCLUIDA', 'CANCELADA']
// Remonta o item enxuto que vem do servidor (dados do plano + campos omitidos por serem o padrão).
const mntRemontar = planos => i => {
  const o = i.plano_id ? { ...planos[i.plano_id], ...i } : { ...i }
  o.key = o.plano_id ? `p${o.plano_id}:${o.ocorrencia}` : 'a' + o.id
  o.base_inicio = o.base_inicio || o.prev_inicio; o.base_fim = o.base_fim || o.prev_fim
  o.status = o.status || o.status_efetivo; o.pct = o.pct || 0
  return o
}
// Datas 'AAAA-MM-DD' em UTC (dia civil de Brasília vindo do servidor).
const mntT = s => { const [y, m, d] = s.split('-').map(Number); return Date.UTC(y, m - 1, d) }
const mntISO = t => new Date(t).toISOString().slice(0, 10)
const mntAdd = (s, n) => mntISO(mntT(s) + n * 864e5)
const mntMes = (s, n) => { const d = new Date(mntT(s)); const y = d.getUTCFullYear(), m = d.getUTCMonth() + n; return mntISO(Date.UTC(y, m, Math.min(d.getUTCDate(), new Date(Date.UTC(y, m + 1, 0)).getUTCDate()))) }
const mntDiff = (a, b) => Math.round((mntT(b) - mntT(a)) / 864e5)
const mntDow = s => new Date(mntT(s)).getUTCDay()
const mntSeg = s => mntAdd(s, -((mntDow(s) + 6) % 7))
const mntHoje = () => { try { return new Date().toLocaleDateString('sv-SE', { timeZone: 'America/Sao_Paulo' }) } catch { return today() } }
const MNT_MESES = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
const MNT_DIAS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb']
const mntMesAno = s => MNT_MESES[+s.slice(5, 7) - 1] + '/' + s.slice(0, 4)
const mntDM = s => (s ? s.slice(8, 10) + '/' + s.slice(5, 7) : '—')
const mntDH = s => (s ? fmt(s.slice(0, 10)) + (s.length > 10 ? ' ' + s.slice(11, 16) : '') : '')
const mntFaixa = (a, b) => (!a ? '—' : a === b || !b ? fmt(a) : `${fmt(a)} a ${fmt(b)}`)
function mntFreq(u, n) {
  n = Number(n) || 1
  if (u === 'dia') return n === 1 ? 'Diária' : `A cada ${n} dias`
  if (u === 'semana') return n === 1 ? 'Semanal' : n === 2 ? 'Quinzenal' : `A cada ${n} semanas`
  if (u === 'ano') return n === 1 ? 'Anual' : `A cada ${n} anos`
  return { 1: 'Mensal', 2: 'Bimestral', 3: 'Trimestral', 4: 'Quadrimestral', 6: 'Semestral', 12: 'Anual' }[n] || `A cada ${n} meses`
}
const lsLer = (k, pad) => { try { return localStorage.getItem(k) || pad } catch { return pad } }
const lsGravar = (k, v) => { try { localStorage.setItem(k, v) } catch {} }
// Escalas: janela padrão + passo da navegação + largura mínima de um dia (px).
const MNT_ESCALAS = {
  semana: { rotulo: 'Semana', janela: a => { const de = mntSeg(a); return [de, mntAdd(de, 13)] }, passo: 7, minPx: 44 },
  mes: { rotulo: 'Mês', janela: a => { const de = a.slice(0, 7) + '-01'; return [de, mntAdd(mntMes(de, 2), -1)] }, meses: 1, minPx: 15 },
  trimestre: { rotulo: 'Trimestre', janela: a => { const q = Math.floor((+a.slice(5, 7) - 1) / 3) * 3 + 1; const de = a.slice(0, 4) + '-' + String(q).padStart(2, '0') + '-01'; return [de, mntAdd(mntMes(de, 6), -1)] }, meses: 3, minPx: 5 },
  ano: { rotulo: 'Ano', janela: a => [a.slice(0, 4) + '-01-01', a.slice(0, 4) + '-12-31'], meses: 12, minPx: 2.6 },
}
const mntNavegar = (escala, a, dir) => (MNT_ESCALAS[escala].passo ? mntAdd(a, dir * MNT_ESCALAS[escala].passo) : mntMes(a, dir * MNT_ESCALAS[escala].meses))
const MNT_AGRUPAR = { unidade: 'Unidade → Sistema', sistema: 'Sistema → Unidade', equipe: 'Equipe → Unidade' }

// Linhas do Gantt: agrupa os itens (filtrados) em dois níveis e achata respeitando o que está recolhido.
// A rotina recorrente é UMA linha com todas as ocorrências da janela; OS e avulsas têm linha própria.
function mntLinhas(itens, cautelas, modo, fechados, equipes, mostrarCautelas, hoje) {
  const nomeEquipe = id => (equipes.get(id) || {}).nome || 'Sem equipe definida'
  const semSistema = i => (i.tipo === 'CORRETIVA_OS' ? 'Corretivas sem sistema' : i.tipo === 'ADMINISTRATIVA' ? 'Administrativo' : 'Sem sistema')
  const nivel = (i, qual) => {
    const eixo = qual === 1 ? (modo === 'unidade' ? 'u' : modo === 'sistema' ? 's' : 'e') : (modo === 'unidade' ? 's' : 'u')
    if (eixo === 'u') return [i.obra_id ? 'u' + i.obra_id : 'u0', i.obra_nome || 'Contrato (geral)', !i.obra_id]
    if (eixo === 's') return [i.sistema_id ? 's' + i.sistema_id : 's0' + i.tipo, i.sistema_nome || semSistema(i), !i.sistema_id]
    return [i.responsavel_id ? 'e' + i.responsavel_id : 'e0', nomeEquipe(i.responsavel_id), !i.responsavel_id]
  }
  const arv = new Map()
  for (const i of itens) {
    const [k1, t1, fim1] = nivel(i, 1), [k2, t2, fim2] = nivel(i, 2)
    if (!arv.has(k1)) arv.set(k1, { key: k1, titulo: t1, fim: fim1, filhos: new Map(), cautelas: [] })
    const g1 = arv.get(k1)
    if (!g1.filhos.has(k2)) g1.filhos.set(k2, { key: k1 + '/' + k2, titulo: t2, fim: fim2, linhas: new Map() })
    const g2 = g1.filhos.get(k2)
    const lk = i.plano_id ? 'p' + i.plano_id : 'a' + i.id
    if (!g2.linhas.has(lk)) {
      const sub = i.plano_id ? mntFreq(i.freq_unidade, i.freq_intervalo) + (modo !== 'equipe' && i.responsavel_id ? ' · ' + nomeEquipe(i.responsavel_id) : '')
        : i.os ? `OS · ${i.os.prioridade}${i.os.solicitante ? ' · ' + i.os.solicitante : ''}` : MNT_TIPO[i.tipo]
      g2.linhas.set(lk, { kind: 'l', key: g2.key + '/' + lk, titulo: i.titulo, sub, pmoc: i.tipo === 'PMOC', itens: [] })
    }
    g2.linhas.get(lk).itens.push(i)
  }
  const cautRows = c => ({ kind: 'c', key: 'c' + c.id, titulo: `${c.numero} · ${c.itens} ${c.itens === 1 ? 'item' : 'itens'}`, sub: (c.status === 'aguardando_retirada' ? 'A retirar · ' : '') + (c.obra_nome || c.lider_nome), cautela: c })
  if (mostrarCautelas && cautelas.length) {
    if (modo === 'equipe') {
      for (const c of cautelas) {
        const k1 = 'e' + c.lider_id
        if (!arv.has(k1)) arv.set(k1, { key: k1, titulo: nomeEquipe(c.lider_id), fim: false, filhos: new Map(), cautelas: [] })
        arv.get(k1).cautelas.push(c)
      }
    } else {
      const g = { key: 'zcautelas', titulo: 'Cautelas das equipes', fim: true, ultimo: true, filhos: new Map(), cautelas: [] }
      for (const c of cautelas) {
        const k2 = 'e' + c.lider_id
        if (!g.filhos.has(k2)) g.filhos.set(k2, { key: g.key + '/' + k2, titulo: c.lider_nome, linhas: new Map(), soCautela: [] })
        g.filhos.get(k2).soCautela.push(c)
      }
      arv.set(g.key, g)
    }
  }
  const ord = (a, b) => (!!a.ultimo - !!b.ultimo) || (!!a.fim - !!b.fim) || a.titulo.localeCompare(b.titulo, 'pt')
  const conta = lista => ({ n: lista.length, atrasadas: lista.filter(i => i.status_efetivo === 'ATRASADA').length })
  const out = []
  for (const g1 of [...arv.values()].sort(ord)) {
    const todos = [...g1.filhos.values()].flatMap(g => [...g.linhas.values()].flatMap(l => l.itens))
    const aberto1 = !fechados.has(g1.key)
    out.push({ kind: 'g1', key: g1.key, titulo: g1.titulo, aberto: aberto1, ...conta(todos), ncaut: g1.cautelas.length + [...g1.filhos.values()].reduce((s, f) => s + ((f.soCautela || []).length), 0) })
    if (!aberto1) continue
    if (g1.cautelas.length) {
      out.push({ kind: 'g2', key: g1.key + '/caut', titulo: 'Cautelas da equipe', aberto: !fechados.has(g1.key + '/caut'), n: 0, atrasadas: 0, ncaut: g1.cautelas.length })
      if (!fechados.has(g1.key + '/caut')) for (const c of g1.cautelas) out.push(cautRows(c))
    }
    for (const g2 of [...g1.filhos.values()].sort(ord)) {
      const itensG2 = [...g2.linhas.values()].flatMap(l => l.itens)
      const aberto2 = !fechados.has(g2.key)
      out.push({ kind: 'g2', key: g2.key, titulo: g2.titulo, aberto: aberto2, ...conta(itensG2), ncaut: (g2.soCautela || []).length })
      if (!aberto2) continue
      for (const c of g2.soCautela || []) out.push(cautRows(c))
      for (const l of [...g2.linhas.values()].sort((a, b) => a.titulo.localeCompare(b.titulo, 'pt'))) {
        l.itens.sort((a, b) => (a.prev_inicio < b.prev_inicio ? -1 : 1))
        const c = conta(l.itens)
        // Estado da cautela para o que está em curso ou começa nos próximos 14 dias (o pior deles).
        const prox = l.itens.filter(i => !MNT_FECHADO.includes(i.status) && i.cautela && i.prev_inicio <= mntAdd(hoje, 14) && i.prev_fim >= mntAdd(hoje, -30))
        const pior = ['sem', 'pendente', 'com'].find(e => prox.some(i => i.cautela.estado === e)) || null
        out.push({ ...l, ...c, cautelaProx: pior })
      }
    }
  }
  return out
}

// Período desenhado da barra: o realizado quando houver (em execução vai até hoje ou até a previsão).
// OS vai da abertura até a conclusão — ou até hoje, se está aberta e vencida; o prazo do SLA fica na
// linha de base cinza embaixo, e dá para ver de relance quanto passou do SLA.
function mntBarraDatas(i, hoje) {
  let ini, fim
  if (i.os) {
    ini = i.prev_inicio
    fim = i.os.conclusao ? i.os.conclusao.slice(0, 10) : !MNT_FECHADO.includes(i.status) && hoje > i.prev_fim ? hoje : i.prev_fim
  } else {
    ini = i.real_inicio || i.prev_inicio
    fim = i.real_inicio ? (i.real_fim || (i.prev_fim > hoje ? i.prev_fim : hoje)) : i.prev_fim
  }
  return [ini, fim < ini ? ini : fim]
}

// Gantt desenhado com DOM absoluto + rolagem virtual (linhas e colunas fora da tela não são desenhadas).
function MntGantt({ dados, linhas, de, ate, escala, selKey, onItem, onLinha, onToggle, onMedicao, onMarco, onCautela }) {
  const scRef = useRef(null)
  const raf = useRef(0)
  const [vp, setVp] = useState({ top: 0, left: 0, w: 1000, h: 560 })
  useEffect(() => {
    const el = scRef.current
    if (!el) return
    const medir = () => setVp({ top: el.scrollTop, left: el.scrollLeft, w: el.clientWidth, h: el.clientHeight })
    medir()
    const onScroll = () => { cancelAnimationFrame(raf.current); raf.current = requestAnimationFrame(medir) }
    el.addEventListener('scroll', onScroll, { passive: true })
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(medir) : null
    if (ro) ro.observe(el)
    return () => { el.removeEventListener('scroll', onScroll); if (ro) ro.disconnect(); cancelAnimationFrame(raf.current) }
  }, [])
  const hoje = dados.hoje
  const LW = vp.w < 640 ? 148 : 290
  const dias = mntDiff(de, ate) + 1
  const px = Math.max(MNT_ESCALAS[escala].minPx, (vp.w - LW - 2) / dias)
  const W = Math.ceil(px * dias)
  const x = d => mntDiff(de, d) * px
  const ROW = 34, TIER = 22, LANE = 26
  const temMedicao = dados.contrato.configurado
  const lanes = temMedicao ? ['marcos', 'periodo', 'etapas', 'pagamento'] : (dados.marcos.length ? ['marcos'] : [])
  const headH = TIER * 2 + lanes.length * LANE
  const bodyH = linhas.length * ROW
  // Ao trocar de janela: posiciona "hoje" a 1/4 da tela (ou volta ao início).
  useEffect(() => {
    const el = scRef.current
    if (!el) return
    el.scrollLeft = hoje >= de && hoje <= ate ? Math.max(0, x(hoje) - (el.clientWidth - LW) * 0.25) : 0
  }, [de, ate, escala, W])
  const xMin = vp.left - 60, xMax = vp.left + vp.w - LW + 60
  const visivel = (a, b) => b >= xMin && a <= xMax
  const i0 = Math.max(0, Math.floor(vp.top / ROW) - 6)
  const i1 = Math.min(linhas.length, Math.ceil((vp.top + Math.max(vp.h - headH, 200)) / ROW) + 6)
  const dMin = mntAdd(de, Math.max(0, Math.floor(xMin / px) - 1)), dMax = mntAdd(de, Math.min(dias - 1, Math.ceil(xMax / px) + 1))

  // Régua de tempo (duas faixas) e fundo (fins de semana, feriados, divisões) — só a parte visível.
  const topo = [], base = [], fundo = []
  const feriados = new Map((dados.feriados || []).map(f => [f.data, f.nome]))
  const semExpediente = d => { const w = mntDow(d); return w === 0 || (w === 6 && !dados.sabado_util) || feriados.has(d) }
  if (escala === 'ano') {
    for (let q = 0; q < 4; q++) { const a = de.slice(0, 4) + '-' + String(q * 3 + 1).padStart(2, '0') + '-01'; const b = mntMes(a, 3); topo.push({ k: a, x: x(a), w: x(b) - x(a), t: `${q + 1}º trimestre ${de.slice(0, 4)}` }) }
    for (let m = de; m <= ate; m = mntMes(m, 1)) { base.push({ k: m, x: x(m), w: x(mntMes(m, 1)) - x(m), t: MNT_MESES[+m.slice(5, 7) - 1] }); fundo.push({ k: 'd' + m, div: true, x: x(m) }) }
  } else {
    for (let m = de.slice(0, 7) + '-01'; m <= ate; m = mntMes(m, 1)) {
      const a = m < de ? de : m, b = mntMes(m, 1) > ate ? mntAdd(ate, 1) : mntMes(m, 1)
      topo.push({ k: m, x: x(a), w: x(b) - x(a), t: MNT_MESES[+m.slice(5, 7) - 1] + ' ' + m.slice(0, 4) })
      fundo.push({ k: 'd' + m, div: true, x: x(a) })
    }
    if (escala === 'trimestre') {
      for (let s = mntSeg(de); s <= ate; s = mntAdd(s, 7)) if (s >= de && visivel(x(s), x(s) + 7 * px)) base.push({ k: s, x: x(s), w: 7 * px, t: mntDM(s) })
    } else {
      const passo = px < 18 ? 2 : 1
      for (let d = dMin; d <= dMax; d = mntAdd(d, 1)) {
        const fds = semExpediente(d)
        if (fds) fundo.push({ k: d, fds: true, x: x(d), w: px, t: feriados.get(d) })
        if (mntDiff(de, d) % passo === 0) base.push({ k: d, x: x(d), w: px * passo, t: escala === 'semana' ? `${MNT_DIAS[mntDow(d)]} ${d.slice(8)}` : d.slice(8), fds, hoje: d === hoje, dica: feriados.get(d) })
      }
    }
  }
  const hojeX = hoje >= de && hoje <= ate ? x(hoje) + px / 2 : null

  const dicaItem = i => [
    i.titulo, i.obra_nome, `${MNT_STATUS[i.status_efetivo].rotulo} · previsto ${mntFaixa(i.prev_inicio, i.prev_fim)}`,
    i.real_inicio ? `realizado ${mntFaixa(i.real_inicio, i.real_fim)}` : null,
    i.base_inicio !== i.prev_inicio || i.base_fim !== i.prev_fim ? `linha de base ${mntFaixa(i.base_inicio, i.base_fim)}` : null,
    i.os ? `SLA até ${i.os.prazo.slice(8, 10)}/${i.os.prazo.slice(5, 7)} ${i.os.prazo.slice(11)}` : null,
    i.cautela && i.cautela.estado !== 'sem_kit' ? MNT_CAUTELA[i.cautela.estado].rotulo : null,
  ].filter(Boolean).join('\n')

  const barras = linha => {
    const els = []
    for (const i of linha.itens) {
      const st = i.status_efetivo
      const [ini, fim] = mntBarraDatas(i, hoje)
      const x1 = x(ini), x2 = x(fim) + px
      const b1 = x(i.base_inicio), b2 = x(i.base_fim) + px
      if (!visivel(Math.min(x1, b1), Math.max(x2, b2) + 40)) continue
      const w = Math.max(3, x2 - x1)
      els.push(<div key={i.key + 'b'} className="gt-base" style={{ left: b1, width: Math.max(2, b2 - b1) }} />)
      const g = MNT_STATUS[st].glifo
      els.push(
        <div key={i.key} className={`gt-bar st-${st}${i.tipo === 'PMOC' ? ' pmoc' : ''}${selKey === i.key ? ' sel' : ''}`} style={{ left: x1, width: w }}
          title={dicaItem(i)} role="button" tabIndex={0} aria-label={dicaItem(i)} onKeyDown={e => { if (e.key === 'Enter') onItem(i) }} onClick={e => { e.stopPropagation(); onItem(i) }}>
          {w >= 16 && g && <span aria-hidden="true">{g}</span>}
          {w >= 92 && <span>{MNT_STATUS[st].rotulo}</span>}
        </div>)
      if (i.os && i.os.conclusao) {
        const dc = i.os.conclusao.slice(0, 10)
        els.push(<div key={i.key + 'c'} className="gt-conclusao" style={{ left: x(dc) + px / 2 - 5, background: i.os.conclusao > i.os.prazo ? 'var(--fill-danger)' : 'var(--fill-ok)' }} />)
      }
      const est = i.cautela && i.cautela.estado
      if (px >= 6 && est && est !== 'sem_kit' && !MNT_FECHADO.includes(i.status) && i.prev_inicio <= mntAdd(hoje, 14) && i.prev_fim >= mntAdd(hoje, -30))
        els.push(<div key={i.key + 'k'} className={`gt-dot ${est}`} style={{ left: x1 + w + 3 }} />)
    }
    return els
  }
  const barrasCautela = c => {
    const x1 = x(c.inicio < de ? de : c.inicio), fimD = hoje > ate ? ate : hoje, x2 = x(fimD) + px
    if (!visivel(x1, x2) || x2 <= x1) return null
    return <div className={`gt-bar cautela aberta-fim${c.status === 'aguardando_retirada' ? ' aguardando' : ''}`} style={{ left: x1, width: Math.max(4, x2 - x1) }}
      title={`${c.numero} — ${c.lider_nome}\n${c.status === 'ativa' ? 'Ativa' : 'Aguardando retirada'} desde ${fmt(c.inicio)}\n${c.unidades} unidade(s) em ${c.itens} item(ns)`}
      onClick={e => { e.stopPropagation(); onCautela(c) }}>{x2 - x1 >= 80 && <span>{c.numero}</span>}</div>
  }
  const laneConteudo = tipo => {
    if (tipo === 'marcos') {
      const ms = dados.marcos
      return ms.map((m, k) => {
        const mx = x(m.data) + px / 2
        if (!visivel(mx - 8, mx + 260)) return null
        // Rótulo à direita do losango; perto do fim da janela, à esquerda (até o marco anterior).
        const prox = Math.min(ms[k + 1] ? x(ms[k + 1].data) - mx : 9999, W - mx)
        // O rótulo do marco anterior ocupa até 240px à direita dele; o daqui só vai à esquerda no que sobra.
        const ant = ms[k - 1] ? mx - x(ms[k - 1].data) - 250 : mx
        const cls = m.data < hoje ? 'passado' : (m.alerta && mntDiff(hoje, m.data) <= 60) ? 'alerta' : ''
        const lado = prox > 130 ? 'dir' : ant > 100 ? 'esq' : null
        return <React.Fragment key={m.key}>
          <div className={`gt-marco ${cls}`} style={{ left: mx - 6 }} title={`${m.titulo}\n${fmt(m.data)}${m.legal ? '\n' + m.legal : ''}`} onClick={() => onMarco(m)} />
          {lado === 'dir' && <div className="gt-marco-t" style={{ left: mx + 10, maxWidth: Math.min(prox - 22, 240), overflow: 'hidden', textOverflow: 'ellipsis' }}>{m.titulo}</div>}
          {lado === 'esq' && <div className="gt-marco-t" style={{ right: W - mx + 10, maxWidth: Math.min(ant, 240), overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'right' }}>{m.titulo}</div>}
        </React.Fragment>
      })
    }
    return dados.medicoes.flatMap(med => {
      const etapas = tipo === 'periodo' ? med.etapas.slice(0, 1) : tipo === 'etapas' ? med.etapas.slice(1, 4) : med.etapas.slice(4)
      return etapas.map(e => {
        const x1 = x(e.inicio < de ? de : e.inicio), x2 = x(e.fim > ate ? ate : e.fim) + px
        if (!visivel(x1, x2) || x2 <= x1) return null
        const st = e.status, w = x2 - x1 - (tipo === 'etapas' ? 1 : 0)
        const rot = tipo === 'periodo' ? `Medição ${med.competencia.slice(5)}/${med.competencia.slice(0, 4)}` : e.titulo
        return <div key={med.competencia + e.etapa} className={`gt-bar st-${st}`} style={{ left: x1, width: Math.max(3, w) }}
          title={`Medição ${med.competencia.slice(5)}/${med.competencia.slice(0, 4)} — ${e.titulo}\nprevisto até ${fmt(e.fim)}${e.real ? '\nrealizado em ' + fmt(e.real) : ''}\n${MNT_STATUS[st].rotulo}${e.atraso ? ' (com atraso)' : ''}${med.glosa ? '\nCom glosa' : ''}`}
          onClick={() => onMedicao(med)}>
          {w >= 16 && MNT_STATUS[st].glifo && <span aria-hidden="true">{MNT_STATUS[st].glifo}</span>}
          {w >= 110 && <span>{rot}</span>}
        </div>
      })
    })
  }
  const LANE_ROT = LW < 200 ? { marcos: 'Marcos', periodo: 'Medição', etapas: 'Envio·ateste·NF', pagamento: 'Pagamento' }
    : { marcos: 'Marcos do contrato', periodo: 'Medição · período', etapas: 'Envio · ateste · NF', pagamento: 'Pagamento' }
  const fundoEls = (alt) => <div className="gt-bg" style={{ left: LW, width: W, height: alt }}>
    {fundo.map(f => f.div ? <div key={f.k} className="div" style={{ left: f.x }} /> : <div key={f.k} className="fds" style={{ left: f.x, width: f.w }} title={f.t || undefined} />)}
  </div>

  return (
    <div className="gt-wrap">
      <div className="gt-scroll" ref={scRef}>
        <div style={{ width: LW + W, position: 'relative' }}>
          <div className="gt-head" style={{ width: LW + W }}>
            {[topo, base].map((tier, n) => (
              <div key={n} className={`gt-tier${n === 0 ? ' top' : ''}`} style={{ width: LW + W }}>
                <div className="gt-corner" style={{ width: LW, height: TIER, position: 'sticky' }}>
                  {n === 0 && <span style={{ border: 'none', position: 'static', fontWeight: 700 }}>Atividades</span>}
                </div>
                {tier.filter(c => visivel(c.x, c.x + c.w)).map(c => (
                  <span key={c.k} className={`${c.fds ? 'fds' : ''}${c.hoje ? ' hoje' : ''}`} style={{ left: LW + c.x, width: c.w }} title={c.dica || undefined}>{c.w > 14 ? c.t : ''}</span>
                ))}
              </div>
            ))}
            {lanes.map(tipo => (
              <div key={tipo} className="gt-lane" style={{ position: 'relative', height: LANE, width: LW + W }}>
                <div className="gt-lbl" style={{ width: LW, height: LANE }}><div className="tx"><div className="t">{LANE_ROT[tipo]}</div></div></div>
                <div className="gt-track" style={{ left: LW, width: W, height: LANE }}>{laneConteudo(tipo)}</div>
                {hojeX != null && <div className="gt-hoje" style={{ left: LW + hojeX - 1 }} />}
              </div>
            ))}
          </div>
          <div style={{ position: 'relative', height: Math.max(bodyH, 120) }}>
            {fundoEls(Math.max(bodyH, 120))}
            {hojeX != null && <div className="gt-hoje" style={{ left: LW + hojeX - 1, height: Math.max(bodyH, 120) }} title={`Hoje, ${fmt(hoje)}`} />}
            {!linhas.length && <div style={{ position: 'sticky', left: 0, width: Math.min(vp.w, LW + W), padding: '40px 16px', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '.88rem' }}>Nenhuma atividade no período com os filtros atuais.</div>}
            {linhas.slice(i0, i1).map((l, k) => {
              const top = (i0 + k) * ROW
              if (l.kind === 'g1' || l.kind === 'g2') return (
                <div key={l.key} className={`gt-row ${l.kind}`} style={{ top, height: ROW, width: LW + W }}>
                  <div className={`gt-lbl ${l.kind}`} style={{ width: LW, paddingLeft: l.kind === 'g2' ? 18 : 8 }} onClick={() => onToggle(l.key)} title={l.titulo} role="button" tabIndex={0} aria-expanded={l.aberto} onKeyDown={e => { if (e.key === 'Enter') onToggle(l.key) }}>
                    <span className={`chev${l.aberto ? ' aberto' : ''}`}><Icon name="chevronRight" size={13} /></span>
                    <div className="tx"><div className="t">{l.titulo}</div></div>
                    <div className="tags">
                      {l.atrasadas > 0 && <span className="rtag rtag-sm tg-perigo" title={`${l.atrasadas} atrasada(s) no período`}>! {l.atrasadas}</span>}
                      <span className="rtag rtag-sm tg-neutro" title={l.n ? `${l.n} ocorrência(s) no período` : `${l.ncaut} cautela(s)`}>{l.n || l.ncaut}</span>
                    </div>
                  </div>
                  <div className="gt-track" style={{ left: LW, width: W }} />
                </div>
              )
              if (l.kind === 'c') return (
                <div key={l.key} className="gt-row" style={{ top, height: ROW, width: LW + W }}>
                  <div className="gt-lbl" style={{ width: LW, paddingLeft: 30 }} onClick={() => onCautela(l.cautela)} title={l.titulo}>
                    <div className="tx"><div className="t">{l.titulo}</div><div className="s">{l.sub}</div></div>
                    <div className="tags"><span className="rtag rtag-sm tg-cobre">Cautela</span></div>
                  </div>
                  <div className="gt-track" style={{ left: LW, width: W }}>{barrasCautela(l.cautela)}</div>
                </div>
              )
              return (
                <div key={l.key} className="gt-row" style={{ top, height: ROW, width: LW + W }}>
                  <div className="gt-lbl" style={{ width: LW, paddingLeft: 30 }} onClick={() => onLinha(l)} title={`${l.titulo}\n${l.sub}`} role="button" tabIndex={0} onKeyDown={e => { if (e.key === 'Enter') onLinha(l) }}>
                    <div className="tx"><div className="t">{l.titulo}</div><div className="s">{l.sub}</div></div>
                    <div className="tags">
                      {l.pmoc && <span className="rtag rtag-sm tg-cobre" title="Item do PMOC (Lei 13.589/2018)">PMOC</span>}
                      {l.atrasadas > 0 && <span className="rtag rtag-sm tg-perigo" title={`${l.atrasadas} atrasada(s) no período`}>! {l.atrasadas}</span>}
                      {l.cautelaProx && l.cautelaProx !== 'com' && <span className={`rtag rtag-sm ${MNT_CAUTELA[l.cautelaProx].tom}`} title={MNT_CAUTELA[l.cautelaProx].rotulo + ' (próximos 14 dias)'}><Icon name="wrench" size={11} /></span>}
                    </div>
                  </div>
                  <div className="gt-track" style={{ left: LW, width: W }}>{barras(l)}</div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className="gt-legenda">
        {['PLANEJADA', 'EM_EXECUCAO', 'CONCLUIDA', 'ATRASADA', 'REPROGRAMADA', 'CANCELADA'].map(s => (
          <span key={s} className="it"><span className={`gt-bar sw st-${s}`}>{MNT_STATUS[s].glifo}</span>{MNT_STATUS[s].rotulo}</span>
        ))}
        <span className="it"><span style={{ width: 22, height: 3, background: 'var(--silver)', borderRadius: 2, display: 'inline-block' }} />Linha de base</span>
        <span className="it"><span className="gt-bar sw st-PLANEJADA pmoc" />PMOC</span>
        <span className="it"><span style={{ width: 9, height: 9, background: 'var(--fill-navy)', transform: 'rotate(45deg)', display: 'inline-block' }} />Marco</span>
        <span className="it"><span className="gt-dot sem" style={{ position: 'static', display: 'inline-block' }} /> / <span className="gt-dot pendente" style={{ position: 'static', display: 'inline-block' }} /> / <span className="gt-dot com" style={{ position: 'static', display: 'inline-block' }} />Sem / pendente / com cautela</span>
        <span className="it"><span style={{ width: 2, height: 12, background: 'var(--accent)', display: 'inline-block' }} />Hoje</span>
      </div>
    </div>
  )
}

// PDF (A4 paisagem) da visão atual: impressão pelo navegador, num iframe (sem pop-up) — anexo ao fiscal.
function mntImprimir({ dados, linhas, de, ate, filtrosTxt }) {
  const dias = mntDiff(de, ate) + 1
  const L = d => (Math.max(0, mntDiff(de, d)) / dias * 100).toFixed(3)
  const Wd = (a, b) => (Math.max(0.15, (mntDiff(a < de ? de : a, b > ate ? ate : b) + 1) / dias * 100)).toFixed(3)
  const COR = { PLANEJADA: ['#E7EDF3', '#4A90A4', '#2B4560'], EM_EXECUCAO: ['#4A90A4', '#4A90A4', '#fff'], CONCLUIDA: ['#2E7D6B', '#2E7D6B', '#fff'],
    ATRASADA: ['#7A2E2E', '#7A2E2E', '#fff'], REPROGRAMADA: ['#F8F0DA', '#B8860B', '#7D5C0A'], CANCELADA: ['#EDF0F3', '#8A9BB0', '#56667A'] }
  const e = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))
  const barra = (a, b, st, txt, pmoc) => { const [bg, bd, fg] = COR[st]; return `<i class="b" style="left:${L(a)}%;width:${Wd(a, b)}%;background:${bg};border-color:${bd};color:${fg}${pmoc ? ';box-shadow:inset 2px 0 0 #A07C4E' : ''}">${txt || ''}</i>` }
  const meses = []
  for (let m = de.slice(0, 7) + '-01'; m <= ate; m = mntMes(m, 1)) { const a = m < de ? de : m; const b = mntAdd(mntMes(m, 1), -1); meses.push(`<i class="m" style="left:${L(a)}%;width:${Wd(a, b)}%">${MNT_MESES[+m.slice(5, 7) - 1]}/${m.slice(2, 4)}</i>`) }
  const hojeL = dados.hoje >= de && dados.hoje <= ate ? `<i class="h" style="left:${L(dados.hoje)}%"></i>` : ''
  const corpo = linhas.map(l => {
    if (l.kind === 'g1' || l.kind === 'g2') return `<tr class="${l.kind}"><td colspan="2">${e(l.titulo)}${l.atrasadas ? ` <span class="atr">! ${l.atrasadas} atrasada(s)</span>` : ''}</td></tr>`
    if (l.kind === 'c') { const c = l.cautela; return `<tr><td class="lb">${e(l.titulo)}<small>${e(l.sub)}</small></td><td><div class="tr">${barra(c.inicio < de ? de : c.inicio, dados.hoje > ate ? ate : dados.hoje, 'PLANEJADA', e(c.numero))}${hojeL}</div></td></tr>` }
    const bs = l.itens.map(i => {
      const [ini, fim] = mntBarraDatas(i, dados.hoje)
      return `<i class="bl" style="left:${L(i.base_inicio)}%;width:${Wd(i.base_inicio, i.base_fim)}%"></i>` + barra(ini, fim, i.status_efetivo, MNT_STATUS[i.status_efetivo].glifo, i.tipo === 'PMOC')
    }).join('')
    return `<tr><td class="lb">${e(l.titulo)}<small>${e(l.sub)}${l.pmoc ? ' · PMOC' : ''}</small></td><td><div class="tr">${bs}${hojeL}</div></td></tr>`
  }).join('')
  // Rótulo do marco à direita do losango; no último terço da página, à esquerda (não vaza da folha).
  const marcos = dados.marcos.map(m => `<i class="mk" style="left:${L(m.data)}%" title="${e(m.titulo)}"></i><i class="mt" style="${L(m.data) > 66 ? `right:calc(${(100 - L(m.data)).toFixed(3)}% + 7px)` : `left:calc(${L(m.data)}% + 7px)`}">${e(m.titulo)} (${mntDM(m.data)})</i>`).join('')
  const med = dados.medicoes.map(m => m.etapas.slice(1).map(x => barra(x.inicio, x.fim, x.status, '')).join('') + barra(m.etapas[0].inicio, m.etapas[0].fim, m.etapas[0].status, 'Medição ' + m.competencia.slice(5) + '/' + m.competencia.slice(2, 4))).join('')
  const c = dados.contrato
  const agora = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
  const html = `<!doctype html><html lang="pt-BR"><head><meta charset="utf-8"><title>Cronograma de manutenção — ${e(c.numero || c.nome)}</title><style>
    @page{size:A4 landscape;margin:9mm}*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}
    body{font-family:'Segoe UI',Arial,sans-serif;color:#0F1820;margin:0;font-size:8.5pt}
    header{border-bottom:2px solid #1A2535;padding-bottom:6px;margin-bottom:6px;display:flex;justify-content:space-between;gap:12px}
    h1{font-size:12pt;margin:0 0 2px}header div{line-height:1.45}header .r{text-align:right;color:#566475}
    table{width:100%;border-collapse:collapse;table-layout:fixed}thead{display:table-header-group}tr{page-break-inside:avoid}
    td{border-bottom:1px solid #DDE3EA;padding:0;vertical-align:middle;font-size:8pt}td.lb{width:62mm;padding:2px 4px;font-weight:600;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}
    td.lb small{display:block;font-weight:400;color:#566475;font-size:7pt;overflow:hidden;text-overflow:ellipsis}
    tr.g1 td{background:#E8ECF0;font-weight:800;padding:3px 4px}tr.g2 td{background:#F6F8FA;font-weight:700;color:#566475;padding:2px 4px 2px 10px;font-size:7.5pt;text-transform:uppercase}
    .tr{position:relative;height:16px;overflow:hidden}.b{position:absolute;top:3px;height:9px;border:1px solid;border-radius:2px;font-style:normal;font-size:6pt;line-height:7px;padding-left:1px;overflow:hidden;white-space:nowrap}
    .bl{position:absolute;bottom:1px;height:2px;background:#8A9BB0;font-style:normal}.h{position:absolute;top:0;bottom:0;width:1.5px;background:#A07C4E}
    .m{position:absolute;top:0;height:14px;border-left:1px solid #C4CDD8;font-style:normal;font-weight:700;padding-left:2px;font-size:7pt}
    .mk{position:absolute;top:4px;width:7px;height:7px;background:#1A2535;transform:rotate(45deg);margin-left:-3px}.mt{position:absolute;top:2px;font-style:normal;font-size:6.5pt;white-space:nowrap;color:#566475}
    .atr{color:#7A2E2E;font-size:7pt}footer{margin-top:6px;font-size:7pt;color:#566475;display:flex;gap:10px;flex-wrap:wrap}
    footer i{display:inline-block;width:14px;height:7px;border:1px solid;vertical-align:middle;margin-right:3px}
  </style></head><body>
  <header><div><h1>Cronograma de manutenção</h1>
    <div><b>${e(empresaInfo.razaoSocial)}</b></div>
    <div>Contrato nº ${e(c.numero || '—')}${c.orgao ? ' · ' + e(c.orgao) : ''} · ${e(c.nome)}</div></div>
    <div class="r"><div><b>Período:</b> ${fmt(de)} a ${fmt(ate)}</div><div><b>Emissão:</b> ${e(agora)}</div>${filtrosTxt ? `<div>${e(filtrosTxt)}</div>` : ''}</div></header>
  <table><thead><tr><td class="lb">Atividade</td><td><div class="tr">${meses.join('')}</div></td></tr>
    ${dados.marcos.length ? `<tr><td class="lb">Marcos do contrato</td><td><div class="tr">${marcos}</div></td></tr>` : ''}
    ${dados.medicoes.length ? `<tr><td class="lb">Medição</td><td><div class="tr">${med}</div></td></tr>` : ''}</thead>
  <tbody>${corpo || '<tr><td colspan="2" style="padding:12px">Nenhuma atividade no período.</td></tr>'}</tbody></table>
  <footer>${Object.entries(MNT_STATUS).map(([k, v]) => `<span><i style="background:${COR[k][0]};border-color:${COR[k][1]}"></i>${v.rotulo}</span>`).join('')}
    <span><i style="background:#8A9BB0;height:2px;border:none"></i>Linha de base</span><span>Linha cobre = hoje · ! = atrasada · ✓ = concluída</span></footer>
  </body></html>`
  const fr = document.createElement('iframe')
  fr.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0'
  document.body.appendChild(fr)
  fr.contentDocument.open(); fr.contentDocument.write(html); fr.contentDocument.close()
  setTimeout(() => { try { fr.contentWindow.focus(); fr.contentWindow.print() } finally { setTimeout(() => fr.remove(), 60000) } }, 250)
}

// CSV das atividades filtradas (ponto e vírgula + BOM: abre direto no Excel).
function mntCsv(itens, equipes, de, ate) {
  const q = v => `"${String(v == null ? '' : v).replace(/"/g, '""').replace(/\r?\n/g, ' ')}"`
  const col = ['Tipo', 'Atividade', 'Unidade', 'Tipo de unidade', 'Sistema', 'Equipe', 'Periodicidade', 'Base início', 'Base fim', 'Previsto início', 'Previsto fim',
    'Realizado início', 'Realizado fim', 'Status', '% concluído', 'Cautela', 'OS nº', 'Prioridade', 'Abertura da OS', 'Prazo SLA', 'Conclusão da OS']
  const linhas = itens.slice().sort((a, b) => (a.prev_inicio < b.prev_inicio ? -1 : 1)).map(i => [
    MNT_TIPO[i.tipo], i.titulo, i.obra_nome, i.obra_tipo, i.sistema_nome, (equipes.get(i.responsavel_id) || {}).nome, i.plano_id ? mntFreq(i.freq_unidade, i.freq_intervalo) : '',
    fmt(i.base_inicio), fmt(i.base_fim), fmt(i.prev_inicio), fmt(i.prev_fim), i.real_inicio ? fmt(i.real_inicio) : '', i.real_fim ? fmt(i.real_fim) : '',
    MNT_STATUS[i.status_efetivo].rotulo, i.pct || 0, i.cautela ? MNT_CAUTELA[i.cautela.estado].rotulo : '',
    i.os ? i.os.numero : '', i.os ? i.os.prioridade : '', mntDH(i.os && i.os.abertura), mntDH(i.os && i.os.prazo), mntDH(i.os && i.os.conclusao),
  ].map(q).join(';'))
  const blob = new Blob(['﻿' + [col.map(q).join(';'), ...linhas].join('\r\n')], { type: 'text/csv;charset=utf-8' })
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `cronograma-manutencao-${de}_${ate}.csv`; a.click()
  setTimeout(() => URL.revokeObjectURL(a.href), 2000)
}

// Painel lateral de uma atividade: detalhes, kit × cautela, OS, histórico e ações.
function MntPainelItem({ alvo, pode, onFechar, onMudou, navigate, addToast }) {
  const [d, setD] = useState(null)
  const [modo, setModo] = useState('')
  const [f, setF] = useState({})
  const [salvando, setSalvando] = useState(false)
  const ref = alvo.id ? { id: alvo.id } : { plano_id: alvo.plano_id, ocorrencia: alvo.ocorrencia }
  const carregar = r => GET('/manutencao/atividade?' + (r.id ? 'id=' + r.id : `plano_id=${r.plano_id}&ocorrencia=${r.ocorrencia}`)).then(setD).catch(e => { addToast(e.message, 'error'); onFechar() })
  useEffect(() => { setD(null); setModo(''); carregar(ref) }, [alvo.key])
  const it = d && d.item
  const acao = async (nome, corpo, ok) => {
    setSalvando(true)
    try {
      const r = await POST('/manutencao/atividades/' + nome, { ref: it.id ? { id: it.id } : ref, ...corpo })
      addToast(ok, 'success'); setModo('')
      await carregar({ id: r.item.id }); onMudou()
    } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }
  if (!d) return <div className="mnt-painel"><div className="pb text-muted">Carregando…</div></div>
  const st = MNT_STATUS[it.status_efetivo]
  const fechado = MNT_FECHADO.includes(it.status)
  const agir = d.pode_agir
  const cz = MNT_CAUTELA[it.cautela.estado]
  const abrirModo = (m, pad) => { setModo(m); setF(pad) }
  const motivoOk = (f.motivo || '').trim().length >= 10
  const solicitar = () => navigate('nova-solicitacao', {
    bolsa_id: it.bolsa_id, obra_id: it.obra_id, ref: it.id ? { id: it.id } : ref,
    titulo: it.titulo, unidade: it.obra_nome, data: it.prev_inicio,
    obs: `Cronograma de manutenção: ${it.titulo} — ${it.obra_nome || 'contrato'} · ${mntFaixa(it.prev_inicio, it.prev_fim)}`,
  })
  const TIPO_H = { reprogramacao: 'Reprogramada', linha_de_base: 'Nova linha de base', cancelamento: 'Cancelada', reabertura: 'Reaberta' }
  return (
    <div className="mnt-painel" role="dialog" aria-label={it.titulo}>
      <div className="ph">
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            <span className={`rtag rtag-sm ${it.tipo === 'PMOC' ? 'tg-cobre' : 'tg-neutro'}`}>{MNT_TIPO[it.tipo]}</span>
            <span className={`rtag rtag-sm ${st.tom}`}>{st.glifo ? st.glifo + ' ' : ''}{st.rotulo}</span>
          </div>
          <h3>{it.titulo}</h3>
        </div>
        <button className="modal-close" onClick={onFechar} aria-label="Fechar">×</button>
      </div>
      <div className="pb">
        <div className="mnt-sec"><div className="tt">Onde e quem</div>
          <dl className="mnt-dl">
            <dt>Unidade</dt><dd>{it.obra_nome || 'Contrato (geral)'}{it.obra_tipo ? ` · ${it.obra_tipo}` : ''}</dd>
            {it.sistema_nome && <><dt>Sistema</dt><dd>{it.sistema_nome}</dd></>}
            <dt>Equipe</dt><dd>{d.responsavel_nome || 'Sem equipe definida'}</dd>
            {d.executor_nome && <><dt>Executor</dt><dd>{d.executor_nome}</dd></>}
            {it.plano_id && <><dt>Periodicidade</dt><dd>{mntFreq(it.freq_unidade, it.freq_intervalo)}</dd></>}
            {it.referencia && <><dt>Referência</dt><dd>{it.referencia}</dd></>}
          </dl>
        </div>
        <div className="mnt-sec"><div className="tt">Datas</div>
          <dl className="mnt-dl">
            {/* Na OS, abertura e prazo do SLA já aparecem no bloco da OS: aqui só se foi reprogramada. */}
            {(!it.os || it.prev_inicio !== it.base_inicio || it.prev_fim !== it.base_fim) && <>
              <dt>{it.os ? 'Prazo do SLA' : 'Linha de base'}</dt><dd>{mntFaixa(it.base_inicio, it.base_fim)}</dd>
              <dt>Previsão atual</dt><dd>{mntFaixa(it.prev_inicio, it.prev_fim)}{(it.prev_inicio !== it.base_inicio || it.prev_fim !== it.base_fim) && <span className="rtag rtag-sm tg-alerta" style={{ marginLeft: 6 }}>mudou</span>}</dd>
            </>}
            <dt>Realizado</dt><dd>{it.real_inicio ? mntFaixa(it.real_inicio, it.real_fim || null) + (it.real_fim ? '' : ' (em execução)') : '—'}</dd>
            {(!agir || fechado) && <><dt>% concluído</dt><dd>{it.pct || 0}%</dd></>}
          </dl>
        </div>
        {it.os && (
          <div className="mnt-sec"><div className="tt">Ordem de serviço</div>
            <dl className="mnt-dl">
              <dt>Nº</dt><dd>{it.os.numero}</dd>
              <dt>Prioridade</dt><dd>{it.os.prioridade}</dd>
              <dt>Abertura</dt><dd>{mntDH(it.os.abertura)}</dd>
              <dt>Prazo (SLA)</dt><dd>{mntDH(it.os.prazo)}</dd>
              <dt>Conclusão</dt><dd>{it.os.conclusao ? mntDH(it.os.conclusao) : '—'}
                {(it.os.conclusao ? it.os.conclusao > it.os.prazo : d.hoje > it.os.prazo.slice(0, 10)) && <span className="rtag rtag-sm tg-perigo" style={{ marginLeft: 6 }}>fora do SLA</span>}</dd>
              {it.os.solicitante && <><dt>Solicitante</dt><dd>{it.os.solicitante}</dd></>}
              {it.os.descricao && <><dt>Descrição</dt><dd style={{ whiteSpace: 'pre-wrap', fontWeight: 400 }}>{it.os.descricao}</dd></>}
            </dl>
          </div>
        )}
        <div className="mnt-sec"><div className="tt">Ferramentas</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 8 }}>
            <span className={`rtag dot ${cz.tom}`}>{cz.rotulo}</span>
            {d.bolsa && <span style={{ fontSize: '.8rem', color: 'var(--text-secondary)' }}>Kit: <b style={{ color: 'var(--text)' }}>{d.bolsa.nome}</b></span>}
          </div>
          {d.kit.length > 0 && (
            <table className="mnt-kit"><thead><tr><th>Ferramenta</th><th style={{ textAlign: 'right' }}>Precisa</th><th style={{ textAlign: 'right' }}>Em cautela</th><th style={{ textAlign: 'right' }}>Pedido</th></tr></thead>
              <tbody>{d.kit.map(k => (
                <tr key={k.ferramenta_id}><td>{k.nome}</td><td style={{ textAlign: 'right' }}>{k.quantidade}</td>
                  <td style={{ textAlign: 'right', color: k.em_cautela >= k.quantidade ? 'var(--success)' : 'var(--text)' }}>{k.em_cautela}</td>
                  <td style={{ textAlign: 'right' }}>{k.pedido || '—'}</td></tr>))}</tbody></table>
          )}
          {!it.bolsa_id && <div className="text-muted" style={{ fontSize: '.8rem' }}>{it.plano_id ? 'O plano desta rotina' : 'Esta atividade'} não define kit de ferramentas.</div>}
          {!pode.solicitar && !fechado && it.cautela.estado === 'sem' && <div className="text-muted" style={{ fontSize: '.8rem', marginTop: 6 }}>Quem pede a cautela é o engenheiro da equipe — pelo Cronograma ou em Nova Solicitação.</div>}
          {d.cautela_vinculada && <div style={{ fontSize: '.8rem', marginTop: 6 }}>Cautela vinculada: <b>{d.cautela_vinculada.numero}</b> ({STATUS_LABEL[d.cautela_vinculada.status] || d.cautela_vinculada.status})</div>}
          {d.solicitacao_vinculada && <div style={{ fontSize: '.8rem', marginTop: 4 }}>Solicitação: <b>{d.solicitacao_vinculada.numero}</b> ({STATUS_LABEL[d.solicitacao_vinculada.status] || d.solicitacao_vinculada.status})</div>}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 10 }}>
            {pode.solicitar && agir && !fechado && it.bolsa_id && it.cautela.estado === 'sem' && <button className="btn btn-accent btn-sm" onClick={solicitar}><Icon name="plus" size={13} /> Solicitar cautela para esta atividade</button>}
            {agir && !fechado && d.cautelas.length > 0 && (
              <select value={it.cautela_id || ''} style={{ width: 'auto', padding: '6px 9px', fontSize: '.8rem' }} aria-label="Vincular cautela"
                onChange={e => acao('atualizar', { cautela_id: e.target.value ? Number(e.target.value) : null }, e.target.value ? 'Cautela vinculada.' : 'Vínculo removido.')}>
                <option value="">Vincular a uma cautela da equipe…</option>
                {d.cautelas.map(c => <option key={c.id} value={c.id}>{c.numero} · {c.status === 'ativa' ? 'ativa' : 'a retirar'} desde {mntDM(c.desde)}</option>)}
              </select>
            )}
          </div>
        </div>

        {agir && (
          <div className="mnt-sec"><div className="tt">Ações</div>
            {!modo && (
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {!fechado && !it.real_inicio && <button className="btn btn-outline btn-sm" onClick={() => acao('iniciar', {}, 'Execução iniciada.')} disabled={salvando}>Iniciar</button>}
                {!fechado && <button className="btn btn-success btn-sm" onClick={() => abrirModo('concluir', { data: d.hoje, hora: '' })}><Icon name="check" size={13} /> Concluir</button>}
                {!fechado && pode.reprogramar && <button className="btn btn-outline btn-sm" onClick={() => abrirModo('reprogramar', { inicio: it.prev_inicio, fim: it.prev_fim, motivo: '' })}>Reprogramar</button>}
                {pode.linha_de_base && !it.os && <button className="btn btn-ghost btn-sm" onClick={() => abrirModo('linha_de_base', { inicio: it.prev_inicio, fim: it.prev_fim, motivo: '' })}>Redefinir linha de base</button>}
                {!fechado && pode.cancelar && <button className="btn btn-ghost btn-sm" onClick={() => abrirModo('cancelar', { motivo: '' })}>Cancelar</button>}
                {fechado && <button className="btn btn-ghost btn-sm" onClick={() => abrirModo('reabrir', { motivo: '' })}>Reabrir</button>}
              </div>
            )}
            {modo === 'concluir' && (
              <div className="mnt-form">
                <div><label>Concluída em</label><input type="date" value={f.data} max={d.hoje} onChange={e => setF({ ...f, data: e.target.value })} /></div>
                {it.os && <div><label>Hora</label><input type="time" value={f.hora} onChange={e => setF({ ...f, hora: e.target.value })} /></div>}
                <div className="full"><label>Observação (opcional)</label><input value={f.obs || ''} maxLength={500} onChange={e => setF({ ...f, obs: e.target.value })} /></div>
                <div className="full" style={{ display: 'flex', gap: 8 }}>
                  <button className="btn btn-success btn-sm" disabled={salvando || !f.data} onClick={() => acao('concluir', { data: f.data, obs: f.obs, ...(it.os && f.hora ? { conclusao: `${f.data} ${f.hora}` } : {}) }, 'Atividade concluída.')}>Confirmar conclusão</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => setModo('')}>Voltar</button>
                </div>
              </div>
            )}
            {(modo === 'reprogramar' || modo === 'linha_de_base') && (
              <div className="mnt-form">
                <div><label>{modo === 'reprogramar' ? 'Novo início' : 'Início da base'}{f.inicio ? ` (${MNT_DIAS[mntDow(f.inicio)]})` : ''}</label><input type="date" value={f.inicio} onChange={e => setF({ ...f, inicio: e.target.value, fim: f.fim < e.target.value ? e.target.value : f.fim })} /></div>
                <div><label>{modo === 'reprogramar' ? 'Novo fim' : 'Fim da base'}{f.fim ? ` (${MNT_DIAS[mntDow(f.fim)]})` : ''}</label><input type="date" value={f.fim} min={f.inicio} onChange={e => setF({ ...f, fim: e.target.value })} /></div>
                <div className="full"><label>Motivo (obrigatório, mín. 10 caracteres)</label><textarea rows={2} value={f.motivo} maxLength={500} onChange={e => setF({ ...f, motivo: e.target.value })} placeholder={modo === 'reprogramar' ? 'Ex.: unidade fechada para dedetização' : 'Ex.: aditivo alterou o calendário do plano'} /></div>
                <div className="full" style={{ display: 'flex', gap: 8 }}>
                  <button className="btn btn-primary btn-sm" disabled={salvando || !motivoOk || !f.inicio} onClick={() => acao(modo, { inicio: f.inicio, fim: f.fim, motivo: f.motivo }, modo === 'reprogramar' ? 'Reprogramada. O motivo foi para o histórico.' : 'Linha de base redefinida.')}>{modo === 'reprogramar' ? 'Reprogramar' : 'Redefinir linha de base'}</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => setModo('')}>Voltar</button>
                </div>
              </div>
            )}
            {(modo === 'cancelar' || modo === 'reabrir') && (
              <div className="mnt-form">
                <div className="full"><label>Motivo (obrigatório, mín. 10 caracteres)</label><textarea rows={2} value={f.motivo} maxLength={500} onChange={e => setF({ ...f, motivo: e.target.value })} /></div>
                <div className="full" style={{ display: 'flex', gap: 8 }}>
                  <button className={`btn btn-sm ${modo === 'cancelar' ? 'btn-danger' : 'btn-primary'}`} disabled={salvando || !motivoOk} onClick={() => acao(modo, { motivo: f.motivo }, modo === 'cancelar' ? 'Atividade cancelada.' : 'Atividade reaberta.')}>{modo === 'cancelar' ? 'Cancelar atividade' : 'Reabrir'}</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => setModo('')}>Voltar</button>
                </div>
              </div>
            )}
            {!modo && !fechado && (
              <div className="mnt-form" style={{ marginTop: 12 }}>
                <div><label>% concluído</label>
                  <select value={Math.round((it.pct || 0) / 25) * 25} onChange={e => acao('atualizar', { pct: Number(e.target.value) }, 'Andamento atualizado.')}>
                    {[0, 25, 50, 75].map(p => <option key={p} value={p}>{p}%</option>)}
                  </select></div>
                <div><label>Executor</label>
                  <select value={it.executor_id || ''} onChange={e => acao('atualizar', { executor_id: e.target.value ? Number(e.target.value) : null }, 'Executor definido.')}>
                    <option value="">Equipe toda</option>
                    {d.executores.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}
                  </select></div>
                <label className="full" style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: '.8rem', fontWeight: 600, color: 'var(--text)' }}>
                  <input type="checkbox" style={{ width: 'auto' }} checked={!!it.colaborador_conclui} onChange={e => acao('atualizar', { colaborador_conclui: e.target.checked }, e.target.checked ? 'O colaborador pode concluir pelo celular.' : 'Só o engenheiro conclui.')} />
                  O colaborador pode marcar como concluída pelo celular
                </label>
              </div>
            )}
          </div>
        )}
        {it.obs && <div className="mnt-sec"><div className="tt">Observação</div><div style={{ fontSize: '.84rem', whiteSpace: 'pre-wrap' }}>{it.obs}</div></div>}
        <div className="mnt-sec"><div className="tt">Histórico</div>
          {!d.historico.length ? <div className="text-muted" style={{ fontSize: '.8rem' }}>Sem reprogramações.</div> : (
            <div className="mnt-hist">{d.historico.map(h => (
              <div key={h.id}><b>{TIPO_H[h.tipo] || h.tipo}</b>{h.de_inicio && h.para_inicio ? `: ${mntFaixa(h.de_inicio, h.de_fim)} → ${mntFaixa(h.para_inicio, h.para_fim)}` : ''}
                <small>{h.motivo}</small><small>{h.usuario_nome || '—'} · {mntDH(h.em)}</small></div>))}</div>
          )}
        </div>
      </div>
    </div>
  )
}

// Painel da medição do mês: etapas previstas × realizadas; o gestor lança datas, valor e glosa (IMR).
function MntPainelMedicao({ med, cid, pode, onFechar, onMudou, addToast }) {
  const [f, setF] = useState(() => ({ ...Object.fromEntries(med.etapas.slice(1).map(e => [e.etapa + '_real', e.real || ''])), valor: med.valor ?? '', glosa_valor: med.glosa_valor ?? '', glosa_motivo: med.glosa_motivo || '', obs: med.obs || '' }))
  const [salvando, setSalvando] = useState(false)
  const [abrirDoc, docEl] = useRdoDocumento(addToast)
  // RDOs da competência (Fase 4 do RDO): o relatório do período do mês civil, até hoje no mês corrente.
  const hojeMed = mntHoje()
  const compDe = `${med.competencia}-01`
  const compUlt = new Date(Date.UTC(Number(med.competencia.slice(0, 4)), Number(med.competencia.slice(5, 7)), 0)).toISOString().slice(0, 10)
  const compAte = compUlt > hojeMed ? hojeMed : compUlt
  // Fase 5: as contagens da competência (as mesmas dos Indicadores e do relatório). Só o gestor recebe; os demais, nada.
  const [rdoComp, setRdoComp] = useState(null)
  useEffect(() => {
    setRdoComp(null)
    if (!pode.rdo || compDe > hojeMed) return
    GET(`/rdo/indicadores?contrato_id=${cid}&de=${compDe}&ate=${compAte}`).then(setRdoComp).catch(() => setRdoComp(null))
  }, [cid, med.competencia])
  const salvar = async () => {
    setSalvando(true)
    try { await PUT(`/manutencao/${cid}/medicoes/${med.competencia}`, f); addToast('Medição atualizada.', 'success'); onMudou(); onFechar() } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }
  const comp = `${med.competencia.slice(5)}/${med.competencia.slice(0, 4)}`
  return (
    <div className="mnt-painel" role="dialog" aria-label={'Medição ' + comp}>
      <div className="ph"><div style={{ flex: 1 }}><span className="rtag rtag-sm tg-neutro">Medição mensal</span><h3>Competência {comp}</h3></div><button className="modal-close" onClick={onFechar} aria-label="Fechar">×</button></div>
      <div className="pb">
        <div className="mnt-sec"><div className="tt">Etapas</div>
          <table className="mnt-kit"><thead><tr><th>Etapa</th><th>Previsto até</th><th>Realizado</th><th>Situação</th></tr></thead>
            <tbody>{med.etapas.map(e => (
              <tr key={e.etapa}><td>{e.titulo}</td><td>{fmt(e.fim)}</td>
                <td>{e.etapa === 'periodo' || !pode.medicao ? (e.real ? fmt(e.real) : '—') : <input type="date" value={f[e.etapa + '_real']} max={mntHoje()} onChange={ev => setF({ ...f, [e.etapa + '_real']: ev.target.value })} style={{ padding: '4px 6px', fontSize: '.78rem' }} />}</td>
                <td><span className={`rtag rtag-sm ${MNT_STATUS[e.status].tom}`}>{MNT_STATUS[e.status].rotulo}{e.atraso ? ' c/ atraso' : ''}</span></td></tr>))}</tbody></table>
          <div className="text-muted" style={{ fontSize: '.74rem', marginTop: 6 }}>Cada etapa parte da data real da anterior; os prazos vêm da configuração do contrato.</div>
        </div>
        {pode.ver_valores && (
          <div className="mnt-sec"><div className="tt">Valores</div>
            <div className="mnt-form">
              <div><label>Valor medido (R$)</label><input inputMode="decimal" value={f.valor} disabled={!pode.medicao} onChange={e => setF({ ...f, valor: e.target.value })} /></div>
              <div><label>Glosa (R$)</label><input inputMode="decimal" value={f.glosa_valor} disabled={!pode.medicao} onChange={e => setF({ ...f, glosa_valor: e.target.value })} /></div>
              <div className="full"><label>Motivo da glosa (IMR)</label><input value={f.glosa_motivo} maxLength={500} disabled={!pode.medicao} onChange={e => setF({ ...f, glosa_motivo: e.target.value })} placeholder="Ex.: OS fora do SLA" /></div>
              <div className="full"><label>Observação</label><input value={f.obs} maxLength={500} disabled={!pode.medicao} onChange={e => setF({ ...f, obs: e.target.value })} /></div>
            </div>
          </div>
        )}
        {pode.rdo && <div className="mnt-sec"><div className="tt">Diário de obra</div>
          {rdoComp && <div className="rdo-legenda" style={{ marginBottom: 8 }}>
            <span>Dias úteis: <strong>{rdoComp.pontualidade.dias_uteis}</strong></span>
            <span>RDOs do contrato fechados: <strong>{rdoComp.dias.fechados}</strong></span>
            <span>No prazo: <strong>{rdoComp.pontualidade.no_prazo} de {rdoComp.pontualidade.esperados}</strong></span>
            <span>Em atraso: <strong>{rdoComp.pontualidade.pendentes}</strong></span>
            <span>Impraticáveis: <strong>{rdoComp.dias.impraticaveis}</strong></span>
            <span>Horas paralisadas: <strong>{rdoNum(rdoComp.dias.horas_paralisadas)}</strong></span>
          </div>}
          {rdoComp && rdoComp.integridade.com_aviso.length > 0 && <div className="rdo-falta" style={{ marginBottom: 8 }}>{rdoComp.integridade.com_aviso.length} RDO(s) com aviso de integridade ficaram fora destas contagens (o PDF mostra todos, com o aviso): {rdoComp.integridade.com_aviso.map(x => x.numero).join(', ')}.</div>}
          <button className="btn btn-outline btn-sm" disabled={compDe > hojeMed} onClick={() => abrirDoc(`/rdo/periodo?contrato_id=${cid}&de=${compDe}&ate=${compAte}&fotos=miniaturas`, `RDOs da competência ${comp}`)}><Icon name="fileText" size={14} /> RDOs da competência (PDF)</button>
          {compAte < compUlt && compDe <= hojeMed && <div className="text-muted" style={{ fontSize: '.74rem', marginTop: 6 }}>Competência em andamento: o documento vai até hoje.</div>}
        </div>}
        {pode.medicao && <button className="btn btn-primary" disabled={salvando} onClick={salvar}>{salvando ? 'Salvando…' : 'Salvar medição'}</button>}
      </div>
      {docEl}
    </div>
  )
}

function MntPainelSimples({ titulo, etiqueta, linhas, rodape, onFechar }) {
  return (
    <div className="mnt-painel" role="dialog" aria-label={titulo}>
      <div className="ph"><div style={{ flex: 1 }}><span className="rtag rtag-sm tg-neutro">{etiqueta}</span><h3>{titulo}</h3></div><button className="modal-close" onClick={onFechar} aria-label="Fechar">×</button></div>
      <div className="pb"><dl className="mnt-dl">{linhas.filter(Boolean).map(([k, v]) => <React.Fragment key={k}><dt>{k}</dt><dd>{v}</dd></React.Fragment>)}</dl>{rodape}</div>
    </div>
  )
}

// Nova OS corretiva (a fiscalização abriu) — o prazo sai do SLA da prioridade.
function MntNovaOS({ dados, cid, user, onFechar, onCriado, addToast }) {
  const agora = (dados.agora || '').replace(' ', 'T')
  const minhas = dados.unidades.filter(u => user.is_master || ['diretor', 'gerente'].includes(user.role) || u.lider_id === user.id)
  const [f, setF] = useState({ numero: '', obra_id: '', sistema_id: '', prioridade: '', abertura: agora, descricao: '', solicitante: '' })
  const slas = dados.sla || []
  const [salvando, setSalvando] = useState(false)
  const salvar = async () => {
    setSalvando(true)
    try { const r = await POST(`/manutencao/${cid}/os`, { ...f, obra_id: Number(f.obra_id) || null, sistema_id: Number(f.sistema_id) || null }); addToast(`OS ${f.numero} registrada — prazo ${mntDH(r.item.os.prazo)}.`, 'success'); onCriado(r.item) } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }
  return (
    <div className="modal-overlay open"><div className="modal modal-md">
      <div className="modal-header"><h3>Registrar OS corretiva</h3><button className="modal-close" onClick={onFechar}>×</button></div>
      <div className="modal-body">
        {!slas.length && <div className="alert alert-warning">Este contrato ainda não tem SLA por prioridade. Cadastre em Configuração antes de registrar OS.</div>}
        <div className="form-grid">
          <div className="form-group"><label>Nº da OS *</label><input value={f.numero} maxLength={40} onChange={e => setF({ ...f, numero: e.target.value })} placeholder="Número da fiscalização" /></div>
          <div className="form-group"><label>Abertura *</label><input type="datetime-local" value={f.abertura} max={agora} onChange={e => setF({ ...f, abertura: e.target.value })} /></div>
          <div className="form-group"><label>Unidade *</label><select value={f.obra_id} onChange={e => setF({ ...f, obra_id: e.target.value })}><option value="">Selecione…</option>{minhas.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}</select></div>
          <div className="form-group"><label>Prioridade *</label><select value={f.prioridade} onChange={e => setF({ ...f, prioridade: e.target.value })}><option value="">Selecione…</option>{slas.map(s => <option key={s.id} value={s.prioridade}>{s.prioridade} — {s.prazo} {s.unidade === 'horas' ? 'h' : s.unidade === 'dias_uteis' ? 'dia(s) útil(eis)' : 'dia(s) corrido(s)'}</option>)}</select></div>
          <div className="form-group"><label>Sistema</label><select value={f.sistema_id} onChange={e => setF({ ...f, sistema_id: e.target.value })}><option value="">—</option>{dados.sistemas.filter(s => s.ativo).map(s => <option key={s.id} value={s.id}>{s.nome}</option>)}</select></div>
          <div className="form-group"><label>Quem abriu</label><input value={f.solicitante} maxLength={120} onChange={e => setF({ ...f, solicitante: e.target.value })} placeholder="Fiscal / setor" /></div>
          <div className="form-group full"><label>Descrição</label><textarea rows={3} value={f.descricao} maxLength={1000} onChange={e => setF({ ...f, descricao: e.target.value })} /></div>
        </div>
      </div>
      <div className="modal-footer"><button className="btn btn-ghost" onClick={onFechar}>Cancelar</button><button className="btn btn-primary" disabled={salvando || !f.numero || !f.obra_id || !f.prioridade || !f.abertura} onClick={salvar}>{salvando ? 'Salvando…' : 'Registrar OS'}</button></div>
    </div></div>
  )
}

// Atividade avulsa (administrativa) ou marco lançado à mão — gestor.
function MntNovaAtividade({ dados, cid, onFechar, onCriado, addToast }) {
  const [f, setF] = useState({ tipo: 'ADMINISTRATIVA', titulo: '', obra_id: '', inicio: dados.hoje, fim: dados.hoje, responsavel_id: '' })
  const [salvando, setSalvando] = useState(false)
  const marco = f.tipo === 'MARCO_CONTRATUAL'
  const salvar = async () => {
    setSalvando(true)
    try { await POST(`/manutencao/${cid}/atividades`, { ...f, fim: marco ? f.inicio : f.fim, obra_id: Number(f.obra_id) || null, responsavel_id: Number(f.responsavel_id) || null }); addToast(marco ? 'Marco lançado.' : 'Atividade lançada.', 'success'); onCriado() } catch (e) { addToast(e.message, 'error') }
    setSalvando(false)
  }
  return (
    <div className="modal-overlay open"><div className="modal modal-md">
      <div className="modal-header"><h3>Nova atividade</h3><button className="modal-close" onClick={onFechar}>×</button></div>
      <div className="modal-body">
        <div className="form-grid">
          <div className="form-group"><label>Tipo</label><select value={f.tipo} onChange={e => setF({ ...f, tipo: e.target.value })}><option value="ADMINISTRATIVA">Administrativa (relatório, reunião, ART, laudo)</option><option value="MARCO_CONTRATUAL">Marco do contrato</option></select></div>
          <div className="form-group"><label>Título *</label><input value={f.titulo} maxLength={160} onChange={e => setF({ ...f, titulo: e.target.value })} placeholder={marco ? 'Ex.: Entrega do laudo de SPDA' : 'Ex.: Reunião com a fiscalização'} /></div>
          <div className="form-group"><label>{marco ? 'Data *' : 'Início *'}</label><input type="date" value={f.inicio} onChange={e => setF({ ...f, inicio: e.target.value, fim: f.fim < e.target.value ? e.target.value : f.fim })} /></div>
          {!marco && <div className="form-group"><label>Fim *</label><input type="date" value={f.fim} min={f.inicio} onChange={e => setF({ ...f, fim: e.target.value })} /></div>}
          {!marco && <div className="form-group"><label>Unidade</label><select value={f.obra_id} onChange={e => setF({ ...f, obra_id: e.target.value })}><option value="">Contrato (geral)</option>{dados.unidades.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}</select></div>}
          {!marco && <div className="form-group"><label>Equipe</label><select value={f.responsavel_id} onChange={e => setF({ ...f, responsavel_id: e.target.value })}><option value="">Engenheiro da unidade</option>{dados.equipes.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}</select></div>}
        </div>
      </div>
      <div className="modal-footer"><button className="btn btn-ghost" onClick={onFechar}>Cancelar</button><button className="btn btn-primary" disabled={salvando || f.titulo.trim().length < 3 || !f.inicio} onClick={salvar}>{salvando ? 'Salvando…' : 'Lançar'}</button></div>
    </div></div>
  )
}

// Configuração do contrato de manutenção: dados do TR, SLA, sistemas, unidades, feriados e plano preventivo.
function MntConfig({ cid, user, addToast, onMudou }) {
  const [c, setC] = useState(null)
  const [f, setF] = useState(null)
  const [sla, setSla] = useState([])
  const [novoSis, setNovoSis] = useState({ nome: '', pmoc: false })
  const [fer, setFer] = useState({ data: '', nome: '' })
  const [plano, setPlano] = useState(null)
  const [fp, setFp] = useState({ obra: '', q: '' })   // filtro da lista de rotinas
  const [salvando, setSalvando] = useState(false)
  const aplicar = d => {
    setC(d)
    const k = d.contrato || {}
    setF({ numero: k.numero || '', objeto: k.objeto || '', orgao: k.orgao || '', processo: k.processo || '', data_assinatura: k.data_assinatura || '', data_os_inicio: k.data_os_inicio || '',
      vigencia_meses: k.vigencia_meses || '', prorrogacoes: k.prorrogacoes || [], data_base_reajuste: k.data_base_reajuste || '', indice_reajuste: k.indice_reajuste || '',
      garantia_vencimento: k.garantia_vencimento || '', gestor_orgao: k.gestor_orgao || '', fiscais: k.fiscais || [], antecedencia_prorrogacao_dias: k.antecedencia_prorrogacao_dias ?? 120,
      med_envio_dias: k.med_envio_dias ?? 5, med_ateste_dias: k.med_ateste_dias ?? 5, med_nf_dias: k.med_nf_dias ?? 2, med_pagamento_dias: k.med_pagamento_dias ?? 30,
      sabado_util: !!k.sabado_util, facultativos_nao_uteis: k.facultativos_nao_uteis !== 0 })
    setSla(d.sla.length ? d.sla.map(s => ({ ...s })) : [{ prioridade: '', prazo: '', unidade: 'horas' }, { prioridade: '', prazo: '', unidade: 'dias_uteis' }])
  }
  const carregar = () => GET(`/manutencao/${cid}/config`).then(aplicar).catch(e => addToast(e.message, 'error'))
  useEffect(() => { setC(null); carregar() }, [cid])
  const chamar = async (fn, ok) => {
    setSalvando(true)
    try { const d = await fn(); if (d && d.contrato_base) aplicar(d); if (ok) addToast(ok, 'success'); onMudou && onMudou(); return d } catch (e) { addToast(e.message, 'error') } finally { setSalvando(false) }
  }
  if (!c || !f) return <div className="text-muted">Carregando…</div>
  const set = (k, v) => setF(x => ({ ...x, [k]: v }))
  const campo = (k, rot, tipo = 'text', extra = {}) => <div className="form-group"><label>{rot}</label><input type={tipo} value={f[k]} onChange={e => set(k, e.target.value)} {...extra} /></div>
  const planoVazio = () => ({ obra_ids: [], sistema_id: '', tipo: 'PREVENTIVA', atividade: '', referencia: '', freq_unidade: 'mes', freq_intervalo: 1, data_inicio: c.hoje, duracao_dias: 1, responsavel_id: '', bolsa_id: '', colaborador_conclui: false, incluir_passadas: false })
  const salvarPlano = () => chamar(() => plano.id
    ? PUT(`/manutencao/planos/${plano.id}`, { ...plano, sistema_id: Number(plano.sistema_id) || null, responsavel_id: Number(plano.responsavel_id) || null, bolsa_id: Number(plano.bolsa_id) || null })
    : POST(`/manutencao/${cid}/planos`, { ...plano, sistema_id: Number(plano.sistema_id) || null, responsavel_id: Number(plano.responsavel_id) || null, bolsa_id: Number(plano.bolsa_id) || null }))
    .then(d => { if (d) { addToast(d.versionado ? 'Periodicidade nova vale a partir de hoje — o histórico ficou no plano anterior.' : d.criados ? `Rotina cadastrada em ${d.criados} unidade(s).` : 'Rotina atualizada.', 'success'); setPlano(null) } })
  const ativas = c.planos.filter(p => !p.data_fim || p.data_fim >= c.hoje)
  const listadas = ativas.filter(p => (!fp.obra || String(p.obra_id) === fp.obra) && casaBusca(fp.q, p.atividade, p.sistema_nome, p.referencia, p.obra_nome))
  const encerradas = c.planos.length - ativas.length
  const v = c.vigencia
  return (
    <div>
      <div className="mnt-cfg-grid">
        <div className="card"><div className="card-header"><span className="card-title">Contrato</span>{c.contrato && <span className="rtag rtag-sm tg-ok">Configurado</span>}</div>
          <div className="card-body">
            <div className="form-grid">
              {campo('numero', 'Nº do contrato')}{campo('processo', 'Processo')}
              <div className="form-group full"><label>Órgão contratante</label><input value={f.orgao} onChange={e => set('orgao', e.target.value)} /></div>
              <div className="form-group full"><label>Objeto</label><textarea rows={2} value={f.objeto} onChange={e => set('objeto', e.target.value)} /></div>
              {campo('data_assinatura', 'Assinatura', 'date')}{campo('data_os_inicio', 'OS de início', 'date')}
              {campo('vigencia_meses', 'Vigência inicial (meses, até 60)', 'number', { min: 1, max: 60 })}
              {campo('data_base_reajuste', 'Data-base do reajuste', 'date')}{campo('indice_reajuste', 'Índice de reajuste')}
              {campo('garantia_vencimento', 'Vencimento da garantia', 'date')}
              {campo('gestor_orgao', 'Gestor do contrato (órgão)')}
              {campo('antecedencia_prorrogacao_dias', 'Alerta de prorrogação (dias antes)', 'number', { min: 0, max: 365 })}
            </div>
            <div style={{ marginTop: 14 }}><label>Prorrogações (termos aditivos)</label>
              {f.prorrogacoes.map((p, i) => (
                <div key={i} className="mnt-linha">
                  <input placeholder="Termo (ex.: 1º TA)" value={p.termo || ''} onChange={e => set('prorrogacoes', f.prorrogacoes.map((x, j) => j === i ? { ...x, termo: e.target.value } : x))} />
                  <input type="number" min={1} max={60} placeholder="Meses" value={p.meses || ''} onChange={e => set('prorrogacoes', f.prorrogacoes.map((x, j) => j === i ? { ...x, meses: e.target.value } : x))} style={{ maxWidth: 100 }} />
                  <button className="btn btn-ghost btn-sm" onClick={() => set('prorrogacoes', f.prorrogacoes.filter((_, j) => j !== i))} aria-label="Remover"><Icon name="trash" size={13} /></button>
                </div>))}
              <button className="btn btn-ghost btn-sm" onClick={() => set('prorrogacoes', [...f.prorrogacoes, { termo: '', meses: 12 }])}><Icon name="plus" size={13} /> Prorrogação</button>
            </div>
            <div style={{ marginTop: 14 }}><label>Fiscais do órgão</label>
              {f.fiscais.map((p, i) => (
                <div key={i} className="mnt-linha">
                  <input placeholder="Nome" value={p.nome} onChange={e => set('fiscais', f.fiscais.map((x, j) => j === i ? { ...x, nome: e.target.value } : x))} />
                  <input placeholder="Cargo / função" value={p.cargo} onChange={e => set('fiscais', f.fiscais.map((x, j) => j === i ? { ...x, cargo: e.target.value } : x))} />
                  <button className="btn btn-ghost btn-sm" onClick={() => set('fiscais', f.fiscais.filter((_, j) => j !== i))} aria-label="Remover"><Icon name="trash" size={13} /></button>
                </div>))}
              <button className="btn btn-ghost btn-sm" onClick={() => set('fiscais', [...f.fiscais, { nome: '', cargo: '' }])}><Icon name="plus" size={13} /> Fiscal</button>
              {user.rdo_ativo ? <div className="text-muted" style={{ fontSize: '.74rem', marginTop: 4 }}>Para o Diário de obra, a fiscalização com portaria e período fica em Diário de obra → Configurar o diário.</div> : null}
            </div>
            <div style={{ marginTop: 14 }}><label>Prazos da medição (após o fim do mês)</label>
              <div className="form-grid" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(120px,1fr))' }}>
                {campo('med_envio_dias', 'Envio (dias úteis)', 'number', { min: 0 })}{campo('med_ateste_dias', 'Ateste (dias úteis)', 'number', { min: 0 })}
                {campo('med_nf_dias', 'NF (dias úteis)', 'number', { min: 0 })}{campo('med_pagamento_dias', 'Pagamento (dias corridos)', 'number', { min: 0 })}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 12, fontSize: '.84rem' }}>
              <label style={{ display: 'flex', gap: 6, alignItems: 'center', color: 'var(--text)' }}><input type="checkbox" style={{ width: 'auto' }} checked={f.sabado_util} onChange={e => set('sabado_util', e.target.checked)} /> Sábado é dia útil</label>
              <label style={{ display: 'flex', gap: 6, alignItems: 'center', color: 'var(--text)' }}><input type="checkbox" style={{ width: 'auto' }} checked={f.facultativos_nao_uteis} onChange={e => set('facultativos_nao_uteis', e.target.checked)} /> Carnaval e Corpus Christi sem expediente</label>
            </div>
            <button className="btn btn-primary" style={{ marginTop: 14 }} disabled={salvando} onClick={() => chamar(() => PUT(`/manutencao/${cid}/contrato`, f), 'Contrato salvo — marcos recalculados.')}>Salvar contrato</button>
          </div>
        </div>

        <div>
          <div className="card" style={{ marginBottom: 16 }}><div className="card-header"><span className="card-title">Vigência e marcos</span></div>
            <div className="card-body">
              {!v ? <div className="text-muted" style={{ fontSize: '.85rem' }}>Preencha a OS de início (ou a assinatura) e a vigência para calcular os marcos.</div> : (
                <>
                  <div style={{ fontSize: '.84rem', marginBottom: 10 }}>Vigência: <b>{fmt(v.inicio)} a {fmt(v.fimAtual)}</b> · {v.total} meses{v.prorrogado ? ` (${v.meses} + ${v.prorrogado} prorrogados)` : ''} · limite legal {fmt(v.limiteLegal)}</div>
                  <table className="mnt-kit"><tbody>{c.marcos.map(m => (
                    <tr key={m.key}><td style={{ whiteSpace: 'nowrap' }}>{fmt(m.data)}</td><td>{m.titulo}{m.legal ? <div className="text-muted" style={{ fontSize: '.7rem' }}>{m.legal}</div> : null}</td>
                      <td style={{ textAlign: 'right' }}>{m.data < c.hoje ? <span className="rtag rtag-sm tg-neutro">passou</span> : <span className={`rtag rtag-sm ${m.alerta ? 'tg-alerta' : 'tg-aco'}`}>em {Math.round((mntT(m.data) - mntT(c.hoje)) / 864e5)} d</span>}</td></tr>))}</tbody></table>
                </>
              )}
            </div>
          </div>
          <div className="card" style={{ marginBottom: 16 }}><div className="card-header"><span className="card-title">SLA por prioridade (do Termo de Referência)</span></div>
            <div className="card-body">
              {sla.map((s, i) => (
                <div key={i} className="mnt-linha">
                  <input placeholder="Prioridade (ex.: Emergencial)" value={s.prioridade} onChange={e => setSla(sla.map((x, j) => j === i ? { ...x, prioridade: e.target.value } : x))} />
                  <input type="number" min={0} step="0.5" placeholder="Prazo" value={s.prazo} onChange={e => setSla(sla.map((x, j) => j === i ? { ...x, prazo: e.target.value } : x))} style={{ maxWidth: 90 }} />
                  <select value={s.unidade} onChange={e => setSla(sla.map((x, j) => j === i ? { ...x, unidade: e.target.value } : x))} style={{ maxWidth: 150 }}>
                    <option value="horas">horas</option><option value="dias_uteis">dias úteis</option><option value="dias_corridos">dias corridos</option></select>
                  <button className="btn btn-ghost btn-sm" onClick={() => setSla(sla.filter((_, j) => j !== i))} aria-label="Remover"><Icon name="trash" size={13} /></button>
                </div>))}
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                <button className="btn btn-ghost btn-sm" onClick={() => setSla([...sla, { prioridade: '', prazo: '', unidade: 'dias_uteis' }])}><Icon name="plus" size={13} /> Prioridade</button>
                <button className="btn btn-primary btn-sm" disabled={salvando} onClick={() => chamar(() => PUT(`/manutencao/${cid}/sla`, { linhas: sla }), 'SLA salvo. OS já abertas mantêm o prazo da abertura.')}>Salvar SLA</button>
              </div>
            </div>
          </div>
          <div className="card" style={{ marginBottom: 16 }}><div className="card-header"><span className="card-title">Feriados locais</span></div>
            <div className="card-body">
              <div className="text-muted" style={{ fontSize: '.78rem', marginBottom: 8 }}>Os nacionais já contam (inclusive Sexta-feira Santa e Consciência Negra). Cadastre os do município/estado do contrato.</div>
              {c.feriados.map(x => <div key={x.id} className="mnt-linha" style={{ fontSize: '.84rem' }}><span style={{ flex: 1 }}><b>{fmt(x.data)}</b> · {x.nome}</span><button className="btn btn-ghost btn-sm" onClick={() => chamar(() => DEL(`/manutencao/feriados/${x.id}`), 'Feriado removido.')} aria-label="Remover"><Icon name="trash" size={13} /></button></div>)}
              <div className="mnt-linha"><input type="date" value={fer.data} onChange={e => setFer({ ...fer, data: e.target.value })} style={{ maxWidth: 160 }} /><input placeholder="Nome do feriado" value={fer.nome} onChange={e => setFer({ ...fer, nome: e.target.value })} />
                <button className="btn btn-outline btn-sm" disabled={!fer.data || fer.nome.trim().length < 3 || salvando} onClick={() => chamar(() => POST(`/manutencao/${cid}/feriados`, fer), 'Feriado cadastrado.').then(d => d && setFer({ data: '', nome: '' }))}>Adicionar</button></div>
            </div>
          </div>
          <div className="card"><div className="card-header"><span className="card-title">Sistemas</span></div>
            <div className="card-body">
              {c.sistemas.map(s => (
                <div key={s.id} className="mnt-linha" style={{ fontSize: '.84rem', opacity: s.ativo ? 1 : .55 }}>
                  <span style={{ flex: 1 }}>{s.nome}</span>
                  <label style={{ display: 'flex', gap: 5, alignItems: 'center', fontSize: '.76rem', color: 'var(--text-secondary)' }}><input type="checkbox" style={{ width: 'auto' }} checked={!!s.pmoc} onChange={e => chamar(() => PUT(`/manutencao/sistemas/${s.id}`, { pmoc: e.target.checked }))} /> PMOC</label>
                  <button className="btn btn-ghost btn-sm" onClick={() => chamar(() => PUT(`/manutencao/sistemas/${s.id}`, { ativo: !s.ativo }))}>{s.ativo ? 'Desativar' : 'Reativar'}</button>
                </div>))}
              <div className="mnt-linha"><input placeholder="Novo sistema" value={novoSis.nome} onChange={e => setNovoSis({ ...novoSis, nome: e.target.value })} />
                <label style={{ display: 'flex', gap: 5, alignItems: 'center', fontSize: '.76rem', color: 'var(--text-secondary)' }}><input type="checkbox" style={{ width: 'auto' }} checked={novoSis.pmoc} onChange={e => setNovoSis({ ...novoSis, pmoc: e.target.checked })} /> PMOC</label>
                <button className="btn btn-outline btn-sm" disabled={novoSis.nome.trim().length < 2 || salvando} onClick={() => chamar(() => POST(`/manutencao/${cid}/sistemas`, novoSis), 'Sistema cadastrado.').then(d => d && setNovoSis({ nome: '', pmoc: false }))}>Adicionar</button></div>
            </div>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: 16 }}><div className="card-header"><span className="card-title">Unidades do contrato</span><span className="text-muted" style={{ fontSize: '.78rem' }}>Cadastro e engenheiro responsável ficam na aba Obras</span></div>
        <div className="table-wrap"><table className="cards-mobile"><thead><tr><th>Unidade</th><th>Tipo</th><th>Engenheiro (equipe)</th></tr></thead>
          <tbody>{c.unidades.filter(u => u.ativo).map(u => (
            <tr key={u.id}><td data-label="Unidade"><b>{u.nome}</b></td>
              <td data-label="Tipo"><select value={u.tipo || ''} onChange={e => chamar(() => PUT(`/manutencao/${cid}/unidades/${u.id}`, { tipo: e.target.value }))} style={{ width: 'auto', padding: '5px 8px', fontSize: '.82rem' }}>
                <option value="">—</option>{c.tipos_unidade.concat(u.tipo && !c.tipos_unidade.includes(u.tipo) ? [u.tipo] : []).map(t => <option key={t} value={t}>{t}</option>)}</select></td>
              <td data-label="Engenheiro">{u.lider_nome || <span className="text-muted">sem engenheiro</span>}</td></tr>))}</tbody></table></div>
      </div>

      <div className="card"><div className="card-header"><span className="card-title">Plano preventivo</span>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>{encerradas > 0 && <span className="text-muted" style={{ fontSize: '.78rem' }}>{encerradas} encerrada(s) no histórico</span>}
          {!plano && <button className="btn btn-accent btn-sm" onClick={() => setPlano(planoVazio())}><Icon name="plus" size={13} /> Nova rotina</button>}</div></div>
        {plano && (
          <div className="card-body" style={{ borderBottom: '1px solid var(--border)' }}>
            <div className="form-grid">
              <div className="form-group full"><label>Atividade *</label><input value={plano.atividade} maxLength={160} onChange={e => setPlano({ ...plano, atividade: e.target.value })} placeholder="Ex.: Limpeza de filtros dos splits" /></div>
              {!plano.id && <div className="form-group full"><label>Unidades * (uma rotina por unidade marcada)</label>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', maxHeight: 160, overflowY: 'auto', padding: 4, border: '1px solid var(--border)', borderRadius: 8 }}>
                  <button type="button" className="mnt-chip" onClick={() => setPlano({ ...plano, obra_ids: plano.obra_ids.length ? [] : c.unidades.filter(u => u.ativo).map(u => u.id) })}>{plano.obra_ids.length ? 'Limpar' : 'Todas'}</button>
                  {c.unidades.filter(u => u.ativo).map(u => <button type="button" key={u.id} className={`mnt-chip${plano.obra_ids.includes(u.id) ? ' on' : ''}`} onClick={() => setPlano({ ...plano, obra_ids: plano.obra_ids.includes(u.id) ? plano.obra_ids.filter(x => x !== u.id) : [...plano.obra_ids, u.id] })}>{u.nome}</button>)}
                </div></div>}
              <div className="form-group"><label>Sistema</label><select value={plano.sistema_id || ''} onChange={e => setPlano({ ...plano, sistema_id: e.target.value })}><option value="">—</option>{c.sistemas.filter(s => s.ativo).map(s => <option key={s.id} value={s.id}>{s.nome}{s.pmoc ? ' (PMOC)' : ''}</option>)}</select></div>
              <div className="form-group"><label>Tipo</label><select value={plano.tipo} onChange={e => setPlano({ ...plano, tipo: e.target.value })}><option value="PREVENTIVA">Preventiva</option><option value="PMOC">PMOC</option><option value="ADMINISTRATIVA">Administrativa</option></select></div>
              <div className="form-group"><label>Periodicidade</label>
                <div style={{ display: 'flex', gap: 6 }}><span style={{ alignSelf: 'center', fontSize: '.84rem', whiteSpace: 'nowrap' }}>a cada</span>
                  <input type="number" min={1} value={plano.freq_intervalo} onChange={e => setPlano({ ...plano, freq_intervalo: e.target.value })} style={{ maxWidth: 70 }} />
                  <select value={plano.freq_unidade} onChange={e => setPlano({ ...plano, freq_unidade: e.target.value })}><option value="dia">dia(s)</option><option value="semana">semana(s)</option><option value="mes">mês(es)</option><option value="ano">ano(s)</option></select></div>
                <small className="text-muted">{mntFreq(plano.freq_unidade, plano.freq_intervalo)}</small></div>
              <div className="form-group"><label>1ª execução</label><input type="date" value={plano.data_inicio} onChange={e => setPlano({ ...plano, data_inicio: e.target.value })} /></div>
              <div className="form-group"><label>Duração (dias úteis)</label><input type="number" min={1} max={60} value={plano.duracao_dias} onChange={e => setPlano({ ...plano, duracao_dias: e.target.value })} /></div>
              <div className="form-group"><label>Equipe</label><select value={plano.responsavel_id || ''} onChange={e => setPlano({ ...plano, responsavel_id: e.target.value })}><option value="">Engenheiro da unidade</option>{c.equipes.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}</select></div>
              <div className="form-group"><label>Kit de ferramentas</label><select value={plano.bolsa_id || ''} onChange={e => setPlano({ ...plano, bolsa_id: e.target.value })}><option value="">Sem kit</option>{c.bolsas.map(b => <option key={b.id} value={b.id}>{b.nome}</option>)}</select></div>
              <div className="form-group"><label>Referência (TR / PMOC / norma)</label><input value={plano.referencia || ''} maxLength={160} onChange={e => setPlano({ ...plano, referencia: e.target.value })} /></div>
              <label className="form-group full" style={{ flexDirection: 'row', gap: 8, alignItems: 'center', color: 'var(--text)' }}><input type="checkbox" style={{ width: 'auto' }} checked={!!plano.colaborador_conclui} onChange={e => setPlano({ ...plano, colaborador_conclui: e.target.checked })} /> O colaborador pode marcar como concluída pelo celular</label>
              {!plano.id && plano.data_inicio < c.hoje && <label className="form-group full" style={{ flexDirection: 'row', gap: 8, alignItems: 'center', color: 'var(--text)' }}><input type="checkbox" style={{ width: 'auto' }} checked={plano.incluir_passadas} onChange={e => setPlano({ ...plano, incluir_passadas: e.target.checked })} /> Incluir as ocorrências anteriores a hoje (vão aparecer como atrasadas até serem lançadas)</label>}
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <button className="btn btn-primary" disabled={salvando || plano.atividade.trim().length < 3 || (!plano.id && !plano.obra_ids.length)} onClick={salvarPlano}>{plano.id ? 'Salvar rotina' : `Cadastrar${plano.obra_ids.length > 1 ? ` em ${plano.obra_ids.length} unidades` : ''}`}</button>
              <button className="btn btn-ghost" onClick={() => setPlano(null)}>Cancelar</button>
            </div>
          </div>
        )}
        {ativas.length > 0 && (
          <div className="mnt-bar-tools" style={{ padding: '12px 16px 0' }}>
            <select value={fp.obra} onChange={e => setFp({ ...fp, obra: e.target.value })} aria-label="Filtrar por unidade"><option value="">Todas as unidades</option>{c.unidades.filter(u => u.ativo).map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}</select>
            <input value={fp.q} onChange={e => setFp({ ...fp, q: e.target.value })} placeholder="Buscar rotina, sistema ou referência" style={{ flex: 1, minWidth: 180 }} aria-label="Buscar rotina" />
            <span className="text-muted" style={{ fontSize: '.78rem' }}>{listadas.length > 300 ? `mostrando 300 de ${listadas.length} — filtre por unidade` : `${listadas.length} de ${ativas.length} rotina(s)`}</span>
          </div>
        )}
        {!ativas.length && !plano ? <div className="card-body text-muted">Nenhuma rotina cadastrada. Cadastre cada rotina uma vez — as ocorrências aparecem sozinhas no Gantt.</div> : (
          <div className="table-wrap"><table className="cards-mobile"><thead><tr><th>Atividade</th><th>Unidade</th><th>Sistema</th><th>Periodicidade</th><th>Equipe</th><th>Kit</th><th></th></tr></thead>
            <tbody>{listadas.slice(0, 300).map(p => (
              <tr key={p.id}>
                <td data-label="Atividade"><b>{p.atividade}</b>{p.referencia && <div className="text-muted" style={{ fontSize: '.74rem' }}>{p.referencia}</div>}</td>
                <td data-label="Unidade">{p.obra_nome}</td>
                <td data-label="Sistema">{p.sistema_nome || '—'}{(p.tipo === 'PMOC' || p.sistema_pmoc) ? <span className="rtag rtag-sm tg-cobre" style={{ marginLeft: 6 }}>PMOC</span> : null}</td>
                <td data-label="Periodicidade">{mntFreq(p.freq_unidade, p.freq_intervalo)}{p.duracao_dias > 1 ? ` · ${p.duracao_dias} d` : ''}</td>
                <td data-label="Equipe">{p.responsavel_nome || '—'}{p.responsavel_da_unidade && p.responsavel_nome ? <div className="text-muted" style={{ fontSize: '.7rem' }}>engenheiro da unidade</div> : null}</td>
                <td data-label="Kit">{p.bolsa_nome || '—'}</td>
                <td data-label=""><div className="actions">
                  <button className="btn btn-ghost btn-sm" onClick={() => setPlano({ ...p, sistema_id: p.sistema_id || '', responsavel_id: p.responsavel_id || '', bolsa_id: p.bolsa_id || '', colaborador_conclui: !!p.colaborador_conclui })}><Icon name="edit" size={13} /></button>
                  <button className="btn btn-ghost btn-sm" title={p.excecoes ? 'Encerrar (o histórico fica)' : 'Excluir'} onClick={() => window.confirm(p.excecoes ? `Encerrar "${p.atividade}"? O que já foi executado fica no histórico.` : `Excluir "${p.atividade}"?`) && chamar(() => DEL(`/manutencao/planos/${p.id}`), p.excecoes ? 'Rotina encerrada.' : 'Rotina excluída.')}><Icon name="trash" size={13} /></button>
                </div></td>
              </tr>))}</tbody></table></div>
        )}
      </div>
    </div>
  )
}

// Visão Gantt da aba Cronograma.
function ManutPage({ user, navigate, addToast, seletorVisao }) {
  const gestor = !!(user.is_master || ['diretor', 'gerente'].includes(user.role))
  const equipe = ['engenheiro', 'lider'].includes(user.role)
  const [contratos, setContratos] = useState(null)
  const [sel, setSel] = useState(null)
  const [aba, setAba] = useState('gantt')
  const [escala, setEscala] = useState(() => lsLer('cf_mnt_escala', 'mes'))
  const [ancora, setAncora] = useState(mntHoje)
  const [agrupar, setAgrupar] = useState(() => lsLer('cf_mnt_agrupar', equipe ? 'equipe' : 'unidade'))
  const [mostrarCautelas, setMostrarCautelas] = useState(false)
  const FILTRO0 = { unidade: '', sistema: '', tipo: '', status: '', equipe: '', atrasadas: false, pmoc: false, semCautela: false }
  const [filtro, setFiltro] = useState(FILTRO0)
  const [fechados, setFechados] = useState(() => new Set())
  const [dados, setDados] = useState(undefined)
  const [carregando, setCarregando] = useState(false)
  const [painel, setPainel] = useState(null)
  const [modal, setModal] = useState(null)
  const [verFiltros, setVerFiltros] = useState(false)
  const [de, ate] = MNT_ESCALAS[escala].janela(ancora)

  useEffect(() => {
    GET('/cronograma/contratos').then(d => {
      const l = d.contratos || []
      setContratos(l)
      const salvo = Number(lsLer('cf_mnt_contrato', 0))
      const s = l.find(c => c.id === salvo) || l.find(c => c.tem_manutencao) || l[0]
      if (s) setSel(s.id); else setDados(null)
    }).catch(e => { addToast(e.message, 'error'); setDados(null) })
  }, [])
  const carregar = () => {
    if (!sel) return
    setCarregando(true)
    const t0 = performance.now()
    GET(`/manutencao/${sel}/gantt?de=${de}&ate=${ate}`)
      .then(d => { d.itens = d.itens.map(mntRemontar(d.planos)); setDados(d); window.__mntMedida = { de, ate, itens: d.itens.length, servidor_ms: d.ms, rede_ms: Math.round(performance.now() - t0), t0: performance.now() } })
      .catch(e => { addToast(e.message, 'error'); setDados(null) })
      .finally(() => setCarregando(false))
  }
  useEffect(carregar, [sel, de, ate])
  const equipesMap = React.useMemo(() => new Map(((dados && dados.equipes) || []).map(e => [e.id, e])), [dados])
  const itensF = React.useMemo(() => !dados ? [] : dados.itens.filter(i =>
    (!filtro.unidade || String(i.obra_id) === filtro.unidade) && (!filtro.sistema || String(i.sistema_id) === filtro.sistema) &&
    (!filtro.tipo || i.tipo === filtro.tipo) && (!filtro.status || i.status_efetivo === filtro.status) &&
    (!filtro.equipe || String(i.responsavel_id) === filtro.equipe) && (!filtro.atrasadas || i.status_efetivo === 'ATRASADA') &&
    (!filtro.pmoc || i.tipo === 'PMOC') && (!filtro.semCautela || (i.cautela && i.cautela.estado === 'sem'))), [dados, filtro])
  const filtrando = Object.keys(FILTRO0).some(k => filtro[k] !== FILTRO0[k])
  const cautelasF = React.useMemo(() => !dados ? [] : dados.cautelas.filter(c => !filtro.equipe || String(c.lider_id) === filtro.equipe), [dados, filtro.equipe])
  const linhas = React.useMemo(() => !dados ? [] : mntLinhas(itensF, cautelasF, agrupar, fechados, equipesMap, mostrarCautelas, dados.hoje), [itensF, cautelasF, agrupar, fechados, equipesMap, mostrarCautelas, dados])
  // Medição do desenho (visão de 1 ano com todas as unidades) — fica em window.__mntMedida.
  useEffect(() => { if (window.__mntMedida && dados) requestAnimationFrame(() => { window.__mntMedida.render_ms = Math.round(performance.now() - window.__mntMedida.t0); window.__mntMedida.linhas = linhas.length }) }, [linhas])

  const trocarEscala = e => { setEscala(e); lsGravar('cf_mnt_escala', e) }
  const trocarAgrupar = a => { setAgrupar(a); lsGravar('cf_mnt_agrupar', a); setFechados(new Set()) }
  const trocarContrato = id => { setSel(id); lsGravar('cf_mnt_contrato', String(id)); setPainel(null); setFiltro(FILTRO0) }
  const toggle = k => setFechados(s => { const n = new Set(s); n.has(k) ? n.delete(k) : n.add(k); return n })
  const abrirItem = i => setPainel({ tipo: 'item', key: i.key, id: i.id, plano_id: i.plano_id, ocorrencia: i.ocorrencia })
  const abrirLinha = l => {
    const hoje = dados.hoje
    const alvo = l.itens.find(i => !MNT_FECHADO.includes(i.status) && i.prev_fim >= hoje) || l.itens.find(i => i.status_efetivo === 'ATRASADA') || l.itens[l.itens.length - 1]
    if (alvo) abrirItem(alvo)
  }
  const filtrosTxt = () => {
    const p = []
    const nome = (lista, id) => ((lista || []).find(x => String(x.id) === id) || {}).nome
    if (filtro.unidade) p.push('Unidade: ' + nome(dados.unidades, filtro.unidade))
    if (filtro.sistema) p.push('Sistema: ' + nome(dados.sistemas, filtro.sistema))
    if (filtro.tipo) p.push('Tipo: ' + MNT_TIPO[filtro.tipo])
    if (filtro.status) p.push('Status: ' + MNT_STATUS[filtro.status].rotulo)
    if (filtro.equipe) p.push('Equipe: ' + nome(dados.equipes, filtro.equipe))
    if (filtro.atrasadas) p.push('Só atrasadas'); if (filtro.pmoc) p.push('Só PMOC'); if (filtro.semCautela) p.push('Sem cautela')
    return 'Agrupado por ' + MNT_AGRUPAR[agrupar].toLowerCase() + (p.length ? ' · ' + p.join(' · ') : '')
  }
  const contratoSel = (contratos || []).find(c => c.id === sel)
  const k = dados && dados.kpis
  const sub = { fontSize: '.85rem', color: 'var(--text-secondary)', margin: '-8px 0 14px' }

  return (
    <div>
      <div className="topbar">
        <h2><Icon name="trending" size={20} /> Cronograma</h2>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          {contratos && contratos.length > 1 && (
            <select value={sel || ''} onChange={e => trocarContrato(Number(e.target.value))} style={{ width: 'auto', minWidth: 200, padding: '8px 10px' }} aria-label="Contrato">
              {contratos.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
          )}
          {seletorVisao}
        </div>
      </div>
      <p style={sub}>Plano de manutenção do contrato: rotinas preventivas e PMOC, OS corretivas com SLA, marcos e medição — cruzados com as cautelas de cada equipe.</p>

      {gestor && dados && (
        <div className="dt-tabs" style={{ margin: '0 0 14px' }}>
          <button className={`dt-tab ${aba === 'gantt' ? 'on' : ''}`} onClick={() => setAba('gantt')}><Icon name="clock" size={14} /> Acompanhamento</button>
          <button className={`dt-tab ${aba === 'config' ? 'on' : ''}`} onClick={() => setAba('config')}><Icon name="edit" size={14} /> Configuração do contrato</button>
        </div>
      )}
      {dados === undefined && <div className="card" style={{ padding: 30, textAlign: 'center', color: 'var(--text-secondary)' }}>Carregando…</div>}
      {dados === null && <div className="card" style={{ padding: 30, textAlign: 'center', color: 'var(--text-secondary)' }}>{contratos && !contratos.length ? 'Nenhum contrato disponível.' : 'Não foi possível carregar o cronograma.'}</div>}

      {dados && aba === 'config' && gestor && <MntConfig cid={sel} user={user} addToast={addToast} onMudou={carregar} />}

      {dados && aba === 'gantt' && !dados.contrato.configurado && !dados.contrato.tem_planos && !dados.itens.length && (
        <div className="card" style={{ padding: 30, textAlign: 'center' }}>
          <div style={{ color: 'var(--text-secondary)', marginBottom: 14 }}>O cronograma de manutenção de <b style={{ color: 'var(--ink)' }}>{contratoSel ? contratoSel.nome : 'este contrato'}</b> ainda não foi configurado.</div>
          {gestor ? <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-accent" onClick={() => setAba('config')}><Icon name="edit" size={14} /> Configurar contrato e plano</button>
            {user.is_master && !user.admin && !user.ceo && !(contratos || []).some(c => c.codigo === 'DEMO-MANUT') && <button className="btn btn-ghost" onClick={async () => {
              try { const r = await POST('/manutencao/demo', { acao: 'criar' }); addToast('Demonstração criada num contrato separado (dados fictícios).', 'success'); const d = await GET('/cronograma/contratos'); setContratos(d.contratos); trocarContrato(r.contrato_id) } catch (e) { addToast(e.message, 'error') }
            }}>Ver com dados de demonstração</button>}
          </div> : <div className="text-muted" style={{ fontSize: '.85rem' }}>Peça ao gestor do contrato para cadastrar o contrato e o plano preventivo.</div>}
        </div>
      )}

      {dados && aba === 'gantt' && (dados.contrato.configurado || dados.contrato.tem_planos || dados.itens.length > 0) && <>
        {contratoSel && contratoSel.codigo === 'DEMO-MANUT' && (
          <div className="alert alert-warning" style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ flex: 1 }}><b>Demonstração com dados fictícios.</b> Contrato separado, não mistura com os dados reais.</span>
            {user.is_master && !user.admin && !user.ceo && <button className="btn btn-ghost btn-sm" onClick={async () => {
              if (!window.confirm('Apagar a demonstração inteira (contrato, unidades e plano fictícios)?')) return
              try { await POST('/manutencao/demo', { acao: 'apagar' }); addToast('Demonstração apagada.', 'success'); const d = await GET('/cronograma/contratos'); setContratos(d.contratos); const s = d.contratos.find(c => c.tem_manutencao) || d.contratos[0]; if (s) trocarContrato(s.id) } catch (e) { addToast(e.message, 'error') }
            }}>Apagar demonstração</button>}
          </div>
        )}
        {k && (
          <div className="mnt-kpis">
            <div className="mnt-kpi"><div className="k">Preventivas do mês no prazo</div>
              <div className={`v ${k.preventivo.pct == null ? '' : k.preventivo.pct >= 90 ? 'ok' : k.preventivo.pct >= 70 ? 'alerta' : 'ruim'}`}>{k.preventivo.pct == null ? '—' : k.preventivo.pct + '%'}</div>
              <div className="s">{k.preventivo.devidas ? `${k.preventivo.no_prazo} de ${k.preventivo.devidas} vencidas até hoje` : 'Nenhuma venceu ainda'} · {k.preventivo.previstas_mes} no mês</div></div>
            <div className="mnt-kpi"><div className="k">OS abertas</div>
              <div className={`v ${k.os.fora_sla ? 'ruim' : ''}`}>{k.os.abertas}</div>
              <div className="s">{k.os.fora_sla ? `${k.os.fora_sla} fora do SLA` : 'Nenhuma fora do SLA'}</div></div>
            <div className="mnt-kpi"><div className="k">Medição</div>
              <div className={`v ${k.medicao && k.medicao.dias < 0 ? 'ruim' : ''}`} style={{ fontSize: '1.05rem', lineHeight: 1.25 }}>{k.medicao ? k.medicao.titulo : '—'}</div>
              <div className="s">{k.medicao ? `${k.medicao.competencia.slice(5)}/${k.medicao.competencia.slice(0, 4)} · ${k.medicao.dias < 0 ? `${-k.medicao.dias} dia(s) de atraso` : k.medicao.dias === 0 ? 'vence hoje' : `faltam ${k.medicao.dias} dia(s)`}` : 'Configure o contrato'}</div></div>
            <div className="mnt-kpi"><div className="k">Próximo marco</div>
              <div className={`v ${k.proximo_marco && k.proximo_marco.alerta && k.proximo_marco.dias <= 60 ? 'alerta' : ''}`}>{k.proximo_marco ? (k.proximo_marco.dias === 0 ? 'hoje' : `${k.proximo_marco.dias} d`) : '—'}</div>
              <div className="s" title={k.proximo_marco ? k.proximo_marco.titulo : ''}>{k.proximo_marco ? `${k.proximo_marco.titulo} · ${fmt(k.proximo_marco.data)}` : 'Sem marcos à frente'}</div></div>
            <div className="mnt-kpi"><div className="k">Sem cautela nesta semana</div>
              <div className={`v ${k.semana.sem_cautela ? 'ruim' : 'ok'}`}>{k.semana.sem_cautela}</div>
              <div className="s">de {k.semana.atividades} atividade(s) · {mntDM(k.semana.inicio)} a {mntDM(k.semana.fim)}</div></div>
          </div>
        )}

        <div className="mnt-bar-tools">
          <div className="mnt-seg" role="group" aria-label="Escala">{Object.entries(MNT_ESCALAS).map(([id, e]) => <button key={id} className={escala === id ? 'on' : ''} onClick={() => trocarEscala(id)}>{e.rotulo}</button>)}</div>
          <div className="mnt-seg" role="group" aria-label="Navegar">
            <button onClick={() => setAncora(a => mntNavegar(escala, a, -1))} aria-label="Período anterior">‹</button>
            <button onClick={() => setAncora(dados.hoje)}>Hoje</button>
            <button onClick={() => setAncora(a => mntNavegar(escala, a, 1))} aria-label="Próximo período">›</button>
          </div>
          <span className="mnt-periodo">{escala === 'ano' ? de.slice(0, 4) : escala === 'semana' ? `${mntDM(de)} – ${fmt(ate)}` : `${mntMesAno(de)} – ${mntMesAno(ate)}`}{carregando ? ' · carregando…' : ''}</span>
          <span className="sp" />
          <select value={agrupar} onChange={e => trocarAgrupar(e.target.value)} aria-label="Agrupar por">{Object.entries(MNT_AGRUPAR).map(([id, r]) => <option key={id} value={id}>{r}</option>)}</select>
          <button className={`mnt-chip${mostrarCautelas ? ' on' : ''}`} onClick={() => setMostrarCautelas(v => !v)} aria-pressed={mostrarCautelas}><Icon name="package" size={13} /> Mostrar cautelas</button>
          <button className={`mnt-chip${verFiltros || filtrando ? ' on' : ''}`} onClick={() => setVerFiltros(v => !v)} aria-expanded={verFiltros}><Icon name="search" size={13} /> Filtros{filtrando ? ' ●' : ''}</button>
        </div>
        {(verFiltros || filtrando) && (
          <div className="mnt-bar-tools">
            <select value={filtro.unidade} onChange={e => setFiltro({ ...filtro, unidade: e.target.value })} aria-label="Unidade"><option value="">Todas as unidades</option>{dados.unidades.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}</select>
            <select value={filtro.sistema} onChange={e => setFiltro({ ...filtro, sistema: e.target.value })} aria-label="Sistema"><option value="">Todos os sistemas</option>{dados.sistemas.map(s => <option key={s.id} value={s.id}>{s.nome}</option>)}</select>
            <select value={filtro.tipo} onChange={e => setFiltro({ ...filtro, tipo: e.target.value })} aria-label="Tipo"><option value="">Todos os tipos</option>{['PREVENTIVA', 'PMOC', 'CORRETIVA_OS', 'ADMINISTRATIVA'].map(t => <option key={t} value={t}>{MNT_TIPO[t]}</option>)}</select>
            <select value={filtro.status} onChange={e => setFiltro({ ...filtro, status: e.target.value })} aria-label="Status"><option value="">Todos os status</option>{Object.entries(MNT_STATUS).map(([s, v]) => <option key={s} value={s}>{v.rotulo}</option>)}</select>
            {!equipe && <select value={filtro.equipe} onChange={e => setFiltro({ ...filtro, equipe: e.target.value })} aria-label="Equipe"><option value="">Todas as equipes</option>{dados.equipes.map(u => <option key={u.id} value={u.id}>{u.nome}</option>)}</select>}
            <button className={`mnt-chip tg-perigo${filtro.atrasadas ? ' on' : ''}`} onClick={() => setFiltro({ ...filtro, atrasadas: !filtro.atrasadas })}>Só atrasadas</button>
            <button className={`mnt-chip tg-cobre${filtro.pmoc ? ' on' : ''}`} onClick={() => setFiltro({ ...filtro, pmoc: !filtro.pmoc })}>Só PMOC</button>
            <button className={`mnt-chip tg-perigo${filtro.semCautela ? ' on' : ''}`} onClick={() => setFiltro({ ...filtro, semCautela: !filtro.semCautela })}>Sem cautela</button>
            {filtrando && <button className="btn btn-ghost btn-sm" onClick={() => setFiltro(FILTRO0)}>Limpar</button>}
          </div>
        )}
        {dados.atrasadas_antes.total > 0 && !filtro.atrasadas && (
          <div className="mnt-aviso"><Icon name="alertTriangle" size={15} /><span style={{ flex: 1 }}><b>{dados.atrasadas_antes.total}</b> atividade(s) atrasada(s) antes deste período.</span>
            <button className="btn btn-ghost btn-sm" onClick={() => { setAncora(dados.atrasadas_antes.mais_antiga); setFiltro({ ...filtro, atrasadas: true }) }}>Ver atrasadas</button></div>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
          {dados.pode.os && <button className="btn btn-accent btn-sm" onClick={() => setModal('os')}><Icon name="plus" size={13} /> Registrar OS</button>}
          {dados.pode.configurar && <button className="btn btn-outline btn-sm" onClick={() => setModal('atividade')}><Icon name="plus" size={13} /> Atividade ou marco</button>}
          <span style={{ flex: 1 }} />
          <button className="btn btn-ghost btn-sm" onClick={() => mntImprimir({ dados, linhas, de, ate, filtrosTxt: filtrosTxt() })}><Icon name="fileText" size={13} /> PDF</button>
          <button className="btn btn-ghost btn-sm" onClick={() => mntCsv(itensF, equipesMap, de, ate)} disabled={!itensF.length}><Icon name="download" size={13} /> CSV</button>
        </div>
        <MntGantt dados={dados} linhas={linhas} de={de} ate={ate} escala={escala} selKey={painel && painel.key}
          onItem={abrirItem} onLinha={abrirLinha} onToggle={toggle}
          onMedicao={m => setPainel({ tipo: 'medicao', key: 'med' + m.competencia, med: m })}
          onMarco={m => setPainel({ tipo: 'marco', key: m.key, marco: m })}
          onCautela={c => setPainel({ tipo: 'cautela', key: 'c' + c.id, cautela: c })} />
      </>}

      {painel && <div className="mnt-painel-fundo" onClick={() => setPainel(null)} />}
      {painel && painel.tipo === 'item' && <MntPainelItem alvo={painel} pode={dados.pode} onFechar={() => setPainel(null)} onMudou={carregar} navigate={navigate} addToast={addToast} />}
      {painel && painel.tipo === 'medicao' && <MntPainelMedicao med={painel.med} cid={sel} pode={dados.pode} onFechar={() => setPainel(null)} onMudou={carregar} addToast={addToast} />}
      {painel && painel.tipo === 'marco' && <MntPainelSimples etiqueta="Marco do contrato" titulo={painel.marco.titulo} onFechar={() => setPainel(null)} linhas={[
        ['Data', fmt(painel.marco.data)],
        ['Faltam', painel.marco.data < dados.hoje ? 'já passou' : `${mntDiff(dados.hoje, painel.marco.data)} dia(s)`],
        painel.marco.legal && ['Base legal', painel.marco.legal],
        ['Origem', painel.marco.manual ? 'Lançado à mão' : 'Calculado a partir dos dados do contrato'],
      ]} />}
      {painel && painel.tipo === 'cautela' && <MntPainelSimples etiqueta="Cautela da equipe" titulo={painel.cautela.numero} onFechar={() => setPainel(null)} linhas={[
        ['Equipe', painel.cautela.lider_nome], ['Status', painel.cautela.status === 'ativa' ? 'Ativa' : 'Aguardando retirada'],
        ['Desde', fmt(painel.cautela.inicio)], painel.cautela.obra_nome && ['Obra', painel.cautela.obra_nome],
        ['Itens', `${painel.cautela.unidades} unidade(s) em ${painel.cautela.itens} item(ns)`],
      ]} rodape={['almoxarifado', 'lider', 'engenheiro'].includes(user.role) && <button className="btn btn-outline btn-sm" style={{ marginTop: 14 }} onClick={() => navigate('cautelas', painel.cautela.id)}>Abrir a cautela</button>} />}
      {modal === 'os' && <MntNovaOS dados={dados} cid={sel} user={user} addToast={addToast} onFechar={() => setModal(null)} onCriado={item => { setModal(null); carregar(); abrirItem(item) }} />}
      {modal === 'atividade' && <MntNovaAtividade dados={dados} cid={sel} addToast={addToast} onFechar={() => setModal(null)} onCriado={() => { setModal(null); carregar() }} />}
    </div>
  )
}

// Aba Cronograma: a Curva S (painel físico-financeiro) continua como estava; o Gantt é a visão nova.
// Almoxarifado vê só o Gantt (a Curva S mostra valores do contrato).
function CronogramaPage(props) {
  const { user } = props
  const temGantt = temModulo(user, 'manutencao')
  const soGantt = user.role === 'almoxarifado' && !user.is_master
  const [visao, setVisao] = useState(() => soGantt ? 'gantt' : lsLer('cf_crono_visao', 'curva'))
  if (!temGantt) return <CurvaSPage {...props} />
  const trocar = v => { setVisao(v); lsGravar('cf_crono_visao', v) }
  const seletor = soGantt ? null : (
    <div className="mnt-seg" role="tablist" aria-label="Visualização">
      <button role="tab" aria-selected={visao === 'curva'} className={visao === 'curva' ? 'on' : ''} onClick={() => trocar('curva')}>Curva S</button>
      <button role="tab" aria-selected={visao === 'gantt'} className={visao === 'gantt' ? 'on' : ''} onClick={() => trocar('gantt')}>Gantt</button>
    </div>
  )
  return visao === 'gantt' || soGantt ? <ManutPage {...props} seletorVisao={seletor} /> : <CurvaSPage {...props} seletorVisao={seletor} />
}

// Colaborador (celular): as atividades da semana, sem Gantt — com a cautela da equipe e o botão de concluir.
function MinhasAtividadesPage({ addToast }) {
  const [semana, setSemana] = useState(null)
  const [d, setD] = useState(null)
  const [salvando, setSalvando] = useState(null)
  const carregar = () => GET('/manutencao/minha-semana' + (semana ? '?semana=' + semana : '')).then(setD).catch(e => addToast(e.message, 'error'))
  useEffect(() => { carregar() }, [semana])
  const concluir = async i => {
    if (!window.confirm(`Marcar "${i.titulo}" como concluída hoje?`)) return
    setSalvando(i.key)
    try { await POST('/manutencao/minha-semana/concluir', { ref: i.id ? { id: i.id } : { plano_id: i.plano_id, ocorrencia: i.ocorrencia } }); addToast('Atividade concluída.', 'success'); carregar() } catch (e) { addToast(e.message, 'error') }
    setSalvando(null)
  }
  if (!d) return <div className="text-muted">Carregando…</div>
  const porDia = new Map()
  for (const i of d.itens) { const dia = i.prev_inicio < d.inicio ? d.inicio : i.prev_inicio; if (!porDia.has(dia)) porDia.set(dia, []); porDia.get(dia).push(i) }
  const dias = [...porDia.keys()].sort().map(dia => ({ dia, itens: porDia.get(dia) }))
  const nDia = s => `${MNT_DIAS[mntDow(s)]} ${mntDM(s)}${s === d.hoje ? ' · hoje' : ''}`
  return (
    <div>
      <div className="topbar"><h2><Icon name="clock" size={20} /> Atividades da semana</h2></div>
      <div className="mnt-bar-tools">
        <div className="mnt-seg" role="group" aria-label="Semana">
          <button onClick={() => setSemana(mntAdd(d.inicio, -7))} aria-label="Semana anterior">‹</button>
          <button onClick={() => setSemana(null)}>Esta semana</button>
          <button onClick={() => setSemana(mntAdd(d.inicio, 7))} aria-label="Próxima semana">›</button>
        </div>
        <span className="mnt-periodo">{mntDM(d.inicio)} a {mntDM(d.fim)}</span>
      </div>
      {d.lider_nome && <p style={{ fontSize: '.85rem', color: 'var(--text-secondary)', margin: '0 0 6px' }}>{d.obra_nome && <><b style={{ color: 'var(--ink)' }}>{d.obra_nome}</b> · </>}Equipe de <b style={{ color: 'var(--ink)' }}>{d.lider_nome}</b>{d.cautelas_equipe.length ? <> · cautela{d.cautelas_equipe.length > 1 ? 's' : ''} da equipe: {d.cautelas_equipe.map(c => c.numero).join(', ')}</> : ' · a equipe não tem cautela ativa'}</p>}
      {!d.itens.length && <div className="card" style={{ padding: 26, textAlign: 'center', color: 'var(--text-secondary)' }}>Nenhuma atividade programada para esta semana.</div>}
      {dias.map(g => (
        <div key={g.dia}>
          <div className="mnt-dia">{nDia(g.dia)}</div>
          {g.itens.map(i => {
            const st = MNT_STATUS[i.status_efetivo], cz = MNT_CAUTELA[i.cautela.estado]
            return (
              <div key={i.key} className="mnt-card">
                <div className="t">{i.titulo}</div>
                <div className="s">{[i.obra_id && i.obra_id === d.obra_id ? null : (i.obra_nome || 'Contrato (geral)'), i.sistema_nome, mntFaixa(i.prev_inicio, i.prev_fim)].filter(Boolean).join(' · ')}</div>
                <div className="tags">
                  <span className={`rtag ${st.tom}`}>{st.glifo ? st.glifo + ' ' : ''}{st.rotulo}</span>
                  {i.tipo === 'PMOC' && <span className="rtag tg-cobre">PMOC</span>}
                  {i.cautela.estado !== 'sem_kit' && <span className={`rtag ${cz.tom}`}><Icon name="wrench" size={11} /> {i.cautela.estado === 'sem' ? 'Ferramentas: fale com o engenheiro' : cz.rotulo}</span>}
                </div>
                {i.pode_concluir && <button className="btn btn-success btn-sm" style={{ marginTop: 10, width: '100%', justifyContent: 'center' }} disabled={salvando === i.key} onClick={() => concluir(i)}><Icon name="check" size={14} /> Marcar como concluída</button>}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}

function ContratosPage({ user, navigate, addToast }) {
  const [data, setData] = useState(null)
  const [responsaveis, setResponsaveis] = useState([])
  const [form, setForm] = useState(null)  // null = sem formulário aberto
  const podeEditar = !user.ceo && (user.is_master || user.role === 'diretor')
  const modsDeploy = (user.modulos && user.modulos.length ? user.modulos : ['cautela', 'obras', 'equipe', 'emprestimos', 'uniformes', 'rec']).filter(m => m !== 'rdo')
  // O Diário de obra liga só por contrato (nunca pelo deploy): a caixa aparece sempre e o contrato novo nasce sem ele.
  const modsCaixas = [...modsDeploy, 'rdo']
  const inp = { padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 9, background: 'var(--surface)', color: 'var(--ink)', fontSize: '.9rem', width: '100%', fontFamily: 'inherit' }

  // Depósitos de base (tipo 'centro'): Niterói, Costellation… — cada um com o seu Almoxarife 2, abastecido pela Sede.
  const [bases, setBases] = useState([])
  const temRec = modsDeploy.includes('rec')
  const carregar = () => GET('/contratos?indicadores=1').then(setData).catch(() => {})
  useEffect(() => {
    carregar(); GET('/usuarios?role=gerente').then(setResponsaveis).catch(() => {})
    if (temRec) GET('/rec/depositos').then(ds => setBases((ds || []).filter(d => d.tipo === 'centro'))).catch(() => {})
  }, [])

  // "Almoxarife 2 desta base pode pedir compra" é da BASE (vale para todos os contratos que a usam): a caixa
  // mostra o que está gravado na base escolhida; base nova nasce podendo.
  const compraDaBase = id => { const b = bases.find(x => String(x.id) === String(id)); return !b || b.almox2_compra !== 0 }
  const novo = () => setForm({ nome: '', codigo: '', cnpj: '', cliente: '', responsavel_id: '', modulos: [...modsDeploy], ativo: 1, deposito_id: '', novo_deposito: '', base_compra: true })
  const editar = c => setForm({ id: c.id, nome: c.nome, codigo: c.codigo || '', cnpj: c.cnpj || '', cliente: c.cliente || '', responsavel_id: c.responsavel_id || '', modulos: c.modulos ? [...c.modulos] : [...modsDeploy], ativo: c.ativo,
    deposito_id: c.deposito_id ? String(c.deposito_id) : '', novo_deposito: '', base_compra: compraDaBase(c.deposito_id) })
  const toggleMod = m => setForm(f => ({ ...f, modulos: f.modulos.includes(m) ? f.modulos.filter(x => x !== m) : [...f.modulos, m] }))
  const salvar = async () => {
    if (!form.nome.trim()) { addToast('Informe o nome do contrato.', 'warning'); return }
    if (form.deposito_id === 'novo' && !form.novo_deposito.trim()) { addToast('Dê um nome ao novo depósito de base.', 'warning'); return }
    const body = { nome: form.nome.trim(), codigo: form.codigo.trim() || null, cnpj: form.cnpj.trim() || null,
      cliente: form.cliente.trim() || null, responsavel_id: form.responsavel_id || null,
      modulos: Array.from(new Set(['cautela', ...form.modulos])), ativo: form.ativo,
      ...(temRec ? (form.deposito_id === 'novo' ? { novo_deposito: form.novo_deposito.trim() } : { deposito_id: form.deposito_id ? Number(form.deposito_id) : null }) : {}),
      ...(temRec && form.deposito_id ? { base_compra: !!form.base_compra } : {}) }
    try {
      if (form.id) { await PUT('/contratos/' + form.id, body); addToast('Contrato atualizado.') }
      else { await POST('/contratos', body); addToast('Contrato criado.') }
      setForm(null); carregar()
      if (temRec && form.deposito_id) GET('/rec/depositos').then(ds => setBases((ds || []).filter(d => d.tipo === 'centro'))).catch(() => {})
    } catch (e) { addToast(e.message || 'Erro ao salvar contrato.', 'error') }
  }

  const contratos = (data && data.contratos) || []
  return (
    <div>
      <div className="topbar">
        <h2>Contratos</h2>
        {podeEditar && <button className="btn btn-accent" onClick={novo}><Icon name="plus" size={14} /> Novo contrato</button>}
      </div>
      <p style={{ fontSize: '.85rem', color: 'var(--text-secondary)', margin: '0 0 20px' }}>
        Cada contrato roda o sistema completo — ferramentas, obras, equipe e indicadores próprios. Gestão restrita a Master, CEO (leitura) e Diretor.
      </p>

      <div className={`ctr-grid${form ? ' com-form' : ''}`}>
        <div className="card">
          <div className="table-wrap"><table className="cards-mobile">
            <thead><tr><th>Contrato</th><th>Módulos</th>{temRec && <th>Base (Almox 2)</th>}<th>Obras</th><th>Equipe</th><th>Status</th>{podeEditar && <th></th>}</tr></thead>
            <tbody>
              {contratos.map((c, i) => (
                <tr key={c.id}>
                  <td data-label="Contrato"><span style={{ display: 'inline-flex', alignItems: 'center', gap: 9, fontWeight: 700 }}><span style={{ width: 11, height: 11, borderRadius: 3, background: corContrato(c, i), flex: 'none' }} />{c.nome}{c.codigo && <span style={{ fontSize: '.7rem', color: 'var(--text-secondary)', fontWeight: 600 }}>{c.codigo}</span>}</span></td>
                  <td data-label="Módulos"><span style={{ display: 'inline-flex', gap: 5, flexWrap: 'wrap' }}>{(c.modulos || []).filter(m => m !== 'cautela').concat(['cautela']).map(m => <span key={m} style={{ fontSize: '.66rem', fontWeight: 700, padding: '2px 8px', borderRadius: 20, background: 'var(--surface-alt,#EEF1F5)', color: 'var(--primary-text)' }}>{MOD_LABEL[m] || m}</span>)}</span></td>
                  {temRec && <td data-label="Base (Almox 2)">{c.deposito_nome || <span className="text-muted">Só a Sede</span>}</td>}
                  <td data-label="Obras">{c.kpis ? c.kpis.obras_ativas : '—'}</td>
                  <td data-label="Equipe">{c.kpis ? c.kpis.colaboradores : '—'}</td>
                  <td data-label="Status"><span className={`badge ${c.ativo ? 'badge-ativo' : 'badge-devolvido'}`}>{c.ativo ? 'Ativo' : 'Inativo'}</span></td>
                  {podeEditar && <td data-label=""><button className="btn btn-outline btn-sm" onClick={() => editar(c)}>Editar</button></td>}
                </tr>
              ))}
              {!contratos.length && <tr><td colSpan={(podeEditar ? 6 : 5) + (temRec ? 1 : 0)} className="text-muted" style={{ textAlign: 'center', padding: 20 }}>Nenhum contrato cadastrado.</td></tr>}
            </tbody>
          </table></div>
        </div>

        {form && (
          <div className="card ctr-form" style={{ padding: 20 }}>
            <div style={{ fontSize: '.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.05em', color: 'var(--text-secondary)', marginBottom: 16 }}>{form.id ? 'Editar contrato' : 'Novo contrato'}</div>
            {!form.id && <div style={{ background: 'linear-gradient(135deg,rgba(74,144,164,.1),rgba(74,144,164,.03))', border: '1px solid var(--tag-aco-bd)', borderRadius: 10, padding: '11px 14px', fontSize: '.8rem', color: 'var(--primary-text)', marginBottom: 16 }}>O novo contrato já nasce com todos os módulos e telas — depois é só cadastrar obras, equipe e acervo.</div>}
            <div style={{ marginBottom: 13 }}><label style={{ display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }}>Nome do contrato *</label><input style={inp} value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} placeholder="Ex.: Contrato Norte" /></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 13 }}>
              <div><label style={{ display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }}>Código</label><input style={inp} value={form.codigo} onChange={e => setForm({ ...form, codigo: e.target.value })} placeholder="C-002" /></div>
              <div><label style={{ display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }}>CNPJ do cliente</label><input style={inp} value={form.cnpj} onChange={e => setForm({ ...form, cnpj: e.target.value })} placeholder="00.000.000/0001-00" /></div>
            </div>
            <div style={{ marginBottom: 13 }}><label style={{ display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }}>Cliente / razão social</label><input style={inp} value={form.cliente} onChange={e => setForm({ ...form, cliente: e.target.value })} placeholder="Nome do cliente do contrato" /></div>
            <div style={{ marginBottom: 13 }}>
              <label style={{ display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }}>Módulos ativos</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {modsCaixas.map(m => {
                  const on = m === 'cautela' || form.modulos.includes(m)
                  return (
                    <label key={m} style={{ display: 'flex', alignItems: 'center', gap: 10, border: '1px solid var(--border)', background: 'var(--surface)', borderRadius: 10, padding: '10px 12px', cursor: m === 'cautela' ? 'default' : 'pointer', opacity: m === 'cautela' ? .75 : 1 }}>
                      <input type="checkbox" checked={on} disabled={m === 'cautela'} onChange={() => toggleMod(m)} />
                      <span style={{ fontSize: '.87rem', fontWeight: 600, color: 'var(--ink)' }}>{MOD_LABEL[m] || m}{m === 'cautela' && ' (base)'}</span>
                    </label>
                  )
                })}
              </div>
            </div>
            <div style={{ marginBottom: 13 }}><label style={{ display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }}>Responsável (Gerente de Contrato)</label>
              <select style={inp} value={form.responsavel_id} onChange={e => setForm({ ...form, responsavel_id: e.target.value })}>
                <option value="">— Selecionar —</option>
                {responsaveis.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
              </select>
            </div>
            {temRec && (
              <div style={{ marginBottom: 13 }}><label htmlFor="ctr-base" style={{ display: 'block', fontSize: '.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', color: 'var(--text-secondary)', marginBottom: 6 }}>Depósito de base (Almoxarife 2)</label>
                <select id="ctr-base" style={inp} value={form.deposito_id} onChange={e => setForm({ ...form, deposito_id: e.target.value, base_compra: e.target.value === 'novo' || compraDaBase(e.target.value) })}>
                  <option value="">Nenhum — só a Sede atende</option>
                  {bases.map(b => <option key={b.id} value={String(b.id)}>{b.nome}</option>)}
                  <option value="novo">+ Novo depósito de base…</option>
                </select>
                {form.deposito_id === 'novo' && <input id="ctr-base-nome" style={{ ...inp, marginTop: 8 }} value={form.novo_deposito} onChange={e => setForm({ ...form, novo_deposito: e.target.value })} placeholder="Nome do depósito (ex.: Costellation)" maxLength={60} />}
                <div style={{ fontSize: '.76rem', color: 'var(--text-secondary)', marginTop: 6, lineHeight: 1.4 }}>Depósito perto das obras, cuidado pelo Almoxarife 2 do contrato e abastecido pela Sede (pedido de reposição). O material das obras sai dele primeiro e da Sede o que faltar. Vários contratos podem usar o mesmo depósito.</div>
                {form.deposito_id && <label style={{ display: 'flex', alignItems: 'flex-start', gap: 9, marginTop: 10, fontSize: '.85rem', color: 'var(--ink)', cursor: 'pointer' }}>
                  <input type="checkbox" checked={!!form.base_compra} onChange={e => setForm({ ...form, base_compra: e.target.checked })} style={{ marginTop: 3, width: 16, height: 16, minWidth: 0, flex: 'none' }} />
                  <span>Almoxarife 2 desta base pode pedir compra<span style={{ display: 'block', fontSize: '.76rem', color: 'var(--text-secondary)' }}>Desmarcado, ele só pede à Sede (pedido de reposição) e a compra sai pelo almoxarifado da Sede. Vale para todos os contratos que usam este depósito.</span></span>
                </label>}
              </div>
            )}
            {form.id && <label style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 14, fontSize: '.87rem', color: 'var(--ink)' }}><input type="checkbox" checked={!!form.ativo} onChange={e => setForm({ ...form, ativo: e.target.checked ? 1 : 0 })} /> Contrato ativo</label>}
            <div style={{ display: 'flex', gap: 10 }}>
              <button className="btn btn-primary" style={{ flex: 1 }} onClick={salvar}>{form.id ? 'Salvar' : 'Criar contrato'}</button>
              <button className="btn btn-outline" onClick={() => setForm(null)}>Cancelar</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

// ─── BUSCA GLOBAL / PALETA DE COMANDO (Cmd+K) ──────────────────────────────────
// Quick-switcher no estilo Slack: acha entidades (cautela/ferramenta/obra/pessoa via
// /busca, escopado no servidor) e navega para qualquer aba do menu do usuário. Teclado:
// ↑/↓ move, Enter abre, Esc fecha. Fonte das abas = construirMenu (mesma do Sidebar).
function CommandPalette({ user, notif, navigate, onClose }) {
  const [q, setQ] = useState('')
  const [ent, setEnt] = useState([])
  const [sel, setSel] = useState(0)
  const inputRef = useRef(null)
  const listRef = useRef(null)
  const menu = menuDe(user, notif)
  const termo = q.trim().toLowerCase()
  const paginas = (termo ? menu.filter(m => casaBusca(termo, m.label)) : menu)
    .map(m => ({ tipo: 'Ir para', icon: m.icon, titulo: m.label, sub: '', page: m.id }))
  // Resultado só leva a aba que está no menu de quem busca (mesma regra de podeAbrir nos cards do painel):
  // o servidor já escopa por papel; isto segura um destino fora do menu (ex.: Obras para o Gerente multicontrato).
  const itens = [...paginas, ...ent.filter(it => menu.some(m => m.id === it.page))]
  useEffect(() => { if (inputRef.current) inputRef.current.focus() }, [])
  useEffect(() => {
    const t = q.trim()
    if (t.length < 2) { setEnt([]); return }
    let vivo = true
    const h = setTimeout(() => { GET('/busca?q=' + encodeURIComponent(t)).then(r => { if (vivo) setEnt(r.resultados || []) }).catch(() => { if (vivo) setEnt([]) }) }, 220)
    return () => { vivo = false; clearTimeout(h) }
  }, [q])
  useEffect(() => { setSel(0) }, [q, ent.length])
  useEffect(() => { const el = listRef.current && listRef.current.querySelector('.cmd-item.on'); if (el) el.scrollIntoView({ block: 'nearest' }) }, [sel])
  const escolher = it => { if (!it) return; navigate(it.page, it.id || null, it.filtro || null); onClose() }
  const onKey = e => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setSel(s => Math.min(s + 1, itens.length - 1)) }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setSel(s => Math.max(s - 1, 0)) }
    else if (e.key === 'Enter') { e.preventDefault(); escolher(itens[sel]) }
    else if (e.key === 'Escape') { e.preventDefault(); onClose() }
  }
  return (
    <div className="cmd-overlay" onClick={onClose}>
      <div className="cmd-box" onClick={e => e.stopPropagation()}>
        <div className="cmd-inrow">
          <Icon name="search" size={18} />
          <input ref={inputRef} className="cmd-input" value={q} onChange={e => setQ(e.target.value)} onKeyDown={onKey}
            placeholder={temModulo(user, 'rec') ? 'Buscar cautela, pedido REC/RC, ferramenta, obra, pessoa ou aba…' : 'Buscar cautela, ferramenta, obra, pessoa ou aba…'} />
          <span className="cmd-esc">ESC</span>
        </div>
        <div className="cmd-list" ref={listRef}>
          {itens.length === 0 && <div className="cmd-empty">{termo ? 'Nada encontrado.' : 'Digite para buscar…'}</div>}
          {itens.map((it, i) => (
            <button key={i} className={`cmd-item ${i === sel ? 'on' : ''}`} onMouseEnter={() => setSel(i)} onClick={() => escolher(it)}>
              <span className="cmd-ic"><Icon name={it.icon || 'search'} size={16} /></span>
              <span className="cmd-tt">{it.titulo}{it.sub ? <span className="cmd-sub"> · {it.sub}</span> : null}</span>
              <span className="cmd-tag">{it.tipo}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

// ─── APP ROOT ─────────────────────────────────────────────────────────────────
function App() {
  const [user, setUser] = useState(null)
  const [page, setPage] = useState('dashboard')
  const [toasts, setToasts] = useState([])
  const [checking, setChecking] = useState(true)
  const [avisoLogin, setAvisoLogin] = useState('')   // por que a sessão terminou (inatividade, senha trocada…)
  const [notif, setNotif] = useState({})
  const [menuOpen, setMenuOpen] = useState(false)
  const [paletteOpen, setPaletteOpen] = useState(false)
  const [openTarget, setOpenTarget] = useState(null)  // deep-link: {page, id} a abrir na página de destino
  // Modo apresentação (tour do CEO). null = desligado.
  // Ativo: { perfis:[...], role:'diretor'|null, master:{token,user} } — guarda a sessão real
  // do apresentador para restaurar ao sair.
  const [tour, setTour] = useState(null)

  const addToast = useCallback((msg, type='success') => {
    const id = Date.now()
    setToasts(t => [...t, {id, msg, type}])
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 3500)
  }, [])

  // Feedback ao tentar qualquer ação de escrita durante a apresentação (bloqueada no cliente e no servidor).
  useEffect(() => {
    const ceo = !!(user && user.ceo)
    tourMode.onBlock = () => addToast(ceo ? 'Acesso CEO: somente leitura.' : 'Somente leitura no modo apresentação.', 'warning')
    if (ceo) tourMode.active = true   // login persistente do CEO: bloqueia toda escrita no cliente
    return () => { tourMode.onBlock = null }
  }, [addToast, user])

  const canPresent = !!(user && !tour && user.is_master && !user.ceo)

  const enterTour = async () => {
    try {
      const perfis = await GET('/auth/tour/perfis')
      const master = { token: token.value, user }
      const first = (perfis.find(p => p.disponivel) || {}).role
      setTour({ perfis, role: null, master })
      if (first) await selectTourPerfil(first, { perfis, master, role: null })
      else addToast('Nenhum perfil com usuário cadastrado para demonstrar.', 'warning')
    } catch (e) { addToast(e.message || 'Falha ao iniciar apresentação.', 'error') }
  }

  const selectTourPerfil = async (role, ctx) => {
    const t = ctx || tour
    if (!t) return
    try {
      const data = await postTour(role, t.master.token)
      token.value = data.token
      tourMode.active = true
      setUser(normUser({ ...data.user }))
      setPage('dashboard')
      setMenuOpen(false)
      setTour({ ...t, role })
    } catch (e) { addToast(e.message || 'Falha ao carregar o perfil.', 'error') }
  }

  const exitTour = () => {
    tourMode.active = false
    if (tour && tour.master) { token.value = tour.master.token; setUser(normUser(tour.master.user)) }
    setTour(null)
    setPage('dashboard')
  }

  useEffect(() => {
    if (token.value) {
      GET('/auth/me').then(u => { setUser(normUser(u)); setChecking(false) })
        .catch(e => { token.value = null; localStorage.removeItem('cf_token'); if (e.data && e.data.sessao) setAvisoLogin(e.message); setChecking(false) })
    } else setChecking(false)
  }, [])

  useEffect(() => {
    if (!user) return
    let prev = {}
    const load = () => GET('/notificacoes').then(n => {
      // Toast para líder quando solicitação fica pronta
      if (user.role === 'lider' || user.role === 'engenheiro') {
        const curr = n.sol_prontas || 0
        const ante = prev.sol_prontas || 0
        if (curr > 0 && curr !== ante) addToast(`${curr} solicitação(ões) pronta(s) para retirada!`, 'warning')
        const tCurr = n.transferencias_recebidas || 0, tAnte = prev.transferencias_recebidas || 0
        if (tCurr > tAnte) addToast(`Você recebeu ${tCurr} pedido(s) de transferência de colaborador — confirme na aba Minha equipe`, 'warning')
      }
      // Toast para operário quando tem empréstimo aguardando confirmação
      if (user.role === 'operario') {
        const curr = n.emprestimos_aguardando_confirmacao || 0
        const ante = prev.emprestimos_aguardando_confirmacao || 0
        if (curr > ante) addToast(`Você tem ${curr} empréstimo(s) aguardando sua confirmação`, 'warning')
      }
      // Alertas do módulo Uniformes — para os 3 perfis com acesso
      if (PERFIS_UNIFORME.includes(user.role)) {
        const minCurr = n.uniforme_estoque_minimo || 0, minAnte = prev.uniforme_estoque_minimo || 0
        if (minCurr > minAnte) addToast(`${minCurr} item(ns) de uniforme/EPI no estoque mínimo`, 'warning')
        const desgCurr = n.uniforme_desgaste || 0, desgAnte = prev.uniforme_desgaste || 0
        if (desgCurr > desgAnte) addToast(`${desgCurr} uniforme(s) com desgaste vencendo — repor`, 'warning')
      }
      prev = n
      setNotif(n)
    }).catch(()=>{})
    load()
    // Aba oculta (app em segundo plano, celular com a tela apagada): não consulta. Ao voltar, consulta na
    // hora — os toasts comparam com a última leitura, então o que mudou nesse meio-tempo ainda avisa.
    const interval = setInterval(() => { if (document.visibilityState !== 'hidden') load() }, 30000)
    const aoVoltar = () => { if (document.visibilityState === 'visible') load() }
    document.addEventListener('visibilitychange', aoVoltar)
    return () => { clearInterval(interval); document.removeEventListener('visibilitychange', aoVoltar) }
  }, [user])

  // navigate(p, id?, filtro?) — id abre aquele item (ou sub-aba) direto na página de destino; filtro
  // (cards do painel) chega à página já filtrada, com a faixa "Mostrando: …" (ver FiltroPainel).
  const navigate = (p, id = null, filtro = null) => { reenquadrar(); setPage(p); setMenuOpen(false); setPaletteOpen(false); setOpenTarget(id || filtro ? { page: p, id, filtro } : null) }
  // Cmd/Ctrl+K abre/fecha a busca global (só com usuário logado).
  useEffect(() => {
    const h = e => { if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) { e.preventDefault(); setPaletteOpen(o => !o) } }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  }, [])
  // Sair encerra a sessão também no servidor (no modo apresentação, a do apresentador).
  const logout = () => {
    const t = tour && tour.master ? tour.master.token : token.value
    if (t) fetch('/api/auth/sair', { method: 'POST', headers: { Authorization: `Bearer ${t}` } }).catch(() => {})
    rdoLimparAparelho()   // RDO digitado e não enviado: o próximo a usar o celular da obra não vê
    tourMode.active = false; setTour(null); token.value = null; localStorage.removeItem('cf_token'); setAvisoLogin(''); setUser(null); setPage('dashboard')
  }
  // Sessão encerrada pelo servidor no meio do uso: volta ao login dizendo o porquê (uma vez só).
  sessaoTela.aoEncerrar = msg => {
    if (!token.value) return
    tourMode.active = false; setTour(null); token.value = null; localStorage.removeItem('cf_token'); setAvisoLogin(msg); setUser(null); setPage('dashboard')
  }

  if (checking) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',fontSize:'1.2rem',color:'var(--text-secondary)'}}>Carregando...</div>
  if (!user) return <LoginPage aviso={avisoLogin} onLogin={u=>{ reenquadrar(); setAvisoLogin(''); setUser(normUser(u)); setPage('dashboard') }} />
  if (user.primeiro_acesso) return <PrimeiroAcessoPage user={user} onConcluido={u=>{ reenquadrar(); setUser(normUser(u)) }} />

  const props = { user, navigate, addToast }
  const renderPage = () => {
    // Motorista/Ajudante: Painel = rota do dia com as pendências (Pendências não é mais aba deles).
    if (user.role === 'motorista' && (page === 'dashboard' || page === 'pendencias')) return <PainelMotorista {...props} notif={notif} />
    // Almoxarife 2: Painel = a base dele (REC + Estoque), não o painel genérico de quem tem cautela.
    if (user.role === 'almoxarife2' && page === 'dashboard') return <PainelAlmox2 {...props} notif={notif} />
    if (page === 'dashboard') return <Dashboard {...props} />
    if (page === 'pendencias') return <PendenciasPage {...props} notif={notif} />
    if (page === 'solicitacoes') return <SolicitacoesPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'nova-solicitacao') return <NovaSolicitacaoPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'equipe') return <EquipePage {...props} />
    if (page === 'equipe-auditoria') return <EquipeAuditoriaPage {...props} />
    if (page === 'cautelas') return <CautelasPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'emprestimos') return <EmprestimosPage {...props} openTarget={openTarget} />
    if (page === 'uniformes') return <UniformesPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'rec') return <RecPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'estoque') return <EstoquePage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'fiscalizacao') return <FiscPage {...props} />
    if (page === 'entregas-bolsas') return <EntregasBolsasPage {...props} />
    if (page === 'servicos-extras') return <ServicosExtrasPage {...props} />
    if (page === 'rdo') return <RdoPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'ferramentas') return <FerramentasPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'obras') return user.role === 'engenheiro' ? <ObrasLiderPage {...props} /> : <ObrasPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'kanban-obras') return <KanbanObrasPage {...props} />
    if (page === 'bolsas') return <BolsasPage {...props} />
    if (page === 'contratos') return <ContratosPage {...props} />
    if (page === 'cronograma') return <CronogramaPage {...props} />
    if (page === 'minhas-atividades') return <MinhasAtividadesPage {...props} />
    if (page === 'minha-equipe') return <MinhaEquipePage {...props} />
    if (page === 'usuarios') return <UsuariosPage {...props} openTarget={openTarget} clearOpenTarget={()=>setOpenTarget(null)} />
    if (page === 'diretor-auditoria') return <DiretorAuditoriaPage {...props} openTarget={openTarget} />
    if (page === 'auditoria') return <AuditoriaPage {...props} />
    return <div style={{padding:24}}>Página não encontrada.</div>
  }

  return (
    <div className="layout">
      <Sidebar user={user} page={page} navigate={navigate} onLogout={logout} notif={notif} open={menuOpen}
        onOpenSearch={()=>setPaletteOpen(true)}
        tour={tour} canPresent={canPresent} onTourEnter={enterTour} onTourSelect={selectTourPerfil} />
      <div className={`sidebar-overlay ${menuOpen?'open':''}`} onClick={()=>setMenuOpen(false)} />
      <div className="main-content">
        <header className="mobile-topbar">
          <div className="mtb-left">
            <button className="mtb-menu" onClick={()=>setMenuOpen(true)} aria-label="Abrir menu"><Icon name="menu" size={22}/></button>
            <div className="mtb-brand">{empresaInfo.logoUrl && <img src={empresaInfo.logoUrl} alt="" style={{maxHeight:28,maxWidth:28,borderRadius:5}} />}<span>Cautelix</span></div>
          </div>
          <div className="mtb-right">
            <button className="mtb-search" onClick={()=>setPaletteOpen(true)} aria-label="Buscar"><Icon name="search" size={19}/></button>
            <ThemeToggleIcon/>
            <button className="mtb-logout" onClick={logout}><Icon name="logout" size={15}/> Sair</button>
          </div>
        </header>
        {tour && (
          <div className="tour-banner">
            <span className="tb-dot" />
            <div>
              <strong>MODO APRESENTAÇÃO</strong>
              <span className="tb-sub"> · visão de <b>{roleLabelDe(user) || user.role}</b>{user.nome ? ` (${user.nome})` : ''} — somente leitura</span>
            </div>
            <button className="tb-exit" onClick={exitTour}><Icon name="x" size={14}/> Sair da apresentação</button>
          </div>
        )}
        {!tour && user.ceo && (
          <div className="tour-banner">
            <span className="tb-dot" />
            <div><strong>ACESSO CEO</strong><span className="tb-sub"> · visão executiva de tudo — somente leitura</span></div>
          </div>
        )}
        {/* key = conta: trocar de perfil no modo apresentação (ou sair dele) remonta a página, que busca os
            dados de novo — o Painel buscava só na montagem e seguia com os números do perfil anterior.
            Atualizar notificações ou navegar não muda a conta, então não remonta. */}
        <React.Fragment key={user.id}>{renderPage()}</React.Fragment>
      </div>
      {paletteOpen && <CommandPalette user={user} notif={notif} navigate={navigate} onClose={()=>setPaletteOpen(false)} />}
      <Toast toasts={toasts} />
    </div>
  )
}

// Volta o zoom do celular para 100% (o "pinçar para re-enquadrar"). No iPhone, travar maximum-scale=1 por
// um instante faz o Safari voltar à escala 1; em seguida o viewport original devolve o pinçar ao usuário.
// Chamado ao entrar no sistema e a cada troca de tela — app nativo não "carrega" zoom de uma tela para outra.
function reenquadrar() {
  const m = document.querySelector('meta[name=viewport]')
  if (!m || !window.visualViewport || window.visualViewport.scale <= 1.01) return
  const orig = m.getAttribute('content')
  m.setAttribute('content', orig + ', maximum-scale=1')
  setTimeout(() => m.setAttribute('content', orig), 400)
}

// Número de card nunca sai do card (Estoque com 6 cards lado a lado: "R$ 11.924,56" vazava a borda).
// O tamanho do CSS é o máximo; se o valor não couber na largura do card, a fonte encolhe só o necessário.
// Valores da mesma faixa de cards e do mesmo tipo encolhem juntos — o "R$ 0,00" do lado não fica maior
// que o "R$ 11.924,56". Vale sozinho para todo card com essas classes, inclusive os que vierem depois.
const NUM_CARD_SEL = '.stat-value, .dc-hero .big, .fin-hero .fh-value'
const NUM_CARD_MIN = 12
function caberNumeros(els) {
  const vistos = new Set(), grupos = []
  for (const el of els) {
    if (vistos.has(el) || !el.isConnected) continue
    const faixa = el.closest('.stats-grid')
    const g = faixa ? [...faixa.querySelectorAll('.stat-value')].filter(o => o.classList.contains('money') === el.classList.contains('money')) : [el]
    g.forEach(o => vistos.add(o))
    grupos.push(g)
  }
  const todos = grupos.flat()
  todos.forEach(el => { el.style.fontSize = ''; el.style.whiteSpace = ''; el.style.overflowWrap = '' })
  const cabe = new Map()
  for (const el of todos) {
    const caixa = el.clientWidth, conteudo = el.scrollWidth
    el._cabeW = caixa
    if (caixa && conteudo > caixa) cabe.set(el, parseFloat(getComputedStyle(el).fontSize) * caixa / conteudo)
  }
  const vaza = el => el.scrollWidth > el.clientWidth
  for (const g of grupos) {
    let px = Math.min(...g.map(el => cabe.get(el) ?? Infinity))
    if (px === Infinity) continue
    px = Math.max(NUM_CARD_MIN, Math.floor(px * 10) / 10)
    g.forEach(el => { el.style.fontSize = px + 'px' })
    // Arredondamento de subpixel: desce meio ponto até caber; no limite mínimo, quebra a linha em vez de vazar.
    while (px > NUM_CARD_MIN && g.some(vaza)) { px = Math.max(NUM_CARD_MIN, px - .5); g.forEach(el => { el.style.fontSize = px + 'px' }) }
    g.filter(vaza).forEach(el => { el.style.whiteSpace = 'normal'; el.style.overflowWrap = 'anywhere' })
  }
}
function instalarNumeroCabe() {
  if (typeof ResizeObserver === 'undefined' || typeof MutationObserver === 'undefined') return
  // Card mudou de largura (janela, menu lateral, celular girado): refaz a conta no quadro seguinte —
  // mexer na fonte dentro do próprio ResizeObserver dispararia o aviso "ResizeObserver loop" do navegador.
  // Só a largura importa: a altura muda quando a própria fonte encolhe.
  const pendentes = new Set()
  let raf = 0
  const ro = new ResizeObserver(entradas => {
    for (const e of entradas) if (e.target.clientWidth !== e.target._cabeW) pendentes.add(e.target)
    if (pendentes.size && !raf) raf = requestAnimationFrame(() => { raf = 0; const l = [...pendentes]; pendentes.clear(); caberNumeros(l) })
  })
  // Valor novo na tela ou valor que mudou: ajusta antes de pintar (o React acabou de escrever no DOM).
  new MutationObserver(registros => {
    const mudou = new Set()
    for (const r of registros) {
      const alvo = r.target.nodeType === 1 ? r.target : r.target.parentElement
      const v = alvo && alvo.closest(NUM_CARD_SEL)
      if (v) mudou.add(v)
      for (const n of r.addedNodes) if (n.nodeType === 1) {
        if (n.matches(NUM_CARD_SEL)) mudou.add(n)
        n.querySelectorAll(NUM_CARD_SEL).forEach(el => mudou.add(el))
      }
      for (const n of r.removedNodes) if (n.nodeType === 1) {
        if (n.matches(NUM_CARD_SEL)) ro.unobserve(n)
        n.querySelectorAll(NUM_CARD_SEL).forEach(el => ro.unobserve(el))
      }
    }
    if (!mudou.size) return
    mudou.forEach(el => { if (el.isConnected) ro.observe(el) })
    caberNumeros(mudou)
  }).observe(document.body, { childList: true, characterData: true, subtree: true })
}

function startApp() {
  instalarNumeroCabe()
  ReactDOM.createRoot(document.getElementById('root')).render(<App />)
}
// Busca o nome real da empresa antes de renderizar (usado em termos legais e avisos);
// se falhar, segue com o valor genérico padrão em vez de travar o carregamento.
fetch('/api/empresa').then(r => r.json()).then(e => {
  if (e && e.nome) empresaInfo.nome = e.nome
  if (e && e.razaoSocial) empresaInfo.razaoSocial = e.razaoSocial
  if (e && e.logoUrl) empresaInfo.logoUrl = e.logoUrl
}).catch(() => {}).finally(startApp)
